/// <reference path="Enrollees.js" />
/// <reference path="../../Interface/Enrollees.Offenders.Profile.Assignments.Popup.htm" />
/// <reference path="CacheSettings.js" />
/// <reference path="Enrollees.js" />
/// <reference path="../_references.js" />


if (isNullOrUndefined(veritracks.enrollees)) {
    veritracks.enrollees = {};
}

if (isNullOrUndefined(veritracks.enrollees.offenders)) {
    veritracks.enrollees.offenders = {};
}

if (isNullOrUndefined(veritracks.enrollees.victims)) {
    veritracks.enrollees.victims = {};
}

if (isNullOrUndefined(veritracks.enrollees.events)) {
    veritracks.enrollees.events = {};
}
var lEventHistoryOffsetProperty= veritracks.system.clientSetting('EventHistoryOffset');
if(lEventHistoryOffsetProperty && !isNaN(Number(lEventHistoryOffsetProperty))){
    gSystemSettings.EventHistoryOffset = lEventHistoryOffsetProperty;
}
var mEnrolleesControls = new EnrolleesControls(),
    mPrintControls = new PrintControls(),
    mEnrolleesData = new EnrolleesData(),
    mEnrolleesIcon = new IconCard(),
    lCorrelateCardViewControl,
    mSexOffenseList,
    mAvailableTags = [
        { 'label': 'a', 'value': 'a', 'id': '1' },
        { 'label': 'b', 'value': 'b', 'id': '2' },
        { 'label': 'c', 'value': 'c', 'id': '3' },
        { 'label': 'd', 'value': 'd', 'id': '4' },
        { 'label': 'e', 'value': 'e', 'id': '5' }
    ];
mEnrolleesData.OffenderProfileCurrentVictims = [];
mEnrolleesControls.UserTransactionLogger = null;

function removeBigChart(aNav) {
    "use strict";
    mEnrolleesControls.CardView.selected(mEnrolleesData.OffenderCurrentId);
    $('#uEnrolleesListCell').removeClass('ChartingLimit');
    $('#enrolleeInfo').hide();
    $('#uEnrolleesChartPanel').hide();
    $('#uEnrolleesListPanel').show();
    $('.LimitedMapActions').hide();
    $('.DefaultMapActions').show();
    resetContentHolders();
}

function enrolleesVeritracksChartingLegend() {
    "use strict";
    function getIconLegent(){
        var html =[];
        for (var lKey in mChartingCalendarColors) {
            if (mChartingCalendarColors.hasOwnProperty(lKey)) {
                if (lKey.indexOf('In Progress') == -1) {
                    html.push('<div>');
                    html.push(LegendIconDisplay(null, lKey, mChartingCalendarColors[lKey]));
                    html.push('</div>');
                }
            }
        }
        return html.join('');
    }
    var lHtml = ['<div style="display:block; float:left; width:150px;">',
                    '<div style="padding:5px;">',
                        '<div class="MapLegendIcon CorrelationIconProperty" style="float:left;"></div>',
                        '<div>' , localizeText('cEventHasAssociation') , '</div>',
                    '</div>',
                    '<div style="padding:5px;">',
                        '<div class="MapLegendIcon CorrelationKnownLocationIconProperty" style="float:left;"></div>',
                        '<div>' , localizeText('cEventHasAssociationKnownLocation') , '</div>',
                    '</div>',
                    '<div style="padding:5px;">',
                        '<div class="MapLegendIcon Track10100001IconProperty" style="float:left;"></div>',
                        '<div>' , localizeText('cEventBraceletStrap') , '</div>',
                    '</div>',
                    '<div style="padding:5px;">',
                        '<div class="MapLegendIcon Track10100010IconProperty" style="float:left;"></div>',
                        '<div>' , localizeText('cEventLowBattery') , '</div>',
                    '</div>',
                    '<div style="padding:5px;">',
                        '<div class="MapLegendIcon Track10100100IconProperty" style="float:left;"></div>',
                        '<div>' , localizeText('cEventOnCharger') , '</div>',
                    '</div>',
                    '<div style="padding:5px;">',
                        '<div class="MapLegendIcon Track10101000IconProperty" style="float:left;"></div>',
                        '<div>' , localizeText('cZoneInclusionZone') , '</div>',
                    '</div>',
                    '<div style="padding:5px;">',
                        '<div class="MapLegendIcon Track10110000IconProperty" style="float:left;"></div>',
                        '<div>' , localizeText('cZoneExclusionZone') , '</div>',
                    '</div>',
                    '<div style="padding:5px;">',
                        '<div class="MapLegendIcon ShieldingIconProperty" style="float:left;"></div>',
                        '<div>' , localizeText('cEventShieldingPossible') , '</div>',
                    '</div>',
                    '<div style="padding:5px;">',
                        '<div class="MapLegendIcon JammingIconProperty" style="float:left;"></div>',
                        '<div>' , localizeText('cEventJammingPossible') , '</div>',
                    '</div>',
                    '<div style="padding:5px;">',
                        '<div class="MapLegendIcon NoGPSIconProperty" style="float:left;"></div>',
                        '<div>' , localizeText('cEventNoGPS') , '</div>',
                    '</div>',
                '</div>',
                '<div id="uVeritracksCalendarLegend" style=" display:block;width:190px; float:left;padding-left: 10px; border-left: solid #8C8C8C;">',
                    getIconLegent(),
                '</div>'
            ];
    DisplayModal(localizeWrapper('cEnrolleeLegend'), lHtml.join(''), null, null);
}

function timelineButtonLoadCheck(aIsLoaded) {
    "use strict";
    var lEnrolleeId = (mEnrolleesData.OffenderCurrentId ? mEnrolleesData.OffenderCurrentId : -1);
    var lEnrolleeCardSelected = mEnrolleesControls.CardView.selectedDataItemById(lEnrolleeId);
    var lIsInformaticsEnabled = false;

    if (lEnrolleeCardSelected){
        lIsInformaticsEnabled = getInformaticsEnabled(lEnrolleeCardSelected['OrganizationId']);
    }

    if (aIsLoaded && GetEnrolleeCardProductIdTimelineSupport() && lIsInformaticsEnabled) {
        enableTimelineButton();
    } else {
        disabledTimelineButton();
    }
}
function testBigChart(aRefresh) {
    "use strict";
    var lButtonBar = GenerateButtonCommandBar();

    if ($('.ChartButton').hasClass('Disabled')) {
        return false;
    }
  //  if (!PopupIsOpen()) {
        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeConfigureSettings'), 'Legend', 'configureDateSettings_Init()'));
        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeLegend'), 'Legend', 'enrolleesVeritracksChartingLegend()'));
        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', 'enrolleesVeritracksCalendarPopup_Dispose()'));
        DisplayPopup(localizeWrapper('cEnrolleeTimeline'), '<div id="uVeritracksLargeChart" style="width:100%;"><div class="loadingGif FixedCenteredDisplay"></div></div>', lButtonBar, true, false);
        $('.PopupWindow').addClass('CalendarWidth');
        window.isTimelineDisplayedFromProfile = true;
 //   }



    $('#uPopupPanel').addClass('LowZIndex');
    mEnrolleesControls.veritracksChartMap = new VeritracksFullCalendarWrapper('#uVeritracksLargeChart',
        {
            "defaultView": "agendaWeek",
            "slotEventOverlap": true,
            "selectOverlap": true,
            "multiDaySelect": false,
            "displayEventEnd": true,
            "editable": false,
            "aspectRatio": 1.8,
            "selectable": true,
            "selectHelper": false,
            "selectMultiDay": false,
            "allDaySlot": false,
          //  "DefaultDate": moment().add(-30,'day'),
            "rightClickOptions": 'agendaMonthDay,agendaWeek,agendaDay',
            "dayStart": getFirstDay(),
            "lazyFetching": true
        },
        {
            "clickHandler": setClickCal,
            "rightClickHandler": setTimelinePopupMenu,
            "viewRender": setDataCal,
            "afterRender": chartAfterRenderImageAppend,
            "selected": setDragCal,
            "events": setEventsFromHistoryCal,
            "disabledNavigation": timelineDisableNavigation
        });

    mEnrolleesControls.veritracksChartMap.setView('agendaDay');
    mEnrolleesControls.veritracksChartMap.setView('agendaWeek');

}

function timelineDisableNavigation(aVal) {
    "use strict";

    if (aVal) {
        if ($(".fc-prev-button").hasClass("ui-state-disabled")) {
            return aVal;
        }
        $(".fc-prev-button").addClass("ui-state-disabled")
                            .attr('disabled', true);
        $(".fc-next-button").addClass("ui-state-disabled")
                            .attr('disabled', true);
    } else {
        $(".fc-prev-button").removeClass("ui-state-disabled")
                            .attr('disabled', false);
        $(".fc-next-button").removeClass("ui-state-disabled")
                            .attr('disabled', false);
    }
}

/** heat map **/
function startHeatMap() {
    "use strict";
    var lWindowHeight = getWindowHeight(),
       lMasterContentHeight = (lWindowHeight - (mMasterOverheadHeight + 10)),
       lPageOverhead = getOverhead('PageOverhead'),
       lLayoutTableHeight = lMasterContentHeight - 10,
       lPageHeight = lLayoutTableHeight - (lPageOverhead),
       lCalendarHeight = lPageHeight - 125,
       lOptions = null,
       lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
       lButtonBar = GenerateButtonCommandBar();

    if (isNullOrUndefined(lEnrollee)) {
        return;
    }

    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', 'veritracksHeatMapPopup_Dispose()'));
    DisplayPopup(lEnrollee.FullName + "<div id='uEnrolleessHeapMapHelpContainer' style='float:right;display:inline-block;' class='HelpLightIconProperty'></div>", '<div id="uOffenderHeatMapPanel" style="width:100%;height:100%"></div>', lButtonBar, true, false);
    $('.PopupWindow').addClass('CalendarWidth');
    mEnrolleesControls.OffenderHeatMapHelpPopup = new sumo.controls.PopupControl("lEnrolleeHeatMapHelpCardPopup", "uEnrolleessHeapMapHelpContainer", {
        "DataSource": [lEnrollee],
        "Html": '<div></div>',
        "CardTemplate": 'Interface/Enrollees.Offenders.HeatMaps.Help.layout.htm',
        "popupStyle": "qtip-lightCard qtip-max-width qtip-max-zindex",
        "popupPosition": {
            my: 'top rigth',
            at: 'bottomLeft'
        }
    });


    lOptions = { 'height': lCalendarHeight, 'cardTemplateName': 'Interface/Enrollees.Offenders.HeatMap.Layout.htm', 'initializeCallback': heatMap_OnInitialized, 'mapOptions': { 'displayType': 'roadmap' } };

    mEnrolleesControls.OffenderHeatMap = new VeritracksHeatMapWrapper('uOffenderHeatMapPanel', 'uOffenderHeatMap', lOptions);

}


function heatMap_OnInitialized(){
    "use strict";

    var lCenterLat = 29.787822,
        lCenterLng = -95.45617,
        lToday = new Date(),
        lEpoch = new Date(0),
        lEndDate = moment().format('MM/DD/YYYY'),
        lLastContact = null,
        lCard = new EnrolleeCardView(),
        lCardViewData = [],
        lEndTime = DisplayShortMomentTime(moment());


    mEnrolleesControls.OffenderHeatMap.getMap().setCenter(lCenterLat, lCenterLng);
    mEnrolleesControls.OffenderHeatMap.getMap().zoom(10);
    populateDateView('#uHeatMapStartDatePicker', heatStartDate_OnChange);
    $('#uHeatMapStartTimeStampPicker').ptTimeSelect({
        'zIndex': 100000,
        'onFocusDisplay': true,
        'onClose': heatStartTime_Onchange
    });
    //populateDateView('#uHeatMapEndDatePicker', heatEndDate_OnChange);
    $('#uHeatMapEndTimeStampPicker').ptTimeSelect({
        'zIndex': 100000,
        'onFocusDisplay': true,
        'onClose': heatEndTime_OnChange
    });

    lCard.Enrollee = mEnrolleesControls.CardView.selectedDataItem().Enrollee;
    lCard.Id = lCard.Enrollee.Id;
    lLastContact = getDataItem(lCard.Id, 'EnrolleeLastContact');
    
    if (!isNullOrUndefined(mEnrolleesControls.CardView.selectedDataItem().LastContactDate) && mEnrolleesControls.CardView.selectedDataItem().LastContactDate > lEpoch) {
        if (!isNullOrUndefined(mEnrolleesControls.CardView.selectedDataItem().LastLatitude) && !isNullOrUndefined(mEnrolleesControls.CardView.selectedDataItem().LastLongitude)) {
            lCenterLat = mEnrolleesControls.CardView.selectedDataItem().LastLatitude;
            lCenterLng = mEnrolleesControls.CardView.selectedDataItem().LastLongitude;
            if (lCenterLat != 0 && lCenterLng != 0) {
                mEnrolleesControls.OffenderHeatMap.getMap().setCenter(lCenterLat, lCenterLng);
            }
        }

        if (mEnrolleesControls.CardView.selectedDataItem().LastContactDate > lEpoch) {
            lToday = mEnrolleesControls.CardView.selectedDataItem().LastContactDate;
        }

    } else if (!isNullOrUndefined(lLastContact)) {
        if (!isNullOrUndefined(lLastContact.Latitude) && !isNullOrUndefined(lLastContact.Longitude)) {
            lCenterLat = lLastContact.Latitude;
            lCenterLng = lLastContact.Longitude;
            if (lCenterLat != 0 && lCenterLng != 0) {
                mEnrolleesControls.OffenderHeatMap.getMap().setCenter(lCenterLat, lCenterLng);
            }
        }
        if (lLastContact.ContactDate > lEpoch) {
            lToday = lLastContact.ContactDate;
        }
    }

    lEndDate = moment(lToday).format('MM/DD/YYYY'),
    lEndTime = DisplayShortMomentTime(moment(lToday));

    lToday.addHours(parseInt($('#uHeatMapDuration').val()) * -1);
    $('#uHeatMapStartDatePicker').val(moment(lToday).format('MM/DD/YYYY'));
    mEnrolleesData.HeatMapStartDate = moment(lToday).format('MM/DD/YYYY');
    $('#uHeatMapStartTimeStampPicker').val(DisplayShortMomentTime(moment(lToday)));
    mEnrolleesData.HeatMapStartTime = DisplayShortMomentTime(moment(lToday));
    $('#uHeatMapEndDatePicker').html(lEndDate);
    mEnrolleesData.HeatMapEndDate = lEndDate;
    $('#uHeatMapEndTimeStampPicker').val(lEndTime);
    mEnrolleesData.HeatMapEndTime = lEndTime;

    $('#uEnrolleeHeatMapTimeFrameLabel').html('Search only tracks between ' + mEnrolleesData.HeatMapStartTime + ' and '  + mEnrolleesData.HeatMapEndTime);

    mEnrolleesControls.OffenderHeatMapCardView = new sumo.controls.CardView('uEnrolleesHeatMapCardView', 'uEnrolleeHeatMapCardViewHolder', {
        'cardTemplate': 'Interface/Enrollees.HeatMap.Card.Template.htm', 'selectMethod': 'auto', 'canUnselect': false, 'cssClass': 'VeritracksHeatCardView', 'keyField': 'Id', 'isSortable': true, 'Columns': [
            { 'id': 'PrimaryId', 'title': localizeWrapper('cEnrolleePrimaryId') },
        ]
    });

    lCard.FirstName = lCard.Enrollee.FirstName;
    lCard.LastName = lCard.Enrollee.LastName;
    lCard.PrimaryId = lCard.Enrollee.PrimaryId;
    if (!isNullOrUndefined(lLastContact)) {
        lCard.TrackingDeviceDisplay = 'block';
        lCard.TrackingDeviceContactDate = displayEventInEnrolleeTimeZone(lLastContact.ContactDate, lCard.Enrollee);
        lCard.TrackingDeviceContactDateDisplay = DisplayShortDateTime(displayEventInEnrolleeTimeZone(lLastContact.ContactDate, lCard.Enrollee));
        lCard.TrackingDeviceContactDisplay = 'block';
        lCard.LastContactDate = displayEventInEnrolleeTimeZone(lLastContact.ContactDate, lCard.Enrollee);
        lCard.LastContactDateDisplay = DisplayShortDateTime(displayEventInEnrolleeTimeZone(lLastContact.ContactDate, lCard.Enrollee));
        if (lLastContact.TrackDate > lEpoch) {
            lCard.LastTrackpointDate = lLastContact.TrackDate;
            lCard.LastTrackpointDateDisplay = DisplayShortDateTime(displayEventInEnrolleeTimeZone(lLastContact.TrackDate, lCard.Enrollee));
            lCard.LastContactDisplay = 'block';
            lCard.LastContactVersion = lLastContact.Version;
        }
    }
    lCard.IsDeletableClass = "ConsumerPreviewDisabled";
    lCardViewData.push(lCard);
    mEnrolleesControls.OffenderHeatMapCardView.setDataSource(lCardViewData);
    mEnrolleesControls.OffenderHeatMapCardView.bind('databind', onHeatMapDataBind);
    mEnrolleesControls.OffenderHeatMapCardView.bind('selectedchanged', uOffenderHeatMap_OnChange);
}

function uOffenderHeatMap_OnChange(aSender, aSelected, aData) {
    "use strict";
    mEnrolleesData.OffenderHeatMapSelected = aSelected;

}

function resetHeatMapContent() {
    "use strict";
    var lViewCardHolderHeight = $('#uEnrolleesHeatListPanel').height();

    if (lViewCardHolderHeight > 500) {
        $('#uEnrolleesHeatMapCardView').css('height', (lViewCardHolderHeight - 10) + 'px');
    } else {
        $('#uEnrolleesHeatMapCardView').css('height', (lViewCardHolderHeight - 20) + 'px');
    }
}

function onHeatMapDataBind(aSender, aParams, aData) {
    "use strict";
    var lDataSource = aSender.getDataSource(),
        lCard = null,
        lSelectedIds = [],
        lSelected = mEnrolleesControls.OffenderHeatMapCardView.selectedDataItem();

    for (var sids in lSelected) {
        if (lSelected.hasOwnProperty(sids)) {
            lSelectedIds.push(lSelected[sids].Id);
        }
    }

    for (var key in lDataSource) {
        if (lDataSource.hasOwnProperty(key)) {
            if (!isNullOrUndefined(lSelected) && lSelectedIds.indexOf(lDataSource[key].Id) == -1) {
                mEnrolleesControls.OffenderHeatMapCardView.selectedIndex(key);
            } else if (isNullOrUndefined(lSelected)) {
                mEnrolleesControls.OffenderHeatMapCardView.selectedIndex(key);
            }

        }
    }
    resetHeatMapContent();
    uEnrolleesHeatMap_OnSearch();
}

function uAddAdditionalEnrolleeHeat_OnClick() {
    "use strict";
    var lOrganizations = [],
        lCardData = [],
        lSelectedIds = [],
        lBuilder = new SumoPredicateBuilder(),
        lHtml = [],
        lColumns = [],
        lButtonBar = GenerateButtonCommandBar(),
        lRiskLevels = riskLevelsFilter_DataListConverter(),
        lEyeColor,
        lHairColor,
        lFeetList = [],
        lInchesList = [],
        lCentimetersList = [],
        lColor = getDataItems('Color'),
        lUserPreferences = getUserPreferences(1),
        lParams,
        lRiskLevelList = [],
        lSort = new SortExpression(),
        lDashboardViewState = getViewState('DandEFilterViewState'),
        lTitle = 'cEnrolleeSearch',
        lKey,
        lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric')),
        lGender;

    lBuilder.AddNewExpressionConditional('Id', 3, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
    lGender = query(getDataItems('Gender'), lBuilder.RootExpression);
    lBuilder.Clear();

    lBuilder.AddNewExpressionConditional('ColorType', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lHairColor = query(lColor, lBuilder.RootExpression);
    lBuilder.Clear();

    lBuilder.AddNewExpressionConditional('ColorType', 2, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lEyeColor = query(lColor, lBuilder.RootExpression);
    lBuilder.Clear();

    for (lKey = 0; lKey <= 8; lKey++) {
        lFeetList.push({ 'Id': lKey });
    }
    for (lKey = 0; lKey <= 11; lKey++) {
        lInchesList.push({ 'Id': lKey });
    }
    for (lKey = 0; lKey <= 275; lKey++) {
        lCentimetersList.push({ 'Id': lKey });
    }


    lColumns.push({ 'Id': 'FullName', 'Title': localizeWrapper('cEnrolleeName'), 'Type': 'Text', 'DataField': 'FullName' },
                { 'Id': 'PrimaryID', 'Title': localizeWrapper('cEnrolleePrimaryId'), 'Type': 'Text', 'DataField': 'PrimaryId' });


    if (gUserDetails.Role !== 2) {
        lColumns.push({ 'Id': 'SecondaryID', 'Title': localizeWrapper('cEnrolleeSecondaryId'), 'Type': 'Text', 'DataField': 'SecondaryId' },
        { 'Id': 'AgentName', 'Title': localizeWrapper('cAgent'), 'Type': 'Text', 'DataField': 'AgentName' },
        { 'Id': 'RiskLevelId', 'Title': localizeWrapper('cEnrolleeRiskLevel'), 'Type': 'Dropdown', 'DataField': 'RiskLevelId', 'DataSource': lRiskLevels, 'DataValueField': 'Id', 'DataTextField': 'Name', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
        { 'Id': 'OrganizationId', 'Title': localizeWrapper('cEnrolleeOrganization'), 'Type': 'Dropdown', 'DataField': 'OrganizationId', 'DataSource': OrganizationSortFormatter(), 'DataValueField': 'Id', 'DataTextField': 'Name', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
        { 'Id': 'IsMyCaseload', 'Title': localizeWrapper('cEnrolleeMyCaseload'), 'Type': 'Dropdown', 'DataField': 'IsMyCaseload', 'DataSource': [{ 'Value': true, 'Text': localizeText('cYes') }, { 'Value': false, 'Text': localizeText('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': true, 'ComparisonType': 'Boolean', 'InsertBlank': true, 'BlankText': localizeText('cBoth') },
        { 'Id': 'HasOpenEvents', 'Title': localizeWrapper('cEnrolleeOpenEvents'), 'Type': 'Dropdown', 'DataField': 'HasOpenEvents', 'DataSource': [{ 'Value': true, 'Text': localizeText('cYes') }, { 'Value': false, 'Text': localizeText('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'ComparisonType': 'Boolean', 'InsertBlank': true, 'BlankText': localizeText('cBoth') });
    }
    else {
        lTitle = 'cEnrolleeAdvanceSearch';
    }

    lColumns.push(
        { 'Id': 'IsAssigned', 'Title': localizeWrapper('cEnrolleeIsAssigned'), 'Type': 'Dropdown', 'DataField': 'IsAssigned', 'DataSource': [{ 'Value': true, 'Text': localizeText('cYes') }, { 'Value': false, 'Text': localizeText('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': true, 'ComparisonType': 'Boolean', 'InsertBlank': true, 'BlankText': localizeText('cBoth') },
        { 'Id': 'DeviceTrackType', 'Title': localizeWrapper('cEnrolleeDeviceType'), 'Type': 'Dropdown', 'DataField': 'DeviceTrackType', 'DataSource': [{ 'Value': 2, 'Text': localizeText('cEnrolleeGPS') }, { 'Value': 1, 'Text': localizeText('cEnrolleeRF') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'ComparisonType': 'Number', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
    { 'Id': 'Weight', 'Title': localizeWrapper('cEnrolleeWeight'), 'Type': 'Text', 'DataField': 'Weight' });

    if (lDoMetric) {
        lColumns.push({ 'Id': 'Height', 'Title': localizeWrapper('cEnrolleeHeightCm'), 'Type': 'Dropdown', 'DataSource': lCentimetersList, 'ComparisonType': 'Number', 'ActualType': 'MeasurementMetric', 'IgnoreValue': 0, 'DataField': 'Height', 'DataValueField': 'Id', 'DataTextField': 'Id' });
    }
    else {
        lColumns.push({ 'Id': 'Height', 'Title': localizeWrapper('cEnrolleeHeight'), 'Type': 'DoubleDropDown', 'DataSource': lFeetList, 'DataSource2': lInchesList, 'ComparisonType': 'Number', 'ActualType': 'MeasurementUSA', 'DataField': 'Height', 'DataValueField': 'Id', 'DataTextField': 'Id' });
    }

    lColumns.push({ 'Id': 'GenderId', 'Title': localizeWrapper('cEnrolleeGender'), 'Type': 'Dropdown', 'DataSource': lGender, 'LocaleName': 'Gender', 'DataField': 'GenderId', 'DataValueField': 'Id', 'DataTextField': 'Description', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
    { 'Id': 'RaceId', 'Title': localizeWrapper('cEnrolleeRace'), 'Type': 'Dropdown', 'DataSource': getDataItems('Race'), 'LocaleName': 'Race', 'DataField': 'RaceId', 'DataValueField': 'Id', 'DataTextField': 'Description', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
    { 'Id': 'HairColorId', 'Title': localizeWrapper('cEnrolleeHairColor'), 'Type': 'Dropdown', 'DataSource': lHairColor, 'LocaleName': 'Color', 'DataField': 'HairColorId', 'DataValueField': 'Id', 'DataTextField': 'Description', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
    { 'Id': 'EyeColorId', 'Title': localizeWrapper('cEnrolleeEyeColor'), 'Type': 'Dropdown', 'DataSource': lEyeColor, 'LocaleName': 'Color', 'DataField': 'EyeColorId', 'DataValueField': 'Id', 'DataTextField': 'Description', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
    { 'Id': 'MarksTattoos', 'Title': localizeWrapper('cEnrolleeMarksAndTattoos'), 'Type': 'Text', 'DataField': 'MarksTattoos' },
    { 'Id': 'VehicleYear', 'Title': localizeWrapper('cEnrolleeVehicleYear'), 'Type': 'Text', 'DataField': 'VehicleYear', 'ComparisonType': 'Number' },
    { 'Id': 'VehiclePlateNumber', 'Title': localizeWrapper('cEnrolleeLicencePlateNumber'), 'Type': 'Text', 'DataField': 'VehiclePlateNumber' },
    { 'Id': 'VehicleColor', 'Title': localizeWrapper('cEnrolleeVehicleColor'), 'Type': 'Dropdown', 'DataSource': VehicleColorSortFormatter(), 'LocaleName': 'VehicleColor', 'DataField': 'VehicleColor', 'DataValueField': 'Description', 'DataTextField': 'Description', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
    { 'Id': 'VehicleMake', 'Title': localizeWrapper('cEnrolleeVehicle'), 'Type': 'Dropdown', 'DataSource': VehicleMakeSortFormatter(), 'DataField': 'VehicleMake', 'DataValueField': 'DescriptionValue', 'DataTextField': 'Description', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
    { 'Id': 'VehicleModel', 'Title': localizeWrapper('cEnrolleeVehicleModel'), 'Type': 'Text', 'DataField': 'VehicleModel' }

);

    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', 'heatmapAddOffenderPopup_Dispose()'));
    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleAddAllToMap'), 'Add All', 'uOffenderHeatMapAddAll_OnSave()'));
    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeAddToMap'), 'Add', 'uOffenderHeatMapAdd_OnSave()'));

    lHtml.push('<div id="uOffenderAddHeatMapPanel" style="width:100%;height:100%">');
    lHtml.push('<div id="uOffenderAddHeatCardViewFilterHolder"></div>');
    lHtml.push('<div id="uOffenderAddHeatCardViewHolder" class="ListPanel NotScrollable"></div>');
    lHtml.push('</div>');

    DisplayPopup('Add Offender', lHtml.join(''), lButtonBar, true, true);

    lParams = {
        'Title': localizeWrapper(lTitle),
        'Content': '',
        'CssClass': 'DefaultFilter',
        'HideOnFilter': true,
        'OnFilter': uOffendersAddHeatCardViewFilter_OnFilter,
        'Columns': lColumns,
        'Settings': null,
        'UserPreferences': null,
        'UserId': gUserDetails.UserId,
        'UserPreferenceType': 1,
        'CallbackClick': uOffendersAddHeatCardviewCallback_Click,
        'LocalizableMethod': localizeDataItem
    };

    //mEnrolleesControls.OffenderHeatMapCardViewFilter = gFilterFactory.createControl('uOffendersHeatAddCardViewFilter', 'uOffenderAddHeatCardViewFilterHolder', lParams);
    mEnrolleesControls.OffenderAddHeatMapCardView = new sumo.controls.CardView('uEnrolleesAddHeatMapCardView', 'uOffenderAddHeatCardViewHolder', {
        'cardTemplate': 'Interface/Enrollees.HeatMap.Card.Popup.Template.htm', 'selectMethod': 'auto', 'canUnselect': false, 'cssClass': 'VeritracksCardView', 'keyField': 'Id', 'isSortable': true, 'Columns': [
            { 'id': 'PrimaryId', 'title': localizeWrapper('cEnrolleePrimaryId') },
        ]
    });


    mEnrolleesControls.OffenderAddHeatMapCardView.bind('databind', onOffenderAddHeatDataBind);
    mEnrolleesControls.OffenderAddHeatMapCardView.bind('selectedchanged', uOffenderAddHeatMap_OnChange);

    var selectedItems = mEnrolleesControls.OffenderHeatMapCardView.getDataSource()

    for (var key in selectedItems) {
        if (selectedItems.hasOwnProperty(key)) {
            lSelectedIds.push(selectedItems[key].Id);
        }
    }
    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('Id', lSelectedIds, false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And());
    lCardData = query(mEnrolleesControls.CardView.getDataSource(), lBuilder.RootExpression);
    mEnrolleesControls.OffenderAddHeatMapCardView.setDataSource(lCardData);

    //mEnrolleesControls.OffenderHeatMapCardViewFilter.filter();
}

function enrolleeHeatMapDataListConverter() {
    "use strict";

    var lBuilder = new SumoPredicateBuilder(),
        lSort = new SortExpression(),
        lEpoch = new Date(0),
        lEnrolleeCard = new EnrolleeCardView(),
        lEnrolleeCardList = [],
        lEnrolleeItem = null,
        lDeviceItem = null,
        lLastContact = null,
        lDeviceAssignments = null,
        lDoContactDetails = null,
        lEventSummaryList = getDataItems('EnrolleeEventSummary'),
        lEnrolleeList = getDataItems('Enrollees'),
        lCardEnrollees = [],
        lDeviceList = getDataItems('Devices'),
        lAgentList = getDataItems('Agents'),
        lUserAgents = [],
        lEnrolleeDataSource = mEnrolleesControls.OffenderHeatMapCardView.getDataSource(),
        lEnrolleeSelected = [],
        lDeviceClusterEnrolleesList = getDataItems('DeviceClusterEnrollee');

    for (var key in lEnrolleeDataSource) {
        if (lEnrolleeDataSource.hasOwnProperty(key)) {
            lEnrolleeSelected.push(lEnrolleeDataSource[key].Id);
        }//end of if
    }//end of for

    lBuilder.AddNewExpressionConditional("OrganizationId", gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional("Id", lEnrolleeSelected, false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And());
    lCardEnrollees = query(lEnrolleeList, lBuilder.RootExpression);
    lBuilder.Clear();

    lBuilder.AddNewExpressionConditional("UserId", gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lUserAgents = query(lAgentList, lBuilder.RootExpression);
    lBuilder.Clear();


    for (var key in lCardEnrollees) {
        if (lCardEnrollees.hasOwnProperty(key)) {
            lEnrolleeCard = new EnrolleeCardView();
            lEnrolleeCard.Id = parseInt(key);
            lEnrolleeItem = lCardEnrollees[key];
            lEnrolleeCard.Enrollee = lEnrolleeItem;
            lEnrolleeCard.FirstName = lEnrolleeItem.FirstName;
            lEnrolleeCard.LastName = lEnrolleeItem.LastName;
            lEnrolleeCard.FullName = lEnrolleeItem.FullName;
            lEnrolleeCard.EnrolleeType = lEnrolleeItem.EnrolleeType;
            lEnrolleeCard.IsAssigned = lEnrolleeItem.IsAssigned;
            lEnrolleeCard.InMyOrganization = true;
            lEnrolleeCard.RiskLevelId = lEnrolleeItem.RiskLevelId;
            lEnrolleeCard.PrimaryId = lEnrolleeItem.PrimaryId;
            lEnrolleeCard.SecondaryId = lEnrolleeItem.SecondaryId
            lEnrolleeCard.OrganizationId = lEnrolleeItem.OrganizationId;
            lEnrolleeCard.AgentName = lAgentList[lEnrolleeItem.AgentId].FullName;
            if (lUserAgents.hasOwnProperty(lEnrolleeItem.AgentId) && lUserAgents[lEnrolleeItem.AgentId].Id == lEnrolleeItem.AgentId) {
                lEnrolleeCard.IsMyCaseload = true;
            }

            if (lEventSummaryList.hasOwnProperty(key)) {
               lEnrolleeCard.HasOpenEvents = (lEventSummaryList[key].Open || lEventSummaryList[key].OpenConfirmed);
            }

            lDeviceAssignments = gCurrentDeviceAssignment[lEnrolleeItem.Id];
            if (!isNullOrUndefined(lDeviceAssignments)) {
                for (var key in lDeviceAssignments) {
                    if (lDeviceAssignments.hasOwnProperty(key)) {
                        if (lDeviceAssignments[key].EnrolleeId == lEnrolleeItem.Id) {
                            lEnrolleeCard.DeviceSerialNumber = lDeviceAssignments[key].SerialNumber;
                            lEnrolleeCard.HasGpsDevice = isGPSProduct(lDeviceAssignments[key].ProductId);
                            lDeviceItem = getDataItem(lDeviceAssignments[key].Id, 'Devices');
                            if (!isNullOrUndefined(lDeviceItem)) {
                                if (lDeviceItem.ProductType == 2) {
                                    lEnrolleeCard.TrackingDeviceId = lDeviceItem.Id;
                                } else {
                                    lEnrolleeCard.StationDeviceId = lDeviceItem.Id;
                                }
                            }
                            break;
                        }//end of if
                    }
                }//end of for
            }//end of if

            lDoContactDetails = false;
            if (lEnrolleeCard.TrackingDeviceId !== -1 || lEnrolleeCard.StationDeviceId !== -1) {
                lLastContact = getDataItem(lEnrolleeItem.Id, 'EnrolleeLastContact');
                if (!isNullOrUndefined(lLastContact) && lLastContact.DeviceId !== -1) {
                    lEnrolleeCard.TrackingDeviceDisplay = 'block';
                    if (lLastContact.DeviceId === lEnrolleeCard.TrackingDeviceId) {
                        lEnrolleeCard.TrackingDeviceSerialNumber = lEnrolleeCard.DeviceSerialNumber;
                        lEnrolleeCard.TrackingDeviceContactDate = displayEventInEnrolleeTimeZone(lLastContact.ContactDate, lEnrolleeCard.Enrollee);
                        lEnrolleeCard.TrackingDeviceContactDateDisplay = DisplayShortDateTime(displayEventInEnrolleeTimeZone(lLastContact.ContactDate, lEnrolleeCard.Enrollee));
                        lEnrolleeCard.TrackingDeviceContactDisplay = 'block';
                        lDoContactDetails = true;
                    } else if (lLastContact.DeviceId === lEnrolleeCard.StationDeviceId) {
                        lDoContactDetails = true;
                        lEnrolleeCard.StationDeviceContactDate = displayEventInEnrolleeTimeZone(lLastContact.ContactDate, lEnrolleeCard.Enrollee);
                        lEnrolleeCard.StationDeviceContactDateDisplay = DisplayShortDateTime(displayEventInEnrolleeTimeZone(lLastContact.ContactDate, lEnrolleeCard.Enrollee));
                        lEnrolleeCard.StationDeviceContactDisplay = 'block';
                    } else {
                        lEnrolleeCard.TrackingDeviceSerialNumber = lEnrolleeCard.DeviceSerialNumber;
                    }
                    if (lDoContactDetails) {
                        lEnrolleeCard.LastContactDate = displayEventInEnrolleeTimeZone(lLastContact.ContactDate, lEnrolleeCard.Enrollee);
                        lEnrolleeCard.LastContactDateDisplay = DisplayShortDateTime(displayEventInEnrolleeTimeZone(lLastContact.ContactDate, lEnrolleeCard.Enrollee));
                        if (lLastContact.TrackDate > lEpoch) {
                            lEnrolleeCard.LastTrackpointDate = lLastContact.TrackDate;
                            lEnrolleeCard.LastTrackpointDateDisplay = DisplayShortDateTime(displayEventInEnrolleeTimeZone(lLastContact.TrackDate, lEnrolleeCard.Enrollee));
                            lEnrolleeCard.LastContactDisplay = 'block';
                            lEnrolleeCard.LastContactVersion = lLastContact.Version;
                        }
                        lEnrolleeCard.LastLatitude = lLastContact.Latitude;
                        lEnrolleeCard.LastLongitude = lLastContact.Longitude;
                        if (lLastContact.BatteryLevel !== 0 && lLastContact.BatteryVoltage !== 0) {
                            lEnrolleeCard.LastContactBatteryImage = inventoryBatteryLevelFormatter(lLastContact.BatteryLevel);
                            lEnrolleeCard.LastContactBatteryLevel = DisplayVolts(lLastContact.BatteryVoltage);
                            lEnrolleeCard.LastContactBatteryPercentage = deviceBatteryPercentageFormatter(lLastContact.BatteryPercentage);
                            lEnrolleeCard.LastContactBatteryDisplay = 'block';
                        }
                    }
                }
            }

            lEnrolleeCardList.push(lEnrolleeCard);
        }//end of if
    }//end of for

    return lEnrolleeCardList;

}

function uOffenderHeatMapAddAll_OnSave() {
    "use strict";

    var lAddDataSource = mEnrolleesControls.OffenderAddHeatMapCardView.getDataSource(),
        lDataSource = mEnrolleesControls.OffenderHeatMapCardView.getDataSource();

    //have to do it this way. otherwise the array index is weird
    for (var key in lAddDataSource) {
        if (lAddDataSource.hasOwnProperty(key)) {
            lAddDataSource[key].IsDeletableClass = "DeletableHeatButton";
            lDataSource.push(lAddDataSource[key]);
        }
    }//end of for

    mEnrolleesControls.OffenderHeatMapCardView.setDataSource(lDataSource);
    heatmapAddOffenderPopup_Dispose();

}

function uOffenderHeatMapAdd_OnSave() {
    "use strict";
    var lDataSource = mEnrolleesControls.OffenderHeatMapCardView.getDataSource(),
        lAddDataSource = mEnrolleesControls.OffenderAddHeatMapCardView.getDataSource(),
        lEnrollees = getDataItems("Enrollees"),
        lEnrolleeCards = [],
        lCardView = null,
        lEnrolleeItem = null,
        lDataDirty = [],
        lBuilder = new SumoPredicateBuilder(),
        lSelected = mEnrolleesData.OffenderHeatMapAddOnSelected;


    for (var key in lDataSource) {
        if (lDataSource.hasOwnProperty(key)) {
            if (lSelected.indexOf(lDataSource[key].Id) != -1) {
                lSelected.splice(lSelected.indexOf(lDataSource[key].Id), 1);
            }
        }
    }//end of for

    lBuilder.AddNewExpressionConditional("Id", lSelected, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lEnrolleeCards = query(lAddDataSource, lBuilder.RootExpression);

    for (var key in lEnrolleeCards) {
        if (lEnrolleeCards.hasOwnProperty(key)) {
            lDataDirty.push(lEnrolleeCards[key]);
        }
    }

    lDataDirty = lDataSource.concat(lDataDirty);
    for (var key in lDataDirty) {
        if (lDataDirty.hasOwnProperty(key)) {
            if (lDataDirty[key].Id != mEnrolleesControls.CardView.selectedDataItem().Id) {
                lDataDirty[key].IsDeletableClass = "DeletableHeatButton";
            }
        }
    }//end of for
    mEnrolleesControls.OffenderHeatMapCardView.setDataSource(lDataDirty);

    heatmapAddOffenderPopup_Dispose();

}

function uDeleteAdditionalEnrolleeHeat_OcClick(aEnrolleeId) {
    "use strict";
    var lDataSourceClean = [],
        lDataSource = mEnrolleesControls.OffenderHeatMapCardView.getDataSource();

    for (var key in lDataSource) {
        if (lDataSource.hasOwnProperty(key)) {
            if (lDataSource[key].Id != aEnrolleeId || lDataSource[key].Id == mEnrolleesData.OffenderCurrentId) {
                lDataSourceClean.push(lDataSource[key]);
            }
        }//end of if
    }//end of for

    mEnrolleesControls.OffenderHeatMapCardView.unbind('databind', onHeatMapDataBind);
    mEnrolleesControls.OffenderHeatMapCardView.setDataSource(lDataSourceClean);
    mEnrolleesControls.OffenderHeatMapCardView.bind('databind', onHeatMapDataBind);

}

function onOffenderAddHeatDataBind() {
    "use strict";
    $('.Clickable.Button.AddButton').hide();
}

function uOffenderAddHeatMap_OnChange(aSender, aSelected, aData) {
    "use strict";

    mEnrolleesData.OffenderHeatMapAddOnSelected = aSelected;

    if (mEnrolleesData.OffenderHeatMapAddOnSelected.length > 0) {
        $('.Clickable.Button.AddButton').show();
    } else {
        $('.Clickable.Button.AddButton').hide();
    }

}

function uHeatFilterCleaner(lOrder) {
    "use stict";
    var Unallowed = [],
        lColumnList = [],
        lKey = null;


    if (lOrder == 1) {
        lUnallowed = ['AgentName', 'BirthDate', 'IsMyCaseload', 'HeightFeet', 'HasAssociationFlag', 'HeightInches', 'HasOpenEvents', 'IsAssigned', 'DeviceTrackType', 'PrimaryID', 'SecondaryID', 'FullName', 'RiskLevelId', 'OrganizationId'];
    }
    else {
        lUnallowed = ['Height', 'HeightFeet', 'HeightInches', 'Weight', 'HairColorId', 'EyeColorId', 'MarksTattoos', 'GenderId', 'RaceId', 'VehicleColor', 'VehicleYear', 'VehicleMake', 'VehicleModel', 'VehiclePlateNumber'];
    }

    for (lKey in mEnrolleesControls.OffenderHeatMapCardViewFilter.Columns) {
        var lColumns = mEnrolleesControls.OffenderHeatMapCardViewFilter.Columns[lKey];

        if ($.inArray(lColumns.Id, lUnallowed) < 0) {
            lColumnList.push(lColumns);
        }
    }

    mEnrolleesControls.OffenderHeatMapCardViewFilter.SetSecondaryColumns(lColumnList);
    mEnrolleesControls.OffenderHeatMapCardViewFilter.LiveExpressionModifier();

}

function uOffendersAddHeatCardViewFilter_OnFilter(aSender, aExpression, aData) {
    "use strict";

    var lDataSource = mEnrolleesControls.OffenderAddHeatMapCardView.getDataSource(),
        lExpressionDirty = aExpression,
        lExpression = null,
        lDataClean = [],
        lBuilder = new SumoPredicateBuilder();

    function offenderHeatMapFilter_OnComplete(aParams, aData) {
        "use strict";
        var lDataIds = [],
            lDataDirty = [],
            lExpressionClean = null,
            lProfilBuilder = new SumoPredicateBuilder();


        mEnrolleesControls.OffenderHeatMapCardViewFilter.Expression = lExpressionDirty;
        uHeatFilterCleaner(0);
        lExpressionClean = mEnrolleesControls.OffenderHeatMapCardViewFilter.Expression;
        lDataClean = query(lDataSource, lExpressionClean);
        lDataIds = getArrayByIds(aData);
        lProfilBuilder.AddNewExpressionConditional('Id', lDataIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());



        lDataDirty = query(lDataClean, lProfilBuilder.RootExpression);
        mEnrolleesControls.OffenderAddHeatMapCardView.setDataSource(lDataDirty);
    }


    if (isNullOrUndefined(aExpression)) {
        mEnrolleesControls.OffenderAddHeatMapCardView.setDataSource(enrolleeHeatMapDataListConverter());
    } else {
        uHeatFilterCleaner(1);
        lExpression = mEnrolleesControls.OffenderHeatMapCardViewFilter.Expression;
        ReadMultiple(gObjectList.OffenderProfile.AssemblyQualifiedName, lExpression, 0, offenderHeatMapFilter_OnComplete, null, null, null, 0);

    }
}

function uOffendersAddHeatCardviewCallback_Click(aSender) {
    "use strict";

}

function heatStartDate_OnChange(){
    "use strict";
    mEnrolleesData.HeatMapStartDate = $('#uHeatMapStartDatePicker').val();
    uEnrolleeHeatMapDuration();
}

function heatStartTime_Onchange() {
    "use strict";
    mEnrolleesData.HeatMapStartTime = $('#uHeatMapStartTimeStampPicker').val();
    $('#uEnrolleeHeatMapTimeFrameLabel').html('Search only tracks between ' + mEnrolleesData.HeatMapStartTime + ' and ' + mEnrolleesData.HeatMapEndTime);
}

function heatEndDate_OnChange() {
    "use strict";
    mEnrolleesData.HeatMapEndDate = $('#uHeatMapEndDatePicker').text();
    heatMapEndTimeChanged();
}

function heatEndTime_OnChange() {
    "use strict";
    mEnrolleesData.HeatMapEndTime = $('#uHeatMapEndTimeStampPicker').val();
    $('#uEnrolleeHeatMapTimeFrameLabel').html('Search only tracks between ' + mEnrolleesData.HeatMapStartTime + ' and ' + mEnrolleesData.HeatMapEndTime);
}

function heatMapEndTimeChanged() {
    "use strict";
    var addedHours = parseInt($('#uHeatMapDuration').val()),
        now = new Date(mEnrolleesData.HeatMapEndDate + ' ' + mEnrolleesData.HeatMapStartTime);
    now.addHours(addedHours);
    mEnrolleesData.HeatMapStartDate = moment(now).format('MM/DD/YYYY');
    $('#uHeatMapStartDatePicker').val(moment(now).format('MM/DD/YYYY'));
    mEnrolleesData.HeatMapStartTime = DisplayShortMomentTime(moment(now));
    $('#uHeatMapStartTimeStampPicker').val(DisplayShortMomentTime(moment(now)));
}

function uEnrolleeHeatMapDuration() {
    "use strict";
    var addedHours = parseInt($('#uHeatMapDuration').val()),
        now = new Date(mEnrolleesData.HeatMapStartDate + ' ' +  mEnrolleesData.HeatMapStartTime);
    now.addHours(addedHours);
    mEnrolleesData.HeatMapEndDate = moment(now).format('MM/DD/YYYY');
    $('#uHeatMapEndDatePicker').html(moment(now).format('MM/DD/YYYY'));
    //mEnrolleesData.HeatMapEndTime = DisplayShortMomentTime(moment(now));
    //$('#uHeatMapEndTimeStampPicker').val(DisplayShortMomentTime(moment(now)));

}

function heatMapGetLastDevice(aTrackType, aData, aEnrolleeId) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lResults = [];

    lBuilder.AddNewExpressionConditional("EnrolleeId", aEnrolleeId, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.DeviceAssignment.AssemblyQualifiedName, lBuilder.RootExpression, 0, getHeatMapDevice_OnSuccess, Sad, aData);

    function getHeatMapDevice_OnSuccess(aParams, aData) {
        var lDeviceIds = [];
        for (var key in aData) {
            if (aData.hasOwnProperty(key)) {
                if (lDeviceIds.indexOf(aData[key].Id) == -1) {
                    lDeviceIds.push(aData[key].Id);
                }
            }
        }
        uEnrolleesHeatMap_OnSearch(aTrackType, aParams, lDeviceIds);
    }

}

function uEnrolleesHeatMap_OnSearch(aTrackType, aData, aDevice) {
    "use strict";

    var lStartDateTime = new Date(moment.utc(mEnrolleesData.HeatMapStartDate + ' ' + mEnrolleesData.HeatMapStartTime)),
        lEndDateTime = new Date(moment.utc(mEnrolleesData.HeatMapEndDate + ' ' + mEnrolleesData.HeatMapEndTime)),
        lOffenderId = mEnrolleesControls.OffenderHeatMapCardView.selectedDataItem().Id,
        lOffenderIds = mEnrolleesData.OffenderHeatMapSelected,
        lAssignments = getDataItems("CurrentDeviceAssignments"),
        lDevice = null,
        lDevices = [],
        lDeviceId = 0,
        lDeviceIds = [],
        lNow = new Date(),
        lIsHistoricalDate = false,
        lObjectType = null,
        lBuilder = new SumoPredicateBuilder();

    $("#uEnrolleHeatMapSearchHolder").hide();
    $("#uEnrolleeHeatMapLoadingBar").show();

    if (lOffenderIds.constructor !== Array) {
        lOffenderIds = [lOffenderIds];
    }

    //look for for current assignment
     lBuilder.AddNewExpressionConditional("EnrolleeId", lOffenderIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
     lDevice = query(lAssignments, lBuilder.RootExpression);
     lBuilder.Clear();

     for (var key in lDevice) {
         if (lDevice.hasOwnProperty(key)) {
             lDevices.push(lDevice[key].Id);
         }
     }

     if (lDevices.length < lOffenderIds.length && isNullOrUndefined(aDevice)) {
         lDevice = null;
     } else if (lDevices.length < lOffenderIds.length) {
         lDevice = [];
     }

    if (isNullOrUndefined(lDevice) && isNullOrUndefined(aDevice)) {
        heatMapGetLastDevice(aTrackType, aData, lOffenderIds);
        //look for previous assignments if any
    } else if (!isNullOrUndefined(aDevice) && aDevice.length == 0) {
        mActivityNotification.addNotification('No previous device assignments found');
        heatMapSearch_OnSuccess([], []);
    } else {
        if (lDevice.length == 0 && !isNullOrUndefined(aDevice)) {
            lDeviceIds = aDevice;
        } else {
            for (var key in lDevice) {
                if (lDevice.hasOwnProperty(key)) {
                    lDeviceIds.push(lDevice[key].Id);
                }
            }//end of for
        }

        if (!isNullOrUndefined(aTrackType) & aTrackType == 1) {
            if (lStartDateTime < lNow.addDays(-2)) {
                lIsHistoricalDate = true;
                lObjectType = gObjectList.TrackpointHistory.AssemblyQualifiedName;
            } else {
                lObjectType = gObjectList.Trackpoint.AssemblyQualifiedName;
            }

            //read trackpoints if not enough visits
            lBuilder.Clear();
            lBuilder.AddNewExpressionConditional("EnrolleeId", lOffenderIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional("TrackDate", lStartDateTime.toWcf(), false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional("TrackDate", lEndDateTime.toWcf(), false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional("TrackTypeId", 1, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());

            if ($("#uEnrolleeHeatMapTimeFrame").is(":checked")) {
                ReadMultiple(lObjectType, lBuilder.RootExpression, 0, heatMapSearchFrame_OnSuccess, Sad, aData);
            } else {
                ReadMultiple(lObjectType, lBuilder.RootExpression, 0, heatMapSearch_OnSuccess, Sad, aData);
            }

        } else {
            //search visits first
            if (isNullOrUndefined(aData)) {
                lBuilder.Clear();
                lBuilder.AddNewExpressionConditional("DeviceId", lDeviceIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional("StartDate", lStartDateTime.toWcf(), false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional("EndDate", lEndDateTime.toWcf(), false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
                if ($("#uEnrolleeHeatMapTimeFrame").is(":checked")) {
                    //veritracks.mapping.readTripsVisits(lOffenderId, lIsHistoricalDate, lStartDateTime, lEndDateTime, false, heatMapSearchFrame_OnSuccess, Sad, null);
                    ReadMultiple(gObjectList.PointGrouping.AssemblyQualifiedName, lBuilder.RootExpression, 0, heatMapSearchFrame_OnSuccess, Sad, null);
                } else {
                    //veritracks.mapping.readTripsVisits(lOffenderId, lIsHistoricalDate, lStartDateTime, lEndDateTime, false, heatMapSearch_OnSuccess, Sad, null);
                    ReadMultiple(gObjectList.PointGrouping.AssemblyQualifiedName, lBuilder.RootExpression, 0, heatMapSearch_OnSuccess, Sad, null);
                }
            } else {
                heatMapSearch_OnSuccess(false,aData)
            }
        }//end of if
    }
}

function heatMapSearchFrame_OnSuccess(aParams, aData) {
    "use strict";
    var lStartDateTime =new Date(moment.utc(mEnrolleesData.HeatMapStartDate + ' ' + mEnrolleesData.HeatMapStartTime)),
        lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
        lTimeZone = getDataItem(lEnrollee.TimeZoneId,'TimeZone'),
        lResults = [],
        lDate = null,
        lhours = 0,
        lStartHours = 0,
        lEndHours = 0,
        lMinutes = 0,
        lStartMinutes = 0,
        lEndMinutes = 0,
        lStartEndTime = new Date(moment.utc(mEnrolleesData.HeatMapEndDate + ' ' + mEnrolleesData.HeatMapEndTime));

    //lStartDateTime = new Date(lStartDateTime);
    //lStartEndTime = new Date(lStartEndTime);

    for (var key in aData) {
        if (aData.hasOwnProperty(key)) {
            if (!isNullOrUndefined(aData[key].TrackDateUTC)) {
                lDate = new Date(aData[key].TrackDateUTC);
            } else {
                lDate = new Date(aData[key].StartDateUTC);
            }


            lhours = lDate.getHours() == 0 ? 24 : lDate.getHours();
            lStartHours = lStartDateTime.getHours() == 0 ? 24 : lStartDateTime.getHours();
            lEndHours = lStartEndTime.getHours() == 0 ? 24 : lStartEndTime.getHours();
            lMinutes = lDate.getMinutes() == 0 ? 60 : lDate.getMinutes();
            lStartMinutes = lStartDateTime.getMinutes() == 0 ? 60 : lStartDateTime.getMinutes();
            lEndMinutes = lStartEndTime.getMinutes() == 0 ? 60 : lStartEndTime.getMinutes();

            if (lhours >= lStartHours && lhours <= lEndHours) {
                if (lhours == lStartHours && lMinutes < lStartMinutes) {
                    //dont add
                } else if (lhours == lEndHours && lMinutes > lEndMinutes) {
                    //dont add
                } else {
                    lResults.push(aData[key]);
                }

            }//end of if

        }//end of if
    }//end of if
    heatMapSearch_OnSuccess(aParams, lResults);
}

function expandHeatMapVisits(aVisits) {
    "use strict";
    var lTrackPoints = [],
        lGPSTracks = [],
        lBuilder = new SumoPredicateBuilder();

    for (var key in aVisits) {
        if (aVisits.hasOwnProperty(key)) {
            if (aVisits[key].hasOwnProperty('Trackpoints') && !isNullOrUndefined(aVisits[key].Trackpoints)) {
                if (!isNullOrUndefined(aVisits[key].Trackpoints)) {
                    lGPSTracks = aVisits[key].Trackpoints;
                    lBuilder.Clear();
                    lBuilder.AddNewExpressionConditional("TrackTypeId", 1, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
                    lTrackPoints = lTrackPoints.concat(query(lGPSTracks, lBuildr.RootExpression));
                }
            } else {
                if (!isNullOrUndefined(aVisits[key])) {
                    lTrackPoints.push(aVisits[key]);
                }
            }
        }//end of if
    }//end of for

    return lTrackPoints;
}

function heatMapSearch_OnSuccess(aParams, aData) {
    "use strict";
    var filterdData = [],
         lVisitsTrackIds = [],
         lBuilder = new SumoPredicateBuilder(),
         lMinHitVisits = parseInt(veritracks.system.clientSetting('hitmapminvisit')),
         lMaxHitVisits = parseInt(veritracks.system.clientSetting('hitmapmaxvisit')),
         lMessage = '',
         lHitType = '',
         lVisitsTracks = [];

    if (!isNullOrUndefined(aData)) {
        if (aData.length < lMinHitVisits) {
            filterdData = expandHeatMapVisits(aData);
        } else {
            filterdData = aData;
        }

        if (filterdData.length < lMinHitVisits && isNullOrUndefined(aParams)) {
            //try search for more trackpoints
            uEnrolleesHeatMap_OnSearch(1, aData);
        } else {

            if (filterdData.length == 0 && aData.length > 0) {
                filterdData = filterdData.concat(aData);
            }

            if (filterdData.length > lMaxHitVisits) {
                filterdData = filterdData.splice(0, lMaxHitVisits - 1);
                lMessage = 'Allowed maximum hits exceeded.';
            }

            if (filterdData.length == 0) {
                lMessage = 'no results found';
            } else {
                if (filterdData[0].__type == gObjectList.Trackpoint.ShortName + ":www.veritracks.com" || filterdData[0].__type == gObjectList.TrackpointHistory.ShortName + ":www.veritracks.com") {
                    lHitType = ' trackpoint';
                } else {
                    lHitType = ' visit';
                }
                lMessage = lMessage + filterdData.length + lHitType + ' results found';
            }
            if (filterdData.length > 2) {
                var aCalcD = veritracks.mapping.calculateDistances(filterdData[0].Latitude, filterdData[0].Longitude, filterdData[filterdData.length - 1].Latitude, filterdData[filterdData.length - 1].Longitude);
                if (!isNullOrUndefined(aCalcD)) {
                    var R = 5280;
                    var rMax = 30;
                    //greater than 30 miles
                    if (aCalcD.distanceInFeet > R * rMax) {
                        var centerObj = filterdData[(filterdData.length - 1) / 2];
                        //reset center point
                        mEnrolleesControls.OffenderHeatMap.getMap().setCenter(centerObj.Latitude, centerObj.Longitude);
                        mEnrolleesControls.OffenderHeatMap.getMap().zoom(10);
                    } else {
                        mEnrolleesControls.OffenderHeatMap.getMap().setCenter(filterdData[0].Latitude, filterdData[0].Longitude);
                    }
                }
            }


            mActivityNotification.addNotification(lMessage);
            mEnrolleesControls.OffenderHeatMap.getMap().disposeHeatMap();
            mEnrolleesControls.OffenderHeatMap.getMap().setHeatMapDataPoints(filterdData);
            mEnrolleesControls.OffenderHeatMap.getMap().toggleHeatMap();
        }
    }
    setTimeout(function () {
        $("#uEnrolleHeatMapSearchHolder").show();
        $("#uEnrolleeHeatMapLoadingBar").hide();
    }, 1000);


}


function veritracksHeatMapPopup_Dispose() {
    "use strict";
    $('.PopupWindow').removeClass('CalendarWidth');
    $('#uPopupPanel').removeClass('LowZIndex');
    mEnrolleesControls.OffenderHeatMap = null;

    if (!isNullOrUndefined(mEnrolleesControls.OffenderHeatMapCardView)) {
        mEnrolleesControls.OffenderHeatMapCardView.dispose();
        mEnrolleesControls.OffenderHeatMapCardView = null;
    }

    if (ModalIsOpen()) {
        CloseModal();
    }
    ClosePopup();
}

function heatmapAddOffenderPopup_Dispose() {
    "use strict";
    if (!isNullOrUndefined(mEnrolleesControls.OffenderAddHeatMapCardView)) {
        mEnrolleesControls.OffenderAddHeatMapCardView.dispose();
        mEnrolleesControls.OffenderAddHeatMapCardView = null;
    }

    if (!isNullOrUndefined(mEnrolleesControls.OffenderHeatMapCardViewFilter)) {
        mEnrolleesControls.OffenderHeatMapCardViewFilter.dispose();
        mEnrolleesControls.OffenderHeatMapCardViewFilter = null;
    }


    if (ModalIsOpen()) {
        CloseModal();
    }

    ClosePopup();
}
/***Artf66582**************************/
/**************************************/

function configureDateSettings_Init() {
    "use strict";
    var lBodyHtml = [],
        lConfigSelect = [],
        lDefaultTimeline = [],
        lButtonCommandBar = GenerateButtonCommandBar();

    var lDayPreference = getFirstDay();
    var lDataPreference = getDayofData();
    var lTabPreference = getTabTimeline();
    var lLoadPreference = getTimelineLoadPreference();
    var lMapDateChangePreference = getTimelineDateChangeMapLoadPreference() == 1? "checked" : "";
    //day of week to start in - configure setting

    var lDefaultStartDayView = uConfigureSelectDayView(lDayPreference);

    var lDefaultStartDayofData = uConfigureDayofData(lDataPreference);

    var lDefaultTabView = uConfigureTabTimeline(lTabPreference);

    lBodyHtml.push('<table>');
    lBodyHtml.push('<tr><td>');
    lBodyHtml.push('<tr>');
    lBodyHtml.push('<td class="FormTitle">' + localizeWrapper('cEnrolleeSelectDay') + '</td>');
    lBodyHtml.push('<td class="FormField">' + lDefaultStartDayView + '</td>');
    lBodyHtml.push('</tr>');
    lBodyHtml.push('<tr><td>');
    lBodyHtml.push('<tr>');
    lBodyHtml.push('<td class="FormTitle">' + localizeWrapper('cEnrolleeDayofData') + '</td>');
    lBodyHtml.push('<td class="FormField">' + lDefaultStartDayofData + '</td>');
    lBodyHtml.push('</tr>');
    lBodyHtml.push('<tr>');
    lBodyHtml.push('<td class="FormTitle"> ' + localizeWrapper('cEnrolleeInitialTimelineMapView')+ ' </td>');
    lBodyHtml.push('<td class="FormField"><input type="checkbox" id="uTimelinePreferenceDefaulView"/></td>');
    lBodyHtml.push('</tr>');
    lBodyHtml.push('<tr>');
    lBodyHtml.push('<td class="FormTitle"> ' + localizeWrapper('cEnrolleeRefreshMapOnDateChange') + ' </td>');
    lBodyHtml.push('<td class="FormField"><input type="checkbox" id="uTimelineRefreshMapOnDateChange" ' + lMapDateChangePreference + '/></td>');
    lBodyHtml.push('</tr>');
    lBodyHtml.push('<tr>');
    lBodyHtml.push('<td class="FormTitle"> ' + localizeWrapper('cEnrolleeTimelineDefaultTab') + ' </td>');
    lBodyHtml.push('<td class="FormField">' + lDefaultTabView + '</td>');
    lBodyHtml.push('</tr>');
    lBodyHtml.push('</td></tr>');
    lBodyHtml.push('</table>');

    GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'uSaveConfigureDateStartSettings()').appendTo(lButtonCommandBar);
    GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', 'ClosePopup()').appendTo(lButtonCommandBar);

    DisplayPopup(localizeWrapper('cEnrolleeConfigureSettings'), lBodyHtml.join(''), lButtonCommandBar, true, true);

    if (parseInt(lLoadPreference)) {
        $('#uTimelinePreferenceDefaulView').prop('checked', true);
    } else {
        $('#uTimelinePreferenceDefaulView').prop('checked', false);
    }
}

/***Artf70400**************************/
/**************************************/
function uConfigureSelectDayView(aDayPreference) {
    var lConfigSelect = [],
        lDayPreference = aDayPreference;
    var lDaysOfWeek = [{ 'key': 0, 'value': localizeText('cSunday') },
                    { 'key': 1, 'value': localizeText('cMonday') },
                    { 'key': 2, 'value': localizeText('cTuesday') },
                    { 'key': 3, 'value': localizeText('cWednesday') },
                    { 'key': 4, 'value': localizeText('cThursday') },
                    { 'key': 5, 'value': localizeText('cFriday') },
                    { 'key': 6, 'value': localizeText('cSaturday') }];

    lConfigSelect.push('<select id="configDaySelect">');
    for (var lKey in lDaysOfWeek) {
        if (lDaysOfWeek.hasOwnProperty(lKey)) {
            if (lDayPreference == lDaysOfWeek[lKey].key) {
                lConfigSelect.push('<option value="' + lDaysOfWeek[lKey].key + '" selected>' + lDaysOfWeek[lKey].value + '</option>');
            }
            else {
                lConfigSelect.push('<option value="' + lDaysOfWeek[lKey].key + '">' + lDaysOfWeek[lKey].value + '</option>');
            }
        }
    }
    lConfigSelect.push('</select>');

    return lConfigSelect.join('');
}

function uConfigureDayofData(aDataPreference) {
    var lConfigSelect = [],
        lDataPreference = aDataPreference;
    var lDataOptions = [{ 'key': 0, 'value': localizeText('cPrior') },
                    { 'key': 1, 'value': localizeText('cCurrent') }];

    lConfigSelect.push('<select id="configDataSelect">');
    for (var lKey in lDataOptions) {
        if (lDataOptions.hasOwnProperty(lKey)) {
            if (lDataPreference == lDataOptions[lKey].key) {
                lConfigSelect.push('<option value="' + lDataOptions[lKey].key + '" selected>' + lDataOptions[lKey].value + '</option>');
            }
            else {
                lConfigSelect.push('<option value="' + lDataOptions[lKey].key + '">' + lDataOptions[lKey].value + '</option>');
            }
        }
    }
    lConfigSelect.push('</select>');

    return lConfigSelect.join('');
}

function uConfigureTabTimeline(aTabPreference) {
    var lConfigSelect = [],
    lDataPreference = aTabPreference;
    var lDataOptions = [{ 'key': 0, 'value': localizeText('cEnrolleeDetails') },
                    { 'key': 1, 'value': localizeText('cEnrolleeQuickMap') }];

    lConfigSelect.push('<select id="tabDataSelect">');
    for (var lKey in lDataOptions) {
        if (lDataOptions.hasOwnProperty(lKey)) {
            if (lDataPreference == lDataOptions[lKey].key) {
                lConfigSelect.push('<option value="' + lDataOptions[lKey].key + '" selected>' + lDataOptions[lKey].value + '</option>');
            }
            else {
                lConfigSelect.push('<option value="' + lDataOptions[lKey].key + '">' + lDataOptions[lKey].value + '</option>');
            }
        }
    }

    lConfigSelect.push('</select>');

    return lConfigSelect.join('');
}
/***Artf66582******Artf70400***********/
/**************************************/
function uSaveConfigureDateStartSettings() {
    "use strict";

    var lStartDaySelected = $('#configDaySelect').val();
    var lStartDataSelected = $('#configDataSelect').val();
    var lTabDataSelected = $('#tabDataSelect').val();
    var lIsInitialLoadSelected = $('#uTimelinePreferenceDefaulView').is(":checked") ? "1" : "0";
    var lIsRefreshMapSelected = $('#uTimelineRefreshMapOnDateChange').is(":checked") ? "1" : "0";
    var lPreference;
    var lPreferenceWrite = [];
    var userId = gUserDetails.UserId;

    if (!isNullOrUndefined(lStartDaySelected)) {
        lPreference = new UserPreference();
        lPreference.UserPreferenceType = 13;
        lPreference.ColumnName = 'TimelineStartDay';
        lPreference.Id = userId;
        lPreference.Value = lStartDaySelected;
        lPreferenceWrite.push(lPreference);
    }

    if (!isNullOrUndefined(lStartDataSelected)) {
        lPreference = new UserPreference();
        lPreference.UserPreferenceType = 13;
        lPreference.ColumnName = 'TimelineDataDay';
        lPreference.Id = userId;
        lPreference.Value = lStartDataSelected;
        lPreferenceWrite.push(lPreference);
    }

    if (!isNullOrUndefined(lIsInitialLoadSelected)) {
        lPreference = new UserPreference();
        lPreference.UserPreferenceType = 13;
        lPreference.ColumnName = 'TimelineDefaultView';
        lPreference.Id = userId;
        lPreference.Value = lIsInitialLoadSelected;
        lPreferenceWrite.push(lPreference);
    }

    if (!isNullOrUndefined(lIsRefreshMapSelected)) {
        lPreference = new UserPreference();
        lPreference.UserPreferenceType = 13;
        lPreference.ColumnName = 'TimelineRefreshMapDateChange';
        lPreference.Id = userId;
        lPreference.Value = lIsRefreshMapSelected;
        lPreferenceWrite.push(lPreference);
    }

    if (!isNullOrUndefined(lTabDataSelected)) {
        lPreference = new UserPreference();
        lPreference.UserPreferenceType = 13;
        lPreference.ColumnName = 'TimelineTab';
        lPreference.Id = userId;
        lPreference.Value = lTabDataSelected;
        lPreferenceWrite.push(lPreference);
    }
    if (lPreferenceWrite.length > 0) {
        writeUserPreferences(lPreferenceWrite, reloadTimelineConfigurations);
    }
    ClosePopup();
}

function reloadTimelineConfigurations(aParams, aData) {
    "use strict";
    var lLoadPreference = parseInt(getTimelineLoadPreference());
    var lDayPreference = parseInt(getDayofData());
    if (!lLoadPreference) {
        if (mStateManager.Settings()[1] == 'Profile') {
            removeBigChart();
        }
    } else {
        if (mStateManager.Settings()[1] == 'Profile') {
            $('#uLoadAllDayTimelineMap').hide();
        }

        if ($('#enrolleesSmallMapCharting').length > 0) {
            var lView;

            if (mEnrolleesControls.veritracksChartMiniMap) {
                lView = mEnrolleesControls.veritracksChartMiniMap.getViewName();
                mEnrolleesControls.veritracksChartMiniMap.destroy();
                mEnrolleesControls.veritracksChartMiniMap = null;
            }
            if (!mEnrolleesControls.veritracksChartMiniMap || $('#uEnrolleesChartPanel').is(':hidden')) {
                enrolleesSmallChart_Init(lView);
                mEnrolleesControls.veritracksChartMiniMap.addExtraData('IgnoreClose', true);
                var lLoadDay = !lDayPreference;
                if (lView == 'agendaWeek') {
                    lLoadDay = false;
                }
                setTimelineDates(true, mEnrolleesData.OffenderCurrentId, lLoadDay);
            }
        }
    }

    testBigChart();
}

/***Artf66582**************************/
/**************************************/
function getFirstDay() {
    var lPreference = getUserPreferences(13);
    var lValue = 0;

    if (lPreference.TimelineStartDay) {
        lValue = lPreference.TimelineStartDay.Value;
    }
    return lValue;
}

/***artf70400*************************/
/*************************************/
function getDayofData() {
    var lPreference = getUserPreferences(13);
    var lValue = 0;

    if (lPreference.TimelineDataDay) {
        lValue = lPreference.TimelineDataDay.Value;
    }
    return lValue;
}

function getTimelineLoadPreference() {
    var lPreference = getUserPreferences(13);
    var lState = getViewState('AnalysisMatchEndDate');
    var lValue = 0;
    var lClientProperty = veritracks.system.clientSetting('TimelineDisabled');
    if (lPreference.TimelineDefaultView) {
        lValue = lPreference.TimelineDefaultView.Value;
    }
    if (!isNullOrUndefined(lState) && !isNullOrUndefined(lState.Value)){
        lValue = 0;
    }

    if (lClientProperty) {
        lValue = 0;
    }
    return lValue;
}

function getTimelineDateChangeMapLoadPreference() {
    var lPreference = getUserPreferences(13);
    var lValue = 1; // default to yes per user story.

    if (lPreference.TimelineRefreshMapDateChange) {
        lValue = lPreference.TimelineRefreshMapDateChange.Value;
    }
    return lValue;
}

function getTabTimeline() {
    var lPreference = getUserPreferences(13);
    var lValue = 1; // default to yes per user story.

    if (lPreference.TimelineTab) {
        lValue = lPreference.TimelineTab.Value;
    }
    return lValue;
}

/***Artf66582**************************/
/**************************************/
function chartAfterRenderImageAppend(aEvent, aElement) {
    "use strict";
    var lMetaEventIdList = [];
    var lTitle = aEvent.title;
    var lContentHtml = [];
    var lEventHtml = [];
    var lDefaultMy = 'left top';
    var lDefaultAt = 'right top';
    var lEvent;
    var lNewEvent;
    var lSort = new SortExpression();
    var lConfirmedList = [];
    var lAllConfirmedCount = 0;
    var lEventLimit = 7;
    var lEventCount = 0;
    var duration = 0;
    var durationCheck = 0;
    var durationTime = '';
    var hours = 0;
    var mins = 0;
    var lListFinished = false;
    var lBuilder = new SumoPredicateBuilder();
    var lKey;
    var lHasAssociation = false;
    var lEnrolleeId;
    var lStartDateUTC;
    var lStopDateUTC;
    var lData;
    var lAssociationActualIcon;
    var lAssociationEvent;
    var lConfirmed = '';

    aElement[0].addEventListener("contextmenu", function (e) {
        e.preventDefault();
        setTimelinePopupMenu(aEvent, aElement);
        
    });
    if (aEvent.end) {
        duration = moment.duration(aEvent.end.diff(aEvent.start));
        durationCheck = duration.asHours();
        hours = Math.floor(duration.asHours());
        mins = Math.floor(duration.asMinutes()) - hours * 60;
        durationTime = formatterMinutesandHours(hours, mins);
    }

    if (durationCheck <= .5) {
        aElement.empty();
    }

    if (aEvent.Associations.length > 0) {
        lAssociationEvent = { 'MetaEventId': 2001 };
        lAssociationActualIcon = 2001;

        for (var lKeyA in aEvent.Associations) {
            if (aEvent.Associations.hasOwnProperty(lKeyA)) {
                if (aEvent.Associations[lKeyA].OrganizationAddressId > 0) {
                    if (checkValidOrganizationAddress(aEvent.Associations[lKeyA].OrganizationAddressId))
                        lAssociationActualIcon = 2002;
                }
            }
        }

        aElement.find("div.fc-content").append(enrolleesEventMapIconFormatter(lAssociationEvent, null, lAssociationActualIcon));
    }
    // potential trips added for visits that have extended no location areas.
    if (aEvent.potentialTrip) {
        aElement.find("div.fc-content").append(enrolleesPotentialTripIconFormatter());
    }
    if (aEvent.eventList) {
        if (aEvent.eventList.length > 0) {
            aElement.addClass('VeritracksSmallEvents');
            var lAllConfirmed = 0;
            for (lKey in aEvent.eventList) {
                if (aEvent.eventList.hasOwnProperty(lKey)) {
                    lEvent = aEvent.eventList[lKey];
                    if (lEvent.IsConfirmed) {
                        lAllConfirmed++;
                    }
                    lAllConfirmedCount = 0;

                    if (lMetaEventIdList.indexOf(lEvent.MetaEventId) == -1) { // only allow 1 icon of the same type
                        if (durationCheck > .5) {
                            lBuilder.Clear();
                            lBuilder.AddNewExpressionConditional('MetaEventId', lEvent.MetaEventId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                            lConfirmedList = query(aEvent.eventList, lBuilder.RootExpression);

                            for (var lKeyA in lConfirmedList) {
                                if (lConfirmedList.hasOwnProperty(lKeyA)) {
                                    if (lConfirmedList[lKeyA].IsConfirmed) {
                                        lAllConfirmedCount++;
                                    }
                                }
                            }
                            lMetaEventIdList.push(lEvent.MetaEventId);
                            if (ObjectLength(lConfirmedList) == lAllConfirmedCount) {
                                aElement.find("div.fc-content").append(enrolleesEventMapIconFormatter(lSort.sort(lConfirmedList)[0]));
                            } else {
                                aElement.find("div.fc-content").append(enrolleesEventMapIconFormatter(lEvent, false));
                            }
                        }
                        lMetaEventIdList.push(lEvent.MetaEventId);

                    }

                    if (lEventCount <= lEventLimit) {
                        if (lEvent.MetaEventId > 0 && lEvent.DisplayFlag == 1) {
                            lConfirmed = lEvent.IsConfirmed ? "<strong>(C)</strong> " : "";
                            lEventHtml.push('<tr><td >' + lConfirmed+ formatterMetaEvent(lEvent.MetaEventId) + '</td>');
                            lEventHtml.push('<td>' + formatEventStartDateTime(lEvent) + '</td>');
                            lEventHtml.push('<td>' + formatEventEndDateTime(lEvent) + '</td></tr>');

                        }
                        lEventCount++;
                    }
                }
            }
            if (lAllConfirmed == aEvent.eventList.length) {
                aElement.addClass('VeritracksSmallGreenEvents');
            }
        }
        lContentHtml.push('<div class="tooltip">');
        if (lAssociationActualIcon) {
            lContentHtml.push('<div class="FloatRight" data-enrolleeId="' + lEnrolleeId + '" data-startdateutc="' + lStartDateUTC + '" data-stopdateutc="' + lStopDateUTC + '"> <strong>' + localizeText('cEnrolleeHasAssociation') + ' </strong>' + enrolleesEventMapIconFormatter( lAssociationEvent, {IsConfirmed: false},  lAssociationActualIcon) + ' </div>');
        }
        lContentHtml.push('<div> <strong>' + localizeText('cAnalysisStart') + ':</strong> ' + aEvent.start.format('MM/DD/YYYY hh:mm:ss A') + '</div>');
        if (aEvent.end) {
            lContentHtml.push('<div> <strong>' + localizeText('cAnalysisEnd') + ':</strong> ' + aEvent.end.format('MM/DD/YYYY hh:mm:ss A') + '</div>');
        }
        if (aEvent.potentialTrip) {
            lContentHtml.push('<div class="FloatRight PotentialVisit" data-enrolleeId="' + lEnrolleeId + '" data-startdateutc="' + lStartDateUTC + '" data-stopdateutc="' + lStopDateUTC + '"> <strong>' + localizeText('cPotentialTrip') + ' </strong>' + enrolleesPotentialTripIconFormatter() + '</div>');
        }
        lContentHtml.push('<div> <strong>' + localizeWrapper('cTimelineDuration') + ':</strong> ' + durationTime + '</div>');
        lContentHtml.push('<div> <strong>title:</strong> ' + lTitle + '</div>');
        if (aEvent.data && aEvent.data.MatchType != "In Motion (i.e., Trip)") {
            lContentHtml.push('<div> <strong> ' + localizeText('cEnrolleeAddress') + ':</strong>');
            lContentHtml.push('<span id="reversegeocode">geocoding....</span>');
            if (aEvent.data.VisitFrequency) {
                lContentHtml.push('<div> <strong>' + localizeText('cEnrolleeTimelineFrequency') + ': </strong>' + VisitFrequencyFormatter(aEvent.data.VisitFrequency) + '</div>');
            }
            lData = { "Latitude": aEvent.data.Latitude, "Longitude": aEvent.data.Longitude };

        }

        if (lEventHtml.length > 0) {
            lContentHtml.push('<div><strong>events</strong></div>');
            lContentHtml.push('<table class="sumo-listview-header-table">');
            lContentHtml.push('<tr class="sumo-listview-header-row">');
            lContentHtml.push('<th class="sumo-listview-header-cell">description</th><th class="sumo-listview-header-cell">' + localizeText('cAnalysisStart') + '</th><th class="sumo-listview-header-cell">' + localizeText('cEventStop') + '</th>');
            lContentHtml.push('</tr>');
            lContentHtml.push(lEventHtml.join(''));
            lContentHtml.push('</table>');
            lContentHtml.push('<strong>' + localizeText('cEnrolleeRightClickDetails') + '</strong>');
        }
        lContentHtml.push('</div>');

        // append qtip to each element.
        aElement.qtip({
            content: {
                text: lContentHtml.join(''),
                position: lData
            },
            hide: { when: { aEvent: 'unfocus' } },
            position: {
                my: lDefaultMy,
                at: lDefaultAt,
                adjust: {
                    method: 'shift'
                },
                viewport : $(window)
                //viewport: aId
            },
            events: {
                show: function (event, api) {
                    var id = '#qtip-' + aElement.qtip().id + '-content ',
                        reverseId = id + '#reversegeocode';

                    reverseGeocodeOnHoverTimelineEvent(aElement, reverseId);
                }
            },
            show: {
                delay: 700
            },
            style: 'qtip-bootstrap qtip-no-width'
        });
    }
}

function reverseGeocodeOnHoverTimelineEvent(aElement, aId) {
    "use strict";
    var lPosition = aElement.qtip('api').options.content.position

    if (lPosition) {
        var geocoder = new google.maps.Geocoder(),
            latlng = new google.maps.LatLng(lPosition.Latitude, lPosition.Longitude);

        geocoder.geocode({ 'latLng': latlng }, function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
                if (results) {
                    $(aId).html(results.formated_address);
                }
            }
        });
    }
}

function setDragCal(aStart, aEnd) {
    "use strict";
    var lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees');

    mEnrolleesData.ChartStartDate = convertMomentLocal(aStart._d);
    mEnrolleesData.ChartEndDate = convertMomentLocal(aEnd._d);

    if (mStateManager.Settings()[1] === 'Map') {
        offenderMapPopulate(true);
    } else {
        ChangeHashSettings(1, 'Map');
    }
}

function timelineRecordTracking(aEnrolleeId, aStartDate, aEndDate) {
    "use strict";
    var lUserTransaction = new UserTransaction();
    var lDoNotTrack = false;
    var lAgentsStopCheck = getDataItem(gUserDetails.UserId, 'Users');

    if (moment(aEndDate) > moment()) {
        aEndDate = moment()._d;
    }
    if (moment(aStartDate) > moment()) {
        lDoNotTrack = true;
    }
    var ORIPropertyTrackReview = veritracks.enrollees.mapping.ORIFlag();
    if (ORIPropertyTrackReview == 'N'){
        // no track at all  return; 
        return; 
    } else if(ORIPropertyTrackReview == 'R'){
        //  Recording  
        // only prevents to record when the Lock button is clicked
        var lLockData = veritracks.enrollees.mapping.getMapTimeLockTrackingState(); 
        if(!lLockData.lock && !lLockData.tracking || lLockData.lock && !lLockData.tracking ){
            return;
        }
    } else if(ORIPropertyTrackReview != 'Y'){
        // block anythng else
        return;
    }
    // Automatically ( no click control at ALL)

    function logUserTimelineTransaction_OnSuccess(aParams, aData) {
        "use strict";
        var lUserTransactionValue = new UserTransactionValue(),
            lUserTransactionValuesList = [];
        
        //CT_TRACKED_OFFENDER_ID 4411
        //lognumber logname
        //data type id = 2
        lUserTransactionValue.TransactionId = aData.Id;
        lUserTransactionValue.LogNumberName = 'CT_TRACKED_OFFENDER_ID';
        lUserTransactionValue.LogNumberValue = aEnrolleeId;
        lUserTransactionValue.DataTypeId = 2;
        lUserTransactionValuesList.push(lUserTransactionValue);

        //TRACK_START_DATE_LOCAL log date value
        //start date of time range
        //data type id = 3
        lUserTransactionValue = new UserTransactionValue();
        lUserTransactionValue.TransactionId = aData.Id;
        lUserTransactionValue.LogDateName = 'TIMELINE_TRACK_START_DATE_LOCAL';
        lUserTransactionValue.LogDateValue = aStartDate;
        lUserTransactionValue.DataTypeId = 3;
        lUserTransactionValuesList.push(lUserTransactionValue);

        //TRACK_STOP_DATE_LOCAL log date value
        //stop date of time range
        //data type id = 3
        lUserTransactionValue = new UserTransactionValue();
        lUserTransactionValue.TransactionId = aData.Id;
        lUserTransactionValue.LogDateName = 'TIMELINE_TRACK_STOP_DATE_LOCAL';
        lUserTransactionValue.LogDateValue = aEndDate;
        lUserTransactionValue.DataTypeId = 3;
        lUserTransactionValuesList.push(lUserTransactionValue);

        //write multiple
        WriteMultiple(lUserTransactionValuesList, null, null, null, true, true);
    }

    if (GetEnrolleeCardProductIdTimelineSupport(aEnrolleeId) && lAgentsStopCheck && !lDoNotTrack) {
        //lUserTransaction.UserId = gUserDetails.UserId;
        lUserTransaction.EnrolleeId = aEnrolleeId;
        lUserTransaction.TypeId = 6; //TODO: Change to 6 JIRA-1171 
        lUserTransaction.DisplayId = gUserDetails.UserId;

        WriteSingle(lUserTransaction, logUserTimelineTransaction_OnSuccess, Sad, null, true);
    }
}

function setEventsFromHistoryCal(aStartEvent, aEndEvent, aTimezone) {
    "use strict";
    var lEnrolleeId = mEnrolleesData.OffenderCurrentId,
        lStartDate = moment(aStartEvent.format()),
        lEndDate = moment(aEndEvent.format());

    veritracks.enrollees.mapping.readEnrolleeTimelineChart(lEnrolleeId, lStartDate, lEndDate, null, function (aTimelineData) {
        if (lEnrolleeId == mEnrolleesData.OffenderCurrentId){
            mEnrolleesControls.veritracksChartMap.setDataSource([]);
            mEnrolleesControls.veritracksChartMap.setDataSource(aTimelineData);
            timelineRecordTracking(lEnrolleeId, lStartDate._d, lEndDate._d);
            timelineDisableNavigation(false);
        }
        mEnrolleesControls.veritracksChartMap.invertDayColors(false, 'ColorInvertGray');
        $('div.qtip:visible').qtip('hide');
    });
}

function setEventsFromHistoryMiniCal(aStartEvent, aEndEvent, aTimezone) {
    "use strict";
    var lEnrolleeId = mEnrolleesData.OffenderCurrentId,
        lStartDate = moment(aStartEvent.format()),
        lEndDate = moment(aEndEvent.format());

    if (lEnrolleeId == -1) {
        lEnrolleeId = $('.cycleCaseSelected').data('value');
    }

    if (mEnrolleesControls.veritracksChartMiniMap) {
        if (!mEnrolleesControls.veritracksChartMiniMap.getExtraData('IgnoreCallback')) {
            timelineInactiveActiveCheck();
            var lParams = { start: aStartEvent, end: aEndEvent };
            veritracks.enrollees.mapping.readEnrolleeTimelineChart(lEnrolleeId, lStartDate, lEndDate, lParams, function (aTimelineData) {
                if (lEnrolleeId == mEnrolleesData.OffenderCurrentId) {
                    mEnrolleesControls.veritracksChartMiniMap.setDataSource([]);
                    mEnrolleesControls.veritracksChartMiniMap.setDataSource(aTimelineData);
                    timelineRecordTracking(lEnrolleeId, lStartDate._d, lEndDate._d);
                    if (mStateManager.Settings()[1] == 'Map') {
                        if (getTimelineDateChangeMapLoadPreference() == 1) {
                            var lStart = moment(lStartDate);
                            var lEnd = moment(lEndDate);
                            var lDifference = lEnd.diff(lStart, 'hours');
                            if (lDifference <= 24) {
                                mEnrolleesData.ChartStartDate = convertMomentLocal(lParams.start._d);
                                mEnrolleesData.ChartEndDate = convertMomentLocal(lParams.end._d);
                                offenderMapPopulate(true, true);
                                if (!isNullOrUndefined(mEnrolleesData.OffenderSecondaryCurrentId)) {
                                    offenderSecondaryMapPopulate();
                                }
                            }
                        }
                    }
                    timelineDisableNavigation(false);
                }
                $('div.qtip:visible').qtip('hide');
            });
        } else {
            mEnrolleesControls.veritracksChartMiniMap.addExtraData('IgnoreCallback', false);
        }
    }


}

function populateTimelineMapElements() {
    var lDisplayType = 'roadmap';
    var lBuilder = new SumoPredicateBuilder();
    var lCard;
    var lResults = [];
    var lKey;

    lBuilder.AddNewExpressionConditional('Id', mEnrolleesData.OffenderCurrentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lResults = query(mEnrolleesData.OffenderClean, lBuilder.RootExpression);

    for (lKey in lResults) {
        if (lResults.hasOwnProperty(lKey)) {
            lCard = lResults[lKey];
        }
    }
    mEnrolleesControls.TimelineMap = new sumo.maps.GoogleMapControl('uTimelineMap', 'uMapTimePanel',
        {
            'displayType': lDisplayType,
            'mapTypeId_OnChange': mapDisplayType_OnChange,
            'OnClick': veritracks.enrollees.mapping.onClick,
        });

    var lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'zIndexStart': 90000,
        'clickEventHandler': timelineVisit_OnClick,
        'rightClickEventHandler': timelineVisit_OnClick,
        'hoverEventHandler': veritracks.mapping.enrolleeMarkerHover,
        'hoverOutEventHandler': veritracks.mapping.enrolleeMarkerHoverOut
    };

    mEnrolleesControls.TimelineMap.layerAdd('Visit', lLayerOptions);

    lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': timelinePlaces_Click,
        'hoverEventHandler': veritracks.mapping.placesMarkerHover,
        'hoverOutEventHandler': veritracks.mapping.placesMarkerHoverOut,
        'zIndexStart': 90000,
        'markerImageSize': { 'width': 26, 'height': 26 }
    };

    mEnrolleesControls.TimelineMap.layerAdd('Places', lLayerOptions);

    lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': timelineVisit_OnClick,
        'zIndexStart': 90000,
        'hoverEventHandler': veritracks.mapping.addressMarkerHover,
        'hoverOutEventHandler': veritracks.mapping.addressMarkerHoverOut
    };

    mEnrolleesControls.TimelineMap.layerAdd('Addresses', lLayerOptions);

    lLayerOptions = {
        'renderType': 'geometry',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1000000,
        'shapeChangeHandler': null
    };

    mEnrolleesControls.TimelineMap.layerAdd('Zones', lLayerOptions);


    lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 80000
    };
    mEnrolleesControls.TimelineMap.layerAdd('Tags', lLayerOptions);

    mEnrolleesControls.TimelineMap.layerAdd('TagLabels', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 700000
    });

    if (!mEnrolleesData.CurrentTimelineEvent.Grouping) {
        if (mEnrolleesData.CurrentTimelineEvent.data && mEnrolleesData.CurrentTimelineEvent.data.PointGroupId == -1 && mEnrolleesData.CurrentTimelineEvent.data.MatchType.indexOf('In Progress') !== -1) {
        } else {
            lBuilder.Clear();
            lBuilder.AddNewExpressionConditional('Id', mEnrolleesData.CurrentTimelineEvent.data.PointGroupId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('DeviceId', lCard.TrackingDeviceId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('StartDate', moment(mEnrolleesData.CurrentTimelineEvent.data.StartDateUTC).add(-1,'days')._d.toWcf(), false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());
            ReadMultiple(gObjectList.PointGrouping.AssemblyQualifiedName, lBuilder.RootExpression, 0, TimelinePointGrouping_Success, null, null);
        }
    }
    else {
        TimelinePointGrouping_Success(null, [mEnrolleesData.CurrentTimelineEvent.Grouping]);
    }
}

function TimelinePointGrouping_Success(aParams, aData) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    var lLatitude = mEnrolleesData.CurrentTimelineEvent.data.Latitude;
    var lLongitude = mEnrolleesData.CurrentTimelineEvent.data.Longitude;

    if (aData.length > 0) {
        FixDates(aData);
        mEnrolleesData.CurrentTimelineEvent.Grouping = aData[0];
        mEnrolleesControls.TimelineMap.setCenter(aData[0].Latitude, aData[0].Longitude);
        mEnrolleesControls.TimelineMap.layerSetDataSource('Visit', [veritracks.mapping.prepareVisitItem(aData[0], 1)]);
        mEnrolleesControls.TimelineMap.zoom(18);

        GetVisitTag(aData[0].Id, timelineUpdateInit_Tags, mEnrolleesData.CurrentTimelineEvent.Grouping);
    }
    timelineAddresses_Init({
        'Latitude': lLatitude,
        'Longitude': lLongitude
    });

}

function timelineUpdateInit_Tags(aParams, aData) {
    timelineTag_OnComplete(aParams, aData);

    var lData = aData[0];

    if (lData) {
        if (mEnrolleesData.CurrentTimelineEvent.title == "Visit Not Labeled") {
            mEnrolleesData.CurrentTimelineEvent.data.MatchType = "Labeled Visit";
            mEnrolleesData.CurrentTimelineEvent.data.Title = lData.Name;
            mEnrolleesData.CurrentTimelineEvent.data.LocationId = lData.TagId;
        }

        timelineUpdateEvent();
    }
}

function GetVisitTag(aVisitId, aCallback, aParams, aIsArray) {
    var lBuilder = new SumoPredicateBuilder();

    if (aIsArray) {
        lBuilder.AddNewExpressionConditional('VisitId', aVisitId, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    } else {
        lBuilder.AddNewExpressionConditional('VisitId', aVisitId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    }
    ReadMultiple(gObjectList.TagVisitLink.AssemblyQualifiedName, lBuilder.RootExpression, 0, aCallback, null, aParams, null, 0);
}

function timelineAddresses_Init(aVisit) {
    "use strict";
    veritracks.mapping.reverseGeoCode(mEnrolleesControls.TimelineMap, aVisit.Latitude, aVisit.Longitude, timelineAddress_Success);

    function timelineAddress_Success(aResults) {
        var lResult = aResults[0];
        var lAddress = new Address(lResult);

        lAddress.Latitude = mEnrolleesData.CurrentTimelineEvent.data.Latitude;
        lAddress.Longitude = mEnrolleesData.CurrentTimelineEvent.data.Longitude;

        buildTimelineAddress(lAddress);
    }
}

function uAddTimelineAddressButton_OnClick() {
    "use strict";
    var lAddress = new EnrolleeAddress(),
        lMapAddress = getTimelineAddressFromMap(),
        lTag;

    if (mEnrolleesControls.TimelineAddressValidator.IsValid()) {
        populateFromEditView(lAddress, 'uTimelineAddress', 'Edit');

        lAddress.EnrolleeId = mEnrolleesData.OffenderCurrentId;
        lAddress.Latitude = RoundNumber(lMapAddress.Latitude, 7);
        lAddress.Longitude = RoundNumber(lMapAddress.Longitude, 7);
        lAddress.City = lMapAddress.City;
        lAddress.Country = lMapAddress.Country;
        lAddress.State = lMapAddress.State;
        lAddress.Street1 = lMapAddress.Street1;
        lAddress.Zip = lMapAddress.ZipCode;
        lAddress.PositionMatchesGeocode = true;
        lAddress.TransactionId = moment().format("YYYYMMDDHHmmss");
        if (lAddress.Id === -1) {
            lTag = new Tag();
            lTag.Name = lAddress.Title;
            lTag.Latitude = lAddress.Latitude;
            lTag.Longitude = lAddress.Longitude;
            lTag.UserId = gUserDetails.UserId;
            WriteSingle(lTag, null, Sad, {}, true);
        }
        WriteSingle(lAddress, uTimelineAddressSave_OnComplete, Sad, null);
    }
}

function uTimelineAddressSave_OnComplete(aParams, aData) {
    "use strict";
    var lAddressType = getDataItem(aData.AddressTypeId, 'AddressType');

    mEnrolleesData.OffenderProfileAddresses[aData.Id] = aData;
    mEnrolleesData.CurrentTimelineEvent.data.LocationId = aData.Id;

    mEnrolleesData.CurrentTimelineEvent.data.MatchType = capitalize(lAddressType.Description);
    mEnrolleesData.CurrentTimelineEvent.data.Title = aData.Title;
    timelineUpdateEvent();
    buildTimelineAddress(aData);
}

function timelineTag_OnComplete(aParams, aData) {
    "use strict";
    var lVisit = aParams;
    var lLabel;
    var lKey;

    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            if (aData[lKey].IsActive) {
                lLabel = aData[lKey];
                if (lLabel.TagId) {
                    mEnrolleesData.CurrentTimelineEvent.TagId = lLabel.TagId;
                } else {
                    mEnrolleesData.CurrentTimelineEvent.TagId = lLabel.Id;
                }
            }
        }
    }
    mEnrolleesControls.TimelineMap.layerSetDataSource('Places', []);
    mEnrolleesControls.TimelineMap.layerSetDataSource('Tags', []);
    mEnrolleesControls.TimelineMap.layerSetDataSource('TagLabels',[]);
    if (lLabel) {
        $('#uTimelinePlacesExist').show();
        $('#uTimelinePlacesCreate').hide();
        timelineLabel_Init(lLabel);
    } else {
        $('#uTimelinePlacesCreate').show();
        $('#uTimelinePlacesExist').hide();
        timelinePlaces_Init();
        $('#uEnrolleeTimelineLabelUpdatedBy').hide();
    }

    function timelineLabel_Init(aLabel) {
        GetTag(mEnrolleesData.CurrentTimelineEvent.TagId, timelineLabelContinue, Sad, aLabel);
    }

    function timelineLabelContinue(aParams, aData) {
        var lTag = aData[0];
        mEnrolleesControls.TimelinePlacesValidator = new Validator('uTimelinePlacesExist', mRegexValidation);
        mEnrolleesControls.TimelineMap.layerSetDataSource('Tags', [veritracks.mapping.prepareTrackpointMarkerItem(lTag, 1)]);
        mEnrolleesControls.TimelineMap.layerSetDataSource('TagLabels', veritracks.mapping.prepareSuggestionLabelOverlayData([lTag]));
        $('#uEnrolleeVisitLabel').text(aParams.Name);
        $('#uEnrolleeTimelineLabelUpdatedBy').show();
        $('#uEnrolleeVisitLabelUser').text(UserNameFormatter(lTag.UserId));
        $('#uEnrolleeVisitLabelEdit').val(aParams.Name);
    }

    function timelinePlaces_Init() {
        var lService = new google.maps.places.PlacesService(mEnrolleesControls.TimelineMap.getMap());
        var request = {
            location: new google.maps.LatLng(lVisit.Latitude, lVisit.Longitude),
            radius: 91,
            types: ['food', 'finance', 'store', 'point_of_interest', 'establishment']
        };

        lService.nearbySearch(request, function (results, status) {
            buildPlacesList(results);
        });
    }
}

function buildTimelineAddress(aAddress) {
    "use strict";
    if (mEnrolleesData.OffenderProfileAddresses.length > 0) {
        populate_AddressesTimeline(null, mEnrolleesData.OffenderProfileAddresses);
    } else {
        enrolleeAddress_Init(mEnrolleesData.OffenderCurrentId, populate_AddressesTimeline);
    }

    function populate_AddressesTimeline(aParams, aAddressList) {
        var lKey;
        var lAddress;
        for (lKey in aAddressList) {
            if (aAddressList.hasOwnProperty(lKey)) {
                mEnrolleesData.OffenderProfileAddresses[aAddressList[lKey].Id] = aAddressList[lKey];
            }
        }

        lAddress = mEnrolleesData.OffenderProfileAddresses[mEnrolleesData.CurrentTimelineEvent.data.LocationId];

        if (lAddress && ['Home', 'Work', 'Other'].indexOf(mEnrolleesData.CurrentTimelineEvent.data.MatchType) !== -1) {
            $('#uTimelineAddAddressSection').hide();
            $('#uTimelineAddressExists').show();
            $('#uAddTimelineAddressButton').hide();
            //$('#uTimelineZoneSection').show();
            TimelineAddressGenerator(lAddress);
            populateTimelineAddressZones(lAddress);
        } else {
            if (mEnrolleesData.CurrentTimelineEvent.data.LocationId > 0) {
                updateTimelineEventAddressRemoved();
            }
            $('#uAddTimelineAddressButton').show();
            populateTimelineAddressTypes(aAddress)
        }
    }
}

function TimelineAddressGenerator(aAddress) {
    "use strict";
    $('#uTimelineAddressCard').html(enrolleeAddressGenerator(aAddress, null, 'uTimelineAddressStreetView_OnClick', null, 'uDeleteTimelineAddressButton_OnClick', 'timelineZoneCreate', null)).show();
    veritracks.localization.localize('#uTimelineAddressCard');
    // remove unused icons
    $('#uTimelineAddressCard .AddressZoneEdit').remove();
    $('#uTimelineAddressCard .AddressEdit').remove();
    $('#uTimelineAddressCard .AddressDelete').remove();
}

function populateTimelineAddressZones(aAddress) {
    "use strict";
    var lAddress = aAddress;
    var lKey;
    var lAddresses = [];

    for (lKey in mEnrolleesData.OffenderProfileAddresses) {
        if (mEnrolleesData.OffenderProfileAddresses.hasOwnProperty(lKey)) {
            lAddresses.push(veritracks.mapping.prepareAddressItem(mEnrolleesData.OffenderProfileAddresses[lKey], 1));
        }
    }
    mEnrolleesControls.TimelineMap.layerSetDataSource('Addresses', lAddresses);
    if (lAddress) {
        $('#uTimelineAddressTitle').html('<strong>' + lAddress.Title + '</strong> (' + getDataItem(lAddress.AddressTypeId, 'AddressType').Description + ')');
        $('#uTimelineAddressDescription').html(addressFormatter(lAddress));
    }
    populateTimelineZone_Init(lAddress);
}


function populateTimelineAddressTypes(aAddress) {
    "use strict";
    var lHasHome = false;
    var lHasWork = false;
    var lItems = getDataItems('AddressType');
    var lTypes = [];
    var lKey;
    var lItem;
    var lMarkerAddresses = [];

    $('#uTimelineAddressDescription').html(addressFormatter(aAddress));

    lMarkerAddresses.push(enrolleeSetTimelineAddressMarker(aAddress));

    // mEnrolleesControls.TimelineMap.layerSetDataSource('Addresses', [veritracks.mapping.prepareAddressItem(aAddress, 1)]);
    if (mEnrolleesData.OffenderProfileAddresses.length > 0) {
        for (lKey in mEnrolleesData.OffenderProfileAddresses) {
            if (mEnrolleesData.OffenderProfileAddresses.hasOwnProperty(lKey)) {
                lMarkerAddresses.push(veritracks.mapping.prepareAddressItem(mEnrolleesData.OffenderProfileAddresses[lKey], 1));
                if (mEnrolleesData.OffenderProfileAddresses[lKey].AddressTypeId == 1)
                    lHasHome = true;
                else if (mEnrolleesData.OffenderProfileAddresses[lKey].AddressTypeId == 2)
                    lHasWork = true;
            }
        }
    }
    mEnrolleesControls.TimelineMap.layerSetDataSource('Addresses', lMarkerAddresses);

    for (lKey in lItems) {
        if (lItems.hasOwnProperty(lKey)) {
            lItem = lItems[lKey];
            if ((lItem.Id === 1 && !lHasHome) || (lItem.Id === 2 && !lHasWork) || (lItem.Id > 2)) {
                lTypes.push(new Option(AddressTypeFormatter(lItem.Description), lItem.Id));
            }
        }
    }
    mEnrolleesControls.TimelineAddressValidator = new Validator('uTimelineAddressSection', mRegexValidation);

    $('#uTimelineAddressAddressTypeIdEdit').append(lTypes);
    $('#uTimelineAddressCreate').show();
}


function populateTimelineZone_Init(aAddress) {
    "use strict";
    var lZone;

    if (aAddress.ZoneId == -1) {
        //$('#uTimelineZoneCreateInclusion').show();
        //$('#uTimelineZoneCreateExclusion').show();
    } else {
        lZone = GetZone(aAddress.ZoneId);
        //$('#uTimelineZoneEdit').show();
        //$('#uTimelineZoneCreateInclusion').hide();
        //$('#uTimelineZoneCreateExclusion').hide();
        mEnrolleesControls.TimelineMap.layerSetDataSource('Zones', veritracks.mapping.prepareZoneData([lZone]));
        timelinePopulateZoneDetails(lZone, aAddress);
    }

}

function timelinePopulateZoneDetails(aZone, aAddress) {
    "use strict";
    TimelineAddressGenerator(aAddress);
}
function getTimelineAddressFromMap() {
    var lDataSource = mEnrolleesControls.TimelineMap.layerGetDataSource('Addresses')[0];
    var lAddress;

    if (lDataSource) {
        if (lDataSource.data.Data) {
            lAddress = lDataSource.data.Data;
        } else {
            lAddress = lDataSource.data;
        }
    }
    return lAddress;
}


function timelineZoneCreate(aAddressId, aButton, aZoneType) {
    "use strict";
    var lAddress = getTimelineAddressFromMap();

    if(lAddress){
        enrolleesOffenderAddressZone_OnCreate(lAddress.Id, null, aZoneType, timelineZoneCreate_Success);
    }
}

function timelineZoneCreate_Success(aParams, aData) {
    "use strict";
    var lAddress = getTimelineAddressFromMap();
    enrolleesOffenderAddressZone_OnZoneSave(aParams, aData);
    lAddress.ZoneId = aData.Id;
    populateTimelineZone_Init(lAddress);
}

function timelineZoneEdit() {
    var lAddress = getTimelineAddressFromMap();

    if (lAddress) {
        ClosePopup();
        ClosePopup();
        enrolleesOffenderAddressZone_OnEdit(lAddress.Id)
    }
}

function uAddTimelineLabel_OnClick() {
    var lTag = new Tag();
    var lLink = new TagVisitLink();
    var lSelected;

    if (mEnrolleesControls.TimelinePlacesListView) {
        lSelected = mEnrolleesControls.TimelinePlacesListView.selectedDataItem()
    }
    lTag.Name = $('#uTimelinePlacesLabelEdit').val();
    if (lTag.Name !== '') {

        if (lSelected && lSelected.name == lTag.Name) {
            lTag.Latitude = lSelected.geometry.location.lat();
            lTag.Longitude = lSelected.geometry.location.lng();
        } else {
            lTag.Latitude = mEnrolleesData.CurrentTimelineEvent.Grouping.Latitude;
            lTag.Longitude = mEnrolleesData.CurrentTimelineEvent.Grouping.Longitude;
        }
        lTag.Latitude = RoundNumber(lTag.Latitude, 7);
        lTag.Longitude = RoundNumber(lTag.Longitude, 7);

        lTag.UserId = gUserDetails.UserId;

        lLink.VisitId = mEnrolleesData.CurrentTimelineEvent.Grouping.Id;
        lLink.Name = lTag.Name;
        WriteSingle(lTag, timelineMapAssignTagSaveTag_OnSuccess, Sad, { 'Link': lLink }, true);
    } else {
        mActivityNotification.addNotification(localizeWrapper('cEnrolleeMissingLabelName'));
    }
}

function uDeleteTimelineLabel_OnClick() {
    "use strict";
    var lTag = mEnrolleesControls.TimelineMap.layerGetDataSource('Tags')[0].data;

    if (lTag) {
        lTag.IsActive = false;
        WriteSingle(lTag, timelineMapDeleteTag_OnSuccess, null, lTag, true);
    }

}

function uEditTimelineLabel_OnClick() {
    "use strict";
    $('#uEditTimelineLabelButton').hide();
    $('#uSaveTimelineLabelButton').show();
    $('#uCancelTimelineLabelButton').show();
    EnterEditMode('uTimelineLabelEditor');
    mEnrolleesControls.TimelinePlacesValidator.scan();
}
function ExitTimelinePlacesEdit() {
    $('#uCancelTimelineLabelButton').hide();
    $('#uEditTimelineLabelButton').show();
    $('#uSaveTimelineLabelButton').hide();

    ExitEditMode('uTimelineLabelEditor');
}

function uCancelTimelineLabel_OnClick() {
    "use strict";
    ExitTimelinePlacesEdit();
}
function uSaveTimelineLabel_OnClick() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    var lOldText = $('#uEnrolleeVisitLabel').text();
    var lText = $('#uEnrolleeVisitLabelEdit').val();
    var lTag = mEnrolleesControls.TimelineMap.layerGetDataSource('Tags')[0].data;


    if (lTag) {
        lTag.Name = lText;
        lTag.UserId = gUserDetails.UserId;
        WriteSingle(lTag, timelineMapAssignTagSaveTag_OnSuccess, null, lTag, true);
    }

}

function timelineMapDeleteTag_OnSuccess(aParams, aData) {
    "use strict";
    var lAddress = mEnrolleesData.OffenderProfileAddresses[mEnrolleesData.CurrentTimelineEvent.data.LocationId];

    if (mEnrolleesData.CurrentTimelineEvent.TagId == mEnrolleesData.CurrentTimelineEvent.data.LocationId || !lAddress) {
        mEnrolleesData.CurrentTimelineEvent.data.MatchType = "Visit Not Labeled";
        mEnrolleesData.CurrentTimelineEvent.data.Title = "";
        mEnrolleesData.CurrentTimelineEvent.data.LocationId = -1;
        timelineUpdateEvent();
    }

    timelineTag_OnComplete(mEnrolleesData.CurrentTimelineEvent.Grouping, []);
    ExitTimelinePlacesEdit();
}
function timelineMapAssignTagSaveTag_OnSuccess(aParams, aData) {
    "use strict";

    if (aParams.Link) {
        aParams.Link.TagId = aData.Id;
        WriteSingle(aParams.Link, timelineMapAssignTag_OnSuccess, Sad, aData, true);
    } else {
        timelineMapAssignTag_OnSuccess(aParams, []);
    }
    //mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.filter();
}

function GetTag(aId, aSuccess, aFail, aParams) {
    var lBuilder = new SumoPredicateBuilder();

    lBuilder.AddNewExpressionConditional('Id', aId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    ReadMultiple(gObjectList.Tag.AssemblyQualifiedName, lBuilder.RootExpression, 0, aSuccess, aFail, aParams);

}

function timelineMapAssignTag_OnSuccess(aParams, aData) {
    "use strict";
    // update timeline section
    // call to update fullcalendar.
    // only update if not labeled match type.
    if (["Labeled Visit", "Visit Not Labeled", "Visit Not Labeled In Progress"].indexOf(mEnrolleesData.CurrentTimelineEvent.data.MatchType) !== -1) {
        mEnrolleesData.CurrentTimelineEvent.data.MatchType = "Labeled Visit";
        mEnrolleesData.CurrentTimelineEvent.data.Title = aParams.Name;
        mEnrolleesData.CurrentTimelineEvent.data.LocationId = aParams.Id;
        timelineUpdateEvent();
    }
    timelineTag_OnComplete(mEnrolleesData.CurrentTimelineEvent.Grouping, [aParams]);
    ExitTimelinePlacesEdit();
    mActivityNotification.addNotification(localizeWrapper('cEnrolleeSuccessNewLabel') + aParams.Name);
}

function updateTimelineEventAddressRemoved() {
    "use strict";

    GetVisitTag(mEnrolleesData.CurrentTimelineEvent.data.PointGroupId, fallbackTagLabel_OnSuccess);


    function fallbackTagLabel_OnSuccess(aParams, aData) {
        var lData = aData[0];
        if (lData) {
            mEnrolleesData.CurrentTimelineEvent.data.MatchType = "Labeled Visit";
            mEnrolleesData.CurrentTimelineEvent.data.Title = lData.Name;
            mEnrolleesData.CurrentTimelineEvent.data.LocationId = lData.Id;
        } else {
            if (mEnrolleesData.CurrentTimelineEvent.data.PointGroupId == -1) {
                mEnrolleesData.CurrentTimelineEvent.data.MatchType = "Visit Not Labeled In Progress";
            } else {
                mEnrolleesData.CurrentTimelineEvent.data.MatchType = "Visit Not Labeled";
            }
            mEnrolleesData.CurrentTimelineEvent.data.Title = "";
            mEnrolleesData.CurrentTimelineEvent.data.LocationId = -1;
        }

        timelineUpdateEvent();
    }
}

function timelineUpdateEvent() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    var lUpdateEvent = [];
    var lKey;

    if (mEnrolleesData.CurrentTimelineEvent.data) {
        mEnrolleesData.CurrentTimelineEvent.backgroundColor = mChartingCalendarColors[mEnrolleesData.CurrentTimelineEvent.data.MatchType];

        if (mEnrolleesData.CurrentTimelineEvent.data.Title == "") {
            mEnrolleesData.CurrentTimelineEvent.title = mEnrolleesData.CurrentTimelineEvent.data.MatchType;
        } else {
            mEnrolleesData.CurrentTimelineEvent.title = mEnrolleesData.CurrentTimelineEvent.data.Title + ' (' + mEnrolleesData.CurrentTimelineEvent.data.MatchType + ')';
        }

        WriteSingle(mEnrolleesData.CurrentTimelineEvent.data, null, null, null, false);

        lBuilder.AddNewExpressionConditional('timelineId', mEnrolleesData.CurrentTimelineEvent.timelineId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

        if (mEnrolleesControls.veritracksChartMap) {
            lUpdateEvent = query(mEnrolleesControls.veritracksChartMap.getRawDataSource(), lBuilder.RootExpression);

            for (lKey in lUpdateEvent) {
                if (lUpdateEvent.hasOwnProperty(lKey)) {
                    lUpdateEvent[lKey].data = mEnrolleesData.CurrentTimelineEvent.data;
                    lUpdateEvent[lKey].backgroundColor = mEnrolleesData.CurrentTimelineEvent.backgroundColor;
                    lUpdateEvent[lKey].title = mEnrolleesData.CurrentTimelineEvent.title;
                }
            }
        }
        if (mEnrolleesControls.veritracksChartMiniMap) {
            lUpdateEvent = query(mEnrolleesControls.veritracksChartMiniMap.getRawDataSource(), lBuilder.RootExpression);

            for (lKey in lUpdateEvent) {
                if (lUpdateEvent.hasOwnProperty(lKey)) {
                    lUpdateEvent[lKey].data = mEnrolleesData.CurrentTimelineEvent.data;
                    lUpdateEvent[lKey].backgroundColor = mEnrolleesData.CurrentTimelineEvent.backgroundColor;
                    lUpdateEvent[lKey].title = mEnrolleesData.CurrentTimelineEvent.title;
                }
            }

        }
    }
    if (mEnrolleesControls.veritracksChartMap) {
        mEnrolleesControls.veritracksChartMap.updateEvent(mEnrolleesData.CurrentTimelineEvent);
    }
    if (mEnrolleesControls.veritracksChartMiniMap) {
        mEnrolleesControls.veritracksChartMiniMap.updateEvent(mEnrolleesData.CurrentTimelineEvent);
    }
}

function buildPlacesList(aList) {
    "use strict";
    var lColumns = [
        { 'id': 'Selection', 'title': '', 'dataField': 'id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': selectionColumnFormatter },
        { 'id': 'name', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'name', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
        { 'id': 'vicinity', 'title': localizeWrapper('cEnrolleeAddress'), 'dataField': 'vicinity', 'width': 'autoData', 'minWidth': 50, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
        { 'id': 'types', 'title': localizeWrapper('cGoogleSuggested'), 'dataField': 'types', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
    ];


    mEnrolleesControls.TimelinePlacesValidator = new Validator('TimelineCreateLabel', mRegexValidation);
    mEnrolleesControls.TimelinePlacesListView = new sumo.controls.ListView('uEnrolleesTimelinePlacesListView', 'uEnrolleesTimelinePlacesListViewHolder', { 'keyField': 'id', 'selectMethod': 'single', 'cssClass': 'VeritracksListView', 'canUnselect': true }, lColumns);
    mEnrolleesControls.TimelinePlacesListView.bind('selectedchanged', uEnrolleesTimelinePlacesListView_OnSelectChange);

    mEnrolleesControls.TimelinePlacesListView.setDataSource(aList);
    mEnrolleesControls.TimelineMap.layerSetDataSource('Places', veritracks.mapping.preparePlacesData(aList));
}

function uEnrolleesTimelinePlacesListView_OnSelectChange(aSender, aSelected, aData) {
    var lPlace = mEnrolleesControls.TimelinePlacesListView.selectedDataItem();

    if (lPlace) {
        mEnrolleesControls.TimelineMap.setCenter(lPlace.geometry.location.lat(), lPlace.geometry.location.lng());
        mEnrolleesControls.TimelineMap.zoom(18);
        $('#uTimelinePlacesLabelEdit').val(lPlace.name);
    } else {
        mEnrolleesControls.TimelineMap.zoom(10);
        $('#uTimelinePlacesLabelEdit').val('');
    }
    mEnrolleesControls.TimelinePlacesValidator.scan();

}

function timelineVisit_OnClick(aSender, aMouseEvent) {
    var lPlace = aSender.sumoData;

    mEnrolleesControls.TimelineMap.setCenter(lPlace.Latitude, lPlace.Longitude);
    mEnrolleesControls.TimelineMap.zoom(18);
}

function timelinePlaces_Click(aSender, aMouseEvent) {
    var lPlace = aSender.sumoData;

    mEnrolleesControls.TimelinePlacesListView.selected(lPlace.id);
}

function uTimelineAddressStreetView_OnClick() {

    mEnrolleesControls.TimelineMap.setStreetLevel(mEnrolleesData.CurrentTimelineEvent.data.Latitude, mEnrolleesData.CurrentTimelineEvent.data.Longitude);
}

function populateTimelineDefaultElements() {
    "use strict";
    var lContentHtml = [];
    var buttonBar = $('.TimelineDetailsWidth .ButtonCommandBar');
    var inputNotesNew = ' <input id="timelineNewNotes" type="text" value="new note..." />';
    var lSelectedTab = $('.DefaultTab').hasClass("Selected");

    buildTimelineEventList();

    var currentTimelineEvent = mEnrolleesData.CurrentTimelineEvent;

    lContentHtml.push('<div id="timelineQuickDetails">');

    if (currentTimelineEvent) {
        if (currentTimelineEvent.title)
            lContentHtml.push('<div id="timelineDetailTitle"> <strong>'+localizeText('cTitle')+':</strong> ' + currentTimelineEvent.title + '</div>');
        lContentHtml.push('<div id="timelineDetailStart"> <strong>' + localizeText('cAnalysisStart') + ':</strong> ' + currentTimelineEvent.start.format('MM/DD/YYYY hh:mm:ss A') + '</div>');
        if (currentTimelineEvent.end)
            lContentHtml.push('<div id="timelineDetailStop"> <strong>' + localizeText('cAnalysisEnd') + ':</strong> ' + currentTimelineEvent.end.format('MM/DD/YYYY hh:mm:ss A') + '</div>');

        if (currentTimelineEvent.data && currentTimelineEvent.data.Frequency) {
            lContentHtml.push('<div> <strong>' + localizeText('cEnrolleeTimelineFrequency') + ': </strong>' + VisitFrequencyFormatter(currentTimelineEvent.data.Frequency) + '</div>');
        }
    }

    lContentHtml.push('</div>');

    $('#uEnrolleesTimelineContentPanel').prepend('<div id="uEnrolleesTimelineContentStart"></div>')
    $('#uEnrolleesTimelineContentPanel').prepend('<div id="uEnrolleesTimelineContentOverhead"></div>')

    var startDetails = $('#uEnrolleesTimelineContentStart');
    var buttonBar = $('#uEnrolleesTimelineContentOverhead');

    startDetails.append(lContentHtml.join(''));


    if (buttonBar.text().length == 0 && lSelectedTab) {
        GenerateButton(localizeWrapper('cEnrolleeConfirm'), 'TimelineConfirm', 'uEnrolleesTimelineEventConfirmButton_OnClick()').appendTo(buttonBar);
        $(inputNotesNew).appendTo(buttonBar);
        GenerateButton(localizeWrapper('cEnrolleeAddNote'), 'TimelineAddNote', 'saveEnrolleesTimleineNotes()').appendTo(buttonBar);
        buttonBar.hide();
    }
    else {
            buttonBar.hide();
    }
}

function saveEnrolleesTimleineNotes() {
    var lSelected = mEnrolleesControls.TimelineEventListView.selectedDataItem(),
        lEvent = null,
        lKey,
        lNotesToWrite = [],
        lOriginalNote = null,
        lNote = null,
        lNoteText = $('#timelineNewNotes').val(),
        lPredicateBuilder = new SumoPredicateBuilder();

    if ($.trim(lNoteText) !== '' && lNoteText !== gTimelineNewNote.DefaultValue) {
        lOriginalNote = new Note(gUserDetails.UserId, lNoteText);
        lOriginalNote.__type = 'Event' + lOriginalNote.__type;
    }

    for (lKey in lSelected) {
        if (lSelected.hasOwnProperty(lKey)) {
            lEvent = lSelected[lKey].EventData;
            if (lOriginalNote !== null) {
                lNote = $.extend({}, lOriginalNote);
                lNote.EventId = lEvent.Id;
                lNote.TransactionId = moment().format("YYYYMMDDHHmmss");
                lNotesToWrite.push(lNote);
                if (!lEvent.HasNotes) {
                    lEvent.HasNotes = true;
                    lEvent.TransactionId = moment().format("YYYYMMDDHHmmss");
                    // some events are in history and will mess up cache -- always save from Events and not EventHistory.
                    lEvent.__type = "Event:www.veritracks.com";
                    setDataItem(lEvent.Id, 'Events', lEvent);
                    WriteSingle(lEvent, null, null, {}, false);
                }

            }
        }
    }

    if (lNotesToWrite.length > 0) {
        var lCurrent = mEnrolleesData.OffenderCurrentId;
        WriteMultiple(lNotesToWrite, timelineConfirmNote_OnWriteSuccess, confirmNote_OnWriteFailure, lCurrent);
    }
}

function timelineConfirmNote_OnWriteSuccess(aParams, aData) {
    gTimelineNewNote.Clear();
    timelineUpdateEvent();
    buildTimelineEventList();
    showTimelineDefaultEditFields(false, false);
    EnrolleeProfileEvents_Init(mEnrolleesData.OffenderCurrentId);
}

function showTimelineDefaultEditFields(needsConfirm, newNote) {
    "use strict";
    var buttonBar = $('#uEnrolleesTimelineContentOverhead');
    buttonBar.hide();

    if (needsConfirm && newNote) {
        buttonBar.show();
    }
    else if (needsConfirm) {
        buttonBar.show();
    }
    else if (newNote) {
        buttonBar.show();
    }
    else {
        buttonBar.hide();
    }

}

function buildTimelineEventList(aData) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    var lSort = new SortExpression();
    var lEvents = [];
    var lColumns = [
    { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': selectionColumnFormatter },
    { 'id': 'Id', 'title': localizeWrapper('cId'), 'dataField': 'Id', 'width': 'autoData', 'minWidth': 50, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
    { 'id': 'Description', 'title': localizeWrapper('cEnrolleeDescription'), 'dataField': 'Description', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
    { 'id': 'Status', 'title': localizeWrapper('cEnrolleeStatus'), 'dataField': 'IsOpen', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'number', 'formatMethod': EventOpenFormatter },
    { 'id': 'Start', 'title': localizeWrapper('cEventStartDate'), 'dataField': 'EventData', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': formatEventStartDateTime },
    { 'id': 'Stop', 'title': localizeWrapper('cEventStopDate'), 'dataField': 'EventData', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': formatEventEndDateTime },
    { 'id': 'ConfirmedDate', 'title': localizeWrapper('cEventConfirmedDate'), 'dataField': 'EventData', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': formatEventConfirmDateTime },
    { 'id': 'Confirmed', 'title': localizeWrapper('cEventConfirmed'), 'dataField': 'IsConfirmed', 'width': 'autoHeader', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': EventConfirmedFormatter },
    { 'id': 'Notes', 'title': localizeWrapper('cEventNotes'), 'dataField': 'Notes', 'width': 'autoHeader', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'number' },
    { 'id': 'MeNotes', 'title': localizeWrapper('cEventMENotes'), 'dataField': 'MeNotes', 'width': 'autoHeader', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'number' },
    { 'id': 'MonitoredEvent', 'title': localizeWrapper('cEventMonitoredEvent'), 'dataField': 'MonitoredEvent', 'width': 'autoHeader', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'number' }
    ];

    mEnrolleesControls.TimelineEventListView = new sumo.controls.ListView('uEnrolleesTimelineEventListView', 'uEnrolleesTimelineEventListViewHolder', { 'keyField': 'Id', 'selectMethod': 'auto', 'cssClass': 'VeritracksListView', 'canUnselect': true }, lColumns);
    mEnrolleesControls.TimelineEventListView.bind('selectedchanged', uEnrolleesTimelineEventListView_OnSelectChange);

    lBuilder.AddNewExpressionConditional('DisplayFlag', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lEvents = query(mEnrolleesData.CurrentTimelineEvent.eventList, lBuilder.RootExpression);
    lSort.addDescendingColumn('StartDateUTC');

    lEvents = lSort.sort(lEvents);
    timelineEnrolleeEventNotes_Init(lEvents);
}


function timelineEnrolleeEventNotes_Init(aEventList) {
    "use strict";
    var lKey,
        lEvent,
        lEventList = [],
        lNotesExist = false,
        lMonitoredEventsExist = false,
        lBuilder = new SumoPredicateBuilder();

    if (!isNullOrUndefined(aEventList)) {
        for (lKey in aEventList) {
            if (aEventList.hasOwnProperty(lKey)) {
                lEvent = aEventList[lKey];
                if (!isNullOrUndefined(lEvent)) {
                    lEventList.push(lEvent.Id);
                    if (lEvent.HasNotes == 1)
                        lNotesExist = true;
                    if (lEvent.MonitoredEventId != -1)
                        lMonitoredEventsExist = true
                }
            }
        }
    }

    if (aEventList.length !== 0) {
        lBuilder.AddNewExpressionConditional('EventId', lEventList, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        if (lNotesExist) {
            ReadMultiple(gObjectList.EventNote.AssemblyQualifiedName, lBuilder.RootExpression, 0, timelineEnrolleeEventNotes_OnSuccess, null, { "EventList": aEventList, "MonitoredEvents": lMonitoredEventsExist }, null, 0);
        }
        else {
            timelineEnrolleeEventNotes_OnSuccess({ "EventList": aEventList, "MonitoredEvents": lMonitoredEventsExist }, []);
        }
    }
}

function timelineEnrolleeEventNotes_OnSuccess(aParams, aData) {
    "use strict";
    var lKey,
        lNoteKey,
        lEvent,
        lBuilder = null,
        lEventList = aParams.EventList,
        lMonitoredEventsExist = aParams.MonitoredEvents,
        lEventDetail = new EventDetailList(),
        lNoteList = [],
        lEventList = [],
        lEventIds = [],
        lMonitoredEventNoteList = [],
        lNote,
        lTimeZone,
        lEnrollee;
    FixDates(aData);
    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lNote = aData[lKey];
            if (isNullOrUndefined(lNoteList[lNote.EventId])) {
                lNoteList[lNote.EventId] = [];
            }
            lNoteList[lNote.EventId].push(lNote);
        }
    }
    $.each(aParams.EventList, function (index, value) {
        lEventIds.push(value.Id);
    });
    if (lEventIds.length > 0) {
        lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('EventId', lEventIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());

        if (lMonitoredEventsExist) {
            ReadMultiple('Veritracks.Core.MonitoredEventNote, Veritracks.Core, Version=2011.10.5050.25812, Culture=neutral, PublicKeyToken=null', lBuilder.RootExpression, 0, timelineMonitoredEventNote_OnSuccess, Sad, lMonitoredEventNoteList, null, 0);
        } else {
            timelineMonitoredEventNote_OnSuccess(lMonitoredEventNoteList, []);
        }

    }
    //else {
    //    MonitoredEventNote_OnSuccess();
    //}
    function timelineMonitoredEventNote_OnSuccess(p, d) {
        FixDates(d);
        for (lKey in d) {
            if (d.hasOwnProperty(lKey)) {
                var lMeNote = d[lKey];
                if (isNullOrUndefined(lMonitoredEventNoteList[lMeNote.EventId])) {
                    lMonitoredEventNoteList[lMeNote.EventId] = [];
                }
                lMonitoredEventNoteList[lMeNote.EventId].push(lMeNote);
            }
        }

        for (lKey in aParams.EventList) {
            lEventDetail = new EventDetailList();
            if (aParams.EventList.hasOwnProperty(lKey)) {
                lEvent = aParams.EventList[lKey];
                lEnrollee = getDataItem(lEvent.EnrolleeId, "Enrollees");
                lTimeZone = getDataItem(lEnrollee.TimeZoneId, "TimeZone");
                if (!isNullOrUndefined(lEvent)) {
                    lEventDetail.Id = lEvent.Id;
                    lEventDetail.IsConfirmed = lEvent.IsConfirmed;
                    lEventDetail.ConfirmedByUserId = lEvent.ConfirmedByUserId;
                    lEventDetail.ZoneTrackPointCount = lEvent.ZoneTrackPointCount;
                    lEventDetail.EnrolleeId = lEvent.EnrolleeId;
                    lEventDetail.MetaEventId = lEvent.MetaEventId;
                    if (lEvent.ZoneId > 0) {
                        lEventDetail.Description = formatterMetaEvent(lEvent.MetaEventId);
                        if (!isNullOrUndefined(lEvent.ZoneName)) {
                            lEventDetail.Description += '</br>' + '(' + lEvent.ZoneName + ')';
                        }
                        else {
                            var lZone = getDataItem(lEvent.ZoneId, "Zones");
                            if (!isNullOrUndefined(lZone)) {
                                lEventDetail.Description += '</br>' + '(' + lZone.Name + ')';
                            }
                        }
                    }
                    else
                        lEventDetail.Description = formatterMetaEvent(lEvent.MetaEventId);
                    lEventDetail.IsOpen = lEvent.IsOpen;
                    lEventDetail.StartDateUTC = displayEnrolleeTimeZoneFormatted(lEvent.StartDateUTC, lTimeZone);
                    lEventDetail.StopDateUTC = displayEnrolleeTimeZoneFormatted(lEvent.StopDateUTC, lTimeZone);
                    lEventDetail.ZoneId = lEvent.ZoneId;
                    lEventDetail.DeviceId = lEvent.DeviceId;
                    lEventDetail.ConfirmedDateUTC = displayEnrolleeTimeZoneFormatted(lEvent.ConfirmedDateUTC, lTimeZone);
                    lEventDetail.DisplayFlag = lEvent.DisplayFlag;
                    lEventDetail.MonitoredEventId = lEvent.MonitoredEventId;
                    if (!isNullOrUndefined(lNoteList[lEvent.Id])) {
                        lEventDetail.Notes = '<div class="NotesIconProperty" onclick="timelineEnrolleeEventNotes_OnClick(\'' + lKey + '\')">' + lNoteList[lEvent.Id].length + '</div>';
                        lEventDetail.NoteData = lNoteList[lEvent.Id];
                    } else {
                        lEventDetail.Notes = '<div class="NotesIconProperty" onclick="timelineEnrolleeEventNotes_OnClick(\'' + lKey + '\')">0</div>';
                    }
                    if (!isNullOrUndefined(lMonitoredEventNoteList[lEvent.Id])) {
                        lEventDetail.MeNotes = '<div class="MeNotesIconProperty" onclick="timelineEnrolleeMeEventNotes_OnClick(\'' + lKey + '\')">' + lMonitoredEventNoteList[lEvent.Id].length + '</div>';
                        lEventDetail.MeNoteData = lMonitoredEventNoteList[lEvent.Id];
                    }
                    else {
                        lEventDetail.MeNotes = '<div class="MeNotesIconProperty" onclick="timelineEnrolleeMeEventNotes_OnClick(\'' + lKey + '\')">0</div></div>';
                    }
                    if (lEventDetail.MonitoredEventId !== -1) {
                        lEventDetail.MonitoredEvent = '<div class="IconButton InstantReportsButton pReportsWrite" onclick="instantReporting_OnClick(2,' + lEventDetail.MonitoredEventId + ')"></div>';
                    }
                    else {
                        lEventDetail.MonitoredEvent = '<div>N/A</div>';
                    }
                    lEventDetail.EventData = lEvent;
                    lEventDetail.SortId = (lEvent.IsOpen ? 2 : 1).toString() + lEvent.StartDateUTC.valueOf();
                    lEventList.push(lEventDetail);
                }
            }
        }

        mEnrolleesControls.TimelineEventListView.setDataSource(lEventList);
    }
    function timelineMonitoredEventNote_OnFailure() {

    }
}

function uEnrolleesTimelineEventConfirmButton_OnClick() {
    "use strict";
    var lWriteList = [],
        lSelected = mEnrolleesControls.TimelineEventListView.selectedDataItem(),
        lEvents = getDataItems('Events'),
        lTimelineEvent = null,
        lKey,
        lNotesToWrite = [],
        lOriginalNote = null,
        lNote = null,
        lNoteText = $('#timelineNewNotes').val(),
        lBuilder = new SumoPredicateBuilder(),
        lEnrollee = mEnrolleesControls.CardView.selectedDataItem();

    lEnrollee = lEnrollee.Enrollee;

    if ($.trim(lNoteText) !== '' && lNoteText !== gNewNote.DefaultValue) {
        lOriginalNote = new Note(gUserDetails.UserId, lNoteText);
        lOriginalNote.__type = 'Event' + lOriginalNote.__type;
    }



    for (var lKey = 0; lKey < lSelected.length; lKey++) {
        lTimelineEvent = lSelected[lKey].EventData;
        lTimelineEvent.IsConfirmed = true;

        lTimelineEvent.ConfirmedByUserId = gUserDetails.UserId;
        lTimelineEvent.ConfirmedDateUTC = new Date();
        // some events are in history and will mess up cache -- always save from Events and not EventHistory.
        lTimelineEvent.__type = "Event:www.veritracks.com";
        lWriteList.push(prepareObjectForWcf(lTimelineEvent));
        if (lOriginalNote !== null) {
            lNote = $.extend({}, lOriginalNote);
            lNote.EventId = lTimelineEvent.Id;
            lTimelineEvent.HasNotes = true;

            lNotesToWrite.push(lNote);
        }
        setDataItem(lTimelineEvent.Id, 'Events', lTimelineEvent);
    }

    if (lWriteList.length > 0) {
        WriteMultiple(lWriteList, enrolleesTimelineEventConfirmationWrite_OnSuccess, enrolleesEventConfirmationWrite_OnFailure, lSelected);
    }

    if (lNotesToWrite.length > 0) {
        var lCurrent = mEnrolleesData.OffenderCurrentId;
        if (mStateManager.Settings()[0] === 'Victims') {
            lCurrent = mEnrolleesData.VictimCurrentId;
        }
        WriteMultiple(lNotesToWrite, enrolleesTimelineEventConfirmationWrite_OnSuccess, confirmNote_OnWriteFailure, lCurrent);
    }
}

function enrolleesTimelineEventConfirmationWrite_OnSuccess(aParams, aData) {
    "use strict";
    var lKey;

    mActivityNotification.addNotification(aData.length.toString() + localizeWrapper('cTimelineConfirmed'));
    timelineUpdateEvent();
    buildTimelineEventList();
    showTimelineDefaultEditFields(false, false);
    EnrolleeProfileEvents_Init(mEnrolleesData.OffenderCurrentId);
    UpdateEnrolleeEventReports(aData);
}

function uEnrolleesTimelineEventListView_OnSelectChange(aSender, aData) {
    "use strict";
    var lSelected = aSender.selectedDataItem(),
    lNeedsConfirmed = false,
    lNewNote = false,
    lNeedsClosed = true,
    lMasterTamperCount = 0,
    lMasterTamperIds = [],
    lEventCount = 0,
    lItem,
    lKey;

    if (!isNullOrUndefined(lSelected) && lSelected.length > 0) {
        for (lKey in lSelected) {
            if (lSelected.hasOwnProperty(lKey)) {

                lItem = lSelected[lKey];
                ++lEventCount;
                if (!lNeedsConfirmed) {
                    lNeedsConfirmed = !lItem.IsConfirmed;
                }
                if (lItem.MetaEventId === 1003 && lNeedsClosed) {
                    ++lMasterTamperCount;
                    lNeedsClosed = lItem.IsOpen;
                    lMasterTamperIds.push(lItem.Id);
                }
            }

        }
        if (lNeedsConfirmed) {
            $('#uEnrolleesTimelineContentOverhead .TimelineConfirmButton').show();
            $('#uEnrolleesTimelineContentOverhead .TimelineAddNoteButton').hide();
            $('#uEnrolleesEventNewNote').unbind('change', uNewTimelineNote_OnChange);
        }
        else {
            lNewNote = true;
            $('#uEnrolleesTimelineContentOverhead .TimelineConfirmButton').hide();
            $('#uEnrolleesTimelineContentOverhead .TimelineAddNoteButton').show();
            $('#timelineNewNotes').change(uNewTimelineNote_OnChange).keyup(uNewTimelineNote_OnChange).keypress(uNewTimelineNote_OnChange).change();
        }
    }
    ////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////
    showTimelineDefaultEditFields(lNeedsConfirmed, lNewNote);


    $('#timelineNewNotes').on('focus', function () {
        gTimelineNewNote.OnFocus();
    });

    $('#timelineNewNotes').on('blur', function() {
        gTimelineNewNote.OnBlur();
    });
    // possibly add new note for confirmed event show()*/
}

function showTimelineDefaultEditFields(needsConfirm, newNote) {
    "use strict";
    var buttonBar = $('#uEnrolleesTimelineContentOverhead');
    buttonBar.hide();

    if (needsConfirm && newNote) {
        buttonBar.show();
    }
    else if (needsConfirm) {
        buttonBar.show();
    }
    else if (newNote) {
        buttonBar.show();
    }
    else {
        buttonBar.hide();
    }

}

// bind event for new note
function uNewTimelineNote_OnChange() {
    "use strict";
    var lEventNoteTextValue = $('#timelineNewNotes').val();
    if ($.trim(lEventNoteTextValue) !== '' && lEventNoteTextValue !== gNewNote.DefaultValue) {
        $('.TimelineAddNoteButton').removeClass('Disabled');
    } else {
            $('.TimelineAddNoteButton').addClass('Disabled');
    }
}
// streamlined note section
// FEEDBACK
var gTimelineNewNote = { };

gTimelineNewNote.DefaultValue = 'new note...';

gTimelineNewNote.Text = function (aText) {
    "use strict";
    var lResult = "",
        lNoteTextInput = $('#timelineNewNotes');
    if (!isNullOrUndefined(aText)) {
        lNoteTextInput.val(aText);
    } else {
        lResult = lNoteTextInput.val();
        }
    return lResult;
};

gTimelineNewNote.OnFocus = function() {
    "use strict";
    if (gTimelineNewNote.Text() === gNewNote.DefaultValue) {
        gTimelineNewNote.Text('');
    }
};

gTimelineNewNote.OnBlur = function () {
    "use strict";
    if (gTimelineNewNote.Text() === '') {
        gTimelineNewNote.Text(gTimelineNewNote.DefaultValue);
    }
};

gTimelineNewNote.Clear = function () {
    "use strict";
    if (gTimelineNewNote.Text() != '') {
        gTimelineNewNote.Text('');
    }
}

function timelinePanelOnChange(aTab, aDetails) {
    "use strict";
    var lFilename = 'Enrollees.Timeline.' + aTab + '.htm';
    var lMethodName = window['populateTimeline' + aTab + 'Elements'];

    $('#uEnrolleesTimelineMenuPanel .Selected').removeClass('Selected');
    $('#uEnrolleesTimelineMenuPanel .' + aTab + 'Tab').addClass('Selected');


   //$('.TimelineDetailsWidth .ButtonCommandBar').hide();

    mEnrolleesData.TimelinePopupOption = aTab;
    populateElement('uEnrolleesTimelineContentPanel', lFilename, lMethodName);
}

function timelinePopulate_Init() {
    "use strict";
    var lDefaultTab = '';
    var lFilename;
    var lFunction;

    if (mEnrolleesData.CurrentTimelineEvent.data && mEnrolleesData.CurrentTimelineEvent.data.PointGroupId !== -1 && mEnrolleesData.CurrentTimelineEvent.data.MatchType != "In Motion (i.e., Trip)") {
        if (getTabTimeline() === '1'){
            lDefaultTab = 'Map';
        }else{
            lDefaultTab = 'Default';
        }

        $('#uEnrolleesTimelineMap').show();
    } else {
        lDefaultTab = 'Default';
        $('#uEnrolleesTimelineMap').hide();
    }
    lFilename = 'Enrollees.Timeline.' + lDefaultTab + '.htm';
    lFunction = window['populateTimeline' + lDefaultTab + 'Elements'];

    $('#uEnrolleesTimelineMenuPanel .Selected').removeClass('Selected');
    $('#uEnrolleesTimelineMenuPanel .' + lDefaultTab + 'Tab').addClass('Selected');

    populateElement('uEnrolleesTimelineContentPanel', lFilename, lFunction);
}


function CloseTimelineDataPopup() {
    "use strict";
    mEnrolleesData.CurrentTimelineEvent = null;
    mEnrolleesControls.TimelineMap = null;
    mEnrolleesControls.TimelineListView = null;
    ClosePopup();
}


function prototypeCorrectStartDate(aStartDate, aElement, aLargeTimeline) {
    "use strict";
    var lCurrentTarget = aElement.currentTarget;
    var lParentTDLevel = $(lCurrentTarget.parentElement.parentElement).index();
    var lHeaderLevel;
    var lPopupContainer = ' ';
    var lStartDate = moment(aStartDate);
    var lStringDate;
    var lDateArray;
    var lMonth;
    var lDay;

    if (aLargeTimeline) {
        lPopupContainer = '#uPopupContainer ';
    }

    lHeaderLevel = $(lPopupContainer + '.fc-row .fc-widget-header:visible')[lParentTDLevel];

    if (lHeaderLevel) {
        var lStartDate = moment(aStartDate);

        lStringDate = $(lHeaderLevel).text(),
        lDateArray = lStringDate.replace(/[^0-9/]/g, '')
            .split('/');

        if (lDateArray.length == 2) {
            lMonth = parseInt(lDateArray[0]) - 1;
            lDay = parseInt(lDateArray[1]);
        } else {
            lStringDate = $(lPopupContainer + '.fc-center:visible').text();
            lDateArray = lStringDate.replace(/ /g, '#')
                .replace(/#/, ' ')
                .replace(/,/g, ' ')
                .replace(/#/, '')
                .split(' ');

            lMonth = moment().month(lDateArray[0]).month();
            lDay = parseInt(lDateArray[1]);
        }
    }

    if (lMonth && lDay && lStartDate.month() != lMonth || lStartDate.date() != lDay) {
        var lMoment = moment();

        lMoment.month(lMonth);
        lMoment.date(lDay);
        lMoment.hour(0);
        lMoment.minute(0);
        lMoment.second(0);

        aStartDate = lMoment._d;
    }

    return aStartDate;
}

function setTimelinePopupMenu(aEvent, aElement) {
    "use strict";
    var lButtonBar = GenerateButtonCommandBar();
    var lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees');
    var lTitle = '';
    mEnrolleesData.CurrentTimelineEvent = aEvent;

    lTitle = localizeWrapper('cEnrolleeTimelineQuick') + ' - ' + lEnrollee.FullName + ' (' + lEnrollee.PrimaryId + ')';

    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', 'CloseTimelineDataPopup()'));

    DisplayPopup(lTitle, '<div id="uEnrolleeTimelinePopupHolder"></div>', lButtonBar, false, true);
    //// calls main timeline popup that will hold tabs --- go to timelinePopulate_Init
    populateElement('uEnrolleeTimelinePopupHolder', 'Enrollees.Timeline.Popup.htm', timelinePopulate_Init);
    $('.Popup2').addClass('TimelineDetailsWidth');
}

function updateChartDates(aEvent, aElement, aFlag) {
    "use strict";

    mEnrolleesData.ChartStartDate = aEvent.start._d;
    mEnrolleesData.ChartEndDate = aEvent.end._d;
    if (moment(mEnrolleesData.ChartEndDate) < moment(mEnrolleesData.ChartStartDate)) {
        if (mEnrolleesData.ChartEndDate.getFullYear() != mEnrolleesData.ChartStartDate.getFullYear()) {
            mEnrolleesData.ChartStartDate.setYear(mEnrolleesData.ChartEndDate.getFullYear());
        } else {
            mEnrolleesData.ChartStartDate.setYear(mEnrolleesData.ChartEndDate.getFullYear()-1);
        }
    }
    if (moment(mEnrolleesData.ChartEndDate).date() != moment(mEnrolleesData.ChartStartDate).date()) {
        var lMoment = moment(mEnrolleesData.ChartStartDate);
        lMoment.hours(23);
        lMoment.minutes(59);
        lMoment.seconds(59);
        mEnrolleesData.ChartEndDate = lMoment._d;
    }
}

function setClickCal(aEvent, aElement) {
    "use strict";
    updateChartDates(aEvent, aElement, true);
    if (mStateManager.Settings()[1] === 'Map') {
        offenderMapPopulate(true);
    } else {
        ChangeHashSettings(1, 'Map');
    }
}

function setDataCal() {
    "use strict";
    var aId = mEnrolleesControls.veritracksChartMap.calendarId();
    $(aId).fullCalendar('removeEvents');
    $(aId).fullCalendar('addEventSource', mEnrolleesControls.veritracksChartMap.getDataSource());
    $(aId).fullCalendar('rerenderEvents');
}

function setMiniDragCal(aStart, aEnd) {
    var lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees');
    mEnrolleesData.ChartStartDate = convertMomentLocal(aStart._d);
    mEnrolleesData.ChartEndDate = convertMomentLocal(aEnd._d);
    offenderMapPopulate(true);
    if (!isNullOrUndefined(mEnrolleesData.OffenderSecondaryCurrentId)) {
        offenderSecondaryMapPopulate();
    }
}

function setMiniClickCal(aEvent, aElement) {
    "use strict";
    updateChartDates(aEvent, aElement, false);
    offenderMapPopulate(true);
    if (!isNullOrUndefined(mEnrolleesData.OffenderSecondaryCurrentId)) {
        offenderSecondaryMapPopulate();
    }
}

function getEnrolleeDefaultTimelineDate(aEnrolleeId, aUseCurrentOffenderDate) {
    "use strict";
    var aId = mEnrolleesControls.veritracksChartMiniMap.calendarId();
    var lMoment = $(aId).fullCalendar('getDate');
    var lEndMoment = moment(lMoment);
    var lLastContact = getDataItem(mEnrolleesData.OffenderCurrentId, 'EnrolleeLastContact');


    //Find last contact date for mini chart depending on configure setting
    var lPrior = getDayofData();

    if (aUseCurrentOffenderDate) {
        if (lLastContact && lPrior == 0) {
            lMoment = moment(lLastContact.ContactDate).subtract(1, "days");
            lEndMoment = moment(lLastContact.ContactDate).subtract(1, "days");
        } else if (lLastContact && lPrior == 1) {
            lMoment = moment(lLastContact.ContactDate);
            lEndMoment = moment(lLastContact.ContactDate);
        } else {
            lMoment = moment();
            lEndMoment = moment();
        }
    }

    lMoment.hours(0);
    lMoment.minutes(0);
    lMoment.seconds(0);

    lEndMoment.hours(23);
    lEndMoment.minutes(59);
    lEndMoment.seconds(59);

    mEnrolleesData.ChartStartDate = lMoment._d;
    mEnrolleesData.ChartEndDate = lEndMoment._d;
}
function loadAllDayTimelineMap(aUseCurrentOffenderDate) {
    "use strict";
    getEnrolleeDefaultTimelineDate(mEnrolleesData.OffenderCurrentId, aUseCurrentOffenderDate);
    offenderMapPopulate(true);
}

function setDataMinCal() {
    "use strict";
    var aId = mEnrolleesControls.veritracksChartMiniMap.calendarId();
    var lViewName = mEnrolleesControls.veritracksChartMiniMap.getViewName();
    $(aId).fullCalendar('removeEvents');
    $(aId).fullCalendar('addEventSource', mEnrolleesControls.veritracksChartMiniMap.getDataSource());
    $(aId).fullCalendar('rerenderEvents');
    if (lViewName == 'agendaDay' && mStateManager.Settings()[1] == 'Map') {
        $('#uLoadAllDayTimelineMap').show();
    } else {
        $('#uLoadAllDayTimelineMap').hide();
    }
}

function populateEnrolleesSmallChartCycle(aEnrollee, aEnrolleeCompleteData) {
    "use strict";
    var lHtml = [],
        lConfigSelect = [],
        lEnrolleeCompleteData = aEnrolleeCompleteData,
        lEnrolleeCardView,
        lEnrolleeID,
        lEnrolleePrimaryID,
        lEnrolleeName,
        lSelectedEnrolleeSN,
        lEnrolleCycleList,
        lSelectedEnrolleeId = aEnrollee.Id,
        lEnrolleeDeviceInfo,
        lEnrolleeDevice,
        lEnrolleeTrackingDeviceId,
        lEnrolleeCardViewCurrent;

    lConfigSelect.push('<div id="caseCycleBox">');
    lConfigSelect.push('<div class="InventoryIconProperty" id="caseCycleBoxHover"></div>')
    lConfigSelect.push('<ul class="caseCycleList">');
    for (var i = 0; i < lEnrolleeCompleteData.length; i++) {
        lEnrolleeCardView = lEnrolleeCompleteData[i];
        lEnrolleeTrackingDeviceId = lEnrolleeCardView['TrackingDeviceId'];
       // if (lEnrolleeTrackingDeviceId != -1) {
         //   lEnrolleeDeviceInfo = GetDevice(lEnrolleeTrackingDeviceId);
         //   lEnrolleeDevice = lEnrolleeDeviceInfo['ProductId'];
            /*1-4-16 timeline show on blutag artf68405*/
          //  if (lEnrolleeDevice == 103) {
                lEnrolleeID = lEnrolleeCardView['Id'];
                lEnrolleePrimaryID = lEnrolleeCardView['PrimaryId'];
                lEnrolleeName = lEnrolleeCardView['FullName'];
                lSelectedEnrolleeSN = lEnrolleeCardView['TrackingDeviceSerialNumber'];

                if (lSelectedEnrolleeId == lEnrolleeID) {
                    lConfigSelect.push('<li data-sn="' + lSelectedEnrolleeSN + '" data-value="' + lEnrolleeID + '"  class="casesAvailable cycleCaseSelected">' + lEnrolleeName + ' <br />(' + lEnrolleePrimaryID + ')' + '</li>');
                }
                else {
                    lConfigSelect.push('<li data-sn="' + lSelectedEnrolleeSN + '" data-value="' + lEnrolleeID + '" class="casesAvailable cycleCaseNotSelected">' + lEnrolleeName + ' <br />(' + lEnrolleePrimaryID + ')' + '</li>');

                }
        //    }
       // }
    }

    lConfigSelect.push('</ul>');
    lConfigSelect.push('</div>');

    uDisplayHoverMoreChartCycleData();

    lConfigSelect.push('<button id="enrolleeCycleCaseLoadPrevious" class="DisabledSelect" onclick="enrolleeCycleCaseLoadPrevious()"><</button>');
    lConfigSelect.push('<button id="enrolleeCycleCaseLoadNext" class="DisabledSelect" onclick="enrolleeCycleCaseLoadNext()">></button>');

    return lConfigSelect.join('');
}

function uDisplayHoverMoreChartCycleData() {
    "use strict";
    var lEnrolleeCardView = mEnrolleesControls.CardView.selectedDataItemById(mEnrolleesData.OffenderCurrentId);

        mEnrolleesControls.PopupEnrolleeSmallCardView = null;

        if (lEnrolleeCardView) {
            mEnrolleesControls.PopupEnrolleeSmallCardView = new sumo.controls.PopupControl("lEnrolleeTimelineCardPopup", "caseCycleBoxHover", {
                "DataSource": [lEnrolleeCardView],
                "Html": '<div class="Property EnrolleeProperty" id="lEnrolleeTimelineCard"></div>',
                "CardTemplate": 'Interface/Enrollees.Card.Popup.Template.htm',
                "popupStyle": "qtip-lightCard qtip-max-width",
                "popupPosition": {
                    my: 'top left',
                    at: 'bottom center'
                }
            });

        }
}

function timelineInactiveActiveCheck() {
    if (mEnrolleesControls.veritracksChartMiniMap) {

        var lEnrolleeId = (mEnrolleesData.OffenderCurrentId ? mEnrolleesData.OffenderCurrentId : -1);
        var lEnrolleeCardSelected = mEnrolleesControls.CardView.selectedDataItemById(lEnrolleeId);
        var lIsInformaticsEnabled = false;
    
        if (lEnrolleeCardSelected){
            lIsInformaticsEnabled = getInformaticsEnabled(lEnrolleeCardSelected['OrganizationId']);
        }

        if (GetEnrolleeCardProductIdTimelineSupport() && lIsInformaticsEnabled) {
            enableTimelineButton();
            $('#uTimelineAlert').hide();
            mEnrolleesControls.veritracksChartMiniMap.invertDayColors(false, 'ColorInvertGray');
        } else {
            disabledTimelineButton();
            $('#uTimelineAlert').show();
            var lTimelineUsed = $("#uVeritracksLargeChart").is(":visible");
            if (!lTimelineUsed) {
                mEnrolleesControls.veritracksChartMiniMap.invertDayColors(true, 'ColorInvertGray');
            }else{
                mEnrolleesControls.veritracksChartMiniMap.invertDayColors(false, 'ColorInvertGray');
            }
        }
    }
}

/*1-4-16 timeline show on blutag artf68405*/
function uDisplayTimelineChartButton(aEnrolleeId) {
    "use strict";
    var lEnrolleeId = (aEnrolleeId ? aEnrolleeId : mEnrolleesData.OffenderCurrentId);
    var lEnrolleeCardSelected = mEnrolleesControls.CardView.selectedDataItemById(lEnrolleeId);
    var lIsInformaticsEnabled = false;
    
    if (lEnrolleeCardSelected){
        lIsInformaticsEnabled = getInformaticsEnabled(lEnrolleeCardSelected['OrganizationId']);
    }
    if (GetEnrolleeCardProductIdTimelineSupport(aEnrolleeId) && lIsInformaticsEnabled) {
        enableTimelineButton();
    }
    else {
        disabledTimelineButton();
    }
}

function disabledTimelineButton() {
    $('.ChartButton').addClass('Disabled');
    if ($('.ChartButton')[0])
        $('.ChartButton')[0].title = localizeText('cTimelineAlert');
    if ($('.ChartButton')[1])
        $('.ChartButton')[1].title = localizeText('cTimelineAlert');

}

function enableTimelineButton() {
    $('.ChartButton').removeClass('Disabled');
    if ($('.ChartButton')[0])
        $('.ChartButton')[0].title = localizeText('cEnrolleeTimeline');
    if ($('.ChartButton')[1])
        $('.ChartButton')[1].title = localizeText('cEnrolleeTimeline');
}
function GetEnrolleeCardProductIdTimelineSupport(aEnrolleeId) {
    var lEnrolleeTrackingDeviceId,
        lEnrolleeDeviceInfo,
        lEnrolleeId = (aEnrolleeId ? aEnrolleeId : mEnrolleesData.OffenderCurrentId),
        lEnrolleeDevice;

    var lEnrolleeCardSelected = mEnrolleesControls.CardView.selectedDataItemById(lEnrolleeId);

    if (lEnrolleeCardSelected) {
        lEnrolleeTrackingDeviceId = lEnrolleeCardSelected['TrackingDeviceId'];

        lEnrolleeDeviceInfo = GetDevice(lEnrolleeTrackingDeviceId);
    }
    if (lEnrolleeDeviceInfo) {
        lEnrolleeDevice = lEnrolleeDeviceInfo['ProductId'];
    }

    return [103, 141, 151].indexOf(lEnrolleeDevice) !== -1
}

function TimelineRemoveLeftoverPopup() {
    "use strict";
    if ($('#uEnrolleesListCell').hasClass('ChartingLimit')) {
        $('div.qtip:visible').qtip('hide');
    }
}

function enrolleeCycleCaseLoadNext(aStep) {
    "use strict";
    var cycleCase = $('.casesAvailable');
    var current = $('.cycleCaseSelected').index();
    var step = 1;

    if (!isNullOrUndefined(aStep)) {
        step = aStep;
    }

    //$('div.qtip:visible').qtip('hide');

    cycleCase.removeClass('cycleCaseSelected');
    cycleCase.eq(current).addClass('cycleCaseNotSelected');
    current = (current + step) % cycleCase.length;
    cycleCase.hide().eq(current).show();
    cycleCase.eq(current).removeClass('cycleCaseNotSelected');
    cycleCase.eq(current).addClass('cycleCaseSelected');

    var lEnrolleeId = $('.cycleCaseSelected').data('value'),
        lEnrollee = GetEnrollee(lEnrolleeId),
        lEnrolleeSN = $('.cycleCaseSelected').data('sn');

    mEnrolleesData.OffenderCurrentId = lEnrolleeId;

    mEnrolleesControls.veritracksChartMiniMap.setDataSource([]);
    enrolleeCycleCallback();

//    mEnrolleesControls.CardView.selected(mEnrolleesData.OffenderCurrentId);

    uDisplayHoverMoreChartCycleData();

    $('#lEnrolleeTimelineId').remove();
    $('#lEnrolleeTimelineSN').text(lEnrolleeSN);
}

function enrolleeCycleCallback() {
    "use strict";
    var lNoLock = true;
    var lEnrollee;

    timelineInactiveActiveCheck();
    if (mStateManager.Settings()[1] === "Profile") {
        mEnrolleesControls.CardView.selected(mEnrolleesData.OffenderCurrentId);
        setTimelineDates(lNoLock, mEnrolleesData.OffenderCurrentId);
    } else {
        if (getTimelineDateChangeMapLoadPreference() == 0) {
            loadAllDayTimelineMap(true);
        }
        setTimelineDates(lNoLock, mEnrolleesData.OffenderCurrentId);
    }
}

function enrolleeCycleCaseLoadPrevious() {
    "use strict";
    var cycleCase = $('.casesAvailable');
    var current = $('.cycleCaseSelected').index();

    //$('div.qtip:visible').qtip('hide');
    cycleCase.removeClass('cycleCaseSelected');
    cycleCase.eq(current).addClass('cycleCaseNotSelected');
    current = (current - 1) % cycleCase.length;
    cycleCase.hide().eq(current).show();
    cycleCase.eq(current).removeClass('cycleCaseNotSelected');
    cycleCase.eq(current).addClass('cycleCaseSelected');

    var lEnrolleeId = $('.cycleCaseSelected').data('value'),
        lEnrollee = GetEnrollee(lEnrolleeId),
        lEnrolleeSN = $('.cycleCaseSelected').data('sn');

    mEnrolleesData.OffenderCurrentId = lEnrolleeId;

    mEnrolleesControls.veritracksChartMiniMap.setDataSource([]);
    enrolleeCycleCallback();

    //mEnrolleesControls.CardView.selected(mEnrolleesData.OffenderCurrentId);
    uDisplayHoverMoreChartCycleData();

    $('#lEnrolleeTimelineId').remove();
    $('#lEnrolleeTimelineSN').text(lEnrolleeSN);
}

function populateEnrolleesSmallChartInfo(aEnrollee, aEnrolleeCompleteList) {
    "use strict";
    var lHtml = [];
    var lEnrollee = aEnrollee,
        lEnrolleeCompleteList = aEnrolleeCompleteList;

    if (!lEnrollee) {
        lEnrollee = mEnrolleesControls.CardView.selectedDataItem().Enrollee;
    }
    lHtml.push('<div class="MapPropertyCell" id="smallChartInfoEnrolleeInfo" style="float:left;">');
    lHtml.push(populateEnrolleesSmallChartCycle(lEnrollee, lEnrolleeCompleteList));
    lHtml.push('</div>');
    lHtml.push('<div class="GridIconCell" style="float:right; width:72px;">');
    lHtml.push('<div class="LargeIconButton IconButton MapOffendersButton" onclick="removeBigChart()" title="back to cards"></div>');
    lHtml.push('<div class="IconButton ChartButton" onclick="testBigChart()" title="big timeline"></div> ');
    lHtml.push('</div>');
    lHtml.push('<div class="GridIconCell" style="float:right; width:72px; margin:2px">');
    lHtml.push('<div class="Button" id="uLoadAllDayTimelineMap" onclick="loadAllDayTimelineMap()" title="map set day 24 hours">' + localizeText('cEnrolleeAllDay') + ' <strong> 24</strong></div> ');
    lHtml.push('</div>');
    lHtml.push('<div class="TimelineAlert" id="uTimelineAlert" style="display:none;">'+ localizeText('cTimelineAlert')+'</div>');
    return lHtml.join('');
}

function enrolleesSmallChartMap_Init() {
    "use strict";
    if (!$('#uEnrolleesChartPanel').is(':hidden')) {
        $('.DefaultMapActions').hide();
        $('.LimitedMapActions').show();
        $('#LimitedMapActionsStartDate').html(localizeText('cEnrolleeStartDate') + ': ' + DisplayShortDateTime(mEnrolleesData.ChartStartDate) + ' - ');
        $('#LimitedMapActionsEndDate').html(localizeText('cEnrolleeEndDate') + ': ' + DisplayShortDateTime(mEnrolleesData.ChartEndDate));
        $('#uLoadAllDayTimelineMap').show();
    }
    if (!mEnrolleesControls.veritracksChartMiniMap.getExtraData('IgnoreClose')) {
        ClosePopup();
    } else {
        mEnrolleesControls.veritracksChartMiniMap.addExtraData('IgnoreClose', false);
    }
}

function enrolleeTimelineCycle_Init() {
    "use strict";
    var lEnrolleeList = mEnrolleesControls.CardView.getDataSource();


    if (lEnrolleeList.length == 1) {
        var lEnrolleeCard = lEnrolleeList[0];

        //if (lEnrolleeCard['TrackingDeviceId']) {
        //    var lDevice = GetDevice(lEnrolleeCard['TrackingDeviceId']);
        //    if (lDevice.ProductId !== 103) {
        //        return false;
        //    }
        //}else{
        //    return false;
        //}
    }
    $('#enrolleeInfo').show();
    $('#enrolleeInfo').html(populateEnrolleesSmallChartInfo(GetEnrollee(mEnrolleesData.OffenderCurrentId), lEnrolleeList));

    if (lEnrolleeList.length == 1) {
        $('#enrolleeCycleCaseLoadPrevious').attr("disabled", "disabled");
        $('#enrolleeCycleCaseLoadNext').attr("disabled", "disabled");
    }

    return true;
}

function updateTimelineIfPresent() {
    var lOldEnrolleeId = -1,
        lCurrentEnrolleeId = mEnrolleesData.OffenderCurrentId;


    if (!$('#enrolleeInfo').is(':hidden')) {
        lOldEnrolleeId = $('.cycleCaseSelected').data('value');

        if (lCurrentEnrolleeId != lOldEnrolleeId) {
            enrolleeTimelineCycle_Init();
            setTimelineDates(true, lCurrentEnrolleeId);
        }
    }

}

function enrolleesSmallChart_Init(aView) {
    "use strict";
    var lWindowHeight = getWindowHeight(),
        lMasterContentHeight = (lWindowHeight - (mMasterOverheadHeight + 10)),
        lPageOverhead = getOverhead('PageOverhead'),
        lLayoutTableHeight = lMasterContentHeight - 10,
        lPageHeight = lLayoutTableHeight - (lPageOverhead),
        lCalendarHeight = lPageHeight - 125,
        lView = "agendaDay",
        lEnrolleeId = mEnrolleesData.OffenderCurrentId;

    if (aView) {
        lView = aView;
    }
    $('#uEnrolleesListCell').addClass('ChartingLimit');
    $('#uEnrolleesListPanel').hide();
    $('#uEnrolleesChartPanel').show();

    //change to cycle with arrows display for smallchart_init pass in second parameter of complete list artf66583
    if ($('#enrolleeInfo').is(':hidden')) {
        var lIsBadEnrollee = enrolleeTimelineCycle_Init();
    }

    if (lEnrolleeId == -1) {
        lEnrolleeId = $('.cycleCaseSelected').data('value');
    }


    if (isNullOrUndefined(mEnrolleesControls.veritracksChartMiniMap)) {
        mEnrolleesControls.veritracksChartMiniMap = new VeritracksFullCalendarWrapper('#enrolleesSmallMapCharting',
            {
                "defaultView": lView,
                "slotEventOverlap": true,
                "selectOverlap": true,
                "multiDaySelect": false,
                "displayEventEnd": true,
                "editable": false,
                "selectable": true,
                "selectHelper": false,
                "selectMultiDay": false,
                "allDaySlot": false,
                "rightClickOptions": 'agendaWeek,agendaDay',
                //"hideTitleFor": "agendaWeek",
                "dayStart": getFirstDay(),
                "lazyFetching": true
            },
            {
                "clickHandler": setMiniClickCal,
                "rightClickHandler": setTimelinePopupMenu,
                "viewRender": setDataMinCal,
                "afterRender": chartAfterRenderImageAppend,
                "selected": setMiniDragCal,
                "events": setEventsFromHistoryMiniCal,
                "disabledNavigation": timelineDisableNavigation
            });

        mEnrolleesControls.veritracksChartMiniMap.setView('agendaWeek');
        mEnrolleesControls.veritracksChartMiniMap.setView('agendaDay');

        mEnrolleesControls.veritracksChartMiniMap.addExtraData('IgnoreClose', false);
    } else {
        mEnrolleesControls.veritracksChartMiniMap.invertDayColors(false, 'ColorInvertGray');
    }

    // calculate content height for small chart
    $('#enrolleesSmallMapCharting').fullCalendar('option', 'contentHeight', lCalendarHeight);
    timelineInactiveActiveCheck();

    return true;
}

function updateMiniTimeline() {
    mEnrolleesControls.veritracksChartMiniMap.addExtraData('IgnoreCallback', true);
    setTimelineMapDate();
    mEnrolleesControls.veritracksChartMiniMap.setDataSource(mEnrolleesControls.veritracksChartMap.getRawDataSource());
    mEnrolleesControls.veritracksChartMiniMap.setView('agendaWeek');
    mEnrolleesControls.veritracksChartMiniMap.setView('agendaDay');
}

function setTimelineDates(aTimelineDefaultDate, aEnrolleeId, aUseCurrentDate) {
    "use strict";
    var lEnrolleeId = aEnrolleeId;
    var lUseCurrentDate = true;

    if (!isNullOrUndefined(aUseCurrentDate)) {
        lUseCurrentDate = aUseCurrentDate;
    }
    if (aTimelineDefaultDate) {
        getEnrolleeDefaultTimelineDate(lEnrolleeId, lUseCurrentDate);
    }
    setTimelineMapDate();
}

function setTimelineMapDate() {
    "use strict";
    var currentMapDate = $(mEnrolleesControls.veritracksChartMiniMap.calendarId()).fullCalendar('getDate');
    var enrolleeDate = moment(mEnrolleesData.ChartStartDate);
    currentMapDate.hours(0);
    currentMapDate.minutes(0);
    currentMapDate.seconds(0);
    enrolleeDate.hours(0);
    enrolleeDate.minutes(0);
    enrolleeDate.seconds(0);

    if (currentMapDate.format() == enrolleeDate.format()) {
        $('#enrolleesSmallMapCharting').fullCalendar('refetchEvents');
    } else {
        $('#enrolleesSmallMapCharting').fullCalendar('gotoDate', mEnrolleesData.ChartStartDate);
    }

    mEnrolleesControls.veritracksChartMiniMap.addExtraData('enrolleeId', mEnrolleesData.OffenderCurrentId);
    $('#enrolleesSmallMapCharting').fullCalendar('scrollTime', mEnrolleesData.ChartStartDate);
}

function resetContentHoldersEnrollees() {
    "use strict";

    var lWindowWidth = $(window).width(),
    lWindowHeight = $(window).height();

    if (mStateManager.Settings()[1] === 'Map') {
        var lMapContentHeight = $('#uEnrolleesMapHolder').height(),
            lMapPlaybackHeight = $('#uMapPlaybackPanel').height(),
            lTrackPointFilterHeight = $('#uTrackpointDetailCardViewFilterHolder').height(),
            lMapHolderHeight = lMapContentHeight - (lMapPlaybackHeight + 20), //640
            lMapLegendHeight = lMapHolderHeight + lMapPlaybackHeight,
            lTrackPointCardViewHeight = lMapLegendHeight - lTrackPointFilterHeight - 12,
            lFirstContentHolderWidth;
        setHeight('#uMapPanel', lMapHolderHeight);
        setHeight('#uMapLegendPanel', lMapLegendHeight);
        setHeight('#uTrackpointDetailCardViewHolder', lTrackPointCardViewHeight);

        var lMapWidth = $('#uMapPanel').width(),
            lMapHeight = $('#uMapPanel').height(),
            lMapOffset = $('#uMapPanel').offset(),
            lNotificationWidth = $('#uMapNotificationPanel').width(),
            lLocateRight,
            lLocateRightAdjustment,
            lLocateBottom,
            lMapPosition = $('#uMapPanel').position(),
            lContentWidth = $('#uEnrolleesMainContentPanel').width();

        if (lWindowWidth <= 980) {
            enrolleesIphoneResolutionMapDisplay();
        }
        else {
            setHeight('#uEnrolleesMapButtonBar', 24);
           /// setWidth('#uOffenderProfilePanel', lContentWidth);
        }
        setWidth('.MapWidth', lMapWidth);
        if (!isNullOrUndefined(lMapOffset)) {
            lLocateRight = lWindowWidth - (lMapWidth + lMapOffset.left);
            lLocateBottom = lWindowHeight - (lMapHeight + lMapOffset.top);
            if (lLocateRight > 180 && lLocateBottom > 0) {
                $('#uLocateMapHolder').css('right', (lLocateRight).toString() + 'px').css('bottom', (lLocateBottom).toString() + 'px').show();
                $('#uVisitLabelHolder').css('left', (lMapPosition.left).toString() + 'px').css('bottom', (lLocateBottom).toString() + 'px').show();
                $('#uMapNotificationPanel').css('bottom', (lLocateBottom).toString() + 'px');
            } else {
                $('#uLocateMapHolder').hide();
                $('#uVisitLabelHolder').hide();
            }
            $('#uMapNotificationPanel').css('margin-left', ((lMapWidth - lNotificationWidth) / 2).toString() + 'px');

            if (!$('#uMapDetailPanelCell').is(':visible')) {
                lLocateRightAdjustment = lLocateRight - 2;
                $('#uLocateMapHolder').css('right', (lLocateRightAdjustment).toString() + 'px').css('bottom', (lLocateBottom).toString() + 'px').show();
            }
        }
        // setWidth('#uEnrolleesNoData', lMapWidth);

    }
    if (mStateManager.Settings()[2] === 'Assignments') {
        var lContentHolderWidth = $('#uEnrolleesAssignmentPanel').width(),
            lAssignmentWidth = $('#uEnrolleesCurrentAssignmentPanel').width(),
            lListWidth = lContentHolderWidth - (lAssignmentWidth + 10);
        setWidth('#uEnrolleesAssignmentsListViewHolder', lListWidth);
    }
    // default profile
    if (lWindowWidth <= 980) {
        enrolleesIphoneResolutionTableDisplay();
    }
    else {
        lFirstContentHolderWidth = $('#uEnrolleesMainContentPanel').width();
        setWidth('#uEnrolleesSecondaryContentPanel', lFirstContentHolderWidth);
    }

    // need to do this after site load or else correct width will not be set to body. Temp bug fix of shifting body up.
    var lVendor = window.navigator.vendor;
    if (!isNullOrUndefined(lVendor)) {
        if (lVendor.indexOf('Google') !== -1 && !$('#uEnrolleesLayoutTableBody').hasClass('NotScrollable')) {
            $('#uEnrolleesLayoutTable').removeClass('NotScrollable');
        }
    }

    //// fix chart height if visible.
    //if ($('#uEnrolleesChartPanel').is(':visible')) {
    //    var lMasterContentHeight = (lWindowHeight - (mMasterOverheadHeight + 10)),
    //        lPageOverhead = getOverhead('PageOverhead'),
    //        lLayoutTableHeight = lMasterContentHeight - 10,
    //        lPageHeight = lLayoutTableHeight - (lPageOverhead),
    //        lListOverhead = getOverhead('ListOverhead'),
    //        lListHeight = lPageHeight - lListOverhead,
    //        lCalendarHeight = lListHeight - 50;

    //    $('#enrolleesSmallMapCharting').fullCalendar('option', 'contentHeight', lCalendarHeight);
    //}

    resetOffenderProfileWindow();
    enrolleesFilterController();
}

function identifyDeviceActionType(aDeviceType) {
    "use strict";
    var lItem = mEnrolleesControls.CardView.selectedDataItem();

    displayDeviceActionPopup(aDeviceType, lItem.TrackingDeviceId, lItem.FullName);
}

function EnrolleePage_uRefreshButton_OnClick() {
    "use strict";
    mEnrolleesData.MapEndDate = new Date();
    mEnrolleesData.MapPageMultiplier = 0;

    // check if would be in cardview after refresh
    SaveStateTargetSet()
    //offender_toggleuMapForwardButton();
    //offender_toggleuLastContactButton();
    uEnrolleesCardView_OnUpdate();
    offenderMapPopulate();
    if (!isNullOrUndefined(mEnrolleesData.OffenderSecondaryCurrentId)) {
        offenderSecondaryMapPopulate();
    }
}

function SaveStateTargetSet() {
    "use strict";
    if (ObjectLength(mEnrolleesData.OffenderPaginated) == 1)
        mEnrolleesData.TargetId = mEnrolleesData.OffenderCurrentId;
}


function uMapNowButton_OnClick() {
    "use strict";
    $('#uLastContactButton').hide();
    $('#uMapNowButton').hide();
    mEnrolleesData.MapEndDate = new Date();
    offenderMapPopulate();
    if (!isNullOrUndefined(mEnrolleesData.OffenderSecondaryCurrentId)) {
        offenderSecondaryMapPopulate();
    }
    //offender_toggleuMapForwardButton();
}

// removed
function EnrolleePage_uLastContactButton_OnClick() {
    "use strict";
    $('#uLastContactButton').hide();
    mEnrolleesData.MapEndDate = new Date(mEnrolleesControls.CardView.selectedDataItem().LastTrackpointDate);
    offenderMapPopulate();
    if (!isNullOrUndefined(mEnrolleesData.OffenderSecondaryCurrentId)) {
        offenderSecondaryMapPopulate();
    }
    //offender_toggleuMapForwardButton();
}

//function forceEnrolleeServerCacheRefresh() {
//    "use strict";

//    if (mEnrolleesData.IsEnrolleeCacheUpdateAvailable) {
//        uEnrolleesCardView_OnUpdate();
//        mEnrolleesData.IsEnrolleeCacheUpdateAvailable = false;
//    } else {
//        mEnrolleesData.IsEnrolleeCacheClicked = true;
//        mCache.UpdateItem("Enrollees");
//    }
//    if (mEnrolleesControls.CardView.isUpdateVisible()) {
//        uEnrolleesCardView_OnUpdate();
//    }
//}

//function forceEnrolleeNoUpdate() {
//    if (!isNullOrUndefined(mEnrolleesData))
//        mEnrolleesData.IsEnrolleeCacheClicked = false;
//}

function EnrolleeLastContact_Updated(aCache, aData) {
    "use strict";
    var lPredicate = new SumoPredicateBuilder(),
        lContacts = null,
        lCardData,
        lContact = null;

    if (!isNullOrUndefined(mEnrolleesControls.CardView)) {
        lCardData = mEnrolleesControls.CardView.selectedDataItem();
    }
    if (!isNullOrUndefined(lCardData)) {
        lPredicate.AddNewExpressionConditional('EnrolleeId', lCardData.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lContacts = query(aData.Data, lPredicate.RootExpression);

        lContact = lContacts[mEnrolleesControls.CardView.selectedDataItem().Id];
        if ((lCardData.LastContactDate === new Date(0) && !isNullOrUndefined(lContact)) ||
        (!isNullOrUndefined(lContact) && lContact.ContactDate > lCardData.LastContactDate)) {
            lCardData.LastContactDate = displayEventInEnrolleeTimeZone(new Date(lContacts[mEnrolleesControls.CardView.selectedDataItem().Id].ContactDate), lCardData.Enrollee);
            lCardData.LastContactDateDisplay = DisplayShortDateTime(displayEventInEnrolleeTimeZone(lCardData.LastContactDate, lCardData.Enrollee));
            if ($('#uRefreshButton').hasClass('RefreshNoButton')) {
                $('#uRefreshButton').removeClass('RefreshNoButton');
            }
            $('#uRefreshButton').addClass('RefreshYesButton');
            $('#uRefreshButton').attr('title', localizeTitleFormatter('refresh available'));
        }
        //Remove to allow recipients button to show instead of hiding it automatically. Needs to happen on filter change or cardview change
        //else {
        //    $('#uRefreshButton').hide();
        //}
    }
}



function addLoadOriButton() {
    "use strict";
    if ($("#uLoadOriDataButton").hasClass("regionalOri")) {
        $("#uLoadOriDataButton").removeClass("regionalOri");
        $("#uUnLoadOriDataButton").addClass("regionalOri");
    }
    if (!$("#uEnrolleesSecondaryContentHolder").hasClass("regionalOri")) {
        $("#uEnrolleesSecondaryContentHolder").addClass("regionalOri");
    }
    if (!$("#uEventsTab").hasClass("regionalOri")) {
        $("#uEventsTab").addClass("regionalOri");
    }
    if (!$("#uZonesTab").hasClass("regionalOri")) {
        $("#uZonesTab").addClass("regionalOri");
    }
}

function loadRegionalOriData() {
    "use strict";
    var selectedEnrolleId = mEnrolleesControls.CardView.selected();
    var enrollee = getDataItem(selectedEnrolleId, "Enrollees");
    var lPredicateBuilder = new SumoPredicateBuilder();
    var count = 1;
    setViewState("isRegionalLoaded", true);
    setViewState("RegionalLoadedId", enrollee.OrganizationId);
    //display event and zone tile
    if ($("#uEventsTab").hasClass("regionalOri")) {
        $("#uEventsTab").removeClass("regionalOri");
    }

    if ($("#uZonesTab").hasClass("regionalOri")) {
        $("#uZonesTab").removeClass("regionalOri");
    }

    if ($("#uEnrolleesSecondaryContentHolder").hasClass("regionalOri")) {
        $("#uEnrolleesSecondaryContentHolder").removeClass("regionalOri");
        $("#uEnrolleesSecondaryContentHolder").show();
    }

    //dump current items
    mCache.RemoveUpdatableItem("Zones");
    mCache.RemoveUpdatableItem("Events");

    mCache.unbind("Zonesupdated", unbindedSuccess);
    mCache.unbind("Eventsupdated", unbindedSuccess);
    mCache.unbind("OffenderSchedulesupdated", unbindedSuccess);

    mCache.bind("Zonesupdated", zoneCacheLoadedOnSuccess);
    mCache.bind("Eventsupdated", eventCacheLoadedOnSuccess);
    mCache.bind("OffenderSchedulesupdated", offenderScheduleCacheLoadedOnSuccess);
    //load orgnazition Zones
    lPredicateBuilder.Clear();
    lPredicateBuilder.AddConditional(gNonErrorBuilder.RootExpression);
    lPredicateBuilder.AddNewExpressionConditional('OrganizationId', enrollee.OrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lPredicateBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    cacheItemUpdatable_Init('Zone', 'Zones', gCacheSettings.ZonesUpdateInterval, lPredicateBuilder.RootExpression, null, false, null);
    //load organization Events
    lPredicateBuilder.Clear();
    lPredicateBuilder.AddConditional(gNonErrorBuilder.RootExpression);
    lPredicateBuilder.AddNewExpressionConditional('OrganizationId', enrollee.OrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lPredicateBuilder.AddNewExpressionConditional('ArchiveFlag', mArchivedFlag, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    cacheItemUpdatable_Init('Event', 'Events', gCacheSettings.EventsUpdateInterval, lPredicateBuilder.RootExpression, null, false, null);

    function zoneCacheLoadedOnSuccess() {
        if (count == 3) {
            mActivityNotification.addNotification(localizeWrapper('cEnrolleeZESLoaded'));
            mCache.unbind("Eventsupdated", unbindedSuccess);
            mCache.unbind("OffenderSchedulesupdated", unbindedSuccess);
            uEnrolleesCardView_OnSelectChange(mEnrolleesControls.CardView, enrollee.Id, enrollee);
            universalSearch_UpdateData();
        }
        count++;
        mCache.unbind("Zonesupdated", unbindedSuccess);
    }

    function eventCacheLoadedOnSuccess() {
        if (count == 3) {
            mActivityNotification.addNotification(localizeWrapper('cEnrolleeZESLoaded'));
            mCache.unbind("Zonesupdated", unbindedSuccess);
            mCache.unbind("OffenderSchedulesupdated", unbindedSuccess);
            uEnrolleesCardView_OnSelectChange(mEnrolleesControls.CardView, enrollee.Id, enrollee);
            universalSearch_UpdateData();
        }
        count++;
       mCache.unbind("Eventsupdated", unbindedSuccess);
    }

    function offenderScheduleCacheLoadedOnSuccess() {
        if (count == 3) {
            mActivityNotification.addNotification(localizeWrapper('cEnrolleeZESLoaded'));
            mCache.unbind("Zonesupdated", unbindedSuccess);
            mCache.unbind("Eventsupdated", unbindedSuccess);
            uEnrolleesCardView_OnSelectChange(mEnrolleesControls.CardView, enrollee.Id, enrollee);
            universalSearch_UpdateData();
        }
        count++;
        mCache.unbind("OffenderSchedulesupdated", unbindedSuccess);
    }

    function unbindedSuccess() {

    }

}

function loadPhotoTypes() {
    "use strict";
    var lPhotoTypes = getDataItems("OffenderPhotoType"),
        lHtml = [];

    $("#uPhotoType").html("");
    for (var lKey in lPhotoTypes) {
        if (lPhotoTypes.hasOwnProperty(lKey)) {
            if (lPhotoTypes[lKey].Id == 5 || lPhotoTypes[lKey].Id == 4) {
                lHtml.push('<option disabled value="' + lPhotoTypes[lKey].Id + '">' + localizeDataItem('OffenderPhotoType', lPhotoTypes[lKey].PhotoTypeText) + '</option>');

            } else {
                lHtml.push('<option value="' + lPhotoTypes[lKey].Id + '">' + localizeDataItem('OffenderPhotoType', lPhotoTypes[lKey].PhotoTypeText) + '</option>');
            }
                   }
    }//end of photo

    $("#uPhotoType").append(lHtml.join(''));
}




function uOffenderMapMaxSearch_Init() {
    var lMaxDurationSetting = veritracks.system.clientSetting('searchablemaxduration'),
        lSelectFilter = $('#uEnrolleeMapTimeFilter'),
        lConstantDuration = [],
        lMaxDuration = [],
        lPreferences = getUserPreferences(4),
        lKey;

    lMaxDurationSetting = parseInt(lMaxDurationSetting);

    lConstantDuration.push({ "value": "5", "option": localizeText('c5min') },
        { "value": "10", "option": localizeText('c10min') },
        { "value": "15", "option": localizeText('c15min') },
        { "value": "30", "option": localizeText('c30min') });


    // id is hours value is minutes option is text
    lMaxDuration.push({ "id": "1", "value": "60", "option": localizeText('c1hour')},
        { "id": "2", "value": "120", "option": localizeText('c2hours') },
        { "id": "4", "value": "240", "option": localizeText('c4hours') },
        { "id": "8", "value": "480", "option": localizeText('c8hours') },
        { "id": "12", "value": "720", "option": localizeText('c12hours') },
        { "id": "24", "value": "1440", "option": localizeText('c1day') },
        { "id": "48", "value": "2880", "option": localizeText('c2days') },
        { "id": "72", "value": "4320", "option": localizeText('c3days') },
        { "id": "96", "value": "5760", "option": localizeText('c4days') },
        { "id": "120", "value": "7200", "option": localizeText('c5days') },
        //{ "id": "144", "value": "7200", "option": "6 day" },
        { "id": "168", "value": "10080", "option": localizeText('c1week') });

    for (lKey in lConstantDuration) {
        if (lConstantDuration.hasOwnProperty(lKey)) {
            lSelectFilter.append($("<option/>").attr("value", lConstantDuration[lKey].value).text(lConstantDuration[lKey].option));
        }
    }

    // checking hours
    if (lMaxDurationSetting >= 1) {
        for (lKey in lMaxDuration) {
            if (lMaxDuration.hasOwnProperty(lKey)) {
                if (lMaxDuration[lKey].id <= lMaxDurationSetting) {
                    lSelectFilter.append($("<option/>").attr("value", lMaxDuration[lKey].value).text(lMaxDuration[lKey].option));
                }
            }
        }
    }

    lPreference = lPreferences['MapTimeSpan'];
    if (!isNullOrUndefined(lPreference)) {
        $('#uEnrolleeMapTimeFilter').val(lPreference.Value);
    }
}


function uInitializeThreads(){
    "use strict";
    mEnrolleesControls.Threads = new VeritracksThreadsControl(veritracks.data.controller.buildGraph);
}


function tempLocalizationOffenderProfile_Arkansas(aId) {
    "use strict";
    $('#tempProfileSecondaryId').text(localizeText('cEnrolleeEmploymentDate'));
    $('#uEnrolleeProfileOrganizationAddress').show();
    if (checkOrganizationProperty(aId, 'is_arkansas_th') == "Y") {
        $("#tempArkansasClassifications").hide();
        $("#uEnrollementStartLabel").html(localizeText('cEnrolleeReleaseDate'));
        $("#uEnrollementEndLabel").html(localizeText('cEnrolleeEnrollmentStart'));
    } else {
        $("#tempArkansasClassifications").show();
        $("#uEnrollementStartLabel").html(localizeText('cEnrolleeEnrollmentStart'));
        $("#uEnrollementEndLabel").html(localizeText('cEnrolleeEnrollmentEnd'));
    }
}

function removeTempLocalizationOffenderProfile_Arkansas(aId) {
    "use strict";
    $('#tempProfileSecondaryId').text(localizeText('cEnrolleeSecondaryId'));
    $("#uEnrollementStartLabel").html(localizeText('cEnrolleeEnrollmentStart'));
    $("#uEnrollementEndLabel").html(localizeText('cEnrolleeEnrollmentEnd'));
    if (checkOrganizationProperty(aId, 'is_arkansas_all') != "Y")
        $('#uEnrolleeProfileOrganizationAddress').hide();
    else
        $('#uEnrolleeProfileOrganizationAddress').show();
    $("#tempArkansasClassifications").show();
}




function enrolleesResetOffenderCardView_OnRender(aSender, aEventData, aEnrolleeId) {
    "use strict";
    mEnrolleesControls.CardView.selected(aEnrolleeId);
    mEnrolleesControls.CardView.unbind('databind', enrolleesResetOffenderCardView_OnRender);
}

function enrolleesResetOffenderCardView(aEnrolleeId) {
    "use strict";
    enrolleesDataListConverter();
    mEnrolleesControls.CardView.bind('databind', enrolleesResetOffenderCardView_OnRender, aEnrolleeId);
    if (mEnrolleesControls.CardViewOffenderFilter) {
        mEnrolleesControls.CardViewOffenderFilter.filter();
    }
}

// ELEMENT INIT
function uEnrolleesCardView_OnUpdate() {
    "use strict";
    if (!isNullOrUndefined(mEnrolleesControls.CardViewOffenderFilter)) {
        SaveStateTargetSet();
        mEnrolleesControls.CardViewOffenderFilter.filter();
        uEnrolleesCardViewSortOnViewState();
        mEnrolleesControls.CardView.selected(mEnrolleesData.OffenderCurrentId);
    } else if (!isNullOrUndefined(mEnrolleesControls.CardViewVictimFilter)) {
        SaveStateTargetSet();
        mEnrolleesControls.CardViewVictimFilter.filter();
        uEnrolleesCardViewSortOnViewState();
        mEnrolleesControls.CardView.selected(mEnrolleesData.VictimCurrentId);
    }
}

function uEnrolleesCardView_OnDataBind(aSender, aParams, aData) {
    "use strict";
    mEnrolleesControls.CardView.unbind('databind', uEnrolleesCardView_OnDataBind);
    mEnrolleesControls.CardView.bind('databind', cardView_OnDataBind);

    mEnrolleesControls.CardView.selected(aData);
}

function uEnrolleesCardViewSortOnViewState() {
    "user strict";
    var lSortState = getViewState('EnrolleesCardViewSort');
    if (!isNullOrUndefined(lSortState)) {
        mEnrolleesControls.CardView.sortExpression(lSortState.Value);
    }
}


function uEnrolleesCardView_OnSort(aParams, aSort) {
    "use strict";
    var lEnrollees = mEnrolleesData.OffenderClean,
        lEnrolleesListSorted = [];
    setViewState('EnrolleesCardViewSort', aSort);

    lEnrolleesListSorted = aSort.sort(lEnrollees);
    mEnrolleesData.OffenderSort = lEnrolleesListSorted;
    mEnrolleesControls.CardViewOffenderFilter.filter();
}

function uEnrolleesCardView_Init() {
    "use strict";
    var lViewState = getViewState('EnrolleesSelectedEnrollee'),
        lSortState = getViewState('EnrolleesCardViewSort');
    mEnrolleesControls.CardView = new sumo.controls.CardView('uEnrolleesCardView', 'uEnrolleesListHolder', {
        'cardTemplate': 'Interface/Enrollees.Card.Template.htm', 'selectMethod': 'single', 'canUnselect': false, 'cssClass': 'VeritracksCardView', 'keyField': 'Id', 'isSortable': true, 'Columns': [
            { 'id': 'FullName', 'title': localizeWrapper('cEnrolleeLastName') + ', ' + localizeWrapper('cEnrolleeFirstName') },
            { 'id': 'FirstName', 'title': localizeWrapper('cEnrolleeFirstName') },
            { 'id': 'LastName', 'title': localizeWrapper('cEnrolleeLastName') },
            { 'id': 'PrimaryId', 'title': localizeWrapper('cEnrolleePrimaryId') },
            { 'id': 'LastContactDate', 'title': localizeWrapper('cInventoryLastContactDate') },
            { 'id': 'LastTrackpointDate', 'title': localizeWrapper('cEnrolleeLastTrackDate') }
        ]
    });
    mEnrolleesControls.CardView.bind('selectedchanged',uEnrolleesCardView_OnSelectChange);
    // mEnrolleesControls.CardView.bind('databind', cardView_OnDataBind);
    mEnrolleesControls.CardView.bind('update', uEnrolleesCardView_OnUpdate);
    mEnrolleesData.IsCardViewInitialized = true;
    mEnrolleesControls.CardView.bind('sort', uEnrolleesCardView_OnSort);

    if (!isNullOrUndefined(lViewState)) {
        mEnrolleesControls.CardView.bind('databind', uEnrolleesCardView_OnDataBind, lViewState.Value);
    } else {
        mEnrolleesControls.CardView.bind('databind', cardView_OnDataBind);
    }
}

function slider_OnSlide(aEvent, aUi) {
    "use strict";

    $('#uSlider').slider('option', 'max', mEnrolleesControls.PlaybackControl.getOverlayCount() - 1);

    if (mEnrolleesControls.PlaybackControl.direction() == 1) {
        mEnrolleesControls.PlaybackControl.next();
    } else {
        mEnrolleesControls.PlaybackControl.previous();
    }

    mEnrolleesControls.PlaybackControl.setIndex(aUi.value, 10);    
}

function slide_OnStart(aEvent,aUi){
    var lTrackpointsReviewed =  mEnrolleesControls.PlaybackControl.getOverlaysPlayed(),
            lCurrentTrackPoint =  mEnrolleesControls.PlaybackControl.getCurrentPoint(),
            lDate =overlayDateFormatter(lCurrentTrackPoint);
            if(!isNullOrUndefined(mEnrolleesData.UserTransactionRecordLogger)){
                mEnrolleesData.UserTransactionRecordLogger.addTransaction(UserTransactionRecordEvents.DRAG_FROM,lDate,-1,-1,lTrackpointsReviewed);
            }
    mEnrolleesControls.PlaybackControl.Activate(false);
    console.log('slide_OnStart',aEvent,aUi)
}
function slider_OnStop(aEvent,aUi){
    mEnrolleesControls.PlaybackControl.Activate(true);
    console.log('slider_OnStop',aEvent,aUi)
    var lTrackpointsReviewed =  mEnrolleesControls.PlaybackControl.getOverlaysPlayed(),
            lCurrentTrackPoint =  mEnrolleesControls.PlaybackControl.getCurrentPoint(),
            lDate =overlayDateFormatter(lCurrentTrackPoint);
            if(!isNullOrUndefined(mEnrolleesData.UserTransactionRecordLogger)){
                mEnrolleesData.UserTransactionRecordLogger.addTransaction(UserTransactionRecordEvents.DRAG_TO,lDate,-1,-1,lTrackpointsReviewed);
            }
}

function validateMapStartDateTimeFormat(aStartTimeValue) {
    "use strict";
    var lStartTimeValue = aStartTimeValue,
        lCorrectFormatStartTime,
        regex = /^(0?[1-9]|1[012])(:[0-5]\d) [AP][M]$/,
        amregex = /(?:AM|am|a.m.|Am|aM|A.M)$/i,
        pmregex = /(?:PM|pm|p.m.|Pm|pM|P.M)$/i;

    if (regex.test(lStartTimeValue)) {
        lCorrectFormatStartTime = aStartTimeValue;
    } else {
        mActivityNotification.addNotification(localizeWrapper('cEnrolleeInvalidTimeFormat'));
        lCorrectFormatStartTime = "12:00 AM";
    }

    return lCorrectFormatStartTime;
}

function validateMapStartDateFormat(aStartDateValue) {
    "use strict";
    var lStartDateValue = aStartDateValue;

    var lTimestamp = Date.parse(lStartDateValue);

    var lToday = new Date();
    var lDay = lToday.getDate();
    var lMonth = lToday.getMonth() + 1; //January is 0!
    var lYear = lToday.getFullYear();

    if (lDay < 10) {
        lDay = '0' + lDay
    }

    if (lMonth < 10) {
        lMonth = '0' + lMonth
    }

    lToday = lMonth + '/' + lDay + '/' + lYear;

    if (isNaN(lTimestamp) == true) {
        mActivityNotification.addNotification(localizeWrapper('cEnrolleeInvalidDateFormat'));
        return lToday;
    } else {
        var lValues = lStartDateValue.split('/'),
            lYearValues = lValues[2];

        if (lYearValues > (lYear + 10)) {
            mActivityNotification.addNotification(localizeWrapper('cEnrolleeInvalidDateFormat'));
            return lToday;
        }

        return lStartDateValue;
    }

}

function enrolleesOffendersMapStartDateTime_OnChange() {
    "use strict";
    var lStartDateValue = validateMapStartDateFormat($('#uMapStartDatePicker').val()),
        lStartTimeValue = validateMapStartDateTimeFormat($('#uMapStartTimePicker').val()),
        lEnrolleeMapTimeFilter = $('#uEnrolleeMapTimeFilter'),
        lValue = lStartDateValue + ' ' + lStartTimeValue,
        lMinutes = 1440,
        lStartDate = new Date(lValue);

    $('#uMapStartDatePicker').val(lStartDateValue);

    if (lEnrolleeMapTimeFilter.length > 0) {
        lMinutes = parseInt(lEnrolleeMapTimeFilter.val());
    }
    mEnrolleesData.MapEndDate = lStartDate.addMinutes(lMinutes);

    veritracks.enrollees.mapping.initializeEnrolleeMap(true);
}

function enrolleesOffendersMapDateTime_OnChange() {
    "use strict";
    var lDateValue = $('#uMapDatePicker').val(),
        lTimeValue = $('#uMapTimePicker').val(),
        lValue = lDateValue + ' ' + lTimeValue;

    $('#uMapDatePicker').val(lDateValue);
    mEnrolleesData.MapEndDate = new Date(lValue);
    veritracks.enrollees.mapping.initializeEnrolleeMap(true);
}

function uEnrolleesMapPlaybackLock() {
    "use strict";
    if (!mEnrolleesControls.PlaybackControl.IsActive()) {
        $('#uEnrolleesMapPlaybackStopButtonDisabled').show();
        $('#uEnrolleesMapPlaybackPreviousButtonDisabled').show();
        $('#uEnrolleesMapPlaybackNextButtonDisabled').show();
        $('#uEnrolleesMapPlaybackPlayButtonDisabled').show();
        $('#uEnrolleesMapPlaybackFastForwardButtonDisabled').show();
        $('#uEnrolleesMapPlaybackSlowDownButtonDisabled').show()
        $('#uEnrolleesMapPlaybackFastForwardButtonDisabled').show();
        $('#uEnrolleesMapPlaybackSlowDownButtonDisabled').show();
        $('#uEnrolleesMapPlaybackStopButton').hide();
        $('#uEnrolleesMapPlaybackPreviousButton').hide();
        $('#uEnrolleesMapPlaybackNextButton').hide();
        $('#uEnrolleesMapPlaybackPlayButton').hide();
        $('#uEnrolleesMapPlaybackFastForwardButton').hide();
        $('#uEnrolleesMapPlaybackSlowDownButton').hide()
        $('#uEnrolleesMapPlaybackFastForwardButton').hide();
        $('#uEnrolleesMapPlaybackSlowDownButton').hide();
        $('#uSlider').hide();
    }
    else {
        enrolleePlaybackControl_OnSelectChange(null, { 'state': 0 }, null);
    }
}

function enrolleePlaybackControl_OnSelectChange(aSender, aEvent, aData) {
    "use strict";
    if (mEnrolleesControls.PlaybackControl.IsActive()) {
        //show slider
        $('#uSlider').show();
        switch (aEvent.state) {
            case 0: //stopped
                mEnrolleesData.PlaybackStatus = 'Stopped';
                //$('#uEnrolleesMapPlaybackPreviousCell').show();
                //$('#uEnrolleesMapPlaybackPlayButton').show();
                //$('#uEnrolleesMapPlaybackPauseButton').hide();
                //$('#uEnrolleesMapPlaybackStopCell').hide();
                //$('#uEnrolleesMapPlaybackFastForwardCell').hide();
                //$('#uEnrolleesMapPlaybackNextCell').show();

                //hide incorrect active buttons
                $('#uEnrolleesMapPlaybackStopButton').hide();
                $('#uEnrolleesMapPlaybackPauseButton').hide();
                $('#uEnrolleesMapPlaybackFastForwardButton').hide();

                //show correct disabled buttons in their place
                $('#uEnrolleesMapPlaybackStopButtonDisabled').show();
                $('#uEnrolleesMapPlaybackFastForwardButtonDisabled').show();
                $('#uEnrolleesMapPlaybackSlowDownButtonDisabled').show()

                //hide incorrect disabled buttons
                $('#uEnrolleesMapPlaybackPreviousButtonDisabled').hide();
                $('#uEnrolleesMapPlaybackPlayButtonDisabled').hide();
                $('#uEnrolleesMapPlaybackNextButtonDisabled').hide();
                $('#uEnrolleesMapPlaybackSlowDownButton').hide()

                //show correct active buttons in their place
                $('#uEnrolleesMapPlaybackPreviousButton').show();
                $('#uEnrolleesMapPlaybackPlayButton').show();
                $('#uEnrolleesMapPlaybackNextButton').show();

                // show map command cell
                $('.MapCommandCell').show('slow');
                break;
            case 1: //playing
                mEnrolleesData.PlaybackStatus = 'Playing';
                //$('#uEnrolleesMapPlaybackPreviousCell').hide();
                //$('#uEnrolleesMapPlaybackPlayButton').hide();
                //$('#uEnrolleesMapPlaybackPauseButton').show();
                //$('#uEnrolleesMapPlaybackStopCell').show();
                //$('#uEnrolleesMapPlaybackFastForwardCell').show();
                //$('#uEnrolleesMapPlaybackNextCell').hide();

                //hide incorrect active buttons
                $('#uEnrolleesMapPlaybackPreviousButton').hide();
                $('#uEnrolleesMapPlaybackPlayButton').hide();
                $('#uEnrolleesMapPlaybackNextButton').hide();

                //show correct disabled buttons in their place
                $('#uEnrolleesMapPlaybackPreviousButtonDisabled').show();
                $('#uEnrolleesMapPlaybackNextButtonDisabled').show();

                //hide incorrect disabled buttons
                $('#uEnrolleesMapPlaybackStopButtonDisabled').hide();
                $('#uEnrolleesMapPlaybackFastForwardButtonDisabled').hide();
                $('#uEnrolleesMapPlaybackSlowDownButtonDisabled').hide();

                //show correct active buttons in their place
                $('#uEnrolleesMapPlaybackPauseButton').show();
                $('#uEnrolleesMapPlaybackStopButton').show();
                $('#uEnrolleesMapPlaybackFastForwardButton').show();
                $('#uEnrolleesMapPlaybackSlowDownButton').show();

                // show map command cell
                $('.MapCommandCell').hide('slow');
                break;
            case 2: //paused
                if (!isNullOrUndefined(aEvent.currentPoint)) {
                    if (mEnrolleesControls.OffenderTrackpointDetailCardView) {
                        mEnrolleesControls.OffenderTrackpointDetailCardView.scrollTop(aEvent.currentPoint.cardViewPrefix + aEvent.currentPoint.Id.toString());
                        mEnrolleesControls.OffenderTrackpointDetailCardView.selected(aEvent.currentPoint.cardViewPrefix + aEvent.currentPoint.Id.toString());
                    } else if(mEnrolleesControls.VictimTrackpointDetailCardView){
                        mEnrolleesControls.VictimTrackpointDetailCardView.scrollTop(aEvent.currentPoint.cardViewPrefix + aEvent.currentPoint.Id.toString());
                        mEnrolleesControls.VictimTrackpointDetailCardView.selected(aEvent.currentPoint.cardViewPrefix + aEvent.currentPoint.Id.toString());
                    }
                }
                mEnrolleesData.PlaybackStatus = 'Paused';
                //$('#uEnrolleesMapPlaybackPreviousCell').show();
                //$('#uEnrolleesMapPlaybackPlayButton').show();
                //$('#uEnrolleesMapPlaybackPauseButton').hide();
                //$('#uEnrolleesMapPlaybackStopCell').show();
                //$('#uEnrolleesMapPlaybackFastForwardCell').hide();
                //$('#uEnrolleesMapPlaybackNextCell').show();

                //hide incorrect active buttons
                $('#uEnrolleesMapPlaybackPauseButton').hide();
                $('#uEnrolleesMapPlaybackFastForwardButton').hide();
                $('#uEnrolleesMapPlaybackSlowDownButton').hide();

                //show correct disabled buttons in their place
                $('#uEnrolleesMapPlaybackFastForwardButtonDisabled').show();
                $('#uEnrolleesMapPlaybackSlowDownButtonDisabled').show();

                //hide incorrect disabled buttons
                $('#uEnrolleesMapPlaybackPreviousButtonDisabled').hide();
                $('#uEnrolleesMapPlaybackStopButtonDisabled').hide();
                $('#uEnrolleesMapPlaybackNextButtonDisabled').hide();

                //show correct active buttons in their place
                $('#uEnrolleesMapPlaybackPreviousButton').show();
                $('#uEnrolleesMapPlaybackPlayButton').show();
                $('#uEnrolleesMapPlaybackStopButton').show();
                $('#uEnrolleesMapPlaybackNextButton').show();
                break;
        }
        $('#uMapPlaybackStatus').html(localizeText('cEnrollee' + mEnrolleesData.PlaybackStatus));
    }
}

function enrolleesTrackpointDetailCardViewSort(aParams, aSort) {
    var lEnrolleesTrackPoints = mEnrolleesData.OffenderMerged,
        lEnrolleesTrackPointListSorted = [];

    lEnrolleesTrackPointListSorted = aSort.sort(lEnrolleesTrackPoints);
    mEnrolleesData.OffenderMerged = lEnrolleesTrackPointListSorted;
    mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.filter();
    if (!isNullOrUndefined(mEnrolleesControls.EnrolleesMap.getHeatMap())) {
        mEnrolleesControls.EnrolleesMap.disposeHeatMap();
        uShowHeatMapButton_OnClick();
    }
}

function enrolleesOffenderPlacesMarker_OnClick(aSender, aMouseEvent) {
    "use strict";
    veritracks.mapping.placesDetailGenerator(mEnrolleesControls.NotificationPanel, aSender);
}

function showStreetViewError(aSender, aErrorMessage) {
    alert(aErrorMessage);
}


function uOffenderMap_Init() {
    "use strict";
    // uTrackpointDetailCardViewFilter_OnFilter();
    var lUserPreferences = getUserPreferences(4),
        lSystemPreferences = getUserPreferences(10),
        lDisplayType = 'roadmap',
        lPermission = gUserPermissions[19],
        lParams,
        lBuilder,
        lFilterList = gMapFilterList,
        lUnavailableItems = ['61'],
        lColumns = [],
        lDoDisplayCellPoints = veritracks.system.clientSetting('MapDisplayCellCentroids'),
        lDefaultCriteria = ['1', '2', '3','4', '5', '9', '20', '8'],       
        lStartDateFilterEditable = veritracks.system.clientSetting('StartDateFilterEditable');

    if (isNullOrUndefined(lPermission) || lPermission.Value == 0) {
        lUnavailableItems.push(6);
    }
    if (!lDoDisplayCellPoints) {
        lUnavailableItems.push(9);
    }
    if (lUnavailableItems.length > 0) {
        lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('Id', lUnavailableItems, false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And());
        lFilterList = query(lFilterList, lBuilder.RootExpression);
    }
    if (gUserDetails.Role !== 2) {
        lFilterList.push({ 'Id': '20', 'Title': localizeText('cEnrolleeTrackpointEvents') });
    }

    lColumns = [

            { 'Id': 'Type', 'Title': localizeWrapper('cEnrolleeDisplay'), 'Type': 'CheckList', 'DataField': 'Type', 'DataSource': lFilterList, 'DataTextField': 'Title', 'DataValueField': 'Id', 'DefaultValue': lDefaultCriteria },
            {
                'Id': 'ZoneRadius', 'Title': localizeWrapper('cZoneZonesSmallerThan'), 'Type': 'Dropdown', 'DataField': 'ZoneRadius', 'DataSource': [
                      { 'Id': 250, 'Title': localizeWrapper('cZone250') },
                      { 'Id': 500, 'Title': localizeWrapper('cZone500') },
                      { 'Id': 750, 'Title': localizeWrapper('cZone750') },
                      { 'Id': 1000, 'Title': localizeWrapper('cZone1000') },
                      { 'Id': 1500, 'Title': localizeWrapper('cZone1500') },
                      { 'Id': 5280, 'Title': localizeWrapper('cZone5280') }
                ], 'DataTextField': 'Title', 'DataValueField': 'Id', 'relationalOperator': mRelationalOperatorEnum.LessThanOrEqual(), 'InsertBlank': true, 'DefaultValue': 500
            }
    ];

    //if (CheckUserHasPermission(61)) {
     //   lColumns.push({ 'Id': 'CorrelateDisplay', 'Title': 'Correlation', 'Type': 'CheckList', 'DataField': 'CorrelateDisplay', 'DataSource': [{ 'Id': '', 'Title': 'Correlation' }], 'DataTextField': 'Title', 'DataValueField': 'Id', 'DefaultValue': '' });
   // }

    lParams = {
        'Title': localizeWrapper('cEnrolleeFindMapObjects'),
        'Content': '',
        'CssClass': 'DefaultFilter',
        'Alignment': 'FilterLeftAlignment',
        'HideOnFilter': true,
        'OnFilter': veritracks.enrollees.mapping.filter,
        'Columns':lColumns,
        'Settings': null,
        'UserPreferences': lUserPreferences,
        'UserId': gUserDetails.UserId,
        'UserPreferenceType': 4
    };
    mEnrolleesControls.OffenderTrackpointDetailCardViewFilter = gFilterFactory.createControl('uTrackpointDetailCardViewFilter', 'uTrackpointDetailCardViewFilterHolder', lParams);
    if (!isNullOrUndefined(lSystemPreferences['MapDisplayType'])) {
        lDisplayType = lSystemPreferences['MapDisplayType'].Value;
    }
    function clickButton(lat){
        alert('yup!'+ lat.toString())
    }
    
    mEnrolleesControls.EnrolleesMap = new sumo.maps.GoogleMapControl('uOffenderMap', 'uMapPanel', { 'displayType': lDisplayType, 'mapTypeId_OnChange': mapDisplayType_OnChange, 'OnClick': veritracks.enrollees.mapping.onClick,
    'OnRightClick':veritracks.enrollees.mapping.onRightClick });
    var lPreSelectFirstCard = !IsAutoZoomEnabled();
    mEnrolleesControls.OffenderTrackpointDetailCardView = new sumo.controls.CardView('uTrackpointDetailCardView', 'uTrackpointDetailCardViewHolder', {
        'cardTemplate': 'Interface/Enrollees.Offenders.Map.Card.Template.htm', 'selectMethod': 'single', 'canUnselect': true, 'cssClass': 'VeritracksCardView', 'keyField': 'Id', 'isSortable': false, 'Columns': [
            { 'id': 'SortDate', 'title': localizeWrapper('cEnrolleeSortDate') },
            { 'id': 'EnrolleeFirstName', 'title': localizeWrapper('cEnrolleeFirstName') },
            { 'id': 'EnroleeLastName', 'title': localizeWrapper('cEnrolleeLastName') }
        ],
        'preSelectFirstCard':lPreSelectFirstCard,
        'IgnoreOnClick': ['StreetViewIcon', 'uEnrolleeCorrelateIcon', 'uEnrolleeCorrelateIconSelected', 'uEnrolleeCorrelateIconKnown', 'uEnrolleeCorrelateIconKnownSelected', 'EnrolleeEvents']
    });
    
    //Note to programmer: remove  uTrackpointDetailCardView_OnSelectChanging() if system continues to work.
    //mEnrolleesControls.OffenderTrackpointDetailCardView.bind('selectedchanging', uTrackpointDetailCardView_OnSelectChanging);
    mEnrolleesControls.OffenderTrackpointDetailCardView.bind('selectedchanged', uTrackpointDetailCardView_OnSelectChange);
    mEnrolleesControls.EnrolleesMap.bind('streetviewerror', showStreetViewError);
    //mEnrolleesControls.OffenderTrackpointDetailCardView.bind('sort', enrolleesTrackpointDetailCardViewSort);
    var lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': true,
        'isVisible': true,
        'clickEventHandler': veritracks.mapping.enrolleeMarkerClick,
        'rightClickEventHandler': veritracks.mapping.enrolleeMarkerRightClick,
        'hoverEventHandler': veritracks.mapping.enrolleeMarkerHover,
        'hoverOutEventHandler': veritracks.mapping.enrolleeMarkerHoverOut,
        'zIndexStart': 90000
    },
    lIsCaseLoadVisible = false,
    lUserPreferences = getUserPreferences(4);
    if (!isNullOrUndefined(lUserPreferences['IsCaseLoadVisible'])) {
        lIsCaseLoadVisible = (lUserPreferences['IsCaseLoadVisible'].Value === 'true');
    }
    mEnrolleesControls.EnrolleesMap.layerAdd('Visits', lLayerOptions);
    //temp ct layer for heatmaps
    mEnrolleesControls.EnrolleesMap.layerAdd('TempHeatCT', lLayerOptions);

    var lLayerOptions = {
            'renderType': 'marker',
            'doesPlayback': true,
            'isVisible': true,
            'clickEventHandler': veritracks.mapping.enrolleeMarkerClick,
            'zIndexStart': 90000
        },
        lIsCaseLoadVisible = false,
        lUserPreferences = getUserPreferences(4);
    if (!isNullOrUndefined(lUserPreferences['IsCaseLoadVisible'])) {
        lIsCaseLoadVisible = (lUserPreferences['IsCaseLoadVisible'].Value === 'true');
    }
    mEnrolleesControls.EnrolleesMap.layerAdd('SecondaryVisits', lLayerOptions);

    lLayerOptions = {
        'renderType': 'label',
        'doesPlayback': true,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 85000
    };
    mEnrolleesControls.EnrolleesMap.layerAdd('Labels', lLayerOptions);

    lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'zIndexStart': 120000,
        'dragEndEventHandler': function (aEvent, aMarker) {
            var lLatLong = { 'Latitude': aMarker.latLng.lat(), 'Longitude': aMarker.latLng.lng() };
            populateEditView(lLatLong, [], {}, 'uMapTag', 'Edit');
        }
    };
    mEnrolleesControls.EnrolleesMap.layerAdd('TagEdit', lLayerOptions);

    lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': veritracks.mapping.enrolleeMarkerClick,
        'zIndexStart': 60000
    };
    mEnrolleesControls.EnrolleesMap.layerAdd('Addresses', lLayerOptions);

    lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 80000
    };
    mEnrolleesControls.EnrolleesMap.layerAdd('Tags', lLayerOptions);

    mEnrolleesControls.EnrolleesMap.layerAdd('TagLabels', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 700000
    });
    mEnrolleesControls.EnrolleesMap.layerAdd('LargeZones', {
        'renderType': 'geometry',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': ignoreme,
        'zIndexStart': 1000000,
        'shapeChangeHandler': offenderZoneMapShape_OnChange
    });
    
    PoiDataHelper.initLayersOnMap(mEnrolleesControls.EnrolleesMap);
    
    

    mEnrolleesControls.EnrolleesMap.layerAdd('Zones', {
        'renderType': 'geometry',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': ignoreme,
        'zIndexStart': 1000000,
        'shapeChangeHandler': offenderZoneMapShape_OnChange
    });
    
    mEnrolleesControls.EnrolleesMap.layerAdd('ZonesNames', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1300000
    });

    mEnrolleesControls.EnrolleesMap.layerAdd('Selected', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1200000
    });

    mEnrolleesControls.EnrolleesMap.layerAdd('SuggestionLabels', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1300000
    });

    mEnrolleesControls.EnrolleesMap.layerAdd('Suggestions', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1400000
    });

    mEnrolleesControls.EnrolleesMap.layerAdd('CaseLoadLabels', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': lIsCaseLoadVisible,
        'clickEventHandler': null,
        'zIndexStart': 1500000
    });

    mEnrolleesControls.EnrolleesMap.layerAdd('CaseLoad', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': lIsCaseLoadVisible,
        'clickEventHandler': null,
        'zIndexStart': 1600000
    });

    mEnrolleesControls.EnrolleesMap.layerAdd('DeviceLastContactLabels', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1500000
    });

    mEnrolleesControls.EnrolleesMap.layerAdd('DeviceLastContact', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1600000
    });

    lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': enrolleesOffenderPlacesMarker_OnClick,
        'zIndexStart': 60000,
        'markerImageSize': { 'width': 32, 'height': 32 }
    };


    mEnrolleesControls.EnrolleesMap.layerAdd('Places', lLayerOptions);

    mEnrolleesControls.EnrolleesMap.layerAdd('DistancePoints', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1300000,
        'markerImageSize': { 'width': 32, 'height': 32 }
    });

    mEnrolleesControls.EnrolleesMap.layerAdd('DistanceLabels', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 2000000
    });

    mEnrolleesControls.EnrolleesMap.layerAdd('ConnectedDistancePoints', {
        'renderType': 'linesegment',
        'doesPlayback': true,
        'isVisible': true,
        'isClickable': false,
        'clickEventHandler': null,
        'zIndexStart': 700000
    });

    lLayerOptions = {
        'renderType': 'linesegment',
        'doesPlayback': true,
        'isVisible': true,
        'isClickable': false,
        'clickEventHandler': null,
        'zIndexStart': 10000
    };
    mEnrolleesControls.EnrolleesMap.layerAdd('ConnectedTracks', lLayerOptions);

    lLayerOptions = {
        'renderType': 'linesegment',
        'doesPlayback': true,
        'isVisible': true,
        'isClickable': false,
        'clickEventHandler': null,
        'zIndexStart': 10000,
        'lineSegmentColor': 'purple'
    };
    mEnrolleesControls.EnrolleesMap.layerAdd('SecondaryConnectedTracks', lLayerOptions);

    //alchocol test layer
    mEnrolleesControls.EnrolleesMap.layerAdd('AlchoholTestPoints', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': enrolleesMapAlcoholMarker_OnClick,
        'zIndexStart': 1300000,
        'markerImageSize': { 'width': 32, 'height': 32 }
    });
    
    mEnrolleesControls.PlaybackControl = mEnrolleesControls.EnrolleesMap.getPlaybackController('Visits', {
        'speedControls': {
            'keyProperty': 'TrackTypeId',
            'values': [
            {
                'value': 1,
                'speedMultiplier': 1
            }, {
                'value': 2,
                'speedMultiplier': 1
            }, {
                'value': 3,
                'speedMultiplier': 1
            }, {
                'value': 'undefined',
                'speedMultiplier': 4
            }]
        },
        'bookmarks': {
            'dateRange': offenderMapPopulate_GetDateRange,
            'autoPause':true,
        }
    });

    mEnrolleesControls.PlaybackControl.bind('statechange', enrolleePlaybackControl_OnSelectChange);
    //mEnrolleesControls.PlaybackControl = mEnrolleesControls.EnrolleesMap.getPlaybackController('SecondaryVisits');
    $('#uSlider').slider({ 'min': 0, 'max': 99, 'slide': slider_OnSlide,start:slide_OnStart,stop:slider_OnStop });
    mEnrolleesControls.PlaybackControl.bind('progressed', uEnrolleesMapPlayback_OnProgressed);
    mEnrolleesControls.PlaybackControl.bind('bookmark_viewed', uEnrolleesMapPlayback_OnBookmarkViewed);
    mEnrolleesControls.PlaybackControl.bind('completed', uEnrolleesMapPlayback_OnCompleted);


    if (lStartDateFilterEditable) {
        populateDateView('#uMapStartDatePicker', enrolleesOffendersMapStartDateTime_OnChange);
        $('#uMapStartTimePicker').ptTimeSelect({
            'zIndex': 100000,
            'onFocusDisplay': true,
            'onClose': enrolleesOffendersMapStartDateTime_OnChange
        });
        $('.MapStartDateFilter').show();
        $('.MapEndDateFilter').hide();
    } else {
        $('.MapStartDateFilter').hide();
        $('.MapEndDateFilter').show();
    }

    populateDateView('#uMapDatePicker', enrolleesOffendersMapDateTime_OnChange);
    $('#uMapTimePicker').ptTimeSelect({
        'zIndex': 100000,
        'onFocusDisplay': true,
        'onClose': enrolleesOffendersMapDateTime_OnChange
    });

    uEnrolleeVisitExpandedPreference();
}

function enrolleesMapAlcoholMarker_OnClick() {
    "use strict";
}

function offendersMapDropdowns_Init() {
    "use strict";
    var lDropdown = null;

    lDropdown = new sumo.controls.Dropdown('uLegendDropdown', 'uLegendHolder', {
        'title': 'Legend',
        'viewportType': 'inline',
        'contentType': 'jQueryElement',
        'isOpen': false,
        'cssClass': 'Events',
        'content': $('#uMapLegendContent')
    });
    mEnrolleesControls.LegendDropdown = lDropdown;

    lDropdown = new sumo.controls.Dropdown('uDetailsDropdown', 'uDetailsHolder', {
        'title': 'Enrollee Details',
        'viewportType': 'inline',
        'contentType': 'jQueryElement',
        'isOpen': true,
        'cssClass': 'Events',
        'content': $('#uMapDetailsContent')
    });
    mEnrolleesControls.DetailsDropdown = lDropdown;

    lDropdown = new sumo.controls.Dropdown('uLocateDropdown', 'uLocateHolder', {
        'title': 'Locate',
        'viewportType': 'inline',
        'contentType': 'jQueryElement',
        'isOpen': false,
        'cssClass': 'Events',
        'content': $('#uMapLocateContent')
    });
    mEnrolleesControls.LocateDropdown = lDropdown;

    lDropdown = new sumo.controls.Dropdown('uNotesDropdown', 'uNotesHolder', {
        'title': 'Notes',
        'viewportType': 'inline',
        'contentType': 'jQueryElement',
        'isOpen': false,
        'cssClass': 'Events',
        'content': $('#uMapNotesContent')
    });
    mEnrolleesControls.NotesDropdown = lDropdown;

    lDropdown = new sumo.controls.Dropdown('uSettingsDropdown', 'uSettingsHolder', {
        'title': 'Settings',
        'viewportType': 'inline',
        'contentType': 'jQueryElement',
        'isOpen': true,
        'cssClass': 'Events',
        'content': $('#uMapSettingsContent')
    });
    mEnrolleesControls.SettingsDropdown = lDropdown;
}

function enrolleesPlaces_OnComplete(aSender, aPlaceList) {
    "use strict";
    var lLength = aPlaceList.length,
        lPlace,
        lType;


    mEnrolleesControls.EnrolleesMap.clearStreetView();

    mEnrolleesControls.NotificationPanel.clearNotifications();
    if (lLength > 0) {
        lPlace = aPlaceList[0];
        lType = lPlace.types[0];
    }

    if (lLength === 1 && !isNullOrUndefined(lPlace) && (lType === 'street_address' || lType === 'locality')) {
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Places', veritracks.mapping.preparePlacesData(aPlaceList));
        mEnrolleesControls.EnrolleesMap.setCenter(lPlace.geometry.location.lat(), lPlace.geometry.location.lng());
        mEnrolleesControls.EnrolleesMap.zoom(17);
    }else if (lLength >= 1){
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Places', veritracks.mapping.preparePlacesData(aPlaceList));
        mEnrolleesControls.EnrolleesMap.setCenter(lPlace.geometry.location.lat(), lPlace.geometry.location.lng());
        mEnrolleesControls.EnrolleesMap.zoom(14);
    } else {
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Places', veritracks.mapping.preparePlacesData(aPlaceList));
    }
}

function offenderMapPopulate_MoveEndDate(aDirection) {
    "use strict";
    var lHours = 24,
        uEnrolleeMapTimeFilter = $('#uEnrolleeMapTimeFilter'),
        lDateRange = offenderMapPopulate_GetDateRange(),
        lNow = new Date();

    if (uEnrolleeMapTimeFilter.length > 0) {
        lHours = parseInt(uEnrolleeMapTimeFilter.val());
    }

    mEnrolleesData.MapEndDate.addMinutes(aDirection * lHours);
}

function uMapBackButton_OnClick() {
    "use strict";
    if (!$('#uMapBackButton').hasClass('Disabled')) {
        offenderMapPopulate_MoveEndDate(-1);
        veritracks.enrollees.mapping.initializeEnrolleeMap();
    }
}

function uMapForwardButton_OnClick() {
    "use strict";
    offenderMapPopulate_MoveEndDate(1);
    veritracks.enrollees.mapping.initializeEnrolleeMap();
}

function uEnrolleeMapTimeFilter_Onchange() {
    "use strict";
    var lPreference = new UserPreference(),
         lStartDateFilterEditable = veritracks.system.clientSetting('StartDateFilterEditable');
    lPreference.ColumnName = 'MapTimeSpan';
    lPreference.Id = gUserDetails.UserId;
    lPreference.UserPreferenceType = 4;
    lPreference.Value = $('#uEnrolleeMapTimeFilter').val();

    writeUserPreferences([lPreference]);
    veritracks.enrollees.mapping.data.VisitCardList = [];
    veritracks.enrollees.mapping.data.VisitsProcesssed = false;

    if (lStartDateFilterEditable) {
        var lTimeFilter = parseInt($('#uEnrolleeMapTimeFilter').val()),
            lStartDate = $('#uMapStartDatePicker').val(),
            lStarTime = $('#uMapStartTimePicker').val(),
            lValue = lStartDate + ' ' + lStarTime,
            lDate = new Date(lValue);

        mEnrolleesData.MapEndDate = lDate.addMinutes(lTimeFilter);
    }
    veritracks.enrollees.mapping.initializeEnrolleeMap();


}

function uMapLockButton_OnClick() {
    "use strict";
 
    veritracks.enrollees.mapping.mapLockClick();   
    
}

function toggleMapDetailVisibility() {
    "use strict";

    var uMapDetailToggle = document.getElementById('uMapDetailToggle');
    if (uMapDetailToggle.src.indexOf("Right") > -1) {
        uMapDetailToggle.src = "Images/LeftDark.png";
        $('#uMapDetailPanelCell').hide("fast");
    } else {
        uMapDetailToggle.src = "Images/RightDark.png";
        $('#uMapDetailPanelCell').show("fast");
    }
}

function uOffendersMapSettingsListView_OnSelectedChanged(aSender, aSelectedIds) {
    "use strict";

    //    var lPreviousSettings = mEnrolleesData.MapSettings,
    //        lNewSettings = [],
    //        i;
    if (mEnrolleesData.PlaybackStatus !== 'Stopped') {
        uEnrolleesMapPlaybackStopButton_OnClick();
    }

    if (aSelectedIds.indexOf(1) >= 0) {
        mEnrolleesControls.EnrolleesMap.layerShow('Zones');
    } else if (aSelectedIds.indexOf(1) === -1) {
        mEnrolleesControls.EnrolleesMap.layerHide('Zones');
    }
    if (aSelectedIds.indexOf(3) >= 0) {
        mEnrolleesControls.EnrolleesMap.layerShow('Addresses');
    } else if (aSelectedIds.indexOf(3) === -1) {
        mEnrolleesControls.EnrolleesMap.layerHide('Addresses');
    }
    if (aSelectedIds.indexOf(100) >= 0) {
        mEnrolleesControls.EnrolleesMap.layerShow('Visits');
        if (aSelectedIds.indexOf(5) >= 0) {
            mEnrolleesControls.EnrolleesMap.layerShow('VisitLabels');
        } else if (aSelectedIds.indexOf(5) === -1) {
            mEnrolleesControls.EnrolleesMap.layerHide('VisitLabels');
        }
    } else if (aSelectedIds.indexOf(100) === -1) {
        mEnrolleesControls.EnrolleesMap.layerHide('Visits');
        mEnrolleesControls.EnrolleesMap.layerHide('VisitLabels');
    }
    if (aSelectedIds.indexOf(200) >= 0) {
        mEnrolleesControls.EnrolleesMap.layerShow('Trips');
        if (aSelectedIds.indexOf(5) >= 0) {
            mEnrolleesControls.EnrolleesMap.layerShow('TripLabels');
        } else if (aSelectedIds.indexOf(5) === -1) {
            mEnrolleesControls.EnrolleesMap.layerHide('TripLabels');
        }
    } else if (aSelectedIds.indexOf(200) === -1) {
        mEnrolleesControls.EnrolleesMap.layerHide('Trips');
        mEnrolleesControls.EnrolleesMap.layerHide('TripLabels');
    }

    //    if (aSelectedIds.indexOf(4) >= 0) {
    //        mEnrolleesControls.EnrolleesMap.layerShow('ConnectedTracks');
    //    } else if (aSelectedIds.indexOf(4) === -1) {
    //        mEnrolleesControls.EnrolleesMap.layerHide('ConnectedTracks');
    //    }

    //    if (aSelectedIds.indexOf(7) >= 0) {
    //        //alert('7 added');
    //    } else if (aSelectedIds.indexOf(7) === -1) {
    //        //alert('7 removed');
    //    }
    //    if (aSelectedIds.indexOf(8) >= 0) {
    //        //alert('8 added');
    //    } else if (aSelectedIds.indexOf(8) === -1) {
    //        //alert('8 removed');
    //    }

    //    for (i = 0; i < aSelectedIds.length; i++) {
    //        lNewSettings.push(aSelectedIds[i]);
    //    }
    //    mEnrolleesData.MapSettings = lNewSettings;
}

function uOffendersMapSettingsListView_Init() {
    "use strict";

    if (isNullOrUndefined(mEnrolleesControls.MapSettingsListView)) {
        var lColumns = [
            { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'formatMethod': selectionColumnFormatter },
            { 'id': 'Description', 'title': localizeWrapper('cEnrolleeDescription'), 'dataField': 'Description', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'formatMethod': null }
        ],
        i,
        lSetting,
        lSettings = [];

        lSettings.push({ 'Id': 100, 'Description': 'Show Visits' });
        lSettings.push({ 'Id': 200, 'Description': 'Show Trackpoints' });
        for (i = 0; i < gMapSettings.length; i++) {
            lSetting = gMapSettings[i];
            if (lSetting.Id !== 8 && lSetting.Id !== 7 && lSetting.Id !== 6 && lSetting.Id !== 4 && lSetting.Id !== 2) {
                lSettings.push(lSetting);
            }
        }

        //mEnrolleesData.MapSettings = [];
        mEnrolleesControls.MapSettingsListView = new sumo.controls.ListView(
            'uMapSettingsListView',
            'uMapSettingsContent',
            { 'keyField': 'Id', 'selectMethod': 'auto', 'cssClass': 'VeritracksSelectListView', 'canUnselect': true, 'showHeader': false },
            lColumns);
        mEnrolleesControls.MapSettingsListView.setDataSource(lSettings);
        mEnrolleesControls.MapSettingsListView.bind('selectedchanged', uOffendersMapSettingsListView_OnSelectedChanged, null);
        //        ({ 'Id': 1, 'Description': 'Show Zones' });
        //        ({ 'Id': 2, 'Description': 'Lock StartDate' });
        //        ({ 'Id': 3, 'Description': 'Show Enrollee Addresses' });
        //        ({ 'Id': 4, 'Description': 'Show Connected Tracks' });
        //        ({ 'Id': 5, 'Description': 'Show Numbered Labels' });
        //        ({ 'Id': 6, 'Description': 'Show Events' });
        //        ({ 'Id': 7, 'Description': 'Show GPS Trackpoints' });
        //        ({ 'Id': 8, 'Description': 'Show Cell Tower Trackpoints' });
        //mEnrolleesControls.MapSettingsListView.selected([1, 3, 100]);
    }
}
function uEnrolleesFilterOrganization_OnChange(aSender, aData, aParams) {
    "use strict";
    var lOrganizationId = aData.currentTarget.value,
        lRiskLevels = RiskLevelFormatter(),
        lBuilder = new SumoPredicateBuilder(),
        lRiskLevel,
        lRiskLevelList = [],
        lItems = [],
        lKey;

    for (lKey in lRiskLevels) {
        if (lRiskLevels.hasOwnProperty(lKey)) {
            lRiskLevel = lRiskLevels[lKey];
            lItems[lRiskLevel.Id] = lRiskLevel;
        }
    }
    if (lOrganizationId !== '') {
        lBuilder.AddNewExpressionConditional('OrganizationId', lOrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lRiskLevels = query(lRiskLevels, lBuilder.RootExpression);
    } else {
        lRiskLevels = lItems;
    }
    mEnrolleesControls.CardViewOffenderFilter.setColumnDataSource('RiskLevelId', lRiskLevels);
}

function riskLevelsFilter_DataListConverter() {
    "use strict";
    var lRiskLevels = RiskLevelFormatter(),
        lRiskLevel,
        lItems = [],
        lKey;


    for (lKey in lRiskLevels) {
        if (lRiskLevels.hasOwnProperty(lKey)) {
            lRiskLevel = lRiskLevels[lKey];
            lItems[lRiskLevel.Id] = lRiskLevel;
        }
    }
    return lItems;
}

function uOffendersCardViewFilter_Init() {
    "use strict";
    if (isNullOrUndefined(mEnrolleesControls.CardViewOffenderFilter)) {
        var lRiskLevels = riskLevelsFilter_DataListConverter(),
            lEyeColor,
            lHairColor,
            lFeetList = [],
            lInchesList = [],
            lCentimetersList = [],
            lColor = getDataItems('Color'),
            lBuilder = new SumoPredicateBuilder(),
            lUserPreferences = getUserPreferences(1),
            lParams,
            lRiskLevelList = [],
            lSort = new SortExpression(),
            lOrganization = getDataItems('Organizations'),
            lDashboardViewState = getViewState('DandEFilterViewState'),
            lColumns = [],
            lTitle = 'cEnrolleeSearch',
            lKey,
            lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric')),
            lEidAllowed = false,
            lGender;

        lBuilder.AddNewExpressionConditional('Id', 3, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
        lGender = query(getDataItems('Gender'), lBuilder.RootExpression);
        lBuilder.Clear();

        lBuilder.AddNewExpressionConditional('ColorType', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lHairColor = query(lColor, lBuilder.RootExpression);
        lBuilder.Clear();

        lBuilder.AddNewExpressionConditional('ColorType', 2, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lEyeColor = query(lColor, lBuilder.RootExpression);
        lBuilder.Clear();


        lBuilder.AddNewExpressionConditional('EidTypeId', 0, false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());
        var lRiskLevelEid = query(getDataItems('RiskLevels'), lBuilder.RootExpression);
        lBuilder.Clear();

        if (Object.values(lRiskLevelEid).length > 0) {
            lEidAllowed = true
        }


        for (lKey = 0; lKey <= 8; lKey++) {
            lFeetList.push({ 'Id': lKey });
        }
        for (lKey = 0; lKey <= 11; lKey++) {
            lInchesList.push({ 'Id': lKey });
        }
        for (lKey = 0; lKey <= 275; lKey++) {
            lCentimetersList.push({ 'Id': lKey });
        }

        lSort.addAscendingColumn('Name');
        lOrganization = lSort.sort(lOrganization);

        lColumns.push({ 'Id': 'FullName', 'Title': localizeWrapper('cEnrolleeName'), 'Type': 'Text', 'DataField': 'FullName' },
                    { 'Id': 'PrimaryID', 'Title': localizeWrapper('cEnrolleePrimaryId'), 'Type': 'Text', 'DataField': 'PrimaryId' });


        if (gUserDetails.Role !== 2) {
            lColumns.push({ 'Id': 'SecondaryID', 'Title': localizeWrapper('cEnrolleeSecondaryId'), 'Type': 'Text', 'DataField': 'SecondaryId' },
            { 'Id': 'AgentName', 'Title': localizeWrapper('cAgent'), 'Type': 'Text', 'DataField': 'AgentName' },
            { 'Id': 'RiskLevelId', 'Title': localizeWrapper('cEnrolleeRiskLevel'), 'Type': 'Dropdown', 'DataField': 'RiskLevelId', 'DataSource': lRiskLevels, 'DataValueField': 'Id', 'DataTextField': 'Name', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
            { 'Id': 'OrganizationId', 'Title': localizeWrapper('cEnrolleeOrganization'), 'Type': 'Dropdown', 'DataField': 'OrganizationId', 'DataSource': OrganizationSortFormatter(), 'DataValueField': 'Id', 'DataTextField': 'Name', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
            { 'Id': 'IsMyCaseload', 'Title': localizeWrapper('cEnrolleeMyCaseload'), 'Type': 'Dropdown', 'DataField': 'IsMyCaseload', 'DataSource': [{ 'Value': true, 'Text': localizeText('cYes') }, { 'Value': false, 'Text': localizeText('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': true, 'ComparisonType': 'Boolean', 'InsertBlank': true, 'BlankText': localizeText('cBoth') },
            { 'Id': 'HasOpenEvents', 'Title': localizeWrapper('cEnrolleeOpenEvents'), 'Type': 'Dropdown', 'DataField': 'HasOpenEvents', 'DataSource': [{ 'Value': true, 'Text': localizeText('cYes') }, { 'Value': false, 'Text': localizeText('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'ComparisonType': 'Boolean', 'InsertBlank': true, 'BlankText': localizeText('cBoth') });
        }
        else {
            lTitle = 'cEnrolleeAdvanceSearch';
        }
        
        lColumns.push(
            { 'Id': 'IsEnrollink', 'Title': localizeWrapper('cEnrolleeIsEnrollink'), 'Type': 'Dropdown', 'DataField': 'IsEnrollink', 'DataSource': [{ 'Value': 1, 'Text': localizeText('cYes') }, { 'Value': 0, 'Text': localizeText('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': true, 'ComparisonType': 'Number', 'InsertBlank': true, 'BlankText': localizeText('cBoth') },
            //{ 'Id': 'HasAssociationFlag', 'Title': localizeWrapper('cEnrolleeHasAssociation'), 'Type': 'Dropdown', 'DataField': 'HasAssociationFlag', 'DataSource': [{ 'Value': true, 'Text': localizeText('cYes') }, { 'Value': false, 'Text': localizeText('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'ComparisonType': 'Boolean', 'InsertBlank': true, 'BlankText': localizeText('cBoth') },
            { 'Id': 'IsAssigned', 'Title': localizeWrapper('cEnrolleeIsAssigned'), 'Type': 'Dropdown', 'DataField': 'IsAssigned', 'DataSource': [{ 'Value': true, 'Text': localizeText('cYes') }, { 'Value': false, 'Text': localizeText('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': true, 'ComparisonType': 'Boolean', 'InsertBlank': true, 'BlankText': localizeText('cBoth') },
            { 'Id': 'DeviceTrackType', 'Title': localizeWrapper('cEnrolleeDeviceType'), 'Type': 'Dropdown', 'DataField': 'DeviceTrackType', 'DataSource': [{ 'Value': 2, 'Text': localizeText('cEnrolleeGPS') }, { 'Value': 1, 'Text': localizeText('cEnrolleeRF') }, { 'Value': 3, 'Text': localizeText('cEnrolleeST') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'ComparisonType': 'Number', 'InsertBlank': true, 'BlankText': localizeText('cAll') });

        if (lEidAllowed) {
            lColumns.push({ 'Id': 'IsEid', 'Title': localizeWrapper('cEnrolleeEidMonitoring'), 'Type': 'Dropdown', 'DataField': 'IsEid', 'DataSource': [{ 'Value': true, 'Text': localizeText('cYes') }, { 'Value': false, 'Text': localizeText('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': '', 'ComparisonType': 'Boolean', 'InsertBlank': true, 'BlankText': localizeText('cBoth') });
        }

        lColumns.push({ 'Id': 'Weight', 'Title': localizeWrapper('cEnrolleeWeight'), 'Type': 'Text', 'DataField': 'Weight' });
        if(lDoMetric){
            lColumns.push({ 'Id': 'Height', 'Title': localizeWrapper('cEnrolleeHeightCm'), 'Type': 'Dropdown', 'DataSource': lCentimetersList, 'ComparisonType': 'Number', 'ActualType': 'MeasurementMetric', 'IgnoreValue': 0, 'DataField': 'Height', 'DataValueField': 'Id', 'DataTextField': 'Id' });
        }
        else{
            lColumns.push({ 'Id': 'Height', 'Title': localizeWrapper('cEnrolleeHeight'), 'Type': 'DoubleDropDown', 'DataSource': lFeetList,'DataSource2': lInchesList, 'ComparisonType': 'Number', 'ActualType': 'MeasurementUSA','DataField': 'Height', 'DataValueField': 'Id', 'DataTextField': 'Id' });
        }

        lColumns.push({ 'Id': 'GenderId', 'Title': localizeWrapper('cEnrolleeGender'), 'Type': 'Dropdown', 'DataSource': lGender,'LocaleName': 'Gender', 'DataField': 'GenderId', 'DataValueField': 'Id', 'DataTextField': 'Description', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
        { 'Id': 'RaceId', 'Title': localizeWrapper('cEnrolleeRace'), 'Type': 'Dropdown', 'DataSource': getDataItems('Race'),'LocaleName': 'Race', 'DataField': 'RaceId', 'DataValueField': 'Id', 'DataTextField': 'Description', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
        { 'Id': 'HairColorId', 'Title': localizeWrapper('cEnrolleeHairColor'), 'Type': 'Dropdown', 'DataSource': lHairColor,'LocaleName': 'Color', 'DataField': 'HairColorId', 'DataValueField': 'Id', 'DataTextField': 'Description', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
        { 'Id': 'EyeColorId', 'Title': localizeWrapper('cEnrolleeEyeColor'), 'Type': 'Dropdown', 'DataSource': lEyeColor,'LocaleName': 'Color',  'DataField': 'EyeColorId', 'DataValueField': 'Id', 'DataTextField': 'Description', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
        { 'Id': 'MarksTattoos', 'Title': localizeWrapper('cEnrolleeMarksAndTattoos'), 'Type': 'Text', 'DataField': 'MarksTattoos' },
        { 'Id': 'VehicleYear', 'Title': localizeWrapper('cEnrolleeVehicleYear'), 'Type': 'Text', 'DataField': 'VehicleYear', 'ComparisonType': 'Number' },
        { 'Id': 'VehiclePlateNumber', 'Title': localizeWrapper('cEnrolleeLicencePlateNumber'), 'Type': 'Text', 'DataField': 'VehiclePlateNumber' },
        { 'Id': 'VehicleColor', 'Title': localizeWrapper('cEnrolleeVehicleColor'), 'Type': 'Dropdown', 'DataSource': VehicleColorSortFormatter(), 'LocaleName': 'VehicleColor', 'DataField': 'VehicleColor', 'DataValueField': 'Description', 'DataTextField': 'Description', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
        { 'Id': 'VehicleMake', 'Title': localizeWrapper('cEnrolleeVehicle'), 'Type': 'Dropdown', 'DataSource': VehicleMakeSortFormatter(), 'DataField': 'VehicleMake', 'DataValueField': 'DescriptionValue', 'DataTextField': 'Description', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
        { 'Id': 'VehicleModel', 'Title': localizeWrapper('cEnrolleeVehicleModel'), 'Type': 'Text', 'DataField': 'VehicleModel' }

);


        lParams = {
            'Title': localizeWrapper(lTitle),
            'Content': '',
            'CssClass': 'DefaultFilter',
            'HideOnFilter': true,
            'OnFilter': uOffendersCardViewFilter_OnFilter,
            'Columns': lColumns,
            'Settings': null,
            'UserPreferences': lUserPreferences,
            'UserId': gUserDetails.UserId,
            'UserPreferenceType': 1,
            'CallbackClick': uOffendersCardviewCallback_Click,
            'LocalizableMethod': localizeDataItem
        };

        mEnrolleesControls.CardViewOffenderFilter = gFilterFactory.createControl('uOffendersCardViewFilter', 'uEnrolleesListFilterHolder', lParams);
    } else {
        mEnrolleesControls.CardViewOffenderFilter.render();
    }

    mEnrolleesControls.CardViewOffenderFilter.bind('OrganizationIdchanged', uEnrolleesFilterOrganization_OnChange);
}
function uEnrolleesTabPreCleaner() {
    uOffendersCardviewCallback_Click();
}
function uOffendersCardviewCallback_Click() {
    mEnrolleesData.TargetId = -1;
}

function enrolleesFilterController() {
    "use strict";
    var lHeight = $(window).height();

    //support for smaller screens
    if ($(window).height() <= 850) {
        $('#uOffendersCardViewFilterContent').addClass('enrolleeSearchSmallScreenSupport');
        $('#uEnrolleesEventsListViewFilterContent').addClass('eventSearchSmallScreenSupport');
    }
    else {
        $('#uOffendersCardViewFilterContent').removeClass('enrolleeSearchSmallScreenSupport');
        $('#uEnrolleesEventsListViewFilterContent').removeClass('eventSearchSmallScreenSupport');
    }
}
function uOffendersCardViewPaginator_Init() {
    "use strict";

    var lEnrolleeState = getViewState('EnrolleesSelectedEnrollee'),
        lPageState = getViewState('EnrolleesSelectedPage'),
        lSortState = getViewState('EnrolleesCardViewSort'),
        lSortExpression;
    if (isNullOrUndefined(mEnrolleesControls.CardViewOffenderPaginator)) {
        mEnrolleesControls.CardViewOffenderPaginator = new sumo.controls.Paginator('uOffendersCardViewPaginator', 'uEnrolleesPagerHolder', {
            'ItemCount': count(mEnrolleesData.OffenderDirty),
            'ItemsPerPage': gPaginationSettings.EnrolleesOffendersItems
        });


        //mEnrolleesControls.CardViewOffenderPaginator = gPaginatorFactory.createControl('uOffendersCardViewPaginator', 'uEnrolleesPagerHolder', {
        //'ItemCount': count(mEnrolleesData.OffenderDirty),
        //'ItemsPerPage': 500000
        //});
        if (!isNullOrUndefined(lEnrolleeState) && !isNullOrUndefined(lPageState)) {
            mEnrolleesControls.CardViewOffenderPaginator.setPage(lPageState.Value);
        }

        mEnrolleesControls.CardViewOffenderPaginator.bind('pagechanged', uOffendersPaginator_OnPageChanged);
    } else {
        mEnrolleesControls.CardViewOffenderPaginator.render();
    }
    mEnrolleesControls.CardViewOffenderFilter.filter();
}
function uEnrolleesEventsPaginator_OnPageChanged(aSender, aNewPage, aData) {
    "use strict";
    if (!isNullOrUndefined(mEnrolleesData.OffenderEventsSorted)) {
        mEnrolleesData.EventsPaginated = aSender.paginate(mEnrolleesData.OffenderEventsSorted);
        mEnrolleesControls.EventsListView.setDataSource(mEnrolleesData.EventsPaginated);
        // mEnrolleesControls.CardView.dataBind();
    }
    //setViewState('EnrolleesSelectedPage', aNewPage);
}

function uOffendersEventsPaginator_Init() {
    "use strict";
    if (isNullOrUndefined(mEnrolleesControls.EventsListViewPaginator)) {
        mEnrolleesControls.EventsListViewPaginator = new sumo.controls.Paginator('uEnrolleesEventsListViewPaginator', 'uEnrolleesEventsListViewPaginatorHolder', {
            'ItemCount': count(mEnrolleesData.OffenderEventsSorted),
            'ItemsPerPage': gPaginationSettings.EventsListItems
        });
        // if (!isNullOrUndefined(lEventState) && !isNullOrUndefined(lPageState)) {
        //  mEnrolleesControls.EventsListViewPaginator.setPage(lPageState.Value);
        //  }
        mEnrolleesControls.EventsListViewPaginator.bind('pagechanged', uEnrolleesEventsPaginator_OnPageChanged);
    } else {
        mEnrolleesControls.EventsListViewPaginator.render();
    }
    // mEnrolleesControls.EventsListViewFilter.filter();
}

function uEnrolleesSchedulesPaginator_OnPageChanged(aSender, aNewPage, aData) {
    "use strict";
    var lDatesFilter,
        lEnrollee = mEnrolleesControls.CardView.selectedDataItem(),
        lPaginatedSchedulesList = [];

    lEnrollee = lEnrollee.Enrollee;
    if (!isNullOrUndefined(mEnrolleesData.EnrolleesSchedulesSorted)) {
        lDatesFilter = aSender.DatesFilter();

        var momentDateFrom = moment(lDatesFilter.FirstDay);
        var momentDateTo = moment(lDatesFilter.LastDay);

        // custom pagination for dates maybe later move to paginator.js
        for (var lKey in mEnrolleesData.EnrolleesSchedulesSorted) {
            if (mEnrolleesData.EnrolleesSchedulesSorted.hasOwnProperty(lKey)) {
                var lSchedule = mEnrolleesData.EnrolleesSchedulesSorted[lKey];
                var lScheduleMoment = moment(moment(lSchedule.StartTime).format('L'));

                if (!displayOldScheduleUILoggedInOri(mEnrolleesData.OffenderCurrentId) && displayDSTSchedules()) {
                    lScheduleMoment = moment(moment(lSchedule.StartTimeLocal).format('L'));
                }

                if (!lSchedule.IsReocurring && lScheduleMoment >= momentDateFrom && lScheduleMoment <= momentDateTo) {
                    lPaginatedSchedulesList.push(lSchedule);
                }
                if (lSchedule.IsReocurring) {
                    lPaginatedSchedulesList.push(lSchedule);
                }
            }
        }
        mEnrolleesData.SchedulesPaginated = aSender.paginate(lPaginatedSchedulesList);
        mEnrolleesControls.SchedulesListView.setDataSource(mEnrolleesData.SchedulesPaginated);
    }
}

function uEnrolleesSchedulesPaginator_Init() {
    "use strict";
    if (isNullOrUndefined(mEnrolleesControls.SchedulesListViewPaginator)) {
        mEnrolleesControls.SchedulesListViewPaginator = new sumo.controls.Paginator('uEnrolleesSchedulesListViewPaginator', 'uEnrolleesSchedulesListViewPaginatorHolder', {
            'ItemCount': count(mEnrolleesData.EnrolleesSchedulesSorted),
            'ItemsPerPage': 100,
            'DateSystem': true
        });
        mEnrolleesControls.SchedulesListViewPaginator.bind('pagechanged', uEnrolleesSchedulesPaginator_OnPageChanged);
    } else {
        mEnrolleesControls.SchedulesListViewPaginator.render();
    }
}

// events
function uEnrolleeEventsNotesManager_Init() {
    "use strict";
    mEnrolleesControls.EventsNotesManager = new SumoNotesManager('uEnrolleeEventsNotesManager', 'uEnrolleeEventsNotesManagerHolder', [], {
        'ClassName': 'Event',
        'OnAdd': uEnrolleeEventsNotesManager_OnAdd,
        'IdentificationProperty': 'EventId',
        'Identifier': -1,
        'UserId': gUserDetails.UserId,
        'PermissionId': 32
    });
}

function uEnrolleesEventsListView_OnSelectChange(aSender, aData) {
    "use strict";
    var lSelected = aSender.selectedDataItem(),
        lNeedsConfirmed = false,
        lNeedsClosed = true,
        lMasterTamperCount = 0,
        lMasterTamperIds = [],
        lEventCount = 0,
        lItem,
        lKey;


    if (!isNullOrUndefined(lSelected) && lSelected.length > 0) {
        //$('#uEnrolleesEventNewNoteButton').show();
        $('#uEnrolleesEventNewNote').attr('placeholder', localizeText('cEventNewNote'))
                                    .val('');
        $('#uEnrolleesEventNewNote').show();
        for (lKey in lSelected) {
            if (lSelected.hasOwnProperty(lKey)) {
                lItem = lSelected[lKey];
                ++lEventCount;
                if (!lNeedsConfirmed) {
                    lNeedsConfirmed = !lItem.IsConfirmed;
                }
                if (lItem.MetaEventId === 1003 && lNeedsClosed) {
                    ++lMasterTamperCount;
                    lNeedsClosed = lItem.IsOpen;
                    lMasterTamperIds.push(lItem.Id);
                }
            }
        }
        if (lNeedsConfirmed) {
            $('#uEnrolleesEventConfirmButton').show();
            $('#uEnrolleesAddConfirmedNoteButton').hide();
            $('#uEnrolleesEventNewNote').unbind('change', uNewNote_OnChange);
        }
        else {
            $('#uEnrolleesEventConfirmButton').hide();
            $('#uEnrolleesAddConfirmedNoteButton').show();
            $('#uEnrolleesEventNewNote').change(uNewNote_OnChange).keyup(uNewNote_OnChange).keypress(uNewNote_OnChange).change();
        }
    } else {
        //$('#uEnrolleesEventNewNoteButton').hide();
        $('#uEnrolleesEventNewNote').hide();
        $('#uEnrolleesAddConfirmedNoteButton').hide();
        $('#uEnrolleesEventConfirmButton').hide();
        // possibly add new note for confirmed event show()
    }

    $('#uEnrolleesEventCloseButton').hide();
    if (lMasterTamperCount > 0 && (lEventCount === lMasterTamperCount) && lNeedsClosed) {
        getEventMasterTamperCanCloseStatus(lMasterTamperIds, 'uEnrolleesEventCloseButton');
    }
}

function uEnrolleesEventsListView_OnSort(aParams, aData) {
    "use strict";
    var lEvents = mEnrolleesData.OffenderEventsRendered,
        lEventListSorted = [],
        lPaginated;
    lEventListSorted = aData.sort(lEvents);
    $.each(lEventListSorted, function (index, value) {
        if (value.NoteData.length > 0) {
            value.Notes = '<div class="NotesIconProperty" onclick="enrolleeEventNotes_OnClick(' + index + ')">' + value.NoteData.length + '</div>';
        }
        else {
            value.Notes = '<div class="NotesIconProperty" onclick="enrolleeEventNotes_OnClick(' + index + ')">0</div>';
        }
        if (value.MeNoteData.length > 0) {
            value.MeNotes = '<div class="MeNotesIconProperty" onclick="enrolleeMeEventNotes_OnClick(' + index + ')">' + value.MeNoteData.length + '</div>';
        }
        else {
            value.MeNotes = '<div class="MeNotesIconProperty" onclick="enrolleeMeEventNotes_OnClick(' + index + ')">0</div>';
        }
        if (value.MonitoredEventId !== -1) {
            value.MonitoredEvent = '<div class="IconButton InstantReportsButton pReportsWrite" onclick="instantReporting_OnClick(2,' + value.MonitoredEventId + ')"></div>';
        }
        else {
            value.MonitoredEvent = '<div>N/A</div>';
        }
    })
    mEnrolleesData.OffenderEventsSorted = lEventListSorted;
    lPaginated = mEnrolleesControls.EventsListViewPaginator.paginate(lEventListSorted);
    mEnrolleesControls.EventsListView.setDataSource(lPaginated);

    //mEnrolleesControls.EventsListViewFilter.filter();
}

function enrolleesEventsIcon_OnClick(aEventId) {

    window.location.hash = "Events.Map." + aEventId;
}

function uEnrolleesEventsListView_Init() {
    "use strict";
    if (isNullOrUndefined(mEnrolleesControls.EventsListView)) {
        var lColumns = [
            { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': selectionColumnFormatter },
            { 'id': 'EventIcon', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': EnrolleesEventIconColumnFormatter },
            { 'id': 'Id', 'title': localizeWrapper('cId'), 'dataField': 'Id', 'width': 'autoData', 'minWidth': 50, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
            { 'id': 'Description', 'title': localizeWrapper('cEnrolleeDescription'), 'dataField': 'Description', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
            { 'id': 'Status', 'title': localizeWrapper('cEnrolleeStatus'), 'dataField': 'IsOpen', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'number', 'formatMethod': EventOpenFormatter },
            { 'id': 'Start', 'title': localizeWrapper('cEventStartDate'), 'dataField': 'EventData', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': formatEventStartDateTime },
            { 'id': 'Stop', 'title': localizeWrapper('cEventStopDate'), 'dataField': 'EventData', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': formatEventEndDateTime },
            { 'id': 'ConfirmedDate', 'title': localizeWrapper('cEventConfirmedDate'), 'dataField': 'EventData', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': formatEventConfirmDateTime },
            { 'id': 'Confirmed', 'title': localizeWrapper('cEventConfirmed'), 'dataField': 'IsConfirmed', 'width': 'autoHeader', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': EventConfirmedFormatter },
            { 'id': 'Notes', 'title': localizeWrapper('cEventNotes'), 'dataField': 'Notes', 'width': 'autoHeader', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'number' },
            { 'id': 'MeNotes', 'title': localizeWrapper('cEventMENotes'), 'dataField': 'MeNotes', 'width': 'autoHeader', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'number' },
            { 'id': 'MonitoredEvent', 'title': localizeWrapper('cEventMonitoredEvent'), 'dataField': 'MonitoredEvent', 'width': 'autoHeader', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'number' }
        ];

        mEnrolleesControls.EventsListView = new sumo.controls.ListView('uEnrolleesEventsListView', 'uEnrolleesEventsListViewHolder', { 'keyField': 'Id', 'selectMethod': 'auto', 'cssClass': 'VeritracksListView', 'canUnselect': true }, lColumns);
        mEnrolleesControls.EventsListView.bind('selectedchanged', uEnrolleesEventsListView_OnSelectChange);
        mEnrolleesControls.EventsListView.bind('sort', uEnrolleesEventsListView_OnSort);
    }
}


function uEnrolleesEventsListViewFilter_OnSuccess(aParams, aData) {
    "use strict";
    if (aParams === mEnrolleesData.OffenderCurrentId) {
        FixDates(aData);
        // mEnrolleesControls.EventsListView.setDataSource(aData);
        enrolleeEventNotes_Init(aData);
    }
}

function enrolleeEventNotesOnclick_OnSuccess(aParams, aData) {
    "use strict";
    var lKey,
        lNote,
        lBodyHtml = [];

    FixDates(aData);
    DisplayPopup(localizeWrapper('cEventNotes'), '', null, false);
    var lPermissionId = 32;
    mEnrolleesControls.NotesManager = new SumoNotesManager('uPopupContent', 'uPopupContent', aData, {
        'ClassName': 'Event',
        'OnAdd': uEnrolleeEventsNotesManager_OnAdd,
        'IdentificationProperty': 'EventId',
        'Identifier': aParams,
        'UserId': gUserDetails.UserId,
        'PermissionId': lPermissionId
    });
    mEnrolleesControls.NotesManager.RenderContents();
    $('#uVeritracksModalBody .ButtonBar').remove();
}

function timelineEnrolleeEventNotes_OnClick(aEventIndex) {
    "use strict";
    var lKey,
        lNote,
        lEventList,
        lEventDetails = mEnrolleesControls.TimelineEventListView.getDataSource(),
        lBuilder = new SumoPredicateBuilder(),
        lEvent = lEventDetails[aEventIndex];

    DisplayModal(localizeWrapper('cEventNotes'), '', null, false);
    var lPermissionId = 32;
    mEnrolleesControls.NotesManager = new SumoNotesManager('uVeritracksModalBody', 'uVeritracksModalBody', lEvent.NoteData, {
        'ClassName': 'Event',
        'OnAdd': uEnrolleeEventsNotesManager_OnAdd,
        'IdentificationProperty': 'EventId',
        'Identifier': lEvent.Id,
        'UserId': gUserDetails.UserId,
        'PermissionId': lPermissionId
    });
    mEnrolleesControls.NotesManager.RenderContents();
    $('#uVeritracksModalBody .ButtonBar').remove();
}

// monitored event notes popup
function timelineEnrolleeMeEventNotes_OnClick(aEventIndex) {
    "use strict";
    var lKey,
        lNote,
        lEventList,
        lEventDetails = mEnrolleesControls.MapEventsListView.getDataSource(),
        lBuilder = new SumoPredicateBuilder(),
        lEvent = lEventDetails[aEventIndex];

    DisplayModal(localizeWrapper('cEventMENotes'), '', null, false);
    mEnrolleesControls.NotesManager = new SumoNotesManager('uVeritracksModalBody', 'uVeritracksModalBody', lEvent.MeNoteData, {
        'ClassName': 'MonitoredEventNote',
        'IdentificationProperty': 'EventId',
        'Identifier': lEvent.Id,
        'UserId': gUserDetails.UserId,
        'PermissionId': 32
    });
    mEnrolleesControls.NotesManager.RenderContents();
    $('#uVeritracksModalBody .ButtonBar').remove();
}

function mapEventsEnrolleeEventNotes_OnClick(aEventIndex) {
    "use strict";
    var lKey,
        lNote,
        lEventList,
        lEventDetails = mEnrolleesControls.MapEventsListView.getDataSource(),
        lBuilder = new SumoPredicateBuilder(),
        lEvent = lEventDetails[aEventIndex];

    DisplayModal(localizeWrapper('cEventNotes'), '', null, false);
    var lPermissionId = 32;
    mEnrolleesControls.NotesManager = new SumoNotesManager('uVeritracksModalBody', 'uVeritracksModalBody', lEvent.NoteData, {
        'ClassName': 'Event',
        'OnAdd': uEnrolleeEventsNotesManager_OnAdd,
        'IdentificationProperty': 'EventId',
        'Identifier': lEvent.Id,
        'UserId': gUserDetails.UserId,
        'PermissionId': lPermissionId
    });
    mEnrolleesControls.NotesManager.RenderContents();
    $('#uVeritracksModalBody .ButtonBar').remove();
}

// monitored event notes popup
function mapEventsEnrolleeMeEventNotes_OnClick(aEventIndex) {
    "use strict";
    var lKey,
        lNote,
        lEventList,
        lEventDetails = mEnrolleesControls.MapEventsListView.getDataSource(),
        lBuilder = new SumoPredicateBuilder(),
        lEvent = lEventDetails[aEventIndex];

    DisplayModal(localizeWrapper('cEventMENotes'), '', null, false);
    mEnrolleesControls.NotesManager = new SumoNotesManager('uVeritracksModalBody', 'uVeritracksModalBody', lEvent.MeNoteData, {
        'ClassName': 'MonitoredEventNote',
        'IdentificationProperty': 'EventId',
        'Identifier': lEvent.Id,
        'UserId': gUserDetails.UserId,
        'PermissionId': 32
    });
    mEnrolleesControls.NotesManager.RenderContents();
    $('#uVeritracksModalBody .ButtonBar').remove();
}

function enrolleeEventNotes_OnClick(aEventIndex) {
    "use strict";
    var lKey,
        lNote,
        lEventList,
        lEventDetails = mEnrolleesControls.EventsListView.getDataSource(),
        lBuilder = new SumoPredicateBuilder(),
        lEvent = lEventDetails[aEventIndex];

    DisplayPopup(localizeWrapper('cEventNotes'), '', null, false);
    var lPermissionId = 32;
    mEnrolleesControls.NotesManager = new SumoNotesManager('uPopupContent', 'uPopupContent', lEvent.NoteData, {
        'ClassName': 'Event',
        'OnAdd': uEnrolleeEventsNotesManager_OnAdd,
        'IdentificationProperty': 'EventId',
        'Identifier': lEvent.Id,
        'UserId': gUserDetails.UserId,
        'PermissionId': lPermissionId
    });
    mEnrolleesControls.NotesManager.RenderContents();
    $('#uPopupContent .ButtonBar').remove();
    $('#uPopupContentListViewPaginationCell').remove();
}

// monitored event notes popup
function enrolleeMeEventNotes_OnClick(aEventIndex) {
    "use strict";
    var lKey,
        lNote,
        lEventList,
        lEventDetails = mEnrolleesControls.EventsListView.getDataSource(),
        lBuilder = new SumoPredicateBuilder(),
        lEvent = lEventDetails[aEventIndex];

    DisplayPopup(localizeWrapper('cEventMENotes'), '', null, false);
    mEnrolleesControls.NotesManager = new SumoNotesManager('uPopupContent', 'uPopupContent', lEvent.MeNoteData, {
        'ClassName': 'MonitoredEventNote',
        'IdentificationProperty': 'EventId',
        'Identifier': lEvent.Id,
        'UserId': gUserDetails.UserId,
        'PermissionId': 32
    });
    mEnrolleesControls.NotesManager.RenderContents();
    $('#uPopupContent .ButtonBar').remove();
    $('#uPopupContentListViewPaginationCell').remove();


}
function enrolleesEventNotes_Render(aEventList) {
    "use strict";

    var InitialSort = {};
    InitialSort.Columns = [];
    InitialSort.Columns.push({
        ColumnName: "SortId",
        Direction: "Descending"
    });

    // for initial clicking
    mEnrolleesData.EventsPaginated = mEnrolleesControls.EventsListViewPaginator.paginate(aEventList);
    if (!isNullOrUndefined(mEnrolleesControls.EventsListView)) {
        mEnrolleesControls.EventsListView.setDataSource(mEnrolleesData.EventsPaginated);
        mEnrolleesControls.EventsListView.sortExpression(InitialSort);
    }
}

//function MonitoredEventNote_OnSuccess(aParams, aData) {
//    var p = aParams;
//    var d = aData;
//}

function EnrolleEventNotes_OnSuccess(aParams, aData) {
    "use strict";
    var lKey,
        lNoteKey,
        lEvent,
        lBuilder = null,
        lEventList = aParams.EventList,
        lMonitoredEventsExist = aParams.MonitoredEvents,
        lEventDetail = new EventDetailList(),
        lNoteList = [],
        lEventList = [],
        lEventIds = [],
        lMonitoredEventNoteList = [],
        lNote,
        lTimeZone,
        lEnrollee;
    FixDates(aData);
    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lNote = aData[lKey];
            if (isNullOrUndefined(lNoteList[lNote.EventId])) {
                lNoteList[lNote.EventId] = [];
            }
            lNoteList[lNote.EventId].push(lNote);
        }
    }
    $.each(aParams.EventList, function (index, value) {
        lEventIds.push(value.Id);
    });
    if (lEventIds.length > 0) {
        lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('EventId', lEventIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());

        if (lMonitoredEventsExist) {
            ReadMultiple('Veritracks.Core.MonitoredEventNote, Veritracks.Core, Version=2011.10.5050.25812, Culture=neutral, PublicKeyToken=null', lBuilder.RootExpression, 0, MonitoredEventNote_OnSuccess, MonitoredEventNote_OnFailure, lMonitoredEventNoteList, null, 0);
        } else {
            MonitoredEventNote_OnSuccess(lMonitoredEventNoteList, []);
        }

    }
    //else {
    //    MonitoredEventNote_OnSuccess();
    //}
    function MonitoredEventNote_OnSuccess(p, d) {
        FixDates(d);
        for (lKey in d) {
            if (d.hasOwnProperty(lKey)) {
                var lMeNote = d[lKey];
                if (isNullOrUndefined(lMonitoredEventNoteList[lMeNote.EventId])) {
                    lMonitoredEventNoteList[lMeNote.EventId] = [];
                }
                lMonitoredEventNoteList[lMeNote.EventId].push(lMeNote);
            }
        }

        for (lKey in aParams.EventList) {
            lEventDetail = new EventDetailList();
            if (aParams.EventList.hasOwnProperty(lKey)) {
                lEvent = aParams.EventList[lKey];
                lEnrollee = getDataItem(lEvent.EnrolleeId, "Enrollees");
                lTimeZone = getDataItem(lEnrollee.TimeZoneId, "TimeZone");
                if (!isNullOrUndefined(lEvent)) {
                    lEventDetail.Id = lEvent.Id;
                    lEventDetail.IsConfirmed = lEvent.IsConfirmed;
                    lEventDetail.ConfirmedByUserId = lEvent.ConfirmedByUserId;
                    lEventDetail.ZoneTrackPointCount = lEvent.ZoneTrackPointCount;
                    lEventDetail.EnrolleeId = lEvent.EnrolleeId;
                    lEventDetail.MetaEventId = lEvent.MetaEventId;
                    if (lEvent.ZoneId > 0) {
                        lEventDetail.Description = formatterMetaEvent(lEvent.MetaEventId);
                        if (!isNullOrUndefined(lEvent.ZoneName)) {
                            lEventDetail.Description += '</br>' + '(' + lEvent.ZoneName + ')';
                        }
                        else {
                            var lZone = getDataItem(lEvent.ZoneId, "Zones");
                            if (!isNullOrUndefined(lZone)) {
                                lEventDetail.Description += '</br>' + '(' + lZone.Name + ')';
                            }
                        }
                    }
                    else
                        lEventDetail.Description = formatterMetaEvent(lEvent.MetaEventId);
                    lEventDetail.IsOpen = lEvent.IsOpen;
                    lEventDetail.StartDateUTC = displayEnrolleeTimeZoneFormatted(lEvent.StartDateUTC, lTimeZone);
                    lEventDetail.StopDateUTC = displayEnrolleeTimeZoneFormatted(lEvent.StopDateUTC, lTimeZone);
                    lEventDetail.ZoneId = lEvent.ZoneId;
                    lEventDetail.DeviceId = lEvent.DeviceId;
                    lEventDetail.ConfirmedDateUTC = displayEnrolleeTimeZoneFormatted(lEvent.ConfirmedDateUTC, lTimeZone);
                    lEventDetail.DisplayFlag = lEvent.DisplayFlag;
                    lEventDetail.MonitoredEventId = lEvent.MonitoredEventId;
                    if (!isNullOrUndefined(lNoteList[lEvent.Id])) {
                        lEventDetail.Notes = '<div class="NotesIconProperty" onclick="enrolleeEventNotes_OnClick(\'' + lKey + '\')">' + lNoteList[lEvent.Id].length + '</div>';
                        lEventDetail.NoteData = lNoteList[lEvent.Id];
                    } else {
                        lEventDetail.Notes = '<div class="NotesIconProperty" onclick="enrolleeEventNotes_OnClick(\'' + lKey + '\')">0</div>';
                    }
                    if (!isNullOrUndefined(lMonitoredEventNoteList[lEvent.Id])) {
                        lEventDetail.MeNotes = '<div class="MeNotesIconProperty" onclick="enrolleeMeEventNotes_OnClick(\'' + lKey + '\')">' + lMonitoredEventNoteList[lEvent.Id].length + '</div>';
                        lEventDetail.MeNoteData = lMonitoredEventNoteList[lEvent.Id];
                    }
                    else {
                        lEventDetail.MeNotes = '<div class="MeNotesIconProperty" onclick="enrolleeMeEventNotes_OnClick(\'' + lKey + '\')">0</div></div>';
                    }
                    if (lEventDetail.MonitoredEventId !== -1) {
                        lEventDetail.MonitoredEvent = '<div class="IconButton InstantReportsButton pReportsWrite" onclick="instantReporting_OnClick(2,' + lEventDetail.MonitoredEventId + ')"></div>';
                    }
                    else {
                        lEventDetail.MonitoredEvent = '<div>N/A</div>';
                    }
                    lEventDetail.EventData = lEvent;
                    lEventDetail.SortId = (lEvent.IsOpen ? 2 : 1).toString() + lEvent.StartDateUTC.valueOf();
                    lEventList.push(lEventDetail);
                }
            }
        }


        mEnrolleesData.OffenderEventsRendered = lEventList;

        if (isNullOrUndefined(mEnrolleesData.OffenderEventsSorted)) {
            mEnrolleesData.OffenderEventsSorted = lEventList;

        }
        $('#uEnrolleesEventsLoadingBar').hide();
        $('.EventsLoadingHidden').show();
        mEnrolleesControls.EventsListView.resize();
        enrolleesEventNotes_Render(lEventList);
    }
    function MonitoredEventNote_OnFailure() {

    }
}


function enrolleeEventNotes_Init(aEventList) {
    "use strict";
    var lKey,
        lEvent,
        lEventList = [],
        lNotesExist = false,
        lMonitoredEventsExist = false,
        lBuilder = new SumoPredicateBuilder();

    if (!isNullOrUndefined(aEventList)) {
        for (lKey in aEventList) {
            if (aEventList.hasOwnProperty(lKey)) {
                lEvent = aEventList[lKey];
                if (!isNullOrUndefined(lEvent)) {
                    lEventList.push(lEvent.Id);
                    if (lEvent.HasNotes == 1)
                        lNotesExist = true;
                    if (lEvent.MonitoredEventId != -1)
                        lMonitoredEventsExist = true
                }
            }
        }
    }
    if (aEventList.length !== 0) {
        lBuilder.AddNewExpressionConditional('EventId', lEventList, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        //mEnrolleesControls.EventsListView.setDataSource([]);
        //enrolleesEventNotes_Render([]);
        if (lNotesExist) {
            ReadMultiple(gObjectList.EventNote.AssemblyQualifiedName, lBuilder.RootExpression, 0, EnrolleEventNotes_OnSuccess, null, { "EventList": aEventList, "MonitoredEvents": lMonitoredEventsExist }, null, 0);
        } else {
            EnrolleEventNotes_OnSuccess({ "EventList": aEventList, "MonitoredEvents": lMonitoredEventsExist }, []);
        }
    } else {
        $('#uEnrolleesEventsLoadingBar').hide();
        $('.EventsLoadingHidden').show();
        mEnrolleesControls.EventsListViewPaginator.paginate([]);
        mEnrolleesControls.EventsListView.resize();

    }
}

function uFilterEnrolleeEventsCleaner() {
    var lKey,
    lUnallowed,
    lColumnList = [];

    lUnallowed = ['AllActionableEvent'];

    for (lKey in mEnrolleesControls.EventsListViewFilter.Columns) {
        var lColumns = mEnrolleesControls.EventsListViewFilter.Columns[lKey];
        if ($.inArray(lColumns.Id, lUnallowed) < 0) {
            lColumnList.push(lColumns);
        }
    }

    mEnrolleesControls.EventsListViewFilter.SetSecondaryColumns(lColumnList);
    mEnrolleesControls.EventsListViewFilter.LiveExpressionModifier();
}

function uEnrolleesEventsListViewFilter_OnFilter(aSender, aExpression, aData) {
    "use strict";
    var lEnrolleeEvents,
        lIsHistory = false,
        lStartDateFilter = evaluateExpressionValue(aExpression, 'StartDateUTC'),
        lEndDateFilter = evaluateExpressionValue(aExpression, 'StopDateUTC'),
        lStartDate,
        lEndDate,
        lSort = new SortExpression(),
        lEventCacheStartDate = new Date(),
        lBuilder = new SumoPredicateBuilder();

    uFilterEnrolleeEventsCleaner();
    aExpression = mEnrolleesControls.EventsListViewFilter.Expression;
    var lEventHistoryOffsetProperty= veritracks.system.clientSetting('EventHistoryOffset');
    if(lEventHistoryOffsetProperty && !isNaN(Number(lEventHistoryOffsetProperty))){
        gSystemSettings.EventHistoryOffset = lEventHistoryOffsetProperty;
    }
    lEventCacheStartDate.addDays(-gSystemSettings.EventHistoryOffset);
    if (lStartDateFilter.length > 0) {
        lStartDate = lStartDateFilter[0].Value;
        lIsHistory = lStartDate <= lEventCacheStartDate;
    }
    if (!lIsHistory && lEndDateFilter.length > 0) {
        lEndDate = lEndDateFilter[0].Value;
        lIsHistory = lEndDate <= lEventCacheStartDate;
    }
    mEnrolleesData.OffenderEventsRendered = [];
    mEnrolleesData.OffenderEventsSorted = [];

    //add spinner , hide list and paginator
    $('.EventsLoadingHidden').hide();
    $('#uEnrolleesEventsLoadingBar').show();

    mEnrolleesControls.EventsListView.setDataSource([]);
    lSort.addDescendingColumn('StartDateUTC');

    if (lIsHistory) {
        var lEnrolleeId;
        if (mStateManager.Settings()[0] === 'Offenders')
            lEnrolleeId = mEnrolleesData.OffenderCurrentId;
        else
            lEnrolleeId = mEnrolleesData.VictimCurrentId;

        lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        // stop bringing back hidden data.
        lBuilder.AddNewExpressionConditional('DisplayFlag', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        if (aExpression.__type.indexOf('ExpressionBinary') !== -1) {
            lBuilder.AddExpressionBinary(aExpression);
        } else {
            lBuilder.AddConditional(aExpression);
        }
        if (lEndDateFilter.length > 0)
            lBuilder.AddNewExpressionConditional('StartDateUTC', lEndDateFilter[0].Value, false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.EventHistory.AssemblyQualifiedName, lBuilder.RootExpression, 0, uEnrolleesEventsListViewFilter_OnSuccess, Sad, mEnrolleesData.OffenderCurrentId, lSort, 0);
    } else {
        if (!isNullOrUndefined(aExpression)) {
            if (aExpression.__type === 'ExpressionBinary:www.sumosoftware.com/Expressions') {
                lBuilder.AddExpressionBinary(aExpression);
            } else {
                lBuilder.AddConditional(aExpression);
            }
        }

        if (lEndDateFilter.length > 0)
            lBuilder.AddNewExpressionConditional('StartDateUTC', lEndDateFilter[0].Value, false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());

        lEnrolleeEvents = query(mEnrolleesData.OffenderEvents, lBuilder.RootExpression);
        lEnrolleeEvents = lSort.sort(lEnrolleeEvents);
        enrolleeEventNotes_Init(lEnrolleeEvents);
    }
}

function enrolleesViewAllEvents_OnClick() {
    "use strict";
    var lEnrollee = mEnrolleesControls.CardView.selectedDataItem();

    if (!isNullOrUndefined(lEnrollee)) {
        setViewState('EnrolleesViewEvents', lEnrollee.Id);
        setViewState('EnrolleesViewEventsLocation', mStateManager.Hash().Settings[1]);
        window.location.hash = 'Events.Map';
    }
}
function uEnrolleesEventsListViewFilter_Init() {
    "use strict";
//    if (isNullOrUndefined(mEnrolleesControls.EventsListViewFilter)) {
        var lUserPreferences = getUserPreferences(3),
            lOrganizations = getDataItems('Organizations'),
            lIsConfirmable = false,
            lEventState = '',
            lParams,
            lItem,
            lKey;

        for (lKey in lOrganizations) {
            if (lOrganizations.hasOwnProperty(lKey)) {
                lItem = lOrganizations[lKey];
                lIsConfirmable = (lItem.EventActionType === 2);
                if (lIsConfirmable) {
                    break;
                }
            }
        }

        if (lIsConfirmable) {
            //lEventState = false;
        }

        lParams = {
            'Title': localizeWrapper('cEventFindEvents'),
            'Content': '',
            'CssClass': 'ButtonFilter',
            'HideOnFilter': true,
            'OnFilter': uEnrolleesEventsListViewFilter_OnFilter,
            'Columns': [
                { 'Id': 'AllActionableEvent', 'Title': localizeWrapper('cEventAllActionableEvents'), 'DataTextField': 'Description', 'DataValueField': 'Id', 'Type': 'CheckList', 'DataSource': [{ 'Id': 'SelectAll', 'Description': localizeText('cSelectAll'), 'data': true }] },
                { 'Id': 'EventType', 'Title': localizeWrapper('cEventType'), 'Type': 'CheckList', 'DataField': 'MetaEventId', 'DataSource': getEventsFilterMetaEvents(), 'DataTextField': 'Description', 'DataValueField': 'Id', 'relationalOperator': mRelationalOperatorEnum.In() },
                { 'Id': 'IsOpen', 'Title': localizeWrapper('cEventIsOpen'), 'Type': 'Dropdown', 'DataField': 'IsOpen', 'DataSource': [{ 'Value': true, 'Text': localizeText('cYes') }, { 'Value': false, 'Text': localizeText('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': '', 'InsertBlank': true, 'BlankText': localizeText('cBoth'), 'ComparisonType': 'Boolean' },
                { 'Id': 'IsConfirmed', 'Title': localizeWrapper('cEventIsConfirmed'), 'Type': 'Dropdown', 'DataField': 'IsConfirmed', 'DataSource': [{ 'Value': true, 'Text': localizeText('cYes') }, { 'Value': false, 'Text': localizeText('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': '', 'InsertBlank': true, 'BlankText': localizeText('cBoth'), 'ComparisonType': 'Boolean' },
                { 'Id': 'HasNotes', 'Title': localizeWrapper('cEventHasNotes'), 'Type': 'Dropdown', 'DataField': 'HasNotes', 'DataSource': [{ 'Value': true, 'Text': localizeText('cYes') }, { 'Value': false, 'Text': localizeText('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': '', 'ComparisonType': 'Boolean', 'InsertBlank': true, 'BlankText': localizeText('cBoth') },
                { 'Id': 'StartDateUTC', 'Title': localizeWrapper('cAnalysisStart'), 'Type': 'Date', 'DataField': 'StartDateUTC', 'DefaultValue': '', 'relationalOperator': mRelationalOperatorEnum.GreaterThanOrEqual() },
                { 'Id': 'StopDateUTC', 'Title': localizeWrapper('cEventStop'), 'Type': 'Date', 'DataField': 'StopDateUTC', 'DefaultValue': '', 'relationalOperator': mRelationalOperatorEnum.LessThanOrEqual() }
            ],
            'Settings': null,
            'UserPreferences': lUserPreferences,
            'UserId': gUserDetails.UserId,
            'UserPreferenceType': 3
        };
        mEnrolleesControls.EventsListViewFilter = gFilterFactory.createControl('uEnrolleesEventsListViewFilter', 'uEnrolleesEventsListViewFilterHolder', lParams);
   // } else {
  //      mEnrolleesControls.EventsListViewFilter.render();
  //  }
    // initial sort by contact date
    var InitialSort = {};
    InitialSort.Columns = [];
    InitialSort.Columns.push({
        ColumnName: "SortId",
        Direction: "Descending"
    });

    // for initial clicking
    mEnrolleesControls.EventsListViewFilter.bind('AllActionableEventchanged', uEventsFilterSelectAll_OnChange);
    mEnrolleesControls.EventsListViewFilter.bind('EventTypechanged', checkEventFiltersSelecAll);
   // mEnrolleesControls.EventsListView.sortExpression(InitialSort);
}

//notes

//addresses

//assignments
function uEnrolleesAssignmentsListView_OnSort(aParams, aSort) {
    "use strict";
    var lDeviceAssignments = mEnrolleesControls.DeviceAssignmentsListView.getDataSource(),
        lDeviceAssignmentsSortedList = [];

    lDeviceAssignmentsSortedList = aSort.sort(lDeviceAssignments);
    mEnrolleesControls.DeviceAssignmentsListView.setDataSource(lDeviceAssignmentsSortedList);
}

function uEnrolleesAssignmentsListView_Init() {
    "use strict";
    if (isNullOrUndefined(mEnrolleesControls.DeviceAssignmentsListView)) {
        var lColumns = [
            { 'id': 'Product', 'title': localizeWrapper('cEnrolleeProduct'), 'dataField': 'ProductId', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'number', 'formatMethod': ProductNameFormatter },
            { 'id': 'SerialNumber', 'title': localizeWrapper('cSerialNumber'), 'dataField': 'SerialNumber', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
            { 'id': 'StartDate', 'title': localizeWrapper('cEnrolleeStartDate'), 'dataField': 'StartDate', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': DisplayLongDateTime },
            { 'id': 'EndDate', 'title': localizeWrapper('cEnrolleeEndDate'), 'dataField': 'EndDate', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': AssignmentEndDateFormatter },
            { 'id': 'ReasonForChange', 'title': localizeWrapper('cEnrolleeChangeReason'), 'dataField': 'ReasonForChange', 'width': 'autoData', 'minWidth': 130, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': AssignmentChangeReasonFormatter },
            { 'id': 'UnAssignedByUserId', 'title': localizeWrapper('cEnrolleeAttemptToRecover'), 'dataField': 'UnAssignedByUserId', 'width': 'autoData', 'minWidth': 130, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': agentNameFormatterByUserId }
        ];
        mEnrolleesControls.DeviceAssignmentsListView = new sumo.controls.ListView('uEnrolleesAssignmentsListView', 'uEnrolleesAssignmentsListViewHolder', { 'keyField': 'Id', 'selectMethod': 'none', 'cssClass': 'VeritracksListView', 'canUnselect': true }, lColumns);
        mEnrolleesControls.DeviceAssignmentsListView.bind('sort', uEnrolleesAssignmentsListView_OnSort);
    }
}

//schedules
//function enrolleesScheduleTypeFormatter(aTypeId) {
//    "use strict";
//    var lResult = '';

//    switch (aTypeId) {
//        case 1:
//            lResult = 'Zone';
//            break;
//        case 2:
//            lResult = 'BluHome';
//            break;
//        case 3:
//            lResult = 'BluBox';
//            break;
//    }

//    return lResult;
//}

////function booleanShortFormatter(aValue) {
////    "use strict";
////    var lResult = '';
////    if (aValue) {
////        lResult = 'X';
////    }
////    return lResult;
//}

function uEnrolleesSchedulesListView_Update() {
    "use strict";
    EnrolleeProfileSchedules_Init(mEnrolleesData.OffenderCurrentId);
}

function uEnrolleesSchedulesListView_OnSort(aParams, aSort) {
    "use strict";

    var lEnrolleeSchedules = mEnrolleesControls.SchedulesListView.getDataSource(),
        lEnrolleeSchedulesList = [];

    lEnrolleeSchedulesList = aSort.sort(lEnrolleeSchedules);
    mEnrolleesControls.SchedulesListView.setDataSource(lEnrolleeSchedulesList);
}


function uEnrolleesSchedulesListView_Init() {
    "use strict";

    // mEnrolleesControls.SchedulesView = new sumo.controls.ScheduleView('uEnrolleeScheduleView', 'uEnrolleesSchedulesViewHolder', { 'cssClass': 'ConsumerPreviewxxDisabled' });
    mEnrolleesControls.SchedulesListView = new sumo.controls.ListView('uEnrolleesSchedulesListView', 'uEnrolleesSchedulesListViewHolder', {
        'keyField': 'Id', 'selectMethod': 'ctrlKey', 'cssClass': 'VeritracksListView', 'canUnselect': true, 'localization': true
    }, [
            { 'id': 'Description', 'title': localizeWrapper('cEnrolleeDescription'), 'dataField': 'Name', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
            { 'id': 'Target', 'title': localizeWrapper('cEnrolleeScheduleTarget'), 'dataField': 'TargetName', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
            { 'id': 'TargetType', 'title': localizeWrapper('cEnrolleeScheduleTargetType'), 'dataField': 'TargetTypeName', 'width': 'autoData', 'minWidth': 75, 'sortable': true, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
            { 'id': 'StartTimeLocal', 'title': localizeWrapper('cAnalysisStart'), 'dataField': 'StartTimeLocal', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': getTimeFormatter },
            { 'id': 'EndTimeLocal', 'title': localizeWrapper('cAnalysisEnd'), 'dataField': 'EndTimeLocal', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': getTimeFormatter },
            { 'id': 'ScheduleType', 'title': localizeWrapper('cEnrolleeScheduleType'), 'dataField': 'ScheduleType', 'width': 'autoData', 'minWidth': 85, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
            { 'id': 'ZoneScheduleType', 'title': localizeWrapper('cEnrolleeZoneScheduleType'), 'dataField': 'ZoneScheduleType', 'width': 'autoData', 'minWidth': 85, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': scheduleZoneTypeFormatter },
            { 'id': 'IsSunday', 'title': localizeWrapper('cSundayLetter'), 'dataField': 'IsSunday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
            { 'id': 'IsMonday', 'title': localizeWrapper('cMondayLetter'), 'dataField': 'IsMonday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
            { 'id': 'IsTuesday', 'title': localizeWrapper('cTuesdayLetter'), 'dataField': 'IsTuesday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
            { 'id': 'IsWednesday', 'title': localizeWrapper('cWednesdayLetter'), 'dataField': 'IsWednesday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
            { 'id': 'IsThursday', 'title': localizeWrapper('cThursdayLetter'), 'dataField': 'IsThursday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
            { 'id': 'IsFriday', 'title': localizeWrapper('cFridayLetter'), 'dataField': 'IsFriday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
            { 'id': 'IsSaturday', 'title': localizeWrapper('cSaturdayLetter'), 'dataField': 'IsSaturday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false }
    ]);
    mEnrolleesControls.SchedulesListView.bind('selectedchanged', uEnrolleesSchedulesListView_OnSelectChange, null);
    mEnrolleesControls.SchedulesListView.bind('update', uEnrolleesSchedulesListView_Update);
    mEnrolleesControls.SchedulesListView.bind('sort', uEnrolleesSchedulesListView_OnSort);
}

function formatScheduleStartTime(aScheduleId) {
    "use strict";
    var lResult = '- check-in -',
        lSchedule = null,
        lTimeZone = null;

    lSchedule = GetOffenderSchedule(aScheduleId);
    if (!isNullOrUndefined(lSchedule) && lSchedule.ScheduleType !== 6) {
        lTimeZone = getEnrolleeTimeZone(lSchedule.EnrolleeId);
        lResult = displayTime(convertMomentFromStringTimezone(lSchedule.StartTimeUTC, lTimeZone.TimeZoneName));
    }
    return lResult;
}

function formatScheduleEndTime(aScheduleId) {
    "use strict";
    var lResult = '',
        lSchedule = null,
        lTimeZone = null;

    lSchedule = GetOffenderSchedule(aScheduleId);
    if (!isNullOrUndefined(lSchedule)) {
        lTimeZone = getEnrolleeTimeZone(lSchedule.EnrolleeId);
        lResult = displayTime(convertMomentFromStringTimezone(lSchedule.EndTimeUTC, lTimeZone.TimeZoneName));
    }
    return lResult;
}


function formatLastContactDateTime(aDate) {
    "use strict";
    var lResult = null,
        lCardData = mEnrolleesControls.CardView.selectedDataItem(),
        lTimeZone = null;

    lTimeZone = getEnrolleeTimeZone(lCardData.Enrollee.Id);
    lResult = DisplayLongDateTime(displayEnrolleeTimeZone(aDate, lTimeZone));
    return lResult;
}

// Event Time formatters using entire event as parameter, in some cases no longer exists in Events cache and throws an error.
function formatEventStartDateTime(aEvent) {
    "use strict";
    var lResult = null,
        lEvent = aEvent,
        lTimeZone = null;

    lTimeZone = getEnrolleeTimeZone(lEvent.EnrolleeId);
    lResult = displayEnrolleeTimeZoneFormatted(lEvent.StartDateUTC, lTimeZone);
    return lResult;
}
function formatSobertrackStartDateTime(aEvent,aParams) {
    "use strict";
    console.log(aParams)
    var lResult = null,
        lEvent = aEvent,
        lTimeZone = null;

    // lTimeZone = getEnrolleeTimeZone(lEvent.EnrolleeId);
    // lResult = displayEnrolleeTimeZoneFormatted(lEvent.StartDate, lTimeZone);
    return lResult;
}

function formatEventEndDateTime(aEvent) {
    "use strict";
    var lResult = localizeWrapper('cEventInProgress'),
        lEvent = aEvent,
        lTimeZone = null;

    if (!lEvent.IsOpen) {
        lTimeZone = getEnrolleeTimeZone(lEvent.EnrolleeId);
        lResult = displayEnrolleeTimeZoneFormatted(lEvent.StopDateUTC, lTimeZone);
    }
    return lResult;
}


function formatEventConfirmDateTime(aEvent) {
    "use strict";
    var lResult = localizeWrapper('cEventNotConfirmed2'),
        lEvent = aEvent,
        lTimeZone = null;

    if (lEvent.IsConfirmed) {
        lTimeZone = getEnrolleeTimeZone(lEvent.EnrolleeId);
        lResult = displayEnrolleeTimeZone(lEvent.ConfirmedDateUTC, lTimeZone);
    }
    return lResult;
}

function displayEnrolleeTimeZone(aDate, aTimeZone) {
    "use strict";
    var lResult = "";
    if (!isNullOrUndefined(aTimeZone)) {
        lResult = DisplayShortDateTime(displayFixedTimeZoneTime(aDate, aTimeZone.TimeZoneName));
    } else {
        lResult = DisplayShortDateTime(displayFixedTimeZoneTime(aDate, ''));
    }

    return lResult;
}
function displayEnrolleeTimeZoneFormatted(aDate, aTimeZone) {
    "use strict";
    var lResult = "";
    if (!isNullOrUndefined(aTimeZone)) {
        var momentUTC = moment.utc(aDate).format('YYYY-MM-DD HH:mm:ss');
        lResult = moment.utc(momentUTC).tz(aTimeZone.TimeZoneName).format('MM/DD/YYYY hh:mm:ss A');

    } else {
        lResult = DisplayShortDateTime(displayFixedTimeZoneTime(aDate, ''));
    }

    return lResult;
}

function displayEnrolleeTimeZoneNameFormatted(aDate, aTimeZoneName){
    "use strict";
    var lResult = "";
    if (!isNullOrUndefined(aTimeZoneName)) {
        var momentUTC = moment.utc(aDate).format('YYYY-MM-DD HH:mm:ss');
        lResult = moment.utc(momentUTC).tz(aTimeZoneName).format('MM/DD/YYYY hh:mm:ss A');

    } else {
        lResult = DisplayShortDateTime(displayFixedTimeZoneTime(aDate, ''));
    }

    return lResult;
}

function uEnrolleesContactHistoryListView_OnSort(aParams, aSort) {
    "use strict";

    //if (isNullOrUndefined(aSort.Columns[0])) {
    //    var InitialSort = {
    //        ColumnName: "ContactDate",
    //        Direction: "Descending"
    //    }
    //    aSort.Columns.push(InitialSort);
    //}


    var lEnrolleeContacts = mEnrolleesControls.ContactHistoryListView.getDataSource(),
        lEnrolleeContactsSortedList = [];

    lEnrolleeContactsSortedList = aSort.sort(lEnrolleeContacts);
    mEnrolleesControls.ContactHistoryListView.setDataSource(lEnrolleeContactsSortedList);
}

//contacthistory
function uEnrolleesContactHistoryListView_Init() {
    "use strict";
    if (isNullOrUndefined(mEnrolleesControls.ContactHistoryListView)) {
        var lColumns = [
            { 'id': 'SerialNumber', 'title': localizeWrapper('cSerialNumber'), 'dataField': 'DeviceId', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': DeviceSerialNumberFormatter },
            { 'id': 'ContactDate', 'title': localizeWrapper('cEnrolleeDateTime'), 'dataField': 'ContactDate', 'width': 'autoData', 'minWidth': 20, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': formatLastContactDateTime },
            { 'id': 'Status', 'title': localizeWrapper('cEnrolleeStatus'), 'dataField': 'Status', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'number', 'formatMethod': contactStatusImageFormatter },
            { 'id': 'RecordCount', 'title': localizeWrapper('cInventoryRecords'), 'dataField': 'RecordCount', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
            { 'id': 'GpsRecordCount', 'title': localizeWrapper('cInventoryGPS'), 'dataField': 'GpsRecordCount', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
            { 'id': 'PercentGps', 'title': localizeWrapper('cInventoryPercentGPS'), 'dataField': 'PercentGps', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'number', 'formatMethod': DisplayPercent },
            { 'id': 'BatteryLevel', 'title': localizeWrapper('cInventoryBatteryLevel'), 'dataField': 'BatteryLevel', 'width': 'autoData', 'minWidth': 24, 'sortable': false, 'cssClass': 'CenterImage', 'dataType': 'number', 'formatMethod': inventoryBatteryLevelFormatter, 'canResize': false },
            { 'id': 'BatteryVoltage', 'title': localizeWrapper('cInventoryBatteryVoltage'), 'dataField': 'BatteryVoltage', 'width': 'autoData', 'minWidth': 24, 'sortable': false, 'cssClass': 'CenterImage', 'dataType': 'number', 'formatMethod': DisplayVolts, 'canResize': false }
        ];
        mEnrolleesControls.ContactHistoryListView = new sumo.controls.ListView('uEnrolleesContactHistoryListView', 'uEnrolleesContactHistoryListViewHolder', { 'keyField': 'Id', 'selectMethod': 'none', 'cssClass': 'VeritracksListView', 'canUnselect': true }, lColumns);
        mEnrolleesControls.ContactHistoryListView.bind('sort', uEnrolleesContactHistoryListView_OnSort);

    }

    // initial sort by contact date
    var InitialSort = {};
    InitialSort.Columns = [];
    InitialSort.Columns.push({
        ColumnName: "ContactDate",
        Direction: "Descending"
    });
    mEnrolleesControls.ContactHistoryListView.sortExpression(InitialSort);
}

// EVENTS PROCESSING
function uEnrolleeEventsNotesManager_OnSuccess(aParams, aData) {
    "use strict";
    var lEventId = aData.EventId;
    EnrolleeProfileEvents_Init(mEnrolleesData.OffenderCurrentId);
}

function uEnrolleeEventsNotesManager_OnFailure(a, b, c) {
    "use strict";
    var l = '';
}

function uEnrolleeEventsNotesManager_OnAdd(aNote) {
    "use strict";
    var lWriteList = [],
        lSelected = mEnrolleesControls.EventsListView.selectedDataItem(),
        lItem = null,
        lKey,
        lEventDetail;
    for (lKey in lSelected) {
        if (lSelected.hasOwnProperty(lKey)) {
            lEventDetail = lSelected[lKey];
            lItem = $.extend({}, aNote);
            lItem.EventId = lEventDetail.Id;
            lWriteList.push(lItem);
        }
    }
    if (lWriteList.length > 0) {
        WriteMultiple(lWriteList, uEnrolleeEventsNotesManager_OnSuccess, uEnrolleeEventsNotesManager_OnFailure, null);
    }
}

function uEnrolleesEventNewNoteButton_OnClick() {
    "use strict";
    mEnrolleesControls.EventsNotesManager.displayPopup();
}

function enrolleesEventConfirmationWrite_OnSuccess(aParams, aData) {
    "use strict";
    mActivityNotification.addNotification(aData.length.toString() + " events confirmed.");
    EnrolleeProfileEvents_Init(mEnrolleesData.OffenderCurrentId);
    UpdateEnrolleeEventReports(aData);
}

function enrolleesEventConfirmationWrite_OnFailure(aParams, a, b, c) {
    "use strict";
    var l = '';
}

function confirmNote_OnWriteSuccess(aEnrollee, aData) {
    "use strict";
    var lEventId = aData.EventId;
    gNewNote.Text(gNewNote.DefaultValue);
    EnrolleeProfileEvents_Init(mEnrolleesData.OffenderCurrentId);
}

function confirmNote_OnWriteFailure(aEnrollee, b, c, d) {
    "use strict";
    mData.ConfirmStepCount--;
    // alert('failed to confirm events for ' + aEnrollee.FullName);
}


function uEnrolleesEventCloseButton_OnClick() {
    "use strict";
    var lWriteList = [],
        lSelected = mEnrolleesControls.EventsListView.selectedDataItem(),
        lEvents = getDataItems('Events'),
        lNow = new Date(),
        lEvent = null,
        lKey;

    for (lKey in lSelected) {
        if (lSelected.hasOwnProperty(lKey)) {
            lEvent = lSelected[lKey].EventData;
            if (!lEvent.IsConfirmed) {
                lEvent.IsConfirmed = true;
                lEvent.ConfirmedByUserId = gUserDetails.UserId;
                lEvent.ConfirmedDateUTC = new Date();
            }
            lEvent.IsOpen = false;
            //lEvent.StopDateUTC = lEvent.ConfirmedDateUTC;
            lEvent.StopDateUTC = lNow;
            // some events are in history and will mess up cache -- always save from Events and not EventHistory.
            lEvent.__type = "Event:www.veritracks.com";
            setDataItem(lEvent.Id, 'Events', lEvent);
            lWriteList.push(lEvent);
        }
    }
    if (lWriteList.length > 0) {
        WriteMultiple(lWriteList, enrolleesEventConfirmationWrite_OnSuccess, enrolleesEventConfirmationWrite_OnFailure, lSelected);
    }
}

function uEnrolleesAddConfirmedNoteButton_OnClick() {
    "use strict";
    var lSelected = mEnrolleesControls.EventsListView.selectedDataItem(),
    lEvent = null,
    lKey,
    lNotesToWrite = [],
    lOriginalNote = null,
    lNote = null,
    lNoteText = $('#uEnrolleesEventNewNote').val(),
    lPredicateBuilder = new SumoPredicateBuilder();

    if ($.trim(lNoteText) !== '' && lNoteText !== gNewNote.DefaultValue) {
        lOriginalNote = new Note(gUserDetails.UserId, lNoteText);
        lOriginalNote.__type = 'Event' + lOriginalNote.__type;
    }

    for (lKey in lSelected) {
        if (lSelected.hasOwnProperty(lKey)) {
            lEvent = lSelected[lKey].EventData;
            if (lOriginalNote !== null) {
                lNote = $.extend({}, lOriginalNote);
                lNote.EventId = lEvent.Id;
                lNotesToWrite.push(lNote);
                if (!lEvent.HasNotes) {
                    lEvent.HasNotes = true;
                    // some events are in history and will mess up cache -- always save from Events and not EventHistory.
                    lEvent.__type = "Event:www.veritracks.com";
                    setDataItem(lEvent.Id, 'Events', lEvent);
                    WriteSingle(lEvent, null, null, {}, false);
                }

            }
        }
    }
    if (lNotesToWrite.length > 0) {
        var lCurrent = mEnrolleesData.OffenderCurrentId;
        if (mStateManager.Settings()[0] === 'Victims') {
            lCurrent = mEnrolleesData.VictimCurrentId;
        }
        WriteMultiple(lNotesToWrite, confirmNote_OnWriteSuccess, confirmNote_OnWriteFailure, lCurrent);
    }
}
function uEnrolleesEventConfirmButton_OnClick() {
    "use strict";
    var lWriteList = [],
        lSelected = mEnrolleesControls.EventsListView.selectedDataItem(),
        lEvents = getDataItems('Events'),
        lEvent = null,
        lKey,
        lNotesToWrite = [],
        lOriginalNote = null,
        lNote = null,
        lNoteText = $('#uEnrolleesEventNewNote').val(),
        lPredicateBuilder = new SumoPredicateBuilder(),
        lEnrollee = mEnrolleesControls.CardView.selectedDataItem();

    lEnrollee = lEnrollee.Enrollee;

    if ($.trim(lNoteText) !== '' && lNoteText !== gNewNote.DefaultValue) {
        lOriginalNote = new Note(gUserDetails.UserId, lNoteText);
        lOriginalNote.__type = 'Event' + lOriginalNote.__type;
    }

    for (lKey in lSelected) {
        if (lSelected.hasOwnProperty(lKey)) {
            lEvent = lSelected[lKey].EventData;
            lEvent.TransactionId = moment().format("YYYYMMDDHHmmss");
            lEvent.IsConfirmed = true;
            lEvent.ConfirmedByUserId = gUserDetails.UserId;
            lEvent.ConfirmedDateUTC = new Date();
            // some events are in history and will mess up cache -- always save from Events and not EventHistory.
            lEvent.__type = "Event:www.veritracks.com";
            lWriteList.push(prepareObjectForWcf(lEvent));

            if (lOriginalNote !== null) {
                lNote = $.extend({}, lOriginalNote);
                lNote.EventId = lEvent.Id;
                lEvent.HasNotes = true;
                lNote.TransactionId = moment().format("YYYYMMDDHHmmss");
                lNotesToWrite.push(lNote);
            }
            setDataItem(lEvent.Id, 'Events', lEvent);
        }
    }
    if (lWriteList.length > 0) {
        WriteMultiple(lWriteList, enrolleesEventConfirmationWrite_OnSuccess, enrolleesEventConfirmationWrite_OnFailure, lSelected);
    }

    if (lNotesToWrite.length > 0) {
        var lCurrent = mEnrolleesData.OffenderCurrentId;
        if (mStateManager.Settings()[0] === 'Victims') {
            lCurrent = mEnrolleesData.VictimCurrentId;
        }
        WriteMultiple(lNotesToWrite, confirmNote_OnWriteSuccess, confirmNote_OnWriteFailure, lCurrent);
    }

    // check if archived
    //   uSaveOnDemandEnrolleeCheck(lEnrollee);
}
// bind event for new note
function uNewNote_OnChange() {
    "use strict";
    var lEventNoteTextValue = $('#uEnrolleesEventNewNote').val();
    if ($.trim(lEventNoteTextValue) !== '' && lEventNoteTextValue !== gNewNote.DefaultValue) {
        $('.ConfirmedEventNoteButton').removeClass('Disabled');
    } else {
        $('.ConfirmedEventNoteButton').addClass('Disabled');
    }
}
// streamlined note section
// FEEDBACK
var gNewNote = {};

gNewNote.Text = function (aText) {
    "use strict";
    var lResult = "",
        lNoteTextInput = $('#uEnrolleesEventNewNote');
    if (!isNullOrUndefined(aText)) {
        lNoteTextInput.val(aText);
    } else {
        lResult = lNoteTextInput.val();
    }
    return lResult;
};

gNewNote.OnFocus = function () {
    "use strict";
    if (gNewNote.Text() === localizeText('cEventNewNote')) {
        gNewNote.Text('');
    }
};

gNewNote.OnBlur = function () {
    "use strict";
    //if (gNewNote.Text() === '') {
    //    gNewNote.Text(localizeText('cEventNewNote'));
    //}
};

function EnrolleeProfileEvents_Init(aEnrolleeId) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lEnrolleeEvents = [],
        lSort = new SortExpression(),
        lNow = new Date(),
        lKey,
        lTemp;
    lNow.addDays(-7);
    // get all open events
    lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('DisplayFlag', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsOpen', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lEnrolleeEvents = query(getDataItems('Events'), lBuilder.RootExpression);

    // get closed events less than 7 days old
    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('DisplayFlag', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsOpen', false, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('StopDateUTC', lNow, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());

    if (!isNullOrUndefined(lEnrolleeEvents)) {
        lTemp = query(getDataItems('Events'), lBuilder.RootExpression);
        for (lKey in lTemp) {
            if (lTemp.hasOwnProperty(lKey)) {
                lEnrolleeEvents.push(lTemp[lKey]);
            }
        }
    }
    else {
        lEnrolleeEvents = query(getDataItems('Events'), lBuilder.RootExpression);
    }

    //lSort.addAscendingColumn('SortOrder');
    lSort.addDescendingColumn('StartDateUTC');

    lEnrolleeEvents = lSort.sort(lEnrolleeEvents);

    if (!isNullOrUndefined(mEnrolleesControls.EventsListView)) {

        mEnrolleesData.OffenderEvents = lEnrolleeEvents;

        mEnrolleesControls.EventsListViewFilter.filter();
    }
    if (!isNullOrUndefined(mEnrolleesControls.EventsNotesManager)) {
        mEnrolleesControls.EventsNotesManager.RenderContents();
    }


}



function uFindProfilePayProvisioned_OnChange() {
    if ($("#uOffenderProfileOffenderPayFlagEdit").is(':checked')) {
        getEnrolleePayProvisioned($('#uOffenderProfileOrganizationIdEdit').val());
    }
    
}

function uOffenderProfilePay_OnChange() {
    "use strict";
    var lEnrollee = getDataItem(mEnrolleesData.OffenderEditingId, "Enrollees");
    var lIsChecked = 0;

    if ($("#uOffenderProfileOffenderPayFlagEdit").is(':checked')) {
        if (!isNullOrUndefined(lEnrollee)) {
            uEnrolleeFrp_Init(lEnrollee, checkForExistingFrps);            
        } else {
            uEnrolleeFrp_Init(new Enrollee(), checkForExistingFrps);
        }
        lIsChecked = 1;
    }
    
    EnrolleePayFlag_Init(lIsChecked, mEnrolleesData.OffenderProfileCurrent.DailyRate, true);
    

}
//EMA Update
function uEMARegistation_OnChange() {
    "use strict";
    var lHtml = [],
        lButtonBar = GenerateButtonCommandBar();

    if ($("#uEMAHasEnrolleeMobileAppEdit").is(':checked')) { 
        $("#uEMACellPhoneNumberEdit").addClass("ValidateRequired");
    } else {
        $("#uEMACellPhoneNumberEdit").removeClass("ValidateRequired");
        if (mEnrolleesData.HasEnrolleeMobileApp) {
            lButtonBar.append(GenerateButton('OK', 'Cancel', function () {
                ClosePopup();
                $('#uEMAHasEnrolleeMobileApp').val('No');
            }));
            lButtonBar.append(GenerateButton('Cancel', 'Cancel', function () {
                $("#uEMACellPhoneNumberEdit").addClass("ValidateRequired");
                $("#uEMAHasEnrolleeMobileAppEdit").prop('checked', true);
                ClosePopup();
            }));
            CloseModal();
            DisplayPopup('Warning', '<div id="uEnrolleeMobileAppWarningPopupHolder">Warning: Disabling Enrollink will remove all location verification configurations for this enrollee.  Click "ok" to proceed.</div>', lButtonBar, false);

        }
    }
}


function checkForExistingFrps(aParams, aData) {
    "use strict";
    EnrolleeFrpGeneratePopup(3, false);
    if (aData != null && aData.length > 0) {
        mEnrolleesData.OffenderFrp = aData;
        populatefrpPopUpEdit();
    } else {
        mEnrolleesData.OffenderFrp = [];
    }
}

function checkEnabledFrp() {
    "use strict";
    var lPageClass = gPageClassManager.EnrolleesOffenderSecondary,
        selectedEnrolleId = mEnrolleesControls.CardView.selected(),
        enrollee = getDataItem(selectedEnrolleId, "Enrollees"),
        isPageClass = CheckUserHasPermission(71);

    //if (enrollee) {
    //    isPageClass = isPageClass && (checkOrganizationProperty(enrollee.OrganizationId, 'enrollee_pay_contract_flag') == 'Y');
    //}

    if (!isNullOrUndefined(enrollee) && enrollee.OffenderPayFlag == 1 && isPageClass) {
        $('#uEnrolleesFrp').show();
        $('#uOffenderPayFlag').show();
    } else if (!isNullOrUndefined(enrollee) && isPageClass) {
        $('#uOffenderPayFlag').show();
        $('#uEnrolleesFrp').hide();
        if (mStateManager.Settings()[2] == 'Frp') {
            $('#uEnrolleesSecondaryMenuEvents').click();
        }
    } else {
        $('#uEnrolleesFrp').hide();
        $('#uOffenderPayFlag').hide();
        if (mStateManager.Settings()[2] == 'Frp') {
            $('#uEnrolleesSecondaryMenuEvents').click();
        }
    }
}



function EnrolleeProfileFrp_Init() {
    "use strict";
    var lEnrollee = mEnrolleesControls.CardView.selectedDataItem();
    uEnrolleeFrp_Init(lEnrollee);
}

function uEnrolleeFrp_Init(aEnrollee, aSuccessCallback) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    lBuilder.AddNewExpressionConditional("IsActive", true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional("EnrolleeId", aEnrollee.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    if (typeof aSuccessCallback != 'undefined') {
        ReadMultiple(gObjectList.EnrolleeFrp.AssemblyQualifiedName, lBuilder.RootExpression, 0, aSuccessCallback, Sad, null, null);
    } else {
        ReadMultiple(gObjectList.EnrolleeFrp.AssemblyQualifiedName, lBuilder.RootExpression, 0, enrolleeFrp_OnSuccess, Sad, null, null);
    }

}


function enrolleeFrp_OnSuccess(aParams, aData) {
    "use strict";
    var lEnrollee = mEnrolleesControls.CardView.selectedDataItem(),
        lOffender;
    if (typeof aData != 'null') {
        mEnrolleesData.OffenderFrp = aData;
        populateEnrolleeFrp(aData);
    } else {
        mEnrolleesData.OffenderFrp = [];
    }
    lOffender = getDataItem(lEnrollee.Id, "Enrollees");
    if (lOffender.AlcoholDeviceFlag == true) {
        $('#uOffenderProfileAlcoholDeviceFlagEdit').prop('checked', true);
    } else {
        $('#uOffenderProfileAlcoholDeviceFlagEdit').prop('checked', false);
    }

}


function populateEnrolleeFrp(aDataSource) {
    "use strict";
    var lHtml = [];
    if (aDataSource) {
        for (var key in aDataSource) {
            if (aDataSource.hasOwnProperty(key)) {
                lHtml.push(enrolleFrpGenerator(aDataSource[key]));
            }
        }

        $('#uEnrolleeFrpHolder').html(lHtml.join(''));
        veritracks.localization.localize('#uEnrolleeFrpHolder');
    }
}

function EnrolleeFrpGeneratePopup(aAddressType, isEditing) {
    "use strict";

    var lBodyHtml = [],
        lEnrolleeId = mEnrolleesData.OffenderCurrentId,
        lButtonCommandBar = GenerateButtonCommandBar(),
        lItems = getDataItems('AddressType'),
        lEnrollee =GetEnrollee(lEnrolleeId),
        lBuilder = new SumoPredicateBuilder(),
        lCountList = [],
        lPreFillAdress = [],
        lHasHome = false,
        lHasWork = false,
        lMapHeight = 0,
        lItem,
        lKey,
        CopyAddress = localizeWrapper('cEnrolleeShowCopyAddress'),
        lHeight = $(window).height();

        if (!isNullOrUndefined(mEnrolleesData.OffenderProfileAddresses) && mEnrolleesData.OffenderProfileAddresses.length > 0) {
            if (aAddressType !== 1) {
                lBuilder.AddNewExpressionConditional('AddressTypeId', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lCountList = query(mEnrolleesData.OffenderProfileAddresses, lBuilder.RootExpression);

                lHasHome = (lCountList.length > 0);
                lBuilder.Clear();
            }
            if (aAddressType !== 2) {
                lBuilder.AddNewExpressionConditional('AddressTypeId', 2, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lCountList = query(mEnrolleesData.OffenderProfileAddresses, lBuilder.RootExpression);

                lHasWork = (lCountList.length > 0);
            }
            lPreFillAdress = mEnrolleesData.OffenderProfileAddresses;
        }
        if (lHeight < 800) {
            lBodyHtml.push('<div style="height:500px; overflow-y:scroll">');
        }
        lBodyHtml.push('<table>');
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeCurrentFRP') + '</td>');
        lBodyHtml.push('<td class="FormField">');
        lBodyHtml.push('<select id="frpPopupSelectHolder" onchange="populateCurrentFrp();"></select>');
        lBodyHtml.push('</td>');
        lBodyHtml.push('<td rowspan="14" valign="top" id="uOffenderAddressEditMapCell"><div style="width: 350px; height: 350px; background-color: silver;" id="uOffenderAddressEditMapPanel"></div></td></tr>');
        lBodyHtml.push('<td><h2>' + localizeWrapper('cEnrolleeAddress') + '</h2></td>');
        lBodyHtml.push('<td class="FormField">');
        if (lPreFillAdress.length > 0) {
            lBodyHtml.push('<span style="float:left; padding-top:6px;" id="uAutoFillShowAddress" class="PaperCopyIconProperty Clickable" onclick="uAutoFill_OnClick()">' + CopyAddress + '</span>');
        }
        lBodyHtml.push('<div class="Clickable IconButton LocateButton FloatRight" id="uMapLocateButton" onclick="uOffenderAddressEditMapLocateButton_OnClick()"  title="geocode"></div></td>');
        lBodyHtml.push('</tr>');
        if (lPreFillAdress.length > 0) {
            lBodyHtml.push('<tr id="uAutoFillAddress"');
            if (mCopyAddress == 0) {
                lBodyHtml.push(' style="display:none;"');
            }
            lBodyHtml.push('><td class="FormTitle">' + localizeWrapper('cEnrolleeAddressAutoFill') + '</td>');
            lBodyHtml.push('<td class="FormField"><select id="uOffenderAddressAddressPrefillEdit" onchange="uOffenderAddressAddressPrefill_OnChange()">');
            lBodyHtml.push('<option value"-1"> </option>');
            for (lKey in lPreFillAdress) {
                if (lPreFillAdress.hasOwnProperty(lKey)) {
                    lItem = lPreFillAdress[lKey];
                    lBodyHtml.push('<option value="');
                    lBodyHtml.push(lItem.Id);
                    lBodyHtml.push('">');
                    lBodyHtml.push(lItem.Title);
                    lBodyHtml.push('</option>');
                }
            }
            lBodyHtml.push('</select></td></tr>');
        }
        // address does not geocode area
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeFRPByPassGeocode') + '</td>');
        lBodyHtml.push('<td class="FormField"><input type="checkbox" id="uOffenderGeocodeCheck" onchange="uOffenderGeocodeCheck_OnChange();"/></td></tr>');

        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAddressStreet1') + '</td>');
        lBodyHtml.push('<td class="FormField"><input type="text" id="uOffenderAddressStreet1Edit" class="Validate ValidateRequired EnrolleeAddressMustGeocode ValidateLength Validate100Length" /></td></tr>');
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAddressStreet2') + '</td>');
        lBodyHtml.push('<td class="FormField"><input type="text" id="uOffenderAddressStreet2Edit" class="EnrolleeAddressMustGeocode Validate ValidateLength Validate100Length" /></td></tr>');
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAddressCity') + '</td>');
        lBodyHtml.push('<td class="FormField"><input type="text" id="uOffenderAddressCityEdit" class="Validate ValidateRequired EnrolleeAddressMustGeocode ValidateLength Validate50Length" /></td></tr>');
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAddressState') + '</td>');
        lBodyHtml.push('<td class="FormField"><input type="text" id="uOffenderAddressStateEdit" class="Validate ValidateRequired  " /></td></tr>');
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAddressZipCode') + '</td>');
        lBodyHtml.push('<td class="FormField"><input type="text" id="uOffenderAddressZipEdit" class="Validate ValidateRequired EnrolleeAddressMustGeocode ValidateLength Validate10Length" /></td></tr>');
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAddressCountry') + '</td>');
        lBodyHtml.push('<td class="FormField"><input type="text" id="uOffenderAddressCountryEdit" class="Validate ValidateRequired EnrolleeAddressMustGeocode ValidateLength Validate255Length" value="USA" />');
        lBodyHtml.push('<input type="hidden" id="uOffenderAddressLatitudeEdit" value="0.0" />');
        lBodyHtml.push('<input type="hidden" id="uOffenderAddressLongitudeEdit" value="0.0" />');
        lBodyHtml.push('</td></tr>');
        lBodyHtml.push('<tr><td colspan="2"><hr /></td></tr>');
        lBodyHtml.push('<tr><td colspan="2"><h2>' + localizeWrapper('cEnrolleeAdditionalInfo') + '</h2></td></tr>');
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeFirstName') + '</td>');
        lBodyHtml.push('<td class="FormField"><input type="text" id="uOffenderFrpFirstName" class="Validate ValidateRequired ValidateLength Validate40Length" value="'+lEnrollee.FirstName+'" /></td></tr>');
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeLastName') + '</td>');
        lBodyHtml.push('<td class="FormField"><input type="text" id="uOffenderFrpLastName" class="Validate ValidateRequired ValidateLength Validate40Length" value="'+lEnrollee.LastName+'"/></td></tr>');
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cAgentEmail') + '</td>');
        lBodyHtml.push('<td class="FormField"><input type="text" id="uOffenderAddressEmailEdit" class="Validate ValidateEmail ValidateLength Validate40Length" /></td></tr>');
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleePhone') + '</td>');
        lBodyHtml.push('<td class="FormField"><input type="text" id="uOffenderAddressPhoneNumberEdit" class="Validate ValidatePhone ValidateLength Validate40Length"  /></td></tr>');
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAltPhone') + '</td>');
        lBodyHtml.push('<td class="FormField"><input type="text" id="uOffenderAddressPhoneNumber2Edit" class="Validate ValidatePhone ValidateLength Validate40Length" /></td></tr>');
        lBodyHtml.push('<!--td></div></td--></tr>');
        lBodyHtml.push('</table>');
        if (lHeight < 500) {
            lBodyHtml.push('</div>');
        }


        GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'uSaveEnrolleeFrpAddress_OnClick(' + isEditing + ')').appendTo(lButtonCommandBar);

        if (aAddressType != 3) {
            GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'ClosePopup()').appendTo(lButtonCommandBar);
        } else {
            GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'undoEnrolleePay()').appendTo(lButtonCommandBar);
        }

        DisplayPopup(localizeWrapper('cEnrolleeFRP'), lBodyHtml.join(''), lButtonCommandBar, true, false);
        lMapHeight = $('#uOffenderAddressEditMapCell').innerHeight();
        setWidth('#uOffenderAddressEditMapPanel', lMapHeight);
        setHeight('#uOffenderAddressEditMapPanel', lMapHeight);
        uOffenderAddressEditMap_Init();
        mEnrolleesControls.AddressesValidator = new Validator('uPopupContainer', mRegexValidation);

        enrolleeAddressMustGeocode_Init();

        if (isEditing && mEnrolleesData.OffenderEditingId !== -1) {
            populatefrpPopUpEdit();
        }

        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional("IsActive", true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.EnrolleeFrp.AssemblyQualifiedName, lBuilder.RootExpression, 0, enrolleeFrpPopupSelect_OnSuccess, Sad, null, null);

    // append qtip to each element.
        $('#uPopupPanel').addClass('LowZIndex');
        $('#uOffenderGeocodeCheck').qtip({
            content: {
                text: localizeText('cEnrolleePayBypassGeocode')
            },
            position: {
                my: 'top right',
                at: 'bottom left',
                viewport: $(window)
            },
            show: {
                delay: 200
            },
            style: 'qtip-bootstrap qtip-max-width'
        });
}

function uOffenderGeocodeCheck_OnChange() {
    "use strict";
    var lCheckValidRemoval = true;
    var lAddress = new EnrolleeAddress();

    populateFromEditView(lAddress, 'uOffenderAddress', 'Edit');

    if (lAddress.Street1 == mEnrolleesData.AddressEditItem.Street1 && lAddress.Street2 == mEnrolleesData.AddressEditItem.Street2 && lAddress.City == mEnrolleesData.AddressEditItem.City
        && lAddress.State == mEnrolleesData.AddressEditItem.State && lAddress.Zipcode == mEnrolleesData.AddressEditItem.Zip && lAddress.Country == mEnrolleesData.AddressEditItem.Country) {
        lCheckValidRemoval = false;
    }

    if ($('#uOffenderGeocodeCheck').is(':checked')) {
        $('.PopupWindow .SaveButton').show();
        $('#uVeritracksModal .SaveButton').show();

        if (lCheckValidRemoval) {
            mEnrolleesControls.AddressesMap.layerSetDataSource('address', []);
            $('#uOffenderAddressLatitudeEdit').val(0);
            $('#uOffenderAddressLongitudeEdit').val(0);
        }
    } else {
        if (lCheckValidRemoval)
            $('.PopupWindow .SaveButton').hide();
            $('#uVeritracksModal .SaveButton').hide();
    }
}

function enrolleeFrpPopupSelect_OnSuccess(aParams, aData) {
    "use strict";
    var lHtml = [];
    mEnrolleesData.Frps = aData;
    for (var i = 0; i < aData.length; i++) {
        lHtml.push('<option value="' + aData[i].Id + '">' + frpFormatter(aData[i].LastName, aData[i].FirstName, aData[i].Email) + '</option>');
    }

    lHtml.push('<option value="0">New</option>');
    $("#frpPopupSelectHolder").html(lHtml.join(''));
    chooseCurrentFrp();
}

function chooseCurrentFrp() {
    "use strict";

    if (mEnrolleesData.OffenderFrp.length > 0) {
        $("#frpPopupSelectHolder").val(mEnrolleesData.OffenderFrp[0].Id);
        populatefrpPopUpEdit();
    } else  {
        $("#frpPopupSelectHolder").val(0);
    }
}

function populateCurrentFrp() {
    "use strict";

    if ($("#frpPopupSelectHolder").val() == 0) {
        populatefrpPopUpEdit(new EnrolleeFrp());
        return;
    }

    for (var i = 0; i < mEnrolleesData.Frps.length; i++) {
        if ($("#frpPopupSelectHolder").val() == mEnrolleesData.Frps[i].Id) {
            mEnrolleesData.CurrentOffenderFrpId = mEnrolleesData.Frps[i].Id;
            populatefrpPopUpEdit(mEnrolleesData.Frps[i]);
            break;
        }
    }

}

function undoEnrolleePay() {
    "use strict";
    if ($('#uOffenderProfileOffenderPayFlagEdit').is(':checked')) {
        $('#uOffenderProfileOffenderPayFlagEdit').prop('checked', false);
    }
    $('#uPopupPanel').removeClass('LowZIndex');
    mEnrolleesData.QueuedFrps = [];
    EnrolleePayFlag_Init(0, 0, true);
    ClosePopup();
}

function populatefrpPopUpEdit(aNewOffenderFrp) {
    "use strict";
    var lOffenderFrp = mEnrolleesData.OffenderFrp[0];

    if (!isNullOrUndefined(aNewOffenderFrp)) {
        lOffenderFrp = aNewOffenderFrp;
    }

    $('#uOffenderAddressStreet1Edit').val(lOffenderFrp.Street1);
    $('#uOffenderAddressStreet2Edit').val(lOffenderFrp.Street2);
    $('#uOffenderAddressCityEdit').val(lOffenderFrp.City);
    $('#uOffenderAddressStateEdit').val(lOffenderFrp.State);
    $('#uOffenderAddressZipEdit').val(lOffenderFrp.Zip);
    $('#uOffenderAddressCountryEdit').val(lOffenderFrp.Country);
    $('#uOffenderFrpFirstName').val(lOffenderFrp.FirstName);
    $('#uOffenderFrpLastName').val(lOffenderFrp.LastName);
    $('#uOffenderAddressEmailEdit').val(lOffenderFrp.Email);
    $('#uOffenderAddressPhoneNumberEdit').val(lOffenderFrp.PhoneNumber);
    $('#uOffenderAddressPhoneNumber2Edit').val(lOffenderFrp.PhoneNumber2);
    mEnrolleesControls.AddressesValidator.scan();
    $('#uOffenderGeocodeCheck').prop('checked', true);
    if (!isNullOrUndefined(aNewOffenderFrp) && aNewOffenderFrp.Street1 == "") {
        $('#uOffenderGeocodeCheck').prop('checked', false);
    }
    uOffenderAddressEditMapLocateButton_OnClick();
}

function uSaveEnrolleeFrpAddress_OnClick(isEditing) {
    "use strict";
    if (mEnrolleesControls.AddressesValidator.IsValid()) {
        $('#uPopupContainer .SaveButton').hide();
        $('#uPopupContainer .CancelButton').hide();

        var lAddress,
            lFrps = [],
            lFrp,
            lEnrollee;

        lAddress = new EnrolleeAddress();
        lAddress.EnrolleeId = mEnrolleesData.OffenderCurrentId;
        lEnrollee = getDataItem(lAddress.EnrolleeId, 'Enrollees');
        populateFromEditView(lAddress, 'uOffenderAddress', 'Edit');
        lAddress.Latitude = RoundNumber(lAddress.Latitude, 7);
        lAddress.Longitude = RoundNumber(lAddress.Longitude, 7);
        lAddress.PositionMatchesGeocode = mEnrolleesData.EnrolleeAddressGeocodeMatch;
        lFrp = new EnrolleeFrp(lAddress, lEnrollee);

        if (mEnrolleesData.OffenderFrp.length > 0){
            lFrp.Id = mEnrolleesData.OffenderFrp[0].Id
        } else if (isEditing) {
            lFrp.Id = mEnrolleesData.CurrentOffenderFrpId;
        }
        lFrp.Email = $('#uOffenderAddressEmailEdit').val();
        lFrp.PhoneNumber = $('#uOffenderAddressPhoneNumberEdit').val();
        lFrp.PhoneNumber2 = $('#uOffenderAddressPhoneNumber2Edit').val();
        lFrp.FirstName = $('#uOffenderFrpFirstName').val();
        lFrp.LastName = $('#uOffenderFrpLastName').val();
        lFrps.push(lFrp);
       
        if (mEnrolleesData.OffenderEditingId != -1) {
            mEnrolleesData.QueuedFrps = [];            
            WriteMultiple(lFrps, uOffenderFrpSave_OnComplete, uOffenderFrpSave_OnFailure, null, true);

        } else {
            if (mEnrolleesData.OffenderProfileCurrent.Id != -1) {               
                mEnrolleesData.QueuedFrps = [];
                WriteMultiple(lFrps, uOffenderFrpSave_OnComplete, uOffenderFrpSave_OnFailure, null, true);
            } else {
                //add to queue
                mEnrolleesData.QueuedFrps = lFrps;
                uOffenderFrpSave_OnComplete(null, true);
            }
        }

    }
}

function uSaveEnrolleeFrpFinal(aEnrolleeId) {
    "use strict";
    mEnrolleesData.QueuedFrps[0].EnrolleeId = aEnrolleeId;
    WriteMultiple(mEnrolleesData.QueuedFrps, null, uOffenderFrpSave_OnFailure, null, true);
}

function uOffenderFrpSave_OnComplete(aParams, aData) {
    "use strict";
    if (aData) {
        ClearValidation();
        ClosePopup();
        mStateManagerEnrolleesSecondaryFrp_Init();
    }
}//end of function

function enrolleFrpGenerator(aFrp) {
    "use strict";
    var lHtml = [],
        lCard = mEnrolleesControls.CardView.selectedDataItem();

    lHtml.push('<div class="AddressTile">');
    lHtml.push('<div>');
    //lHtml.push('<img src="Images/CancelDark16.png" alt="Edit" title="remove" onclick="uOffenderFrpRemoveButton_OnClick(');
    //lHtml.push(aFrp.Id);
    //lHtml.push(')" class="Clickable pEnrolleesOffenderAddressesWrite" style="float:right; margin-left: 5px;" />');
    lHtml.push('<img src="Images/PencilDark16.png" alt="Edit" title="Edit" onclick="EnrolleeFrpGeneratePopup(-1, true');
    //lHtml.push(aFrp.Id);
    lHtml.push(')" class="Clickable pEnrolleesOffenderAddressesWrite" style="float:right;margin-left: 5px;" />');
    lHtml.push('</div>');
    lHtml.push('<div>');
    lHtml.push(aFrp.Street1);
    lHtml.push('</div>');
    if (!isNullOrUndefined(aFrp.Street2) && aFrp.Street2 !== '') {
        lHtml.push('<div>');
        lHtml.push(aFrp.Street2);
        lHtml.push('</div>');
    }
    lHtml.push('<div>');
    lHtml.push(aFrp.City);
    lHtml.push(' ');
    lHtml.push(aFrp.State);
    lHtml.push(', ');
    lHtml.push(aFrp.Zip);
    lHtml.push('</div>');

    if (!isNullOrUndefined(aFrp.FirstName) && !isNullOrUndefined(aFrp.LastName)) {
        lHtml.push('<div><strong>' + localizeWrapper('cEnrolleeName') + '</strong> ');
        lHtml.push(aFrp.LastName + ", " + aFrp.FirstName);
        lHtml.push('</div>');
    }

    if (!isNullOrUndefined(aFrp.Email) && aFrp.Email !== '') {
        lHtml.push('<div><strong>' + localizeWrapper('cAgentEmail') + '</strong> ');
        lHtml.push(aFrp.Email);
        lHtml.push('</div>');
    }

    if (!isNullOrUndefined(aFrp.PhoneNumber) && aFrp.PhoneNumber !== '') {
        lHtml.push('<div><strong>' + localizeWrapper('cEnrolleePhone') + '</strong> ');
        lHtml.push(aFrp.PhoneNumber);
        lHtml.push('</div>');
    }
    if (!isNullOrUndefined(aFrp.PhoneNumber2) && aFrp.PhoneNumber2 !== '') {
        lHtml.push('<div><strong>' + localizeWrapper('cEnrolleeAltPhone') + '</strong> ');
        lHtml.push(aFrp.PhoneNumber2);
        lHtml.push('</div>');
    }

    lHtml.push('</div>');
    return lHtml.join('');
}//end of function

function uOffenderFrpRemoveButton_OnClick(aId) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lFrp;

    for (var item in mEnrolleesData.OffenderFrp) {
        if (mEnrolleesData.OffenderFrp.hasOwnProperty(item)) {
            if (mEnrolleesData.OffenderFrp[item].Id == aId) {
                lFrp = mEnrolleesData.OffenderFrp[item];
                break;
            }
        }//end of if
    }//end of for

    if (typeof lFrp != 'undefined') {
        lFrp.IsActive = false;
        WriteSingle(lFrp, uOffenderFrpRemove_OnSuccess, uOffenderFrpSave_OnFailure, null);
    }
}

function uOffenderFrpRemove_OnSuccess() {
    "use strict";
    EnrolleeProfileFrp_Init();
}

function uOffenderFrpSave_OnFailure(a, b, c) {
    "use strict";

}//end of function


// NOTES PROCESSING
function uEnrolleeNoteSave_OnSuccess(aParams, aData) {
    "use strict";
    FixDates(aData);
    mEnrolleesControls.NotesManager.NotesList.push(aData);
    mEnrolleesControls.NotesManager.RenderContents();
}

function uEnrolleeNoteSave_OnFailure(a, b, c) {
    "use strict";
    //mActivityNotification.addNotification("Note not saved.");
}

function uEnrolleeNotesManager_OnAdd(aNote) {
    "use strict";
    var lCurrent = mEnrolleesData.OffenderCurrentId;
    if (mStateManager.Settings()[0] === 'Victims') {
        lCurrent = mEnrolleesData.VictimCurrentId;
    }
    WriteSingle(aNote, uEnrolleeNoteSave_OnSuccess, uEnrolleeNoteSave_OnFailure, lCurrent);
}

function EnrolleeProfileNotes_OnLoad(aParams, aNotesList) {
    "use strict";
    var lPermissionId = 14;
    FixDates(aNotesList);

    if (mStateManager.Settings()[0] === 'Victims') {
        lPermissionId = 47;
    }
    mEnrolleesControls.NotesManager = new SumoNotesManager('uEnrolleeNotesManager', 'uEnrolleeNotesManagerHolder', aNotesList, { 'OnAdd': uEnrolleeNotesManager_OnAdd, 'IdentificationProperty': 'EnrolleeId', 'Identifier': aParams, 'ClassName': 'Enrollee', 'UserId': gUserDetails.UserId, 'PermissionId': lPermissionId });
    mEnrolleesControls.NotesManager.RenderContents();
}

function EnrolleeProfileNotes_Init(aEnrolleeId) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lSort = new SortExpression();
    lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lSort.addDescendingColumn('CreatedDateUTC');

    ReadMultiple(gObjectList.EnrolleeNote.AssemblyQualifiedName, lBuilder.RootExpression, 0, EnrolleeProfileNotes_OnLoad, Sad, aEnrolleeId, lSort);
}





// ADDRESSES PROCESSING
function enrolleeAddressHeightMatch() {
    "use strict";
    var lMaxHeight = 150,
        lAddressList = $('.AddressTile'),
        lItem,
        i;

    for (i = 0; i < lAddressList.length; i++) {
        lItem = $(lAddressList[i]);
        if (lItem.height() > lMaxHeight) {
            lMaxHeight = lItem.height();
        }
        setHeight('.AddressTile', lMaxHeight);
    }
}

function uUpdateBluPlusConfiguration_AfterAddressEdit(aId) {
    "use strict";
    //var lConfiguration = new BluPlusConfiguration();

    //lConfiguration.TetheredAddressId = aId;
    //lConfiguration.EnrolleeId = mEnrolleesData.BluPlusConfiguration.EnrolleeId;
    //lConfiguration.VerificationPeriod = mEnrolleesData.BluPlusConfiguration.VerificationPeriod;

    WriteSingle(mEnrolleesData.BluPlusConfiguration, null, null, [], true);

}
// save device assignment again.
function uUpdateBluBoxAddress_AfterSave(aId) {
    "use strict";
    var lEnrollment = new OffenderDeviceEnrollment(gUserDetails.UserId, mEnrolleesData.OffenderCurrentId);
    var lCurrentAssignments = gCurrentDeviceAssignment[mEnrolleesData.OffenderCurrentId];
    var lAssignment;
    var lTransactionId;
    for (var lKey in lCurrentAssignments) {
        if (lCurrentAssignments.hasOwnProperty(lKey)) {
            if ([110].indexOf(lCurrentAssignments[lKey].ProductId) !== -1) {
                lAssignment = lCurrentAssignments[lKey];
                lEnrollment.TrackingDeviceType = lCurrentAssignments[lKey].ProductId;
                lEnrollment.TrackingDeviceId = lCurrentAssignments[lKey].Id;

                lTransactionId = moment().format("YYYYMMDDHHmmss");
                lEnrollment.TransactionId = lTransactionId;
            }
        }
        WriteSingle(lEnrollment, BluBoxAddressUpdate_OnSuccess, failure, [lAssignment, lTransactionId], true);
    }

}

  // need to save enrollment, devices, device cluster, deviceclusterdevice, device cluster enrollees old and new.
  function BluBoxAddressUpdate_OnSuccess(aParams, aData) {
        "use strict;"
        var aParams = aParams[0];
        var lTransactionId = aParams[1];
        var lOldCluster;
        var lDeviceClusterEnrollees = [];
        var lBuilder = new SumoPredicateBuilder();
        var lDevices = [];
        var lClusterDevice;

        lBuilder.AddNewExpressionConditional('EnrolleeId', mEnrolleesData.OffenderCurrentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

        lDeviceClusterEnrollees = query(getDataItems('DeviceClusterEnrollee'), lBuilder.RootExpression);

        for (var lKey in lDeviceClusterEnrollees) {
            if (lDeviceClusterEnrollees.hasOwnProperty(lKey)) {
                lOldCluster = getDataItem(lDeviceClusterEnrollees[lKey].DeviceClusterId, 'DeviceClusters');
                lOldCluster.TransactionId = lTransactionId;
                lOldCluster.IsActive = false;
            }
        }
        lBuilder.Clear();

        lBuilder.AddNewExpressionConditional('DeviceClusterId', lOldCluster.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lClusterDevice = query(getDataItems('DeviceClusterDevices'), lBuilder.RootExpression);

        for (var lKey in lClusterDevice) {
            if (lClusterDevice.hasOwnProperty(lKey)) {
                lClusterDevice = lClusterDevice[lKey];
                lClusterDevice.TransactionId = lTransactionId;
                lClusterDevice.IsActive = false;
            }
        }

        lDevices.push(getDataItem(aParams.Id, 'Devices'));
        lDevices.push(getDataItem(lClusterDevice.DeviceId, 'Devices'));

        WriteSingle(lClusterDevice, BluBoxDeviceOldClusterDeviceUpdate_OnSuccess, failure,
                    {
                        'Devices': lDevices,
                        'DeviceCluster': lOldCluster,
                        'DeviceClusterDevice': lClusterDevice,
                        'DeviceClusterEnrollees': lDeviceClusterEnrollees
                    },
                    true);
}


    function BluBoxDeviceOldClusterDeviceUpdate_OnSuccess(aParams, aData) {
        "use strict";
        if (aData) {
            setDataItem(aData.Id, 'DeviceClusterDevices', aData);
        }

        WriteSingle(aParams.DeviceCluster, BluBoxDeviceOldClusterUpdate_OnSuccess, failure, aParams, true);
    }

    function BluBoxDeviceOldClusterUpdate_OnSuccess(aParams, aData) {
        "use strict";
        if (aData) {
            setDataItem(aData.Id, 'DeviceClusters', aData);
        }

        WriteMultiple(aParams.Devices, BluBoxDevicesUpdate_OnSuccess, failure, aParams, true);
    }

    function BluBoxDevicesUpdate_OnSuccess(aParams, aData) {
        "use strict";
        var lDeviceCluster = new DeviceCluster();

        lDeviceCluster = aParams.DeviceCluster;
        lDeviceCluster.Id = -1;
        lDeviceCluster.TransactionId = moment().format("YYYYMMDDHHmmss");
        lDeviceCluster.IsActive = true;

        for (var lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                setDataItem(aData.Id, 'Devices', aData);
            }
        }
        WriteSingle(lDeviceCluster, BluBoxDeviceCLusterUpdate_OnSuccess, failure, aParams, true);
    }

    function BluBoxDeviceCLusterUpdate_OnSuccess(aParams, aData) {
        "use strict";
        var lDeviceClusterDevice = new DeviceClusterDevice();

        lDeviceClusterDevice = aParams.DeviceClusterDevice;
        lDeviceClusterDevice.Id = -1;
        lDeviceClusterDevice.TransactionId = moment().format("YYYYMMDDHHmmss");
        lDeviceClusterDevice.DeviceClusterId = aData.Id;
        lDeviceClusterDevice.IsActive = true;

        setDataItem(aData.Id, 'DeviceClusters', aData);

        WriteSingle(lDeviceClusterDevice, BluBoxDeviceCLusterDeviceUpdate_OnSuccess, failure, aParams, true);
    }

    function BluBoxDeviceCLusterDeviceUpdate_OnSuccess(aParams, aData) {
        "use strict";
        var lDeviceClusterEnrollees = [];
        var lDeviceClusterEnrollee = new DeviceClusterEnrollee();

        lDeviceClusterEnrollee.DeviceClusterId = aData.DeviceClusterId;
        lDeviceClusterEnrollee.TransactionId = moment().format("YYYYMMDDHHmmss");
        lDeviceClusterEnrollee.IsActive = true;
        lDeviceClusterEnrollee.EnrolleeId = mEnrolleesData.OffenderCurrentId;

        for (var lKey in aParams.DeviceClusterEnrollees) {
            if (aParams.DeviceClusterEnrollees.hasOwnProperty(lKey)) {
                var lClustered = new DeviceClusterEnrollee();
                lClustered.DeviceClusterId = aParams.DeviceClusterEnrollees[lKey].DeviceClusterId;
                lClustered.EnrolleeId = aParams.DeviceClusterEnrollees[lKey].EnrolleeId;
                lClustered.IsActive = false;
                lClustered.Id = aParams.DeviceClusterEnrollees[lKey].Id;
                lDeviceClusterEnrollees.push(lClustered);
            }
        }

        setDataItem(aData.Id, 'DeviceClusterDevices', aData);

        lDeviceClusterEnrollees.push(lDeviceClusterEnrollee);
        if (lDeviceClusterEnrollees) {
            WriteMultiple(lDeviceClusterEnrollees, DeviceClusterEnrolleeUpdate_OnSuccess, failure, null, true);
        }
    }

    function DeviceClusterEnrolleeUpdate_OnSuccess(aParams, aData) {
        "use strict";

        for (var lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                var lData = aData[lKey];
                setDataItem(lData.Id, 'DeviceClusterEnrollee', lData);
            }
        }
        mActivityNotification.addNotification(localizeWrapper('cEnrolleeBluBoxLocationOpened'));
        mCache.UpdateItem('CurrentDeviceAssignments');
        ClosePopup();
    }


    function uOffenderAddressSave_OnComplete(aParams, aData) {
        "use strict";
        var lBuilder = new SumoPredicateBuilder(),
            lZone;

        mEnrolleesData.OffenderProfileAddresses[aData.Id] = aData;
        mActivityNotification.addNotification(localizeWrapper('cEnrolleeAddressSaved') + aData.Title);
        if (mEnrolleesData.BluPlusConfiguration && aData.Id == mEnrolleesData.BluPlusConfiguration.TetheredAddressId) {
            uUpdateBluPlusConfiguration_AfterAddressEdit(aData.Id);
        }
        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        mEnrolleesData.OffenderProfileAddresses = query(mEnrolleesData.OffenderProfileAddresses, lBuilder.RootExpression);
        EnrolleeProfileAddresses_Init(mEnrolleesData.OffenderCurrentId);
        if (!aData.IsActive) {
           // updateTimelineSectionAddress(aData);
        }
        //EnrolleeProfileAddresses_OnLoad(mEnrolleesData.OffenderCurrentId, mEnrolleesData.OffenderProfileAddresses);

        ClearValidation();
        ClosePopup();
        if(!isNullOrUndefined(aParams) && aParams.ZoneId && aParams.ZoneId > 0){
            var lZone = getDataItem(aParams.ZoneId, 'Zones');
            if (lZone.Shape == 2){
                var lButtonCommandBar = GenerateButtonCommandBar();
                GenerateButton('Ok', 'Ok', 'ClosePopup()').appendTo(lButtonCommandBar);
                DisplayPopup('Zone Move', '<p>The assigned zone cannot be moved.  Please go to the Zone tile to manually move.</p>', lButtonCommandBar, false, false);
            }
        }
        if(mStateManager.Hash().Settings[1] === 'Map'){
            offenderMapPopulate();
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('address', []);
        }
        if (veritracks.enrollees.mapping.data.DoAddHomeAddress == true && mStateManager.Hash().Settings[1] === 'Map') {
            var lEnrollee = getDataItem(aData.EnrolleeId, "Enrollees");
            var lCard = veritracks.enrollees.mapping.generateAddressCard(aData, lEnrollee);
            veritracks.enrollees.mapping.data.PrimaryCardList.push(lCard);
            var lColValues = mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.columnValue('Type');
            if (lColValues.indexOf("1") == -1) {
                enrolleesOffenderMapTypeChange("1")
            }
            mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.filter();
            mEnrolleesControls.OffenderTrackpointDetailCardView.selected(lCard.Id);

        }
    }

    function uOffenderAddressSave_OnFailure(a, b, c) {
        "use strict";
        $('#uPopupContainer .SaveButton').show();
        $('#uPopupContainer .CancelButton').show();
        //mActivityNotification.addNotification('Address save error: ' + c);
    }

    function uOffenderAddressSaveButton_OnClick(aId) {
        "use strict";
        if (mEnrolleesControls.AddressesValidator.IsValid()) {
            $('#uPopupContainer .SaveButton').hide();
            $('#uPopupContainer .CancelButton').hide();
            var lAddress,
                lTag;
            if (aId === -1) {
                lAddress = new EnrolleeAddress();
                lAddress.EnrolleeId = mEnrolleesData.OffenderCurrentId;
            } else {
                lAddress = mEnrolleesData.OffenderProfileAddresses[aId];
                lAddress.TransactionId = moment().format("YYYYMMDDHHmmss");
            }
           populateFromEditView(lAddress, 'uOffenderAddress', 'Edit');          
            lAddress.Latitude = RoundNumber(lAddress.Latitude, 7);
            lAddress.Longitude = RoundNumber(lAddress.Longitude, 7);

            //Vulnerability 3255
            lAddress.Title = veritracks.system.encodeHtml(lAddress.Title);
            lAddress.AdditionalInfo = veritracks.system.encodeHtml(lAddress.AdditionalInfo);
            lAddress.Notes = veritracks.system.encodeHtml(lAddress.Notes);
            lAddress.PhoneNumber = veritracks.system.encodeHtml(lAddress.PhoneNumber);
            lAddress.PhoneNumber2 = veritracks.system.encodeHtml(lAddress.PhoneNumber2);
            //Table accepts up to 40 cahracters for the Phone columns
            if(lAddress.PhoneNumber.length > 40 || lAddress.PhoneNumber2.length > 40)
            {
                var errorLocation = lAddress.PhoneNumber.length > 40? 'Phone Number':'Alt Phone';
                mActivityNotification.addNotification('Address save error: ' + errorLocation+' too long.');
            }

            //if (lAddress.Latitude !== 0 && lAddress.Longitude !== 0) {
            //    lAddress.PositionMatchesGeocode = false;
            //}
            lAddress.PositionMatchesGeocode = mEnrolleesData.EnrolleeAddressGeocodeMatch;
            if (lAddress.Id === -1) {
                lTag = new Tag();
                lTag.Name = lAddress.Title;
                lTag.Latitude = lAddress.Latitude;
                lTag.Longitude = lAddress.Longitude;
                lTag.UserId = gUserDetails.UserId;
                WriteSingle(lTag, null, Sad, {}, true);
            }
            WriteSingle(lAddress, uOffenderAddressSave_OnComplete, uOffenderAddressSave_OnFailure, {"ZoneId":lAddress.ZoneId});

            // update zone address type
            if (lAddress.ZoneId > 0) {
                var lZone = getDataItem(lAddress.ZoneId, 'Zones');
                lZone.AddressTypeId = lAddress.AddressTypeId;
                if (lZone.Shape != 2){
                    lZone.CenterLatitude = lAddress.Latitude;
                    lZone.CenterLongitude = lAddress.Longitude;
                }                
                lZone.TransactionId = moment().format("YYYYMMDDHHmmss");
                lZone.CreatedDateUTC = (new Date(lZone.CreatedDateUTC)).toWcf();
                setDataItem(lZone.Id, 'Zones', lZone);                
                UpdateZones([lZone], function(aParams,aData){
                    mActivityNotification.addNotification('updated zone.....');
                }, function(a,b){
                    mActivityNotification.addNotification('failed updating zone.....');
                }, null, true);
                mActivityNotification.addNotification('Updating Zone.....');

            }
        }
    }

    function uOffenderAddressEditMap_OnDragEnd(aOverlay, aEvent) {
        "use strict";
        mEnrolleesData.EnrolleeAddressGeocodeMatch = false;
        $('#uOffenderAddressLatitudeEdit').val(aEvent.latLng.lat());
        $('#uOffenderAddressLongitudeEdit').val(aEvent.latLng.lng());
    }
    function uOffenderAddressEditMap_Init() {
        "use strict";
        var lSystemPreferences = getUserPreferences(10),
            lDisplayType = 'roadmap';

        if (!isNullOrUndefined(lSystemPreferences['MapDisplayType'])) {
            lDisplayType = lSystemPreferences['MapDisplayType'].Value;
        }
        if (!isNullOrUndefined(mEnrolleesControls.AddressesMap)) {
            mEnrolleesControls.AddressesMap.dispose();
            mEnrolleesControls.AddressesMap = null;
        }
        mEnrolleesControls.AddressesMap = new sumo.maps.GoogleMapControl('uOffenderAddressEditMap', 'uOffenderAddressEditMapPanel', { 'displayType': lDisplayType, 'mapTypeId_OnChange': mapDisplayType_OnChange, 'OnClick': null });
        var lLayerOptions = {
            'renderType': 'marker',
            'doesPlayback': false,
            'isVisible': true,
            'dragEndEventHandler': uOffenderAddressEditMap_OnDragEnd,
            'clickEventHandler': null,
            'zIndexStart': 1000000,
            
        };
        var lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
            lIsInformatics = false;
        if (!isNullOrUndefined(lEnrollee)) {
            lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);

        }
        if(lIsInformatics){
            lLayerOptions['markerImageSize']= { 'width': 70, 'height': 70 };
        }
        mEnrolleesControls.AddressesMap.layerAdd('address', lLayerOptions);
    }

    function enrolleeSetTimelineAddressMarker(aAddress) {
        "use strict";
        var lMarkerData = {},
            lMarker;
        // mEnrolleesControls.TimelineMap.setCenter(aAddress.Latitude, aAddress.Longitude);
        switch (aAddress.AddressTypeId) {
            case 1:
                lMarker = 'Images/Maps/home.png';
                break;
            case 2:
                lMarker = 'Images/Maps/work.png';
                break;
            default:
                lMarker = 'Images/Maps/other.png';
                break;
        }
        lMarkerData = {
            'data': {
                'Data': aAddress,
                'Latitude': aAddress.Latitude,
                'Longitude': aAddress.Longitude
            },
            'latitude': aAddress.Latitude,
            'longitude': aAddress.Longitude,
            'anchor': { 'x': 12, 'y': 12 },
            'iconUri': lMarker,
            'doHover': true
        };


        return lMarkerData;
    }
    function enrolleeSetAddressMarker(aLatitude, aLongitude) {
        "use strict";
        var lMarkerData = [],
            lMarker;
        mEnrolleesControls.AddressesMap.setCenter(aLatitude, aLongitude);
        mEnrolleesControls.AddressesMap.zoom(17);
        switch (parseInt($('#uOffenderAddressAddressTypeIdEdit').val(), 10)) {
            case 1:
                lMarker = 'Images/Maps/home.png';
                break;
            case 2:
                lMarker = 'Images/Maps/work.png';
                break;
            default:
                lMarker = 'Images/Maps/other.png';
                break;
        }
        lMarkerData.push({
            'latitude': aLatitude,
            'longitude': aLongitude,
            'anchor': { 'x': 12, 'y': 12 },
            'iconUri': lMarker,
            'doHover': false
        });
        mEnrolleesControls.AddressesMap.layerSetDataSource('address', lMarkerData);
    }

    function uEnrolleeAddressMapLocate_Complete(aType, aLocation) {
        "use strict";
        var lItem,
            lStreetNumber = '',
            lStreet1 = '',
            lStreet2 = '',
            lCity = '',
            lState = '',
            lZipcode = '',
            lKey,
            lCountry = '';
        if (aType === 'Geocode') {
            if (aLocation !== null) {
                mActivityNotification.addNotification(localizeWrapper('cDefaultCenteringAddress') + aLocation.formated_address);
                $('#uOffenderAddressLatitudeEdit').val(aLocation.center_latitude);
                $('#uOffenderAddressLongitudeEdit').val(aLocation.center_longitude);
                if(mEnrolleesControls.AddressesMap){
                    mEnrolleesControls.AddressesMap.setAddressMarker("uOffenderAddressAddressTypeIdEdit",aLocation.center_latitude.toString(), aLocation.center_longitude.toString());
                }
                if(mEnrolleesControls.EnrolleesMap){
                    mEnrolleesControls.EnrolleesMap.setAddressMarker("uOffenderAddressAddressTypeIdEdit",aLocation.center_latitude.toString(), aLocation.center_longitude.toString());
                } 
                $('.PopupWindow .SaveButton').show();
                $('#uVeritracksModal .SaveButton').show();
                var AddressSearch = new Address(aLocation);
                //mEnrolleesData.AddressEditItem.StreetAddressNumber = lStreetNumber;
                console.log(AddressSearch);
                mEnrolleesData.AddressEditItem.Street1 = AddressSearch.Street1;
                mEnrolleesData.AddressEditItem.Street2 = lStreet2;
                mEnrolleesData.AddressEditItem.City = AddressSearch.City;
                mEnrolleesData.AddressEditItem.State = AddressSearch.State;
                mEnrolleesData.AddressEditItem.Zipcode = AddressSearch.ZipCode;
                mEnrolleesData.AddressEditItem.Country = AddressSearch.Country;
                mEnrolleesData.AddressEditItem.Description = AddressSearch.Description;

                $('#uOffenderAddressStreet1Edit').val("");
                $('#uOffenderAddressStreet1Edit').val(AddressSearch.StreetNumber + " " + AddressSearch.Street1);
                $('#uOffenderAddressCityEdit').val(AddressSearch.City);
                $('#uOffenderAddressZipEdit').val(AddressSearch.ZipCode);
                $('#uOffenderAddressStateEdit').val(AddressSearch.State);
                $('#uOffenderAddressCountryEdit').val(AddressSearch.Country);
                $('#uOffenderAddressDescriptionEdit').val(AddressSearch.Description);

                if ($('#uOffenderGeocodeCheck').is(':visible')) {
                    $('#uOffenderGeocodeCheck').prop('checked', false);
                }
                mEnrolleesControls.AddressesValidator.IsValid();

            } else {
                mActivityNotification.addNotification(localizeWrapper('cDefaultAddressNotGeocoded'));
            }
        } else {
            mActivityNotification.addNotification(localizeWrapper('cDefaultCenteringLatLong') + aLocation.Latitude + ', ' + aLocation.Longitude);
        }
    }

    function uOffenderAddressEditMapLocateButton_OnClick() {
        "use strict";

        var lAddress = '';
        lAddress += $('#uOffenderAddressStreet1Edit').val();
        lAddress += ' ' + $('#uOffenderAddressStreet2Edit').val();
        lAddress += ' ' + $('#uOffenderAddressCityEdit').val();
        lAddress += ' ' + $('#uOffenderAddressStateEdit').val();
        lAddress += ' ' + $('#uOffenderAddressZipEdit').val();
        mEnrolleesData.EnrolleeAddressGeocodeMatch = true;
        if(mEnrolleesControls.EnrolleesMap){
            mEnrolleesControls.EnrolleesMap.locate(lAddress, uEnrolleeAddressMapLocate_Complete);
        }
        if(mEnrolleesControls.AddressesMap){
            
            mEnrolleesControls.AddressesMap.locate(lAddress, uEnrolleeAddressMapLocate_Complete);
        }
    }

    function bluBoxZoneGeocode(aZone) {
        "use strict";
        $(window).resize();
        veritracks.mapping.renderZones(mEnrolleesControls.blueBoxMap, 'Zones', [aZone], populateDeviceClusterZoneDataStation_onComplete, aZone);
    }

    function bluBoxGeocode_Init() {
        "use strict";
        var lDisplayType = 'roadmap',
            lSystemPreferences = getUserPreferences(10);

        if (!isNullOrUndefined(lSystemPreferences['MapDisplayType'])) {
            lDisplayType = lSystemPreferences['MapDisplayType'].Value;
        }
        bluBoxMap_Dispose();
        mEnrolleesControls.blueBoxMap = new sumo.maps.GoogleMapControl('uOffenderBluBoxMapHolder', 'uOffenderBluBoxMaptMapPanel', { 'displayType': lDisplayType, 'mapTypeId_OnChange': mapDisplayType_OnChange, 'OnClick': null });


        mEnrolleesControls.blueBoxMap.layerAdd('Zones', {
            'renderType': 'geometry',
            'doesPlayback': false,
            'isVisible': true,
            'clickEventHandler': null,
            'zIndexStart': 1000000,
            'shapeChangeHandler': offenderZoneMapShape_OnChange
        });

        mEnrolleesControls.blueBoxMap.layerAdd('ZonesNames', {
            'renderType': 'label',
            'doesPlayback': false,
            'isVisible': true,
            'clickEventHandler': null,
            'zIndexStart': 1300000
        });


    }

    function bluBoxMap_Dispose() {
        "use strict";
        if (!isNullOrUndefined(mEnrolleesControls.blueBoxMap)) {
            mEnrolleesControls.blueBoxMap.dispose();
            mEnrolleesControls.blueBoxMap = null;
        }
    }

    function populateDeviceClusterZoneDataStation_onComplete(aParams, aZones, aVertices) {
        var lZone = aZones[0];
        mEnrolleesControls.blueBoxMap.layerSetDataSource('Zones', aZones);
        mEnrolleesControls.blueBoxMap.layerSetDataSource('ZonesNames', veritracks.mapping.prepareEnrolleesZoneLabelOverlayData(aZones));
        mEnrolleesControls.blueBoxMap.fitBounds();
    }

    function enrolleeAddressMustGeocode_Init() {
        "use strict";
        $('.EnrolleeAddressMustGeocode').keyup(function () {
            var lBypassGeocode = $('#uOffenderGeocodeCheck').is(':checked');

            if (!lBypassGeocode){
                $('.PopupWindow .SaveButton').hide();
                $('#uVeritracksModal .SaveButton').hide();
            }
                
            if(mEnrolleesControls.AddressesMap){
                mEnrolleesControls.AddressesMap.layerSetDataSource('address', []);
            }
            if(mEnrolleesControls.EnrolleesMap){
                mEnrolleesControls.EnrolleesMap.layerSetDataSource('address', []);
            }
            $('#uOffenderAddressLatitudeEdit').val(0);
            $('#uOffenderAddressLongitudeEdit').val(0);
        });
    }
    
    /** 
     * Generates an modal or popup in order to creat/edit an Enrollee Address
     * @name enrolleeAddressEditGenerator
     * @function
     * @param {string} aId - the  enrolleeId to default when edit or use -1 for a new entry
     * @param {string} aAddressType - the  address type to default when edit or use -1 for a new entry
     * @param {LatLng} Latlng - A google.maps.LatLng class 
    */
    function enrolleeAddressEditGenerator(aId, aAddressType,Latlng) {
        "use strict";
        var lButtonCommandBar = GenerateButtonCommandBar(),
            lBodyHtml = [],
            lItems = getDataItems('AddressType'),
            lBuilder = new SumoPredicateBuilder(),
            lCountList = [],
            lPreFillAdress = [],
            lHasHome = false,
            lHasWork = false,
            lMapHeight = 0,
            lItem,
            lKey,
            CopyAddress = localizeWrapper('cEnrolleeShowCopyAddress'),
            lAddressLabel = localizeWrapper('cEnrolleeAddAddress'),
            lHeight = $(window).height(),
            showSideMap = isNullOrUndefined(Latlng);
        if(Latlng){
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('address', [])
                
        }
        if (mCopyAddress == 1) {
            CopyAddress = localizeWrapper('cEnrolleeHideCopyAddress');
        }

        if (aId != -1) {
            lAddressLabel = localizeWrapper('cEnrolleeEditAddress');
        }
        if (!isNullOrUndefined(mEnrolleesData.OffenderProfileAddresses) && mEnrolleesData.OffenderProfileAddresses.length > 0) {
            if (aAddressType !== 1) {
                lBuilder.AddNewExpressionConditional('AddressTypeId', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lCountList = query(mEnrolleesData.OffenderProfileAddresses, lBuilder.RootExpression);

                lHasHome = (lCountList.length > 0);
                lBuilder.Clear();
            }
            if (aAddressType !== 2) {
                lBuilder.AddNewExpressionConditional('AddressTypeId', 2, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lCountList = query(mEnrolleesData.OffenderProfileAddresses, lBuilder.RootExpression);

                lHasWork = (lCountList.length > 0);
            }
            lPreFillAdress = mEnrolleesData.OffenderProfileAddresses;
        }
        if (lHeight < 800) {
            lBodyHtml.push('<div style="height:500px; overflow-y:scroll overflow-x: hidden;">');
        }
        lBodyHtml.push('<table>');
        lBodyHtml.push('<tr><td colspan="2"><h2>' + localizeWrapper('cEnrolleeDetails') + '</h2></td></tr>');
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cType') + '</td>');
        lBodyHtml.push('<td class="FormField"><select id="uOffenderAddressAddressTypeIdEdit">');
        for (lKey in lItems) {
            if (lItems.hasOwnProperty(lKey)) {
                lItem = lItems[lKey];
                if ((lItem.Id === 1 && !lHasHome) || (lItem.Id === 2 && !lHasWork) || (lItem.Id > 2)) {
                    lBodyHtml.push('<option value="');
                    lBodyHtml.push(lItem.Id);
                    lBodyHtml.push('">');
                    lBodyHtml.push(AddressTypeFormatter(lItem.Description));
                    lBodyHtml.push('</option>');
                }
            }
        }
        lBodyHtml.push('</select></td>');
        if(showSideMap){
            lBodyHtml.push('<td rowspan="14" valign="top" id="uOffenderAddressEditMapCell"><div style="width: 350px; height: 350px; background-color: silver;" id="uOffenderAddressEditMapPanel"></div></td></tr>');
        }
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cTitle') + '</td>');
        lBodyHtml.push('<td class="FormField"><input type="text" id="uOffenderAddressTitleEdit" class="Validate ValidateRequired ValidateNotEmpty ValidateLength Validate50Length" /></td></tr>');
        lBodyHtml.push('<tr>');
        lBodyHtml.push('<td><h2>' + localizeWrapper('cEnrolleeAddress') + '</h2></td>');
        lBodyHtml.push('<td class="FormField">');
        if (lPreFillAdress.length > 0) {
            lBodyHtml.push('<span style="float:left; padding-top:6px;" id="uAutoFillShowAddress" class="PaperCopyIconProperty Clickable" onclick="uAutoFill_OnClick()">' + CopyAddress + '</span>');
        }
        lBodyHtml.push('<div class="Clickable IconButton LocateButton FloatRight" id="uMapLocateButton" onclick="uOffenderAddressEditMapLocateButton_OnClick()"  title="' + localizeText('cAddressGeocode') + '"></div></td>');
        lBodyHtml.push('</tr>');
        if (lPreFillAdress.length > 0) {
            lBodyHtml.push('<tr id="uAutoFillAddress"');
            if (mCopyAddress == 0) {
                lBodyHtml.push(' style="display:none;"');
            }
            lBodyHtml.push('><td class="FormTitle">' + localizeWrapper('cEnrolleeAddressAutoFill') + '</td>');
            lBodyHtml.push('<td class="FormField"><select id="uOffenderAddressAddressPrefillEdit" onchange="uOffenderAddressAddressPrefill_OnChange()">');
            lBodyHtml.push('<option value"-1"> </option>');
            for (lKey in lPreFillAdress) {
                if (lPreFillAdress.hasOwnProperty(lKey)) {
                    lItem = lPreFillAdress[lKey];
                    lBodyHtml.push('<option value="');
                    lBodyHtml.push(lItem.Id);
                    lBodyHtml.push('">');
                    lBodyHtml.push(lItem.Title);
                    lBodyHtml.push('</option>');
                }
            }
            lBodyHtml.push('</select></td></tr>');
        }
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAddressStreet1') + '</td>');
        lBodyHtml.push('<td class="FormField"><input type="text" id="uOffenderAddressStreet1Edit" class="Validate ValidateRequired ValidateNotEmpty EnrolleeAddressMustGeocode ValidateLength Validate100Length" /></td></tr>');
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAddressStreet2') + '</td>');
        lBodyHtml.push('<td class="FormField"><input type="text" id="uOffenderAddressStreet2Edit" class="EnrolleeAddressMustGeocode Validate ValidateLength Validate100Length" /></td></tr>');
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAddressCity') + '</td>');
        lBodyHtml.push('<td class="FormField"><input type="text" id="uOffenderAddressCityEdit" class="Validate EnrolleeAddressMustGeocode ValidateLength Validate50Length" /></td></tr>');
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAddressState') + '</td>');
        lBodyHtml.push('<td class="FormField"><input type="text" id="uOffenderAddressStateEdit" class="Validate " /></td></tr>');
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAddressZipCode') + '</td>');
        lBodyHtml.push('<td class="FormField"><input type="text" id="uOffenderAddressZipEdit" class="Validate EnrolleeAddressMustGeocode ValidateLength Validate10Length" /></td></tr>');
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAddressCountry') + '</td>');
        lBodyHtml.push('<td class="FormField"><input type="text" id="uOffenderAddressCountryEdit" class="Validate ValidateRequired EnrolleeAddressMustGeocode ValidateLength Validate255Length" value="USA" />');
        lBodyHtml.push('<input type="hidden" id="uOffenderAddressLatitudeEdit" value="0.0" />');
        lBodyHtml.push('<input type="hidden" id="uOffenderAddressLongitudeEdit" value="0.0" />');
        lBodyHtml.push('<input type="hidden" id="uOffenderAddressDescriptionEdit" value="" />');
        lBodyHtml.push('</td></tr>');
       
        if (aId != -1 && lPreFillAdress.length > 0) {
            if (lPreFillAdress[aId].TetheredLocationFlag) {
                lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAddressTether') + '</td><td><input id="uOffenderAddressTetheredLocationFlagEdit" type="checkbox" value="" checked/></td></tr>');
            } else {
                lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAddressTether') + '</td><td><input id="uOffenderAddressTetheredLocationFlagEdit" type="checkbox" value="" /></td></tr>');
            }
            
        } else {
            lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAddressTether') + '</td><td><input id="uOffenderAddressTetheredLocationFlagEdit" type="checkbox" value=""/></td></tr>');
        }

        lBodyHtml.push('<tr><td colspan="2"><hr /></td></tr>');
        lBodyHtml.push('<tr><td colspan="2"><h2>' + localizeWrapper('cEnrolleeAdditionalInfo') + '</h2></td></tr>');
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleePhone') + '</td>');
        lBodyHtml.push('<td class="FormField"><input type="text" id="uOffenderAddressPhoneNumberEdit" class="Validate xxxxxValidatePhone ValidateLength Validate40Length" /></td></tr>');
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAltPhone') + '</td>');
        lBodyHtml.push('<td class="FormField"><input type="text" id="uOffenderAddressPhoneNumber2Edit" class="Validate xxxxxValidatePhone ValidateLength Validate40Length" /></td></tr>');
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeAdditionalInfo') + '</td>');
        lBodyHtml.push('<td class="FormField"><textarea rows="3" cols="30" id="uOffenderAddressAdditionalInfoEdit" class="Validate ValidateLength Validate200Length"></textarea></td></tr>');
        lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cEnrolleeNotes') + '</td>');
        lBodyHtml.push('<td class="FormField"><textarea rows="3" cols="30" id="uOffenderAddressNotesEdit" class="Validate ValidateLength Validate1000Length"></textarea></td>');
        lBodyHtml.push('<!--td></div></td--></tr>');
        lBodyHtml.push('</table>');
        if (lHeight < 500) {
            lBodyHtml.push('</div>');
        }


        if (mEnrolleesData.BluPlusConfiguration && mEnrolleesData.BluPlusConfiguration.TetheredAddressId == aId) {
            var lBuilder = new SumoPredicateBuilder(),
                lEvents,
                lEventIsOpen = 1,
                lKey;

            // for blu+ only
            // should reconsider even having this as an option.
            var lDeviceAssignments = gCurrentDeviceAssignment[mEnrolleesData.OffenderCurrentId];
            lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('EnrolleeId', mEnrolleesData.OffenderCurrentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            var lDeviceCluster = query(getDataItems('DeviceClusterEnrollee'), lBuilder.RootExpression);
            if (ObjectLength(lDeviceCluster) > 0) {
                lBuilder.Clear();
                lBuilder.AddNewExpressionConditional('EnrolleeId', mEnrolleesData.OffenderCurrentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional('MetaEventId', 397, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional('StartDateUTC', lDeviceAssignments[mEnrolleesData.BluPlusConfiguration.Id].StartDate, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
                lEvents = query(getDataItems('Events'), lBuilder.RootExpression);
            }

            if (!isNullOrUndefined(lEvents)) {
                var lDate = new Date().addDays(-7);
                if (+lDeviceAssignments[mEnrolleesData.BluPlusConfiguration.Id].StartDate < lDate)
                    lEventIsOpen = 0;
                else {
                    lEventIsOpen = 1;
                    for (var lKey in lEvents) {
                        if (lEvents.hasOwnProperty(lKey)) {
                            if (lEvents[lKey].IsOpen)
                                lEventIsOpen = 1;
                            else
                                lEventIsOpen = 0;
                        }
                    }
                }
            }
            if (lEventIsOpen) {
                // mEnrolleesData.BluPlusConfiguration = null;
                GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'uOffenderAddressSaveButton_OnClick(' + aId + ')').appendTo(lButtonCommandBar);
            } else {
                GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'uBluBoxNotificationMove(' + aId + ')').appendTo(lButtonCommandBar);
            }
        } else {
            GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'uOffenderAddressSaveButton_OnClick(' + aId + ')').appendTo(lButtonCommandBar);
        }
        GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel',Latlng ? 'uOffenderEnrolleeAddressClose()':'ClosePopup()' ).appendTo(lButtonCommandBar);
        
        if(Latlng){
            DisplayModal(lAddressLabel, lBodyHtml.join(''), 'uOffenderEnrolleeAddressClose()', false,{
                top:'35%',
                right:'20%',
                left: 'auto',
                buttons: lButtonCommandBar.html()
            });
            mEnrolleesControls.AddressesValidator = new Validator('uVeritracksModal', mRegexValidation);

        }else { 
            DisplayPopup(lAddressLabel, lBodyHtml.join(''), lButtonCommandBar, false, false);
            mEnrolleesControls.AddressesValidator = new Validator('uPopupContainer', mRegexValidation);

        }
        if(Latlng){
            document.getElementById('uPopupContainer').innerHTML = ""; // clear form before 
            mEnrolleesControls.EnrolleesMap.mapInit();
            
            setTimeout(function(){
                mEnrolleesControls.EnrolleesMap.setAddressMarker('uOffenderAddressAddressTypeIdEdit',Latlng.lat().toString(), Latlng.lng().toString());
                // listen for AddressTypeChange change
                document.getElementById('uOffenderAddressAddressTypeIdEdit').addEventListener('change',function(e){
                    var lat = document.getElementById('uOffenderAddressLatitudeEdit').value;
                    var lng = document.getElementById('uOffenderAddressLongitudeEdit').value;
                    mEnrolleesControls.EnrolleesMap.setAddressMarker('uOffenderAddressAddressTypeIdEdit',lat, lng);
                });
                mEnrolleesControls.EnrolleesMap.reverseGeocode( Latlng.lat().toString(), Latlng.lng().toString(), function(address,status){
                    $('#uOffenderAddressDescriptionEdit').val(address.Description);
                    $('#uOffenderAddressStreet1Edit').val(address.Street1);
                    $('#uOffenderAddressStreet2Edit').val(address.Street2);
                    $('#uOffenderAddressCityEdit').val(address.City);
                    $('#uOffenderAddressStateEdit').val(address.State);
                    $('#uOffenderAddressZipEdit').val(address.Zip);
                    $('#uOffenderAddressCountryEdit').val(address.Country);
                    mEnrolleesData.EnrolleeAddressGeocodeMatch = true;

                    document.getElementById('uOffenderAddressLatitudeEdit').value = Latlng.lat().toString();
                    document.getElementById('uOffenderAddressLongitudeEdit').value = Latlng.lng().toString();
                    //auto fill verification
                    mEnrolleesControls.AddressesValidator.AutoFillVerify($('#uOffenderAddressStreet1Edit')[0]);
                    mEnrolleesControls.AddressesValidator.AutoFillVerify($('#uOffenderAddressStreet2Edit')[0]);
                    mEnrolleesControls.AddressesValidator.AutoFillVerify($('#uOffenderAddressCityEdit')[0]);
                    mEnrolleesControls.AddressesValidator.AutoFillVerify($('#uOffenderAddressStateEdit')[0]);
                    mEnrolleesControls.AddressesValidator.AutoFillVerify($('#uOffenderAddressZipEdit')[0]);
                    mEnrolleesControls.AddressesValidator.AutoFillVerify($('#uOffenderAddressCountryEdit')[0]);
                    
                }, null);

            });
        } else { 
            uOffenderAddressEditMap_Init();
            
        }
        enrolleeAddressMustGeocode_Init();
        lMapHeight = $('#uOffenderAddressEditMapCell').innerHeight();
        setWidth('#uOffenderAddressEditMapPanel', lMapHeight);
        setHeight('#uOffenderAddressEditMapPanel', lMapHeight);
        if (aId === -1) {
            $('.PopupWindow .SaveButton').hide();
        }
    }

    function uOffenderEnrolleeAddressClose(){
        // Called on enrolleeAddressEditGenerator@fn close 
        ClosePopup();
        mEnrolleesControls.EnrolleesMap.mustGeocodeInit();
    }


    //EMA
    

    function enrolleesEMAEventsIcon_OnClick(aEMAEventId) {
        window.location.hash = "Events.Map." + aEMAEventId;
    }

    function enrolleesEMAEventImageIcon_OnClick(aId) {
        const lButtonBar = GenerateButtonCommandBar(),
            lEMACheckInEventList = mEnrolleesControls.EMAListView.getDataSource(), //didnt work for ie 11
            lEMACheckInEvent = lEMACheckInEventList.find(obj=>obj.Id === aId);
        const is_in_violation = lEMACheckInEvent.CheckInViolationId == 4721;
        const is_image_empty = lEMACheckInEvent.CheckInImage == "";
            // add check if lResult is empty 
        if(!is_image_empty && is_in_violation){
            lButtonBar.append(GenerateButton('Add to Stock', 'Continue', function () {
                ClosePopup();
                uOffenderSetPhoto(lEMACheckInEvent);
            }));
        }
        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel',ClosePopup));
        const no_image_path = 'Images/NoPhoto.png';
        const ema_check_in_image_path = MUGSHOTS+ lEMACheckInEvent.CheckInImage;
        const image_status_html = is_in_violation ?'<div class="CheckInStatusImage">'+lEMACheckInEvent.CheckInViolation+'</div>': '';
        DisplayPopup('Check In Image '+ EnrolleesEMACheckinTime(lEMACheckInEvent.CheckInTimeUTC),`
        <div id="uEnrolleeMobileAppCheckInCheckInImagePopupHolder">
            <img id="EMACheckInImage" src="${is_image_empty?no_image_path:ema_check_in_image_path}" style="height:395px;width:auto;margin:0px auto;">
            ${image_status_html}
        </div>
        `,lButtonBar, false);
    }
    function uOffenderSetPhoto(uEMAEventObj) {
        "use strict";
        var lOffenderPhoto = new OffenderPhoto();
        lOffenderPhoto.EnrolleeId = mEnrolleesData.OffenderProfileCurrent.Id;
        lOffenderPhoto.PhotoUri = uEMAEventObj.CheckInImage;
        lOffenderPhoto.PhotoTypeId = 5;
        lOffenderPhoto.AlcoholImageId = uEMAEventObj.EMAImageId;
        WriteSingle(lOffenderPhoto, uOffenderSetPhoto_OnSuccess , uOffenderSetPhoto_OnFail, null);
        function uOffenderSetPhoto_OnSuccess(aParams, aData) {
            "use strict";
            mActivityNotification.addNotification('Image added to profile');
            loadEnrollePhotos(lOffenderPhoto.EnrolleeId, offenderPhoto_OnSuccess);
        }
        
        function uOffenderSetPhoto_OnFail() {
            "use strict";
            mActivityNotification.addNotification('Not able to add image to profile');
        }
    }
    function uEnrolleesMobileAppCheckInHistoryListView_OnClick() {
        "use strict";

        $('#uEnrolleesMobileAppCheckInHistory').addClass('EMAListViewSelected');
        $('#uEnrolleesMobileAppScheduleRequest').removeClass('EMAListViewSelected');
        $('#uEnrolleesMobileAppSelfReporting').removeClass('EMAListViewSelected');
        var lColumns = [
            { 'id': 'EMAEventIcon', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': EnrolleesEMAEventIconColumnFormatter },
            { 'id': 'TimeOfCheckIN', 'title': localizeWrapper('cEnrolleeMobileAppCheckInTime'), 'dataField': 'CheckInTimeUTC', 'width': 'autoData', 'minWidth': 120, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': EnrolleesEMACheckinTime },
            { 'id': 'CheckInResults', 'title': localizeWrapper('cEnrolleeResults'), 'dataField': 'CheckInStatus', 'width': 'autoData', 'minWidth': 100, 'sortable': true, 'cssClass': null, 'dataType': 'String', 'formatMethod': null },
            { 'id': 'Description', 'title': "Description", 'dataField': 'CheckInViolation', 'width': 'autoData', 'minWidth': 200, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
            { 'id': 'Image', 'title': 'Image', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 80, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': EnrolleesEMAEventImageColumnFormatter },
        ];
        mEnrolleesControls.EMAListView = new sumo.controls.ListView('uEnrolleesMobileAppListView', 'uEnrolleesMobileAppListViewHolder', { 'keyField': 'Id', 'selectMethod': 'none', 'cssClass': 'VeritracksListView', 'canUnselect': true }, lColumns);
        mEnrolleesControls.EMAListView.bind('sort', mEnrolleesMobileAppCheckInHistory_Sort);

        mEnrolleesControls.EMAListView.setDataSource(mEnrolleesData.EMACheckinEvent);
        $("#uEnrolleesMobileAppListViewTable").css("margin-bottom", "27px");
        // initial sort by contact date
        var InitialSort = {};
        InitialSort.Columns = [];
        InitialSort.Columns.push({
            ColumnName: "CheckInTimeUTC",
            Direction: "Descending"
        });
        mEnrolleesControls.EMAListView.sortExpression(InitialSort);
    }

    function EnrolleeProfileEMA_Init(aEnrolleeID){
        uEnrolleesMobileAppCheckInHistoryListView_OnClick()
    }

    //EMA
    function uEnrolleesMobileAppCheckInHistoryListView_Init(aParams, aData) {
        mEnrolleesData.EMACheckinEvent = aData;
        if (mStateManager.Settings()[2] === "EMA") {
            uEnrolleesMobileAppCheckInHistoryListView_OnClick()
        }
    }

    //EMA
    function mEnrolleesMobileAppCheckInHistory_Sort(aParams, aSort) {
        "use strict";
        var lEMACheckinHistory = mEnrolleesControls.EMAListView.getDataSource(),
            lEMACheckinHistorySortedList = [];
        

        lEMACheckinHistorySortedList = aSort.sort(lEMACheckinHistory);
        mEnrolleesControls.EMAListView.setDataSource(lEMACheckinHistorySortedList);
        $("#uEnrolleesMobileAppListViewTable").css("margin-bottom", "27px");
    }

    function EnrolleeMobileAppCheckInButton_OnClick() {
        "use strict";
        var lHtml = [],
            lButtonBar = GenerateButtonCommandBar();

        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeSave'), 'save', uEnrolleeMobileAppCheckIn_OnSave));
        
        DisplayPopup(localizeWrapper('cEnrolleeMobileAppCheckIn'), '<div id="uEnrolleeMobileAppCheckInPopupHolder"></div>', lButtonBar, false);
        populateElement('uEnrolleeMobileAppCheckInPopupHolder', 'Enrollee.Mobile.App.CheckIn.Popup.htm', function () {
            $('#uEnrolleeMobileAppCheckInPopupHolder').append('<img id="uEnrolleeMobileAppCheckInLoadingBar" src="Images/ProgressBar.gif" alt="Loading..."  />')
            GetEMACheckInSchedule(mEnrolleesData.OffenderCurrentId, EnrolleeMobileAppCheckInPopulate_Init, Sad, null);
        });
    }

    //EMA
    function uEnrolleesMobileAppSelfReport_OnClick() {
        "use strict";

        $('#uEnrolleesMobileAppCheckInHistory').removeClass('EMAListViewSelected');
        $('#uEnrolleesMobileAppScheduleRequest').removeClass('EMAListViewSelected');
        $('#uEnrolleesMobileAppSelfReporting').addClass('EMAListViewSelected');
        var lColumns = [
            { 'id': 'Category', 'title': 'Category', 'dataField': 'ChangeReqTypeId', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'String', 'formatMethod': EnrolleesEMASelfReportCategoryColumnFormatter },
            { 'id': 'Update', 'title': 'Request', 'dataField': 'ChangeReqNewValue', 'width': 'autoData', 'minWidth': 80, 'sortable': false, 'maxWidth': 600, 'cssClass': null, 'dataType': 'String', 'formatMethod': EnrolleesEMALargeSringViewFormatter },
            { 'id': 'Status', 'title': 'Status', 'dataField': 'AgentDecision', 'width': 'autoData', 'maxWidth': 80, 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'String', 'formatMethod': EnrolleesEMAChangeRequestStatusColumnFormatter },
            { 'id': 'Approve', 'title': 'Approve', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'cssClass': null, 'dataType': 'String', 'formatMethod': EnrolleesEMASelfReportApprovedColumnFormatter },
            { 'id': 'Deny', 'title': 'Deny', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'cssClass': null, 'dataType': 'String', 'formatMethod': EnrolleesEMASelfReportDenyColumnFormatter },
        ];
        mEnrolleesControls.EMASelfReportListView = new sumo.controls.ListView('uEnrolleesMobileAppListView', 'uEnrolleesMobileAppListViewHolder', { 'keyField': 'Id', 'selectMethod': 'none', 'cssClass': 'VeritracksListView', 'canUnselect': true }, lColumns);
        mEnrolleesControls.EMASelfReportListView.setDataSource(mEnrolleesData.EMASelfReportRequest);
        mEnrolleesControls.EMASelfReportListView.bind('sort', mEnrolleesMobileAppSelfReportRequest_Sort);

        $("#uEnrolleesMobileAppListViewTable").css("margin-bottom", "27px");

        var InitialSort = {};
        InitialSort.Columns = [];
        InitialSort.Columns.push({
            ColumnName: "AgentDecision",
            Direction: "Ascending"
        });
        mEnrolleesControls.EMASelfReportListView.sortExpression(InitialSort);

        for (var i = 0; i < mEnrolleesData.EMASelfReportRequest.length; i++) {
            if (mEnrolleesData.EMASelfReportRequest[i].AgentDecision !== "1") {
                $("#uEMASelfReportApproveButton" + mEnrolleesData.EMASelfReportRequest[i].Id).hide();
                $("#uEMASelfReportDenyButton" + mEnrolleesData.EMASelfReportRequest[i].Id).hide();
            }
        }
    }

    //EMA
    function mEnrolleesMobileAppSelfReportRequest_Sort(aParams, aSort) {
        "use strict";
        var lSelfReportRequest = mEnrolleesControls.EMASelfReportListView.getDataSource(),
            lSelfReportRequestSortedList = [];

        lSelfReportRequestSortedList = aSort.sort(lSelfReportRequest);
        mEnrolleesControls.EMASelfReportListView.setDataSource(lSelfReportRequestSortedList);

        $("#uEnrolleesMobileAppListViewTable").css("margin-bottom", "27px");
        for (var i = 0; i < lSelfReportRequest.length; i++) {
            if (lSelfReportRequest[i].AgentDecision !== "1") {
                $("#uEMASelfReportApproveButton" + lSelfReportRequest[i].Id).hide();
                $("#uEMASelfReportDenyButton" + lSelfReportRequest[i].Id).hide();
            }
        }
    }

    function EnrolleesMobileAppChangeRequest_OnComplete(aParams, aData) {
        "use strict";
        mEnrolleesData.EMASelfReportRequest = aData.filter(function(obj) {
            return obj.ChangeReqTypeId !== "1";
        });
        mEnrolleesData.EMAScheduleRequest = aData.filter(function(obj) {
            return obj.ChangeReqTypeId === "1";
        });

        displayEMANotification();
    }
    function EnrolleesMobileMessagePending_OnComplete(aParams, aData){
        "use strict";
        mEnrolleesData.EMAMessagePending = aData;
        displayEMANotification();
    }

    function displayEMANotification() {
        "use strict";
        var selfReportNotification = 0,
            scheduleRequestNotification = 0, 
            offenderMessagePending = (mEnrolleesData.EMAMessagePending && mEnrolleesData.EMAMessagePending.length) ? mEnrolleesData.EMAMessagePending[0]['Pending']:0;
        if(mEnrolleesData.EMASelfReportRequest){
            for (var i = 0; i < mEnrolleesData.EMASelfReportRequest.length; i++) {
                if (mEnrolleesData.EMASelfReportRequest[i].AgentDecision === "1") {
                    selfReportNotification++
                }
            }
        }
        if(mEnrolleesData.EMAScheduleRequest){ 
            for (var i = 0; i < mEnrolleesData.EMAScheduleRequest.length; i++) {
                if (mEnrolleesData.EMAScheduleRequest[i].AgentDecision === "1") {
                    scheduleRequestNotification++
                }
            }
        }

        if ((selfReportNotification + scheduleRequestNotification + offenderMessagePending) > 0) {
            $('#uEnrolleesMobileAppNotification').text(selfReportNotification + scheduleRequestNotification + offenderMessagePending);
            $('#uEnrolleesMobileAppNotification').addClass('NotificationNumber');
        } else {
            $('#uEnrolleesMobileAppNotification').text("");
            $('#uEnrolleesMobileAppNotification').removeClass('NotificationNumber');
        }

        if (mStateManager.Settings()[2] === "EMA") {
            if (selfReportNotification > 0) {
                $('#uEnrolleesMobileAppSelfReportingNotification').text(selfReportNotification);
                $('#uEnrolleesMobileAppSelfReportingNotification').addClass('NotificationNumber');
            } else {
                $('#uEnrolleesMobileAppSelfReportingNotification').text("");
                $('#uEnrolleesMobileAppSelfReportingNotification').removeClass('NotificationNumber');
            }
            if (scheduleRequestNotification > 0) {
                $('#uEnrolleesMobileAppScheduleRequestNotification').text(scheduleRequestNotification);
                $('#uEnrolleesMobileAppScheduleRequestNotification').addClass('NotificationNumber');
            } else {
                $('#uEnrolleesMobileAppScheduleRequestNotification').text("");
                $('#uEnrolleesMobileAppScheduleRequestNotification').removeClass('NotificationNumber');
            }
            
            if(offenderMessagePending > 0){
                $('#uEnrolleesMobileMessagePendingNotification').text(offenderMessagePending);
                $('#uEnrolleesMobileMessagePendingNotification').addClass('NotificationNumber');
            } else {
                $('#uEnrolleesMobileMessagePendingNotification').text("");
                $('#uEnrolleesMobileMessagePendingNotification').removeClass('NotificationNumber');
            }
        }
    }

    function EMASelfReportWrite_OnClick(aChangeRequestId, aDecision) {
        var lSelfReportRequest = mEnrolleesControls.EMASelfReportListView.getDataSource(),
            lData = new EMAChangeRequest(),
            lResult = lSelfReportRequest.filter(function(obj) {
                return obj.Id === aChangeRequestId;
            }),
            lOffender = GetEnrollee(mEnrolleesData.OffenderCurrentId),
            lAgentList = getDataItems('Agents'),
            lCTUserIdList = [],
            OriAgentData = {},
            lBuilder = new SumoPredicateBuilder();
        
        lBuilder.AddNewExpressionConditional("UserId", gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional("OrganizationId", lOffender.OrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        OriAgentData = query(lAgentList, lBuilder.RootExpression)

        for (var lKey in OriAgentData) {
            if (OriAgentData.hasOwnProperty(lKey)) {
                lData.UserId = OriAgentData[lKey].Id;
            }
        }

        if (aDecision.toString() === "3") {
            mActivityNotification.addNotification('Approving Request.');
        } else if (aDecision.toString() === "2") {
            mActivityNotification.addNotification('Denying Request.');
        }
        lData.AppUserId = gUserDetails.UserId;
        lData.EnrolleeId = mEnrolleesData.OffenderCurrentId;
        lData.Id = lResult[0].Id;
        lData.ChangeReqTypeId = lResult[0].ChangeReqTypeId;
        lData.ChangeReqNewValue = lResult[0].ChangeReqNewValue;
        lData.AgentDecision = aDecision.toString();
        lData.ChangeRequestKeyValue = lResult[0].ChangeRequestKeyValue;
        lData.Description = lResult[0].Description;
        lData.StartDate = lResult[0].StartDate;
        lData.StopDate = lResult[0].StopDate;
        lData.ActionId = lResult[0].ActionId;
        lData.ZoneId = lResult[0].ZoneId;

        WriteSingle(lData, uEnrolleesMobileAppSelfReport_RemoveItem(aChangeRequestId, aDecision), Sad, null, true);
    }

    function uEnrolleesMobileAppSelfReport_RemoveItem(aChangeRequestId, aDecision) {
        for (var i = 0; i < mEnrolleesData.EMASelfReportRequest.length; i++) {
            if (mEnrolleesData.EMASelfReportRequest[i].Id === aChangeRequestId) {
                mEnrolleesData.EMASelfReportRequest[i].AgentDecision = aDecision.toString();
            }
        }
        if (aDecision.toString() === "3") {
            mActivityNotification.addNotification('Approved Request.');
        } else if (aDecision.toString() === "2") {
            mActivityNotification.addNotification('Denied Request.');

        }
        mEnrolleesControls.EMASelfReportListView.setDataSource(mEnrolleesData.EMASelfReportRequest);
        for (var i = 0; i < mEnrolleesData.EMASelfReportRequest.length; i++) {
            if (mEnrolleesData.EMASelfReportRequest[i].AgentDecision !== "1") {
                $("#uEMASelfReportApproveButton" + mEnrolleesData.EMASelfReportRequest[i].Id).hide();
                $("#uEMASelfReportDenyButton" + mEnrolleesData.EMASelfReportRequest[i].Id).hide();
            }
        }

        var InitialSort = {};
        InitialSort.Columns = [];
        InitialSort.Columns.push({
            ColumnName: "AgentDecision",
            Direction: "Ascending"
        });
        mEnrolleesControls.EMASelfReportListView.sortExpression(InitialSort);

        $("#uEnrolleesMobileAppListViewTable").css("margin-bottom", "27px");
        displayEMANotification();
    }

    function uEnrolleesMobileAppScheduleRequest_OnClick() {
        "use strict";
        $('#uEnrolleesMobileAppCheckInHistory').removeClass('EMAListViewSelected');
        $('#uEnrolleesMobileAppScheduleRequest').addClass('EMAListViewSelected');
        $('#uEnrolleesMobileAppSelfReporting').removeClass('EMAListViewSelected');

        var lColumns = [
            { 'id': 'Type', 'title': 'Type', 'dataField': 'ActionId', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'String', 'formatMethod': EnrolleesEMAScheduleTypeColumnFormatter },
            { 'id': 'Zone', 'title': 'Zone', 'dataField': 'ZoneName', 'width': 'autoData', 'minWidth': 100, 'maxWidth': 100, 'sortable': false, 'cssClass': null, 'dataType': 'String', 'formatMethod': null },
            { 'id': 'RequestStart', 'title': 'Request Start', 'dataField': 'StartDateUTC', 'width': 'autoData', 'minWidth': 150, 'maxWidth': 150, 'sortable': false, 'cssClass': null, 'dataType': 'date', 'formatMethod': EnrolleesEMACheckinTime },
            { 'id': 'RequestEnd', 'title': 'Request Stop', 'dataField': 'StopDateUTC', 'width': 'autoData', 'minWidth': 150, 'maxWidth': 150, 'sortable': false, 'cssClass': null, 'dataType': 'date', 'formatMethod': EnrolleesEMACheckinTime },
            { 'id': 'Reason', 'title': 'Reason', 'dataField': 'Description', 'width': 'autoData', 'maxWidth': 400, 'minWidth': 150, 'sortable': false, 'cssClass': null, 'dataType': 'String', 'formatMethod': EnrolleesEMALargeSringViewFormatter },
            { 'id': 'Status', 'title': 'Status', 'dataField': 'AgentDecision', 'width': 'autoData', 'maxWidth': 80, 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'String', 'formatMethod': EnrolleesEMAChangeRequestStatusColumnFormatter },
            { 'id': 'Approved', 'title': 'Approve', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'cssClass': null, 'dataType': 'String', 'formatMethod': EnrolleesEMATimeoutApprovedColumnFormatter },
            { 'id': 'Deny', 'title': 'Deny', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'cssClass': null, 'dataType': 'String', 'formatMethod': EnrolleesEMATimeoutDenyColumnFormatter },
        ];
        mEnrolleesControls.EMATimeoutRequestListView = new sumo.controls.ListView('uEnrolleesMobileAppListView', 'uEnrolleesMobileAppListViewHolder', { 'keyField': 'Id', 'selectMethod': 'none', 'cssClass': 'VeritracksListView', 'canUnselect': true }, lColumns);
        mEnrolleesControls.EMATimeoutRequestListView.setDataSource(mEnrolleesData.EMAScheduleRequest);
        mEnrolleesControls.EMATimeoutRequestListView.bind('sort', mEnrolleesMobileAppTimeoutRequest_Sort);

        $("#uEnrolleesMobileAppListViewTable").css("margin-bottom", "27px");

    }

    //EMA
    function mEnrolleesMobileAppTimeoutRequest_Sort(aParams, aSort) {
        "use strict";
        var lTimeOutRequest = mEnrolleesControls.EMATimeoutRequestListView.getDataSource(),
            lTimeOutRequestSortedList = [];

        lTimeOutRequestSortedList = aSort.sort(lTimeOutRequest);
        mEnrolleesControls.EMATimeoutRequestListView.setDataSource(lTimeOutRequestSortedList);

        $("#uEnrolleesMobileAppListViewTable").css("margin-bottom", "27px");
        for (var i = 0; i < lTimeOutRequest.length; i++) {
            if (lTimeOutRequest[i].AgentDecision !== "1") {
                $("#uEMAScheduleRequestApproveButton" + lTimeOutRequest[i].Id).hide();
                $("#uEMAScheduleRequestDenyButton" + lTimeOutRequest[i].Id).hide();
            }
        }
    }
    
    function EMAScheduleWrite_OnClick(aChangeRequestId, aDecision) {
        var lScheduleRequest = mEnrolleesControls.EMATimeoutRequestListView.getDataSource(),
            lResult = lScheduleRequest.filter(function(obj) {return obj.Id === aChangeRequestId;}),
            lData =new EMAChangeRequest(lResult[0]),
            lOffender = GetEnrollee(mEnrolleesData.OffenderCurrentId),  
            lIsBlueTagDeviceAssigned =  EnrolleeHelper.IsEnrolleeAssignedToDevice(mEnrolleesData.OffenderCurrentId,[103,151]), // BlueTag devices.  
            lDisplayReasonModal =  veritracks.core.GetOriProperty(lOffender.OrganizationId,'ema_change_request_reason'); //TODO: THis will be removed once Enrollink 2.0 is available
            lData.UserId = AgentHelper.getId(lOffender.OranizationId); //Get AppUserId
            lData.AppUserId = gUserDetails.UserId;
            lData.EnrolleeId = mEnrolleesData.OffenderCurrentId;
            lData.AgentDecision = aDecision.toString();
            lDisplayReasonModal?EnrrollinkReasonModalComponent():uSaveChangeRequest();
        function uSaveChangeRequest(){
            if (aDecision.toString() === "3") {
                mActivityNotification.addNotification('Approving Request.');
            } else if (aDecision.toString() === "2") {
                mActivityNotification.addNotification('Denying Request.');
            }
            WriteSingle(lData, uEnrolleesMobileAppSchedule_RemoveItem(aChangeRequestId, aDecision,lData), Sad, null, true);
            ClosePopup();
        }
        //Enrollink Reason Modal
        //TODO: Descope when possible 
        function EnrrollinkReasonModalComponent(){
            var htmlOptions = {
                "3":[ '<div id="uEnrolleeMobileAppReasonPopup" class="OffenderProfileHasEnrolleeMobileApp">',
                    '<p>Check if you would like to automatically request an Enrollink Check-In at the requested time.</p>',
                       '<span class="FormTitle">',
                            '<span class="cLocalize cEMARegistationTitle">Check-In Required</span>',
                        '</span>',
                         '<span class="FormField">',
                            '<input class="Validate" type="checkbox" id="uEnrolleeMobileAppReasonPopupCheckInRequired" checked />',
                        '</span>',
                    '</div>'].join('')
            };
            //
            var lHtml = [
                '<div id="uEnrolleeMobileAppReasonPopupHolder">',
                    '<p>Please provide a reason if applicable, this will be visible to your enrollee</p>',
                    '<textarea id="uEnrolleeMobileAppReasonPopupNoteTextArea" class="AddNoteTextArea" style="width: 490px;"></textarea>',
                    htmlOptions[aDecision.toString()] && !lIsBlueTagDeviceAssigned? htmlOptions[aDecision.toString()]:'',
                '</div>'
            ],lButtonBar = GenerateButtonCommandBar();
            lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeConfirm'), 'Continue', function () {
                // Execute on Confirm
                if(aDecision.toString() === "3" && !lIsBlueTagDeviceAssigned){
                    lData.CheckInRequired = +document.getElementById('uEnrolleeMobileAppReasonPopupCheckInRequired').checked;
                }
                lData.AgentNotes = document.getElementById('uEnrolleeMobileAppReasonPopupNoteTextArea').value;
                uSaveChangeRequest();
            })).append(GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel',ClosePopup));
            DisplayPopup(localizeWrapper('cEnrolleeMobileAppRequestAgentResponseTitle'),lHtml.join(' '), lButtonBar, false);
        }
    }   

    function uEnrolleesMobileAppSchedule_RemoveItem(aChangeRequestId, aDecision,aData) {
        for (var i = 0; i < mEnrolleesData.EMAScheduleRequest.length; i++) {
            if (mEnrolleesData.EMAScheduleRequest[i].Id === aChangeRequestId) {
                mEnrolleesData.EMAScheduleRequest[i].AgentDecision = aDecision.toString();
                mEnrolleesData.EMAScheduleRequest[i].CheckInRequired = aData.CheckInRequired;
                mEnrolleesData.EMAScheduleRequest[i].AgentNotes = aData.AgentNotes;
            }
        }
        if (aDecision.toString() === "3") {
            mActivityNotification.addNotification('Approved Request.');
        } else if (aDecision.toString() === "2") {
            mActivityNotification.addNotification('Denied Request.');

        }
        mEnrolleesControls.EMATimeoutRequestListView.setDataSource(mEnrolleesData.EMAScheduleRequest);
        for (var i = 0; i < mEnrolleesData.EMAScheduleRequest.length; i++) {
            if (mEnrolleesData.EMAScheduleRequest[i].AgentDecision !== "1") {
                $("#uEMAScheduleRequestApproveButton" + mEnrolleesData.EMAScheduleRequest[i].Id).hide();
                $("#uEMAScheduleRequestDenyButton" + mEnrolleesData.EMAScheduleRequest[i].Id).hide();
            }
        }
        displayEMANotification();
    }

    //EMA
    function uEnrolleesMobileAppQuestionnaire_OnClick() {
        "use strict";
        var lButtonBar = GenerateButtonCommandBar();

        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeSave'), 'EMAQuestionnaireSaveButton Save', function () {
            ClosePopup();
        }));
        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeMobileAppRequestQuestionnaire'), 'EMAQuestionnaireRequest', function () {
            ClosePopup();
        }));

        DisplayPopup(localizeWrapper('cEnrolleeMobileAppQuestionnaire'), '<div id="uEnrolleeMobileAppQuestionnairePopupHolder"></div>', lButtonBar, false);
        populateElement('uEnrolleeMobileAppQuestionnairePopupHolder', 'Enrollee.Mobile.App.Questionnaire.Popup.htm', EnrolleeMobileAppQuestionnairePopulate_Init);
    }
    var uVideoCall = null;
    
    function EnrolleeMobileAppVideoCallButton_OnClick(){
        var elm = document.getElementById('uEnrolleesMobileAppVideoCall');
        elm.setAttribute('loading','')
        //Validate if Enrollink is Enabled.. if is disabled then we can't continue
        //Validate if Number is given. 
        if(uVideoCall == null || uVideoCall.closed){
            var uRoomName = EMAData.CellPhoneNumber;
        
            veritracks.security.controller.getJWT(function(token){
                var api_room_url = "video/room?roomName=" + uRoomName + ''; 
                console.log(api_room_url); 
                // callAjaxAPI('GET',token,api_room_url, null,function(aParam,aRoomInfo){
                //     console.log('room info',aRoomInfo);
                //     if(aRoomInfo.status.includes("")){
                //         alert('Can not perform video call at this time. Another video call is in progress with enrollee.');
                //         elm.removeAttribute('loading');
                //     }
                    
                //   }, function(aParam,aData){
                //     //failure
                    
                //     elm.removeAttribute('loading');
                //     console.log('room info', aData.status, aData.responseText);
                   
                // },{}, false);

                 var api_videocall_url = "video/" + uRoomName + "/agentId_" + gUserDetails.UserId;
                    console.log(api_videocall_url);
                        callAjaxAPI('GET',
                            token,
                            api_videocall_url,
                            null,
                        function(aParam,aTwilioToken){
                            //success
                                uVideoCall = window.open('Interface/Enrollees.Enrollink.Video.html',"VideoCall","popup=yes;width=200;heigth=200;titlebar=no,status=no,location=no,menubar=no,scrollbars=no,resizable=no;");
                                uVideoCall.opener.aTwilioToken = aTwilioToken;
                                uVideoCall.opener.aTwilioRoomName = uRoomName;
                                uVideoCall.opener.uEnrolleeId = mEnrolleesData.OffenderCurrentId;
                                uVideoCall.opener.uEnrolleeFullName = GetEnrollee(mEnrolleesData.OffenderCurrentId).FullName;
                                uVideoCall.opener.uAgentFullName = gUserDetails.FullName;
                                window.postMessage(aTwilioToken,document.location.origin + '/Interface/Enrollees.Enrollink.Video.html')
                                
                                elm.removeAttribute('loading')
                                var lOnDemandCall = new EMAOnDemandCheckin();
                                lOnDemandCall.AppUserId = gUserDetails.UserId;
                                lOnDemandCall.Id = mEnrolleesData.OffenderCurrentId;
                                lOnDemandCall.AgentId = gUserDetails.UserId;
                                lOnDemandCall.IsVideoCall = 1;
                                lOnDemandCall.AgentName = gUserDetails.FullName;
                                WriteSingle(lOnDemandCall, function(e){
                                    
                                }, Sad,null, true);
                                
                            }, function(aParam,aData){
                            //failure
                            elm.removeAttribute('loading');
                            console.log(aData);
                        },{}, false);
            
                
            })
        }else {
            uVideoCall.focus();
            elm.removeAttribute('loading')
        }
    }
    //EMA On Demand Popup
    function EnrolleeMobileAppOnDemandCheckInButton_OnClick() {
        "use strict";
        var lHtml = [],
            lButtonBar = GenerateButtonCommandBar();

        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeConfirm'), 'Confirm', function () {
            //call proc 
            var lStartTime = moment.utc()._d,
                lEndTime = moment.utc()._d,
                lTimeZone = getEnrolleeTimeZone(mEnrolleesData.OffenderCurrentId),
                lCheckInData = new EMAEnrolleePeriodicCheckin(),
                lDays = ['IsSunday', 'IsMonday', 'IsTuesday', 'IsWednesday', 'IsThursday', 'IsFriday', 'IsSaturday'],
                lDayName = lDays[lStartTime.getDay()],
                lOnDemandCheckinRequest = new EMAOnDemandCheckin();
            mActivityNotification.addNotification("Sending on demand location verification.");
            lOnDemandCheckinRequest.AppUserId = gUserDetails.UserId;
            lOnDemandCheckinRequest.Id = mEnrolleesData.OffenderCurrentId;
            mActivityNotification.addNotification("Saving location verification schedule.");
            lCheckInData.AppUserId = gUserDetails.UserId
            lCheckInData.Id = mEnrolleesData.OffenderCurrentId;
            lStartTime = convertTimeToUTC(lStartTime, lTimeZone.TimeZoneName);
            lCheckInData.StartTime = lStartTime.toTimeString().slice(0, 8);
            lEndTime = convertTimeToUTC(lEndTime, lTimeZone.TimeZoneName);
            lCheckInData.EndTime = lEndTime.toTimeString().slice(0, 8);
            lCheckInData.CheckinTypeID = 1;
            lCheckInData[lDayName] = 1;
            var lOnDemandCheckInAndNotification = [lOnDemandCheckinRequest,lCheckInData]
            WriteMultiple(lOnDemandCheckInAndNotification, EnrolleeMobileAppOnDemand_OnSuccess(), Sad,null, true);
        }));
        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', function () {
            ClosePopup();
        }));

        DisplayPopup(localizeWrapper('cEnrolleeMobileAppConfirmOnDemand'), '<div id="uEnrolleeMobileAppCheckInOnDemandPopupHolder"><p>Please confirm you want to send a on demand location verification.</p></div>', lButtonBar, false);
    }

    function EnrolleeMobileAppOnDemand_OnSuccess() {
        mActivityNotification.addNotification("On demand location verification sent.");
        ClosePopup();
    }


        //EMA
    function EnrolleeMobileAppCheckInPopulate_Init(aParams, aData) {
        var lHtml = [],
            CheckInHolder = $('#uEnrolleeMobileAppCheckInContentHolder');

        lHtml.push('<table style="table-layout: fixed; max-width: 100%; min-width: 100%;">');
        lHtml.push('<tr><td><h1>Periodic Verification</h1></td></tr>')
        lHtml.push('<tr><td><div id="uEnrolleeMobileAppEnrollCheckInSelectionContainer" style="margin-bottom: 5px"><h3 style="display: block; margin-left: 20px" class="Editable">Type</h3>');
        lHtml.push('<select style="margin-left: 20px; margin-top: 5px; max-width: 150px; min-width: 150px;" id="uEnrolleeMobileAppEnrollCheckInSelection" onChange="EnrolleeMobileAppCheckInPeriodic_Update(parseInt(this.value))">');
        lHtml.push('<option value="2" selected>Fixed</option>');
        lHtml.push('<option value="3">Random</option>');
        lHtml.push('</select></div>');
        lHtml.push('<div id="uEnrolleeMobileAppPeriodicCheckInSettings">');
        lHtml.push('<div id="uEnrolleeMobileAppPeriodicCheckInDisplay2" ><table style="table-layout: fixed; max-width: 100%; min-width: 100%;"><tr><td>');
        lHtml.push('<div id="uEnrolleeMobileAppCheckInFixedIntervalContainer"><h3 style="display: block; margin-left: 20px;">Verification Every</h3>');
        lHtml.push('<select style="margin-left: 20px; margin-top: 5px; max-width: 150px; min-width: 150px;" id="uEnrolleeMobileAppCheckInFixedInterval">');
        for (var i = 15; i < 60; i = i + 15) {
            lHtml.push('<option value="' + i + '" >' + i + ' Minutes</option>');
        }
        lHtml.push('<option value="60">1 Hour</option>');
        lHtml.push('<option value="90">1.5 Hours </option>');
        for (var i = 2; i < 5; i++) {
            lHtml.push('<option value="' + i * 60 + '" >' + i + ' Hours</option>');
            lHtml.push('<option value="' + ((i * 60) + 30) + '" >' + i + '.5 Hours</option>');
        }
        lHtml.pop();
        lHtml.push('</select></div></td></tr></table></div>');
        lHtml.push('<div id="uEnrolleeMobileAppPeriodicCheckInDisplay3" style="display: none"><table style="table-layout: fixed; max-width: 100%; min-width: 100%;"><tr><td>');
        lHtml.push('<div id="uEnrolleeMobileAppCheckInRandomIntervalContainer"><h3 style="display: block; margin-left: 20px;">Number of Verifications</h3>');
        lHtml.push('<select style="margin-left: 20px; margin-top: 5px; max-width: 150px; min-width: 150px;" id="uEnrolleeMobileAppCheckInRandomInterval">');
        for (var i = 1; i < 11; i++) {
            lHtml.push('<option id="EMACheckinRandomSelection' + i + '" value="' + i + '" >' + i + '</option>');
        }
        lHtml.push('</select></div></td></tr></table></div></div></td>');
        lHtml.push('<td valign="top" id="uEMACheckInDayOfWeekHolder" >');
        lHtml.push('<div class="EMAStatusTitle NoWrap">Day of Week</div>');
        lHtml.push('<div><input type="checkbox" id="uEMACheckInScheduleRecurrenceAllWeek" onclick="checkOrUncheckEMADaysOfWeek()" class="ValidateOnClick" /><label for="uEMACheckInScheduleRecurrenceAllWeek"> All Week</label></div>');
        lHtml.push('<div><input type="checkbox" id="uEMACheckInScheduleRecurrenceSunday" onclick="adjustDaysOfWeekEMACheckBoxes()" /><label for="uEMACheckInScheduleRecurrenceSunday"> Sunday</label></div>');
        lHtml.push('<div><input type="checkbox" id="uEMACheckInScheduleRecurrenceMonday" onclick="adjustDaysOfWeekEMACheckBoxes()" /><label for="uEMACheckInScheduleRecurrenceMonday"> Monday</label></div>');
        lHtml.push('<div><input type="checkbox" id="uEMACheckInScheduleRecurrenceTuesday" onclick="adjustDaysOfWeekEMACheckBoxes()" /><label for="uEMACheckInScheduleRecurrenceTuesday"> Tuesday</label></div>');
        lHtml.push('<div><input type="checkbox" id="uEMACheckInScheduleRecurrenceWednesday" onclick="adjustDaysOfWeekEMACheckBoxes()" /><label for="uEMACheckInScheduleRecurrenceWednesday"> Wednesday</label></div>');
        lHtml.push('<div><input type="checkbox" id="uEMACheckInScheduleRecurrenceThursday" onclick="adjustDaysOfWeekEMACheckBoxes()" /><label for="uEMACheckInScheduleRecurrenceThursday"> Thursday</label></div>');
        lHtml.push('<div><input type="checkbox" id="uEMACheckInScheduleRecurrenceFriday" onclick="adjustDaysOfWeekEMACheckBoxes()" /><label for="uEMACheckInScheduleRecurrenceFriday"> Friday</label></div>');
        lHtml.push('<div><input type="checkbox" id="uEMACheckInScheduleRecurrenceSaturday" onclick="adjustDaysOfWeekEMACheckBoxes()" /><label for="uEMACheckInScheduleRecurrenceSaturday"> Saturday</label></div>');
        lHtml.push('</td></tr>');
        lHtml.push('<tr id="uEnrolleeMobileAppPeriodicCheckInTime">');
        lHtml.push('<td style="padding-bottom: 30px"><div style="margin-left: 20px;" id="uEnrolleeMobileAppPeriodicCheckInStartTime"><h3 class="Editable">Start Time</h3>')
        lHtml.push('<input type="text" id="uEnrolleeMobileAppCheckInStartTime" style="display: inline-block;" value="6:30 AM"></div></td>');
        lHtml.push('<td style="padding-bottom: 30px"><div id="uEnrolleeMobileAppPeriodicCheckInEndTime" ><h3 class="Editable">End Time</h3>');
        lHtml.push('<input type="text" id="uEnrolleeMobileAppCheckInEndTime" value="8:00 PM">');
        lHtml.push('</div></td></tr></table>');
        CheckInHolder.html('');
        $('#uEnrolleeMobileAppCheckInLoadingBar').remove();
        CheckInHolder.append($(lHtml.join('')));
        $('#uEnrolleeMobileAppCheckInStartTime').ptTimeSelect({
            'zIndex': 100000,
            'onFocusDisplay': true,
            'onClose': EnrolleeMobileAppCheckInRandom_Update
        });
        $('#uEnrolleeMobileAppCheckInEndTime').ptTimeSelect({
            'zIndex': 100000,
            'onFocusDisplay': true,
            'onClose': EnrolleeMobileAppCheckInRandom_Update
        });
        var lTimeZone = getEnrolleeTimeZone(mEnrolleesData.OffenderCurrentId);        if (aData[0]) {
            $('#uEnrolleeMobileAppPeriodicCheckInDisplay2').hide();
            $('#uEnrolleeMobileAppPeriodicCheckInDisplay3').hide();
            $("#uEnrolleeMobileAppEnrollCheckInSelection").val(aData[0].CheckinTypeID);
            $("#uEnrolleeMobileAppCheckInFixedInterval").val(aData[0].CheckinInterval);
            $("#uEnrolleeMobileAppCheckInRandomInterval").val(aData[0].NumberOfCheckIn);
            var lTime = displayFixedTimeZoneTime(new Date('01 Jan 2001 ' + aData[0].StartTime),lTimeZone.TimeZoneName);
            $('#uEnrolleeMobileAppCheckInStartTime').val(lTime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }));
            lTime = displayFixedTimeZoneTime(new Date('01 Jan 2001 ' + aData[0].EndTime),lTimeZone.TimeZoneName);
            $('#uEnrolleeMobileAppCheckInEndTime').val(lTime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }));

            for (var i = 0; i < aData.length; i++) {
                if (aData[i].IsSunday === 1) {
                    $('#uEMACheckInScheduleRecurrenceSunday').prop('checked', true);
                } else if (aData[i].IsMonday === 1) {
                    $('#uEMACheckInScheduleRecurrenceMonday').prop('checked', true);
                } else if (aData[i].IsTuesday === 1) {
                    $('#uEMACheckInScheduleRecurrenceTuesday').prop('checked', true);
                } else if (aData[i].IsWednesday === 1) {
                    $('#uEMACheckInScheduleRecurrenceWednesday').prop('checked', true);
                } else if (aData[i].IsThursday === 1) {
                    $('#uEMACheckInScheduleRecurrenceThursday').prop('checked', true);
                } else if (aData[i].IsFriday === 1) {
                    $('#uEMACheckInScheduleRecurrenceFriday').prop('checked', true);
                } else if (aData[i].IsSaturday === 1) {
                    $('#uEMACheckInScheduleRecurrenceSaturday').prop('checked', true);
                }
            } 
            adjustDaysOfWeekEMACheckBoxes();
            EnrolleeMobileAppCheckInRandom_Update();
            $('#uEnrolleeMobileAppEnrollCheckInSelectionContainer').show();
            $('#uEMACheckInDayOfWeekHolder').show();
            $('#uEnrolleeMobileAppPeriodicCheckInSettings').show();
            $('#uEnrolleeMobileAppPeriodicCheckInTime').show();
            if (aData[0].CheckinTypeID === 2) {
                $('#uEnrolleeMobileAppPeriodicCheckInDisplay2').show();
                $("#uEnrolleeMobileAppCheckInFixedInterval").show();
            } else {
                $('#uEnrolleeMobileAppPeriodicCheckInDisplay3').show();
                $("#uEnrolleeMobileAppCheckInRandomInterval").show();
            }
        }
    }

    function checkOrUncheckEMADaysOfWeek() {
        "use strict";
        if (!isNullOrUndefined($('#uEMACheckInScheduleRecurrenceAllWeek').attr('checked'))) {
            $('#uEMACheckInScheduleRecurrenceSunday').prop('checked', true);
            $('#uEMACheckInScheduleRecurrenceMonday').prop('checked', true);
            $('#uEMACheckInScheduleRecurrenceTuesday').prop('checked', true);
            $('#uEMACheckInScheduleRecurrenceWednesday').prop('checked', true);
            $('#uEMACheckInScheduleRecurrenceThursday').prop('checked', true);
            $('#uEMACheckInScheduleRecurrenceFriday').prop('checked', true);
            $('#uEMACheckInScheduleRecurrenceSaturday').prop('checked', true);
            $('#uEMACheckInDayOfWeekHolder').addClass('ValidateSuccess');
        } else {
            $('#uEMACheckInScheduleRecurrenceSunday').prop('checked', false);
            $('#uEMACheckInScheduleRecurrenceMonday').prop('checked', false);
            $('#uEMACheckInScheduleRecurrenceTuesday').prop('checked', false);
            $('#uEMACheckInScheduleRecurrenceWednesday').prop('checked', false);
            $('#uEMACheckInScheduleRecurrenceThursday').prop('checked', false);
            $('#uEMACheckInScheduleRecurrenceFriday').prop('checked', false);
            $('#uEMACheckInScheduleRecurrenceSaturday').prop('checked', false);
            $('#uEMACheckInDayOfWeekHolder').removeClass('ValidateSuccess');
        }
    }

    function adjustDaysOfWeekEMACheckBoxes() {
        "use strict";
        if ($('#uEMACheckInScheduleRecurrenceSunday').attr('checked') ||
            $('#uEMACheckInScheduleRecurrenceMonday').attr('checked') ||
            $('#uEMACheckInScheduleRecurrenceTuesday').attr('checked') ||
            $('#uEMACheckInScheduleRecurrenceWednesday').attr('checked') ||
            $('#uEMACheckInScheduleRecurrenceThursday').attr('checked') ||
            $('#uEMACheckInScheduleRecurrenceFriday').attr('checked') ||
            $('#uEMACheckInScheduleRecurrenceSaturday').attr('checked')
        ) {
            $('#uEMACheckInDayOfWeekHolder').addClass('ValidateSuccess')
        } else {
            $('#uEMACheckInDayOfWeekHolder').removeClass('ValidateSuccess')
        }
        if ($('#uEMACheckInScheduleRecurrenceSunday').attr('checked') &&
            $('#uEMACheckInScheduleRecurrenceMonday').attr('checked') &&
            $('#uEMACheckInScheduleRecurrenceTuesday').attr('checked') &&
            $('#uEMACheckInScheduleRecurrenceWednesday').attr('checked') &&
            $('#uEMACheckInScheduleRecurrenceThursday').attr('checked') &&
            $('#uEMACheckInScheduleRecurrenceFriday').attr('checked') &&
            $('#uEMACheckInScheduleRecurrenceSaturday').attr('checked')
        ) {
            $('#uEMACheckInScheduleRecurrenceAllWeek').prop('checked', true);
        } else {
            $('#uEMACheckInScheduleRecurrenceAllWeek').prop('checked', false);
        }
    }

    //EMA
    function EnrolleeMobileAppCheckInPeriodic_Update(selection) {
        $("#uEnrolleeMobileAppPeriodicCheckInDisplay2").hide();
        $("#uEnrolleeMobileAppPeriodicCheckInDisplay3").hide();
        $("#uEnrolleeMobileAppPeriodicCheckInDisplay" + selection).show();
    }

    //EMA
    function EnrolleeMobileAppCheckInRandom_Update() {
        var lStartTime = new Date('01 Jan 2001 ' + $('#uEnrolleeMobileAppCheckInStartTime').val()),
            lEndTime = new Date('01 Jan 2001 ' + $('#uEnrolleeMobileAppCheckInEndTime').val()),
            hours = 0;

        if (lEndTime.getTime() < lStartTime.getTime()) {
            lEndTime = new Date(lStartTime);
            lEndTime.setHours(lEndTime.getHours() + 1);
            $('#uEnrolleeMobileAppCheckInEndTime').val(lEndTime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }))
        } else if (lEndTime.getTime() === lStartTime.getTime()) {
            lEndTime = new Date(lStartTime);
            lEndTime.setMinutes(lEndTime.getMinutes() + 15);
            $('#uEnrolleeMobileAppCheckInEndTime').val(lEndTime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }))
        }
        hours = Math.abs(lEndTime - lStartTime) / 36e5;
        for (var i = 1; i < 11; i++) {
            $('#EMACheckinRandomSelection' + i).hide();
        }
        if (hours <= 0.5) {
            $('#EMACheckinRandomSelection1').show();
            if (parseInt($('#uEnrolleeMobileAppCheckInRandomInterval').val()) > 1) {
                $('#uEnrolleeMobileAppCheckInRandomInterval').val('1')
            }
        } else if (hours <= 0.75) {
            $('#EMACheckinRandomSelection1').show();
            $('#EMACheckinRandomSelection2').show();
            if (parseInt($('#uEnrolleeMobileAppCheckInRandomInterval').val()) > 2) {
                $('#uEnrolleeMobileAppCheckInRandomInterval').val('2')
            }
        } else if (hours <= 1.25) {
            $('#EMACheckinRandomSelection1').show();
            $('#EMACheckinRandomSelection2').show();
            $('#EMACheckinRandomSelection3').show();
            if (parseInt($('#uEnrolleeMobileAppCheckInRandomInterval').val()) > 3) {
                $('#uEnrolleeMobileAppCheckInRandomInterval').val('3')
            }
        } else if (hours <= 1.75) {
            for (var i = 1; i < 5; i++) {
                $('#EMACheckinRandomSelection' + i).show();
            }
            if (parseInt($('#uEnrolleeMobileAppCheckInRandomInterval').val()) > 4) {
                $('#uEnrolleeMobileAppCheckInRandomInterval').val('4')
            }
        } else if (hours <= 2.25) {
            for (var i = 1; i < 7; i++) {
                $('#EMACheckinRandomSelection' + i).show();
            }
            if (parseInt($('#uEnrolleeMobileAppCheckInRandomInterval').val()) > 6) {
                $('#uEnrolleeMobileAppCheckInRandomInterval').val('6')
            }
        } else if (hours <= 2.75) {
            for (var i = 1; i < 8; i++) {
                $('#EMACheckinRandomSelection' + i).show();
            }
            if (parseInt($('#uEnrolleeMobileAppCheckInRandomInterval').val()) > 7) {
                $('#uEnrolleeMobileAppCheckInRandomInterval').val('7')
            }
        } else if (hours < 3) {
            for (var i = 1; i < 9; i++) {
                $('#EMACheckinRandomSelection' + i).show();
            }
            if (parseInt($('#uEnrolleeMobileAppCheckInRandomInterval').val()) > 8) {
                $('#uEnrolleeMobileAppCheckInRandomInterval').val('8')
            }
        } else if (hours <= 3.25) {
            for (var i = 1; i < 10; i++) {
                $('#EMACheckinRandomSelection' + i).show();
            }
            if (parseInt($('#uEnrolleeMobileAppCheckInRandomInterval').val()) > 9) {
                $('#uEnrolleeMobileAppCheckInRandomInterval').val('9')
            }
        } else {
            for (var i = 1; i < 11; i++) {
                $('#EMACheckinRandomSelection' + i).show();
            }
        }
    }

    //EMA 
    function uEnrolleeMobileAppCheckIn_OnSave() {
        "use strict";
        var lStartTime = new Date('01 Jan 2001 ' + $('#uEnrolleeMobileAppCheckInStartTime').val()),
            lEndTime = new Date('01 Jan 2001 ' + $('#uEnrolleeMobileAppCheckInEndTime').val()),
            lTimeZone = getEnrolleeTimeZone(mEnrolleesData.OffenderCurrentId),
            lCheckInData = new EMAEnrolleePeriodicCheckin();

        mActivityNotification.addNotification("Saving location verification schedule.");
        lCheckInData.AppUserId = gUserDetails.UserId
        lCheckInData.Id = mEnrolleesData.OffenderCurrentId;
        lStartTime = convertTimeToUTC(lStartTime, lTimeZone.TimeZoneName);
        lCheckInData.StartTime = lStartTime.toTimeString().slice(0, 8);
        lEndTime = convertTimeToUTC(lEndTime, lTimeZone.TimeZoneName);
        lCheckInData.EndTime = lEndTime.toTimeString().slice(0, 8);
        lCheckInData.CheckinTypeID = parseInt($('#uEnrolleeMobileAppEnrollCheckInSelection').val(), 10);
        if (lCheckInData.CheckinTypeID === 2) {
            lCheckInData.CheckinInterval = parseInt($('#uEnrolleeMobileAppCheckInFixedInterval').val(), 10);
        } else {
            lCheckInData.NumberOfCheckIn = parseInt($('#uEnrolleeMobileAppCheckInRandomInterval').val(), 10);
        }
        if ($('#uEMACheckInScheduleRecurrenceSunday').is(':checked')) {
            lCheckInData.IsSunday = 1
        }
        if ($('#uEMACheckInScheduleRecurrenceMonday').is(':checked')) {
            lCheckInData.IsMonday = 1
        }
        if ($('#uEMACheckInScheduleRecurrenceTuesday').is(':checked')) {
            lCheckInData.IsTuesday = 1
        }
        if ($('#uEMACheckInScheduleRecurrenceWednesday').is(':checked')) {
            lCheckInData.IsWednesday = 1
        }
        if ($('#uEMACheckInScheduleRecurrenceThursday').is(':checked')) {
            lCheckInData.IsThursday = 1
        }
        if ($('#uEMACheckInScheduleRecurrenceFriday').is(':checked')) {
            lCheckInData.IsFriday = 1
        }
        if ($('#uEMACheckInScheduleRecurrenceSaturday').is(':checked')) {
            lCheckInData.IsSaturday = 1
        }

        WriteSingle(lCheckInData, uEnrolleeMobileAppCheckIn_OnSuccess(), Sad, null, true);
    }

    function uEnrolleeMobileAppCheckIn_OnSuccess() {
        mActivityNotification.addNotification("Location verification schedule saved.");
        ClosePopup();
    }

    //EMA
    function EnrolleeMobileAppQuestionnairePopulate_Init() {
        //get data

        EMAQuestionnaireOnChange("Create");
    }

    //EMA
    function EMAQuestionnaireOnChange(aTab) {
        "use strict";
        var lFilename = 'Enrollee.Mobile.App.Questionnaire.Popup.' + aTab + '.htm',
            lMethodName = window['EnrolleeMobileAppQuestionnairePopulate' + aTab],
            template = 0; //need to get the template value

        $('#uEnrolleeMobileAppQuestionnaireMenuPanel .Selected').removeClass('Selected');
        $('#uEnrolleeMobileAppQuestionnaireMenuPanel .' + aTab + 'Tab').addClass('Selected');

        if (aTab === 'Verify') {
            $('.EMAQuestionnaireSaveButton').hide();
            $('.EMAQuestionnaireRequestButton').show();
        } else {
            $('.EMAQuestionnaireRequestButton').hide();
            $('.EMAQuestionnaireSaveButton').show();
        }
        
        populateElement('uEnrolleeMobileAppContentPanel', lFilename, lMethodName, template);
    }

    //EMA
    function EnrolleeMobileAppQuestionnairePopulateCreate(template) {
        var ExtraDetilesChecked = '',
            lHtml = [], //get questions and awnsers for db
            lTemplates = [{ Title: 'Normal', Questions: ['Have you moved to a new address?', 'Has your employment status changed?', 'Do you have new tattoos?', 'Do you have new scars?', 'Do you have a new vechile?', 'Have you gained or lost more than 5 pounds?', 'Have you changed your hair color?'], Answers: [["Yes", "No"], ["Yes, Unemployed", "Yes, New Employment", "No"], ["Yes", "No"], ["Yes", "No"], ["Yes", "No"], ["Yes", "No", "Not sure"], ["Yes", "No"]] }, { Title: 'test', Questions: ['testing temp'], Answers: [["okay", "it works"]] }],
            lQuestions = lTemplates[template].Questions,
            lAnswers = lTemplates[template].Answers,
            QuestionnaireCreateHolder = $('#uEnrolleeMobileAppCreateQuestionnaireViewHolder');
        
        QuestionnaireCreateHolder.html('');

        lHtml.push('<select style="margin-top: 20px; margin-bottom: 20px; max-width: 150px; min-width: 150px; " id="uEMAQuestionnaireTemplate" onChange="EnrolleeMobileAppQuestionnairePopulateCreate(parseInt(this.value))">');
        lHtml.push('<option value="0">Select Template</option>');
        for (let i = 0; i < lTemplates.length; i++) {
            if (i === template) {
                lHtml.push('<option value="' + (i) + '"selected>' + lTemplates[i].Title + '</option>');
            } else {
                lHtml.push('<option value="' + (i) + '">' + lTemplates[i].Title + '</option>');
            }
        }
        lHtml.push('</select>');
        
        lHtml.push('<div style="max-height: 400px; overflow: auto"><table style="table-layout: fixed; max-width: 100%;" border="1" id="QuestionnaireCreateQuestions">')
        for (let i = 0; i < lQuestions.length; i++) {
            lHtml.push('<tr>');
            lHtml.push('<th style="min-width: 75px">Question ' + (i + 1) + ':</th>');
            lHtml.push('<td colspan="2" style="min-width: 390px"><div style="font-weight: bold;">' + lQuestions[i] + '</div></td>');
            lHtml.push('</tr>');
            lHtml.push('<tr>');
            lHtml.push('<th>Answers</th>');
            lHtml.push('<td colspan="2"><div>');
            lHtml.push('<table style="width: 100%;">');
            lHtml.push('<tbody id="uEMAQuestionnaireAnswerChoices' + i + '">')
            for (let j = 0; j < lAnswers[i].length; j++) {
                lHtml.push('<tr id="uEMAQuestionnaireAnswer' + i + ',' + (j + 1) + '" style="margin-bottom: 20px;"><td colspan="2">' + (j + 1) + ') ' + lAnswers[i][j] + '</td></tr>');
            }
            //this will get the agent a opportunity to add to the awnsers.
            lHtml.push('</tbody>')
            lHtml.push('</table>');

            lHtml.push('</div></td>');
            lHtml.push('</tr>');

            lHtml.push('<tr style="height: 20px;"></tr>');

        }
        lHtml.push('</table></div>');

        QuestionnaireCreateHolder.append($(lHtml.join('')))
    }

    //EMA allow custom question.  could be a feature later if we allow custom components.
    function EnrolleeMobileAppQuestionnairePopulateCustomCreate() {
        var ExtraDetilesChecked = '',
            lHtml = [], //get questions and awnsers for db
            lQuestions = mEnrolleesData.Questions,
            lAnswers = mEnrolleesData.Answers,
            lTemplates = [{ Title: 'Normal', Questions: [{ Question: 'Are you Employed', AllowExtraDetails: false }, { Question: 'Are you married', AllowExtraDetails: true }], Answers: [["yes", "no"], ["maybe", "i dont know"]] }, { Title: 'Kids', Questions: [{ Question: 'did you make every class this week?', AllowExtraDetails: false }, { Question: 'are you passing all your classes', AllowExtraDetails: false }], Answers: [["yes", "no"], ["maybe", "yes", "Im failing"]] }],
            QuestionnaireCreateHolder = $('#uEnrolleeMobileAppCreateQuestionnaireViewHolder');

        QuestionnaireCreateHolder.html('');

        lHtml.push('<select style="margin-top: 20px; margin-bottom: 20px; max-width: 150px; min-width: 150px; " id="uEMAQuestionnaireTemplate" onChange="EMASetQuestionnaireTemplate()">');
        lHtml.push('<option value="0">Select Template</option>');
        for (let i = 0; i < lTemplates.length; i++) {
            lHtml.push('<option value="' + (i+1) + '">' + lTemplates[i].Title + '</option>');
        }
        lHtml.push('</select>');

        lHtml.push('<table border="1"><tbody><tr><td><input placeholder="Add A New Question" type="text" id="uEMAQuestionnaireNewQuestion"/></td><td><span style="float:right" class="Button Clickable" onclick="EMAQuestionnaireAddQuestion()">Add Question</span></td></tr></tbody></table>');
        lHtml.push('<div style="max-height: 400px; overflow: auto"><table style="table-layout: fixed; max-width: 100%;" border="1" id="QuestionnaireCreateQuestions">')
        for (let i = 0; i < lQuestions.length; i++) {
            if (lQuestions[i].AllowExtraDetails) {
                ExtraDetilesChecked = "checked";
            } else {
                ExtraDetilesChecked = "";
            }
            lHtml.push('<tr>');
            lHtml.push('<th style="min-width: 75px">Question ' + (i + 1) + ':</th>');
            lHtml.push('<td style="min-width: 299px"><div style="font-weight: bold;">' + lQuestions[i].Question + '</div></td>');
            lHtml.push('<td style="min-width: 83px"><div class="Button Clickable" onclick="EMAQuestionnaireRemoveQuestion(' + i + ');">Remove Question</div></td>');
            lHtml.push('</tr>');

            lHtml.push('<tr>');
            lHtml.push('<th>Answers</th>');
            lHtml.push('<td colspan="2"><div>');
            lHtml.push('<table style="width: 100%;">');
            lHtml.push('<tbody id="uEMAQuestionnaireAnswerChoices' + i + '">')
            for (let j = 0; j < lAnswers[i].length; j++) {
                lHtml.push('<tr id="uEMAQuestionnaireAnswer' + i + ',' + (j + 1) + '" style="margin-bottom: 20px;"><td>' + (j + 1) + ') ' + lAnswers[i][j] + '</td><td><div style="margin-left: 20px; float: right;" class="Button Clickable" onclick="EMAQuestionnaireRemoveAnswer(' + i + ', ' + j + ')">Remove</div></td></tr>');
            }
            //this will get the agent a opportunity to add to the awnsers.
            lHtml.push('</tbody>')
            lHtml.push('<tr><td><input placeholder="Add A New Answer" type="text" id="uEMAQuestionnaireNewAnswer' + i + '"/></td><td><span style="float:right" class="Button Clickable" onclick="EMAQuestionnaireAddAnswer(' + i + ');">Add</span></td></tr>');
            //lHtml.push('</tbody>')
            lHtml.push('</table>');
            lHtml.push('</div></td>');
            lHtml.push('</tr>');
            lHtml.push('<tr>');
            lHtml.push('<th>Options</th>');
            lHtml.push('<td colspan="2"><div style="display: flex;"><input type="checkbox" id="uEMAQuestionnaireAllowExtraDetails' + i + '"' + ExtraDetilesChecked + '/><div style="font-weight: bold;">Allow Enrollee to Provide Extra Details?</div></div></td>');
            lHtml.push('</tr>');

            lHtml.push('<tr style="height: 20px;"></tr>');

        }
        lHtml.push('</table></div>');

        QuestionnaireCreateHolder.append($(lHtml.join('')))
    }

    //EMA could be a feature later if we allow custom components.
    function EMAQuestionnaireRemoveQuestion(indexToRemove) {
        var lQuestions = mEnrolleesData.Questions,
            lAnswers = mEnrolleesData.Answers;

        lQuestions.splice(indexToRemove, 1);
        lAnswers.splice(indexToRemove, 1);

        mEnrolleesData.Questions = lQuestions;
        mEnrolleesData.Answers = lAnswers;
        
        EnrolleeMobileAppQuestionnairePopulateCreate();
    }

    //EMA could be a feature later if we allow custom components.
    function EMAQuestionnaireAddQuestion() {
        var lQuestion = mEnrolleesData.Questions,
            lAnswers = mEnrolleesData.Answers;

        if ($('#uEMAQuestionnaireNewQuestion').val() !== '') {
            //update html view
            lQuestion.push($('#uEMAQuestionnaireNewQuestion').val());
            lAnswers.push([]);
            mEnrolleesData.Questions = lQuestion;
            mEnrolleesData.Answers = lAnswers;
            
            EnrolleeMobileAppQuestionnairePopulateCreate();
        }
    }

    //EMA could be a feature later if we allow custom components.
    function EMAQuestionnaireAddAnswer(indexOfQuestion) {
        var lHtml = [],
            lAnswers = mEnrolleesData.Answers,
            QuestionnaireAnswerSection = $('#uEMAQuestionnaireAnswerChoices' + indexOfQuestion);

        if ($('#uEMAQuestionnaireNewAnswer' + indexOfQuestion).val() !== '') {
            //update html view
            lHtml.push('<tr id="uEMAQuestionnaireAnswer' + indexOfQuestion + ',' + (lAnswers[indexOfQuestion].length + 1) + '" style="margin-bottom: 20px;"><td>' + (lAnswers[indexOfQuestion].length + 1) + ') ' + $('#uEMAQuestionnaireNewAnswer' + indexOfQuestion).val() + '</td><td style="margin-left: 20px; float: right;" class="Button Clickable" onclick="EMAQuestionnaireRemoveAnswer(' + indexOfQuestion + ', ' + lAnswers[indexOfQuestion].length + ')">Remove</td></tr>');
            QuestionnaireAnswerSection.append($(lHtml.join('')));
            //update variables storing the answers
            lAnswers[indexOfQuestion].push($('#uEMAQuestionnaireNewAnswer' + indexOfQuestion).val());
            mEnrolleesData.Answers = lAnswers;
            $('#uEMAQuestionnaireNewAnswer' + indexOfQuestion).val("");
            //EnrolleeMobileAppQuestionnairePopulateCreate();

            //Questions and anwsers should be stored to enroleee in dataOBjects
        }
    }

    //EMA could be a feature later if we allow custom components.
    function EMAQuestionnaireRemoveAnswer(indexOfQuestion, indexOfAnswer) {
        var lAnswers = mEnrolleesData.Answers;

        lAnswers[indexOfQuestion].splice(indexOfAnswer, 1);
        mEnrolleesData.Answers = lAnswers; 

        EnrolleeMobileAppQuestionnairePopulateCreate();

        //Questions and anwsers should be stored to enroleee in dataOBjects
    }

    //EMA
    function EnrolleeMobileAppQuestionnairePopulateVerify() {
        var ExtraDetilesChecked = '',
            lHtml = [], 
            template = 0, //get template from enrollee
            lTemplates = [{ Title: 'Normal', Questions: ['Have you moved to a new address?', 'Has your employment status changed?', 'Do you have new tattoos?', 'Do you have new scars?', 'Do you have a new vechile?', 'Have you gained or lost more than 5 pounds?', 'Have you changed your hair color?'], Answers: [["Yes", "No"], ["Yes, Unemployed", "Yes, New Employment", "No"], ["Yes", "No"], ["Yes", "No"], ["Yes", "No"], ["Yes", "No", "Not sure"], ["Yes", "No"]] }, { Title: 'test', Questions: ['testing temp'], Answers: [["okay", "it works"]] }],
            lEnrolleesSelection = [{ selection: 0, details: '1212 N post oak. Apt 3 houston texas 77054' }, { selection: 0, details: "Walmart 1414 N Post Oak St. Houston, Texas 77054" }, { selection: 1, details: "" }, { selection: 1, details: '' }, { selection: 0, details: 'Blue, 1998 Dodge Ram 1500, License Plate: 123ABC' }, { selection: 1, details: '' }, { selection: 0, details: 'Black' }],
            lQuestions = lTemplates[template].Questions,
            lAnswers = lTemplates[template].Answers,
            QuestionnaireVerifyHolder = $('#uEnrolleeMobileAppVerifyQuestionnaireViewHolder');

        QuestionnaireVerifyHolder.html('');

        lHtml.push('<div style="max-height: 400px; overflow: auto; margin-top: 20px;"><table style="table-layout: fixed; max-width: 100%;" border="1" id="QuestionnaireVerifyQuestions">')
        for (let i = 0; i < lQuestions.length; i++) {
            lHtml.push('<tr>');
            lHtml.push('<th style="min-width: 75px">Question ' + (i + 1) + ':</th>');
            lHtml.push('<td colspan="2" style="min-width: 299px"><div style="font-weight: bold;">' + lQuestions[i] + '</div></td>');
            lHtml.push('</tr>');

            lHtml.push('<tr>');
            lHtml.push('<th>Answer</th>');
            lHtml.push('<td colspan="2">');
            //lHtml.push('<table style="width: 100%;">');
            //lHtml.push('<tbody id="uEMAQuestionnaireAnswerSelection' + i + '">')
            lHtml.push('<div style="margin: 20px">' + lAnswers[i][lEnrolleesSelection[i].selection] + ': ' + lEnrolleesSelection[i].details + '</div>');
            //lHtml.push('</tbody>')
            //lHtml.push('</table>');
            lHtml.push('</td>');
            lHtml.push('</tr>');
            lHtml.push('<tr>');
            lHtml.push('<th>Verify</th>');
            lHtml.push('<td colspan="2"><div style="display: flex;"><div style="margin-left: 20px; float: left;" class="Button Clickable" onclick="EMAQuestionnaireApproveAnswer(' + i + ')">Approve</div><div style="margin-left: 20px; float: right;" class="Button Clickable" onclick="EMAQuestionnaireDenyAnswer(' + i + ')">Deny</div></td>');
            lHtml.push('</tr>');

            lHtml.push('<tr style="height: 20px;"></tr>');

        }
        lHtml.push('</table></div>');

        QuestionnaireVerifyHolder.append($(lHtml.join('')))
    } 

    function EMAQuestionnaireApproveAnswer(indexOfQuestion) {
        console.log('approve answer to question ' + indexOfQuestion);
    }   

    function EMAQuestionnaireDenyAnswer(indexOfQuestion) {
        console.log('Deny answer to question ' + indexOfQuestion);
    }

    function uBluBoxNotificationMove(aId) {
        "use strict";
        var lBodyHtml = [];
        var lButtonCommandBar = GenerateButtonCommandBar();

        lBodyHtml.push('<div>' + localizeWrapper('cEnrolleeBluBoxMoveNotification') + '</div>');
        lBodyHtml.push('<div>' + localizeWrapper('cEnrolleeBluBoxMoveNotificationProceed') + '</div>');

        GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'uOffenderAddressSaveButton_OnClick(' + aId + ')').appendTo(lButtonCommandBar);
        GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'ClosePopup()').appendTo(lButtonCommandBar);

        DisplayPopup(localizeWrapper('cEnrolleeBluBoxNotification'), lBodyHtml.join(''), lButtonCommandBar, false, true);
    }

    function uAutoFill_OnClick() {
        "use strict";
        if (mCopyAddress == 1) {
            $('#uAutoFillAddress').hide();
            $('#uAutoFillShowAddress').html(localizeWrapper('cEnrolleeShowCopyAddress'));
            mCopyAddress = 0;
        }
        else {
            $('#uAutoFillAddress').show();
            $('#uAutoFillShowAddress').html(localizeWrapper('cEnrolleeHideCopyAddress'));
            mCopyAddress = 1;
        }
    }
    function uOffenderAddressAddressPrefill_OnChange() {
        "use strict";
        var lBuilder = new SumoPredicateBuilder(),
            lSelectedId = $('#uOffenderAddressAddressPrefillEdit').val(),
            lAddress;

        if (lSelectedId != "") {
            lBuilder.AddNewExpressionConditional('Id', lSelectedId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lAddress = query(mEnrolleesData.OffenderProfileAddresses, lBuilder.RootExpression);

            for (var lKey in lAddress) {
                if (lAddress.hasOwnProperty(lKey)) {
                    lAddress = lAddress[lKey];
                }
            }

            $('#uOffenderAddressStreet1Edit').val(lAddress.Street1);
            $('#uOffenderAddressStreet2Edit').val(lAddress.Street2);
            $('#uOffenderAddressCityEdit').val(lAddress.City);
            $('#uOffenderAddressStateEdit').val(lAddress.State);
            $('#uOffenderAddressZipEdit').val(lAddress.Zip);
            $('#uOffenderAddressCountryEdit').val(lAddress.Country);

            //auto fill verification
            mEnrolleesControls.AddressesValidator.AutoFillVerify($('#uOffenderAddressStreet1Edit')[0]);
            mEnrolleesControls.AddressesValidator.AutoFillVerify($('#uOffenderAddressStreet2Edit')[0]);
            mEnrolleesControls.AddressesValidator.AutoFillVerify($('#uOffenderAddressCityEdit')[0]);
            mEnrolleesControls.AddressesValidator.AutoFillVerify($('#uOffenderAddressStateEdit')[0]);
            mEnrolleesControls.AddressesValidator.AutoFillVerify($('#uOffenderAddressZipEdit')[0]);
            mEnrolleesControls.AddressesValidator.AutoFillVerify($('#uOffenderAddressCountryEdit')[0]);


            uOffenderAddressEditMapLocateButton_OnClick();
        }
    }

    function uOffenderAddressAddButton_OnClick() {
        "use strict";
        mEnrolleesData.EnrolleeAddressGeocodeMatch = null;
        enrolleeAddressEditGenerator(-1, -1);
    }


    function disableSchedule_OnSuccess(aParams, aData) {
        "use strict";
        var l = "";

    }


    function uOffenderAddressRemoveConfirmButton_OnClick(aAddressId, aCallback) {
        "use strict";
        var lAddress = mEnrolleesData.OffenderProfileAddresses[aAddressId],
            lAddressWrite = null,
            lCallback = uOffenderAddressSave_OnComplete,
            lBuilder = new SumoPredicateBuilder(),
            lOffenderSchedules = mEnrolleesData.OffenderSchedules,
            lOffenderScheduleList = [],
            lKey,
            lItem,
            lZone;


        if (aCallback) {
            lCallback = aCallback;
        }


        lBuilder.AddNewExpressionConditional('ScheduleType', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('EntityId', lAddress.ZoneId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('EnrolleeId', lAddress.EnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsAbsenceSched', getCarveOutPreference(), false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

        lOffenderSchedules = query(lOffenderSchedules, lBuilder.RootExpression);
        if (count(lOffenderSchedules) > 0) {
            for (lKey in lOffenderSchedules) {
                if (lOffenderSchedules.hasOwnProperty(lKey)) {
                    lItem = lOffenderSchedules[lKey];
                    lItem.IsActive = false;
                    lItem.IsEnabled = false;
                    lOffenderScheduleList.push(lItem);
                }
            }
            WriteMultiple(lOffenderScheduleList, disableSchedule_OnSuccess, Sad, lOffenderScheduleList, true);
        }

        if (!isNullOrUndefined(lAddress)) {
            lAddressWrite = $.extend({}, lAddress);
            lAddressWrite.IsActive = false;
            lAddressWrite.TransactionId = moment().format("YYYYMMDDHHmmss");
            WriteSingle(lAddressWrite, lCallback, uOffenderAddressSave_OnFailure, false);
        }

        // zone exist has been deleted from db, not cleared from cache, this is done when deleting regular zones to remove from cache.
        if (lAddress.ZoneId > 0) {
            lZone = getDataItem(lAddress.ZoneId, 'Zones');
            if (lZone.EnrolleeCount <= 1) {
                lZone.IsActive = false;
            }
            else {
                lZone.EnrolleeCount = lZone.EnrolleeCount - 1;
            }
            WriteSingle(lZone, null, null, null, false);
        }

    }

    function uOffenderAddressRemoveButton_OnClick(aAddressId) {
        "use strict";
        var lButtonBar = GenerateButtonCommandBar(),
            lBuilder = new SumoPredicateBuilder(),
            lEnrollee = GetEnrollee(mEnrolleesData.OffenderCurrentId);

        if (lEnrollee) {
            GenerateButton(localizeWrapper('cEnrolleeContinue'), 'Continue', 'uOffenderAddressRemoveConfirmButton_OnClick(' + aAddressId + ');').appendTo(lButtonBar);
            DisplayPopup(localizeWrapper('cEnrolleeDeleteAddress'), localizeWrapper('cEnrolleeAddressDeleteContinue'), lButtonBar, false);
        }

    }

    function uOffenderAddressEditButton_OnClick(aAddressId) {
        "use strict";
        var lAddress = mEnrolleesData.OffenderProfileAddresses[aAddressId];
        if (!isNullOrUndefined(lAddress)) {
            mEnrolleesData.EnrolleeAddressGeocodeMatch = lAddress.PositionMatchesGeocode;
            //Vulnerability 3255 additional
            lAddress.Title = veritracks.system.decodeHtml(lAddress.Title);
            lAddress.AdditionalInfo = veritracks.system.decodeHtml(lAddress.AdditionalInfo);
            lAddress.Notes = veritracks.system.decodeHtml(lAddress.Notes);
            lAddress.PhoneNumber = veritracks.system.decodeHtml(lAddress.PhoneNumber);
            lAddress.PhoneNumber2 = veritracks.system.decodeHtml(lAddress.PhoneNumber2);

            enrolleeAddressEditGenerator(aAddressId, lAddress.AddressTypeId);
            populateEditView(lAddress, [], {}, 'uOffenderAddress', 'Edit');
            if (lAddress.Latitude + lAddress.Longitude !== 0.0) {
                mActivityNotification.addNotification(localizeWrapper('cDefaultCenteringLatLong') + lAddress.Latitude.toString() + ', ' + lAddress.Longitude.toString());
                //enrolleeSetAddressMarker(lAddress.Latitude.toString(), lAddress.Longitude.toString());
                mEnrolleesControls.AddressesMap.setAddressMarker("uOffenderAddressAddressTypeIdEdit",lAddress.Latitude.toString(), lAddress.Longitude.toString());
            }
            mEnrolleesControls.AddressesValidator.IsValid();
        }
    }

    function enrolleesOffenderAddressZone_OnAddressSave(aParams, aData) {
        "use strict";
        var lHtml = [],
            lItem,
            lKey;

        EnrolleeProfileAddresses_Init(mEnrolleesData.OffenderCurrentId);
        applyUserPermissions([15, 2]);
        enrolleeAddressHeightMatch();
    }

    function enrolleesOffenderAddressZone_OnZoneSave(aParams, aData) {
        "use strict";
        if (aData.Id > 0) {
            setDataItem(aData.Id, 'Zones', aData);
            mActivityNotification.addNotification(localizeWrapper('cZoneZoneSave') + aData.Name);
            aParams.ZoneId = aData.Id;
            // create 24x7 schedule for exclusion zone only
            if (aData.Type == 2) {
                createSchedulefromExclusionZone(aData, function(aP, aData){
                  WriteSingle(aParams, null, null, null, true);
                });
            }else if(aData.Type == 1){
              WriteSingle(aParams, enrolleesOffenderAddressZone_OnAddressSave, null, null, true);
            }
        } else if (aData.Id == -2) {
            mActivityNotification.addNotification(localizeWrapper('cZoneDuplicateNameError') + aData.Name);
        }
    }

    function createSchedulefromExclusionZone(aData, aCallback) {
        "use strict";
        var lSchedule = new OffenderSchedule(),
            lTimeZone = getEnrolleeTimeZone(mEnrolleesData.OffenderCurrentId),
            lNow = new Date();

        lSchedule.EntityId = aData.Id;
        lSchedule.EnrolleeId = mEnrolleesData.OffenderCurrentId;
        lSchedule.ScheduleType = 1;
        lSchedule.ZoneScheduleType = 1;

        lSchedule.IsSunday = true;
        lSchedule.IsMonday = true;
        lSchedule.IsTuesday = true;
        lSchedule.IsWednesday = true;
        lSchedule.IsThursday = true;
        lSchedule.IsFriday = true;
        lSchedule.IsSaturday = true;

        lSchedule.IsRecurring = true;
        lSchedule.Name = 'Schedule for Exclusion Zone: ' + aData.Name;
        lSchedule.StartTime = convertTimeToUTC(new Date(displayShortDate(lNow) + ' 00:00:00'), lTimeZone.TimeZoneName);
        lSchedule.EndTime = convertTimeToUTC(new Date(displayShortDate(lNow) + ' 23:59:00'), lTimeZone.TimeZoneName);
        lSchedule.IsActive = true;

        saveSchedulesMultiDay([lSchedule], function(aParams, aData){
            aCallback(aParams, aData);
          createSchedulefromZone_OnSuccess(aParams, aData);
        }, {});
        //WriteSingle(lSchedule, createSchedulefromExclusionZone_OnSuccess, createSchedulefromExclusionZone_OnFailure, {}, true);
        // write 24/7 schedule
    }

    function createSchedulefromExclusionZone_OnFailure() {
        mActivityNotification.addNotification(localizeWrapper('cEnrolleeScheduleFail'));
    }

    function enrolleesOffenderAddressZone_OnCreate(aAddressId, aButton, aZoneType, aCallback) {
        "use strict";
        var lAddress = mEnrolleesData.OffenderProfileAddresses[aAddressId],
            lZone = new Zone(),
            lZoneType = 1,
            lEnrollee = GetEnrollee(mEnrolleesData.OffenderCurrentId),
            lCard = mEnrolleesControls.CardView.selectedDataItem(),
            lCallback = window['enrolleesOffenderAddressZone_OnZoneSave'];

        if (aZoneType) {
            lZoneType = aZoneType;
        }

        if (aCallback) {
            lCallback = aCallback;
        }

        if (aButton)
            $('.AddressZoneCreate' + aAddressId).remove();

        lZone.AgentId = lEnrollee.AgentId;
        lZone.CenterLatitude = lAddress.Latitude;
        lZone.CenterLongitude = lAddress.Longitude;
        lZone.Description = 'Auto generated from address';
        lZone.Name = lEnrollee.PrimaryId + ' - ' + lAddress.Title + ' - ' + lEnrollee.LastName;
        lZone.OrganizationId = lEnrollee.OrganizationId;
        lZone.Radius = 150;
        lZone.Scope = 1;
        lZone.Shape = 1;
        lZone.Type = lZoneType;
        lZone.AddressTypeId = lAddress.AddressTypeId;

        mActivityNotification.addNotification(localizeWrapper('cZoneSaving') + lZone.Name);
        WriteSingle(lZone, lCallback, null, lAddress, true);
    }

    function enrolleesOffenderAddressZone_OnEdit(aAddressId) {
        "use strict";
        var lEnrollee = GetEnrollee(mEnrolleesData.OffenderCurrentId),
            lAddress = mEnrolleesData.OffenderProfileAddresses[aAddressId],
            lBuilder = new SumoPredicateBuilder(),
            lZones = getDataItems('Zones'),
            lZoneId = -1,
            lItem,
            lKey;
        if (lAddress.ZoneId !== -1) {
            lZoneId = lAddress.ZoneId;
        } else {
            lBuilder.AddNewExpressionConditional('Name', lEnrollee.PrimaryId + ' ' + lAddress.Title, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lZones = query(lZones, lBuilder.RootExpression);
            for (lKey in lZones) {
                if (lZones.hasOwnProperty(lKey)) {
                    lItem = lZones[lKey];
                    lZoneId = lItem.Id;
                    break;
                }
            }
        }
        if (lZoneId !== -1) {
            setViewState('NavigatedFromAddressZoneEdit', true);
            setViewState('ZonesSelectedZone', lZoneId);
            setViewState('ZoneReturnEnrolleeId', lEnrollee.Id);
            window.location.hash = 'Zones.Map.' + lZoneId;
        } else {
            mActivityNotification.addNotification(localizeWrapper('cZoneNoMatch'));
        }
    }

    function save24x7Schedule(aAddressId) {
        "use strict";
        var lAddress = mEnrolleesData.OffenderProfileAddresses[aAddressId];
        var lZone = getDataItem(lAddress.ZoneId, 'Zones');
        var lEnrollee = GetEnrollee(lAddress.EnrolleeId);
        var lTimeZone = getEnrolleeTimeZone(lEnrollee.Id);
        var lSchedule = new OffenderSchedule();

        $('.24x7ScheduleAddress' + aAddressId).remove();

        lSchedule.StartTime.setHours(0);
        lSchedule.StartTime.setMinutes(0);
        lSchedule.StartTime.setSeconds(0);
        lSchedule.EndTime.setHours(23);
        lSchedule.EndTime.setMinutes(59);
        lSchedule.EndTime.setSeconds(0);
        ['IsMonday', 'IsTuesday', 'IsWednesday', 'IsThursday', 'IsFriday', 'IsSaturday', 'IsSunday'].forEach(function (day) {
            lSchedule[day] = true;
        })
        lSchedule.EnrolleeId = lEnrollee.Id;
        lSchedule.OrganizationId = lEnrollee.OrganizationId;
        lSchedule.Name = 'Schedule for ' + (lZone.Type == 1 ? 'Inclusion' : 'Exclusion') + ' Zone: ' + lZone.Name;


        lSchedule.StartTime = convertTimeToUTC(lSchedule.StartTime, lTimeZone.TimeZoneName);
        lSchedule.EndTime = convertTimeToUTC(lSchedule.EndTime, lTimeZone.TimeZoneName);
        lSchedule.EntityId = lZone.Id;
        lSchedule.ZoneScheduleType = 1;
        lSchedule.ScheduleType = 1;
        //uSchedulesTargetType_OnSelectChange();
        saveSchedulesMultiDay([lSchedule], function (aParams, aData) {
            mActivityNotification.addNotification('Schedules created for Zone.');
            createSchedulefromZone_OnSuccess(aParams, aData);
        });
    }

    function createSchedulefromZone_OnSuccess(aParams, aData) {
        "use strict";
        mActivityNotification.addNotification(localizeWrapper('cEnrolleeScheduleSuccess'));
        mCache.bind('OffenderSchedulescomplete', enrolleesOffenderAddressScheduleCache_OnComplete, aData);

        ReloadEnrolleeSchedules(mEnrolleesData.OffenderCurrentId, function () {
            EnrolleeProfileAddresses_OnLoad(null, mEnrolleesData.OffenderProfileAddresses);
        })
    }

     function enrolleesOffenderAddressScheduleCache_OnComplete(aParams, aData) {
        "use strict"
        mCache.unbind('OffenderSchedulescomplete', enrolleesOffenderAddressScheduleCache_OnComplete);

        //EnrolleeProfileAddresses_OnLoad(null, mEnrolleesData.OffenderProfileAddresses);

    }

    function enrolleeAddressGenerator(aAddress, aBluPlusConfiguration, aStreetViewFunction, aAddressEditFunction, aAddressDeleteFunction, aAddressZoneCreate, aAddressZoneEdit, aSchedule) {
        "use strict";
        var lHtml = [],
            lZoneTitle = 'Create Zone',
            lScheduleTitle = 'Create 24x7 Schedule',
            lStreetViewFunction = '',
            lAddressEditFunction = 'uOffenderAddressEditButton_OnClick',
            lAddressDeleteFunction = 'uOffenderAddressRemoveButton_OnClick',
            lZoneCreate = 'enrolleesOffenderAddressZone_OnCreate',
            lZoneEdit = 'enrolleesOffenderAddressZone_OnEdit',
            lScheduleSave = 'Schedule Saved',
            lZoneIcon = 'ZonesDarkGreen16.png',
            lZones = getDataItems('Zones'),
            lCard = mEnrolleesControls.CardView.selectedDataItem(),
            lBuilder = new SumoPredicateBuilder(),
            lSchedules = mEnrolleesData.OffenderSchedules,
            lZone;

        if (aStreetViewFunction) {
            lStreetViewFunction = aStreetViewFunction;
        }
        if (aAddressEditFunction) {
            lAddressEditFunction = aAddressEditFunction;
        }
        if (aAddressDeleteFunction) {
            lAddressDeleteFunction = aAddressDeleteFunction;
        }
        if (aAddressZoneCreate) {
            lZoneCreate = aAddressZoneCreate;
        }
        if (aAddressZoneEdit) {
            lZoneEdit = aAddressZoneEdit;
        }

        if (aAddress.ZoneId > 0) {
            lBuilder.AddNewExpressionConditional('Id', aAddress.ZoneId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        } else {
            //THIS IS A LAME HACK AND SHOULD BE REPLACED BY ZONE ID IN THE ADDRESS
            lBuilder.AddNewExpressionConditional('Name', lCard.Enrollee.PrimaryId + ' ' + aAddress.Title, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        }
        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lZones = query(lZones, lBuilder.RootExpression);
        lBuilder.Clear();

        lBuilder.AddNewExpressionConditional('EntityId', aAddress.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('ScheduleType', 6, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lSchedules = query(lSchedules, lBuilder.RootExpression);
        lBuilder.Clear();
        lHtml.push('<div class="AddressTile">');
        lHtml.push('<div>');
         // Support multiple Thethered address 
        if (count(lSchedules) === 0) {
            lHtml.push('<img src="Images/CancelDark16.png" alt="Remove" title="' + localizeText('cEnrolleeRemove') + '" onclick="');
            lHtml.push(lAddressDeleteFunction);
            lHtml.push('(');
            lHtml.push(aAddress.Id);
            lHtml.push(')" class="Clickable pEnrolleesOffenderAddressesWrite AddressDelete" style="float:right; margin-left: 5px;" />');
        }
        lHtml.push('<img src="Images/PencilDark16.png" alt="Edit" title="' + localizeText('cEnrolleeEdit') + '" onclick="');
        lHtml.push(lAddressEditFunction);
        lHtml.push('(');
        lHtml.push(aAddress.Id);
        lHtml.push(')" class="Clickable pEnrolleesOffenderAddressesWrite AddressEdit" style="float:right;" />');
        // Support multiple Thethered address 
        if (lZones.length !== 0) {
            lZoneTitle = localizeText('cEnrolleeEditInclusionZone');
            for (var lKey in lZones) {
                if (lZones.hasOwnProperty(lKey)) {
                    if (lZones[lKey].Type == 2) {
                        lZoneIcon = 'ZonesDarkRed16.png';
                        lZoneTitle = localizeText('cEnrolleeEditExclusionZone');
                    }
                }
            }
            lHtml.push('<img src="Images/' + lZoneIcon + '" class="Clickable FloatRight AddressZoneEdit pZonesWrite" style="margin-right: 5px;" onclick="');
            lHtml.push(lZoneEdit);
            lHtml.push('(');
            lHtml.push(aAddress.Id);
            lHtml.push(', this)" alt="');
            lHtml.push(lZoneTitle);
            lHtml.push('" title="');
            lHtml.push(lZoneTitle);
            lHtml.push('" />');
            if (!aSchedule)
                lHtml.push('<img src="Images/24x7image.png" title="Create 24x7 Schedule" class="Clickable FloatRight 24x7ScheduleAddress' + aAddress.Id + '" style="margin-right: 5px;" onclick="save24x7Schedule('+aAddress.Id+')" />');
        } else {
            lHtml.push('<img src="Images/ZonesDarkRed16.png" class="Clickable FloatRight AddressZoneCreate' + aAddress.Id + ' pZonesWrite" style="margin-right: 5px;" onclick="');
            lHtml.push(lZoneCreate);
            lHtml.push('(');
            lHtml.push(aAddress.Id);
            lHtml.push(', this,2)" alt="');
            lHtml.push(localizeText('cEnrolleeCreateExclusionZone'));
            lHtml.push('" title="');
            lHtml.push(localizeText('cEnrolleeCreateExclusionZone'));
            lHtml.push('" />');
            lHtml.push('<img src="Images/ZonesDarkGreen16.png" class="Clickable FloatRight AddressZoneCreate' + aAddress.Id + ' pZonesWrite" style="margin-right: 5px;" onclick="');
            lHtml.push(lZoneCreate);
            lHtml.push('(');
            lHtml.push(aAddress.Id);
            lHtml.push(', this,1)" alt="');
            lHtml.push(localizeText('cEnrolleeCreateInclusionZone'));
            lHtml.push('" title="');
            lHtml.push(localizeText('cEnrolleeCreateInclusionZone'));
            lHtml.push('" />');
        }
        lHtml.push('<strong>');
        lHtml.push(aAddress.Title);
        lHtml.push('</strong> (');
        lHtml.push(AddressTypeFormatter(getDataItem(aAddress.AddressTypeId, 'AddressType').Description));
        lHtml.push(')</div>');
        if (lStreetViewFunction) {
            lHtml.push('<span class="StreetIconProperty" id="uLastLocationStreetView" onclick="' + lStreetViewFunction + '()"></span>');
        }
        lHtml.push('<div style="position:relative;" class="noOverflowEllipsis" title="'+aAddress.Street1+'">');
        lHtml.push(aAddress.Street1);
        
        var aAddressTypes =['Home','Work','Other'];
        aAddressTypes[5] ='Transient';
        
        lHtml.push('</div>');
        if (!isNullOrUndefined(aAddress.Street2) && aAddress.Street2 !== '') {
            lHtml.push('<div class="noOverflowEllipsis" title="'+aAddress.Street2+'" >');
            lHtml.push(aAddress.Street2);
            lHtml.push('</div>');
        }
        lHtml.push('<div >');
        lHtml.push(aAddress.City);
        lHtml.push(' ');
        lHtml.push(aAddress.State);
        lHtml.push(', ');
        lHtml.push(aAddress.Zip);
        lHtml.push('</div>');
        console.log(aAddress,aAddress.AddressTypeId,aAddressTypes[aAddress.AddressTypeId -1 ])
        if(aAddress.AddressTypeId && aAddress.TetheredLocationFlag && aAddressTypes[aAddress.AddressTypeId -1 ]){

            var lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
                lIsInformatics = false;
            if (!isNullOrUndefined(lEnrollee)) {
                lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);

            }
            var imageUrl =  lIsInformatics == true ? encodeURI('assets/Address '+aAddressTypes[aAddress.AddressTypeId -1 ]+' Auth.svg') : aAddress.AddressTypeId + '-Address16.png';
            lHtml.push('<div id="uEnrolleeAddressTypeImg" style="position:relative; display:inline; left:5px;" >');
            lHtml.push('<img src="Images/' + imageUrl + '" class="u' + aAddressTypes[aAddress.AddressTypeId -1 ] + 'EnrroleeAddressTypeId enrollee__address__card--icon" title="' + aAddressTypes[aAddress.AddressTypeId -1] + '" />');
            lHtml.push('</div>');
        }
        if (!isNullOrUndefined(aAddress.AdditionalInfo) && aAddress.AdditionalInfo !== '') {
            lHtml.push('<div class="noOverflowEllipsis" title="'+aAddress.AdditionalInfo+'"  ><strong style="display:block;">' + localizeWrapper('cEnrolleeAdditionalInfo') + '</strong> ');
            lHtml.push(aAddress.AdditionalInfo);
            lHtml.push('</div>');
        }
        if (!isNullOrUndefined(aAddress.Notes) && aAddress.Notes !== '') {
            lHtml.push('<div class="noOverflowEllipsis" title="'+aAddress.Notes+'" ><strong style="display:block;">' + localizeWrapper('cEnrolleeNotes') + '</strong> ');
            lHtml.push(aAddress.Notes);
            lHtml.push('</div>');
        }
        if (!isNullOrUndefined(aAddress.PhoneNumber) && aAddress.PhoneNumber !== '') {
            lHtml.push('<div class="noOverflowEllipsis" title="'+aAddress.PhoneNumber+'"><strong>' + localizeWrapper('cEnrolleePhone') + '</strong> ');
            lHtml.push(aAddress.PhoneNumber);
            lHtml.push('</div>');
        }
        if (!isNullOrUndefined(aAddress.PhoneNumber2) && aAddress.PhoneNumber2 !== '') {
            lHtml.push('<div class="noOverflowEllipsis" title="'+aAddress.PhoneNumber2+'"><strong>' + localizeWrapper('cEnrolleeAltPhone') + '</strong> ');
            lHtml.push(aAddress.PhoneNumber2);
            lHtml.push('</div>');
        }
        if (lZones.length !== 0) {
            lZone = lZones[lZones.length - 1];
            lHtml.push('<div><strong>' + localizeWrapper('cZone') + '</strong> ');
            lHtml.push(lZone.Name);
            lHtml.push(' (');
            if (lZone.Type === 1) {
                lHtml.push(localizeWrapper('cZoneInclusion'));
            } else {
                lHtml.push(localizeWrapper('cZoneExclusion'));
            }
            lHtml.push(')');
            lHtml.push('</div>');

        }
        if(aSchedule){
            lHtml.push('<div><strong> Schedule </strong> ');
            lHtml.push(aSchedule.Name);

            lHtml.push('</div>');
        }
        lHtml.push('</div>');
        return lHtml.join('');
    }

    function EnrolleeProfileAddresses_OnLoad(aParams, aAddressList,abb) {
        "use strict";
        var lHtml = [],
            lItem,
            lBuilder = new SumoPredicateBuilder(),
           
            lSchedules = getEnrolleeSchedules(),
            lKey;

        // for blu+ only
        if (aParams) {
            mEnrolleesData.BluPlusConfiguration = aParams;
        }
        else {
            mEnrolleesData.BluPlusConfiguration = null;
        }


        mEnrolleesData.OffenderProfileAddresses = [];
        for (lKey in aAddressList) {
            if (aAddressList.hasOwnProperty(lKey)) {
                lItem = aAddressList[lKey];
                mEnrolleesData.OffenderProfileAddresses[lItem.Id] = lItem;
                var schedule = Object.values(lSchedules).find(function (sc) {
                    return sc.ZoneScheduleType == 1 && sc.EntityId == lItem.ZoneId && sc.IsActive;
                })
                lHtml.push(enrolleeAddressGenerator(lItem, aParams, null, null, null, null, null, schedule));
            }
        }
        $('#uEnrolleeAddressesHolder').html(lHtml.join(''));
        veritracks.localization.localize('#uEnrolleeAddressesHolder');
        applyUserPermissions([15, 2]);
        enrolleeAddressHeightMatch();
    }

    function EnrolleeProfileAddresses_Init(aEnrolleeId) {
        "use strict";
        var lSelected = mEnrolleesControls.CardView.selectedDataItem(),
            lBuilder = new SumoPredicateBuilder();

        function configuration_OnLoad(aParams, aData) {
            lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            ReadMultiple(gObjectList.EnrolleeAddress.AssemblyQualifiedName, lBuilder.RootExpression, 0, EnrolleeProfileAddresses_OnLoad, null, aData[0], null, 0);
        }

        if (!isNullOrUndefined(lSelected)) {
            lBuilder.AddNewExpressionConditional('Id', lSelected.TrackingDeviceId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('EnrolleeId', lSelected.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            ReadMultiple(gObjectList.BluPlusConfiguration.AssemblyQualifiedName, lBuilder.RootExpression, 0, configuration_OnLoad, null, null, null, 0);
            lBuilder.Clear();
        }
    }

    

    function enrolleesOffenderDeviceClusterRead_OnSuccess(aParams, aData) {
        "use strict";
        var lCluster;
        if (aParams === mEnrolleesData.OffenderCurrentId) {
            mEnrolleesData.OffenderDeviceClusters = aData;
            if (aData.length > 0) {
                lCluster = getDataItem(aData[0].DeviceClusterId, 'DeviceClusters');
                if (!isNullOrUndefined(lCluster)) {
                    $('#uDeviceClusterName').html(lCluster.Name);
                    $('.StationDevice').show();
                    $('.DeviceCluster').show();
                    $('.Unassigned').hide();
                }
            }
        } 
    }

    function enrolleesOffenderDeviceClusterRead_OnFailure(aParams, a, b, c) {
        "use strict";
        var l = '';
    }

    function offenderEidReservationWrite_OnFailure(aParams, aData) {
        "use strict";
        var l = '';

    }

    function offenderEidReservationWrite_OnSuccess(aParams, aData) {
        "use strict";
        FixDates(aData);
        mEnrolleesData.OffenderEidReservation = aData;
        //mEnrolleesData.OffenderEidReservation.DeviceGpsStatus = aParams;
    }

    function eidConfigurationSave_OnClick() {
        "use strict";
        var lBuilder = new SumoPredicateBuilder(),
            lReservationId = mEnrolleesData.OffenderEidReservation.Id,
            lEnrolleeId = mEnrolleesData.OffenderEidReservation.EnrolleeId,
            lEnrollees = getDataItems('Enrollees'),
            lDeviceId,
            lStartDate = $('#uEidConfigurationStartDate').val(),
            lEndDate = $('#uEidConfigurationEndDate').val(),
            lDateChanged = false,
            lDoWrite = false,
            lDeviceGpsStatus;

        if (mEnrolleesControls.DeviceAssignmentsValidator.IsValid()) {
            if ($.trim(lStartDate).length > 0) {
                if (lStartDate != displayShortDate(mEnrolleesData.OffenderEidReservation.StartDate)) {
                    lStartDate = new Date(lStartDate);
                    mEnrolleesData.OffenderEidReservation.StartDate = lStartDate;
                    lDateChanged = true;
                }
            }
            if ($.trim(lEndDate).length > 0) {
                if (lEndDate != displayShortDate(mEnrolleesData.OffenderEidReservation.EndDate)) {
                    lEndDate = new Date(lEndDate);
                    mEnrolleesData.OffenderEidReservation.EndDate = lEndDate;
                    lDateChanged = true;
                }
            }

            lDeviceGpsStatus = mEnrolleesData.OffenderEidReservation.DeviceGpsStatus;
            if (!$('#uMaintainEidActivationCheckBox').is(":checked")) {
                //mEnrolleesData.OffenderEidReservation.EndDateUTC = new Date();
                mEnrolleesData.OffenderEidReservation.StatusId = 5;
                lDoWrite = true;
                mActivityNotification.addNotification(localizeWrapper('cEnrolleeRemovedFromEid'));
            } else if (lDateChanged) {
                lDoWrite = true;
                mActivityNotification.addNotification(localizeWrapper('cEnrolleeEidReservationUpdated'));
            }

            lDeviceId = gCurrentDeviceAssignment[mEnrolleesData.OffenderCurrentId].length - 1;
            if ($('#uEnableGpsCheckBox').is(":checked")) {
                //Send to command to device to turn on GPS
                if (!lDeviceGpsStatus) {
                    mActivityNotification.addNotification(localizeWrapper('cInventoryDeviceGPSOnAction'));
                    mEnrolleesData.OffenderEidReservation.DeviceGpsStatus = true;
                    generateDeviceAction(10, lDeviceId);
                }
            } else {
                if (mEnrolleesData.OffenderEidReservation.DeviceGpsStatus) {
                    mActivityNotification.addNotification(localizeWrapper('cInventoryDeviceGPSOffAction'));
                    mEnrolleesData.OffenderEidReservation.DeviceGpsStatus = false;
                    generateDeviceAction(11, lDeviceId);
                }
            }
            if (lDoWrite) {
                mEnrolleesData.OffenderEidReservation.TransactionId = moment().format("YYYYMMDDHHmmss");
                mEnrolleesData.OffenderEidReservation.UserId = gUserDetails.UserId;
                WriteSingle(mEnrolleesData.OffenderEidReservation, offenderEidReservationWrite_OnSuccess, offenderEidReservationWrite_OnFailure, lDeviceGpsStatus);
            }
            ClosePopup();
            EnrolleeEidCheck(mEnrolleesData.OffenderCurrentId);
        }
    }

    function eidReservations_OnSuccess(aParams, aData) {
        "use strict";
        FixDates(aData);
        mEnrolleesData.OffenderEidReservation = aData[0];
        $('#uEidStatusField').html('');
        $('.EidStatus').hide();
        if (!isNullOrUndefined(mEnrolleesData.OffenderEidReservation)) {
            if (mEnrolleesData.OffenderEidReservation.StatusId <= 2) {
                $('#uEidStatusField').html(reservationStatusFormatter(mEnrolleesData.OffenderEidReservation.StatusId));
                $('.EidStatus').show();
                if (mEnrolleesData.OffenderEidReservation.StatusId === 2) {
                    DeviceGpsStatusCheck();
                } else {
                    $('#uEidConfigurationButton').hide();
                }
            } else {
                $('.EidStatus').hide();
            }
        }
    }

    function uOffenderProfileRisklLevelIdEdit_OnChange(self) {
        var lEnrollee = GetEnrollee(mEnrolleesData.OffenderCurrentId);
        var lRiskLevelId = $(self).val();
        var lOrganizationId = $('#uOffenderProfileOrganizationIdEdit').val()
        var lRiskLevel = getRiskLevel(lRiskLevelId, lOrganizationId);
        var lAssignment = gCurrentDeviceAssignment[mEnrolleesData.OffenderCurrentId];

        if (!lAssignment) return
        lAssignment = Object.values(lAssignment).filter(function (a) { return [103, 104, 111, 151].indexOf(a.ProductId) !== -1 });

        //blutag and blutwo support only paired with bluhome/blubox.
        if (lAssignment.length == 0) return;

        if (!lAssignment.find(function (a) { return a.ProductId == 104 }) && !mEnrolleesData.OffenderDeviceClusters.length > 0) {
            return
        }

        if (lEnrollee.OrganizationId == lOrganizationId && mEnrolleesData.OffenderEidReservation && mEnrolleesData.OffenderEidReservation.StatusId <= 2 && mEnrolleesData.OffenderEidReservation.EidTypeId !== 3) {
            return
        }

        if ((lEnrollee.OrganizationId == lOrganizationId && lEnrollee.RiskLevelId == lRiskLevelId) || lRiskLevel.EidTypeId == -1) {
            $(self).removeClass('ValidateError');
            $('#EidReservationQuotaFilled').hide();
            $('.EidReservation').hide();
            $('#uOffenderProfileEnrolleeEIdEndDateEdit').val(moment().format('L'));
            if (mEnrolleesControls.OffenderProfileValidator) {
                mEnrolleesControls.OffenderProfileValidator.IsValid();
            }
            return;
        } else {
            $('#uOffenderProfileEnrolleeEIdEndDateEdit').val('');
            if (mEnrolleesControls.OffenderProfileValidator) {
                mEnrolleesControls.OffenderProfileValidator.IsValid();
            }
        }

        // check if enrollee is assigned to bbg

        EidQuotaCheck(lRiskLevel, function (quota) {
            if (quota == 1) {
                $('.EidReservation').show()
                $('#EidReservationQuotaFilled').hide();
                $('#uOffenderProfileEnrolleeEIdEndDateEdit').addClass('ValidateRequired')
                populateDateView('#uOffenderProfileEnrolleeEIdEndDateEdit', function () {
                    mEnrolleesControls.OffenderProfileValidator.IsValid();
                });
            } else if (quota == 0) {
                $(self).addClass('ValidateError');
                $('#EidReservationQuotaFilled').show();
                $('#uOffenderProfileEnrolleeEIdEndDateEdit').removeClass('ValidateRequired')
                $('.EidReservation').hide("fast")
                //dont show eid, risk level should not be valid
            }

        })
       // function EidQuotaCheck(aRiskLevel, aOnSuccess) {


    }


    function EnrolleeEidCheck(aEnrolleeId) {
        "use strict";
        var lBuilder = new SumoPredicateBuilder();
        var lRiskLevel = getEnrolleeRiskLevel(aEnrolleeId);

        $('.EidStatus').hide();

        if (lRiskLevel && lRiskLevel.EidTypeId !== -1)
            getEidReservation(eidReservations_OnSuccess, Sad);

        if (lRiskLevel && (lRiskLevel.EidTypeId == 1 || lRiskLevel.EidTypeId == 2)) {
            $(".EidQuota").show();
        }
    }

    function deviceGpsStatusCheck_OnSuccess(aParams, aData) {
        "use strict";
        if (!isNullOrUndefined(mEnrolleesData.OffenderEidReservation)) {
            mEnrolleesData.OffenderEidReservation.DeviceGpsStatus = aData[0].IsActive;
            //applyUserPermissions([39]);
            $('#uEidConfigurationButton').show();
        }
    }

    function DeviceGpsStatusCheck() {
        "use strict";
        var lBuilder = new SumoPredicateBuilder(),
            lSelected = mEnrolleesData.OffenderCurrentId,
            lDevice;
        if (!isNullOrUndefined(gCurrentDeviceAssignment) && gCurrentDeviceAssignment[lSelected]) {
            var lAssignments = Object.values(gCurrentDeviceAssignment[lSelected]);
            
            lDevice = lAssignments.find(function (a) { return [103, 111, 151].indexOf(a.ProductId) !== -1 });
            lBuilder.AddNewExpressionConditional('Id', lDevice.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            ReadMultiple(gObjectList.DeviceGpsStatus.AssemblyQualifiedName, lBuilder.RootExpression, 0, deviceGpsStatusCheck_OnSuccess, Sad, "test", null, 0);
        }

    }

    function eidConfigurationDates_OnChange() {
        mEnrolleesControls.DeviceAssignmentsValidator.IsValid();
    }

    function deviceAssignmentsEidConfigurationDates_OnChange() {
        mEnrolleesData.Validator.IsValid();
    }

    function uEidConfigurationButton_OnClick() {
        "use strict";
        var lButtonBar = GenerateButtonCommandBar();

        GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'eidConfigurationSave_OnClick()').appendTo(lButtonBar);
        DisplayPopup(localizeWrapper('cEnrolleeEidSettings'), '<div id="uEidConfigurationHolder"></div>', lButtonBar, false);
        mEnrolleesControls.DeviceAssignmentsValidator = new Validator('uEidConfigurationHolder', mRegexValidation);
        populateElement('uEidConfigurationHolder', 'Enrollees.Offenders.Profile.EIDConfiguration.Dialog.htm', function () {
            applyUserPermissions([37]);
            if (mEnrolleesData.OffenderEidReservation.DeviceGpsStatus) {
                $('input[id=uEnableGpsCheckBox]').attr('checked', true);
            } else {
                $('input[id=uEnableGpsCheckBox]').attr('checked', false);
            }
            $('#uEidConfigurationStartDate').val(displayShortDate(mEnrolleesData.OffenderEidReservation.StartDate));
            $('#uEidConfigurationEndDate').val(displayShortDate(mEnrolleesData.OffenderEidReservation.EndDate));
            populateDateView('#uEidConfigurationStartDate', eidConfigurationDates_OnChange);
            populateDateView('#uEidConfigurationEndDate', eidConfigurationDates_OnChange);
            mEnrolleesControls.DeviceAssignmentsValidator.IsValid();
        });
    }

    function EnrolleeProfileAssignments_Init(aEnrolleeId) {
		"use strict";
		$('.TrackingDevice').hide();
		$('.StationDevice').hide();
		$('.BluHome').hide();
		$('.EidEnrollee').hide();
        $('#uAudibleToneWhenLowBatteryHolder').hide();
		$('.ConfigurationButton').hide();
		$('.DeviceCluster').hide();
		$('.Unassigned').show();
		$('.SoberDevice').hide();
        
		if (!isNullOrUndefined(mEnrolleesControls.DeviceAssignmentsListView)) {
            var lSort = new SortExpression(),
                lBuilder = new SumoPredicateBuilder();

            mEnrolleesData.OffenderEidReservation = null;
            
            EnrolleeEidCheck(mEnrolleesData.OffenderCurrentId);

			lSort.addDescendingColumn('StartDate');
            lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            ReadMultiple(gObjectList.DeviceAssignment.AssemblyQualifiedName, lBuilder.RootExpression, 0, EnrolleeProfileAssignments_OnLoad, Sad, null, lSort, 0);

            lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            ReadMultiple(gObjectList.DeviceClusterEnrollee.AssemblyQualifiedName, lBuilder.RootExpression, 0, enrolleesOffenderDeviceClusterRead_OnSuccess, enrolleesOffenderDeviceClusterRead_OnFailure, aEnrolleeId, null, 0);
        }
    }

    function uBluPlusSchedulesListView_OnSelectChange(aSender, aSelectedIndexes, aParams) {
        "use strict";
        var i,
            lItem,
            lIndexes = [];
        if (!isNullOrUndefined(aSelectedIndexes) && aSelectedIndexes.length > 3) {
            for (i = 0; i < 3; ++i) {

                lItem = aSelectedIndexes[i];
                if (!isNullOrUndefined(lItem)) {
                    lIndexes.push(lItem);
                }
            }
            aSender.selected(lIndexes);
        }
    }

    function bluPlusConfigurationSchedules_OnSaveSuccess(aParams, aData) {
        "use strict";
        var lItem,
            lKey;


        mEnrolleesControls.SchedulesBluPlusConfigurationListView.unbind('selectedchanged', uBluPlusSchedulesListView_OnSelectChange);

        if (!isNullOrUndefined(mEnrolleesControls.SchedulesBluPlusConfigurationListView)) {
            mEnrolleesControls.SchedulesBluPlusConfigurationListView.dispose();
            mEnrolleesControls.SchedulesBluPlusConfigurationListView = null;
        }
        ClosePopup();
    }

    function bluPlusConfiguration_OnSaveSuccess(aParams, aData) {
        "use strict";

        if (aParams.length > 0) {
            WriteMultiple(aParams, bluPlusConfigurationSchedules_OnSaveSuccess, null, null, true);
        } else {
            bluPlusConfigurationSchedules_OnSaveSuccess(null, []);
        }
    }

    function bluPlusConfiguration_OnSave() {
        "use strict";
        var lInitialValue = $('#uBluPlusConfigurationTetheredAddressId').val(),
            lBluPlusConfiguration = new BluPlusConfiguration(),
            lSelected = mEnrolleesControls.CardView.selectedDataItem(),
            lSchedules = mEnrolleesData.OffenderSchedules,
            lSelectedScheduleIds = mEnrolleesControls.SchedulesBluPlusConfigurationListView.selected(),
            lScheduleWrite = [],
            lItem,
            lKey,
            lBuilder = new SumoPredicateBuilder();

        lBluPlusConfiguration.Id = lSelected.TrackingDeviceId;
        lBluPlusConfiguration.EnrolleeId = lSelected.Id;
        populateFromEditView(lBluPlusConfiguration, 'uBluPlusConfiguration', 'Edit');
        //lBluPlusConfiguration.TetheredAddressId = lSelectedId;

        lBuilder.AddNewExpressionConditional('EnrolleeId', lSelected.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('ScheduleType', 6, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

        lSchedules = query(lSchedules, lBuilder.RootExpression);

        for (lKey in lSchedules) {
            if (lSchedules.hasOwnProperty(lKey)) {
                lItem = lSchedules[lKey];
                lItem = $.extend({}, lItem);
                lItem.IsEnabled = (lSelectedScheduleIds.indexOf(lItem.Id) !== -1);
                lItem.TransactionId = moment().format("YYYYMMDDHHmmss");
                lScheduleWrite.push(lItem);
            }
        }

        if (mEnrolleesControls.DeviceAssignmentsValidator.IsValid()) {
            if (lBluPlusConfiguration.VerificationPeriod !== '') {
                lBluPlusConfiguration.VerificationPeriod = Math.abs(parseInt(lBluPlusConfiguration.VerificationPeriod));
                WriteSingle(lBluPlusConfiguration, bluPlusConfiguration_OnSaveSuccess, null, lScheduleWrite, true);
            } else {
                bluPlusConfiguration_OnSaveSuccess(lScheduleWrite, null);
            }
        }
    }

    function uBluPlusConfigurationTetheredAddressIdEdit_OnChange(aSelect) {
        "use strict";
        var lInitialValue = $('#uBluPlusConfigurationTetheredAddressId').val(),
            lValue = $(aSelect).val();

        if (lValue !== lInitialValue) {
            $('#uBluPlusConfigurationVerificationPeriodEdit').addClass('ValidateRequired');
        } else {
            $('#uBluPlusConfigurationVerificationPeriodEdit').removeClass('ValidateRequired');
        }

        mEnrolleesControls.DeviceAssignmentsValidator.scan();
    }

    function uBluPlusConfigurationButton_OnClick() {
        "use strict";
        var lBuilder = new SumoPredicateBuilder(),
            lSelected = mEnrolleesControls.CardView.selectedDataItem();

        function bluPlusConfigurationPopup_OnLoad(aParams, aData) {
            var lSchedules = mEnrolleesData.OffenderSchedules,
                lBuilder = new SumoPredicateBuilder(),
                lBluPlusConfiguration = aParams.BluPlusConfiguration[0],
                lSelectedScheduleIds = [],
                lItem,
                lKey;

            mEnrolleesData.OffenderProfileAddresses = aData;

            if (!isNullOrUndefined(mEnrolleesData.OffenderProfileAddresses) && mEnrolleesData.OffenderProfileAddresses.length > 0) {

                populateEditView(lBluPlusConfiguration, [
                { 'Id': 'TetheredAddressId', 'Type': 'Dropdown', 'DataSource': mEnrolleesData.OffenderProfileAddresses, 'DataValueField': 'Id', 'DataTextField': 'Title' }
                ], { 'VerificationPeriod': blankFormatter }, 'uBluPlusConfiguration', 'Edit');

                populateEditView(lBluPlusConfiguration, [
                ], {}, 'uBluPlusConfiguration', '');

            }
            else {
                //empty dropdown
            }

            lBuilder.AddNewExpressionConditional('EnrolleeId', lSelected.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('ScheduleType', 6, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lSchedules = query(lSchedules, lBuilder.RootExpression);

            //if (isNullOrUndefined(mEnrolleesControls.SchedulesBluPlusConfigurationListView)) {
            mEnrolleesControls.SchedulesBluPlusConfigurationListView = new sumo.controls.ListView('uBluPlusSchedulesListView', 'uBluPlusSchedulesListViewHolder', {
                'keyField': 'Id', 'selectMethod': 'auto', 'cssClass': 'VeritracksListView', 'canUnselect': true
            }, [
                { 'id': 'Description', 'title': localizeWrapper('cEnrolleeDescription'), 'dataField': 'Name', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
                { 'id': 'EndTimeLocal', 'title': localizeWrapper('cEnrolleeCheckIn'), 'dataField': 'EndTimeLocal', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'date', 'formatMethod': getTimeFormatter },
                { 'id': 'IsSunday', 'title': localizeWrapper('cSundayLetter'), 'dataField': 'IsSunday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'dataType': 'boolean', 'cssClass': null, 'formatMethod': booleanShortFormatter, 'canResize': false },
                { 'id': 'IsMonday', 'title': localizeWrapper('cMondayLetter'), 'dataField': 'IsMonday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
                { 'id': 'IsTuesday', 'title': localizeWrapper('cTuesdayLetter'), 'dataField': 'IsTuesday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
                { 'id': 'IsWednesday', 'title': localizeWrapper('cWednesdayLetter'), 'dataField': 'IsWednesday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
                { 'id': 'IsThursday', 'title': localizeWrapper('cThursdayLetter'), 'dataField': 'IsThursday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
                { 'id': 'IsFriday', 'title': localizeWrapper('cFridayLetter'), 'dataField': 'IsFriday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
                { 'id': 'IsSaturday', 'title': localizeWrapper('cSaturdayLetter'), 'dataField': 'IsSaturday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false }
            ]);

            //}

            mEnrolleesControls.SchedulesBluPlusConfigurationListView.setDataSource(lSchedules);
            mEnrolleesControls.SchedulesBluPlusConfigurationListView.bind('selectedchanged', uBluPlusSchedulesListView_OnSelectChange);

            for (lKey in lSchedules) {
                if (lSchedules.hasOwnProperty(lKey)) {
                    lItem = lSchedules[lKey];
                    if (lItem.IsEnabled) {
                        lSelectedScheduleIds.push(lItem.Id);
                    }
                }
            }
            mEnrolleesControls.SchedulesBluPlusConfigurationListView.selected(lSelectedScheduleIds);
        }

        function bluPlusConfigurationRead_OnFailure(aParams, aData) {
            var l = "";
        }

        function bluPlusConfigurationRead_OnSuccess(aParams, aData) {
            var lButtonBar = GenerateButtonCommandBar(),
                lHtml = [],
                lBuilder = new SumoPredicateBuilder();

            GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'bluPlusConfiguration_OnSave();').appendTo(lButtonBar);

            DisplayPopup(localizeWrapper('cEnrolleeBluPlusConfiguration'), '<div id="uBluPlusConfigurationHolder">' + localizeWrapper('cEnrolleeLoading') + '</div>', lButtonBar, false);

            populateElement('uBluPlusConfigurationHolder', 'Enrollees.Offenders.Profile.Assignments.BluPlus.Popup.htm', function () {
                if (isNullOrUndefined(mEnrolleesData.OffenderProfileAddresses)) {
                    lBuilder.AddNewExpressionConditional('EnrolleeId', lSelected.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                    ReadMultiple(gObjectList.EnrolleeAddress.AssemblyQualifiedName, lBuilder.RootExpression, 0, bluPlusConfigurationPopup_OnLoad, Sad, { 'BluPlusConfiguration': aData }, null, 20);
                    lBuilder.Clear();


                } else {
                    bluPlusConfigurationPopup_OnLoad({ 'BluPlusConfiguration': aData }, mEnrolleesData.OffenderProfileAddresses);
                }

                mEnrolleesControls.DeviceAssignmentsValidator = new Validator('uBluPlusConfigurationHolder', mRegexValidation);
            });
        }

        lBuilder.AddNewExpressionConditional('Id', lSelected.TrackingDeviceId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('EnrolleeId', lSelected.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.BluPlusConfiguration.AssemblyQualifiedName, lBuilder.RootExpression, 0, bluPlusConfigurationRead_OnSuccess, bluPlusConfigurationRead_OnFailure, null, null, 0);
        lBuilder.Clear();
    }

    function uBluHomeConfigurationButton_OnSaveSuccess(aParams, aData) {
        "use strict";
        ClosePopup();
    }

    function uBluHomeConfigurationButton_OnSave(aId) {
        "use strict";
        var lConfiguration = new BluHomeConfiguration(),
            lDeviceAssignments = gCurrentDeviceAssignment[mEnrolleesData.OffenderCurrentId],
            lDevices = getDataItems('Devices'),
            lDevice,
            lItem,
            lKey;

        if (mEnrolleesControls.BluHomeEditValidator.IsValid()) {
            // the intent of this block is to find the device that is NOT a station device, but a tracking device
            for (lKey in lDeviceAssignments) {
                if (lDeviceAssignments.hasOwnProperty(lKey)) {
                    lItem = lDeviceAssignments[lKey];
                    lDevice = lDevices[lItem.Id];
                    if ([104, 109].indexOf(lDevice.ProductId) === -1) {
                        lConfiguration.TrackingDeviceId = lDevice.Id;
                        break;
                    }
                }
            }

            lConfiguration.Id = aId;
            lConfiguration.EnrolleeId = mEnrolleesData.OffenderCurrentId;
            lConfiguration.UserId = gUserDetails.UserId;
            lConfiguration.DoReset = $('#uBluHomeConfigurationDoResetEdit').is(':checked');
            $('#uBluHomeConfigurationDoResetEdit').val(lConfiguration.DoReset);
            populateFromEditView(lConfiguration, 'uBluHomeConfiguration', 'Edit');
            //lConfiguration.InRangeCount = 0;
            //lConfiguration.CallInPeriod = 0;
            WriteSingle(lConfiguration, uBluHomeConfigurationButton_OnSaveSuccess, null, {}, true);
        }
    }

    function uBluHomeConfigurationButton_OnComplete(aConfiguration) {
        "use strict";
        var lRfRange = getDataItems('RfRange');
        if (aConfiguration.CallInPeriod === -1) {
            aConfiguration.CallInPeriod = '';
        }
        if (aConfiguration.InRangeCount === -1) {
            aConfiguration.InRangeCount = '';
		}
        if (aConfiguration.OriginatingPhoneNumber === "-1") {
            aConfiguration.OriginatingPhoneNumber = '';
        }
        populateEditView(aConfiguration, [
            { 'Id': 'RfRange', 'Type': 'Dropdown', 'DataSource': getDataItems('RfRange'), 'LocaleName': 'RFRange', 'DataValueField': 'Id', 'DataTextField': 'Description' }
		], {}, 'uBluHomeConfiguration', 'Edit', localizeDataItem);
		if (!isNullOrUndefined(mEnrolleesControls.BluHomeEditValidator)) {
            mEnrolleesControls.BluHomeEditValidator.dispose();
        }
        mEnrolleesControls.BluHomeEditValidator = new Validator('uBluHomeEditPanel', mRegexValidation);
    }

    function enrolleesBluHomeConfiguration_OnRead(aParams, aData) {
        "use strict";
        var lButtonBar = GenerateButtonCommandBar(),
            lConfiguration = { 'Id': aParams.Id };

        if (aData.length > 0) {
            lConfiguration = aData[0];
        }
        GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'uBluHomeConfigurationButton_OnSave(' + lConfiguration.Id + ');').appendTo(lButtonBar);
        DisplayPopup(localizeWrapper('cEnrolleeBluHomeConfiguration'), '<div id="uBluHomeConfigurationHolder">' + localizeWrapper('cEnrolleeLoading') + '</div>', lButtonBar, false);
        populateElement('uBluHomeConfigurationHolder', 'Enrollees.Offenders.Profile.Assignments.BluHome.Popup.htm', function () { uBluHomeConfigurationButton_OnComplete(lConfiguration); });
    }

    function uBluHomeConfigurationButton_OnClick() {
        "use strict";
        var lBuilder = new SumoPredicateBuilder(),
            lAssignments = mEnrolleesControls.DeviceAssignmentsListView.getDataSource(),
            lCurrentDate = new Date('01-01-9000'),
            lDevices = getDataItems('Devices'),
            lParams,
            lDevice,
            lItem,
            lKey;

        for (lKey in lAssignments) {
            if (lAssignments.hasOwnProperty(lKey)) {
                lItem = lAssignments[lKey];
                lDevice = lDevices[lItem.Id];
                if (!isNullOrUndefined(lDevice)) {
                    if ([104, 109].indexOf(lDevice.ProductId) !== -1 && lItem.EndDate > lCurrentDate) {
                        lBuilder.AddNewExpressionConditional('Id', lItem.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());
                        lParams = lDevice;
                    }
                }
            }
        }
        if (!isNullOrUndefined(lBuilder.RootExpression)) {
            ReadMultiple(gObjectList.BluHomeConfiguration.AssemblyQualifiedName, lBuilder.RootExpression, 0, enrolleesBluHomeConfiguration_OnRead, uBluHomeConfigurationButton_OnClick, lParams, null, null, true);
        } else {
            enrolleesBluHomeConfiguration_OnRead(null, {});
        }

        //mEnrolleesControls.BluHomeEditValidator = new Validator('uBluHomeEditPanel', mRegexValidation);
    }

    function EnrolleeProfileAssignments_OnLoad(aParams, aAssignmentList) {
        "use strict";
        FixDates(aAssignmentList);
        var lKey,
            lCurrentDate = new Date('01-01-9000'),
            lSort = new SortExpression(),
            lAssignment,
            lItem,
			lDevice = null,
            lAlcoholDevice = null,
            isAssigned = false,
            lAssignedObject = null,
			lEnrollee = mEnrolleesControls.CardView.selectedDataItem();
		
        for (lKey in aAssignmentList) {
            if (aAssignmentList.hasOwnProperty(lKey)) {
                lAssignment = aAssignmentList[lKey];
                lAssignment.StartDate = displayEventInEnrolleeTimeZone(lAssignment.StartDate, lEnrollee.Enrollee);
                lAssignment.EndDate = displayEventInEnrolleeTimeZone(lAssignment.EndDate, lEnrollee.Enrollee);
                lAssignment.UnAssignedByUserId = lAssignment.AttemptRecoverFlag ? lAssignment.UnAssignedByUserId : -1;
                if(lCurrentDate < lAssignment.EndDate){
                    isAssigned = true;
                    lAssignedObject = lAssignment;
                }

                if (lAssignment.EndDate > lCurrentDate) {
                    lItem = lAssignment;//getDataItem(lAssignment.Id, 'Devices');
                    lDevice = getDataItem(lItem.Id, 'Devices');

                    if (lItem.AlcoholDeviceId !== -1) {
                        lAlcoholDevice = getDataItem(lItem.AlcoholDeviceId, 'Devices');
                    } else {
                        lAlcoholDevice = null;
                    }

                    if (!isNullOrUndefined(lDevice)) {
                        isAssignedCheck();
                        switch (lDevice.ProductId) {
                            case 151://BLUtag8
                            case 161://Tband
                            case 103://BLUtag
                                PopulateDetailView(lDevice, { 'ProductId': ProductNameFormatter }, 'uTrackingDevice');
                                $('.TrackingDevice').show();
                                $('.Unassigned').hide();
                                break;
                            case 141://bluTagInt
                                PopulateDetailView(lDevice, { 'ProductId': ProductNameFormatter }, 'uTrackingDevice');
                                $('.TrackingDevice').show();
                                $('.Unassigned').hide();
                                break;
                            case 106://BLUband
                                PopulateDetailView(lDevice, { 'ProductId': ProductNameFormatter }, 'uTrackingDevice');
                                $('.TrackingDevice').show();
                                $('.Unassigned').hide();
                                break;
                            case 110://BLU+
                                PopulateDetailView(lDevice, { 'ProductId': ProductNameFormatter }, 'uTrackingDevice');
                                applyUserPermissions([38]);
                                $('.BluPlus').show();
                                $('.TrackingDevice').show();
                                $('#uBluPlusConfigurationButton').show();
                                $('.Unassigned').hide();
                                break;
							case 104:// BluHome
								PopulateDetailView(lDevice, { 'ProductId': ProductNameFormatter, 'PhoneNumber': bluHomePhoneNumberFormatter }, 'uBluHome');
								$('#uBluHomeMessageButton').hide();
                                $('.BluHome').show();
                                $('#uBluHomeConfigurationButton').show();
                                $('.StationDevice').show();
								$('.Unassigned').hide();

                                break;
                            case 109:// BluHome Cellular
                                PopulateDetailView(lDevice, { 'ProductId': ProductNameFormatter, 'PhoneNumber': bluHomePhoneNumberFormatter }, 'uBluHome');
                                $('#uBluHomeMessageButton').show();
                                //$('#uBluHomePhoneNumberRow').hide();
                                $('.BluHome').show();
                                $('#uBluHomeConfigurationButton').show();
                                $('.StationDevice').show();
                                $('.Unassigned').hide();
                                $('#BluHomeV4FingerprintEnrollment').hide();
                                if (lDevice.SupportFingerprintFlag) {
                                    $('.BluHomeV4').show();
                                    $('#uBluHomePhoneNumber').html(bluHomePhoneNumberFormatter(lDevice.PhoneNumber));
                                    GetBluHomeCommandStatus(mEnrolleesData.OffenderCurrentId, ShowBluHomeInitiateStatus, Sad, null);
                                } else {
                                    $('.BluHomeV4').hide();
                                    $('#uBluHomePhoneNumber').html('');
                                }
                                break;
                            case 121://SoberTrack
                                PopulateDetailView(lDevice, { 'ProductId': ProductNameFormatter, 'PhoneNumber': bluHomePhoneNumberFormatter }, 'uSoberDevice');
                                $('.SoberDevice').show();
                                $('.Unassigned').hide();
                                break;

                        }
                    }

                    if (!isNullOrUndefined(lAlcoholDevice) && lAlcoholDevice.Id != lDevice.Id) {
                        PopulateDetailView(lAlcoholDevice, { 'ProductId': ProductNameFormatter, 'PhoneNumber': bluHomePhoneNumberFormatter }, 'uSoberDevice');
                        $('.SoberDevice').show();
                        $('.Unassigned').hide();
                        var sobertrackPairAssignment = new DeviceAssignment(lDevice.Id, lItem.EnrolleeId);
                        sobertrackPairAssignment.ProductId = lDevice.ProductId;
                        sobertrackPairAssignment.OrganizationId = lItem.OrganizationId;
                        sobertrackPairAssignment.EndDate = lItem.EndDate;
                        sobertrackPairAssignment.StartDate = lItem.StartDate;
                        sobertrackPairAssignment.UserId = lItem.UserId;
                        sobertrackPairAssignment.SerialNumber = lDevice.SerialNumber;
                        aAssignmentList.push(sobertrackPairAssignment);
                        lSort.addDescendingColumn("StartDate");
                        aAssignmentList = lSort.sort(aAssignmentList);
                    }
                }
                
            }
        }
        var isFlagEnabled =veritracks.system.clientSetting('enableaudibleinlowbattery');
        if(!isNullOrUndefined(lAssignedObject)){
            var lEnrollee = GetEnrollee(mEnrolleesData.OffenderCurrentId);
            $('#uAudibleToneWhenLowBatteryHolder')[isFlagEnabled === 1 && isAssigned && lAssignedObject.ProductId !== 161?'show':'hide']();
            if(isFlagEnabled == 1 && isAssigned ){
                //TODO: change ProductId with Enum
                if(!isNullOrUndefined(lAssignedObject) && lAssignedObject.hasOwnProperty('AudibleToneFlag')){
                    $('#uAudibleToneWhenLowBattery').attr('checked',!!lAssignedObject['AudibleToneFlag']);
                }
            }
        }
        mEnrolleesControls.DeviceAssignmentsListView.setDataSource(aAssignmentList);
        mEnrolleesControls.DeviceAssignmentsListView.sort();
	} 


function ShowBluHomeInitiateStatus(aParams, aData) {
    if (aData[0] && aData[0].BluHomeInitiateStatus !== undefined && aData[0].BluHomeInitiateStatus !== "") {
        $('#BluHomeV4FingerprintEnrollment').show();
        $('#uBluHomeAssignmentStatus').html(aData[0].BluHomeInitiateStatus);
    }
}

function uBluHomeSendMessageButton_OnClick() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lAssignments = mEnrolleesControls.DeviceAssignmentsListView.getDataSource(),
        lCurrentDate = new Date('01-01-9000'),
        lDevices = getDataItems('Devices'),
        lParams,
        lDevice,
        lItem,
        lKey;

    for (lKey in lAssignments) {
        if (lAssignments.hasOwnProperty(lKey)) {
            lItem = lAssignments[lKey];
            lDevice = lDevices[lItem.Id];
            if (!isNullOrUndefined(lDevice)) {
                if ([104, 109].indexOf(lDevice.ProductId) !== -1 && lItem.EndDate > lCurrentDate) {
                    lBuilder.AddNewExpressionConditional('Id', lItem.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());
                    lParams = lDevice;
                }
            }
        }
    }

    if (!isNullOrUndefined(lBuilder.RootExpression)) {
        ReadMultiple(gObjectList.BluHomeConfiguration.AssemblyQualifiedName, lBuilder.RootExpression, 0, enrolleesBluHomeConfigurationMessage_OnRead, uBluHomeSendMessageButton_OnClick, lParams, null, null, true);
    } else {
        enrolleesBluHomeConfigurationMessage_OnRead(null, {});
    }
}

function enrolleesBluHomeConfigurationMessage_OnRead(aParams, aData) {
    "use strict";
    var lHtml = [],
        lButtonBar = GenerateButtonCommandBar(),
        lConfiguration = { 'Id': aParams.Id };

    if (aData.length > 0) {
        lConfiguration = aData[0];
    }

    lHtml.push('<div id="uBluHomeSendMessage">');
    lHtml.push('<p>');
    lHtml.push(localizeWrapper('cInventoryBluHomeSendMessage'));
    lHtml.push('</p>')
    lHtml.push('<p>');
    lHtml.push(localizeWrapper('cInventoryBluHomeSendTopLabel'));
    lHtml.push('</p>')
    lHtml.push('<input type="text" id="uBluHomeTopLine"/>');
    lHtml.push('<p>');
    lHtml.push(localizeWrapper('cInventoryBluHomeSendBottomLabel'));
    lHtml.push('</p>')
    lHtml.push('<input type="text" id="uBluHomeBottomLine"/>');
    lHtml.push('<p></div>');

    GenerateButton(localizeWrapper('cInventoryPostMessage'), 'Post Message', 'uBluHomePostMessageButton(' + lConfiguration.Id + ');').appendTo(lButtonBar);
    GenerateButton(localizeWrapper('cInventoryClearMessage'), 'Clear Message', 'uBluHomeClearMessageButton(' + lConfiguration.Id + ');').appendTo(lButtonBar);
    DisplayPopup(localizeWrapper('cInventoryBluHomeMessageManager'), lHtml.join(''), lButtonBar, false);

}

function uBluHomePostMessageButton(aId) {
    "use strict";
    var lTopLine = $('#uBluHomeTopLine').val(),
        lBottomLine = $('#uBluHomeBottomLine').val(),
        lConfiguration = new BluHomeConfiguration();

    // post message
    lConfiguration.Id = aId;
    lConfiguration.UserId = gUserDetails.UserId;
    lConfiguration.EnrolleeId = mEnrolleesData.OffenderCurrentId
    lConfiguration.CommandType = 1;
    lConfiguration.TopMessage = lTopLine;
    lConfiguration.BottomMessage = lBottomLine;

    WriteSingle(lConfiguration, aOnSuccess, null, null, null);

    function aOnSuccess(aParams, aData) {
        ClosePopup();
    }
}

function uBluHomeClearMessageButton(aId) {
    "use strict";
    var lConfiguration = new BluHomeConfiguration();

    // clear message
    lConfiguration.Id = aId;
    lConfiguration.UserId = gUserDetails.UserId;
    lConfiguration.EnrolleeId = mEnrolleesData.OffenderCurrentId
    lConfiguration.CommandType = 0;
    lConfiguration.TopMessage = '';
    lConfiguration.BottomMessage = '';

    WriteSingle(lConfiguration, aOnSuccess, null, null, null);

    function aOnSuccess(aParams, aData) {
        ClosePopup();
    }
}

// SCHEDULES PROCESSING
function enrolleeAddress_Init(aEnrolleeId, aCallback) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();

    lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.EnrolleeAddress.AssemblyQualifiedName, lBuilder.RootExpression, 0, aCallback, Sad, aEnrolleeId, null, 20);
}



function EnrolleeProfileContactHistory_Init(aEnrolleeId) {
    "use strict";

    function onToggle() {
        lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('ContactDate', lStartDate, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.EnrolleeContact.AssemblyQualifiedName, lBuilder.RootExpression, 0, EnrolleeProfileContactHistory_OnComplete, Sad, null, lSort, 0);
    }


    if (!isNullOrUndefined(mEnrolleesControls.ContactHistoryListView)) {
        mEnrolleesControls.ContactHistoryListView.setDataSource([]);
        var lBuilder = new SumoPredicateBuilder(),
            lSort = new SortExpression(),
            lStartDate = new Date(),
            lIds = [],
            lKey;
        lSort.addDescendingColumn('ContactDate');
        lStartDate.addDays(-1);

        setLoadingBarStatus('uEnrolleesContactLoadingBar', 'uEnrolleesContactHistoryHolder', true, onToggle);
    }
}

function EnrolleeProfileContactHistory_OnComplete(aParams, aContactList) {
    "use strict";
    FixDates(aContactList);
    //setLoadingBarStatus('uEnrolleesContactLoadingBar', 'uEnrolleesContactHistoryHolder', false, onToggle);
    $('#uEnrolleesContactLoadingBar').hide();
    $('#uEnrolleesContactHistoryHolder').show();

    mEnrolleesControls.ContactHistoryListView.setDataSource(aContactList);
    mEnrolleesControls.ContactHistoryListView.sort();
}

//function mStateManagerEnrolleesSecondaryActions_Init() {
//    var lEnrolleeId = mEnrolleesData.OffenderCurrentId;
//    if (mStateManager.Settings()[0] === 'Victims') {
//        lEnrolleeId = mEnrolleesData.VictimCurrentId;
//    }
//}

function EnrolleesAdvancedDataPermissions(aHash, aId) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lEnrollee = null;

    lBuilder.AddNewExpressionConditional('Id', aId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.Enrollee.AssemblyQualifiedName, lBuilder.RootExpression, 0, EnrolleeAdvancedPermissions_OnSuccess, null, null, null, 0);

    function EnrolleeAdvancedPermissions_OnSuccess(aParams, aData) {
        if (ObjectLength(aData) > 0) {
            FixDates(aData);
            lEnrollee = aData[0];
            lEnrollee.InMyOrganization = false;
            setDataItem(aId, 'Enrollees', lEnrollee);
            if (lEnrollee.EnrolleeType == 2) {
                aHash = 'Enrollees.Victims.Map.Events';
            }
            lBuilder.Clear();
            lBuilder.AddNewExpressionConditional('Id', lEnrollee.AgentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            ReadMultiple(gObjectList.Agent.AssemblyQualifiedName, lBuilder.RootExpression, 0, AgentAdvancedPermissions_OnSuccess, null, null, null, 0);
        } else {
            lEnrollee = getDataItem(aId, 'EnrolleesUniversal');
            AgentAdvancedPermissions_OnSuccess(null, []);
        }
    }

    function AgentAdvancedPermissions_OnSuccess(aParams, aData) {
        if (ObjectLength(aData) > 0) {
            FixDates(aData);
            setDataItem(aData[0].Id, 'Agents', aData[0]);
        }
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('Id', lEnrollee.OrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.Organization.AssemblyQualifiedName, lBuilder.RootExpression, 0, OrganizationAdvancedPermissions_OnSuccess, null, null, null, 0);
    }

    function OrganizationAdvancedPermissions_OnSuccess(aParams, aData) {
        if (ObjectLength(aData) > 0) {
            FixDates(aData);
            setDataItem(aData[0].Id, 'Organizations', aData[0]);
        }
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('Id', aId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.EnrolleeLastContact.AssemblyQualifiedName, lBuilder.RootExpression, 0, EnrolleeLastContactAdvancedPermissions_OnSuccess, null, null, null, 0);
    }

    function EnrolleeLastContactAdvancedPermissions_OnSuccess(aParams, aData) {
        if (ObjectLength(aData) > 0) {
            FixDates(aData);
            setDataItem(aId, 'EnrolleeLastContact', aData[0]);
        }
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('EnrolleeId', aId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('EndDate', (new Date(9000, 11, 30)), false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.DeviceAssignment.AssemblyQualifiedName, lBuilder.RootExpression, 0, DeviceAssignmentAdvancedPermissions_OnSuccess, null, null, null, 0);

    }

    function DeviceAssignmentAdvancedPermissions_OnSuccess(aParams, aData) {
        if (ObjectLength(aData) > 0) {
            FixDates(aData);
            setDataItem(aId, 'CurrentDeviceAssignments', aData);
            gCurrentDeviceAssignment[aId] = aData;
            lBuilder.Clear();
            lBuilder.AddNewExpressionConditional('Id', getArrayByIds(aData), false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            ReadMultiple(gObjectList.Device.AssemblyQualifiedName, lBuilder.RootExpression, 0, DeviceAdvancedPermissions_OnSuccess, null, null, null, 0);
        } else {
            DeviceAdvancedPermissions_OnSuccess(null, []);
        }
    }

    function DeviceAdvancedPermissions_OnSuccess(aParams, aData) {
        // here we go to the enrollees page
        if (ObjectLength(aData) > 0) {
            FixDates(aData);
            for (var lKey in aData) {
                if (aData.hasOwnProperty(lKey)) {
                    setDataItem(aData[lKey].Id, 'Devices', aData[lKey]);
                }
            }
        }
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('EnrolleeId', aId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.DeviceClusterEnrollee.AssemblyQualifiedName, lBuilder.RootExpression, 0, DeviceClusterEnrolleeAdvancedPermissions_OnSuccess, null, null, null, 0);
    }

    function DeviceClusterEnrolleeAdvancedPermissions_OnSuccess(aParams, aData) {
        // here we go to the enrollees page
        if (ObjectLength(aData) > 0) {
            FixDates(aData);
            setDataItem(aData[0].Id, 'DeviceClusterEnrollee', aData[0]);
            lBuilder.Clear();
            lBuilder.AddNewExpressionConditional('Id', aData[0].DeviceClusterId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            ReadMultiple(gObjectList.DeviceCluster.AssemblyQualifiedName, lBuilder.RootExpression, 0, DeviceClusterAdvancePermissions_OnSuccess, null, null, null, 0);
        } else {
            DeviceClusterAdvancePermissions_OnSuccess(null, []);
        }
    }

    function DeviceClusterAdvancePermissions_OnSuccess(aParams, aData) {
        if (ObjectLength(aData) > 0) {
            FixDates(aData);
            setDataItem(aData[0].Id, 'DeviceClusters', aData[0]);
        }
        // check page on if on enrollees call data list converter
        if (mStateManager.Tab() == 'Enrollees') {
            enrolleesDataListConverter();
            if (!isNullOrUndefined(mEnrolleesControls.CardView)) {
                mEnrolleesData.TargetId = aId;
                mEnrolleesControls.CardViewOffenderFilter.filter();
            }
        } else {
            window.location.hash = aHash + "." + aId.toString();
        }
    }
}


function enrolleesDataListConverter() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lSort = new SortExpression(),
        lAssignSort = new SortExpression(),
        lEpoch = new Date(0),
        lEnrolleeCard = new EnrolleeCardView(),
        lEventSummaryList = getDataItems('EnrolleeEventSummary'),
        lEnrolleeList = getDataItems('Enrollees'),
        lDeviceList = getDataItems('Devices'),
        lAgentList = getDataItems('Agents'),
        lSortState = getViewState('EnrolleesCardViewSort'),
        lDeviceClusterEnrolleesList = getDataItems('DeviceClusterEnrollee'),
        lAgent,
        lMyAgents,
        lMyAgentIds = [],
        lDevice,
        lAlcoholDevice = null,
        lDeviceAssignments,
        lLastContact,
        lDoContactDetails = false,
        lEventSummary,
        lEnrolleeItem,
        lEnrolleeKey,
        lEnrolleeCardList = [],
        lDeviceClusterEnrolleeItem,
        lEnrollee,
        lCluster,
        lItem,
        lKey;

    var lAssociationsDisabled = veritracks.system.clientSetting("associationdisabled");

    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lDeviceClusterEnrolleesList = query(lDeviceClusterEnrolleesList, lBuilder.RootExpression);


    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('UserId', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lMyAgents = query(lAgentList, lBuilder.RootExpression);
    lBuilder.Clear();
    for (lKey in lMyAgents) {
        if (lMyAgents.hasOwnProperty(lKey)) {
            lItem = lMyAgents[lKey];
            lMyAgentIds.push(lItem.Id);
        }
    }

    for (lEnrolleeKey in lEnrolleeList) {
        if (lEnrolleeList.hasOwnProperty(lEnrolleeKey)) {
            lEnrolleeItem = lEnrolleeList[lEnrolleeKey];
            lEnrolleeCard = new EnrolleeCardView();

            // EnrolleeenrolleeCorrelate_OnSuccess
            lEnrolleeCard.Enrollee = lEnrolleeItem;
            lEnrolleeCard.FullName = lEnrolleeItem.FullName;
            if (lEnrolleeCard.FullName == "")
                lEnrolleeCard.FullName = lEnrolleeItem.LastName + ', ' + lEnrolleeItem.FirstName;
            lEnrolleeCard.FirstName = lEnrolleeItem.FirstName;
            lEnrolleeCard.LastName = lEnrolleeItem.LastName;
            lEnrolleeCard.Id = lEnrolleeItem.Id;
            lEnrolleeCard.IsAssigned = lEnrolleeItem.IsAssigned;
            lEnrolleeCard.IsEnrollink = lEnrolleeItem.IsEnrollink;

            lEnrolleeCard.OrganizationId = lEnrolleeItem.OrganizationId;
            lEnrolleeCard.PrimaryId = lEnrolleeItem.PrimaryId;
            lEnrolleeCard.InMyOrganization = (gUserDetails.OrganizationIds.indexOf(lEnrolleeItem.OrganizationId) !== -1);
            lEnrolleeCard.RiskLevelId = lEnrolleeItem.RiskLevelId;
            lEnrolleeCard.SecondaryId = lEnrolleeItem.SecondaryId;
            lEnrolleeCard.EnrolleeType = lEnrolleeItem.EnrolleeType;


            if (!isNullOrUndefined(lEnrolleeItem.HasVictimFlag) && lEnrolleeItem.HasVictimFlag) {
                lEnrolleeCard.HasVictimDisplay = 'block';
            }

            if (!isNullOrUndefined(lEnrolleeItem.HasAssociationFlag) && lEnrolleeItem.HasAssociationFlag) {
               // lEnrolleeCard.HasAssociationFlag = lEnrolleeItem.HasAssociationFlag;
                //lEnrolleeCard.AssociationEventDisplay = 'block';
            }
            // Agent
            lAgent = lAgentList[lEnrolleeItem.AgentId];
            if (!isNullOrUndefined(lAgent)) {
                lEnrolleeCard.AgentName = lAgent.FullName;
            }else{
                lEnrolleeCard.AgentName = '- unknown -';
            }

            lEnrolleeCard.IsMyCaseload = (lMyAgentIds.indexOf(lEnrolleeItem.AgentId) !== -1);
                // Device
                lDeviceAssignments = gCurrentDeviceAssignment[lEnrolleeItem.Id];
                lAssignSort.addAscendingColumn('ProductId');
                lDeviceAssignments = lAssignSort.sort(lDeviceAssignments);
                if (!isNullOrUndefined(lDeviceAssignments)) {
                    for (lKey in lDeviceAssignments) {
                        if (lDeviceAssignments.hasOwnProperty(lKey)) {
                            lItem = lDeviceAssignments[lKey];
                            lDevice = lDeviceList[lItem.Id];
                            lAlcoholDevice = lDeviceList[lItem.AlcoholDeviceId];
                            if (!isNullOrUndefined(lDevice) && lEnrolleeCard.IsAssigned) {
                                if ([2, 7].indexOf(lDevice.ProductType) !== -1) {
                                    lEnrolleeCard.TrackingDeviceId = lDevice.Id;
                                    lEnrolleeCard.TrackingDeviceDisplay = 'block';
                                    lEnrolleeCard.TrackingDeviceSerialNumber = lDevice.SerialNumber;
                                    //lEnrolleeCard.HasGpsDevice = true;
                                    if (lDevice.ProductType === 7) {
                                        lEnrolleeCard.DeviceTrackType = 1;
                                    } else {
                                        lEnrolleeCard.DeviceTrackType = 2;
                                        lEnrolleeCard.HasGpsDevice = true;
                                    }
                                } else if (lDevice.ProductType == 8 && lEnrolleeCard.TrackingDeviceId == -1) {
                                    lEnrolleeCard.TrackingDeviceId = lDevice.Id;
                                    lEnrolleeCard.TrackingDeviceDisplay = 'block';
                                    lEnrolleeCard.TrackingDeviceSerialNumber = lDevice.SerialNumber;
                                    lEnrolleeCard.DeviceTrackType = 2;
                                    lEnrolleeCard.HasGpsDevice = true;
                                    lEnrolleeCard.SobertrackUsage = sobertrackTotalTestFormatter(lDevice.SobertrackUsage);
                                    lEnrolleeCard.HasSoberTrackDevice = true;                                  
                                    lEnrolleeCard.SoberTrackDisplay = 'block';
                                } else if ([3,8].indexOf(lDevice.ProductType) !== -1) {
                                    lEnrolleeCard.StationDeviceId = lDevice.Id;
                                    lEnrolleeCard.StationDeviceDisplay = 'block';
                                    lEnrolleeCard.StationDeviceSerialNumber = lDevice.SerialNumber;
                                    if (lDevice.ProductType == 8) {
                                        lEnrolleeCard.HasSoberTrackDevice = true;                                        
                                    }
                                }
                            }//end of outer if
                            
                            if (!isNullOrUndefined(lAlcoholDevice)) {
                                var lAlcoholLastCompleatedTest = GetSoberTrackLastCompleatedTestCheckByEnrolleeId(lEnrolleeItem.Id,lEnrolleeItem.OrganizationId)
                                lEnrolleeCard.DeviceTrackType = 3;
                                if(lAlcoholLastCompleatedTest){                                   
                                    lEnrolleeCard.LastTestDisplay = 'block';
                                    lEnrolleeCard.LastTestDateDisplay = "Last Test Result "+DisplayShortDateTime(displayEventInEnrolleeTimeZone(fixDate(lAlcoholLastCompleatedTest.StartDate), lEnrolleeCard.Enrollee)); 
                                }
                                var lAlcoholLastCheck = GetSoberTrackLastTestByEnrolleeId(lEnrolleeItem.Id);
                                if(lAlcoholLastCheck){
                                    lEnrolleeCard.LastCheckDisplay = 'block';
                                    lEnrolleeCard.LastCheckDateDisplay = "Last Check " +DisplayShortDateTime(displayEventInEnrolleeTimeZone(fixDate(lAlcoholLastCheck.StartDate), lEnrolleeCard.Enrollee)); 
                                }
                                if (lEnrolleeCard.TrackingDeviceId == -1) {
                                    lEnrolleeCard.TrackingDeviceId = lAlcoholDevice.Id;
                                    lEnrolleeCard.TrackingDeviceDisplay = 'block';
                                    lEnrolleeCard.TrackingDeviceSerialNumber = lAlcoholDevice.SerialNumber;                                    
                                    lEnrolleeCard.HasGpsDevice = true;
                                    lEnrolleeCard.HasSoberTrackDevice = true;                                    
                                } else if (lDevice.Id != lAlcoholDevice.Id) {
                                    lEnrolleeCard.StationDeviceId = lAlcoholDevice.Id;
                                    lEnrolleeCard.StationDeviceDisplay = 'block';
                                    lEnrolleeCard.StationDeviceSerialNumber = lAlcoholDevice.SerialNumber;
                                    lEnrolleeCard.HasSoberTrackDevice = true;                                   
                                }
                            }//end fo if
                        }
                    }
                }

                if (lEnrolleeCard.Id === 231) {
                    var l = '';
                }

                // Last Contact
                lDoContactDetails = false;
                if (lEnrolleeCard.TrackingDeviceId !== -1 || lEnrolleeCard.StationDeviceId !== -1) {
                    lLastContact = getDataItem(lEnrolleeItem.Id, 'EnrolleeLastContact');
                    if (!isNullOrUndefined(lLastContact) && lLastContact.DeviceId !== -1) {
                        if (lLastContact.DeviceId === lEnrolleeCard.TrackingDeviceId) {
                            lEnrolleeCard.TrackingDeviceContactDate = displayEventInEnrolleeTimeZone(lLastContact.ContactDate, lEnrolleeCard.Enrollee);
                            lEnrolleeCard.TrackingDeviceContactDateDisplay = DisplayShortDateTime(displayEventInEnrolleeTimeZone(lLastContact.ContactDate, lEnrolleeCard.Enrollee));
                            lEnrolleeCard.TrackingDeviceContactDisplay = 'block';
                            lDoContactDetails = true;
                        } else if (lLastContact.DeviceId === lEnrolleeCard.StationDeviceId) {
                            lDoContactDetails = true;
                            lEnrolleeCard.StationDeviceContactDate = displayEventInEnrolleeTimeZone(lLastContact.ContactDate, lEnrolleeCard.Enrollee);
                            lEnrolleeCard.StationDeviceContactDateDisplay = DisplayShortDateTime(displayEventInEnrolleeTimeZone(lLastContact.ContactDate, lEnrolleeCard.Enrollee));
                            lEnrolleeCard.StationDeviceContactDisplay = 'block';
                        }
                        if (lDoContactDetails) {
                            lEnrolleeCard.LastContactDate = displayEventInEnrolleeTimeZone(lLastContact.ContactDate, lEnrolleeCard.Enrollee);
                            lEnrolleeCard.LastContactDateDisplay = DisplayShortDateTime(displayEventInEnrolleeTimeZone(lLastContact.ContactDate, lEnrolleeCard.Enrollee));
                            if (lLastContact.TrackDate > lEpoch) {
                                lEnrolleeCard.LastTrackpointDate = lLastContact.TrackDate;
                                lEnrolleeCard.LastTrackpointDateDisplay = DisplayShortDateTime(displayEventInEnrolleeTimeZone(lLastContact.TrackDate, lEnrolleeCard.Enrollee));
                                lEnrolleeCard.LastContactDisplay = 'block';
                                lEnrolleeCard.LastContactVersion = lLastContact.Version;
                            }
                            lEnrolleeCard.LastLatitude = lLastContact.Latitude;
                            lEnrolleeCard.LastLongitude = lLastContact.Longitude;
                            if (lLastContact.BatteryLevel !== 0 && lLastContact.BatteryVoltage !== 0) {
                                lEnrolleeCard.LastContactBatteryImage = inventoryBatteryLevelFormatter(lLastContact.BatteryLevel);
                                lEnrolleeCard.LastContactBatteryLevel = DisplayVolts(lLastContact.BatteryVoltage);
                                lEnrolleeCard.LastContactBatteryPercentage = deviceBatteryPercentageFormatter(lLastContact.BatteryPercentage);
                                lEnrolleeCard.LastContactBatteryDisplay = 'block';
                            }
                        }
                    }
                }
                if (lEnrolleeCard.TrackingDeviceId === -1 && lEnrolleeCard.StationDeviceId === -1) {
                    lEnrolleeCard.TrackingDeviceDisplay = 'block';
                }

                // Event Summary
                if (!isNullOrUndefined(lEventSummaryList)) {
                    lEventSummary = lEventSummaryList[lEnrolleeItem.Id];
                    if (!isNullOrUndefined(lEventSummary)) {
                        if (lEventSummary.StrapTamperEventIndicator) {
                            lEnrolleeCard.TamperEventDisplay = 'block';
                        }
                        if (lEventSummary.ZoneEventIndicator) {
                            lEnrolleeCard.ZoneEventDisplay = 'block';
                        }
                        if (lEventSummary.ScheduleEventIndicator) {
                            lEnrolleeCard.ScheduleEventDisplay = 'block';
                        }
                        if (lEnrolleeCard.IsAssigned && lEnrolleeItem.HasVictimFlag || lEnrolleeItem.EnrolleeType == 2) {
                            lEnrolleeCard.VictimEventLevel = victimLevelFormatter(lEventSummary);
                            lEnrolleeCard.VictimIconDisplay = lEnrolleeCard.VictimEventLevel.length > 0 ? 'block' : 'none';
                            lEnrolleeCard.VictimEventLevelDesc = getVictimLevelDesc(lEventSummary);
                        }
                        if (lEventSummary.AssociationEventIndicator) {
                            lEnrollee = getDataItem(lEnrolleeItem.Id, 'Enrollees');                           
                            var lIsInformatics = false;
                            if (!isNullOrUndefined(lEnrollee)) {
                                lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
                            }
                            if (lIsInformatics || !lAssociationsDisabled) {
                                lEnrolleeCard.AssociationEventDisplay = 'block';
                                lEnrolleeCard.HasAssociationFlag = true;
                                var lTimeZone = getTimezone(lEnrolleeItem.TimeZoneId);
                                var lTime;

                                if (lTimeZone) {
                                    lTime = moment(lEventSummary.LastAssociationDateString).tz(lTimeZone.TimeZoneName);
                                } else {
                                    lTime = moment(lEventSummary.LastAssociationDateString);
                                }
                                lEnrolleeCard.LastAssociationDate = "Last Association starting: " + lTime.from(moment());
                            }                           
                        }

                        lEnrolleeCard.HasOpenEvents = (lEventSummary.Open || lEventSummary.OpenConfirmed);

                        if (lEventSummary.EmaPendingRequest == true || lEventSummary.EmaPendingMsg == true) {
                            lEnrolleeCard.HasEmaEvents = '';
                        }
                    }
                }
                for (lKey in lDeviceClusterEnrolleesList) {
                    if (lDeviceClusterEnrolleesList.hasOwnProperty(lKey)) {
                        lDeviceClusterEnrolleeItem = lDeviceClusterEnrolleesList[lKey];
                        if (lDeviceClusterEnrolleeItem.EnrolleeId === lEnrolleeItem.Id) {
                            lCluster = getDataItem(lDeviceClusterEnrolleeItem.DeviceClusterId, 'DeviceClusters');
                            if (lCluster && lCluster.IsActive) {
                                lEnrolleeCard.StationDeviceSerialNumber = lCluster.Name;
                                lEnrolleeCard.StationDeviceDisplay = 'block';
                            }
                        }
                    }
                }

                lEnrolleeCardList[lEnrolleeItem.Id] = lEnrolleeCard;
        }
    }

    // Data Assignment
    lSort.addAscendingColumn('FullName');

    lBuilder.AddNewExpressionConditional('EnrolleeType', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    mEnrolleesData.OffenderClean = query(lEnrolleeCardList, lBuilder.RootExpression);
    mEnrolleesData.OffenderClean = lSort.sort(mEnrolleesData.OffenderClean);
    mEnrolleesData.OffenderSort = null;
    if (!isNullOrUndefined(lSortState)) {
        mEnrolleesData.OffenderSort = lSortState.Value.sort(mEnrolleesData.OffenderClean);
    }
    lBuilder.Clear();

    lBuilder.AddNewExpressionConditional('EnrolleeType', 2, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    mEnrolleesData.VictimClean = query(lEnrolleeCardList, lBuilder.RootExpression);
    mEnrolleesData.VictimClean = lSort.sort(mEnrolleesData.VictimClean);
    mEnrolleesData.VictimSort = null;
    if (!isNullOrUndefined(lSortState)) {
        mEnrolleesData.VictimSort = lSortState.Value.sort(mEnrolleesData.VictimClean);
    }

    lBuilder.Clear();
    if (!isNullOrUndefined(mEnrolleesControls.EnrolleesMap)) {
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('CaseLoad', veritracks.mapping.prepareContactMarkerData(mEnrolleesData.LastLocationByCardView));
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('CaseLoadLabels', veritracks.mapping.prepareSuggestionLabelOverlayData(mEnrolleesData.LastLocationByCardView));
    }
    $('#uRefreshButton').addClass('RefreshNoButton');
}

function test(aParams, aData) {
    var lBuilder = new SumoPredicateBuilder(),
    victimCard = aParams,
    victimData = aData[0],
    offenderCard = null;
    if (victimCard.IsAssigned) {
        victimCard.VictimEventLevel = victimLevelFormatter(victimData);
        victimCard.VictimIconDisplay = victimCard.VictimEventLevel.length > 0 ? 'block' : 'none';
        victimCard.VictimEventLevelDesc = getVictimLevelDesc(victimData);
        //query offenderclean array with the OffenderId of the victim
        if (victimData.OffenderId !== -1) {
            lBuilder.AddNewExpressionConditional('Id', victimData.OffenderId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            //Offender card below: set icon on it too
            var offenderCards = query(mEnrolleesData.OffenderClean, lBuilder.RootExpression);
            for (var lKey in offenderCards) {
                if (offenderCards.hasOwnProperty(lKey)) {
                    offenderCard = offenderCards[lKey];
                    offenderCard.VictimEventLevel = victimCard.VictimEventLevel;
                    offenderCard.VictimIconDisplay = victimCard.VictimIconDisplay;
                    offenderCard.VictimEventLevelDesc = victimCard.VictimEventLevelDesc;
                }
            }
        }
    }

}
function testfail(aParams, aData) {

}
function enrolleesDataItem_Updated(aParams, aCache) {
    "use strict";
    var lPaginatedData;
    if (mStateManager.Settings()[0] == 'Offenders') {
        lPaginatedData = mEnrolleesData.OffenderPaginated;
    } else {
        lPaginatedData = mEnrolleesData.VictimPaginated;
    }
    enrolleesDataListConverter();
    if (!isNullOrUndefined(mEnrolleesControls.CardView)) {
        var lUpdatedReturn = UpdateViewOnNewDataReturn(aCache, lPaginatedData);
        if (lUpdatedReturn.IsFound) {
            var lArrayByIdA = getArrayByIds(lUpdatedReturn.ReturnData);
            var lArrayByIdB = getArrayByIds(mEnrolleesData.EnrolleeRecentlyUpdated);
            lArrayByIdB = lArrayByIdB.unique();
            // check if updated items are more than what was forced updated
            if (lArrayByIdA.length > lArrayByIdB.length) {
                mEnrolleesControls.CardView.setUpdated(true);
                if (!$('#enrolleeInfo').is(':hidden')) {
                    UpdateTimelineEnrolleeInfo();
                    uDisplayHoverMoreChartCycleData();
                }
            }
            mEnrolleesData.EnrolleeRecentlyUpdated = [];
        }
    }
}

function deviceClusterDataListConverter() {
    "use strict";
    var lTempList = getDataItems('DeviceClusters'),
        lBuilder = new SumoPredicateBuilder(),
        lItem,
        lKey,
        lCard;


    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lTempList = query(lTempList, lBuilder.RootExpression);
    for (lKey in lTempList) {
        if (lTempList.hasOwnProperty(lKey)) {
            lItem = lTempList[lKey];
            lCard = new DeviceAssignmentCardView();
            lCard.Title = lItem.Name;
            lCard.Description = lItem.Description;
            lCard.Id = lItem.Id;
            lCard.ProductId = 999;
            lCard.OrganizationId = lItem.OrganizationId;
            lCard.IsAssignable = true;
            lCard.IsMultiAssignable = false;
            lCard.ZoneId = lItem.ZoneId;
            lCard.Zone = BlueBoxZoneFormatter(lItem.ZoneId);
            if (!isNullOrUndefined(mEnrolleesData.StationEnrollees[lCard.Id])) {
                lCard.EnrolleeId = mEnrolleesData.StationEnrollees[lCard.Id].EnrolleeId;
                lCard.IsBluPlus = bluPlusCheck(lCard.EnrolleeId);
            } else {
                lCard.EnrolleeId = -1;
                lCard.IsBluPlus = false;
            }
            mEnrolleesData.StationsClean['C' + lItem.Id] = lCard;
        }
    }
}

function deviceAddOnDataListConverter() {
    "use strict";
    var lCardViewList = {},
        lBuilder = new SumoPredicateBuilder(),
        lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
        lCurrentAssigned = gCurrentDeviceAssignment[mEnrolleesData.OffenderCurrentId],
        lDevices = getDataItems('Devices'),
        lProducts = getDataItems('Products'),
        lDeviceAssignments,
        lDeviceAssignment,
        lAssignmentItem,
        lEnrolleeAssignments,
        lIsAssignable,
        lDeviceList = [],
        lItem,
        lCard = new DeviceAssignmentCardView();


    lBuilder.AddNewExpressionConditional('EndDate', new Date(), false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());
    lDeviceAssignments = query(getDataItems('CurrentDeviceAssignments'), lBuilder.RootExpression);
    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('ProductId', 111, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsInUse', false, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('OrganizationId', lEnrollee.OrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lDeviceList = query(lDevices, lBuilder.RootExpression);

    for (var lKey in lCurrentAssigned) {
        if (lCurrentAssigned.hasOwnProperty(lKey)) {
            if (lCurrentAssigned[lKey].ProductId == 111) {
                var lDevice = getDataItem(lCurrentAssigned[lKey].Id, 'Devices');
                lDeviceList.push(lDevice);
            }
        }
    }
    for (var lKey in lDeviceList) {
        if (lDeviceList.hasOwnProperty(lKey)) {
            lItem = lDeviceList[lKey];
            if ([1, 2, 3, 5].indexOf(lItem.Status) !== -1) {
                // unassigned
                lIsAssignable = true;
            } else if (lItem.Status === 4) {
                // assigned
                lBuilder.Clear();
                lBuilder.AddNewExpressionConditional('Id', lItem.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lDeviceAssignment = query(lDeviceAssignments, lBuilder.RootExpression);
                if (!isNullOrUndefined(lDeviceAssignment)) {
                    for (var lAssignmentKey in lDeviceAssignment) {
                        if (lDeviceAssignment.hasOwnProperty(lAssignmentKey)) {
                            lAssignmentItem = lDeviceAssignment[lAssignmentKey];
                            lEnrolleeAssignments = gCurrentDeviceAssignment[lAssignmentItem.EnrolleeId];
                            lIsAssignable = true;
                        }
                    }
                } else {
                    lIsAssignable = false;
                }
            }
            if (lIsAssignable) {
                lCard = new DeviceAssignmentCardView();
                lCard.Title = lItem.SerialNumber;
                lCard.Description = lProducts[lItem.ProductId].Name;
                lCard.Id = lItem.Id;
                lCard.ProductId = lItem.ProductId;
                lCard.OrganizationId = lItem.OrganizationId;
                lCardViewList['A' + lItem.Id] = lCard;
                lCard.IsAssignable = lIsAssignable;
                lCard.IsMultiAssignable = false;
            }
        }
    }

    mEnrolleesData.AddOnsClean = lCardViewList;
}

function EnrolleesDeviceClusterEnrollee_OnLoad(aParams, aData) {
    "use strict";
    var lKey,
        lItem,
        lCard,
        lClusterIdList = {};

    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lItem = aData[lKey];
            lCard = new StationEnrollee();
            lCard.EnrolleeId = lItem.EnrolleeId;
            lCard.DeviceClusterId = lItem.DeviceClusterId;
            lClusterIdList[lItem.DeviceClusterId] = lCard;
        }
    }

    mEnrolleesData.StationEnrollees = lClusterIdList;
    deviceClusterDataListConverter();
}

function enrolleesStationListConverter() {
    "use strict";
    var lCardViewList = {},
        lBuilder = new SumoPredicateBuilder(),
        lDevices = getDataItems('Devices'),
        lBluBoxGroups = null,
        lQuery,
        lProducts = getDataItems('Products'),
        lDCDList = getDataItems('DeviceClusterDevices'),
        lDeviceIdList = [],
        lDeviceAssignments,
        lDeviceAssignment,
        lEnrolleeAssignments,
        lAssignedIds = [],
        lAssignment,
        lTempList,
        lItem,
        lCard = new DeviceAssignmentCardView(),
        lKey,

        lIsAssignable = null,
        lIsMultiAssignable = null,

        lBluTags,
        lBluTagInts,
        lBluHomes,
        lBluTagIds = [],
        lBluTagExpression,

        lBluBoxes,

        lBluTwos,

        lSoberTracks,

        lAssignmentKey,
        lAssignmentItem,
        lItemId,
        lClusterIdList = [];




    lBuilder.AddNewExpressionConditional('EndDate', new Date(), false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());
    lDeviceAssignments = query(getDataItems('CurrentDeviceAssignments'), lBuilder.RootExpression);

    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('ProductId', [103, 151], false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lBluTags = query(lDevices, lBuilder.RootExpression);

    for (lKey in lBluTags) {
        if (lBluTags.hasOwnProperty(lKey)) {
            lBluTagIds.push(lKey);
        }
    }

    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('ProductId', 141, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBluTagInts = query(lDevices, lBuilder.RootExpression);

    for (lKey in lBluTagInts) {
        if (lBluTagInts.hasOwnProperty(lKey)) {
            lBluTagIds.push(lKey);
        }
    }

    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('ProductId', [104, 109], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lBluHomes = query(lDevices, lBuilder.RootExpression);

    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('Id', lBluTagIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lBluTagExpression = lBuilder.RootExpression;
    for (lKey in lBluHomes) {
        if (lBluHomes.hasOwnProperty(lKey)) {
            lIsMultiAssignable = null;
            lIsAssignable = null;
            lItem = lBluHomes[lKey];
            if ([1, 2, 3, 5].indexOf(lItem.Status) !== -1) {
                // unassigned
                lIsAssignable = true;
                lIsMultiAssignable = false;
            } else if (lItem.Status === 4) {
                // assigned
                lBuilder.Clear();
                lBuilder.AddNewExpressionConditional('Id', lItem.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lDeviceAssignment = query(lDeviceAssignments, lBuilder.RootExpression);
                if (!isNullOrUndefined(lDeviceAssignment)) {
                    for (lAssignmentKey in lDeviceAssignment) {
                        if (lDeviceAssignment.hasOwnProperty(lAssignmentKey)) {
                            lAssignmentItem = lDeviceAssignment[lAssignmentKey];
                            lEnrolleeAssignments = gCurrentDeviceAssignment[lAssignmentItem.EnrolleeId];
                            //lQuery = query(lEnrolleeAssignments, lBluTagExpression);
                            lIsAssignable = false;
                            lIsMultiAssignable = true; //(count(lQuery) === 0);
                        }
                    }
                } else {
                    lIsAssignable = true;
                    lIsMultiAssignable = false;
                }
            }
        }
        if (lIsAssignable || lIsMultiAssignable) {
            lCard = new DeviceAssignmentCardView();
            lCard.Title = lItem.SerialNumber;
            lCard.Description = lProducts[lItem.ProductId].Name;
            lCard.Id = lItem.Id;
            lCard.ProductId = lItem.ProductId;
            lCard.OrganizationId = lItem.OrganizationId;
            lCardViewList['D' + lItem.Id] = lCard;
            lCard.IsAssignable = lIsAssignable;
            lCard.IsMultiAssignable = lIsMultiAssignable;
        }
    }
    //lDeviceAssignments = getDataItems('DeviceClusterDevices');
    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('ProductId', 105, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('Status', [1, 2, 3, 5], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());


    //for (lKey in lDCDList) {
    //    if (lDCDList.hasOwnProperty(lKey)) {
    //        lItem = lDCDList[lKey];
    //        lDeviceIdList.push(lItem.DeviceId);
    //    }
    //}
    //if (lDeviceIdList.length > 0) {
    //    lBuilder.AddNewExpressionConditional('Id', lDeviceIdList, false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And());
    //}

    lBluBoxes = query(lDevices, lBuilder.RootExpression);
    for (lKey in lBluBoxes) {
        if (lBluBoxes.hasOwnProperty(lKey)) {
            lItem = lBluBoxes[lKey];
            //if (!isNullOrUndefined(lDeviceAssignments)) {
            //lDeviceAssignment = lDeviceAssignments[lItem.Id];
            //if ([1, 2, 3, 5].indexOf(lItem.Status) !== -1 || isNullOrUndefined(lDeviceAssignment)) {
            lCard = new DeviceAssignmentCardView();
            lCard.Title = lItem.SerialNumber;
            lCard.Description = lProducts[lItem.ProductId].Name;
            lCard.Id = lItem.Id;
            lCard.ProductId = lItem.ProductId;
            lCard.OrganizationId = lItem.OrganizationId;
            lCardViewList['D' + lItem.Id] = lCard;
            lCard.IsAssignable = true;
            lCard.IsMultiAssignable = false;
            //}
            //}
        }
    }

    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('ProductId', 111, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('Status', [1, 2, 3, 5], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());

    lBluTwos = query(lDevices, lBuilder.RootExpression);

    for (lKey in lBluTwos) {
        if (lBluTwos.hasOwnProperty(lKey)) {
            lItem = lBluTwos[lKey];
            lCard = new DeviceAssignmentCardView();
            lCard.Title = lItem.SerialNumber;
            lCard.Description = lProducts[lItem.ProductId].Name;
            lCard.Id = lItem.Id;
            lCard.ProductId = lItem.ProductId;
            lCard.OrganizationId = lItem.OrganizationId;
            lCardViewList['D' + lItem.Id] = lCard;
            lCard.IsAssignable = true;
            lCard.IsMultiAssignable = false;
        }
    }

    lTempList = getDataItems('DeviceClusters');
    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lTempList = query(lTempList, lBuilder.RootExpression);

    for (lKey in lTempList) {
        if (lTempList.hasOwnProperty(lKey)) {
            lItemId = lTempList[lKey].Id;
            lClusterIdList.push(lItemId);
        }
    }
    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('IsActive', true, true, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    if (lClusterIdList.length === 0) {
        lClusterIdList.push(-9999);
    }
    lBuilder.AddNewExpressionConditional('DeviceClusterId', lClusterIdList, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.DeviceClusterEnrollee.AssemblyQualifiedName, lBuilder.RootExpression, 0, EnrolleesDeviceClusterEnrollee_OnLoad, null, null);

    //        for (lKey in lTempList) {
    //    if (lTempList.hasOwnProperty(lKey)) {
    //        lItem = lTempList[lKey];
    //        lCard = new DeviceAssignmentCardView();
    //        lCard.Title = lItem.Name;
    //        lCard.Description = lItem.Description;
    //        lCard.Id = lItem.Id;
    //        lCard.ProductId = 999;
    //        lCard.OrganizationId = lItem.OrganizationId;
    //        lCardViewList['C' + lItem.Id] = lCard;
    //        lCard.IsAssignable = true;
    //        lCard.IsMultiAssignable = false;
    //        if (!isNullOrUndefined(mEnrolleesData.StationEnrollees[lCard.Id])) {
    //            lCard.EnrolleeId = mEnrolleesData.StationEnrollees[lCard.Id].EnrolleeId;
    //            lCard.IsBluPlus = bluPlusCheck(lCard.EnrolleeId);
    //        } else {
    //            lCard.EnrolleeId = -1;
    //            lCard.IsBluPlus = false;
    //        }
    //    }
    //}

    //SoberTrack
    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('ProductId', 121, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('Status', [1, 2, 3, 5], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lSoberTracks = query(lDevices, lBuilder.RootExpression);

    for (var lKey in lSoberTracks) {
        if (lSoberTracks.hasOwnProperty(lKey)) {
            var lItem = lSoberTracks[lKey];
            var lCard = new DeviceAssignmentCardView();
            lCard.Title = lItem.SerialNumber;
            lCard.Description = lProducts[lItem.ProductId].Name;
            lCard.Id = lItem.Id;
            lCard.ProductId = lItem.ProductId;
            lCard.OrganizationId = lItem.OrganizationId;
            lCardViewList['D' + lItem.Id] = lCard;
            lCard.IsAssignable = true;
            lCard.IsMultiAssignable = false;
        }
    }



    mEnrolleesData.StationsClean = lCardViewList;
}

function enrolleesScheduleZonesDataListConverter() {
    "use strict";
    var lZonesList = getDataItems('Zones'),
        lBuilder = new SumoPredicateBuilder(),
        lScheduleTargetList = [],
        lScheduleTarget = new ScheduleTarget(),
        lZone,
        lKey;

    //lBuilder.AddNewExpressionConditional('Scope', 3, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());
    //lBuilder.AddNewExpressionConditional('AgentId', [], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.Or());
    lBuilder.AddNewExpressionConditional('Scope', 3, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('AoiZoneEnable', false, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lZonesList = query(lZonesList, lBuilder.RootExpression);
    for (lKey in lZonesList) {
        if (lZonesList.hasOwnProperty(lKey)) {
            lZone = lZonesList[lKey];
            lScheduleTarget = new ScheduleTarget();
            lScheduleTarget.Id = lZone.Id;
            lScheduleTarget.Name = lZone.Name;
            lScheduleTarget.TypeId = 1;
            if (lZone.Type === 1) {
                lScheduleTarget.TypeName = localizeText('cZoneInclusionZone');
            } else {
                lScheduleTarget.TypeName = localizeText('cZoneExclusionZone');
            }
            lScheduleTarget.AddressType = lZone.AddressTypeId > 0 ? addressTypeFormatter(lZone.AddressTypeId) + ' ' + localizeText('cEnrolleeAddress') : "";
            lScheduleTarget.UniqueId = 'Z' + lZone.Id;
            lScheduleTargetList[lScheduleTarget.UniqueId] = lScheduleTarget;
        }
    }
    mEnrolleesData.SchedulesZonesClean = lScheduleTargetList;
}


function enrolleesScheduleAddressesDataListConverter(aParams, aData) {
    "use strict";
    var lAddressList = aData,
    lBuilder = new SumoPredicateBuilder(),
    lScheduleTargetList = [],
    lScheduleTarget = new ScheduleTarget(),
    lAddress,
    lKey;

    if (!isNullOrUndefined(mEnrolleesData.SchedulesTargetsClean)) {
        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lAddressList = query(lAddressList, lBuilder.RootExpression);

        for (lKey in lAddressList) {
            if (lAddressList.hasOwnProperty(lKey)) {
                lAddress = lAddressList[lKey];
                lScheduleTarget = new ScheduleTarget();
                lScheduleTarget.Id = lAddress.Id;
                lScheduleTarget.Name = lAddress.Title;
                lScheduleTarget.TypeId = 6;
                lScheduleTarget.TypeName = addressTypeFormatter(lAddress.AddressTypeId) + ' ' + localizeText('cEnrolleeAddress');
                lScheduleTarget.UniqueId = 'A' + lAddress.Id;
                mEnrolleesData.SchedulesTargetsClean[lScheduleTarget.UniqueId] = lScheduleTarget;
            }
        }
        //mEnrolleesData.SchedulesAddressesClean = lScheduleTargetList;
        //mEnrolleesData.SchedulesTargetsClean = mEnrolleesData.SchedulesTargetsClean.concat(lScheduleTargetList);
    }
}

function uFilterCleaner(aOrder) {
    var lKey,
        lUnallowed,
        lColumnList = [],
        lOrder = aOrder;

    if (lOrder == 1) {
        lUnallowed = ['AgentName', 'BirthDate', 'IsMyCaseload', 'HeightFeet','HasAssociationFlag', 'HeightInches', 'HasOpenEvents', 'IsAssigned','IsEnrollink', 'DeviceTrackType', 'PrimaryID', 'SecondaryID', 'FullName', 'RiskLevelId', 'OrganizationId', 'IsEid'];
    }
    else if (lOrder == 2){
        lUnallowed = ['Height', 'HeightFeet', 'HeightInches', 'Weight', 'HairColorId', 'EyeColorId', 'MarksTattoos', 'GenderId', 'RaceId', 'VehicleColor', 'VehicleYear', 'VehicleMake', 'VehicleModel', 'VehiclePlateNumber', 'IsEid'];
    } else {
        lUnallowed = ['IsEid']
    }

    for (lKey in mEnrolleesControls.CardViewOffenderFilter.Columns) {
        var lColumns = mEnrolleesControls.CardViewOffenderFilter.Columns[lKey];
        //// need a cleaner for gender
        //if (lColumns.Id === 'GenderId' && lColumns.Value == '3') {

        //}
        if ($.inArray(lColumns.Id, lUnallowed) < 0) {
            lColumnList.push(lColumns);
        }
    }

    mEnrolleesControls.CardViewOffenderFilter.SetSecondaryColumns(lColumnList);
    mEnrolleesControls.CardViewOffenderFilter.LiveExpressionModifier();
}

function eidFilterBuilder() {
    var lBuilder = new SumoPredicateBuilder();
    var eidExpression = mEnrolleesControls.CardViewOffenderFilter.ExpressionState.IsEid;
    if (!eidExpression || eidExpression.Value === "") {
        return lBuilder.RootExpression;
    }
    var riskLevels = Object.values(getDataItems('RiskLevels')).filter(function (risk) { return risk.EidTypeId !== -1 });
    var riskLevelIds = riskLevels.map(function (eidRiskLevels) { return eidRiskLevels.Id }).unique();
    var organizationIds = riskLevels.map(function (eidRiskLevels) { return eidRiskLevels.OrganizationId }).unique();

    if (eidExpression.Value) {
        lBuilder.AddNewExpressionConditional('RiskLevelId', riskLevelIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    } else {
        lBuilder.AddNewExpressionConditional('RiskLevelId', riskLevelIds, false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And());
    }

    return lBuilder.RootExpression;
}

function uOffendersCardViewFilter_OnFilter(aSender, aExpression, aData) {
    "use strict";
    var lBuilder,
        lExpression,
        lIsEmpty = true,
        lSortState = getViewState('EnrolleesCardViewSort');

    setViewState('DandEFilterViewState', false);
    if (isNullOrUndefined(mEnrolleesData.OffenderSort)) {
        mEnrolleesData.OffenderSort = mEnrolleesData.OffenderClean;
    }
    if (mEnrolleesData.TargetId === -1) {
        // filter eid here 
        mEnrolleesData.OffenderSort = query(mEnrolleesData.OffenderClean, eidFilterBuilder());
        uFilterCleaner(3);
        lExpression = mEnrolleesControls.CardViewOffenderFilter.Expression;

        mEnrolleesData.OffenderDirty = query(mEnrolleesData.OffenderSort, lExpression);
        uFilterCleaner(1);
        lExpression = mEnrolleesControls.CardViewOffenderFilter.Expression;
        if (!isNullOrUndefined(lExpression)) {
            ReadMultiple(gObjectList.OffenderProfile.AssemblyQualifiedName, lExpression, 0, offenderProfileFilter_OnComplete, null, null, null, 0);
        }
        else {
            offenderProfileFilter_OnComplete([], null);
        }
        deleteViewState('SpatialMatchesEnrollee');
    } else {
        lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('Id', mEnrolleesData.TargetId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        mEnrolleesData.OffenderDirty = query(mEnrolleesData.OffenderSort, lBuilder.RootExpression);
        offenderProfileFilter_OnFinish();
    }

    if (mEnrolleesData.AnalysisEnrollee === -1 || mEnrolleesData.OffenderPaginated.length > 1) {
        $('#uEnrolleeSpatialBackButton').hide();
    }
    else {
        mEnrolleesData.AnalysisEnrollee = -1;
    }
    function offenderProfileFilter_OnComplete(aParams, aData) {
        "use strict";
        var lIds,
            lBuilder = new SumoPredicateBuilder(),
            lExpression;

        lBuilder.Clear();
        if (!isNullOrUndefined(aData)) {
            uFilterCleaner(2);
            lExpression = mEnrolleesControls.CardViewOffenderFilter.Expression;

            if (!isNullOrUndefined(lExpression)) {
                if (lExpression.__type === 'ExpressionBinary:www.sumosoftware.com/Expressions') {
                    lBuilder.AddExpressionBinary(lExpression);
                } else {
                    lBuilder.AddConditional(lExpression);
                }
            }

            lIds = getArrayByIds(aData);
            lBuilder.AddNewExpressionConditional('Id', lIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            mEnrolleesData.OffenderDirty = query(mEnrolleesData.OffenderSort, lBuilder.RootExpression);
        }
        offenderProfileFilter_OnFinish();
    }

    function offenderProfileFilter_OnFinish() {
        if (mEnrolleesData.OffenderDirty)
            lIsEmpty = (mEnrolleesData.OffenderDirty.length === 0);
		veritracks.system.applyFilterState('Enrollees', lIsEmpty);
        if (isNullOrUndefined(lSortState)) {
            mEnrolleesData.OffenderDirty = EnrolleeSortFormatter(mEnrolleesData.OffenderDirty);
        }
        mEnrolleesData.OffenderPaginated = mEnrolleesControls.CardViewOffenderPaginator.paginate(mEnrolleesData.OffenderDirty);
        if (mEnrolleesData.OffenderPaginated.length === 0) {
            $('#uEnrolleeTrackPointCount').html('');
        }
        if (!isNullOrUndefined(mEnrolleesControls.CardView)) {
            for (var lKeyA in mEnrolleesData.OffenderPaginated) {
                if (mEnrolleesData.OffenderPaginated.hasOwnProperty(lKeyA)) {
                    mEnrolleesData.OffenderPaginated[lKeyA].EventIconDisplay = 'none';
                }
            }
            mEnrolleesControls.CardView.setDataSource(mEnrolleesData.OffenderPaginated);
        }
        //if (isNullOrUndefined(mEnrolleesControls.CardViewOffenderPaginator)) {
        //    uOffendersCardViewPaginator_Init();
        //}

        uLastLocationByCardViewFiltered();
        if (lIsEmpty) {
            if (!$("#uHomeToolCommandButton").hasClass("regionalOri")) {
                $("#uHomeToolCommandButton").addClass("regionalOri");
                $("#uMapCommandCell").css("width", "115px");
            }
        }
        veritracks.localization.localizeTitle();
    }
}

function uLastLocationByCardViewFiltered() {
    "use strict";
    var lCardViewTrackpoints = [],
        lLastContact,
        lKey;

    for (lKey in mEnrolleesData.OffenderPaginated) {
        if (mEnrolleesData.OffenderPaginated.hasOwnProperty(lKey)) {
            var lData = mEnrolleesData.OffenderPaginated[lKey];
            lLastContact = getDataItem(lData.Id, 'EnrolleeLastContact');
            if (!isNullOrUndefined(lLastContact) && lLastContact.DeviceId !== -1) {
                if (lLastContact.DeviceId === lData.TrackingDeviceId) {                    
                    // iteration 3 (id 663) filter by enrollee card list not caseload removed .IsMyCaseload filter leaving all cardviews with trackdata
                    if (lLastContact.Latitude !== 0 && lLastContact.Longitude !== 0) {                        
                        //CardViewTrackpoints.push({ 'Latitude': lLastContact.Latitude, 'Longitude': lLastContact.Longitude, 'TrackTypeId': 12, 'Name': lData.FullName, 'IconId': lLastContact.IconId });
                        lCardViewTrackpoints.push({ 'Latitude': lLastContact.Latitude, 'Longitude': lLastContact.Longitude, 'TrackTypeId': 12, 'Name': lData.FullName, 'IconId': lLastContact.IconId });
                        
                    }
                }
            }
        }
    }
    mEnrolleesData.LastLocationByCardView = lCardViewTrackpoints;
    if ($('#uToggleAllLastKnownPointsButton').is(':hidden')) {
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('CaseLoad', veritracks.mapping.prepareTrackpointMarkerData(mEnrolleesData.LastLocationByCardView));
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('CaseLoadLabels', veritracks.mapping.prepareSuggestionLabelOverlayData(mEnrolleesData.LastLocationByCardView));
    }
}

function uOffendersPaginator_OnPageChanged(aSender, aNewPage, aData) {
    "use strict";
    if (!isNullOrUndefined(mEnrolleesData.OffenderDirty)) {
        mEnrolleesData.OffenderPaginated = aSender.paginate(mEnrolleesData.OffenderDirty);
        var lIsEmpty = (mEnrolleesData.OffenderDirty.length === 0);
        for (var lKeyA in mEnrolleesData.OffenderPaginated) {
            if (mEnrolleesData.OffenderPaginated.hasOwnProperty(lKeyA)) {
                mEnrolleesData.OffenderPaginated[lKeyA].EventIconDisplay = 'none';
            }
        }
        mEnrolleesControls.CardView.setDataSource(mEnrolleesData.OffenderPaginated);
        veritracks.system.applyFilterState('Enrollees', lIsEmpty);

        uLastLocationByCardViewFiltered();
        // mEnrolleesControls.CardView.dataBind();
    }
    setViewState('EnrolleesSelectedPage', aNewPage);
}

function enrolleesScheduleDataListConverter(aScheduleList) {
    "use strict";
    var lScheduleList = [],
        lScheduleItem = new ScheduleItem({}),
        lZones = getDataItems('Zones'),
        lDevices = getDataItems('Devices'),
        lDeviceClusters =[],
        lItem,
        lSchedule,
        lKey,
        lAddresses,
        lBuilder = new SumoPredicateBuilder();

    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lDeviceClusters = query(getDataItems('DeviceClusters'), lBuilder.RootExpression);
    lBuilder.Clear();

    for (lKey in aScheduleList) {
        if (aScheduleList.hasOwnProperty(lKey)) {
            lSchedule = aScheduleList[lKey];
            lScheduleItem = new ScheduleItem(lSchedule);
            switch (lScheduleItem.TargetTypeId) {
                case 8:
                case 1:
                    lItem = lZones[lScheduleItem.EntityId];
                    if (!isNullOrUndefined(lItem)) {
                        if (lItem.Type == 1) {
                            lScheduleItem.TargetName = lSchedule.ZoneName + ' - '+ localizeText('cZoneInclusion');
                        }
                        else if (lItem.Type == 2) {
                            lScheduleItem.TargetName = lSchedule.ZoneName + ' - ' + localizeText('cZoneExclusion');
                        }
                    } else {
                        lScheduleItem.TargetName = lSchedule.ZoneName;
                    }
                    break;
                case 10:
                case 2:
                    lItem = lDevices[lScheduleItem.EntityId];
                    if (!isNullOrUndefined(lItem)) {
                        lScheduleItem.TargetName = lItem.SerialNumber;
                    }
                    break;
                case 7:
                case 3:
                    if(lDeviceClusters[lScheduleItem.EntityId]){
                      lItem = lDeviceClusters[lScheduleItem.EntityId];
                      if (!isNullOrUndefined(lItem)) {
                          lScheduleItem.TargetName = lItem.Name;
                      }
                    }
                    break;
                case 6:
                    if (!isNullOrUndefined(mEnrolleesData.SchedulesTargetsClean)) {
                        lItem = mEnrolleesData.SchedulesTargetsClean['A' + lScheduleItem.EntityId];
                    }
                    if (!isNullOrUndefined(lItem)) {
                        lScheduleItem.TargetName = lItem.Name;
                    }
                    break;
            }
            lScheduleList.push(lScheduleItem);
        }
    }
    return lScheduleList;
}

function prepEnrolleeScheules(aSchedules) {
    "use strict";
    var lResult = [],
        lItem,
        lKey,
        lSort = new SortExpression();
    for (lKey in aSchedules) {
        if (aSchedules.hasOwnProperty(lKey)) {
            lItem = aSchedules[lKey];
            lResult.push({
                'id': lItem.Id,
                'type': lItem.ScheduleType.toString().toLowerCase(),
                'startSunday': lItem.IsSunday,
                'startMonday': lItem.IsMonday,
                'startTuesday': lItem.IsTuesday,
                'startWednesday': lItem.IsWednesday,
                'startThursday': lItem.IsThursday,
                'startFriday': lItem.IsFriday,
                'startSaturday': lItem.IsSaturday,
                'startTime': lItem.StartTime,
                'endTime': lItem.EndTime, // - if end time < start time, then break to two schedule items. one start time to midnight and one midnight to end time the following day
                'hoverText': lItem.Name
            });
        }
    }
    lSort.addAscendingColumn('type');
    lResult = lSort.sort(lResult);
    return lResult;
}



function EnrolleeProfileSchedules_OnLoad(aParams) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lDevices = getDataItems('Devices'),
        lDeviceAssignments = gCurrentDeviceAssignment[aParams.EnrolleeId],
        lAssignment,
        lEnrolleeScheduleDisplays = [],
        lEnrolleeSchedules,
        lCarveEnabled = veritracks.system.clientSetting('veritracksabsenceschedules'),
        lScheduleTarget,
        lDevice,
        lItem,
        lZoneIdList = [],
        lSelectedEnrollee,
        lSort,
        lKey,
        lBluPlusDevice;
    //OffenderScheduleDisplay



    if (mEnrolleesControls.CardView) {
        lSelectedEnrollee = mEnrolleesControls.CardView.selectedDataItem();
    }
    mCache.bind('Zonesupdated', enrolleesScheduleZonesDataListConverter);
    enrolleesScheduleZonesDataListConverter();

      if (!isNullOrUndefined(aParams.EnrolleeId) && aParams.EnrolleeId > 0) {
          lBuilder.AddNewExpressionConditional('EnrolleeId', aParams.EnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
          lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

          ReadMultiple(gObjectList.DeviceClusterEnrollee.AssemblyQualifiedName, lBuilder.RootExpression, 0, EnrolleeProfileScheduleDeviceCluster_OnLoad, null, aParams);
          lBuilder.Clear();


              MyZoneEnrolleesInit(mEnrolleesData.OffenderSchedules);

              for (lKey in mEnrolleesData.OffenderSchedules) {
                  if (mEnrolleesData.OffenderSchedules.hasOwnProperty(lKey)) {
                      lEnrolleeScheduleDisplays.push(new OffenderScheduleDisplay(mEnrolleesData.OffenderSchedules[lKey], true));
                  }
              }
              lEnrolleeSchedules = enrolleesScheduleDataListConverter(lEnrolleeScheduleDisplays);

              if (!isNullOrUndefined(lDeviceAssignments)) {
                  for (lKey in lDeviceAssignments) {
                      if (lDeviceAssignments.hasOwnProperty(lKey)) {
                          lAssignment = lDeviceAssignments[lKey];
                          if (!isNullOrUndefined(lAssignment)) {
                              lDevice = lDevices[lAssignment.Id];
                          }
                          if (!isNullOrUndefined(lDevice) && [104, 109].indexOf(lDevice.ProductId) !== -1) {
                              lScheduleTarget = new ScheduleTarget();
                              lScheduleTarget.Id = lDevice.Id;
                              lScheduleTarget.Name = lDevice.SerialNumber;
                              lScheduleTarget.TypeId = 2;
                              lScheduleTarget.TypeName = 'BLUhome';
                              lScheduleTarget.UniqueId = 'B' + lDevice.Id;
                              mEnrolleesData.SchedulesTargetsClean[lScheduleTarget.UniqueId] = lScheduleTarget;
                          }
                          if ([110].indexOf(lDevice.ProductId !== -1)) {
                              lBluPlusDevice = lDevice;
                          }
                      }
                  }
                  if (isNullOrUndefined(lBluPlusDevice)) {
                      lBluPlusDevice = lDevice;
                  }
                  uEnrolleesDeviceHistoryColumns_OnSuccess(lEnrolleeSchedules, lBluPlusDevice.Id);
              }
              else {
                  lSort = new SortExpression();
                  lSort.addDescendingColumn('EndDate');
                  lBuilder.Clear();
                  lBuilder.AddNewExpressionConditional('EnrolleeId', aParams.EnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                  ReadMultiple(gObjectList.DeviceAssignment.AssemblyQualifiedName, lBuilder.RootExpression, 0, uEnrolleesDeviceHistoryColumns_OnSuccess, null, lEnrolleeSchedules, lSort, 0);
              }
          }
}

function MyZoneEnrolleesInit(aSchedules) {
    "use strict";
    if (!mEnrolleesControls.CardView) return;

    var lBuilder = new SumoPredicateBuilder();
    var lZonesList = [];
    var lZoneIdList = [];
    var lSelectedEnrollee = mEnrolleesControls.CardView.selectedDataItem();
    var lMyAgentIds = getMyAgentIdsByOrganization(gUserDetails.UserId, [lSelectedEnrollee.OrganizationId]);

    lBuilder.AddNewExpressionConditional('AgentId', lMyAgentIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lZonesList = query(getDataItems('Zones'), lBuilder.RootExpression) || [];

    lZonesList.forEach(function (zone) {
        lZoneIdList.push(zone.Id);
    });

    aSchedules.forEach(function (schedule) {
        if ([1, 8].indexOf(schedule.ScheduleType) !== -1)
            lZoneIdList.push(schedule.EntityId);
    });
    mEnrolleesData.EnrolleeZoneIdList = lZoneIdList.unique();
}

function uEnrolleesDeviceHistoryColumns_OnSuccess(aParams, aData) {
    FixDates(aData);
    var lDevice,
        lColumns = [],
        lOldColumns,
        lEnrolleeSchedules = aParams;

    if (ObjectLength(aData) > 0) {
        lDevice = aData[0];
    }
    else {
        lDevice = getDataItem(aData, 'Devices');
    }

    mEnrolleesData.EnrolleesSchedulesSorted = lEnrolleeSchedules;


    if(mEnrolleesControls.SchedulesListView) {
      lOldColumns = mEnrolleesControls.SchedulesListView.getColumns();

      lColumns.push({ 'id': 'Description', 'title': 'Description', 'dataField': 'Name', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
          { 'id': 'Target', 'title': 'Target', 'dataField': 'TargetName', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
          { 'id': 'TargetType', 'title': 'Target Type', 'dataField': 'TargetTypeName', 'width': 'autoData', 'minWidth': 75, 'sortable': true, 'cssClass': null, 'dataType': 'number', 'formatMethod': null });

      if (!displayOldScheduleUILoggedInOri(mEnrolleesData.OffenderCurrentId) && displayDSTSchedules()) {
            lColumns.push({ 'id': 'StartTimeLocal', 'title': 'Start', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': getCheckInFormatter },
            { 'id': 'EndTimeLocal', 'title': 'End', 'dataField': 'EndTimeLocal', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': getTimeFormatter });
        }else{
            lColumns.push({ 'id': 'StartTime', 'title': 'Start', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': formatScheduleStartTime },
          { 'id': 'EndTime', 'title': 'End', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': formatScheduleEndTime });
        }

      if (!isNullOrUndefined(lDevice)) {
          if (lDevice.ProductId == 110) {
              lColumns.push({ 'id': 'IsEnabled', 'title': 'Enabled', 'dataField': 'IsEnabled', 'width': 'autoData', 'minWidth': 85, 'sortable': true, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': EventConfirmedFormatter });
          }
      }
      lColumns.push({ 'id': 'ScheduleType', 'title': 'Type', 'dataField': 'ScheduleType', 'width': 'autoData', 'minWidth': 85, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
         { 'id': 'ZoneScheduleType', 'title': 'Zone Category', 'dataField': 'ZoneScheduleType', 'width': 'autoData', 'minWidth': 85, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': scheduleZoneTypeFormatter },
         { 'id': 'IsSunday', 'title': 'S', 'dataField': 'IsSunday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
         { 'id': 'IsMonday', 'title': 'M', 'dataField': 'IsMonday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
         { 'id': 'IsTuesday', 'title': 'T', 'dataField': 'IsTuesday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
         { 'id': 'IsWednesday', 'title': 'W', 'dataField': 'IsWednesday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
         { 'id': 'IsThursday', 'title': 'R', 'dataField': 'IsThursday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
         { 'id': 'IsFriday', 'title': 'F', 'dataField': 'IsFriday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
         { 'id': 'IsSaturday', 'title': 'S', 'dataField': 'IsSaturday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false });

      mEnrolleesControls.SchedulesListView.setColumns(lColumns);
      mEnrolleesControls.SchedulesListView.setDataSource(lEnrolleeSchedules);
      mEnrolleesControls.SchedulesListView.sort();
      mEnrolleesControls.SchedulesListViewPaginator.ResetDates();
      mEnrolleesControls.SchedulesListViewPaginator.setPage(1);

      $('#uUnSelectAllScheduleButton').hide();

      if (lEnrolleeSchedules.length > 0) {
          $('#uSelectAllScheduleButton').show();
      } else {
          $('#uSelectAllScheduleButton').hide();
      }
    }
}

function uSelectAllScheduleButton_OnClick(selected) {
    "use strict;"
    if (selected) {
        $('#uUnSelectAllScheduleButton').show();
        $('#uSelectAllScheduleButton').hide();
        mEnrolleesControls.SchedulesListView.selectAllList();
    } else {
        $('#uSelectAllScheduleButton').show();
        $('#uUnSelectAllScheduleButton').hide();
        $('#uDeleteScheduleButton').hide();
        mEnrolleesControls.SchedulesListView.unselectAllList();
    }
}

function uEnrolleesTimeZone_OnClick() {
    if ($('#uEnrolleesTimeZone').prop("checked")) {
        mEnrolleesData.EnrolleesTimeZone = getEnrolleeTimeZone(mEnrolleesControls.CardView.selected());
        mEnrolleesData.EnrolleesTimeZone = mEnrolleesData.EnrolleesTimeZone.TimeZoneName;
    }
    else {
        mEnrolleesData.EnrolleesTimeZone = '';
    }
}

function enrolleesScheduleAddressesOnSuccess(aParams, aData) {
    "use strict";
    mEnrolleesData.SchedulesTargetsClean = $.extend({}, mEnrolleesData.SchedulesZonesClean);
    mEnrolleesData.CarveOutTargetsClean = [];// = $.extend({}, mEnrolleesData.SchedulesZonesClean);

    enrolleesScheduleAddressesDataListConverter(aParams.EnrolleeId, aData);
    EnrolleeProfileSchedules_OnLoad(aParams);

    if (mEnrolleesControls.carveOutSchedule)
        populateAbsenceScheduleTargetList();
}

function EnrolleeProfileSchedules_Init(aEnrolleeId) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lTargetEnrolleeId = getViewState('ZoneScheduleEnrolleeId'),
        lTargetZoneId = getViewState('ZoneScheduleId');
    if (!isNullOrUndefined(lTargetEnrolleeId) && lTargetEnrolleeId.Value === aEnrolleeId) {
        setViewState('ZoneScheduleId', null);
        setViewState('ZoneScheduleEnrolleeId', null);
    }

    uEnrolleesSchedulesPaginator_Init();
    lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.EnrolleeAddress.AssemblyQualifiedName, lBuilder.RootExpression, 0, enrolleesScheduleAddressesOnSuccess, Sad, { 'EnrolleeId': aEnrolleeId, 'TargetZoneId': lTargetZoneId, 'TargetEnrolleeId': lTargetEnrolleeId }, null, 20);
}

function enrolleeSchedulePopup_Dispose() {
    "use strict";
    if (!isNullOrUndefined(gEnrolleeScheduleView)) {
        gEnrolleeScheduleView.dispose();
        gEnrolleeScheduleView = null;
    }
    ClosePopup();
}

function enrolleesVeritracksCalendarLegend() {
    "use strict";
    var lHtml = [];
    lHtml.push('<div id="uVeritracksCalendarLegend style="width:200px;">');
    if($(mEnrolleesControls.veritracksCalendar.calendarId() + ' tbody').hasClass("ColorInvert")){
        lHtml.push(LegendIconDisplay('VeritracksAbsenceSchedule', localizeText('cEnrolleeScheduleRecurringAbsence')));
        lHtml.push(LegendIconDisplay('VeritracksAbsenceScheduleOverride', localizeText('cEnrolleeScheduleSingleDayAbsence')));
    }else{
      lHtml.push(LegendIconDisplay('VeritracksInclusionZoneSchedule', localizeText('cZoneInclusionZone')));
      lHtml.push(LegendIconDisplay('VeritracksInclusionZoneScheduleOverride', localizeText('cZoneInclusionZoneOverride')));
      lHtml.push(LegendIconDisplay('VeritracksDayChecInSchedule', localizeText('cEnrolleeScheduleCheckIn')));
      lHtml.push(LegendIconDisplay('VeritracksDayRegularSchedule', 'BLUBox/BLUHome'));
      lHtml.push(LegendIconDisplay('VeritracksDayRegularScheduleOverride', 'BLUBox/BLUHome ' + localizeText('cEnrolleeOverride')));
    }
    lHtml.push('</div>');
    DisplayModal(localizeText('cEnrolleeLegend'), lHtml.join(''), null, null);
}

function LegendIconDisplay(aType, aText, aBackgroundColor) {
    "use strict";
    var lHtml = [];

    if (aBackgroundColor) {
        if (aBackgroundColor == "#FFFFFF" ) {
            lHtml.push('<span style=" margin:2px; padding:2px; border-style:solid; border-color:black; color:black; display:block;border background-color:' + aBackgroundColor + ';">' + aText + '</span>');
        }
        else {
            lHtml.push('<span style=" margin:2px; padding:2px; color:white; display:block; background-color:' + aBackgroundColor + ';">' + aText + '</span>');
        }
    } else {
        lHtml.push('<span class="' + aType + '" style=" margin:2px; padding:2px; color:white; display:block;">' + aText + '</span>');
    }

    return lHtml.join('');
}


function getRegularSchedules(aEnrolleeId) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
    lEnrolleeScheduleDisplays = [],
    lOldSchedules,
    lEnrolleeSchedules = [],
    lTimeZone = getEnrolleeTimeZone(aEnrolleeId),
    lKey;

    lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('ScheduleType', 7, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsAbsenceSched', getCarveOutPreference(), false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lOldSchedules = query(mEnrolleesData.OffenderSchedules, lBuilder.RootExpression);
    for (lKey in lOldSchedules) {
        if (lOldSchedules.hasOwnProperty(lKey)) {
            var lSchedule = new OffenderScheduleDisplay(lOldSchedules[lKey], true);

            if (!lSchedule.IsRecurring) {
                lSchedule.StartTime = convertMomentFromStringTimezone(lSchedule.StartDateUTC + " " + moment(lSchedule.StartTimeUTC).format("hh:mm A"), lTimeZone.TimeZoneName);
                lSchedule.EndTime = convertMomentFromStringTimezone(lSchedule.EndDateUTC + " " + moment(lSchedule.EndTimeUTC).format("hh:mm A"), lTimeZone.TimeZoneName);
            } else {
                lSchedule.StartTime = convertMomentFromStringTimezone(lSchedule.StartTimeUTC, lTimeZone.TimeZoneName);
                lSchedule.EndTime = convertMomentFromStringTimezone(lSchedule.EndTimeUTC, lTimeZone.TimeZoneName);
            }
            lEnrolleeScheduleDisplays.push(lSchedule);
        }
    }

    lEnrolleeSchedules = enrolleesScheduleDataListConverter(lEnrolleeScheduleDisplays);
    // sort 24 hour schedules first, then whatever
    lEnrolleeSchedules = enrolleesSortSchedulePopup(lEnrolleeSchedules);
    // remove exclusion zone schedules
    lEnrolleeSchedules = removeExclusionZoneSchedules(lEnrolleeSchedules);

    return lEnrolleeSchedules;
}

function enrolleeSchedulePopup_Init(aEnrolleeId) {
    "use strict";
    var lButtonBar = GenerateButtonCommandBar();
    var lScheduleType = getRegularSchedules;
    var lCarvedSchedule = checkCarveOutModeEnabled(aEnrolleeId);
    var lCarveDisabled = true;

    if (lCarvedSchedule) {
        lCarveDisabled = false;
    }
    if (!PopupIsOpen()) {
        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'enrolleesVeritracksCalendarSaveCarved()', true));
        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeReocurring'), 'ToggleOff', 'enrolleesVeritracksCurrentCarveRecurring()', true));
        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeViewAbsenceSchedules'), 'Carve', 'enrolleesVeritracksCalendarEnterCarveMode()', lCarveDisabled));
        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeLegend'), 'Legend', 'enrolleesVeritracksCalendarLegend()'));
        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', 'enrolleesVeritracksCalendarPopup_Dispose()'));
        DisplayPopup(localizeWrapper('cEnrolleeCalendarSchedule'), '<div id="uVeritracksCalendarHolder" style="width:100%; display:block;"></div>', lButtonBar, true);
        $('.PopupWindow').addClass('CalendarWidth');
    } else {
        if (lCarveDisabled)
            $('.Clickable.Button.CarveButton').hide();
        else
            $('.Clickable.Button.CarveButton').show();
    }

    if (isNullOrUndefined(mEnrolleesControls.veritracksCalendar)) {
        mEnrolleesControls.veritracksCalendar = new VeritracksFullCalendarWrapper('#uVeritracksCalendarHolder',
            {
                "defaultView": "agendaWeek",
                "slotEventOverlap": true,
                "selectOverlap": true,
                "multiDaySelect": true,
                "displayEventEnd": true,
                "editable": true,
                "aspectRatio": 1.8,
                "selectable": true,
                "selectHelper": true,
                "selectMultiDay": false,
                "allDaySlot": true,
                "rightClickOptions": 'month,agendaWeek,agendaDay',
                "lazyFetching": true
            },
            {}
            );
    }
    mEnrolleesControls.veritracksCalendar.addExtraData("enrolleeId", aEnrolleeId);
    if (lCarvedSchedule)
        mEnrolleesControls.veritracksCalendar.addExtraData("masterSchedule", lCarvedSchedule);

    mEnrolleesControls.veritracksCalendar.addExtraData("absencesExist", absencesExist(aEnrolleeId));
    if ($(mEnrolleesControls.veritracksCalendar.calendarId() + ' tbody').hasClass("ColorInvert")) {
        lScheduleType = getAbsentSchedules;
        mEnrolleesControls.veritracksCalendar.setHandlers({
            "renderHandler": handleAbsenceRender,
            "clickHandler": calendarCloseAbsence,
            "viewRender": generateSchedulesTimespan,
            "specialEventLayout": checkRecurringAbsence,
            "editMode": updateEditFlags,
            "selected": checkAbsenceSaveButtonDisplayed,
            "resizeOver": resizeOverUpdateAbsences
        });
    } else {
        mEnrolleesControls.veritracksCalendar.setHandlers({
            "clickHandler": handleClickSchedule,
            "viewRender": generateSchedulesTimespan,
            "editMode": selectEditModePopup,
            "selected": createSchedule
        });
    }


    mEnrolleesControls.veritracksCalendar.setView('agendaDay');
    mEnrolleesControls.veritracksCalendar.setView('agendaWeek');

    mEnrolleesControls.veritracksCalendar.setDataSource(lScheduleType(aEnrolleeId));
    if ($(mEnrolleesControls.veritracksCalendar.calendarId() + ' tbody').hasClass("ColorInvert"))
      checkAbsenceSaveButtonDisplayed();
}

function enrolleesVeritracksCalendarEnterCarveMode() {
    "use strict";
    var lViewName = mEnrolleesControls.veritracksCalendar.getViewName();
    var lEnrolleeId = mEnrolleesControls.veritracksCalendar.getExtraData("enrolleeId");

    mEnrolleesControls.veritracksCalendar.setView("month");
    if (!$(mEnrolleesControls.veritracksCalendar.calendarId() + ' tbody').hasClass("ColorInvert")) {
        mActivityNotification.addNotification(localizeWrapper('cEnrolleeScheduleCarveOutModeEnter') + mEnrolleesControls.veritracksCalendar.getExtraData('masterSchedule').Name);
        mEnrolleesControls.veritracksCalendar.updateFullCalendarOptions("allDaySlot", false);
        mEnrolleesControls.veritracksCalendar.setView(lViewName);
        mEnrolleesControls.veritracksCalendar.invertDayColors(true);
        mEnrolleesControls.veritracksCalendar.disableView('month');
        mEnrolleesControls.veritracksCalendar.deleteHandlers();
        mEnrolleesControls.veritracksCalendar.setHandlers({
            "renderHandler": handleAbsenceRender,
            "specialEventLayout": checkRecurringAbsence,
            "clickHandler": calendarCloseAbsence,
            "viewRender": generateSchedulesTimespan,
            "editMode": updateEditFlags,
            "selected": checkAbsenceSaveButtonDisplayed,
            "resizeOver": resizeOverUpdateAbsences
        });
        mEnrolleesControls.veritracksCalendar.setDataSource(getAbsentSchedules(lEnrolleeId));
        $('.Clickable.Button.ToggleOffButton').show();
        $('.ToggleOffButton').addClass('ToggleOnButton');
        $('.ToggleOffButton').text('Recurring');
        $('.Clickable.Button.CarveButton').html("View Regular Schedules");
    } else {
        mEnrolleesControls.veritracksCalendar.updateFullCalendarOptions("allDaySlot", true);
        mEnrolleesControls.veritracksCalendar.setView(lViewName);
        mEnrolleesControls.veritracksCalendar.invertDayColors(false);
        mEnrolleesControls.veritracksCalendar.enableView('month');
        mEnrolleesControls.veritracksCalendar.deleteHandlers();
        mEnrolleesControls.veritracksCalendar.setHandlers({
            "clickHandler": handleClickSchedule,
            "viewRender": generateSchedulesTimespan,
            "editMode": selectEditModePopup,
            "selected": createSchedule
        });
        mEnrolleesControls.veritracksCalendar.setDataSource(getRegularSchedules(lEnrolleeId));
        //$('.Clickable.Button.SaveButton').show();
        $('.Clickable.Button.ToggleOffButton').hide();
        $('.Clickable.Button.CarveButton').html("View Absence Schedules");
    }
}

function removeExclusionZoneSchedules(aEnrolleeSchedules) {
    "use strict";
    var lEnrolleeSchedules = [],
        lZone,
        lKey;

    for (lKey in aEnrolleeSchedules) {
        if (aEnrolleeSchedules.hasOwnProperty(lKey)) {
            if (aEnrolleeSchedules[lKey].ZoneScheduleType > 0) { // bug 2382
                lZone = getDataItem(aEnrolleeSchedules[lKey].EntityId, 'Zones');
                if (!isNullOrUndefined(lZone)) {
                    if (lZone.Type !== 2) {
                        lEnrolleeSchedules.push(aEnrolleeSchedules[lKey]);
                    }
                }
            } else {
                lEnrolleeSchedules.push(aEnrolleeSchedules[lKey]);
            }
        }
    }

    return lEnrolleeSchedules;
}

function enrolleesVeritracksCalendarPopup_Dispose() {
    "use strict";
    $('.PopupWindow').removeClass('CalendarWidth');
    $('#uPopupPanel').removeClass('LowZIndex');
    mEnrolleesControls.veritracksCalendar = null;
    if (ModalIsOpen()) {
        CloseModal();
    }
    ClosePopup();
    window.isTimelineDisplayedFromProfile = false;
}

function offender_toggleuLastContactButton() {
    "use strict";
    var lDateRange = offenderMapPopulate_GetDateRange(),
        lEnrollee = mEnrolleesControls.CardView.selectedDataItem(),
        lEnrolleeData = lEnrollee.Enrollee;

    if (mStateManager.Settings()[1] === 'Map' && (displayEventInEnrolleeTimeZone(lEnrollee.LastContactDate, lEnrolleeData) <= lDateRange.startDate || displayEventInEnrolleeTimeZone(lEnrollee.LastContactDate, lEnrolleeData) >= lDateRange.endDate)) {
        // $('#uLastContactButton').show(); removed, preferred Now button.
        $('#uMapNowButton').show();// Removed for Now button being obsolete same as same commented line below update (EE) added for iteration 2 purposes
    } else {
        //$('#uLastContactButton').hide();
        $('#uMapNowButton').hide();
    }
}

function generateOffenderPhotoPopup() {
    "use strict";

    var html = [],
        lPhotoTypes = getDataItems("OffenderPhotoType"),
        lPhotoTypeText = '',
        aOffender = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex];

    if (mEnrolleesData.OffenderPhotos.length == 0) {
        return;
    }
        for (var lKey in lPhotoTypes) {
            if (lPhotoTypes.hasOwnProperty(lKey) && lPhotoTypes[lKey].Id == aOffender.PhotoTypeId) {
            lPhotoTypeText = lPhotoTypes[lKey].PhotoTypeText;
            break;
        }
    }

     html.push("<div id='uOffenderPhotoPopupContainer'>");
     if (aOffender.PhotoTypeId == 4) {
         html.push("<img id='popup" + aOffender.Id + "' src='" + MUGSHOTS + aOffender.PhotoUri + "' style='height:395px;width:auto;margin:0px auto;'/>");
     } else if (aOffender.PhotoTypeId == 5) {
         if (aOffender.PhotoUri === "") {
             html.push("<img id='popup" + aOffender.Id + "' src='Images/NoPhoto.png' style='height:395px;width:auto;margin:0px auto;'/>");
         } else {
             html.push("<img id='popup" + aOffender.Id + "' src='" + MUGSHOTS + aOffender.PhotoUri + "' style='height:395px;width:auto;margin:0px auto;'/>");
         }
     } else {
         html.push("<img id='popup" + aOffender.Id + "' src='" + MUGSHOTS + aOffender.PhotoUri + "' style='height:395px;width:auto;margin:0px auto;'/>");
     }
    html.push("</div>");
    DisplayPopup(aOffender.PhotoDescription + " | " + lPhotoTypeText, html.join(""), null, false, true);
    resizeOffenderPhoto("popup" + aOffender.Id);

}

function uDeleteMainOffenderPhoto() {
    "use strict";
    var lNextPhoto,
        indexId = 0,
        currentDeletedPhoto,
        nextPhotoOrderNo = new OffenderPhoto();

    if (mEnrolleesData.OffenderPhotos.length <= 1) {
        $('#uOffenderProfilePhotoUri').attr('src', 'Images/NoPhoto.png');
        $('#uOffenderProfilePhotoUri').attr('width', 97);
    } else {
        indexId = mEnrolleesData.OffenderPhotoIndex;
        nextPhotoOrderNo = new OffenderPhoto();
        nextPhotoOrderNo.Id = mEnrolleesData.OffenderPhotos[parseInt(indexId)].Id;
        nextPhotoOrderNo.EnrolleeId = mEnrolleesData.OffenderPhotos[parseInt(indexId)].EnrolleeId;
        nextPhotoOrderNo.IsActive = mEnrolleesData.OffenderPhotos[parseInt(indexId)].IsActive;
        nextPhotoOrderNo.PhotoOrderNo = mEnrolleesData.OffenderPhotos[parseInt(indexId)].PhotoOrderNo;
        nextPhotoOrderNo.PhotoUri = null;
        nextPhotoOrderNo.PhotoDescription = null;
        mEnrolleesData.OffenderPhotosEdited.push(nextPhotoOrderNo);

        if (indexId == mEnrolleesData.OffenderPhotos.length - 1) {
            uGoToNextOffenderPhoto(-1);
        } else {
            uGoToNextOffenderPhoto(1);
        }

    }

    currentDeletedPhoto = mEnrolleesData.OffenderPhotos[indexId];
    currentDeletedPhoto.IsActive = 0;
    mEnrolleesData.OffenderPhotosDeleted.push(currentDeletedPhoto);

    if (mEnrolleesData.OffenderPhotos.length > 0) {
        mEnrolleesData.OffenderPhotos.splice(indexId, 1);
        if (mEnrolleesData.OffenderPhotos.length == 1 || mEnrolleesData.OffenderPhotos.length == 0) {
            $("#uPreviousOffenderPhotoButton").hide();
            $("#uPreviousOffenderPhotoButtonContainer").show();
            $("#uNextOffenderPhotoButton").hide();
            $("#uNextOffenderPhotoButtonContainer").show();
        }

        if (mEnrolleesData.OffenderPhotos.length == 0) {
            $("#uOffenderPhotoDeleteButton").hide();
        }
    }

    if (mEnrolleesData.OffenderPhotoIndex >= mEnrolleesData.OffenderPhotos.length && mEnrolleesData.OffenderPhotoIndex != 0) {
        mEnrolleesData.OffenderPhotoIndex--;
    } else if (indexId == 0) {
        mEnrolleesData.OffenderPhotoIndex = indexId;
    }

    if (mEnrolleesData.OffenderPhotoIndex == mEnrolleesData.OffenderPhotos.length - 1) {
        $("#uNextOffenderPhotoButton").hide();
        $("#uNextOffenderPhotoButtonContainer").show();
    }

    updatePhotoNumbers();
}


function uGoToNextOffenderPhoto(aDirection) {
    "use strict";
    var lNextOffender,
        lCurrentOffender,
        lFoundOffender = false;


    if (mEnrolleesData.OffenderPhotoDescription != mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoDescription && mEnrolleesData.OffenderPhotoDescription != '') {

        lCurrentOffender = new OffenderPhoto();
        lCurrentOffender.Id = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].Id;
        lCurrentOffender.EnrolleeId = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].EnrolleeId;
        lCurrentOffender.PhotoUri = null;
        lCurrentOffender.PhotoOrderNo = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoOrderNo;
        lCurrentOffender.IsActive = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].IsActive;
        lCurrentOffender.PhotoDescription = mEnrolleesData.OffenderPhotoDescription;

        if (mEnrolleesData.OffenderPhotosEdited.length == 0) {
            mEnrolleesData.OffenderPhotosEdited.push(lCurrentOffender);
        } else {
            for (var i = 0; i < mEnrolleesData.OffenderPhotosEdited.length; i++) {
                if (mEnrolleesData.OffenderPhotosEdited[i].Id == lCurrentOffender.Id && mEnrolleesData.OffenderPhotosEdited[i].PhotoUri == null) {
                    mEnrolleesData.OffenderPhotosEdited[i] = lCurrentOffender;
                    lFoundOffender = true;
                    break;
                }//end of if
            }//end of for

            if (!lFoundOffender) {
                mEnrolleesData.OffenderPhotosEdited.push(lCurrentOffender);
            }
        }//end of else

        mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoDescription = mEnrolleesData.OffenderPhotoDescription;
    }//end of outer if

    if (aDirection == 1 && mEnrolleesData.OffenderPhotoIndex == mEnrolleesData.OffenderPhotos.length - 2) {
        mEnrolleesData.OffenderPhotoIndex++;
        lNextOffender = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex];
        if (lNextOffender.PhotoTypeId == 5) {
            if (lNextOffender.PhotoUri === "") {
                $("#uOffenderProfilePhotoUri").attr("src", "Images/NoPhoto.png");
            } else {
                $("#uOffenderProfilePhotoUri").attr("src",  MUGSHOTS + lNextOffender.PhotoUri);
            }
        } else {
            $("#uOffenderProfilePhotoUri").attr("src",  MUGSHOTS + lNextOffender.PhotoUri);
        }
        $("#uOffenderProfilePhotoUri").attr("title", lNextOffender.PhotoDescription);
        $("#uNextOffenderPhotoButton").hide();
        $("#uNextOffenderPhotoButtonContainer").show();
        $("#uPreviousOffenderPhotoButton").show();
        $("#uPreviousOffenderPhotoButtonContainer").hide();
    } else if (aDirection == -1 && mEnrolleesData.OffenderPhotoIndex == 1) {
        mEnrolleesData.OffenderPhotoIndex--;
        lNextOffender = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex];
        if (lNextOffender.PhotoTypeId == 5) {
            if (lNextOffender.PhotoUri === "") {
                $("#uOffenderProfilePhotoUri").attr("src", "Images/NoPhoto.png");
            } else {
                $("#uOffenderProfilePhotoUri").attr("src",  MUGSHOTS + lNextOffender.PhotoUri);
            }
        } else {
            $("#uOffenderProfilePhotoUri").attr("src",  MUGSHOTS + lNextOffender.PhotoUri);
        }
        $("#uOffenderProfilePhotoUri").attr("title", lNextOffender.PhotoDescription);
        $("#uPreviousOffenderPhotoButton").hide();
        $("#uPreviousOffenderPhotoButtonContainer").show();
        $("#uNextOffenderPhotoButton").show();
        $("#uNextOffenderPhotoButtonContainer").hide();
    } else {
        mEnrolleesData.OffenderPhotoIndex = mEnrolleesData.OffenderPhotoIndex + aDirection;
        lNextOffender = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex];
        if (lNextOffender.PhotoTypeId == 5) {
            if (lNextOffender.PhotoUri === "") {
                $("#uOffenderProfilePhotoUri").attr("src", "Images/NoPhoto.png");
            } else {
                $("#uOffenderProfilePhotoUri").attr("src",  MUGSHOTS + lNextOffender.PhotoUri);
            }
        } else {
            $("#uOffenderProfilePhotoUri").attr("src",  MUGSHOTS + lNextOffender.PhotoUri);
        }
        $("#uOffenderProfilePhotoUri").attr("title", lNextOffender.PhotoDescription);
        $("#uPreviousOffenderPhotoButton").show();
        $("#uPreviousOffenderPhotoButtonContainer").hide();
        $("#uNextOffenderPhotoButton").show();
        $("#uNextOffenderPhotoButtonContainer").hide();
    }

    if (mEnrolleesData.OffenderPhotosEditMode == "Edit") {
        uCancelOffenderPhotoButton_OnClick();
    }

    mEnrolleesData.OffenderPhotoDescription = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoDescription;
    $("#uPhotoType").val(mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoTypeId);

    if (isNullOrUndefined(mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoUri) || mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoUri == "") {
        $("#uOffenderProfilePhotoUri").attr("src", "Images/NoPhoto.png");
    }

    //if (mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoTypeId == 4) {
   //     $("#uOffenderProfilePhotoUri").addClass("AlcoholUploadedImage");
   // } else {
     //   $("#uOffenderProfilePhotoUri").removeClass("AlcoholUploadedImage");
   // }

    updatePhotoNumbers();

}


function resizeOffenderPhoto(aPicId) {
    "use strict";
    var img = new Image(),
        minWidth = 0,
        minHeight = 0,
        minAllowedWidth = 1000;

    img.onload = function () {
        if (PopupIsOpen()) {
            if (img.width < minAllowedWidth) {
                minWidth = img.width * .70;
                minHeight = img.height * .70;
                $("#uOffenderPhotoPopupContainer").width(minWidth);
                $("#uOffenderPhotoPopupContainer").height(minHeight);
                $("#" + aPicId).css('width', minWidth);
                $("#" + aPicId).css('height', minHeight);
            } else {
                $("#uOffenderPhotoPopupContainer").width($("#" + aPicId).width());
}

            $("#uOffenderPhotoPopupContainer").zoom({
                url: $("#" + aPicId).attr("src")
            });

        }
    }//end of img load

    img.src = $("#" + aPicId).attr("src");
}

function repositionPhotoNumbers(aImage) {
    "use strict";
    var lMainPhotoWidth,
        lLeftPercent =.30,
        lMargin,
        lImage = new Image();

    lImage.onload = function () {
        lMainPhotoWidth = $("#uOffenderProfilePhotoUri").width();
        lMargin = lMainPhotoWidth * lLeftPercent;


        if (!isNaN(lMargin)) {
            if (mEnrolleesData.OffenderPhotos.length == 1) {
                //lMargin = lMargin;
                //$("#uPhotoNumberContainer").css("margin-left", lMargin + "px");
            } else {
                $("#uPhotoNumberContainer").css("margin-left", lMargin + "px");
            }

        }

    };


    $("#uPhotoNumberContainer").css("margin-left", "25px");

    lImage.src = aImage;

}

function offenderPhoto_OnSuccess(aParams, aData) {
    "use strict";
    var lSort = new SortExpression();

        lSort.addAscendingColumn("PhotoOrderNo");

    if (!aData.hasOwnProperty("Data") && aData.length != 0) {
        mEnrolleesData.OffenderPhotos = lSort.sort(aData);
        mEnrolleesData.OffenderPhotoIndex = 0;
        if (mEnrolleesData.OffenderPhotos[0].PhotoTypeId == 5) {
            if (mEnrolleesData.OffenderPhotos[0].PhotoUri === "") {
                $('#uOffenderProfilePhotoUri').attr('src', 'Images/NoPhoto.png');
            } else {
                $("#uOffenderProfilePhotoUri").attr("src",  MUGSHOTS + mEnrolleesData.OffenderPhotos[0].PhotoUri);
            }
        } else {
            $("#uOffenderProfilePhotoUri").attr("src",  MUGSHOTS + mEnrolleesData.OffenderPhotos[0].PhotoUri);
        }
        $("#uOffenderProfilePhotoUri").attr("title", mEnrolleesData.OffenderPhotos[0].PhotoDescription);
        $("#uOffenderProfilePhotoUri").css("width", "auto");
        $("#uPreviousOffenderPhotoButton").hide();
        if (aData.length == 1) {
            $("#uPreviousOffenderPhotoButtonContainer").hide();
            $("#uNextOffenderPhotoButton").hide();
            $("#uNextOffenderPhotoButtonContainer").hide();
        } else {
            $("#uPreviousOffenderPhotoButtonContainer").show();
        }

        $("#uPhotoType").val(mEnrolleesData.OffenderPhotos[0].PhotoTypeId);
        $("#uPhotoNumberContainer").show();
        updatePhotoNumbers();
    } else {
        mEnrolleesData.OffenderPhotos = [];
        $('#uOffenderProfilePhotoUri').attr('src', 'Images/NoPhoto.png');
        $("#uOffenderProfilePhotoUri").css("width", "97px");
        $("#uOffenderProfilePhotoUri").attr("title", "Enrollee Photo");
        $("#uPreviousOffenderPhotoButton").hide();
        $("#uPreviousOffenderPhotoButtonContainer").hide();
        $("#uNextOffenderPhotoButton").hide();
        $("#uNextOffenderPhotoButtonContainer").hide();
        $("#uPhotoTypeContainer").hide();
        $("#uPhotoNumberContainer").hide();
    }

    if (aData.length > 1) {
        $("#uNextOffenderPhotoButton").show();
        $("#uNextOffenderPhotoButtonContainer").hide();
    }
}

function loadEnrollePhotos(aCurrentOffenderId, aCallback) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    lBuilder.AddNewExpressionConditional('EnrolleeId', aCurrentOffenderId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.OffenderPhotos.AssemblyQualifiedName, lBuilder.RootExpression, 0, aCallback, null, null, null, 0);
}



function soberTrackSchedulesShow() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    var lEnrolleeCard = mEnrolleesControls.CardView.selectedDataItem();
    var lEnrolleeSoberTrack,
        lNoCurrentAssignment = false;

    if (lEnrolleeCard) {
        lEnrolleeSoberTrack = lEnrolleeCard.HasSoberTrackDevice;
        
        if (!isNullOrUndefined(lEnrolleeSoberTrack)) {
            if (lEnrolleeSoberTrack) {
                mEnrolleesData.SoberTrackAssigned = true;
                mEnrolleesData.SoberTrackAssignedPreviously = false;
                $('#uEnrolleesSecondaryMenuSoberTrackSchedules').show();
                $('#uSoberTrackScheduleButton').show();
                $('.pEnrolleesOffenderSoberTrackReview').show();

            } else {
                mEnrolleesData.SoberTrackAssigned = false;
                mEnrolleesData.SoberTrackAssignedPreviously = false;
                $('#uEnrolleesSecondaryMenuSoberTrackSchedules').hide();
                $('.pEnrolleesOffenderSoberTrackReview').hide();
            }

            // check if previously assigned
            if (!lEnrolleeSoberTrack) {
                lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrolleeCard.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional('AlcoholDeviceId', 1, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
                ReadMultiple(gObjectList.DeviceAssignment.AssemblyQualifiedName, lBuilder.RootExpression, 0, function EnrolleeSoberTrackProfileAssignments_OnLoad(aParams, aData) {
                    "use strict";
                    if (aData.length && aParams == mEnrolleesData.OffenderCurrentId) {
                        mEnrolleesData.SoberTrackAssigned = false;
                        mEnrolleesData.SoberTrackAssignedPreviously = true;
                        $('#uEnrolleesSecondaryMenuSoberTrackSchedules').show();
                        $('#uSoberTrackScheduleButton').show();
                        $('.pEnrolleesOffenderSoberTrackReview').show();
                    } else if(aParams == mEnrolleesData.OffenderCurrentId) {
                        mEnrolleesData.SoberTrackAssigned = false;
                        mEnrolleesData.SoberTrackAssignedPreviously = false;
                        $('#uEnrolleesSecondaryMenuSoberTrackSchedules').hide();
                        $('#uSoberTrackScheduleButton').hide();
                        $('.pEnrolleesOffenderSoberTrackReview').hide();
                    }
                }, Sad, lEnrolleeCard.Id, null, 0);
            }
        }

    }

}


// LIST EVENTS
function uEnrolleesCardView_OnSelectChange(aSender, aEnrolleeId, aData) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    var RegionalLoadedIdViewState = getViewState("RegionalLoadedId");
    var lEnrollee = getDataItem(aEnrolleeId, 'Enrollees');
    if(!isNullOrUndefined(lEnrollee)){        
        var lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
        var lTimelineDisabled = veritracks.system.clientSetting('TimelineDisabled');        
        if (lIsInformatics || (!isNullOrUndefined(lTimelineDisabled) && !lTimelineDisabled)) {
            $('#TimelineChartButton').show();
        }  else if (!lIsInformatics && !isNullOrUndefined(lTimelineDisabled) && lTimelineDisabled) {
            $('#TimelineChartButton').hide();
        }
    }
    
    

    veritracks.security.controller.extendSession();


    if (mEnrolleesData.AgentTimeManagement[mEnrolleesData.OffenderCurrentId] && aEnrolleeId != mEnrolleesData.OffenderCurrentId) {
        mEnrolleesData.AgentTimeManagement[mEnrolleesData.OffenderCurrentId].finish()
    }


    if (!isNullOrUndefined(mEnrolleesControls.CardView)) {
        veritracks.enrollees.mapping.data.VisitCardList = [];
        veritracks.enrollees.mapping.data.VisitsProcesssed = false;
        veritracks.enrollees.mapping.data.LookAheadCardList = [];
        mEnrolleesData.OffenderProfileAddresses = [];
        mEnrolleesData.OffenderDeviceClusters = [];
        mEnrolleesData.EnrolleeBPLTBS = null;
        $('#uEnrolleesNoDataText').empty();
        $('#uEnrolleeTrackPointCount').hide();
        mEnrolleesData.EnrolleesMapTransactionStartDate = null;
        mEnrolleesData.EnrolleesMapTransactionStopDate = null;
        mEnrolleesData.UserTransactionRecordLogger = null;
        mEnrolleesControls.CardViewTimer.SetTimer(function (aParams) {


            var lIsEmpty = true;

            if (mStateManager.Tab() === 'Enrollees') {
                if (mStateManager.Settings()[0] === 'Offenders') {
                    lIsEmpty = (mEnrolleesData.OffenderDirty.length === 0);
                } else {
                    lIsEmpty = (mEnrolleesData.VictimDirty.length === 0);
                }
            }

            veritracks.system.applyFilterState('Enrollees', lIsEmpty);
            if (mEnrolleesData.MapPageMultiplier === 0) {
                mEnrolleesData.MapEndDate = new Date();
            }
            if (!isNullOrUndefined(aParams.EnrolleeId) && !isNullOrUndefined(mEnrolleesControls.CardView)) {
                var lEnrollee = mEnrolleesControls.CardView.selectedDataItem(),
                    lEnrolleeId;
                //offender_toggleuLastContactButton();
                if (aParams.EnrolleeId !== -1 && !isNullOrUndefined(lEnrollee)) {
                    lEnrolleeId = lEnrollee.Id;
                    if (mStateManager.Settings()[0] === 'Offenders') {
                        enrolleesOffenderEditCancel();
                        //mCurrentDeviceId = lEnrollee.DeviceId;
                        if (mStateManager.Settings()[1] === 'Profile') {
                            var lAgentsStopCheck = getDataItem(gUserDetails.UserId, 'Users');
                            if (lAgentsStopCheck) {
                                var lTransactionDate = new Date(moment());
                                logUserTransaction(mEnrolleesData.OffenderCurrentId, 5, gUserDetails.UserId, lTransactionDate, lTransactionDate, lTransactionDate);
                            }
                            checkEnabledFrp();
                            if (mEnrolleesData.secondLockOnEnrolleeId !== aEnrolleeId) {
                                if (gUserDetails.RegionalOri) {
                                    if (RegionalLoadedIdViewState && lEnrollee.OrganizationId == RegionalLoadedIdViewState.Value) {
                                        addUnloadButton();
                                        //show
                                    } else if (RegionalLoadedIdViewState && lEnrollee.OrganizationId != RegionalLoadedIdViewState.Value) {
                                        addLoadOriButton();
                                        //not show
                                    } else {
                                        if (!lEnrollee.InMyOrganization) {
                                            removeLoadButtons();
                                            //not show
                                        } else if (!getViewState("isRegionalLoaded")) {
                                            addLoadOriButton();
                                        }
                                    }
                                } else {
                                    //show
                                }

                                mEnrolleesData.secondLockDate = null;
                                mEnrolleesData.secondLockOnEnrolleeId = null;
                            }
                            updateTimelineIfPresent();
                            if(lEnrolleeId == mEnrolleesData.OffenderCurrentId){
                                //reload if is the same Id
                                offenderProfilePopulate();
                            }
                            //EMA data
                        } else if (mStateManager.Settings()[1] === 'SoberTrackReview'){
                            //On Select ENrollee
                            mEnrolleesSoberTrackReviewLisView_OnClickCardView();
                          
                        }else {

                            // check if calendar is currently being used -- big one
                            if ($("#uVeritrackscLargeChart").is(":visible")) {
                                ReloadEnrolleeSchedules(lEnrolleeId, function () {
                                    offenderMapPopulate(true);
                                });
                            } else {
                                ReloadEnrolleeSchedules(lEnrolleeId, function () {
                                    enrolleesOffenderMap_Init();
                                });
                            }


                            //offenderMapPopulate();
                            checkOffenderHasSoberTrack();
                            setTimeout(function () {
                                if (!isNullOrUndefined(getViewState('CurrentCorrelationStartDate')) && !isNullOrUndefined(getViewState('CurrentCorrelationStartDate'))) {
                                    $('#uMapDatePicker').val(displayShortDate(new Date(getViewState('CurrentCorrelationStartDate').Value)));
                                    $('#uMapTimePicker').val(getViewState('CurrentCorrelationTime').Value);
                                    $("#uEnrolleeMapTimeFilter").val(getViewState('CorrelationTimeFilter').Value);
                                    deleteViewState('CurrentCorrelationStartDate');
                                    deleteViewState('CurrentCorrelationTime');
                                    deleteViewState('CorrelationTimeFilter');
                                    enrolleesOffendersMapDateTime_OnChange();
                                }

                            }, 1200);
                        }
                        if ((lEnrolleeId !== mEnrolleesData.OffenderCurrentId || lEnrolleeId === mEnrolleesData.OffenderCurrentIdFromDashboard) || mStateManager.refreshEMAGetStatus ) {
                            //if a new enrollee was selected the lEnrolleeID will have the new enrollees id
                            mStateManager.refreshEMAGetStatus = false;
                            mEnrolleesData.OffenderCurrentIdFromDashboard = -1;
                            mEnrolleesData.OffenderCurrentId = lEnrolleeId;
                            offenderProfilePopulate();
                            GetEMAEnrolleeStatus(lEnrolleeId, PopulateEMAProfileViews, Sad, null);
                        } 

                    } else {
                        mEnrolleesData.VictimCurrentId = lEnrolleeId;
                        if (mStateManager.Settings()[1] === 'Profile') {
                            var aPrevState = mStateManager.getPreviousState(),
                            aCurrentState = mStateManager.getSystemState(),
                            isFromMapPrev = aPrevState.Primary === 'Map';
                            if(lEnrolleeId !== mEnrolleesData.OffenderCurrentId || (isFromMapPrev)){
                                VictimController.ExitEditMode();
                                Victim.victimProfilePopulate();
                            }
                        } else {
                            Victim.enrolleesVictimMap_Init();
                        }
                    }
                    if (mStateManager.Settings()[1] === 'Profile') {
                        if ((lEnrolleeId !== mEnrolleesData.OffenderCurrentId || lEnrolleeId === mEnrolleesData.OffenderCurrentIdFromDashboard) || mStateManager.refreshEMAGetStatus ) {
                            //if a new enrollee was selected the lEnrolleeID will have the new enrollees id
                            mStateManager.refreshEMAGetStatus = false;
                            mEnrolleesData.OffenderCurrentIdFromDashboard = -1;
                            mEnrolleesData.OffenderCurrentId = lEnrolleeId;
                        } 
                        
                        if (lEnrollee.InMyOrganization) {
                            ReloadEnrolleeSchedules(lEnrolleeId, function () {
                                if (mStateManager.Settings()[2] !== 'Notifications')
                                    window['EnrolleeProfile' + mStateManager.Settings()[2] + '_Init'](lEnrolleeId);
                            })
                            $('#uEditOffenderButton').show();
                        }
                        else {
                            $('#uEnrolleesSecondaryContentHolder').hide();
                            $('#uEditOffenderButton').hide();
                            ReloadEnrolleeSchedules(lEnrolleeId, function () {

                            });
                        }
                    }
                    if (mStateManager.Settings()[1] === 'Map') {
                        if (!isNullOrUndefined(mEnrolleesControls.PlaybackControl)) {
                            mEnrolleesControls.PlaybackControl.Activate(false);
                            uEnrolleesMapPlaybackLock();
                        }
                        uEnrolleesMapPlaybackStopButton_OnClick();
                        $('#uEditZoneButton').hide();
                        $('.TagControls ').hide();

                        if (gUserDetails.RegionalOri && (getViewState("RegionalLoadedId") == null || getViewState("RegionalLoadedId").Value == null)) {
                            $("#uHomeToolCommandButton").addClass("regionalOri");
                            $("#uMapCommandCell").css("width", "115px");
                        } else if (gUserDetails.RegionalOri) {
                            $("#uHomeToolCommandButton").removeClass("regionalOri");
                            $("#uMapCommandCell").css("width", "180px");
                        } else {
                            if (isNullOrUndefined(mEnrolleesData.OffenderCurrentId)) {
                                $("#uHomeToolCommandButton").addClass("regionalOri");
                                $("#uMapCommandCell").css("width", "115px");
                            } else {
                                $("#uHomeToolCommandButton").removeClass("regionalOri");
                                $("#uMapCommandCell").css("width", "180px");
                            }
                        }

                    }
                }
                else {
                    removeLoadButtons();
                }
            } else {
                mEnrolleesData.OffenderCurrentId = -1;
            }
        }, { 'Sender': aSender, 'EnrolleeId': aEnrolleeId, 'Data': aData });

        var lEnrollee = mEnrolleesControls.CardView.selectedDataItem();


        uDisplayTimelineChartButton(aEnrolleeId, aData);
        if (mStateManager.Settings()[1] !== 'Profile') {
            timelineButtonLoadCheck(false);
        }
        if (!isNullOrUndefined(lEnrollee) && lEnrollee.HasGpsDevice) {
            $('.DeviceActionButton').show();
            if (lEnrollee.HasSoberTrackDevice) {
                $('.SoberTrackDeviceButton').show();
                $('.RapidReportButton').hide();
                getSoberTrackOnDemandIsReady(lEnrollee.Id, $('.SoberTrackDeviceButton'));
            } else {
                $('.SoberTrackDeviceButton').hide();
            }
            showRapidReportingStatusToggle(lEnrollee.TrackingDeviceSerialNumber);
        } else {
            $('.DeviceActionButton').hide();
        }
        if (!isNullOrUndefined(mEnrolleesControls.EnrolleesMap)) {
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('Places', veritracks.mapping.preparePlacesData([]));
        }
        veritracks.enrollees.mapping.PreviousZoom(0)
        if (!isNullOrUndefined(lEnrollee)) { 
            setViewState('EnrolleesSelectedEnrollee', lEnrollee.Id);
        }
        if (!isNullOrUndefined(mEnrolleesControls.NotificationPanel)) {
            mEnrolleesControls.NotificationPanel.clearNotifications();
        }
        isAssignedCheck();
        soberTrackSchedulesShow();
    }


}

function addUnloadButton() {
    "use strict";
    if ($("#uUnLoadOriDataButton").hasClass("regionalOri")) {
        $("#uUnLoadOriDataButton").removeClass("regionalOri");
        $("#uLoadOriDataButton").addClass("regionalOri");
    }

    if ($("#uEnrolleesSecondaryContentHolder").hasClass("regionalOri")) {
        $("#uEnrolleesSecondaryContentHolder").removeClass("regionalOri");
    }

    if ($("#uEventsTab").hasClass("regionalOri")) {
        $("#uEventsTab").removeClass("regionalOri");
    }

    if ($("#uZonesTab").hasClass("regionalOri")) {
        $("#uZonesTab").removeClass("regionalOri");
    }

}

function removeLoadButtons() {
    "user strict";
    $("#uLoadOriDataButton").addClass("regionalOri");
    $("#uUnLoadOriDataButton").addClass("regionalOri");
}

function unloadRegionalOriData() {
    "use strict";
    var lEnrollee = mEnrolleesControls.CardView.selectedDataItem();
    mCache.RemoveUpdatableItem("Zones");
    mCache.RemoveUpdatableItem("Events");

    $("#uEventsTab").addClass("regionalOri");
    $("#uZonesTab").addClass("regionalOri");
    $("#uEnrolleesSecondaryContentHolder").addClass("regionalOri");
    setViewState("RegionalLoadedId", null);
    //remove event icon from that card
    lEnrollee.EventIconDisplay = 'none';
    mEnrolleesControls.CardView.updateSingleItem(lEnrollee);
    uEnrolleesCardView_OnSelectChange(mEnrolleesControls.CardView, lEnrollee.Id, lEnrollee);
    universalSearch_UpdateData();
    mActivityNotification.addNotification(localizeWrapper('cEnrolleeZESUnLoaded'));

}

function checkOffenderHasSoberTrack() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    lBuilder.AddNewExpressionConditional("EnrolleeId", mEnrolleesControls.CardView.selectedDataItem().Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional("ProductId", 121, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.DeviceAssignment.AssemblyQualifiedName,lBuilder.RootExpression, 0, checkSobertrack_OnSuccess, Sad, null,null);

}

function checkSobertrack_OnSuccess(aParams, aData) {
    "use strict";
    var lColumns,
        lDataSource,
        lDefaultValues = [],
        lAllowedItems = [],
        lAllowedValues = [],
        lHasSoberTrackFilterItem = false,
        lUnallowed = ["21"],
        lState = null,
        lItem;

    lColumns = mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.Columns;

    for (var key in lColumns) {
        if (lColumns.hasOwnProperty(key)) {
            if (lColumns[key].DataField == "Type") {
                lDataSource = lColumns[key].DataSource;
                lDefaultValues = lColumns[key].DefaultValue;
                if (isNullOrUndefined(aData) || aData.length == 0) {
                    for (var lDataKey in lDataSource) {
                        if (lDataSource.hasOwnProperty(lDataKey)) {
                            lItem = lDataSource[lDataKey];
                            if (lUnallowed.indexOf(lItem.Id) == -1) {
                                lAllowedItems.push(lItem);
                            }//end of if
                        }//end of if
                    }//inner of for
                    mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.setColumnDataSource(lColumns[key].Id, lAllowedItems);
                } else {

                    for (var lDataKey in lDataSource) {
                        if (lDataSource.hasOwnProperty(lDataKey)) {
                            lItem = lDataSource[lDataKey];
                            if (lUnallowed.indexOf(lItem.Id) != -1) {
                                lHasSoberTrackFilterItem = true;
                                break;
                            }//end of if
                        }//end of if
                    }//inner of for

                    if (!lHasSoberTrackFilterItem) {
                        lDataSource.push({ "Id": "21", "Title": localizeText('cEnrolleeAlcoholTestPoints') });
                    }
                    mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.setColumnDataSource(lColumns[key].Id, lDataSource);
                }

            }//end of if
        }//end of if
    }//end of for

}

function uEnrolleesOffenderEventsListViewFilter_OnFilter(aExpression) {
    "use strict";
    mEnrolleesControls.EventsListView.Filter(aExpression);
}

function EnrolleeProfileScheduleDeviceCluster_OnLoad(aParams, aDeviceClusterList) {
    "use strict";
    var lDeviceClusters = [],
        lDeviceCluster,
        lAssignment,
        lKey,
        lBuilder = new SumoPredicateBuilder(),
        lScheduleTarget;

    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lDeviceClusters = query(getDataItems('DeviceClusters'), lBuilder.RootExpression);

    for (lKey in aDeviceClusterList) {
        if (aDeviceClusterList.hasOwnProperty(lKey)) {
            lAssignment = aDeviceClusterList[lKey];
            if (!isNullOrUndefined(lAssignment)) {
                lDeviceCluster = lDeviceClusters[lAssignment.DeviceClusterId];
                if (!isNullOrUndefined(lDeviceCluster)) {
                    lScheduleTarget = new ScheduleTarget();
                    lScheduleTarget.Id = lDeviceCluster.Id;
                    lScheduleTarget.Name = lDeviceCluster.Name;
                    lScheduleTarget.TypeId = 3;
                    lScheduleTarget.TypeName = 'BLUbox Group';
                    lScheduleTarget.UniqueId = 'D' + lDeviceCluster.Id;
                    mEnrolleesData.SchedulesTargetsClean[lScheduleTarget.UniqueId] = lScheduleTarget;
                }
            }
        }
    }
	$('#uEditScheduleButton').hide();
    if (mEnrolleesData.SchedulesTargetsClean.length > 0) {
        $('#uSelectAllScheduleButton').show();
    }
    if (displayOldScheduleUILoggedInOri(aParams.EnrolleeId)) {
		if (!getCarveOutPreference()) {
			$('#uEnrolleeViewScheduleButton').show();
			$('#uEnrolleeViewCarveOutScheduleButton').hide();
			$('#uAddScheduleButton').show();
            if (!isNullOrUndefined(aParams.TargetEnrolleeId) && !isNullOrUndefined(aParams.TargetEnrolleeId.Value) &&
                aParams.TargetEnrolleeId.Value === aParams.EnrolleeId &&
                !isNullOrUndefined(aParams.TargetZoneId) && !isNullOrUndefined(aParams.TargetZoneId.Value)) {
                mEnrolleesData.TargetZoneId = aParams.TargetZoneId.Value;
                $('#uAddScheduleButton').click();
            }
        }
    }
    else {
        var checkCarveOutEnabled = checkIfCarveOutSchedulesAllowed();
		if (checkCarveOutEnabled) {
			$('#uEnrolleeViewCarveOutScheduleButton').show();
			$('#uAddScheduleButton').hide();
			$('#uEnrolleeViewScheduleButton').hide();
		}
        else
            $('#uEnrolleeViewCarveOutScheduleButton').hide();
    }

    if(PopupIsOpen()) {
      populateAbsenceScheduleTargetList();
    }
}

function uScheduleFullDayCheckbox_OnChange() {
    "use strict";
    var lIsDisabled = $(this).is(':checked');
    $('#uScheduleStartTime').val('12:00 AM').attr('disabled', lIsDisabled);
    $('#uScheduleEndTime').val('11:59 PM').attr('disabled', lIsDisabled);
}

function EnrolleeProfileSchedule_Init(aHeaderText, aCallback, aIsCalendar) {
    "use strict";
    var lButtonCommandBar = GenerateButtonCommandBar();
    GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'uSaveScheduleButton_OnClick(' + aIsCalendar + ')').appendTo(lButtonCommandBar);
    GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'CalendarClosePopup()').appendTo(lButtonCommandBar);
    DisplayPopup(aHeaderText, '<div id="uScheduleDialogPanel"></div>', lButtonCommandBar, true, aIsCalendar);
    populateElement('uScheduleDialogPanel', 'Enrollees.Offenders.Profile.Schedules.Dialog.htm', function () { EnrolleeProfileSchedule_OnComplete(aCallback); });
}

function CalendarClosePopup() {
    ClosePopup();
    if(mEnrolleesControls.veritracksCalendar)
        mEnrolleesControls.veritracksCalendar.resetData();
}

function enrolleesProfileScheduleTarget_Populate(aTargetType, aSearchString) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lList,
        lTargetType = scheduleTargetTypeFormatter(aTargetType);

    //if (lTargetType !== '6') {
    lBuilder.AddNewExpressionConditional('Name', aSearchString, false, mRelationalOperatorEnum.Like(), mLogicalOperatorEnum.Or());
    lBuilder.AddNewExpressionConditional('TypeName', aSearchString, false, mRelationalOperatorEnum.Like(), mLogicalOperatorEnum.Or());
    lBuilder.AddNewExpressionConditional('TypeId', parseInt(lTargetType), false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    if (aTargetType === 'My') {
        lBuilder.AddNewExpressionConditional('Id', mEnrolleesData.EnrolleeZoneIdList, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    }
    lList = query(mEnrolleesData.SchedulesTargetsClean, lBuilder.RootExpression);

    mEnrolleesControls.SchedulesTargetCardView.setDataSource(lList);
}

function uSchedulesTargetCardViewFilter_OnChange() {
    "use strict";
    var lTargetType = $('#uSchedulesTargetType').val();
    enrolleesProfileScheduleTarget_Populate(lTargetType, $('#uSchedulesTargetCardViewFilter').val());

    if (mEnrolleesData.TargetZoneId !== -1) {
        mEnrolleesControls.SchedulesTargetCardView.selected('Z' + mEnrolleesData.TargetZoneId);
    }
}

function uSchedulesTargetCardView_OnSelectChange(aSender, aTargetId, aData) {
    "use strict";
    var lTargetType = $('#uSchedulesTargetType').val(),
        lDataSource;

    if (lTargetType === 'My') {
        lTargetType = 1;
    }

    lDataSource = aSender.getDataSource();
    if (((lTargetType == 2 || lTargetType == 3) && (count(lDataSource) === 0 || !isNullOrUndefined(aTargetId))) ||
         ((lTargetType == 1 || lTargetType == 6) && !isNullOrUndefined(aTargetId))) {
        $('.PopupWindow .SaveButton').show();
    } else {
        $('.PopupWindow .SaveButton').hide();
    }
    $('.HideButton').hide();
}

function uSchedulesTargetType_OnSelectChange() {
    "use strict";
    var lSchedulesTarget = $('#uSchedulesTargetType option:selected').val();
    uSchedulesTargetCardViewFilter_OnChange();
    uSchedulesTargetCardView_OnSelectChange(mEnrolleesControls.SchedulesTargetCardView, mEnrolleesControls.SchedulesTargetCardView.selected(), null);
    $('.ScheduleTimespan').hide();
    if (lSchedulesTarget === '1' || lSchedulesTarget === 'My') {
        $('#uSchedulesZoneCategory').show();
        $('#uSchedulesZoneCategoryTitle').show();
    } else {
        $('#uSchedulesZoneCategory').hide();
        $('#uSchedulesZoneCategoryTitle').hide();
    }
    if (lSchedulesTarget !== '6' && $('.PopupTitle').text() !== 'Edit ScheduleEdit Schedule') {
        $('.ScheduleTimespan').show();
    }

    enrolleeScheduleEnterEditMode();
}

function EnrolleeProfileSchedule_OnComplete(aCallback) {
    "use strict";
    var lContentHtml = [],
        lKey,
        lObject;

    function onInitialized() {
        mEnrolleesControls.SchedulesTargetCardView.unbind('initialized', onInitialized);
        enrolleesProfileScheduleTarget_Populate(1, '');

        populateDateView('#uScheduleStartDate', function () { });
        $('.TimePicker').ptTimeSelect({
            'zIndex': 100000,
            'onFocusDisplay': true
        });
        populateEditView({}, [
            //{ 'Id': 'EntityId', 'Type': 'Dropdown', 'DataSource': mEnrolleesData.SchedulesTargetsClean, 'DataValueField': 'UniqueId', 'DataTextField': 'Name' }
        ], {}, 'uSchedule', 'Edit');
        if (!isNullOrUndefined(aCallback)) {
            aCallback();
        }
    }

    applyUserPermissions([2, 7, 8, 11]);
    mEnrolleesControls.SchedulesTargetCardView = new sumo.controls.CardView('uSchedulesTargetCardView',
        'uSchedulesTargetCardViewHolder',
        {
            'cardTemplate': 'Interface/Enrollees.Offenders.Profile.Schedules.Dialog.Card.Template.htm',
            'selectMethod': 'single',
            'canUnselect': false,
            'cssClass': 'VeritracksCardView'
        });
    mEnrolleesControls.SchedulesTargetCardView.bind('selectedchanged', uSchedulesTargetCardView_OnSelectChange);
    mEnrolleesControls.SchedulesTargetCardView.bind('initialized', onInitialized);
    $('#uScheduleFullDayCheckbox').change(uScheduleFullDayCheckbox_OnChange);
}

function enrolleesOffenderScheduleCache_OnComplete(aSender, aData, aParams) {
    "use strict";
    var lEnrolleeId = mEnrolleesData.OffenderCurrentId;

    if (PopupIsOpen('#uVeritracksCalendarHolder')) {
        lEnrolleeId = mEnrolleesControls.veritracksCalendar.getExtraData('enrolleeId');
        enrolleeSchedulePopup_Init(lEnrolleeId);
    }
    EnrolleeProfileSchedules_Init(lEnrolleeId);

    if ($('#uScheduleDialogPanel').is(":visible") || $('#uAbsenceScheduleDialogPanel').is(":visible"))
        ClosePopup();
    $('#uEnrolleeScheduleActionButtonBar').show();
}

function enrolleesOffenderScheduleUpdate_OnSuccess(aSchedule) {
    "use strict";
    var lZone = getDataItem(aSchedule.EntityId, 'Zones'),
        lSchedules = mEnrolleesData.OffenderSchedules,
        lBuilder = new SumoPredicateBuilder(),
        lEnrolleeCount = 0,
        lEnrolleeIds = [],
        lItem,
        lKey;
    if (!isNullOrUndefined(lZone)) {
        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('EntityId', aSchedule.EntityId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('ScheduleType', [1,8], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());

        lSchedules = query(lSchedules, lBuilder.RootExpression);
        lEnrolleeCount = countDistinct(lSchedules, 'EnrolleeId');

        lZone.EnrolleeCount = lEnrolleeCount;

        WriteSingle(lZone, null, null, null, false);
    }
}

function updateScheduleZoneCategory(aSchedules) {
    "use strict";
    var lZoneIds = aSchedules.map(function (schedule) {
        if (schedule.ZoneScheduleType >= 1) {
            return schedule.EntityId;
        }
    });
    
    lZoneIds = lZoneIds.filter(function (a) { return a });
    lZoneIds = lZoneIds.unique();

    GetRefreshedZones(lZoneIds.join(','), function (aParams, aData) {
        aData.forEach(function (zone) {
            setDataItem(zone.Id, 'Zones', zone)
        })
    }, Sad)
}

function enrolleesOffenderScheduleWrite_OnSuccess(aParams, aData) {
    "use strict";
    FixDates(aData);
    updateScheduleZoneCategory(aData);

    ReloadEnrolleeSchedules(mEnrolleesData.OffenderCurrentId, function (aParams, aNewSchedules) {
        enrolleesOffenderScheduleCache_OnComplete(null, null, aData)
    })
}

function enrolleesOffenderScheduleWrite_OnFailure(aParams, a, b, c) {
    "use strict";
    var l = '';

}

function checkOrUncheckDaysOfWeek() {
    "use strict";
    if (!isNullOrUndefined($('#uScheduleRecurrenceAllWeek').attr('checked'))) {
        $('#uScheduleRecurrenceSunday').prop('checked', true);
        $('#uScheduleRecurrenceMonday').prop('checked', true);
        $('#uScheduleRecurrenceTuesday').prop('checked', true);
        $('#uScheduleRecurrenceWednesday').prop('checked', true);
        $('#uScheduleRecurrenceThursday').prop('checked', true);
        $('#uScheduleRecurrenceFriday').prop('checked', true);
        $('#uScheduleRecurrenceSaturday').prop('checked', true);
    } else {
        $('#uScheduleRecurrenceSunday').prop('checked', false);
        $('#uScheduleRecurrenceMonday').prop('checked', false);
        $('#uScheduleRecurrenceTuesday').prop('checked', false);
        $('#uScheduleRecurrenceWednesday').prop('checked', false);
        $('#uScheduleRecurrenceThursday').prop('checked', false);
        $('#uScheduleRecurrenceFriday').prop('checked', false);
        $('#uScheduleRecurrenceSaturday').prop('checked', false);
    }
}

function adjustDaysOfWeekCheckBoxes() {
    "use strict";
    if ($('#uScheduleRecurrenceSunday').attr('checked') &&
        $('#uScheduleRecurrenceMonday').attr('checked') &&
        $('#uScheduleRecurrenceTuesday').attr('checked') &&
        $('#uScheduleRecurrenceWednesday').attr('checked') &&
        $('#uScheduleRecurrenceThursday').attr('checked') &&
        $('#uScheduleRecurrenceFriday').attr('checked') &&
        $('#uScheduleRecurrenceSaturday').attr('checked')
        ) {
        $('#uScheduleRecurrenceAllWeek').prop('checked', true);
    } else {
        $('#uScheduleRecurrenceAllWeek').prop('checked', false);
    }

}

function uSaveScheduleButton_OnClick() {
    "use strict";
    var lStart = new Date($('#uScheduleStartDate').val() + ' ' + $('#uScheduleStartTime').val()),
        lEnd = new Date($('#uScheduleStartDate').val() + ' ' + $('#uScheduleEndTime').val()),
        lZoneCategory = $('#uSchedulesZoneCategory').val(),
        //lTargetIndex = $('#uScheduleEntityIdEdit').val(),
        lTargetIndex = mEnrolleesControls.SchedulesTargetCardView.selected(),
        lTargetId = 0,
        //lPrefix = 'Z',
        lType = parseInt(scheduleTargetTypeFormatter($('#uSchedulesTargetType').val())),
        lSchedule = mEnrolleesData.SchedulesEditItem,
        lKey,
        lCount = 0,
        lSchedules = mEnrolleesData.OffenderSchedules,
        lBuilder = new SumoPredicateBuilder(),
        lOffenderSchedules = [],
        lButtonCommandBar = GenerateButtonCommandBar(),
        lScheduleList = [],
        lEnrolleeId = mEnrolleesData.OffenderCurrentId,
        lWrapSchedule,
        lTimeZone;

    if (lEnrolleeId == -1) {
        lEnrolleeId = mEnrolleesControls.veritracksCalendar.getExtraData('enrolleeId');
    }
    $('#uEnrolleeScheduleActionButtonBar').hide();
    if (lSchedule.Id !== -1) {
        lBuilder.AddNewExpressionConditional('Id', lSchedule.Id, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
    }
    lBuilder.AddNewExpressionConditional('ScheduleType', 6, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsEnabled', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsAbsenceSched', getCarveOutPreference(), false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lOffenderSchedules = query(lSchedules, lBuilder.RootExpression);

    if (lType === 6 && count(lOffenderSchedules) >= 3) {
        alert('Too many active address schedules. Saving as disabled.');
        lSchedule.IsEnabled = false;
    }

    if (mEnrolleesData.SchedulesValidator.IsValid()) {
        $('.PopupWindow .SaveButton').hide();
        $('.PopupWindow .CancelButton').hide();
        if (lType === 1 || lType === 2 || lType === 3 || lType === 6) {
            if (!isNullOrUndefined(lTargetIndex)) {
                lTargetId = parseInt(lTargetIndex.substring(1, lTargetIndex.length));
            } else {
                lTargetId = -1;
            }
        }

        lSchedule.TransactionId = moment().format("YYYYMMDDHHmmss");
        lSchedule.EnrolleeId = lEnrolleeId;
        lSchedule.EntityId = lTargetId;
        lSchedule.ScheduleType = lType;
        lSchedule.EndTime = lEnd;
        if (lSchedule.ScheduleType === 6) {
            lSchedule.StartTime = new Date(lSchedule.EndTime);
            lSchedule.StartTime.addMinutes(-15);
        } else {
            lSchedule.StartTime = lStart;
        }
        lTimeZone = getEnrolleeTimeZone(lSchedule.EnrolleeId);
        lSchedule.IsNoSchedule = document.getElementById('uIsNoSchedule').checked;
        if (lSchedule.IsNoSchedule) {
            lSchedule.StartTime.setHours(0);
            lSchedule.StartTime.setMinutes(0);
            lSchedule.StartTime.setSeconds(0);

            //lSchedule.EndTime = new Date(lSchedule.StartTime.getDate());
            lSchedule.EndTime.setHours(23);
            lSchedule.EndTime.setMinutes(59);
            lSchedule.EndTime.setSeconds(0);
        }
        lSchedule.IsRecurring = ($('#uScheduleType').val() === 'true');
        lSchedule.IsActive = true;
        lSchedule.IsForcedLeave = false;
        lSchedule.Name = $('#uScheduleName').val();
        lSchedule.ZoneScheduleType = lZoneCategory;
        //lSchedule.TimeZoneCode = getTimezonebyBrowser();
        if (lSchedule.IsRecurring) {
            lSchedule.IsSunday = $('#uScheduleRecurrenceSunday').is(':checked');// document.getElementById('uScheduleRecurrenceSunday').checked;
            lSchedule.IsMonday = $('#uScheduleRecurrenceMonday').is(':checked');//document.getElementById('uScheduleRecurrenceMonday').checked;
            lSchedule.IsTuesday = $('#uScheduleRecurrenceTuesday').is(':checked');//document.getElementById('uScheduleRecurrenceTuesday').checked;
            lSchedule.IsWednesday = $('#uScheduleRecurrenceWednesday').is(':checked');//document.getElementById('uScheduleRecurrenceWednesday').checked;
            lSchedule.IsThursday = $('#uScheduleRecurrenceThursday').is(':checked');//document.getElementById('uScheduleRecurrenceThursday').checked;
            lSchedule.IsFriday = $('#uScheduleRecurrenceFriday').is(':checked');//document.getElementById('uScheduleRecurrenceFriday').checked;
            lSchedule.IsSaturday = $('#uScheduleRecurrenceSaturday').is(':checked');//document.getElementById('uScheduleRecurrenceSaturday').checked;
        } else {
            lSchedule.IsSunday = lSchedule.StartTime.getDay() === 0;
            lSchedule.IsMonday = lSchedule.StartTime.getDay() === 1;
            lSchedule.IsTuesday = lSchedule.StartTime.getDay() === 2;
            lSchedule.IsWednesday = lSchedule.StartTime.getDay() === 3;
            lSchedule.IsThursday = lSchedule.StartTime.getDay() === 4;
            lSchedule.IsFriday = lSchedule.StartTime.getDay() === 5;
            lSchedule.IsSaturday = lSchedule.StartTime.getDay() === 6;
        }
        lScheduleList.push(lSchedule);
        if ($('#uScheduleWrapDaysCheckbox').is(':checked') && lSchedule.EndTime < lSchedule.StartTime && !lSchedule.IsNoSchedule) {
            lWrapSchedule = $.extend({}, lSchedule);
            lWrapSchedule.StartTime = new Date(lWrapSchedule.StartTime);
            lWrapSchedule.EndTime = new Date(lWrapSchedule.EndTime);

            lWrapSchedule.Name += ' Early';
            lWrapSchedule.StartTime.setHours(0);
            lWrapSchedule.StartTime.setMinutes(0);
            lSchedule.Name += ' Late';
            lSchedule.EndTime.setHours(23);
            lSchedule.EndTime.setMinutes(59);

            lWrapSchedule.StartTime = convertTimeToUTC(lWrapSchedule.StartTime, lTimeZone.TimeZoneName);
            lWrapSchedule.EndTime = convertTimeToUTC(lWrapSchedule.EndTime, lTimeZone.TimeZoneName);

            lScheduleList.push(lWrapSchedule);
        }
        lSchedule.StartTime = convertTimeToUTC(lSchedule.StartTime, lTimeZone.TimeZoneName);
        lSchedule.EndTime = convertTimeToUTC(lSchedule.EndTime, lTimeZone.TimeZoneName);
        saveSchedulesMultiDay(lScheduleList);
    } else {
        $('.PopupWindow .SaveButton').removeClass('Disabled');
        $('.PopupWindow .CancelButton').removeClass('Disabled');
    }
}

function resetScheduleDays(schedule, dayCount) {
    var start = schedule.StartTime;
    var end = schedule.EndTime;
    var lSchedule = JSON.parse(JSON.stringify(schedule)); //copy

    lSchedule.IsMonday = false;
    lSchedule.IsTuesday = false;
    lSchedule.IsWednesday = false;
    lSchedule.IsThursday = false;
    lSchedule.IsFriday = false;
    lSchedule.IsSaturday = false;
    lSchedule.IsSunday = false;
    lSchedule.StartTime = start;
    lSchedule.EndTime = end;

    if (dayCount > 0) {
        lSchedule.Id = -1;
    }

    return lSchedule;
}

function CreateAutoExceptionFlagCheck(aSchedule, master) {
    var lEnrollee = GetEnrollee(master.EnrolleeId);
    if(master.IsMonday && master.IsTuesday && master.IsWednesday && master.IsThursday &&
        master.IsFriday && master.IsSaturday && master.IsSunday && master.IsRecurring) {
        if (moment(aSchedule.EndTime).diff(aSchedule.StartTime)/60000 !== 1439) return 0

        var autoExceptionFlag = checkIsCurrentDay(aSchedule) ? 1 : 0;

        if (autoExceptionFlag) {
            if (displayOldScheduleUILoggedInOri(mEnrolleesData.OffenderCurrentId))
                autoExceptionFlag = 0
        }

        return autoExceptionFlag;
    }
    return 0;
}

function saveSchedulesMultiDay(aScheduleList, aCallback, aParams) {
    "use strict";
    var lSchedules = [];
    var lSchedulesList = [];
    var lCallback = enrolleesOffenderScheduleWrite_OnSuccess;

    if (aCallback) {
        lCallback = aCallback;
    }

    lSchedulesList = aScheduleList;

    aScheduleList.forEach(function (schedule) {
        var lSchedule;
        var dayCount = 0;

        if (!schedule.IsActive) {
            lSchedules.push(schedule);
            return;
        }
        if (schedule.IsMonday) {
            lSchedule = resetScheduleDays(schedule, dayCount);
            lSchedule.IsMonday = true;
            lSchedule.EndTime = moment(lSchedule.EndTime).weekday(1).toDate();
            lSchedule.StartTime = moment(lSchedule.StartTime).weekday(1).toDate();
            if (moment(lSchedule.EndTime) < moment(lSchedule.StartTime)) {
                lSchedule.StartTime = moment(lSchedule.StartTime).add(-1, 'day').toDate();
            }
            lSchedule.CreateAutoExceptionFlag = CreateAutoExceptionFlagCheck(lSchedule, schedule);
            lSchedules.push(lSchedule);
            dayCount++;
        }
        if (schedule.IsTuesday) {
            lSchedule = resetScheduleDays(schedule, dayCount);
            lSchedule.IsTuesday = true;
            lSchedule.EndTime = moment(lSchedule.EndTime).weekday(2).toDate();
            lSchedule.StartTime = moment(lSchedule.StartTime).weekday(2).toDate();
            if (moment(lSchedule.EndTime) < moment(lSchedule.StartTime)) {
                lSchedule.StartTime = moment(lSchedule.StartTime).add(-1, 'day').toDate();
            }
            lSchedule.CreateAutoExceptionFlag = CreateAutoExceptionFlagCheck(lSchedule, schedule);
            lSchedules.push(lSchedule);
            dayCount++;
        }
        if (schedule.IsWednesday) {
            lSchedule = resetScheduleDays(schedule, dayCount);
            lSchedule.IsWednesday = true;
            lSchedule.EndTime = moment(lSchedule.EndTime).weekday(3).toDate();
            lSchedule.StartTime = moment(lSchedule.StartTime).weekday(3).toDate();
            if (moment(lSchedule.EndTime) < moment(lSchedule.StartTime)) {
                lSchedule.StartTime = moment(lSchedule.StartTime).add(-1, 'day').toDate();
            }
            lSchedule.CreateAutoExceptionFlag = CreateAutoExceptionFlagCheck(lSchedule, schedule);
            lSchedules.push(lSchedule);
            dayCount++;
        }
        if (schedule.IsThursday) {
            lSchedule = resetScheduleDays(schedule, dayCount);
            lSchedule.IsThursday = true;
            lSchedule.EndTime = moment(lSchedule.EndTime).weekday(4).toDate();
            lSchedule.StartTime = moment(lSchedule.StartTime).weekday(4).toDate();
            if (moment(lSchedule.EndTime) < moment(lSchedule.StartTime)) {
                lSchedule.StartTime = moment(lSchedule.StartTime).add(-1, 'day').toDate();
            }
            lSchedule.CreateAutoExceptionFlag = CreateAutoExceptionFlagCheck(lSchedule, schedule);
            lSchedules.push(lSchedule);
            dayCount++;
        }
        if (schedule.IsFriday) {
            lSchedule = resetScheduleDays(schedule, dayCount);
            lSchedule.IsFriday = true;
            lSchedule.EndTime = moment(lSchedule.EndTime).weekday(5).toDate();
            lSchedule.StartTime = moment(lSchedule.StartTime).weekday(5).toDate();
            if (moment(lSchedule.EndTime) < moment(lSchedule.StartTime)) {
                lSchedule.StartTime = moment(lSchedule.StartTime).add(-1, 'day').toDate();
            }
            lSchedule.CreateAutoExceptionFlag = CreateAutoExceptionFlagCheck(lSchedule, schedule);
            lSchedules.push(lSchedule);
            dayCount++;
        }
        if (schedule.IsSaturday) {
            lSchedule = resetScheduleDays(schedule, dayCount);
            lSchedule.IsSaturday = true;
            lSchedule.EndTime = moment(lSchedule.EndTime).weekday(6).toDate();
            lSchedule.StartTime = moment(lSchedule.StartTime).weekday(6).toDate();
            if (moment(lSchedule.EndTime) < moment(lSchedule.StartTime)) {
                lSchedule.StartTime = moment(lSchedule.StartTime).add(-1, 'day').toDate();
            }
            lSchedule.CreateAutoExceptionFlag = CreateAutoExceptionFlagCheck(lSchedule, schedule);
            lSchedules.push(lSchedule);
            dayCount++;
        }
        if (schedule.IsSunday) {
            lSchedule = resetScheduleDays(schedule, dayCount);
            lSchedule.IsSunday = true;
            lSchedule.EndTime = moment(lSchedule.EndTime).weekday(0).toDate();
            lSchedule.StartTime = moment(lSchedule.StartTime).weekday(0).toDate();
            if (moment(lSchedule.EndTime) < moment(lSchedule.StartTime)) {
                lSchedule.StartTime = moment(lSchedule.StartTime).add(-1, 'day').toDate();
            }
            lSchedule.CreateAutoExceptionFlag = CreateAutoExceptionFlagCheck(lSchedule, schedule);
            lSchedules.push(lSchedule);
            dayCount++;
        }
    });

    if (!displayOldScheduleUILoggedInOri(mEnrolleesData.OffenderCurrentId)) {
        lSchedulesList = lSchedules;
    }

    WriteMultiple(lSchedulesList, lCallback, enrolleesOffenderScheduleWrite_OnFailure, aParams, true);
}



function uSchedulesTargetCardView_OnInit() {
    "use strict";
    mEnrolleesControls.SchedulesTargetCardView.unbind('databind', uSchedulesTargetCardView_OnInit);
    var lSchedule = mEnrolleesData.SchedulesEditItem,
        lPrefix = 'Z';
    switch (lSchedule.ScheduleType) {
        case 2:
            lPrefix = 'B';
            break;
        case 3:
            lPrefix = 'D';
            break;
        case 6:
            lPrefix = 'A';
            break;
    }
    mEnrolleesControls.SchedulesTargetCardView.selected(lPrefix + lSchedule.EntityId);
}

function bluPlusCheck(aEnrolleeId) {
    "use strict";
    return hasProduct(aEnrolleeId, 110);
}

function hasProduct(aEnrolleeId, aProductId) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lDevices = getDataItems('Devices'),
        lDeviceIds = gCurrentDeviceAssignment[aEnrolleeId],
        lDeviceIdList = [],
        lDevice,
        lKey,
        lItem,
        lValue;

    for (lKey in lDeviceIds) {
        if (lDeviceIds.hasOwnProperty(lKey)) {
            lItem = lDeviceIds[lKey].Id;
            lDeviceIdList.push(lItem);
        }
    }
    if (['object', 'array'].indexOf(typeof aProductId) !== -1) {
        lBuilder.AddNewExpressionConditional('ProductId', aProductId, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    } else {
        lBuilder.AddNewExpressionConditional('ProductId', aProductId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    }
    lBuilder.AddNewExpressionConditional('Id', lDeviceIdList, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lDevice = query(lDevices, lBuilder.RootExpression);
    if (!isNullOrUndefined(lDevice))
        lValue = (lDevice.length > 0);

    return lValue;
}

function enrolleeScheduleEnterEditMode() {
    "use strict";
    var lSchedulesTarget = $('#uSchedulesTargetType option:selected').val(),
        lIsBluPlus = bluPlusCheck(mEnrolleesData.OffenderCurrentId);
    // lDevice;
    $('#uSchedulePrimaryTimeContainer').hide();

    if (!isNullOrUndefined(lSchedulesTarget)) {
        if (lSchedulesTarget === '6') {
            $('#uScheduleSecondaryTimeHolder').html('Check-In Time');
            $('#uSchedulePrimaryTimeContainer').hide();
            $('.BluPlusHidden').hide();
        } else {
            $('#uSchedulePrimaryTimeContainer').show();
            $('.BluPlusHidden').show();
            $('#uScheduleSecondaryTimeHolder').html('End Time');
        }
    }
}

function enrolleesSchedulePopulate() {
    "use strict";
    var lSchedule = mEnrolleesData.SchedulesEditItem,
        lPrefix = 'Z',
        lEnrolleeId = mEnrolleesData.OffenderCurrentId,
        lDeviceAssignments,
        lHasBluPlus = bluPlusCheck(lEnrolleeId),
        lAbsencesExist = absencesExist(lEnrolleeId),
        lHasBluHome = false,
        lHasDeviceCluster = false,
        lHasBluTag = false,
        lDevice,
        lBuilder = new SumoPredicateBuilder(),
        lZone,
        lHtml = [],
        lItem,
        lKey;

    if (lEnrolleeId == -1) {
        lEnrolleeId = mEnrolleesControls.veritracksCalendar.getExtraData("enrolleeId");
    }
    lDeviceAssignments = gCurrentDeviceAssignment[lEnrolleeId];

    lHtml.push('<select id="uSchedulesTargetType" onchange="uSchedulesTargetType_OnSelectChange()">');
    if (lHasBluPlus) {
        lHtml.push('<option value="3" class="pInventoryDeviceClusters pInventory">BLUbox</option>');
        lHtml.push('<option value="6" class="">BLU+ Address</option>');
    } else if (isNullOrUndefined(lDeviceAssignments) || lDeviceAssignments.length === 0) {
        lHtml.push('<option value="1" class="pZones">' + localizeText('cZone') + '</option>');
        lHtml.push('<option value="My" class="pZones">' + localizeText('cZoneIsMine') + '</option>');
        lHtml.push('<option class="pInventoryDevices pInventory" value="2">BLUhome</option>');
        lHtml.push('<option value="3" class="pInventoryDeviceClusters pInventory">BLUbox</option>');
        lHtml.push('<option value="6" class="">BLU+ Address</option>');
    } else {
        for (lKey in lDeviceAssignments) {
            if (lDeviceAssignments.hasOwnProperty(lKey)) {
                lItem = lDeviceAssignments[lKey];
                lDevice = getDataItem(lItem.Id, 'Devices');
                if ([104, 109].indexOf(lDevice.ProductId) !== -1) {
                    lHasBluHome = true;
                } else if (lDevice.ProductId === 103 || lDevice.ProductId === 141 || lDevice.ProductId === 151) { //artf79146 -- need to change device logic to be centralized on what a certain device has access too. EE 11/1/2016
                    lHasBluTag = true;
                }
            }
        }
        lBuilder.AddNewExpressionConditional('TypeId', 3, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lDeviceAssignments = query(mEnrolleesData.SchedulesTargetsClean, lBuilder.RootExpression);
        lHasDeviceCluster = (!isNullOrUndefined(lDeviceAssignments) && count(lDeviceAssignments) > 0);
        if (lHasBluTag) {
            lHtml.push('<option value="1" class="pZones">' + localizeText('cZone') + '</option>');
            lHtml.push('<option value="My" class="pZones">' + localizeText('cZoneIsMine') + '</option>');
        }
        if (lHasBluHome) {
            lHtml.push('<option class="pInventoryDevices pInventory" value="2">BLUhome</option>');
        }
        if (lHasDeviceCluster) {
            lHtml.push('<option value="3" class="pInventoryDeviceClusters pInventory">BLUbox</option>');
        }
    }
    lHtml.push('</select>');
    lHtml = lHtml.join('');
    if (lHtml.indexOf('<option') === -1) {
        $('#uOffenderSchedulePopupContentHolder').hide();
        $('#uOffenderScheduleErrorContentHolder').show();
    }
    $('#uScheduleTypeHolder').html(lHtml);

    switch (lSchedule.ScheduleType) {
        case 2:
            lPrefix = 'B';
            break;
        case 3:
            lPrefix = 'D';
            break;
    }

    if (!isNullOrUndefined(lSchedule)) {
        $('#uScheduleName').val(lSchedule.Name);
        $('#uScheduleEntityIdEdit').val(lPrefix + lSchedule.EntityId);
        mEnrolleesControls.SchedulesTargetCardView.bind('databind', uSchedulesTargetCardView_OnInit);
        $('#uSchedulesTargetType').val(lSchedule.ScheduleType);
        uSchedulesTargetType_OnSelectChange();

        $('#uScheduleStartTime').val($.format.date(lSchedule.StartTime, "h:mm a"));
        $('#uScheduleStartDate').val($.format.date(lSchedule.StartTime, "MM/dd/yyyy"));
        $('#uScheduleEndTime').val($.format.date(lSchedule.EndTime, "h:mm a"));
        $('#uScheduleEndDate').val($.format.date(lSchedule.EndTime, "MM/dd/yyyy"));

        document.getElementById('uScheduleRecurrenceSunday').checked = lSchedule.IsSunday;
        document.getElementById('uScheduleRecurrenceMonday').checked = lSchedule.IsMonday;
        document.getElementById('uScheduleRecurrenceTuesday').checked = lSchedule.IsTuesday;
        document.getElementById('uScheduleRecurrenceWednesday').checked = lSchedule.IsWednesday;
        document.getElementById('uScheduleRecurrenceThursday').checked = lSchedule.IsThursday;
        document.getElementById('uScheduleRecurrenceFriday').checked = lSchedule.IsFriday;
        document.getElementById('uScheduleRecurrenceSaturday').checked = lSchedule.IsSaturday;

        document.getElementById('uScheduleWrapDaysCheckbox').checked = true;
        //enrolleeScheduleEnterEditMode();

        var lZoneCategories = [];
        lZoneCategories.push(new Option(localizeText('cEnrolleeActive'), 1));
        lZoneCategories.push(new Option(localizeText('cEnrolleeSilent'), 2));
        lZoneCategories.push(new Option(localizeText('cEnrollee911'), 3));

        $('#uSchedulesZoneCategory').append(lZoneCategories);

        if (lSchedule.ZoneScheduleType !== -1) {
            $('#uSchedulesZoneCategory').val(lSchedule.ZoneScheduleType);
        }
        mEnrolleesData.SchedulesValidator = new Validator('uScheduleDialogPanel', mRegexValidation);
    }
    if (mEnrolleesData.TargetZoneId !== -1) {
        lZone = getDataItem(mEnrolleesData.TargetZoneId, 'Zones');
        $('#uSchedulesTargetCardViewFilter').val(lZone.Name).keyup();
        mEnrolleesData.TargetZoneId = -1;
    }
    var lTypes = [];
    lTypes.push(new Option(localizeText('cEnrolleeReoccurring'), true));
    lTypes.push(new Option(localizeText('cEnrolleeOverride'), false));

    $('#uScheduleType').append(lTypes);


    $('#uScheduleType').val(lSchedule.IsRecurring.toString());


    uScheduleType_OnChange(document.getElementById('uScheduleType'));


    //enrolleeScheduleEnterEditMode();
}
function uAddScheduleButton_OnComplete() {
    "use strict";
    enrolleesSchedulePopulate();
}

function uAddScheduleButton_OnClick() {
    "use strict";
    mEnrolleesData.SchedulesEditItem = new OffenderSchedule();
    EnrolleeProfileSchedule_Init(localizeWrapper('cEnrolleeAddNewSchedule'), enrolleesSchedulePopulate);
}


function uEditScheduleRoute_OnClick() {
    if (mEnrolleesControls.SchedulesListView.selectedDataItem()[0].TargetTypeId == 7) {
        editAbsenceSchedule({ "scheduleId": mEnrolleesControls.SchedulesListView.selected()[0] }, false);
    } else {
        uEditScheduleButton_OnClick();
    }
}

function uDeleteScheduleRoute_OnClick() {
    var lSelectedIds = mEnrolleesControls.SchedulesListView.selected();
    var lIds = [];
    var lDeleteIds = [];
    var lSchedules = [];

    for (var lKey in lSelectedIds) {
        if(lSelectedIds.hasOwnProperty(lKey)){
            var lItem = GetOffenderSchedule(lSelectedIds[lKey]);
              lSchedules.push(lItem);
        }
    }
    if (lAbsences.length > 0) {
        uDeleteAbsenceSchedule(lAbsences, false);
    } else {
        uRemoveAllAbsenceSchedules(lIds, lDeleteIds, false);
    }
}


function DeleteCalendarContinue(aParams, aData){
      var lSchedule = mEnrolleesControls.veritracksCalendar.getEditingSchedule(),
          lItem;

      //mActivityNotification.addNotification(aParams.type + " Absence Successfully!");
      for (var lKey in aParams.Ids) {
          if (aParams.Ids.hasOwnProperty(lKey)) {
              lItem = GetOffenderSchedule(aParams.Ids[lKey]);
              if (lItem) {
                  lItem.IsActive = false;
                  updateOffenderScheduleCache(lItem);
              }
          }
      }

      uDeleteSchedule([lSchedule.scheduleId], true);
}

function uRemoveAllAbsenceSchedules(aIds, aDeleteIds, aIsCalendar) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    var lSchedules = [];
    var lDeletedSchedules = [];
    var lAbsences = [];
    var lCallback;
    var lEnrolleeId = mEnrolleesData.OffenderCurrentId;
    if(aIsCalendar){
        lCallback = DeleteCalendarContinue;
        lEnrolleeId = mEnrolleesControls.veritracksCalendar.getExtraData("enrolleeId");
    }

    lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('ScheduleType', [2, 3], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsRecurring', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsAbsenceSched', getCarveOutPreference(), false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lSchedules = query(mEnrolleesData.OffenderSchedules, lBuilder.RootExpression);

    lBuilder.AddNewExpressionConditional('Id', aDeleteIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());

    lDeletedSchedules = query(lSchedules, lBuilder.RootExpression);
    if (ObjectLength(lSchedules) > 0 && ObjectLength(lSchedules) == ObjectLength(lDeletedSchedules)) {
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('ScheduleType', 7, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsAbsenceSched', getCarveOutPreference(), false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

        lAbsences = query(mEnrolleesData.OffenderSchedules, lBuilder.RootExpression);

        var lAbsenceIds = getArrayByIds(lAbsences);

        if (lAbsenceIds.length > 0)
            uDeleteAbsenceSchedule(lAbsenceIds, aIsCalendar, lCallback);
        else
            uDeleteSchedule(aIds, aIsCalendar);
    } else {
        uDeleteSchedule(aIds, aIsCalendar);
    }
}

function deleteRegularSchedulesList_OnSuccess(aParams, aData) {
    "use strict";
    var lItem;
    var lSelectedIds = [];
    var lIds = [];

    if (mEnrolleesControls.SchedulesListView)
        lSelectedIds = mEnrolleesControls.SchedulesListView.selected();

    for (var lKey in aParams.Ids) {
        if (aParams.Ids.hasOwnProperty(lKey)) {
            //mActivityNotification.addNotification(aParams.type + " Absence Successfully!");
            lItem = GetOffenderSchedule(aParams.Ids[lKey]);
            if (lItem) {
                lItem.IsActive = false;
                updateOffenderScheduleCache(lItem);
            }
        }
    }
    for (var lKey in lSelectedIds) {
        if (lSelectedIds.hasOwnProperty(lKey)) {
            var lItem = GetOffenderSchedule(lSelectedIds[lKey]);
            if (lItem.ScheduleType !== 7) {
                lIds.push([lItem.Id]);
            }
        }
    }
    if (lIds.length > 0) {
        uDeleteSchedule(lIds,false);
    } else {
        enrolleesOffenderScheduleWrite_OnSuccess(null,[])
    }
}

function uEditScheduleButton_OnClick() {
    "use strict";
    var lId = mEnrolleesControls.SchedulesListView.selected()[0],
    lTimeZone;

    mEnrolleesData.SchedulesEditItem = new OffenderScheduleDisplay(GetOffenderSchedule(lId), true);
    lTimeZone = getEnrolleeTimeZone(mEnrolleesData.SchedulesEditItem.EnrolleeId);
    mEnrolleesData.SchedulesEditItem.StartTime = displayFixedTimeZoneTime(mEnrolleesData.SchedulesEditItem.StartTime, lTimeZone.TimeZoneName);
    mEnrolleesData.SchedulesEditItem.EndTime = displayFixedTimeZoneTime(mEnrolleesData.SchedulesEditItem.EndTime, lTimeZone.TimeZoneName);
    if (!mEnrolleesData.SchedulesEditItem.IsRecurring && !mEnrolleesData.SchedulesEditItem.IsNoSchedule) {
        FixStartTime();
    }
    EnrolleeProfileSchedule_Init('Edit Schedule', enrolleesSchedulePopulate);
}

function uDeleteScheduleButton_OnClick() {
    "use strict";
    var lSelectedIds = mEnrolleesControls.SchedulesListView.selected();
    uDeleteSchedule(lSelectedIds);
}

// Override Schedules Fix
function FixStartTime() {
    "use strict";
    var lDate = new moment(mEnrolleesData.SchedulesEditItem.StartTime),
        lDay;

    if (mEnrolleesData.SchedulesEditItem.IsMonday) {
        lDay = 1;
    }
    else if (mEnrolleesData.SchedulesEditItem.IsTuesday) {
        lDay = 2;
    }
    else if (mEnrolleesData.SchedulesEditItem.IsWednesday) {
        lDay = 3;
    }
    else if (mEnrolleesData.SchedulesEditItem.IsThursday) {
        lDay = 4;
    }
    else if (mEnrolleesData.SchedulesEditItem.IsFriday) {
        lDay = 5;
    }
    else if (mEnrolleesData.SchedulesEditItem.IsSaturday) {
        lDay = 6;
    }
    else {
        lDay = 0;
    }
    mEnrolleesData.SchedulesEditItem.StartTime = lDate.weekday(lDay)._d;
}

function uDeleteSchedule(aSelectedIds, aIsCalendar) {
    var lSelectedIds = aSelectedIds,
        lScheduleList = [],
        lItem,
        lKey;

    for (lKey = 0; lKey < lSelectedIds.length; lKey++) {
        if (lSelectedIds.hasOwnProperty(lKey)) {
            lItem = GetOffenderSchedule(lSelectedIds[lKey]);
            lItem.IsActive = false;
            lItem.TransactionId = moment().format("YYYYMMDDHHmmss");
            //lScheduleList.push(prepareObjectForWcf(lItem));
            lScheduleList.push(lItem);
        }
    }
    WriteMultiple(lScheduleList, enrolleesOffenderScheduleWrite_OnSuccess, enrolleesOffenderScheduleWrite_OnFailure, null, true);
}

function uUpdateSchedule(aScheduleId, aDay) {
    var lSchedule = GetOffenderSchedule(aScheduleId),
        lDayCount = 0;

    // clean this checking if single day schedule and has clicked delete day
    if (lSchedule.IsSunday)
        lDayCount++;
    if (lSchedule.IsMonday)
        lDayCount++;
    if (lSchedule.IsTuesday)
        lDayCount++;
    if (lSchedule.IsWednesday)
        lDayCount++;
    if (lSchedule.IsThursday)
        lDayCount++;
    if (lSchedule.IsFriday)
        lDayCount++;
    if (lSchedule.IsSaturday)
        lDayCount++;

    if (aDay == 0) {
        lSchedule.IsSunday = false;
    } else if (aDay == 1) {
        lSchedule.IsMonday = false;
    } else if (aDay == 2) {
        lSchedule.IsTuesday = false;
    } else if (aDay == 3) {
        lSchedule.IsWednesday = false;
    } else if (aDay == 4) {
        lSchedule.IsThursday = false;
    } else if (aDay == 5) {
        lSchedule.IsFriday = false;
    } else if (aDay == 6) {
        lSchedule.IsSaturday = false;
    } else {

    }
    if (lDayCount == 1 || !lSchedule.IsRecurring) {
        lSchedule.IsActive = false;
    }

    if (lSchedule.IsRecurring && !lSchedule.IsActive) {
        lSchedule.IsActive = true;
        uRemoveAllAbsenceSchedules([[lSchedule.Id]], [lSchedule.Id], true);
    } else {
        WriteMultiple([lSchedule], enrolleesOffenderScheduleWrite_OnSuccess, enrolleesOffenderScheduleWrite_OnFailure, null, true);
    }
}

function uEnrolleesSchedulesListView_OnSelectChange() {
    "use strict";
    var lSelectedLength = mEnrolleesControls.SchedulesListView.selected().length;

    if (displayOldScheduleUILoggedInOri(mEnrolleesData.OffenderCurrentId)) {
        if (lSelectedLength > 1) {
            $('#uEditScheduleButton').hide();
            $('#uDeleteScheduleButton').show();
            $('#uUnSelectAllScheduleButton').show();
			$('#uSelectAllScheduleButton').hide();
        } else if (lSelectedLength === 1) {
            //mEnrolleesControls.SchedulesView.selected(mEnrolleesControls.SchedulesListView.selected());
            $('#uEditScheduleButton').show();
            $('#uDeleteScheduleButton').show();
            $('#uUnSelectAllScheduleButton').hide();
			$('#uSelectAllScheduleButton').show();
        } else {
            $('#uEditScheduleButton').hide();
            $('#uDeleteScheduleButton').hide();
			$('#uSelectAllScheduleButton').show();
        }
	} else {
        if (lSelectedLength > 1) {
            $('#uDeleteScheduleButton').show();
            $('#uUnSelectAllScheduleButton').show();
            $('#uSelectAllScheduleButton').hide();
        } else if (lSelectedLength === 1) {
            //mEnrolleesControls.SchedulesView.selected(mEnrolleesControls.SchedulesListView.selected());
            $('#uDeleteScheduleButton').show();
            $('#uUnSelectAllScheduleButton').hide();
            $('#uSelectAllScheduleButton').show();
        } else {
            $('#uDeleteScheduleButton').hide();
            $('#uSelectAllScheduleButton').show();
        }
    }

}

function uScheduleType_OnChange(aSelect) {
    "use strict";
    //alert(aSelect.options[aSelect.selectedIndex].value);
    var lValue = aSelect.options[aSelect.selectedIndex].value;

    if(document.getElementById('uIsNoSchedule'))
      document.getElementById('uIsNoSchedule').checked = false;

    if (lValue === "true") {
        $('.OverrideSchedule').hide('fast', function () {
            $('.StandardSchedule').show();
            $('#uDayOfWeekHolder').addClass('ValidateCheckboxList');
        });
    } else {
        $('.StandardSchedule').hide('fast', function () {
            $('.OverrideSchedule').show();
            if (mEnrolleesControls.veritracksCalendar) {
                verifyOverrideDateMatches();
            }
            $('#uDayOfWeekHolder').removeClass('ValidateCheckboxList');
        });
    }
}

function uIsNoSchedule_OnClick(aCheckbox) {
    if ($.browser.msie) {
        aCheckbox.blur();
        aCheckbox.focus();
    }
}

function uIsNoSchedule_OnChange(aCheckbox) {
    "use strict";
    if (aCheckbox.checked) {
        $('.NotOverrideCancelSchedule').hide();
        $('.ScheduleTimespan').hide();
    } else {
        $('.NotOverrideCancelSchedule').show();
        $('.ScheduleTimespan').show();
    }
}

function offenderZonesWrite_OnComplete(aZone, aIsNew) {
    "use strict";
    var lCard = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItem();
    if (aZone.Id > 0) {
        mEnrolleesData.OffenderZoneEdit = null;
        mEnrolleesData.OffenderZoneShapeEdit = null;
        $('#uEditZoneButton').show();
        $('#uEnrolleeMapTimeFilter').change();
    }
}

function offenderEditZoneSaveButton_OnClick() {
    "use strict";
    var lCard = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItem();
    mEnrolleesData.OffenderZoneEdit.Radius = Math.round(mEnrolleesData.OffenderZoneEdit.Radius);
    mActivityNotification.addNotification(localizeWrapper('cZoneSaving') + mEnrolleesData.OffenderZoneEdit.Name);
    $('#uSaveZoneButton').hide();
    $('#uCancelZoneButton').hide();
    $('#uEditZoneButton').hide();
    veritracks.mapping.saveZone(mEnrolleesData.OffenderZoneEdit, lCard.Vertices, mEnrolleesData.OffenderZoneShapeEdit, offenderZonesWrite_OnComplete);
}

function offenderZoneMapShape_OnChange(aShape) {
    "use strict";
    if (mEnrolleesData.OffenderZoneEdit.Shape === 1) {
        mEnrolleesData.OffenderZoneEdit.CenterLatitude = aShape.center.lat();
        mEnrolleesData.OffenderZoneEdit.CenterLongitude = aShape.center.lng();
        mEnrolleesData.OffenderZoneEdit.Radius = sumo.geo.conversion.metersToFeet(aShape.radius);
    } else {
        var lCenter = aShape.getCenter();
        mEnrolleesData.OffenderZoneEdit.CenterLatitude = lCenter.lat();
        mEnrolleesData.OffenderZoneEdit.CenterLongitude = lCenter.lng();
    }
}

function offenderEditZoneButton_OnClick() {
    "use strict";
    var lCard = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItem();

    mEnrolleesData.OffenderZoneEdit = $.extend({}, lCard.TrackItem.data);
    if (lCard.TrackItem.radius <= mEnrolleesData.MaximumZoneRadius) {
        mEnrolleesData.OffenderZoneShapeEdit = veritracks.mapping.editZone(mEnrolleesControls.EnrolleesMap, 'Zones', lCard.TrackItem.data);
    } else {
        mEnrolleesData.OffenderZoneShapeEdit = veritracks.mapping.editZone(mEnrolleesControls.EnrolleesMap, 'LargeZones', lCard.TrackItem);
    }
    mEnrolleesControls.EnrolleesMap.setCenter(lCard.TrackItem.data.CenterLatitude, lCard.TrackItem.data.CenterLongitude);
    mEnrolleesControls.EnrolleesMap.zoom(16);
    $('#uSaveZoneButton').show();
    $('#uCancelZoneButton').show();
    $('#uEditZoneButton').hide();
}

function offenderEditZoneCancelButton_OnClick() {
    "use strict";
    var lCard = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItem();
    $('#uSaveZoneButton').hide();
    $('#uCancelZoneButton').hide();

    if (!isNullOrUndefined(mEnrolleesData.OffenderZoneShapeEdit)) {
        mEnrolleesData.OffenderZoneShapeEdit.setEditable(false);
        mEnrolleesData.OffenderZoneShapeEdit = null;
        mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.filter();
        mEnrolleesControls.EnrolleesMap.setCenter(lCard.TrackItem.data.CenterLatitude, lCard.TrackItem.data.CenterLongitude);
        mEnrolleesControls.EnrolleesMap.zoom(16);
        $('#uEditZoneButton').show();
    }
}

function offenderExpandVisitButton_OnClick() {
    "use strict";
    veritracks.enrollees.mapping.expandVisit();
}

function offenderCollapseVisitButton_OnClick() {
    "use strict";
    veritracks.enrollees.mapping.collapseVisits(true);
    $('#uCollapseVisitButton').hide();
}

function offenderMapAddTag_OnLocate(aType, aLocation) {
    "use strict";
    if (aType === 'LatLong') {
        if (aLocation !== null) {
            var l = '';
        }
    }
}

function offenderMapAddTagButton_OnClick() {
    "use strict";
    var lCenter = mEnrolleesControls.EnrolleesMap.getCenter(),
        lLatitude = lCenter.lat(),
        lLongitude = lCenter.lng(),
        lMarkerData = [],
        lMarker;

    lMarkerData.push({
        'latitude': lLatitude,
        'longitude': lLongitude,
        'anchor': { 'x': 12, 'y': 12 },
        'iconUri': 'Images/Maps/SuggestionDark.png',
        'doHover': false
    });
    populateEditView({ 'Latitude': lLatitude, 'Longitude': lLongitude }, [], {}, 'uMapTag', 'Edit');
    mEnrolleesControls.EnrolleesMap.layerSetDataSource('TagEdit', lMarkerData);
    $('.AddTagControls').show();
    $('.AssignTagControls').hide();
    $('#uMapAddTagButton').hide();
}

function offenderMapAddTagCancelButton_OnClick() {
    "use strict";
    mEnrolleesControls.EnrolleesMap.layerSetDataSource('TagEdit', []);
    $('.AddTagControls').hide();
    $('.AssignTagControls').show();
    $('#uMapAddTagButton').show();
}


function getVisitSuggestions(aId, aSuccessCallback, aFailCallback, aParams) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
     lSort = new SortExpression();

    lBuilder.AddNewExpressionConditional('PointGroupingId', aId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('UserId', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lSort.addAscendingColumn('ScoreBasis');
    ReadMultiple(gObjectList.VisitSuggestion.AssemblyQualifiedName, lBuilder.RootExpression, 0, aSuccessCallback, aFailCallback, aParams, lSort, 0);

}
function offenderMapAddTagSave_OnSuccess(aParams, aData) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lSort = new SortExpression(),
        lCard = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItem();
    getVisitSuggestions(lCard.TrackItem.data.Id, offenderVisitSuggestion_OnSuccess, Sad, mEnrolleesData.OffenderCurrentId);

    populateEditView({ 'Latitude': 0, 'Longitude': 0 }, [], {}, 'uMapTag', 'Edit');
    mEnrolleesControls.EnrolleesMap.layerSetDataSource('TagEdit', []);
    $('.AddTagControls').hide();
    $('.AssignTagControls').show();
    $('#uMapAddTagButton').show();
    offenderMapPopulate();
}

function offenderMapAddTagSaveButton_OnClick() {
    "use strict";
    var lTag = new Tag();
    populateFromEditView(lTag, 'uMapTag', 'Edit');

    if (lTag.Name !== '') {
        lTag.UserId = gUserDetails.UserId;
        WriteSingle(lTag, offenderMapAddTagSave_OnSuccess, Sad, {}, true);
    }
}

function offenderMapAssignTag_OnSuccess(aParams, aData) {
    "use strict";
    GetTag(aData.TagId, getTagSuccess, Sad)

    function getTagSuccess(aTagParams, aTag) {
        var lTag,
        lBuilder = new SumoPredicateBuilder(),
        lCardList,
        lVisitCard,
        lTagCard;

        if(aTag.length == 1){
            lTag = aTag[0];
        }
        lTagCard = veritracks.enrollees.mapping.generateTagCard(lTag);

        //updateTimelineSection(aData);
        lBuilder.AddNewExpressionConditional('TagId', aData.TagId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        if (aParams.IconClass.indexOf('Track1') !== -1) {
            lCardList = query(veritracks.enrollees.mapping.data.PrimaryCardList, lBuilder.RootExpression);
            if (lCardList.length === 0) {
                veritracks.enrollees.mapping.data.PrimaryCardList.push(lTagCard);
            }
        } else {
            lCardList = query(veritracks.enrollees.mapping.data.SecondaryCardList, lBuilder.RootExpression);
            if (lCardList.length === 0) {
                veritracks.enrollees.mapping.data.SecondaryCardList.push(lTagCard);
            }
        }

        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('Id', aParams.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        if (aParams.IconClass.indexOf('Track1') !== -1) {
            lCardList = query(veritracks.enrollees.mapping.data.PrimaryCardList, lBuilder.RootExpression);
        } else {
            lCardList = query(veritracks.enrollees.mapping.data.SecondaryCardList, lBuilder.RootExpression);
        }
        lVisitCard = lCardList[lCardList.length - 1];

        if (!isNullOrUndefined(lVisitCard)) {
            lVisitCard.Detail3 = 'Tag: ' + lTag.Name;
        }
        veritracks.enrollees.mapping.data.TagCardList[aData.Id] = lTagCard;
        mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.filter();
    }
}


function offenderMapAssignTagSaveTag_OnSuccess(aParams, aData) {
    "use strict";
    aParams.Link.TagId = aData.Id;
    aParams.Tag = aData;
    WriteSingle(aParams.Link, offenderMapAssignTag_OnSuccess, Sad, aParams.Card, true);
    //mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.filter();
}

function offenderMapAssignTagSaveTag_OnFailure(aParams, a, b, c) {
    "use strict";
}

function offenderMapAssignTagSaveButton_OnClick() {
    "use strict";
    var lLink = new TagVisitLink(),
        lSuggestion,
        lCard = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItem(),
        lSource = $('#uAssignTagSelect').autocomplete('option', 'source'),
        lBuilder = new SumoPredicateBuilder(),
        lText = $.trim($('#uAssignTagSelect').val()),
        lList,
        lTag;
    if (lText !== '') {
        if (mEnrolleesData.OffenderVisitTagId !== -1) {
            lLink.TagId = mEnrolleesData.OffenderVisitTagId;
            lLink.VisitId = lCard.TrackItem.data.Id;
            lBuilder.AddNewExpressionConditional('id', lLink.TagId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lSource = query(lSource, lBuilder.RootExpression);
            if (lSource.length > 0) {
                lLink.Name = lSource[lSource.length - 1].label;
            }
            WriteSingle(lLink, offenderMapAssignTag_OnSuccess, Sad, lCard, true);
        } else {
            lBuilder.AddNewExpressionConditional('value', lText, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lList = query(lSource, lBuilder.RootExpression);
            if (lList.length >= 1) {
                lSuggestion = lSource[lSource.length - 1];
                lLink.TagId = lSuggestion.id;
                lLink.VisitId = lCard.TrackItem.data.Id;
                lLink.Name = lSuggestion.label;
                WriteSingle(lLink, offenderMapAssignTag_OnSuccess, Sad, lCard, true);
            } else {
                lTag = new Tag();
                lTag.Name = lText;
                lTag.Latitude = lCard.Latitude;
                lTag.Longitude = lCard.Longitude;
                lTag.UserId = gUserDetails.UserId;

                lLink.VisitId = lCard.TrackItem.data.Id;
                lLink.Name = lText;
                WriteSingle(lTag, offenderMapAssignTagSaveTag_OnSuccess, offenderMapAssignTagSaveTag_OnFailure, { 'Link': lLink, 'Card': lCard }, true);
            }
        }
    }
}

function updateTimelineSection(aLink) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    lBuilder.AddNewExpressionConditional('PointGroupId', aLink.VisitId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.EnrolleeTimeline.AssemblyQualifiedName, lBuilder.RootExpression, 0, timelineLinkPair_onSuccess, Sad,
    {
        'TagId': aLink.TagId,
        'Name': aLink.Name
    },
    null, 0, true);

}

function updateTimelineSectionTag(aTag, aDelete) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    var lDelete = false;

    if (aDelete) {
        lDelete = aDelete;
    }
    lBuilder.AddNewExpressionConditional('LocationId', aTag.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.EnrolleeTimeline.AssemblyQualifiedName, lBuilder.RootExpression, 0, timelineLinkPair_onSuccess, Sad,
    {
        'TagId': aTag.Id,
        'Name': aTag.Name,
        'Delete': lDelete
    },
    null, 0, true);

}

function timelineLinkPair_onSuccess(aParams, aData) {
    "use strict";
    var lData = aData[0];
    var lAddress;

    if (lData) {
        if(['Home','Work','Other'].indexOf(lData.MatchType)!== -1){
            lAddress = mEnrolleesData.OffenderProfileAddresses[lData.locationId];
        }
        if (!lAddress || lData.MatchType == 'Visit Not Labeled') {
            if (aParams.Delete) {
                lData.MatchType = 'Visit Not Labeled';
                lData.Title = '';
                lData.LocationId = -1;
            } else {
                lData.MatchType = 'Labeled Visit';
                lData.Title = aParams.Name;
                lData.LocationId = aParams.TagId;
            }
        }

        WriteSingle(lData, null, null, null, false);
    }
}

function updateTimelineSectionAddress(aAddress, aInTimeline) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();

    lBuilder.AddNewExpressionConditional('LocationId', aAddress.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.EnrolleeTimeline.AssemblyQualifiedName, lBuilder.RootExpression, 0, timelineAddressUnPair_onSuccess, Sad, aInTimeline,
    null, 0, true);

}

function timelineAddressUnPair_onSuccess(aParams, aData) {
    "use strict";
    var lVisitIds = [];
    if (aData) {
        aData.map(function (aTimelineSection) {
            lVisitIds.push(aTimelineSection.PointGroupId);
        });

        if (lVisitIds.length > 0) {
            GetVisitTag(lVisitIds, UpdateTimelineSectionAddresses, [aData, aParams], true);
        }
    }
}

function UpdateTimelineSectionAddresses(aParams, aData) {
    "use strict";
    var lTimelineSection = aParams[0];
    var lCallback = null;

    if (aParams[1]) {
        lCallback = timelineUpdateEventAddress;
    }

    lTimelineSection.map(function (aTimelineSection) {
        var lKey;
        var lInProgress = '';

        if(aTimelineSection.MatchType.indexOf("In Progress")!== -1){
            lInProgress = ' In Progress';
        }

        aTimelineSection.MatchType = 'Visit Not Labeled';
        aTimelineSection.Title = '';
        aTimelineSection.LocationId = -1;

        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                if (aData[lKey].VisitId == aTimelineSection.PointGroupId) {
                        aTimelineSection.MatchType = "Labeled Visit";
                        aTimelineSection.Title = aData[lKey].Name;
                        aTimelineSection.LocationId = aData[lKey].TagId;
                }
            }
        }

        aTimelineSection += lInProgress;
    });

    WriteMultiple(lTimelineSection, lCallback, null, null, false);
}
function enrolleesOffenderLabelSaveButton_OnClick(aTagId) {
    "use strict";
    var lCard = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItemById('l' + aTagId);
    function success(aParams, aData) {
        //updateTimelineSectionTag(aData);
        $('#uEnrolleeMapTimeFilter').change();
        mEnrolleesControls.LabelEditValidator.dispose();
        mEnrolleesControls.LabelEditValidator = null;
        ClosePopup();
    }

    var lTag = lCard.TrackItem.data;

    if (mEnrolleesControls.LabelEditValidator.IsValid()) {
        lTag.Name = $('#uEnrolleesOffenderLabelEdit').val();
        lTag.UserId = gUserDetails.UserId;
        WriteSingle(lTag, success, null, null, true);
    }
}

function enrolleesOffenderLabelDeleteButton_OnClick(aTagId) {
    "use strict";
    var lCard = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItemById('l' + aTagId);

    function success(aParams, aData) {
       // updateTimelineSectionTag(aData, true);
        $('#uEnrolleeMapTimeFilter').change();
        mEnrolleesControls.LabelEditValidator.dispose();
        mEnrolleesControls.LabelEditValidator = null;
        ClosePopup();
    }

    var lTag = lCard.TrackItem.data;

    if (mEnrolleesControls.LabelEditValidator.IsValid()) {
        lTag.IsActive = false;
        lTag.UserId = gUserDetails.UserId;
        WriteSingle(lTag, success, null, null, true);
    }
}

function enrolleesOffenderLabelEdit(aTagId) {
    "use strict";
    var lCard = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItemById(aTagId),
        lTag = lCard.TrackItem.data,
        lButtonBar = GenerateButtonCommandBar(),
        lHtml = [];

    GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'enrolleesOffenderLabelSaveButton_OnClick(' + lTag.Id + ')').appendTo(lButtonBar);
    GenerateButton(localizeWrapper('cEnrolleeDelete'), 'Remove', 'enrolleesOffenderLabelDeleteButton_OnClick(' + lTag.Id + ')').appendTo(lButtonBar);

    lHtml.push('<h2>'+ localizeWrapper('cEnrolleeOffenderLabelName')+'</h2>');
    lHtml.push('<div id="uEnrolleesOffenderLabelHolder"><input id="uEnrolleesOffenderLabelEdit" type="text" name="uEnrolleesOffenderLabelEdit" style="" class="Validate ValidateRequired" value="' + lTag.Name + '" /></div>');

    DisplayPopup(localizeWrapper('cEnrolleeEditOffenderLabel'), lHtml.join(''), lButtonBar, false);
    mEnrolleesControls.LabelEditValidator = new Validator('uEnrolleesOffenderLabelHolder', mRegexValidation);
}

function offenderReadTrips_OnFailure(aParams, a, b, c) {
    "use strict";
}

function uTrackpointDetailCardViewFilter_OnFilter(aSender, aExpression, aData) {
    "use strict";
    var lDataSet = query(mEnrolleesData.OffenderMerged, aExpression),
        lTagList = [],
        lTagLabelList = [],
        lAddressesList = [],
        lZonesList = [],
        lTrackpointList = [],
        lAlcoholPointList = [],
        lSecondaryTrackPointList = [],
        lCardViewList = [],
        lLabelList = [],
        lPrimaryTrackpointList = [],
        lCardList = [],
        lMapBounds,
        lTrackItem,
        lIndexCounter = 0,
        lCard,
        lKey,
        lTagIdList = [],
        lTagVisitCards,
        lTagCards,
        lBuilder = new SumoPredicateBuilder(),
        lSort = new SortExpression();
    if (mEnrolleesData.OffenderMapRequestCount === 0) {
        if (lDataSet.length === 0) {
            if (mEnrolleesData.OffenderMerged.length > 0) {
                $('#uEnrolleesNoDataText').text('No track data available for current filter.');
            } else {
                $('#uEnrolleesNoDataText').text('No track data available.');
            }
            //$('.sumo-googlemap').hide();

            $('#uEnrolleesNoData').show();
            $('#uEnrolleesTrackPointLoadingBar').hide();
        } else {
            $('.sumo-googlemap').show();
            $('#uEnrolleesTrackPointLoadingBar').hide();
            $('#uEnrolleesNoData').hide();
        }
        $('#uEnrolleeTrackPointCount').show();
        // google maps workaround to ensure it fills the container
        $(window).resize();
        lBuilder.AddNewExpressionConditional('TagId', -1, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
        lTagVisitCards = query(lDataSet, lBuilder.RootExpression);
        lBuilder.Clear();
        for (lKey in lTagVisitCards) {
            if (lTagVisitCards.hasOwnProperty(lKey)) {
                lCard = lTagVisitCards[lKey];
                lTagIdList.push(lCard.TagId);
            }
        }
        if (lTagIdList.length > 0) {
            lBuilder.AddNewExpressionConditional('Type', 6, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('TagId', lTagIdList, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            lTagCards = query(mEnrolleesData.TagCardClean, lBuilder.RootExpression);

            if (!isNullOrUndefined($('#uTrackpointDetailCardViewFilterType6').attr('checked'))) { // NEEDS TO CHANGE ONLY TEMPORARY
                lDataSet = lDataSet.concat(lTagCards);
            }
        }

        lSort.addAscendingColumn('SortOrder');
        lSort.addDescendingColumn('SortDate');
        lSort.addAscendingColumn('Type');
        //lSort.addDescendingColumn('');
        lDataSet = lSort.sort(lDataSet);

        lIndexCounter = lDataSet.length;
        for (lKey in lDataSet) {
            if (lDataSet.hasOwnProperty(lKey)) {
                //lCard = $.extend({}, lDataSet[lKey]);
                lCard = lDataSet[lKey];
                lCard.DisplayName = lCard.Name + ' (' + lIndexCounter.toString() + ')';
                lCardViewList.push(lCard);
                lTrackItem = lCard.TrackItem;
                lCard.SVGMarker = TrackItem.SVGMarker;
                if (!isNullOrUndefined(lTrackItem)) {
                    switch (lCard.SortOrder) {
                        case 0:
                            lTagList.push(lTrackItem);
                            lTagLabelList.push(lTrackItem.data);
                            break;
                        case 1:
                            lAddressesList.push(lTrackItem);
                            lLabelList.push(lCard);
                            break;
                        case 2:
                            //if (lTrackItem.radius <= mEnrolleesData.MaximumZoneRadius) {
                            lZonesList.push(lTrackItem);
                            //}
                            break;
                        case 3:
                            if (lCard.EnrolleeId === mEnrolleesData.OffenderCurrentId) {
                                lPrimaryTrackpointList.push(lTrackItem);
                            } else {
                                lSecondaryTrackPointList.push(lTrackItem);
                            }
                            lTrackpointList.push(lTrackItem);
                            lCardList.push(lCard);
                            lLabelList.push(lCard);
                            break;
                        case 4:
                            lAlcoholPointList.push(lTrackItem);
                            break;
                    }
                }
            }
            --lIndexCounter;
        }
        lTrackpointList.reverse();
        if (!mEnrolleesData.IsOffenderMapFit && lTrackpointList.length > 0) {
            mEnrolleesData.IsOffenderMapFit = true;
            lMapBounds = mEnrolleesControls.EnrolleesMap.getBoundsFromArray(lTrackpointList);
            mEnrolleesControls.EnrolleesMap.fitBounds(lMapBounds);
        }
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Tags', lTagList);
        lTagLabelList = veritracks.mapping.prepareSuggestionLabelOverlayData(lTagLabelList);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('TagLabels', lTagLabelList);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Addresses', lAddressesList);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Zones', lZonesList);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('ZonesNames', veritracks.mapping.prepareEnrolleesZoneLabelOverlayData(lZonesList));
        lPrimaryTrackpointList.reverse();
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Visits', lPrimaryTrackpointList);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('SecondaryVisits', lSecondaryTrackPointList);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('ConnectedTracks', veritracks.mapping.prepareTripPointLineSegmentData(lPrimaryTrackpointList));
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('SecondaryConnectedTracks', veritracks.mapping.prepareTripPointLineSegmentData(lSecondaryTrackPointList));
        mEnrolleesData.OffenderMapCardRendered = lCardViewList;
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Labels', veritracks.mapping.prepareTrackpointDetailCardLabelOverlayData(lLabelList));
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('AlchoholTestPoints', lAlcoholPointList);
        mEnrolleesControls.OffenderTrackpointDetailCardView.setDataSource(lCardViewList);
        writeUserPreferences(aSender.FilterState);
    }

}

function offenderMapDisplayAllPoints_FitBounds() {
    //    "use strict";
  
}

function offenderMapDisplayAllPoints(aFitBounds) {
    "use strict";
    var lSort = new SortExpression();

    lSort.addAscendingColumn('SortOrder');
    lSort.addDescendingColumn('SortDate');

    if (!isNullOrUndefined(mEnrolleesControls.OffenderTrackpointDetailCardView) && aFitBounds) {
        mEnrolleesControls.OffenderTrackpointDetailCardView.bind('databind', offenderMapDisplayAllPoints_FitBounds);
    }
    if (!isNullOrUndefined(mEnrolleesData.OffenderSecondaryMapCardDirty) && mEnrolleesData.OffenderCurrentId !== mEnrolleesData.OffenderSecondaryCurrentId) {
        mEnrolleesData.OffenderMerged = mEnrolleesData.OffenderMapCardDirty.concat(mEnrolleesData.OffenderSecondaryMapCardDirty);
    } else {
        mEnrolleesData.OffenderMerged = mEnrolleesData.OffenderMapCardDirty;
    }
    mEnrolleesData.OffenderMerged = lSort.sort(mEnrolleesData.OffenderMerged);
    //[DEBUG]
    if (!isNullOrUndefined(mEnrolleesControls.OffenderTrackpointDetailCardViewFilter)) {
        //mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.filter();
    }
}

function offenderMapPopulate_ValidateComplete() {
    "use strict";
    if (--mEnrolleesData.OffenderMapRequestCount === 0) {
        offenderMapDisplayAllPoints(true);
        alert('all requests complete.');
    } else {
        alert(mEnrolleesData.OffenderMapRequestCount.toString() + ' remaining requests.');
    }
}

function offenderMapPopulate_GetAddressesSuccess(aParams, aAddressList) {
    "use strict";
    var lCard = new MapCard(),
        lAddress,
        lTrackItem,
        lKey;

    if (mEnrolleesData.RequestId === aParams.RequestId) {
        for (lKey in aAddressList) {
            if (aAddressList.hasOwnProperty(lKey)) {
                lAddress = aAddressList[lKey];
                //lTrackItem = veritracks.mapping.prepareAddressItem(lAddress);
                lTrackItem = veritracks.mapping.prepareAddressItem(lAddress, aParams.EnrolleePosition);
                mEnrolleesData.OffenderMapOverlayClean.push(lTrackItem);

                if (!isNullOrUndefined(lTrackItem)) {
                    lCard = new MapCard();
                    lCard.Id = 'a' + lTrackItem.data.Data.Id;
                    lCard.Type = 1;
                    lCard.GsmSignalStrength = -1;
                    lCard.SortOrder = 1;
                    lCard.TrackItem = lTrackItem;
                    lCard.Name = lAddress.Title;
                    lCard.Latitude = lAddress.Latitude;
                    lCard.Longitude = lAddress.Longitude;
                    lCard.SVGMarker = lTrackItem.SVGMarker;
                    //switch (lAddress.AddressTypeId) {
                    //    case 1:
                    //        lCard.IconClass = 'MapHome';
                    //        break;
                    //    case 2:
                    //        lCard.IconClass = 'MapWork';
                    //        break;
                    //    case 3:
                    //        lCard.IconClass = 'MapOther';
                    //        break;
                    //}
                    lCard.IconClass = 'Track' + lTrackItem.cardViewClass;
                    lCard.Date = lCard.SortDate;
                    lCard.Detail = lAddress.Street1;
                    lCard.Address = lAddress.Street1;
                    if (lAddress.Street2 !== '') {
                        lCard.Detail2 = lAddress.Street2;
                        lCard.Address += ' ' + lAddress.Street2;
                    }
                    lCard.Detail3 = lAddress.City + ', ' + lAddress.State + ' ' + lAddress.Zip.toString();
                    lCard.Address += ' ' + lCard.Detail3;
                    if (aParams.EnrolleePosition === 1) {
                        mEnrolleesData.OffenderMapCardClean.push(lCard);
                    } else {
                        mEnrolleesData.OffenderSecondaryMapCardClean.push(lCard);
                    }
                    //mEnrolleesData.OffenderMapCardClean.push(lCard);
                }
            }
        }
        //mEnrolleesData.OffenderMapCardDirty = mEnrolleesData.OffenderMapCardClean.slice(0);
        //mEnrolleesData.OffenderMapOverlayDirty = mEnrolleesData.OffenderMapOverlayClean.slice(0);

        mEnrolleesData.OffenderMapOverlayDirty = copyArray(mEnrolleesData.OffenderMapOverlayClean);
        mEnrolleesData.OffenderMapCardDirty = copyArray(mEnrolleesData.OffenderMapCardClean);

        offenderMapPopulate_ValidateComplete();
    }
    else {
        offenderMapPopulate_ValidateComplete();
    }
}

function offenderMapPopulate_GetAddresses(aEnrolleeId, aRequestId, aRequestCount, aEnrolleePosition) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();

    function onFailure(aParams, a, b, c) {
        mActivityNotification.addNotification(localizeWrapper('cEnrolleeAdressReadFailed') + b);
    }

    lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.EnrolleeAddress.AssemblyQualifiedName, lBuilder.RootExpression, 0, offenderMapPopulate_GetAddressesSuccess, onFailure, { 'RequestId': aRequestId, 'RequestCount': aRequestCount, 'EnrolleePosition': aEnrolleePosition }, null, 20);
}

function offenderMapPopulate_GetZonesSuccess(aParams, aData, aVertices) {
    "use strict";
    var lZones = getDataItems('Zones'),
        lCard = new MapCard(),
        lVertexList = {},
        lTrackItem,
        lIndex,
        lZoneId,
        lZone,
        lBuilder = new SumoPredicateBuilder(),
        lEnrollees = getDataItems('Enrollees'),
        lEnrolleeName,
        lCurrentEnrollee = lEnrollees[aParams.EnrolleeId],
        lEnrollee,
        lItem,
        lKey;

    //lBuilder.AddNewExpressionConditional('Id', aParams.EnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    //lEnrollee = query(lEnrollees, lBuilder.RootExpression);
    lEnrolleeName = lEnrollees[aParams.EnrolleeId].FullName;
    //lBuilder.Clear();
    if (mEnrolleesData.RequestId === aParams.RequestId) {
        //for (lIndex = 0; lIndex < aData.length; lIndex++) {
        //    lTrackItem = aData[lIndex];
        //    if (isNullOrUndefined(lVertexList[lTrackItem.ZoneId])) {
        //        lVertexList[lTrackItem.ZoneId] = [];
        //    }
        //    lVertexList[lTrackItem.ZoneId].push(lTrackItem);
        //}
        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lTrackItem = aData[lKey];
                lZone = lTrackItem.data;
                //for (lIndex = 0; lIndex < aParams.ZoneIds.length; lIndex++) {
                //    lZoneId = aParams.ZoneIds[lIndex];
                //    lZone = $.extend({}, lZones[lZoneId]);
                //    lZone.vertices = lVertexList[lZoneId];
                //    lTrackItem = veritracks.mapping.prepareZoneItem(lZone);

                lCard = new MapCard();
                lCard.Id = 'z' + lZone.Id;
                lCard.Type = 2;
                lCard.SortOrder = 2;
                lCard.TrackItem = lTrackItem;
                lCard.EnrolleeId = aParams.EnrolleeId;
                lCard.EnrolleeName = lEnrolleeName;
                lCard.EnrolleeFirstName = lCurrentEnrollee.FirstName;
                lCard.EnrolleeLastName = lCurrentEnrollee.LastName;
                lCard.Name = lZone.Name;
                lCard.GsmSignalStrength = -1;
                lCard.IconClass = 'Zone';
                lCard.Latitude = lZone.CenterLatitude;
                lCard.Longitude = lZone.CenterLongitude;
                //lCard.SVGMarker = lTrackItem.SVGMarker;
                if (!isNullOrUndefined(aVertices[lZone.Id])) {
                    lCard.Vertices = aVertices[lZone.Id];
                }
                lCard.Date = lCard.SortDate;
                lCard.Detail = lZone.Description;
                lCard.Address = '- no address available -';
                if (lZone.Radius > 1000) {
                    lCard.isMapped = false;
                }
                lCard.ZoneRadius = lZone.Radius;
                lCard.ExtendedDetail = veritracks.mapping.generateCardDetailProperty('Type', zoneTypeFormatter(lZone.Type)) + veritracks.mapping.generateCardDetailProperty('Scope', zoneScopeFormatter(lZone.Scope));
                if (aParams.EnrolleePosition === 1) {
                    mEnrolleesData.OffenderMapCardClean.push(lCard);
                } else {
                    mEnrolleesData.OffenderSecondaryMapCardClean.push(lCard);
                }
                //}
            }
        }

        mEnrolleesData.OffenderMapOverlayDirty = copyArray(mEnrolleesData.OffenderMapOverlayClean);
        mEnrolleesData.OffenderMapCardDirty = copyArray(mEnrolleesData.OffenderMapCardClean);

        offenderMapPopulate_ValidateComplete();
    } else {
        offenderMapPopulate_ValidateComplete();
    }
}

function offenderMapPopulate_GetZones(aEnrolleeId, aRequestId, aRequestCount, aEnrolleePosition) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lSchedules = mEnrolleesData.OffenderSchedules,
        lSort = new SortExpression(),
        lZoneIds = [],
        lZones = [],
        lSchedule,
        lZone,
        lKey;

    lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('ScheduleType', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsAbsenceSched', getCarveOutPreference(), false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lSchedules = query(lSchedules, lBuilder.RootExpression);
    for (lKey in lSchedules) {
        if (lSchedules.hasOwnProperty(lKey)) {
            lSchedule = lSchedules[lKey];
            if (lZoneIds.indexOf(lSchedule.EntityId) === -1) {
                lZoneIds.push(lSchedule.EntityId);
                lZones.push(getDataItem(lSchedule.EntityId, 'Zones'));
            }
        }
    }
    veritracks.mapping.renderZones(mEnrolleesControls.EnrolleesMap, 'Zones', lZones, offenderMapPopulate_GetZonesSuccess, { 'RequestId': aRequestId, 'RequestCount': aRequestCount, 'ZoneIds': lZoneIds, 'EnrolleePosition': aEnrolleePosition, 'EnrolleeId': aEnrolleeId });
}

function uTrackpointDetailCardView_OnSelectChanging(aSender, aCardIndex, aData) {
    "use strict";
    var lCard = aSender.selectedDataItem();
    if (!isNullOrUndefined(lCard) && aCardIndex.Current !== aCardIndex.New) {
        lCard.IsExpanded = false;
    }
}

function offenderVisitSuggestion_OnSuccess(aParams, aData) {
    "use strict";
    var lKey,
        lItem,
        lTrackItem,
        //lSuggestionPoints = [],
        lSuggestionList = [];

    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lItem = aData[lKey];
            lSuggestionList.push({ 'label': lItem.Name, 'value': lItem.Name, 'id': lItem.TagId });
            //lSuggestionPoints.push(veritracks.mapping.prepareTrackpointMarkerItem(lItem));
        }
    }
    $('#uAssignTagSelect').autocomplete('option', 'source', lSuggestionList);
    //$('.TagControls').show();
}

function uTrackpointDetailCardViewNoAddressUpdate(aCard) {
    "use strict";
    aCard.Address = 'No Address Found';
    $('#uTrackpointAddress' + aCard.Id).text(aCard.Address);
}

function uTrackpointDetailCardViewAddressUpdate(aCard, aAddress) {
    "use strict";
    aCard.Address = aAddress;
    $('#uTrackpointAddress' + aCard.Id).text(aCard.Address).attr('title', aCard.Address);
    aCard.IsGeocoded = true;
}

function uTrackpointDetailCardView_OnGeocode(aResult, aStatus) {
    "use strict";
    var lAddress,
        lCard;
    if (aStatus === 'OK') {
        lAddress = aResult;
        lCard = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItem();
        uTrackpointDetailCardViewAddressUpdate(lCard, lAddress.formated_address);
    } else {
        uTrackpointDetailCardViewNoAddressUpdate(lCard);
    }
}

function enrolleesVisitAddressRead_OnSuccess(aParams, aData) {
    "use strict";
    var lAddress;
    if (aData.length > 0) {
        lAddress = aData[0];
        uTrackpointDetailCardViewAddressUpdate(aParams.Card, lAddress.Description);
    } else {
        uTrackpointDetailCardViewNoAddressUpdate(aParams.Card);
    }
}

function enrolleesVisitAddressRead_OnFailure(aParams, a, b, c) {
    "use strict";
    uTrackpointDetailCardViewNoAddressUpdate(aParams.Card);
}

function uTrackpointDetailCardView_OnSelectChange(aSender, aCardIndex, aData) {
    "use strict";
    //TODO: If aCardIndex is Null means "CardView has been unselected"
    // If aCardIndex contains a value it means a CarvView has been selected. 
    var lCard = aSender.selectedDataItem(),
        lBuilder = new SumoPredicateBuilder(),
        lEnrollee = mEnrolleesControls.CardView.selectedDataItem(),
        lIsInformatics = false,       
        lSort = new SortExpression(),
        lTrackItem,
        lFilename,
        lPreviousZoom;
    if (!isNullOrUndefined(lEnrollee)) {
        lIsInformatics = getInformaticsEnabled(lEnrollee.Enrollee.OrganizationId);
    }
     var j = aSender.selected();

            if (lEnrollee.Enrollee.EnrolleeType == 1) {
    offenderEditZoneCancelButton_OnClick();
    offenderMapAddTagCancelButton_OnClick();
            }
    mEnrolleesControls.EnrolleesMap.clearStreetView();
    if (!isNullOrUndefined(lCard)) {
        if (isNullOrUndefined(aSender.getPreviousSelectedKey())) {
            lPreviousZoom = mEnrolleesControls.EnrolleesMap.getZoom();
            veritracks.enrollees.mapping.PreviousZoom(lPreviousZoom);
        }
        veritracks.enrollees.mapping.CurrentCardType(lCard.Type);
        $('#uSaveZoneButton').hide();
        $('#uCancelZoneButton').hide();
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('LargeZones', []);
        switch (lCard.Type) {
            case 1: // address
            case 4: // visit point
            case 5: // trip point
                $('#uExpandVisitButton').hide();
                $('#uCollapseVisitButton').hide();
                $('.TagControls').hide();
                $('#uEditZoneButton').hide();
                if (!lCard.IsGeocoded) {
                    mEnrolleesControls.EnrolleesMap.geocode(lCard.Latitude.toString() + ', ' + lCard.Longitude.toString(), veritracks.enrollees.mapping.onGeocode, lCard);
                }
                break;
                //case 5: // trip point
                //    $('#uExpandVisitButton').hide();
                //    $('#uCollapseVisitButton').hide();
                //    $('.TagControls').hide();
                //    $('#uEditZoneButton').hide();
                //    if (!lCard.IsGeocoded) {
                //        mEnrolleesControls.EnrolleesMap.geocode(lCard.Latitude.toString() + ', ' + lCard.Longitude.toString(), veritracks.enrollees.mapping.onGeocode, lCard);
                //    }
                //    break;
            case 2: // zone
                $('#foo').bind('click', function () {
                    alert('User clicked on "foo."');
                });
                $('#uExpandVisitButton').hide();
                $('#uCollapseVisitButton').hide();
                $('.TagControls').hide();
                $('#uEditZoneButton').show();
                if (lCard.TrackItem.radius > mEnrolleesData.MaximumZoneRadius) {
                    mEnrolleesControls.EnrolleesMap.layerSetDataSource('LargeZones', [lCard.TrackItem]);
                }
                break;
            case 3:  // visit
                if (lCard.IsExpanded === true) {
                    $('#uExpandVisitButton').hide();
                    $('#uCollapseVisitButton').show();
                } else {
                    $('#uExpandVisitButton').show();
                    $('#uCollapseVisitButton').hide();
                }

                $('#uAssignTagSelect').val(lCard.TagName);
                mEnrolleesData.OffenderVisitTagId = lCard.TagId;
                //$('.TagControls').hide();

                getVisitSuggestions(lCard.TrackItem.data.Id, offenderVisitSuggestion_OnSuccess, Sad, mEnrolleesData.OffenderCurrentId);

                if (!lCard.IsGeocoded && lCard.TrackItem.data.AddressId !== -1) {
                    lBuilder.Clear();
                    lBuilder.AddNewExpressionConditional('Id', lCard.TrackItem.data.AddressId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                    ReadMultiple(gObjectList.Address.AssemblyQualifiedName, lBuilder.RootExpression, 0, enrolleesVisitAddressRead_OnSuccess, enrolleesVisitAddressRead_OnFailure, { 'Card': lCard }, null, 0);
                }

                //offenderVisitSuggestion_OnSuccess(null, []);
                //$('.TagControls').show();
                $('#uEditZoneButton').hide();

                if (lCard.DisplayName.indexOf("In Progress") !== -1) {
                    $('.TagControls').hide();
                } else {

                    $('.TagControls').show();
                }
                if (!lCard.IsGeocoded && !lCard.TrackItem.data.IsCurrent) {
                    mEnrolleesControls.EnrolleesMap.geocode(lCard.Latitude.toString() + ', ' + lCard.Longitude.toString(), veritracks.enrollees.mapping.onGeocode, lCard);
                }
                break;
            case 99:  // visit
                if (lCard.IsExpanded === true) {
                    $('#uExpandVisitButton').hide();
                    $('#uCollapseVisitButton').show();
                } else {
                    $('#uExpandVisitButton').show();
                    $('#uCollapseVisitButton').hide();
                }

                $('#uAssignTagSelect').val(lCard.TagName);
                mEnrolleesData.OffenderVisitTagId = lCard.TagId;
                //$('.TagControls').hide();

                getVisitSuggestions(lCard.TrackItem.data.Id, offenderVisitSuggestion_OnSuccess, Sad, mEnrolleesData.OffenderCurrentId);
                
                if (!lCard.IsGeocoded && lCard.TrackItem.data.AddressId !== -1) {
                    lBuilder.Clear();
                    lBuilder.AddNewExpressionConditional('Id', lCard.TrackItem.data.AddressId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                    ReadMultiple(gObjectList.Address.AssemblyQualifiedName, lBuilder.RootExpression, 0, enrolleesVisitAddressRead_OnSuccess, enrolleesVisitAddressRead_OnFailure, { 'Card': lCard }, null, 0);
                }

                //offenderVisitSuggestion_OnSuccess(null, []);
                //$('.TagControls').show();
                $('#uEditZoneButton').hide();

                if (lCard.DisplayName.indexOf("In Progress") !== -1) {
                    $('.TagControls').hide();
                } else {

                    $('.TagControls').show();
                }
                if (!lCard.IsGeocoded && !lCard.TrackItem.data.IsCurrent) {
                    mEnrolleesControls.EnrolleesMap.geocode(lCard.Latitude.toString() + ', ' + lCard.Longitude.toString(), veritracks.enrollees.mapping.onGeocode, lCard);
                }
                break;
            case 6: // tag
                if (!lCard.IsGeocoded) {
                    mEnrolleesControls.EnrolleesMap.geocode(lCard.Latitude.toString() + ', ' + lCard.Longitude.toString(), veritracks.enrollees.mapping.onGeocode, lCard);
                }
                break;
            case 21: //sobertrack
                uQuickReviewAlcoholMonitoring(lCard.TrackItem.data.Data);
                if (!lCard.IsGeocoded) {
                    mEnrolleesControls.EnrolleesMap.geocode(lCard.Latitude.toString() + ', ' + lCard.Longitude.toString(), veritracks.enrollees.mapping.onGeocode, lCard);
                }
				break;
			case 8: //cell
				if (!lCard.IsGeocoded) {
					mEnrolleesControls.EnrolleesMap.geocode(lCard.Latitude.toString() + ', ' + lCard.Longitude.toString(), veritracks.enrollees.mapping.onGeocode, lCard);
				}
				break;
			case 9: //wifi
				if (!lCard.IsGeocoded) {
					mEnrolleesControls.EnrolleesMap.geocode(lCard.Latitude.toString() + ', ' + lCard.Longitude.toString(), veritracks.enrollees.mapping.onGeocode, lCard);
				}
				break;
            case 31: //EMA Check-in
                if (!lCard.IsGeocoded) {
                    mEnrolleesControls.EnrolleesMap.geocode(lCard.Latitude.toString() + ', ' + lCard.Longitude.toString(), veritracks.enrollees.mapping.onGeocode, lCard);
                }
                break;
            case 61: //EMA Check-in
                if (!lCard.IsGeocoded) {
                    mEnrolleesControls.EnrolleesMap.geocode(lCard.Latitude.toString() + ', ' + lCard.Longitude.toString(), veritracks.enrollees.mapping.onGeocode, lCard);
                }
                break;
        }
        if (!isNullOrUndefined(lCard.TrackItem.type)) {
            mEnrolleesControls.EnrolleesMap.locate(lCard.TrackItem.centerLatitude.toString() + ', ' + lCard.TrackItem.centerLongitude.toString(), null);
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('Selected', []);
        } else {
            mEnrolleesControls.EnrolleesMap.locate(lCard.TrackItem.latitude.toString() + ', ' + lCard.TrackItem.longitude.toString(), null);
            lTrackItem = $.extend({}, lCard.TrackItem);
            if (lIsInformatics) {
                // lFilename = lTrackItem.iconUri.substring(0, lTrackItem.iconUri.length - 1) + 'Selected.png';

                veritracks.mapping.iconGenerator.clear();    
                var IconId = IconHelper.getIconIdByName('TrackPoint Selected');
                if (!isNullOrUndefined(mEnrolleesIcon['icons'][IconId]['IconValue'])) {                    
                    var lMappedIconId = -1;
                    //objects need to be more consistent
                    if (!isNullOrUndefined(lTrackItem.data.Data)) {
                        lMappedIconId = lTrackItem.data.Data.IconId;
                    } else {
                        lMappedIconId = lTrackItem.data.IconId;
                    }                    
                   
                    //need a better way of centering the selected icon. the main issue here is the alcohol icons 
                    if ([141, 151, 161, 171, 181, 191].indexOf(lMappedIconId) != -1) {
                        veritracks.mapping.iconGenerator.addSVGToQueue({ "IconGroup": "Shape", "Shape": "Circle", "Width": lTrackItem.ScaledImageSize.width + (lTrackItem.ScaledImageSize.width * -.40), "Height": lTrackItem.ScaledImageSize.height + (lTrackItem.ScaledImageSize.height * -.40), "Stroke": { color: '#67EDF4', width: 3 } });
                        veritracks.mapping.iconGenerator.drawSVG();
                        lFilename = veritracks.mapping.iconGenerator.generateMapMarker(veritracks.mapping.iconGenerator.getSvg());
                        veritracks.mapping.iconGenerator.clear();
                    } else {
                        lFilename = veritracks.mapping.iconGenerator.generateMapMarker(mEnrolleesIcon.icons[IconId]['IconValue']);
                    }                   
                }
            } else {
                lFilename = lTrackItem.iconUri.substring(0, lTrackItem.iconUri.length - 4) + 'Selected.png';
            }
            
            lTrackItem.iconUri = lFilename;
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('Selected', [lTrackItem]);
        }

    } else {
        $('#uSaveZoneButton').hide();
        $('#uCancelZoneButton').hide();
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('LargeZones', []);
        $('#uExpandVisitButton').hide();
        $('#uCollapseVisitButton').hide();
        $('.TagControls').hide();
        $('#uEditZoneButton').hide();
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Selected', []);
    }



}


function offenderReadTagVisitLink_OnSuccess(aParams, aData) {
    "use strict";
}

function offenderReadTripsVisits_OnSuccess(aParams, aData) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lCard = new MapCard(),
        lNow = new Date(),
        lSort = new SortExpression(),
        lTrackpointList,
        lTripVisitList,
        lTrackpoint,
        lTrackItem,
        lVisitCardList = {},
        lVisitIdList = [],
        //lTrackpointCountList = [],
        //lHtml = [],
        lTPKey,
        lItem,
        lEnrollees = getDataItems('Enrollees'),
        lKey,
        lCountKey,
        lEnrolleeName,
        lEnrollee,
        lTrackPointCount,
        lPrimaryEnrollee,
        lTagIdList = [],
        lTrackPointCount = 0,
        lCurrentEnrollee,
        lVisitCount = 0,
        lPreferences = getUserPreferences(4),
        lPreference,
        lTrackTypeValue;

    function onFailure(aParams, a, b, c) {
        mActivityNotification.addNotification(localizeWrapper('cEnrolleeVisitLabelReadFailed') + b);
    }
    lBuilder.AddNewExpressionConditional('Id', aParams.OffenderId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lEnrollee = query(lEnrollees, lBuilder.RootExpression);
    lEnrolleeName = lEnrollee[aParams.OffenderId].FullName;
    lCurrentEnrollee = lEnrollee[aParams.OffenderId];
    lBuilder.Clear();
    if (mEnrolleesData.RequestId === aParams.RequestId) {
        FixDates(aData);
        lSort.addDescendingColumn('StartDate');
        lTripVisitList = lSort.sort(aData);
        for (lKey in lTripVisitList) {
            if (lTripVisitList.hasOwnProperty(lKey)) {
                lItem = lTripVisitList[lKey];
                if (lItem.Latitude !== 0 && lItem.Longitude !== 0) {
                    if (lItem.EndDate > lNow) {
                        lTrackItem = veritracks.mapping.prepareVisitItem(lItem, aParams.EnrolleePosition);
                        mEnrolleesData.OffenderMapOverlayClean.push(lTrackItem);
                        ++lVisitCount;
                        lCard = new MapCard();
                        lCard.Id = 'v-' + aParams.EnrolleePosition.toString();
                        lCard.Type = 3;
                        lCard.SortOrder = 3;
                        lCard.TrackItem = lTrackItem;
                        lCard.EnrolleeId = aParams.OffenderId;
                        lCard.EnrolleeName = lEnrolleeName;
                        lCard.EnrolleeFirstName = lCurrentEnrollee.FirstName;
                        lCard.EnrolleeLastName = lCurrentEnrollee.LastName;
                        lCard.Name = 'In Progress';
                        //lCard.IconClass = 'VisitInProgress';
                        lCard.IconClass = 'Track' + lTrackItem.cardViewClass;
                        lCard.Date = lItem.StartDate;
                        lCard.SortDate = lItem.EndDate;
                        lCard.GsmSignalStrength = -1;
                        lCard.Latitude = lItem.Latitude;
                        lCard.Longitude = lItem.Longitude;
                        lCard.Detail = 'Start: ' + DisplayShortDateTime(lItem.StartDate);
                        lCard.ExtendedDetail = veritracks.mapping.generateCardDetailProperty('Trackpoint Count1', lItem.TrackPointCount);
                        lTrackPointCount += lItem.TrackPointCount;
                        lCard.SVGMarker = lTrackItem.SVGMarker;
                        //mEnrolleesData.OffenderMapCardClean.push(lCard);
                        if (aParams.EnrolleePosition === 1) {
                            mEnrolleesData.OffenderMapCardClean.push(lCard);
                        } else {
                            mEnrolleesData.OffenderSecondaryMapCardClean.push(lCard);
                        }
                    } else {
                        switch (lItem.Type) {
                            case 1:
                                lSort = new SortExpression();
                                lSort.addDescendingColumn('TrackDate');
                                lTrackpointList = lItem.Trackpoints;
                                lTrackpointList = lSort.sort(lTrackpointList);
                                FixDates(lTrackpointList);
                                for (lTPKey in lTrackpointList) {
                                    if (lTrackpointList.hasOwnProperty(lTPKey)) {
                                        lTrackpoint = lTrackpointList[lTPKey];
                                        lTrackItem = veritracks.mapping.prepareTrackpointMarkerItem(lTrackpoint, aParams.EnrolleePosition);
                                        mEnrolleesData.OffenderMapOverlayClean.push(lTrackItem);


                                        lCard = new MapCard();
                                        lCard.Id = 't' + lTrackpoint.Id;
                                        lCard.Type = 5;
                                        lCard.SortOrder = 3;
                                        lCard.TrackItem = lTrackItem;
                                        lCard.EnrolleeId = aParams.OffenderId;
                                        lCard.EnrolleeName = lEnrolleeName;
                                        lCard.Name = 'Trackpoint';
                                        lCard.SVGMarker = lTrackItem.SVGMarker;
                                        lCard.GsmSignalStrength = Math.floor(lTrackpoint.GsmSignal / 6);
                                        if (lCard.GsmSignalStrength === 5) {
                                            lCard.GsmSignalStrength = 4;
                                        } else if (lCard.GsmSignalStrength === 4) {
                                            lCard.GsmSignalStrength = 3;
                                        } else if (lCard.GsmSignalStrength === 3) {
                                            lCard.GsmSignalStrength = 2;
                                        } else if (lCard.GsmSignalStrength === 2) {
                                            lCard.GsmSignalStrength = 1;
                                        } else if (lCard.GsmSignalStrength === 1) {
                                            lCard.GsmSignalStrength = 0;
                                        }

                                        lCard.IconClass = 'Track' + lTrackItem.cardViewClass;
                                        lCard.Date = lTrackpoint.TrackDate;
                                        lCard.SortDate = lTrackpoint.TrackDate;
                                        switch (lTrackpoint.TrackTypeId) {
                                            case 1:
                                            case 2:
                                                lCard.Latitude = lTrackpoint.Latitude;
                                                lCard.Longitude = lTrackpoint.Longitude;
                                                break;
                                            case 3:
                                                lCard.Latitude = lTrackpoint.CellTowerLatitude;
                                                lCard.Longitude = lTrackpoint.CellTowerLongitude;
                                                break;
                                        }
                                        lCard.Detail = DisplayShortDateTime(lTrackpoint.TrackDate);
                                        lCard.InventoryBatteryClass = 'InventoryBattery' + lTrackpoint.BatteryLevel;
                                        lCard.InventorySignalClass = 'InventoryBattery' + lTrackpoint.BatteryLevel;
                                        lCard.GsmSignalStrengthClass = 'InventoryGsmSignal' + lCard.GsmSignalStrength;
                                        lCard.ExtendedDetail = veritracks.mapping.trackpointGenerateCardDetail(lTrackpoint);

                                        if (aParams.EnrolleePosition === 1) {
                                            mEnrolleesData.OffenderMapCardClean.push(lCard);
                                            ++lTrackPointCount;
                                        } else {
                                            mEnrolleesData.OffenderSecondaryMapCardClean.push(lCard);
                                        }
                                    }
                                }
                                break;
                            case 2:
                                lTrackItem = veritracks.mapping.prepareVisitItem(lItem, aParams.EnrolleePosition);
                                mEnrolleesData.OffenderMapOverlayClean.push(lTrackItem);
                                lCard = new MapCard();
                                lCard.Id = 'v' + lTrackItem.data.Id.toString() + lTrackItem.data.StartDate.getTime().toString();
                                lCard.Type = 3;
                                lCard.SortOrder = 3;
                                lCard.TrackItem = lTrackItem;
                                lCard.Name = localizeWrapper('cEnrolleesMappingVisit');
                                lCard.EnrolleeId = aParams.OffenderId;
                                lCard.EnrolleeName = lEnrolleeName;
                                lCard.IconClass = 'Track' + lTrackItem.cardViewClass;
                                lCard.GsmSignalStrength = -1;
                                lCard.Date = lItem.StartDate;
                                lCard.SortDate = lItem.EndDate;
                                lCard.Latitude = lItem.Latitude;
                                lCard.Longitude = lItem.Longitude;
                                lCard.SVGMarker = lTrackItem.SVGMarker;
                                lCard.Detail = localizeWrapper('cEnrolleesMappingStart') + ' ' + DisplayShortDateTime(lItem.StartDate);
                                lCard.Detail2 = localizeWrapper('cEnrolleesMappingEnd') + ' ' + DisplayShortDateTime(lItem.EndDate);
                                lCard.ExtendedDetail = veritracks.mapping.generateCardDetailProperty('Trackpoint Count', lItem.TrackPointCount);
                                if (aParams.EnrolleePosition === 1) {
                                    mEnrolleesData.OffenderMapCardClean.push(lCard);
                                } else {
                                    mEnrolleesData.OffenderSecondaryMapCardClean.push(lCard);
                                }
                                lVisitCardList[lTrackItem.data.Id] = lCard;
                                ++lVisitCount;
                                lTrackPointCount += lItem.TrackPointCount;
                                lVisitIdList.push(lTrackItem.data.Id);
                                break;
                        }
                    }
                }
            }
        }
        if (aParams.EnrolleePosition === 1) {
            lPrimaryEnrollee = lEnrollee[mEnrolleesData.OffenderCurrentId];

            lPreference = lPreferences['TrackType'];

            if (!isNullOrUndefined(lPreference)) {
                lTrackTypeValue = parseInt(lPreference.Value, 10);
            }

            if (lTrackTypeValue === 1) {
                if (!isNullOrUndefined(lPrimaryEnrollee)) {
                    if (lVisitCount === 1) {
                        $('#uEnrolleeTrackPointCount').html(lPrimaryEnrollee.FullName + ': ' + lTrackPointCount + 'GPS Points, ' + lVisitCount + ' Visit');
                    } else {
                        $('#uEnrolleeTrackPointCount').html(lPrimaryEnrollee.FullName + ': ' + lTrackPointCount + 'GPS Points, ' + lVisitCount + ' Visits');

                    }
                }
            } else {
                $('#uEnrolleeTrackPointCount').html(lPrimaryEnrollee.FullName + ': ' + lTrackPointCount + ' Points');

            }

            mEnrolleesData.OffenderMapOverlayDirty = copyArray(mEnrolleesData.OffenderMapOverlayClean);
            mEnrolleesData.OffenderMapCardDirty = copyArray(mEnrolleesData.OffenderMapCardClean);
        } else {
            mEnrolleesData.OffenderSecondaryMapOverlayDirty = copyArray(mEnrolleesData.OffenderSecondaryMapOverlayClean);
            mEnrolleesData.OffenderSecondaryMapCardDirty = copyArray(mEnrolleesData.OffenderSecondaryMapCardClean);
        }
        if (lVisitIdList.length > 0) {
            lBuilder.AddNewExpressionConditional('VisitId', lVisitIdList, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            ReadMultiple(gObjectList.TagVisitLink.AssemblyQualifiedName, lBuilder.RootExpression, 0, offenderReadTagVisitLink_OnSuccess, onFailure, { 'RequestId': aParams.RequestId, 'Items': lVisitCardList, 'DoFitBounds': true }, null, 0);
        } else {
            offenderMapPopulate_ValidateComplete();
        }
    } else {
        offenderMapPopulate_ValidateComplete();
    }
}


/****artf66560*****************/
/******************************/
function enrolleeMapEventsPopup_Onclick(aCardId) {
    "use strict";
    var lButtonBar = GenerateButtonCommandBar();
    var lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees');
    var lTitle = '';

    lTitle = localizeWrapper('cEnrolleeMapEvents') + ' - ' + lEnrollee.FullName + ' (' + lEnrollee.PrimaryId + ')';

    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', 'CloseMapEventsDataPopup()'));
    DisplayPopup(lTitle, '<div id="uEnrolleeMapEventsPopupHolder"></div>', lButtonBar, false, false);

    //// calls main timeline popup that will hold tabs --- go to timelinePopulate_Init
    populateElement('uEnrolleeMapEventsPopupHolder', 'Enrollees.Offenders.Map.Events.Popup.Layout.htm', populateMapEventsElements);
    $('.Popup2').addClass('MapEventsDetailsWidth');
}

function CloseMapEventsDataPopup() {
    "use strict";
    mEnrolleesControls.MapEventsListView = null;
    ClosePopup();
}

function populateMapEventsElements() {
    "use strict";
    var lContentHtml = [];
    var inputNotesNew = ' <input id="MapEventsNewNotes" type="text" value="new note..." />';

    setLoadingBarStatus('uMapEventsCardViewLoadingBar', 'uEnrolleesMapEventsContentPanel', true,buildMapEventsList);
    $('#uEnrolleesMapEventsContentHolder').prepend('<div id="uEnrolleesMapEventsContentOverhead"></div>');

    $('#uEnrolleesMapEventsContentHolder').prepend('<div id="uEnrolleesMapEventsMenuPanel" class="EnrolleesSecondaryContentVisualOverhead ContentSecondaryOverhead ContentSecondaryMenu"><ul class="MenuList"><li class="ContentSecondaryTab DefaultTab pEvents Selected" id="uEnrolleesMapEventsMenuEvents"><span class="cLocalize cEvents">Events</span></li></ul></div>');



    var buttonBar = $('#uEnrolleesMapEventsContentOverhead');

    if (buttonBar.text().length == 0) {
        GenerateButton(localizeWrapper('cEnrolleeConfirm'), 'MapEventConfirm', 'uEnrolleesMapEventsConfirmButton_OnClick()').appendTo(buttonBar);
        $(inputNotesNew).appendTo(buttonBar);
        GenerateButton(localizeWrapper('cEnrolleeAddNote'), 'MapEventAddNote', 'saveEnrolleesMapEventsNotes()').appendTo(buttonBar);
        //buttonBar.hide();
    }
    else {
        buttonBar.hide();
    }



    veritracks.localization.localize('#uEnrolleesMapEventsContentHolder');
}

function saveEnrolleesMapEventsNotes() {
    var lSelected = mEnrolleesControls.MapEventsListView.selectedDataItem(),
        lEvent = null,
        lKey,
        lNotesToWrite = [],
        lOriginalNote = null,
        lNote = null,
        lNoteText = $('#MapEventsNewNotes').val(),
        lPredicateBuilder = new SumoPredicateBuilder();

    if ($.trim(lNoteText) !== '' && lNoteText !== gMapEventsNewNote.DefaultValue) {
        lOriginalNote = new Note(gUserDetails.UserId, lNoteText);
        lOriginalNote.__type = 'Event' + lOriginalNote.__type;
    }

    for (lKey in lSelected) {
        if (lSelected.hasOwnProperty(lKey)) {
            lEvent = lSelected[lKey].EventData;
            if (lOriginalNote !== null) {
                lNote = $.extend({}, lOriginalNote);
                lNote.EventId = lEvent.Id;
                lNote.TransactionId = moment().format("YYYYMMDDHHmmss");
                lNotesToWrite.push(lNote);
                if (!lEvent.HasNotes) {
                    lEvent.HasNotes = true;
                    lEvent.TransactionId = moment().format("YYYYMMDDHHmmss");
                    // some events are in history and will mess up cache -- always save from Events and not EventHistory.
                    lEvent.__type = "Event:www.veritracks.com";
                    setDataItem(lEvent.Id, 'Events', lEvent);
                    WriteSingle(lEvent, null, null, {}, false);
                }

            }
        }
    }

    if (lNotesToWrite.length > 0) {
        var lCurrent = mEnrolleesData.OffenderCurrentId;
        WriteMultiple(lNotesToWrite, mapEventsConfirmNote_OnWriteSuccess, confirmNote_OnWriteFailure, lCurrent);
    }
}

function mapEventsConfirmNote_OnWriteSuccess(aParams, aData) {
    gMapEventsNewNote.Clear();
    buildMapEventsList();
    showMapEventsDefaultEditFields(false, false);
}

function buildMapEventsList() {
    "use strict";
    var lColumns = [
        { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': selectionColumnFormatter },
        { 'id': 'Id', 'title': localizeWrapper('cId'), 'dataField': 'Id', 'width': 'autoData', 'minWidth': 50, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
        { 'id': 'Description', 'title': localizeWrapper('cEnrolleeDescription'), 'dataField': 'Description', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
        { 'id': 'Status', 'title': localizeWrapper('cEnrolleeStatus'), 'dataField': 'IsOpen', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'number', 'formatMethod': EventOpenFormatter },
        { 'id': 'Start', 'title': localizeWrapper('cEventStartDate'), 'dataField': 'EventData', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': formatEventStartDateTime },
        { 'id': 'Stop', 'title': localizeWrapper('cEventStopDate'), 'dataField': 'EventData', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': formatEventEndDateTime },
        { 'id': 'ConfirmedDate', 'title': localizeWrapper('cEventConfirmedDate'), 'dataField': 'EventData', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': formatEventConfirmDateTime },
        { 'id': 'Confirmed', 'title': localizeWrapper('cEventConfirmed'), 'dataField': 'IsConfirmed', 'width': 'autoHeader', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': EventConfirmedFormatter },
        { 'id': 'Notes', 'title': localizeWrapper('cEventNotes'), 'dataField': 'Notes', 'width': 'autoHeader', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'number' },
        { 'id': 'MeNotes', 'title': localizeWrapper('cEventMENotes'), 'dataField': 'MeNotes', 'width': 'autoHeader', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'number' },
        { 'id': 'MonitoredEvent', 'title': localizeWrapper('cEventMonitoredEvent'), 'dataField': 'MonitoredEvent', 'width': 'autoHeader', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'number' }
    ];
    mEnrolleesControls.MapEventsListView = new sumo.controls.ListView('uEnrolleesMapEventsListView', 'uEnrolleesMapEventsContentPanel', { 'keyField': 'Id', 'selectMethod': 'auto', 'cssClass': 'VeritracksListView', 'canUnselect': true }, lColumns);
    mEnrolleesControls.MapEventsListView.bind('selectedchanged', uEnrolleesMapEventsListView_OnSelectChange);
    mEnrolleesControls.MapEventsListView.setDataSource([]);

    mapEventsOnLoad_Init();
}

function mapEventsOnLoad_Init() {
    "use strict";
    var lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees');
    var lCard = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItem();
    //read from enrollee events assign to levents for time
    mapEventsEnrollee_Init(lEnrollee, lCard);
}

function mapEventsEnrollee_Init(aEnrollee, aCard) {
    "use strict";
    var lEnrollee = aEnrollee;
    var lEnrolleeId = lEnrollee.Id;
    var lBuilder = new SumoPredicateBuilder();
    var lChildBuilder = new SumoPredicateBuilder();
    var lSort = new SortExpression();
    var lEvents = [];
    var lCard = aCard;
    var lTypeId = lCard.Type;

    //Check if visit or trackpoint
    if (lTypeId == 3 || lTypeId == 99) {
        var lStartDate = getMoment(aCard.TrackItem.data.StartDateUTC);
        var lStopDate = getMoment(aCard.TrackItem.data.EndDateUTC);


        lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('StartDateUTC', lStopDate, false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsConfirmed', 0, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('DisplayFlag', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lChildBuilder.AddNewExpressionConditional('StopDateUTC', lStartDate, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.Or());
        lChildBuilder.AddNewExpressionConditional('IsOpen', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());

        lBuilder.Concatenate(lChildBuilder, mLogicalOperatorEnum.And());

        //ReadMultiple(gObjectList.EventHistory.AssemblyQualifiedName, lBuilder.RootExpression, 0, mapmapEventNotes_OnSuccess, null, null, null, 0, true);

        var events = getDataItems('Events');
        var results = query(events, lBuilder.RootExpression);
        mapmapEventNotes_OnSuccess(null, results);
    }
    else if (lTypeId == 5 || lTypeId == 8) {
        var lStartDate = lCard.TrackItem.data.TrackDateUTC,
            lStartDate = displayEventInEnrolleeTimeZone(lStartDate, lEnrollee);

        lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('StartDateUTC', lStartDate, false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('DisplayFlag', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lChildBuilder.AddNewExpressionConditional('StopDateUTC', lStartDate, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.Or());
        lChildBuilder.AddNewExpressionConditional('IsOpen', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());

        lBuilder.Concatenate(lChildBuilder, mLogicalOperatorEnum.And());

        //ReadMultiple(gObjectList.EventHistory.AssemblyQualifiedName, lBuilder.RootExpression, 0, mapmapEventNotes_OnSuccess, null, null, null, 0, true);

        var events = getDataItems('Events');
        var results = query(events, lBuilder.RootExpression);
        mapmapEventNotes_OnSuccess(null, results);
    }


    function mapmapEventNotes_OnSuccess(a, aEvents) {
        "use strict";
        lEvents = aEvents;

        lEvents = lSort.sort(lEvents);
        mapEventsEnrolleeEventNotes_Init(lEvents);
    }
}



function mapEventsEnrolleeEventNotes_Init(aEventList) {
    "use strict";
    var lKey,
        lEvent,
        lEventList = [],
        lNotesExist = false,
        lMonitoredEventsExist = false,
        lBuilder = new SumoPredicateBuilder();
    if (!isNullOrUndefined(aEventList)) {
        for (lKey in aEventList) {
            if (aEventList.hasOwnProperty(lKey)) {
                lEvent = aEventList[lKey];
                if (!isNullOrUndefined(lEvent)) {
                    lEventList.push(lEvent.Id);
                    if (lEvent.HasNotes == 1)
                        lNotesExist = true;
                    if (lEvent.MonitoredEventId != -1)
                        lMonitoredEventsExist = true
                }
            }
        }
    }

    if (aEventList.length !== 0) {
        lBuilder.AddNewExpressionConditional('EventId', lEventList, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        if (lNotesExist) {
            ReadMultiple(gObjectList.EventNote.AssemblyQualifiedName, lBuilder.RootExpression, 0, mapEventsEnrolleeEventNotes_OnSuccess, null, { "EventList": aEventList, "MonitoredEvents": lMonitoredEventsExist }, null, 0);
        }
        else {
            mapEventsEnrolleeEventNotes_OnSuccess({ "EventList": aEventList, "MonitoredEvents": lMonitoredEventsExist }, []);
        }
    }else {
        setLoadingBarStatus('uMapEventsCardViewLoadingBar', 'uEnrolleesMapEventsContentPanel', false);
    }
}

function mapEventsEnrolleeEventNotes_OnSuccess(aParams, aData) {
    "use strict";
    var lKey,
        lNoteKey,
        lEvent,
        lBuilder = null,
        lEventList = aParams.EventList,
        lMonitoredEventsExist = aParams.MonitoredEvents,
        lEventDetail = new EventDetailList(),
        lNoteList = [],
        lEventList = [],
        lEventIds = [],
        lMonitoredEventNoteList = [],
        lNote,
        lTimeZone,
        lEnrollee;
    FixDates(aData);
    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lNote = aData[lKey];
            if (isNullOrUndefined(lNoteList[lNote.EventId])) {
                lNoteList[lNote.EventId] = [];
            }
            lNoteList[lNote.EventId].push(lNote);
        }
    }
    $.each(aParams.EventList, function (index, value) {
        lEventIds.push(value.Id);
    });
    if (lEventIds.length > 0) {
        lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('EventId', lEventIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());

        if (lMonitoredEventsExist) {
            ReadMultiple('Veritracks.Core.MonitoredEventNote, Veritracks.Core, Version=2011.10.5050.25812, Culture=neutral, PublicKeyToken=null', lBuilder.RootExpression, 0, mapEventsMonitoredEventNote_OnSuccess, Sad, lMonitoredEventNoteList, null, 0);
        } else {
            mapEventsMonitoredEventNote_OnSuccess(lMonitoredEventNoteList, []);
        }

    }else {
        setLoadingBarStatus('uMapEventsCardViewLoadingBar', 'uEnrolleesMapEventsContentPanel', false);

    }

    function mapEventsMonitoredEventNote_OnSuccess(p, d) {
        FixDates(d);
        for (lKey in d) {
            if (d.hasOwnProperty(lKey)) {
                var lMeNote = d[lKey];
                if (isNullOrUndefined(lMonitoredEventNoteList[lMeNote.EventId])) {
                    lMonitoredEventNoteList[lMeNote.EventId] = [];
                }
                lMonitoredEventNoteList[lMeNote.EventId].push(lMeNote);
            }
        }

        for (lKey in aParams.EventList) {
            lEventDetail = new EventDetailList();
            if (aParams.EventList.hasOwnProperty(lKey)) {
                lEvent = aParams.EventList[lKey];
                lEnrollee = getDataItem(lEvent.EnrolleeId, "Enrollees");
                lTimeZone = getDataItem(lEnrollee.TimeZoneId, "TimeZone");
                if (!isNullOrUndefined(lEvent)) {
                    lEventDetail.Id = lEvent.Id;
                    lEventDetail.IsConfirmed = lEvent.IsConfirmed;
                    lEventDetail.ConfirmedByUserId = lEvent.ConfirmedByUserId;
                    lEventDetail.ZoneTrackPointCount = lEvent.ZoneTrackPointCount;
                    lEventDetail.EnrolleeId = lEvent.EnrolleeId;
                    lEventDetail.MetaEventId = lEvent.MetaEventId;
                    if (lEvent.ZoneId > 0) {
                        lEventDetail.Description = formatterMetaEvent(lEvent.MetaEventId);
                        if (!isNullOrUndefined(lEvent.ZoneName)) {
                            lEventDetail.Description += '</br>' + '(' + lEvent.ZoneName + ')';
                        }
                        else {
                            var lZone = getDataItem(lEvent.ZoneId, "Zones");
                            if (!isNullOrUndefined(lZone)) {
                                lEventDetail.Description += '</br>' + '(' + lZone.Name + ')';
                            }
                        }
                    }
                    else
                        lEventDetail.Description = formatterMetaEvent(lEvent.MetaEventId);
                    lEventDetail.IsOpen = lEvent.IsOpen;
                    lEventDetail.StartDateUTC = displayEnrolleeTimeZoneFormatted(lEvent.StartDateUTC, lTimeZone);
                    lEventDetail.StopDateUTC = displayEnrolleeTimeZoneFormatted(lEvent.StopDateUTC, lTimeZone);
                    lEventDetail.ZoneId = lEvent.ZoneId;
                    lEventDetail.DeviceId = lEvent.DeviceId;
                    lEventDetail.ConfirmedDateUTC = displayEnrolleeTimeZoneFormatted(lEvent.ConfirmedDateUTC, lTimeZone);
                    lEventDetail.DisplayFlag = lEvent.DisplayFlag;
                    lEventDetail.MonitoredEventId = lEvent.MonitoredEventId;
                    if (!isNullOrUndefined(lNoteList[lEvent.Id])) {
                        lEventDetail.Notes = '<div class="NotesIconProperty" onclick="mapEventsEnrolleeEventNotes_OnClick(\'' + lKey + '\')">' + lNoteList[lEvent.Id].length + '</div>';
                        lEventDetail.NoteData = lNoteList[lEvent.Id];
                    } else {
                        lEventDetail.Notes = '<div class="NotesIconProperty" onclick="mapEventsEnrolleeEventNotes_OnClick(\'' + lKey + '\')">0</div>';
                    }
                    if (!isNullOrUndefined(lMonitoredEventNoteList[lEvent.Id])) {
                        lEventDetail.MeNotes = '<div class="MeNotesIconProperty" onclick="mapEventsEnrolleeMeEventNotes_OnClick(\'' + lKey + '\')">' + lMonitoredEventNoteList[lEvent.Id].length + '</div>';
                        lEventDetail.MeNoteData = lMonitoredEventNoteList[lEvent.Id];
                    }
                    else {
                        lEventDetail.MeNotes = '<div class="MeNotesIconProperty" onclick="mapEventsEnrolleeMeEventNotes_OnClick(\'' + lKey + '\')">0</div></div>';
                    }
                    if (lEventDetail.MonitoredEventId !== -1) {
                        lEventDetail.MonitoredEvent = '<div class="IconButton InstantReportsButton pReportsWrite" onclick="instantReporting_OnClick(2,' + lEventDetail.MonitoredEventId + ')"></div>';
                    }
                    else {
                        lEventDetail.MonitoredEvent = '<div>N/A</div>';
                    }
                    lEventDetail.EventData = lEvent;
                    lEventDetail.SortId = (lEvent.IsOpen ? 2 : 1).toString() + lEvent.StartDateUTC.valueOf();
                    lEventList.push(lEventDetail);
                }
            }
        }
        mEnrolleesControls.MapEventsListView.setDataSource(lEventList);
        setLoadingBarStatus('uMapEventsCardViewLoadingBar', 'uEnrolleesMapEventsContentPanel', false);
    }
    function mapEventsMonitoredEventNote_OnFailure() {

    }
}

function uEnrolleesMapEventsConfirmButton_OnClick() {
    "use strict";
    var lWriteList = [],
        lSelected = mEnrolleesControls.MapEventsListView.selectedDataItem(),
        lEvents = getDataItems('Events'),
        lMapEvent = null,
        lKey,
        lNotesToWrite = [],
        lOriginalNote = null,
        lNote = null,
        lNoteText = $('#MapEventsNewNotes').val(),
        lBuilder = new SumoPredicateBuilder(),
        lEnrollee = mEnrolleesControls.CardView.selectedDataItem();

    lEnrollee = lEnrollee.Enrollee;

    if ($.trim(lNoteText) !== '' && lNoteText !== gNewNote.DefaultValue) {
        lOriginalNote = new Note(gUserDetails.UserId, lNoteText);
        lOriginalNote.__type = 'Event' + lOriginalNote.__type;
    }



    for (var lKey = 0; lKey < lSelected.length; lKey++) {
        lMapEvent = lSelected[lKey].EventData;
        lMapEvent.IsConfirmed = true;
        lMapEvent.ConfirmedByUserId = gUserDetails.UserId;
        lMapEvent.ConfirmedDateUTC = new Date();
        // some events are in history and will mess up cache -- always save from Events and not EventHistory.
        lMapEvent.__type = "Event:www.veritracks.com";
        lWriteList.push(prepareObjectForWcf(lMapEvent));
        if (lOriginalNote !== null) {
            lNote = $.extend({}, lOriginalNote);
            lNote.EventId = lMapEvent.Id;
            lMapEvent.HasNotes = true;
            lNotesToWrite.push(lNote);
        }
        setDataItem(lMapEvent.Id, 'Events', lMapEvent);
    }

    if (lWriteList.length > 0) {
        WriteMultiple(lWriteList, enrolleesMapEventsConfirmationWrite_OnSuccess, enrolleesEventConfirmationWrite_OnFailure, lSelected);
    }

    if (lNotesToWrite.length > 0) {
        var lCurrent = mEnrolleesData.OffenderCurrentId;
        if (mStateManager.Settings()[0] === 'Victims') {
            lCurrent = mEnrolleesData.VictimCurrentId;
        }
        WriteMultiple(lNotesToWrite, enrolleesMapEventsConfirmationWrite_OnSuccess, confirmNote_OnWriteFailure, lCurrent);
    }
}

function enrolleesMapEventsConfirmationWrite_OnSuccess(aParams, aData) {
    "use strict";
    var lKey;
    gMapEventsNewNote.Clear();
    mActivityNotification.addNotification(aData.length.toString() + ' ' + localizeWrapper('cEnrolleeMapEventConfirmed'));
    buildMapEventsList();
    UpdateEnrolleeEventReports(aData);
}

function uEnrolleesMapEventsListView_OnSelectChange(aSender, aData) {
    "use strict";
    var lSelected = aSender.selectedDataItem(),
    lNeedsConfirmed = false,
    lNewNote = false,
    lNeedsClosed = true,
    lMasterTamperCount = 0,
    lMasterTamperIds = [],
    lEventCount = 0,
    lItem,
    lKey;

    if (!isNullOrUndefined(lSelected) && lSelected.length > 0) {
        for (lKey in lSelected) {
            if (lSelected.hasOwnProperty(lKey)) {

                lItem = lSelected[lKey];
                ++lEventCount;
                if (!lNeedsConfirmed) {
                    lNeedsConfirmed = !lItem.IsConfirmed;
                }
                if (lItem.MetaEventId === 1003 && lNeedsClosed) {
                    ++lMasterTamperCount;
                    lNeedsClosed = lItem.IsOpen;
                    lMasterTamperIds.push(lItem.Id);
                }
            }

        }
        if (lNeedsConfirmed) {
            $('#uEnrolleesMapEventsContentOverhead .MapEventConfirmButton').show();
            $('#uEnrolleesMapEventsContentOverhead .MapEventAddNoteButton').hide();
            $('#uEnrolleesEventNewNote').unbind('change', uNewMapEventsNote_OnChange);
        }
        else {
            lNewNote = true;
            $('#uEnrolleesMapEventsContentOverhead .MapEventConfirmButton').hide();
            $('#uEnrolleesMapEventsContentOverhead .MapEventAddNoteButton').show();
            $('#MapEventsNewNotes').change(uNewMapEventsNote_OnChange).keyup(uNewMapEventsNote_OnChange).keypress(uNewMapEventsNote_OnChange).change();
        }
    }
    ////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////
    showMapEventsDefaultEditFields(lNeedsConfirmed, lNewNote);


    $('#MapEventsNewNotes').on('focus', function () {
        gMapEventsNewNote.OnFocus();
    });

    $('#MapEventsNewNotes').on('blur', function () {
        gMapEventsNewNote.OnBlur();
    });
    // possibly add new note for confirmed event show()*/
}

function showMapEventsDefaultEditFields(needsConfirm, newNote) {
    "use strict";
    var buttonBar = $('#uEnrolleesMapEventsContentOverhead');
    buttonBar.hide();

    if (needsConfirm && newNote) {
        buttonBar.show();
    }
    else if (needsConfirm) {
        buttonBar.show();
    }
    else if (newNote) {
        buttonBar.show();
    }
    else {
        buttonBar.hide();
    }

}


// bind event for new note
function uNewMapEventsNote_OnChange() {
    "use strict";
    var lEventNoteTextValue = $('#MapEventsNewNotes').val();
    if ($.trim(lEventNoteTextValue) !== '' && lEventNoteTextValue !== gMapEventsNewNote.DefaultValue) {
        $('.MapEventAddNoteButton').removeClass('Disabled');
    } else {
        $('.MapEventAddNoteButton').addClass('Disabled');
    }
}
// streamlined note section
// FEEDBACK
var gMapEventsNewNote = {};

gMapEventsNewNote.DefaultValue = 'new note...';

gMapEventsNewNote.Text = function (aText) {
    "use strict";
    var lResult = "",
        lNoteTextInput = $('#MapEventsNewNotes');
    if (!isNullOrUndefined(aText)) {
        lNoteTextInput.val(aText);
    } else {
        lResult = lNoteTextInput.val();
    }
    return lResult;
};

gMapEventsNewNote.OnFocus = function () {
    "use strict";
    if (gMapEventsNewNote.Text() === gMapEventsNewNote.DefaultValue) {
        gMapEventsNewNote.Text('');
    }
};

gMapEventsNewNote.OnBlur = function () {
    "use strict";
    if (gMapEventsNewNote.Text() === '') {
        gMapEventsNewNote.Text(gMapEventsNewNote.DefaultValue);
    }
};

gMapEventsNewNote.Clear = function () {
    "use strict";
    if (gMapEventsNewNote.Text() != '') {
        gMapEventsNewNote.Text('');
    }
}

function offenderMapPopulate_GetDateRange(isRounded) {
    "use strict";
    var //lHours = 24, //FB 1431
        lMinutes = 1440,
        uEnrolleeMapTimeFilter = $('#uEnrolleeMapTimeFilter'),
        lTripStartDate = new Date(mEnrolleesData.MapEndDate),
        lTripEndDate = new Date(mEnrolleesData.MapEndDate),
        lStartDateFilterEditable = veritracks.system.clientSetting('StartDateFilterEditable'),
        lTripTimeValue,
        lValue;

    if (!isNullOrUndefined(isRounded) && !isRounded) {
        //dont round
        lTripStartDate = new Date(mEnrolleesData.MapEndDate.getYear(), mEnrolleesData.MapEndDate.getMonth(), mEnrolleesData.MapEndDate.getDay(), mEnrolleesData.MapEndDate.getHours(), mEnrolleesData.MapEndDate.getMinutes(), mEnrolleesData.MapEndDate.getSeconds(), 0);
        lTripEndDate = new Date(mEnrolleesData.MapEndDate.getYear(), mEnrolleesData.MapEndDate.getMonth(), mEnrolleesData.MapEndDate.getDay(), mEnrolleesData.MapEndDate.getHours(), mEnrolleesData.MapEndDate.getMinutes(), mEnrolleesData.MapEndDate.getSeconds(), 0);
    }

    if (uEnrolleeMapTimeFilter.length > 0) {
        //lHours = parseInt(uEnrolleeMapTimeFilter.val());
        lMinutes = parseInt(uEnrolleeMapTimeFilter.val());
    }
    lTripStartDate.addMinutes(-1 * lMinutes);

    return { 'startDate': lTripStartDate, 'endDate': lTripEndDate };
}

function offenderMapPopulateNextDay_GetDateRange(aEndDate) {
    "use strict";
    var lMinutes = 1440,
        uEnrolleeMapTimeFilter = $('#uEnrolleeMapTimeFilter'),
        lTripStartDate,
        lTripEndDate = new Date(aEndDate),
        lIsValid = true;

    if (uEnrolleeMapTimeFilter.length > 0) {
        lMinutes = parseInt(uEnrolleeMapTimeFilter.val());
    }

    lTripEndDate.addMinutes(-1 * lMinutes);
    lTripStartDate = new Date(lTripEndDate);
    lTripStartDate.addMinutes(-1 * lMinutes);

    if (lMinutes > 1440)
        lIsValid = false;

    return { 'startDate': lTripStartDate, 'endDate': lTripEndDate, 'IsValid': lIsValid };

}

function offenderMapPopulate(aInTimelineSmallChart, aIgnoreTimelineRefresh) {
    "use strict";
    var lContact = getDataItem(mEnrolleesData.OffenderCurrentId, 'EnrolleeLastContact'),
        lDateRange = offenderMapPopulate_GetDateRange(),
        lTripStartDate = lDateRange.startDate,
        lTripEndDate = lDateRange.endDate,
        lTrackDate,
        lState,
        lUserChange = false,
        lStartDateFilterEditable = veritracks.system.clientSetting('StartDateFilterEditable'),
        lUpdateFlag = false,
        lOffender = GetEnrollee(mEnrolleesData.OffenderCurrentId),
        lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
        lIsInformatics = false;
    if (!isNullOrUndefined(lEnrollee)) {
        lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);

    }
        
    if (!isNullOrUndefined(arguments[0]))
        lUserChange = arguments[0];

    if (!lOffender.InMyOrganization) {
        $('#uShowTrackPointEventsButton').hide();
    }
    else {
        $('#uShowTrackPointEventsButton').show();
    }

    $('#uRefreshButton').removeClass('RefreshYesButton');
    $('#uRefreshButton').addClass('RefreshNoButton');
    $('#uRefreshButton').attr('title', localizeTitleFormatter('refesh not available'));

    function onReplace(aId) {
    }

    if (!isNullOrUndefined(mEnrolleesControls.NotificationPanel)) {
        mEnrolleesControls.NotificationPanel.clearNotifications();
    }
    if (!isNullOrUndefined(mEnrolleesControls.OffenderTrackpointDetailCardView)) {
        mEnrolleesControls.OffenderTrackpointDetailCardView.setDataSource([]);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Selected', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Addresses', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Zones', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('PointOfInterestMarker', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('PointOfInterestShape',[])
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('LargeZones', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Visits', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('DeviceLastContact', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('DeviceLastContactLabel', []);

        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Tags', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('TagLabels', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('ZonesNames', []);
        //mEnrolleesControls.EnrolleesMap.layerSetDataSource('Visits', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('SecondaryVisits', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('ConnectedTracks', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('SecondaryConnectedTracks', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Labels', []);

        offender_toggleuLastContactButton();


        if (mEnrolleesData.PlaybackStatus !== 'Stopped') {
            uEnrolleesMapPlaybackStopButton_OnClick();
        }
    }
    if (isNullOrUndefined(mEnrolleesControls.PrimaryEnrolleeTimer))
        mEnrolleesControls.PrimaryEnrolleeTimer = new TimerManager(500);

    mEnrolleesControls.PrimaryEnrolleeTimer.SetTimer(function (aParams) {
        lState = getViewState('AnalysisMatchEndDate');
        var lEnrollee = GetEnrollee(mEnrolleesData.OffenderCurrentId),
            lCardContact = mEnrolleesControls.CardView.selectedDataItem();

        mEnrolleesControls.EnrolleesMap.layerSetDataSource('DeviceLastContact', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('DeviceLastContactLabels', []);
        mEnrolleesControls.EnrolleesMap.layerHide('DeviceLastContact');
        mEnrolleesControls.EnrolleesMap.layerHide('DeviceLastContactLabels');
        if (lCardContact.StationDeviceSerialNumber != '- unassigned -') {
            uDisplayBLUBoxConfirmedLocation(lCardContact.StationDeviceSerialNumber);
        }
        var lSpatialResult = false;
        if (!isNullOrUndefined(lState) && !isNullOrUndefined(lState.Value)) {
            mEnrolleesData.MapEndDate = lState.Value;
            lDateRange = offenderMapPopulate_GetDateRange();
            lTripStartDate = lDateRange.startDate;
            lTripEndDate = lDateRange.endDate;
            lSpatialResult = true;
            setViewState('AnalysisMatchEndDate', null);
            setViewState('TravelBackFromEnrolleesTile', true);
        } else {
            var lSpatialState = getViewState('AnalysisSpatialMatchEndDate');
            if (!isNullOrUndefined(lSpatialState)) {
                mEnrolleesData.MapEndDate = lSpatialState.Value;
                lDateRange = offenderMapPopulate_GetDateRange();
                lTripStartDate = lDateRange.startDate;
                lTripEndDate = lDateRange.endDate;
                deleteViewState('AnalysisSpatialMatchEndDate');
            }
        }
        // Check if when clicking on timeline is coming from Map or Profile
        var lTimelineUsed = window.isTimelineDisplayedFromProfile?window.isTimelineDisplayedFromProfile:$("#uVeritracksLargeChart").is(":visible");
        var lSmallTimelineUsed = $('#enrolleesSmallMapCharting').is(":visible");
        if (lTimelineUsed) {
            lTripStartDate = mEnrolleesData.ChartStartDate;
            lTripEndDate = mEnrolleesData.ChartEndDate;
            enrolleesSmallChart_Init();
            if (!aIgnoreTimelineRefresh)
                updateMiniTimeline();
        }
        if (lTimelineUsed || lSmallTimelineUsed) {
            if (!lSpatialResult) {
                lTripStartDate = mEnrolleesData.ChartStartDate;
                lTripEndDate = mEnrolleesData.ChartEndDate;
            } else {
                mEnrolleesData.ChartStartDate = lTripStartDate;
                mEnrolleesData.ChartEndDate = lTripEndDate;
            }
            enrolleesSmallChartMap_Init();
        }
        timelineButtonLoadCheck(true);

        // Render Point of Interest on Map
        if (lIsInformatics) {
            PoiDataHelper.renderOnMap(mEnrolleesControls.EnrolleesMap);
        }
        

        if (lStartDateFilterEditable) {
            $('#uMapStartDatePicker').val(displayShortDate(lTripStartDate));
            $('#uMapStartTimePicker').val($.format.date(lTripStartDate, "h:mm a"));
            $('#uMapEndDate').html(DisplayShortDateTime(lTripEndDate));
        } else {
            $('#uMapStartDate').html(DisplayShortDateTime(lTripStartDate));
            $('#uMapDatePicker').val(displayShortDate(lTripEndDate));
            $('#uMapTimePicker').val($.format.date(lTripEndDate, "h:mm a"));
        }
        var ltTripStartDate = FixSentDate(lTripStartDate, lEnrollee);
        var ltTripEndDate = FixSentDate(lTripEndDate, lEnrollee);

        if (!isNullOrUndefined(lContact) && lEnrollee.IsAssigned && (!lTimelineUsed && !lSmallTimelineUsed)) {
            lTrackDate = new Date(lContact.TrackDate);           
            lUpdateFlag = (+lTrackDate == +mEnrolleesData.MapEndDate) ? true : false;
        } else {
            lTrackDate = new Date(0);
        }
        var lTimeZone = getTimezone(lEnrollee.TimeZoneId);
        var currentDateTime = displayFixedTimeZoneTime(new Date(), lTimeZone.TimeZoneName);
        // dont allow credit for user on future dates
        if (moment(lTripStartDate) < moment(currentDateTime)) {
            var lAgentsStopCheck = getDataItem(gUserDetails.UserId, 'Users');
            if (lAgentsStopCheck) {
                var lTrackCount = CalculateTrackpointCount();
                var lVisitCount = CalculateVisitCount();
                var lCardCount = 0;
                if (!isNullOrUndefined(mEnrolleesControls.OffenderTrackpointDetailCardView)) {
                    var lCardCount = mEnrolleesControls.OffenderTrackpointDetailCardView.getDataSource().length;
                    //if card view is not empty get gps points only
                    if (lCardCount > 0) {
                        lCardCount = lVisitCount.Count + lTrackCount;
                    }
                }
                logUserTransaction(mEnrolleesData.OffenderCurrentId, 7, gUserDetails.UserId, ltTripStartDate, ltTripEndDate, lTrackDate, null, lCardCount);
            }   
            
            //clear
            if(window.isTimelineDisplayedFromProfile){
                window.isTimelineDisplayedFromProfile = false; // this implentation needs to be changed in a future.
                //Set flag to false as it means it already navigated to the Map. (from Profile to Map)
            }
        }

        veritracks.enrollees.mapping.initialize(mEnrolleesData.OffenderCurrentId, 1, ltTripStartDate, ltTripEndDate, lUpdateFlag, function () {
            if (veritracks.enrollees.mapping.data.IsLocked && veritracks.enrollees.mapping.data.IsTracking) {
                var lTimeZone = getTimezone(lEnrollee.TimeZoneId);
                var currentDateTime = displayFixedTimeZoneTime(new Date(), lTimeZone.TimeZoneName);
                // dont allow credit for user on future dates
                if (moment(lTripStartDate) < moment(currentDateTime)) {
                    var lAgentsStopCheck = getDataItem(gUserDetails.UserId, 'Users');
                    if (lAgentsStopCheck) {
                        var lTrackCount = CalculateTrackpointCount();
                        var lVisitCount = CalculateVisitCount();
                        var lCardCount = lVisitCount.Count + lTrackCount;
                        logUserTransaction(mEnrolleesData.OffenderCurrentId, 1, gUserDetails.UserId, ltTripStartDate, ltTripEndDate, lTrackDate, null, lCardCount);
                    }
                }
            }           
        });
        var lNextDay = offenderMapPopulateNextDay_GetDateRange(ltTripEndDate);
        if (lNextDay.IsValid && !lUpdateFlag)
            veritracks.enrollees.mapping.initializeNextDay(mEnrolleesData.OffenderCurrentId, 1, lNextDay.startDate, lNextDay.endDate);


    }, {}, onReplace);
}

function UpdateTimelineEnrolleeInfo(){
    "use strict";
    var lSelectedEnrollee = mEnrolleesControls.CardView.selectedDataItem();
    var lLastContact = getDataItem(lSelectedEnrollee.Enrollee.Id, 'EnrolleeLastContact');

    FixSpeedLastContact_Updater(lLastContact, true);
}

function FixSpeedLastContact_Updater(aUpdatedContact, aIgnoreRecentlyUpdated) {
    "use strict";
    var lSelectedEnrollee = mEnrolleesControls.CardView.selectedDataItem(),
        lStartDate,
        lEnrolleeMapTimeFilter = $('#uEnrolleeMapTimeFilter'),
        lMinutes = 1440,
        lUpdateViewRefresh,
        lLastContact = getDataItem(lSelectedEnrollee.Enrollee.Id, 'EnrolleeLastContact');

    if (!isNullOrUndefined(aUpdatedContact)) {
        if (+aUpdatedContact.ContactDate > +lSelectedEnrollee.LastContactDate || +aUpdatedContact.TrackDate > +lSelectedEnrollee.LastTrackpointDate) {
            aUpdatedContact.Id = aUpdatedContact.EnrolleeId;

            if (aIgnoreRecentlyUpdated)
                mEnrolleesData.EnrolleeRecentlyUpdated.push(aUpdatedContact);

            lUpdateViewRefresh = UpdateViewOnNewDataReturn(getCacheItem('EnrolleeLastContact'), [aUpdatedContact]);
            if (lUpdateViewRefresh.IsFound && ObjectLength(lUpdateViewRefresh.ReturnData) == 1)
                mEnrolleesControls.CardView.setUpdated(false);
            // cache
            lLastContact.TrackDate = aUpdatedContact.TrackDate;
            //cardview
            lSelectedEnrollee.LastTrackpointDate = aUpdatedContact.TrackDate;
            lSelectedEnrollee.LastTrackpointDateDisplay = DisplayShortDateTime(displayEventInEnrolleeTimeZone(aUpdatedContact.TrackDate, lSelectedEnrollee.Enrollee));
            lSelectedEnrollee.LastContactDate = aUpdatedContact.ContactDate;
            lSelectedEnrollee.TrackingDeviceContactDateDisplay = DisplayShortDateTime(displayEventInEnrolleeTimeZone(aUpdatedContact.ContactDate, lSelectedEnrollee.Enrollee));
            //date filter
            lStartDate = new Date(aUpdatedContact.TrackDate);
            if (lEnrolleeMapTimeFilter.length > 0) {
                lMinutes = parseInt(lEnrolleeMapTimeFilter.val());
            }
            lStartDate = lStartDate.addMinutes(-lMinutes);

            // update date filter
            $('#uMapStartDatePicker').val(displayShortDate(displayEventInEnrolleeTimeZone(lStartDate, lSelectedEnrollee.Enrollee)));
            $('#uMapStartTimePicker').val($.format.date(displayEventInEnrolleeTimeZone(lStartDate, lSelectedEnrollee.Enrollee), "h:mm a"));
            $('#uMapEndDate').html(DisplayShortDateTime(displayEventInEnrolleeTimeZone(aUpdatedContact.TrackDate, lSelectedEnrollee.Enrollee)));

            // update enrollee last contact cache
            setDataItem(lSelectedEnrollee.Enrollee.Id, 'EnrolleeLastContact', lLastContact);

            // update single item on cardview
            mEnrolleesControls.CardView.updateSingleItem(lSelectedEnrollee);
        }
    }
}

function FixSentDate(aTime, aEnrollee) {
    "use strict";
    var lTimeZone,
        lDate;
    if (aEnrollee) {
        lTimeZone = getTimezone(aEnrollee.TimeZoneId);
    } else {
        lTimeZone = getTimezone(1);
    }
    lDate = convertTimeToUTC(aTime, lTimeZone.TimeZoneName);

    return lDate;
}

function enrolleesOffenderMap_Init() {
    "use strict";
    var lCard,
        lBuilder = new SumoPredicateBuilder(),
        lContactDateTimeSpan,
        lContactDateTime,
        lTrackDateTime,
        lOldDate,
        lContact = getDataItem(mEnrolleesData.OffenderCurrentId, 'EnrolleeLastContact');
    if (!veritracks.enrollees.mapping.data.IsLocked) {
        lOldDate = new Date();
        lOldDate.addYears(-10);
        lCard = mEnrolleesControls.CardView.selectedDataItem();
        //lTrackDateTime = lCard.LastTrackpointDate;
        //lContactDateTime = lCard.LastContactDate;
        if (lCard.Enrollee.IsAssigned) {
            if (isNullOrUndefined(lContact)) {
                lTrackDateTime = getMoment();
                lContactDateTime = getMoment();
                if (!lCard.Enrollee.InMyOrganization) {
                    if (getMoment(lCard.LastTrackpointDate) > getMoment(lOldDate)) {
                        lTrackDateTime = lCard.TrackDate;
                        lContactDateTime = lCard.TrackDate;
                    }
                }
            } else {
                lTrackDateTime = lContact.TrackDate;
                lContactDateTime = lContact.ContactDate;
            }
            lContactDateTimeSpan = getMoment(lContactDateTime);

            // if contact is really old or trackdate is more than a year older than contact date
            lContactDateTimeSpan.addYears(-1);
            if (lContactDateTime < lOldDate || lContactDateTimeSpan > lTrackDateTime) {
                lTrackDateTime = getMoment();
            }
            mEnrolleesData.MapEndDate = displayEventInEnrolleeTimeZone(lTrackDateTime, lCard.Enrollee);
        }
    }
    if (!veritracks.enrollees.mapping.data.IsLocked && !mEnrolleesControls.CardView.selectedDataItem().Enrollee.IsAssigned && isNullOrUndefined(mEnrolleesData.secondLockDate)) {
        var lSort = new SortExpression();
        lSort.addDescendingColumn('ContactDate');
        lBuilder.AddNewExpressionConditional('EnrolleeId', mEnrolleesData.OffenderCurrentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.EnrolleeContactHistory.AssemblyQualifiedName, lBuilder.RootExpression, 0, EnrolleeContact_OnComplete, null, null, lSort, 0);
    } else {
        if (veritracks.enrollees.mapping.data.IsLocked) {
            mEnrolleesData.MapEndDate = getMoment(mEnrolleesData.LockFeatureEndSaveState);
        }
        if (!isNullOrUndefined(mEnrolleesData.secondLockDate)) {
            mEnrolleesData.MapEndDate = getMoment(mEnrolleesData.secondLockDate);
            mEnrolleesData.secondLockDate = null;
            mEnrolleesData.secondLockOnEnrolleeId = null;
        }
        offenderMapPopulate();
        if (!isNullOrUndefined(mEnrolleesData.OffenderSecondaryCurrentId)) {
            offenderSecondaryMapPopulate();
        }
    }



    function EnrolleeContact_OnComplete(aParams, aContactList) {
        if (ObjectLength(aContactList) > 0) {
            var lContact,
                lTestDate;
            FixDates(aContactList);
            lContact = aContactList[0];
            lTestDate = getMoment(lContact.TrackDate);
            if (lContact.ContactDate > lTestDate.addYears(1) || isNaN(lTestDate)) {
                lContact.TrackDate = lContact.ContactDate;
            }
            mEnrolleesData.MapEndDate = getMoment(lContact.TrackDate);
        }
        else {
            mEnrolleesData.MapEndDate = new Date();
        }
        offenderMapPopulate();
        if (!isNullOrUndefined(mEnrolleesData.OffenderSecondaryCurrentId)) {
            offenderSecondaryMapPopulate();
        }
    }
}

function offenderEnrolleePopulate(aId) {
    "use strict";
    var lOffender;
    var lEnrolleeId = mEnrolleesData.OffenderCurrentId;
    //var lEMAData = new DataItem("EMAEnrolleeStatus");
    var lBuilder = new SumoPredicateBuilder();

    if(aId){
        lEnrolleeId = aId;
    }

    lOffender = GetEnrollee(lEnrolleeId);

    // temporary localization for arkansas
    if (lOffender) {
        if (checkOrganizationProperty(lOffender.OrganizationId, 'is_arkansas_th') == "Y") {
            tempLocalizationOffenderProfile_Arkansas(lOffender.OrganizationId);
        } else {
            removeTempLocalizationOffenderProfile_Arkansas(lOffender.OrganizationId);
        }
    }
    
    PopulateDetailView(lOffender, {
        'AgentId': AgentNameFormatter,
        'OrganizationId': OrganizationNameFormatter,
        'RiskLevelId': EnrolleeRiskLevelFormatter,
        'Birthdate': BirthDateStringFormatter,
        'ReferralDate': dateSelectorFormatter,
        'OffenderPayFlag': EnrolleeAlcoholFlagFormatter,
        'AlcoholDeviceFlag': EnrolleeAlcoholFlagFormatter
    }, 'uOffenderProfile');

    //lBuilder.AddNewExpressionConditional('Id', lEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
}

function EnrolleesMobileAppProfileRefresh_OnClick() {
    mActivityNotification.addNotification("Refreshing mobile application tab.");
    GetEMAEnrolleeStatus(mEnrolleesData.OffenderCurrentId, PopulateEMAProfileViews, Sad, null);
}

function PopulateEMAProfileViews_Update(aParams, aData) {
    var lEMAData = [new EMAEnrolleeStatus()],
        lEventSummaryList = getDataItems('EnrolleeEventSummary'),
        lEmaEventSummary = null,
        lBuilder = new SumoPredicateBuilder();
    
    if (aData && aData.Id === -2) {
        $('#uEMACellPhoneNumberEdit').val($('#uEMACellPhoneNumber').val())
        if ($('#uEMAHasEnrolleeMobileApp').val() === 'Yes') {
            $('#uEMAHasEnrolleeMobileAppEdit').prop('checked', true);
        } else {
            $('#uEMAHasEnrolleeMobileAppEdit').prop('checked', false);
        }
        EMAPhoneNumberInUse();  
    } else {
        lEMAData[0].AppUserId = gUserDetails.UserId;
        if ($('#uEMAHasEnrolleeMobileAppEdit').is(":checked")) {
            lEMAData[0].HasEnrolleeMobileApp = 1;
        }
        lBuilder.AddNewExpressionConditional('Id', lEMAData[0].Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lEmaEventSummary = query(lEventSummaryList, lBuilder.RootExpression);
        for (var key in lEmaEventSummary) {
            if (lEmaEventSummary.hasOwnProperty(key)) {
                if (lEMAData[0].HasEnrolleeMobileApp == 0) {
                    lEmaEventSummary[key].EmaPendingRequest = false;
                    setDataItem(lEmaEventSummary[key].Id, 'EnrolleeEventSummary', lEmaEventSummary[key]);
                }                
            }
        }
       
        lEMAData[0].CellPhoneNumber =  getIntlPhoneNumberFromElement('#uEMACellPhoneNumberEdit');//$('#uEMACellPhoneNumberEdit').val();
        lEMAData[0].EMAFlag = mEnrolleesData.OffenderCurrentEMAFlag;
        PopulateEMAProfileViews('', lEMAData);
    }
}

//EMA failed phonenumbersave Popup
function EMAPhoneNumberInUse() {
    "use strict";
    var lHtml = [],
        lButtonBar = GenerateButtonCommandBar();

    lButtonBar.append(GenerateButton('Okay', 'Okay', function () {
        ClosePopup();
    }));

    DisplayPopup('Enrollink Phone Number In Use', '<div id="uEMAPhoneNumberPopupHolder"><p>The enrollee Primary Contact Number was not saved, because it is already in use by another enrollee.  Please verify the phone number was typed correctly, or remove the number from the other enrollee.</p></div>', lButtonBar, false);
}

//EMA Profile
function PopulateEMAProfileViews(aParams, aData) {
    var lEMAData = {
        HasEnrolleeMobileApp: 'No',
        CellPhoneNumber: '',
        CellPhoneNumberEdit: ''
    };
    
    if(AgentHelper.getPermissionValueById(61)< 1){
        $("#uEnrolleesMobileAppVideoCall").remove()
    }
    if (aData[0] && aData[0].EMAFlag === 1) {
        mEnrolleesData.OffenderCurrentEMAFlag = 1;
        $('#uOffenderProfileHasEnrolleeMobileApp').show();
        if (aData[0].HasEnrolleeMobileApp !== undefined && aData[0].HasEnrolleeMobileApp === 1) {
            $('#uEnrolleesMobileApp').show();
            lEMAData.HasEnrolleeMobileApp = "Yes";
            mEnrolleesData.HasEnrolleeMobileApp = true;
            $('#uEMAHasEnrolleeMobileAppEdit').prop('checked', true);
            $('#uEMAHasEnrolleeMobileApp').val('Yes');
            $('#uEMACellPhoneNumberEdit').addClass("ValidateRequired");
            //get EMA Data
            var ema_self_reported_changes = veritracks.core.GetOriProperty(GetEnrollee(mEnrolleesData.OffenderCurrentId).OrganizationId, 'ema_self_reported_changes');
            if(!ema_self_reported_changes){
                // if N or null then remove (N default)
                $('#uEnrolleesMobileAppSelfReporting').remove();
            }
            var lEnrollee = new Enrollee(GetEnrollee(mEnrolleesData.OffenderCurrentId)),
            lIsBlueTagDeviceAssigned = EnrolleeHelper.IsEnrolleeAssignedToDevice(mEnrolleesData.OffenderCurrentId,[103,151]); // BlueTag devices           ;
            if(lIsBlueTagDeviceAssigned){
                $("#uEnrolleesMobileAppOnDemandCheckIn").remove();
                $("#uEnrolleesMobileAppPeriodicCheckIn").remove();
            }

            GetEMACheckInEvent(mEnrolleesData.OffenderCurrentId, uEnrolleesMobileAppCheckInHistoryListView_Init, Sad, null);
            GetEMAChangeRequest(mEnrolleesData.OffenderCurrentId, EnrolleesMobileAppChangeRequest_OnComplete, Sad, null);
            GetEMAMessagePending(mEnrolleesData.OffenderCurrentId,EnrolleesMobileMessagePending_OnComplete,Sad,null);
        } else {
            lEMAData.HasEnrolleeMobileApp = "No";
            mEnrolleesData.HasEnrolleeMobileApp = false;
            $('#uEnrolleesMobileApp').hide();
            $('#uEMAHasEnrolleeMobileAppEdit').prop('checked', false);
            $('#uEMAHasEnrolleeMobileApp').val('No');
            $('#uEMACellPhoneNumberEdit').removeClass("ValidateRequired");
            if (mStateManager.Settings()[2] === "EMA") {
                ChangeHashSettings(2, 'Events');
            }
        }
        if (aData[0].CellPhoneNumber !== undefined && aData[0].CellPhoneNumber !== "") {
            lEMAData.CellPhoneNumber = aData[0].CellPhoneNumber;
            lEMAData.CellPhoneNumberEdit = aData[0].CellPhoneNumber;
            // $('#uEMACellPhoneNumberEdit').val(aData[0].CellPhoneNumber);
            setIntlPhoneNumber('#uEMACellPhoneNumberEdit',aData[0].CellPhoneNumber,{onlyCountries:UserHelper.getPhoneCodes()});
            $('#uEMACellPhoneNumber').val(aData[0].CellPhoneNumber);
        } else {
            setIntlPhoneNumber('#uEMACellPhoneNumberEdit','',{onlyCountries:UserHelper.getPhoneCodes()});
            // const itl =window.intlTelInput.getInstance(document.querySelector('#uEMACellPhoneNumberEdit'));
            // itl?itl.setNumber(""):$('#uEMACellPhoneNumberEdit').val("");
            $('#uEMACellPhoneNumber').val("");
        }
        PopulateDetailView(lEMAData, {
            'CellPhoneNumber': CellPhoneNumberFormatter,
            'CellPhoneNumberEdit': InternationalPhoneNumberFormatter,
        }, 'uEMA');
    } else if (aData[0] && aData[0].EMAFlag === 0) {
        mEnrolleesData.OffenderCurrentEMAFlag = 0;
        if (mStateManager.Settings()[2] === "EMA") {
            ChangeHashSettings(2, 'Events');
        }
        $('#uOffenderProfileHasEnrolleeMobileApp').hide();
        lEMAData.HasEnrolleeMobileApp = "No";
        mEnrolleesData.HasEnrolleeMobileApp = false;
        $('#uEnrolleesMobileApp').hide();
        $('#uEMAHasEnrolleeMobileApp').val('No');
        $('#uEMACellPhoneNumberEdit').removeClass("ValidateRequired");
        $('#uEMAHasEnrolleeMobileAppEdit').prop('checked', false);
        if (aData[0].CellPhoneNumber !== undefined && aData[0].CellPhoneNumber !== "") {
            lEMAData.CellPhoneNumber = aData[0].CellPhoneNumber;
            lEMAData.CellPhoneNumberEdit = aData[0].CellPhoneNumber;
            // $('#uEMACellPhoneNumberEdit').val(aData[0].CellPhoneNumber);
            setIntlPhoneNumber('#uEMACellPhoneNumberEdit',aData[0].CellPhoneNumber,{onlyCountries:UserHelper.getPhoneCodes()});

            $('#uEMACellPhoneNumber').val(aData[0].CellPhoneNumber);
        } else {
            setIntlPhoneNumber('#uEMACellPhoneNumberEdit','',{onlyCountries:UserHelper.getPhoneCodes()});
            
            // const itl =window.intlTelInput.getInstance(document.querySelector('#uEMACellPhoneNumberEdit'));
            // itl?itl.setNumber(""):$('#uEMACellPhoneNumberEdit').val("");
            $('#uEMACellPhoneNumber').val("");
        }
        PopulateDetailView(lEMAData, {
            'CellPhoneNumber': CellPhoneNumberFormatter,
            'CellPhoneNumberEdit': InternationalPhoneNumberFormatter,
        }, 'uEMA');
    }
    window.EMAData = lEMAData;
}

function BirthDateStringFormatter(aBirthdate) {
    "use strict";
    var lDate = '';
    if (aBirthdate !== '12/07/1874')
        lDate = aBirthdate;

    return lDate;

}
function offenderProfileRead_OnComplete(aParams, aData) {
    "use strict";
    var lDetailsOptions = {
        'SupervisionBeginDate': dateSelectorFormatter,
        'SupervisionEndDate': dateSelectorFormatter,
        'DailyRate': displayDailyRate,
        'TimeZoneCode': timezoneCodeFormatter,
        'GenderId': genderFormatter,
        'RaceId': raceFormatter,
        'HairColorId': colorFormatter,
        'EyeColorId': colorFormatter,
        'Height': displayHeight,
        'Weight': displayWeight,
        'PrimaryOffenseId': offenseFormatter,
        'SupervisionTypeId': offenderSupervisionTypeFormatter,
        'VehicleYear': vehicleYearFormatter,
        'VehicleMake': vehicleMakeFormatter,
        'VehicleColor': vehicleColorFormatter,
        'IsSexOffender': displayBoolean,
        'LanguageId': offenderLanguageFormatter,
        'SecurusEnrolleePayId': OffenderPayFlagFormatter
    };

    if (aParams === mEnrolleesData.OffenderCurrentId && !isNullOrUndefined(aData[0])) {
        mEnrolleesData.OffenderProfileCurrent = aData[0];
        
        var lOffender = GetEnrollee(mEnrolleesData.OffenderProfileCurrent.Id);
        FixDates(aData);
        if(veritracks.system.clientSetting('VictimMonitoringEnabled')){
            var EnrolleeTmp = new Enrollee();
            EnrolleeTmp.setValues(aData[0]);
            EnrolleeTmp.GetVictim(function(aParam,aValue){
                if(aValue){
                    mEnrolleesData.OffenderProfileCurrentVictims = aValue;
                    var html =[]
                    aValue.map(function(val,index){
                        html.push(VictimIdLinkFormatter(val.Id))
                    })
                    $('#uSAMADetailsVictimId').html(html.join(' '))
                }
            })
        }
        offenderEnrolleePopulate(lOffender.Id);
        if (checkOrganizationProperty(lOffender.OrganizationId, 'is_arkansas_all') == "Y") {
            lDetailsOptions['OrganizationAddressId'] = OrganizationAddressTitleformatter;
        }
        PopulateDetailView(mEnrolleesData.OffenderProfileCurrent, lDetailsOptions, 'uOffenderProfile');

        loadEnrollePhotos(aData[0].Id, offenderPhoto_OnSuccess);
    }
    if (!isNullOrUndefined(mEnrolleesData.OffenderProfileCurrent) && mEnrolleesData.OffenderProfileCurrent.Height === 0) {
        $('#uOffenderProfileHeight').hide();
    }
    isAssignedCheck();

}

function offenderProfileRead_OnFailure(a, b, c) {
    "use strict";
}

function offenderCategoryRead_OnComplete(aParams, aData) {
    "use strict";
    if (aParams === mEnrolleesData.OffenderCurrentId && !isNullOrUndefined(aData)) {
        var lKey, lCategory, lHtml = [];

        mEnrolleesData.OffenderProfileCategories = aData;
        for (lKey in mEnrolleesData.OffenderProfileCategories) {
            lCategory = mEnrolleesData.OffenderProfileCategories[lKey];
            if (lCategory.IsActive) {
                lHtml.push('<div>');
                lHtml.push(dataItemFormatter('MetaEnrolleeCategory', 'Description', '', mEnrolleesData.OffenderProfileCategories[lKey].MetaEnrolleeCategoryId));//getDataItem(mEnrolleesData.OffenderProfileCategories[lKey].MetaEnrolleeCategoryId, 'MetaEnrolleeCategory').Description);
                lHtml.push('</div>');
            }
        }
            $('#uOffenderProfileCategoryList').html(lHtml.join(''));

    }
}

function offenderCategoryRead_OnFailure(a, b, c) {
    "use strict";
}

function offenderSexOffenseRead_OnComplete(aParams, aData) {
    "use strict";
    if (aParams === mEnrolleesData.OffenderCurrentId && !isNullOrUndefined(aData)) {
        var lEnrollee = GetEnrollee(mEnrolleesData.OffenderCurrentId);

        // var lKey, lItem, lHtml = [];
        mEnrolleesData.OffenderProfileSexOffenses = aData;
        getSexOffenseList(lEnrollee.OrganizationId);
    }
}
function getSexOffenseCheckList(aOrganizationId) {
    "use strict";
    GetOriSexOffense(aOrganizationId,
        function (aParams, aOriSexOffenseList) {
            mSexOffenseList = aOriSexOffenseList.length > 0 ? aOriSexOffenseList :getEnrolleeCategoriesData();
            populateSexOffenseCheckboxList();
        },
        function () {
            mSexOffenseList = getDataItems('SexOffense');
            populateSexOffenseCheckboxList();
        }
    );
}
function getSexOffenseList(aOrganizationId) {
    "use strict";
    GetOriSexOffense(aOrganizationId,
        function (aParams, aOriSexOffenseList) {
            if (aOriSexOffenseList.length > 0) {
                mSexOffenseList = aOriSexOffenseList;
                listAssignedSexOffenses();
            } else {
                mSexOffenseList = getDataItems('SexOffense');
                listAssignedSexOffenses();
            }
        },
        function () {
            mSexOffenseList = getDataItems('SexOffense');
            listAssignedSexOffenses();
        }
    );
}

function listAssignedSexOffenses() {
    "use strict";

    var lKey, lItem, lHtml = [];

    for (lKey in mEnrolleesData.OffenderProfileSexOffenses) {
        if (mEnrolleesData.OffenderProfileSexOffenses.hasOwnProperty(lKey)) {
            lItem = mEnrolleesData.OffenderProfileSexOffenses[lKey];
            if (lItem.IsActive) {
                var found = mSexOffenseList.find(function(element) {
                    if (element) {
                        return element.Id === mEnrolleesData.OffenderProfileSexOffenses[lKey].SexOffenseId;
                    }
                });
                if(!isNullOrUndefined(found)){
                    lHtml.push('<div>');
                    lHtml.push(found.Description);// 
                    lHtml.push('</div>');
                }
            }
        }
    }
    $('#uOffenderProfileSexOffenseList').html(lHtml.join(''));
}

function offenderSexOffenseRead_OnFailure(a, b, c) {
    "use strict";
}

function PopulateOffenderMap() {
    "use strict";
    $('#uEnrolleesMapPanel').text(mEnrolleesData.OffenderCurrentId);
}

function PopulateEnrolleeData() {
    "use strict";
    if (mCurrentHash.Settings[0] === 'Offenders') {
        if (mCurrentHash.Settings[1] === 'Profile') {
            offenderProfilePopulate();
        }else {
            PopulateOffenderMap();
        }
    } else {
        if (mCurrentHash.Settings[1] === 'Profile') {
            Victim.victimProfilePopulate();
        } else {
            Victim.PopulateVictimMap();
        }
    }
}

function SelectEnrollee(aEnrolleeId) {
    "use strict";
    //mCurrentEnrolleeId = aEnrolleeId;
    $('.EnrolleesCardDetail.Selected').removeClass('Selected');
    $('#uEnrolleeList' + aEnrolleeId).addClass('Selected');
    PopulateEnrolleeData(aEnrolleeId);
}

// EVENTS
function uEnrolleesListHolder_OnClick(aObject) {
    "use strict";
    var lEnrolleeId = aObject.id.substring(13, aObject.id.length);
    SelectEnrollee(lEnrolleeId);
}
function enrolleesPrint_OnLoad(aDocument) {
    "use strict";
    var lMapPanel = $(aDocument).find('#uTestPanel'),
               lData = [{ 'Id': 1, 'Value': 'One' }, { 'Id': 2, 'Value': 'Two' }];
    if (lMapPanel.length > 0) {
        mEnrolleesControls.PrintMap = new sumo.controls.ListView('uTestList', lMapPanel[0],
             { 'keyField': 'Id', 'selectMethod': 'single', 'cssClass': 'VeritracksListView', 'canUnselect': false },
             [{ 'id': 'Value', 'title': 'Name', 'dataField': 'Value', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'formatMethod': null }]);
        mEnrolleesControls.PrintMap.setDataSource(lData);
    }

}

function uEnrolleesEventPrint_OnClick() {
}


// OFFENDER
function resetOffenderProfileWindow(aPercentage) {
    "use strict";
    var lPercentageDiff = 10;

    var lWindowWidth = $(window).width(),
        lPanelWidth = $('#uEnrolleesMainContentPanel').width(),
        lContentHolders = $('#uEnrolleesContentHolder').width();
    //if window size is small
    if (!isNullOrUndefined(aPercentage)) {
        lPercentageDiff = lContentHolders - (lContentHolders * aPercentage);
    }

    lPanelWidth = lContentHolders - lPercentageDiff;
    setWidth('#uEnrolleesMainContentPanel', lPanelWidth);
    setWidth('#uEnrolleesSecondaryContentPanel', lPanelWidth);

}

function enrolleeOffenderEnterEditMode() {
    "use strict";
    $('#uEnrolleesSecondaryContentHolder').hide('fast', resetContentHolders);
    $('#uEditOffenderButton').hide();
    $('#uAddOffenderButton').hide();
    $("#uPreviousOffenderPhotoButtonContainer").show();

    $('#uSaveOffenderButton').show();
    $('#uCancelOffenderButton').show();


    EnterEditMode('uOffenderProfilePanel');
    $('#uPrimaryIdAlert').hide();
    $('#uEnrollmentDateError').hide();

    $('#uOffenderPhotoDeleteButton').show();
    $('#uOffenderPhotoAddButton').show();
    $('#uOffenderPhotoEditButton').show();

    if (mEnrolleesData.OffenderPhotos.length == 0) {
        $('#uOffenderPhotoAddButton').show();
        $('#uPhotoTypeContainer').hide();
        $("#uPreviousOffenderPhotoButtonContainer").show();
        $("#uNextOffenderPhotoButtonContainer").show();
        $("#uOffenderPhotoDescriptionEdit").val('');
        $("#uPhotoType").val('1');
        $('#uOffenderPhotoDeleteButton').addClass("DisabledOffenderActionButtons");
        $('#uOffenderPhotoEditButton').addClass("DisabledOffenderActionButtons");
    } else {
        $('#uOffenderPhotoDeleteButton').removeClass("DisabledOffenderActionButtons");
        $('#uOffenderPhotoEditButton').removeClass("DisabledOffenderActionButtons");
        if (mEnrolleesData.OffenderPhotos.length == 1) {
            $('#uPreviousOffenderPhotoButton').hide();
            $('#uNextOffenderPhotoButton').hide();
            $('#uPreviousOffenderPhotoButtonContainer').show();
            $('#uNextOffenderPhotoButtonContainer').show();
        } else {
            $('#uNextOffenderPhotoButton').show();
        }
        $("#uOffenderPhotoDescriptionEdit").val(mEnrolleesData.OffenderPhotos[0].PhotoDescription);
        $("#uPhotoType").val(mEnrolleesData.OffenderPhotos[0].PhotoTypeId);
        mEnrolleesData.OffenderPhotosEditMode = "Edit";

        }

    if (mEnrolleesData.OffenderPhotos.length > 0) {
        $("#uOffenderPhotoDescriptionEdit").val(mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoDescription);
        mEnrolleesData.OffenderPhotoDescription = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoDescription;
    }
    $('#EidReservationQuotaFilled').hide();
    $('.EidReservation').hide();
    $('#uOffenderProfileEnrolleeEIdEndDateEdit').removeClass('ValidateRequired');
    mEnrolleesData.QueuedFrps = [];
}

function enrolleeOffenderExitEditMode() {
    "use strict";
    if (mStateManager.Settings()[1] === 'Profile') {
        if (mEnrolleesData.IsSecondaryVisible) {
            $('#uEnrolleesSecondaryContentHolder').show('fast', resetContentHolders);
        }
        $('#uAddOffenderButton').show();
        $('#uEditOffenderPhotoFilenameTextBox').hide();
        $('#uEditOffenderPhotoButton').hide();
        $('#uSaveOffenderButton').hide();
        $('#uCancelOffenderButton').hide();
        $("#uOffenderPhotoDeleteButton").hide();
        $("#uOffenderPhotoAddButton").hide();
        $('#uOffenderPhotoEditButton').hide();
        $('#uOffenderPhotoCancelButton').hide();
        //$('#uEditOffenderPhotoFilenameTextBox').unbind();
        ExitEditMode('uOffenderProfilePanel');
        $("#uOffenderPhotoDescriptionContainer").hide();
        $('.EidReservation').hide();
        mEnrolleesData.OffenderPhotosEditMode = "Display";
    }
}

function EnrolleePayFlag_Init(aOffenderPayFlag, aDailyRate, aOld){
    "use strict";
    if (aOffenderPayFlag == 1) {
        $('#uOffenderProfileOffenderPayFlagEdit').prop('checked', true);
        $('#uOffenderProfileDailyRateEdit').prop('disabled', false);
    } else {
        $('#uOffenderProfileDailyRateEdit').prop('disabled', true);
        //$('#uOffenderProfileDailyRateEdit').val('');
        $('#uOffenderProfileOffenderPayFlagEdit').prop('checked', false);
    }

    if (!aOld) {
        $('#uOffenderProfileDailyRateQtip').qtip({
            content: {
                text: localizeText('cEnrolleeFrpFlagNeeded')
            },
            position: {
                my: 'top right',
                at: 'bottom left',
                viewport: $(window)
            },
            show: {
                delay: 200
            },
            style: 'qtip-bootstrap qtip-max-width'
        });
    }
}

function offenderPopulateEditMode(aEnrollee, aOffender) {
    "use strict";
    var lFeetList = [],
        lInchesList = [],
        lCentimetersList = [],
        lRiskLevels,
        lBuilder = new SumoPredicateBuilder(),
        lKey,
        lColor = getDataItems('Color'),
        lHairColor,
        lEyeColor,
        lCategoryList = getEnrolleeClassificationsData(),
        lTimeZoneList = getDataItems('TimeZone'),
        lOrganizations;
    lBuilder.AddNewExpressionConditional('ColorType', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lHairColor = query(lColor, lBuilder.RootExpression);
    lBuilder.Clear();

    lBuilder.AddNewExpressionConditional('ColorType', 2, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lEyeColor = query(lColor, lBuilder.RootExpression);
    lBuilder.Clear();

    lBuilder.AddNewExpressionConditional('Id', 1, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());

    lRiskLevels = query(RiskLevelFormatter(), lBuilder.RootExpression);
    for (lKey = 0; lKey <= 8; lKey++) {
        lFeetList.push({ 'Id': lKey });
    }
    for (lKey = 0; lKey <= 11; lKey++) {
        lInchesList.push({ 'Id': lKey });
    }

	for (lKey = 0; lKey <= 275; lKey++) {
        lCentimetersList.push({ 'Id': lKey });
	}

	$("#uOffenderProfileOrganizationAddressIdEdit").empty()
                .append(OrganizationAddressSelectFormatter());

	if (checkOrganizationProperty(aEnrollee.OrganizationId, 'is_arkansas_all') == "Y") {
	    $("#uOffenderProfileOrganizationAddressIdEdit").val(aOffender.OrganizationAddressId);
	} else {
	    removeTempLocalizationOffenderProfile_Arkansas(aEnrollee.OrganizationId);
	    $("#uOffenderProfileOrganizationAddressIdEdit").val(0);
	}

    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('Id', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lOrganizations = query(OrganizationSortFormatter(), lBuilder.RootExpression);

    mEnrolleesData.OffenderTimeZoneIsOverridden = (aEnrollee.Id !== -1);
    aEnrollee.Birthdate = new Date(aEnrollee.Birthdate);

    EnrolleePayFlag_Init(aEnrollee.OffenderPayFlag, aOffender.DailyRate)

    if (aEnrollee.AlcoholDeviceFlag == 1) {
        $('#uOffenderProfileAlcoholDeviceFlagEdit').prop('checked', true);
    } else {
        $('#uOffenderProfileAlcoholDeviceFlagEdit').prop('checked', false);
    }


    var laTimeZoneIds = [];
    if (aEnrollee.Id == -1) {
        //if new Enrollee
        mEnrolleesData.EnrolleeAlternateContact = new EnrolleeAlternateContact();
        mEnrolleesData.EnrolleeAlternateContacts = [];
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('UserId', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        var lUserAgents = query(getDataItems('Agents'), lBuilder.RootExpression);
        for (var key in lUserAgents) {
            if (lUserAgents.hasOwnProperty(key)) {
                if (laTimeZoneIds.indexOf(lUserAgents[key].TimeZoneId) == -1) {
                    if (checkOrganizationProperty(lUserAgents[key].OrganizationId, 'only_one_timezone') === 'Y') {
                        laTimeZoneIds.push(lUserAgents[key].TimeZoneId);
                    }//end of if
                }//end of if
            }//end of if
        }//end of for
    } else {
        if (checkOrganizationProperty(aEnrollee.OrganizationId, 'only_one_timezone') === 'Y') {
            laTimeZoneIds.push(aEnrollee.TimeZoneId);
        }//end of if
    }

    var lSelectedTimezoneName = $('#uOffenderProfileTimeZoneCode').text();
    lTimeZoneList = lTimeZoneList.filter(function (a) {
        if (laTimeZoneIds.length > 0 && laTimeZoneIds.indexOf(a.Id) == -1) {
            return false;
        }
        return a.IsActive == 1 || a.Name == lSelectedTimezoneName;
    });
    populateEditView(aEnrollee, [
    //{ 'Id': 'AgentId', 'Type': 'Dropdown', 'DataSource': getDataItems('Agents'), 'DataValueField': 'Id', 'DataTextField': 'FullName' },
                        { 'Id': 'OrganizationId', 'Type': 'Dropdown', 'DataSource': lOrganizations, 'DataValueField': 'Id', 'DataTextField': 'Name' },
                        { 'Id': 'RiskLevelId', 'Type': 'Dropdown', 'DataSource': lRiskLevels, 'DataValueField': 'Id', 'DataTextField': 'Name','insertBlank':true }
    ], { 'Birthdate': dateSelectorFormatter, 'ReferralDate': dateSelectorFormatter, }, 'uOffenderProfile', 'Edit');

    populateEditView(aOffender, [
                        { 'Id': 'TimeZoneCode', 'Type': 'Dropdown', 'DataSource': lTimeZoneList, 'LocaleName': 'TimeZone', 'DataValueField': 'TimeZoneCode', 'DataTextField': 'Name' },
                        { 'Id': 'GenderId', 'Type': 'Dropdown', 'DataSource': getDataItems('Gender'), 'LocaleName': 'Gender', 'DataValueField': 'Id', 'DataTextField': 'Description', 'isNullableKey': true },
                        { 'Id': 'RaceId', 'Type': 'Dropdown', 'DataSource': getDataItems('Race'), 'LocaleName': 'Race', 'DataValueField': 'Id', 'DataTextField': 'Description', 'isNullableKey': true },
                        { 'Id': 'HairColorId', 'Type': 'Dropdown', 'DataSource': lHairColor, 'LocaleName': 'Color', 'DataValueField': 'Id', 'DataTextField': 'Description', 'isNullableKey': true },
                        { 'Id': 'EyeColorId', 'Type': 'Dropdown', 'DataSource': lEyeColor, 'LocaleName': 'Color', 'DataValueField': 'Id', 'DataTextField': 'Description', 'isNullableKey': true },
                        { 'Id': 'HeightFeet', 'Type': 'Dropdown', 'DataSource': lFeetList, 'DataValueField': 'Id', 'DataTextField': 'Id' },
                        { 'Id': 'HeightInches', 'Type': 'Dropdown', 'DataSource': lInchesList, 'DataValueField': 'Id', 'DataTextField': 'Id' },
                        { 'Id': 'HeightCentimeter', 'Type': 'Dropdown', 'DataSource': lCentimetersList, 'DataValueField': 'Id', 'DataTextField': 'Id' },
                        { 'Id': 'VehicleMake', 'Type': 'Dropdown', 'DataSource': VehicleMakeSortFormatter(), 'LocaleName': 'VehicleMake', 'DataValueField': 'DescriptionValue', 'DataTextField': 'Description', 'isNullableKey': true },
                        { 'Id': 'VehicleColor', 'Type': 'Dropdown', 'DataSource': VehicleColorSortFormatter(), 'LocaleName': 'VehicleColor', 'DataValueField': 'Description', 'DataTextField': 'Description', 'isNullableKey': true },
                        { 'Id': 'PrimaryOffenseId', 'Type': 'Dropdown', 'DataSource': getDataItems('Offense'), 'LocaleName': 'Offense', 'DataValueField': 'Id', 'DataTextField': 'Description', 'isNullableKey': true },
                        { 'Id': 'SupervisionTypeId', 'Type': 'Dropdown', 'DataSource': getDataItems('SupervisionType'), 'LocaleName': 'SupervisionType', 'DataValueField': 'Id', 'DataTextField': 'Description', 'isNullableKey': false },
                        { 'Id': 'CategoryList', 'Type': 'CheckboxList', 'DataSource': lCategoryList, 'LocaleName': 'MetaEnrolleeCategory', 'DataValueField': 'Id', 'DataTextField': 'Description' },
                        { 'Id': 'LanguageId', 'Type': 'Dropdown', 'DataSource': getDataItems('Languages'), 'LocaleName': 'Languages', 'DataValueField': 'Id', 'DataTextField': 'Description' },

    ], {
        'SupervisionBeginDate': dateSelectorFormatter,
        'Weight': displayMetricWeigthData,
        'VehicleYear': displayNumericData,
        'SupervisionEndDate': dateSelectorFormatter,
        'DailyRate': displayCurrencyNoMoney
    }, 'uOffenderProfile', 'Edit', localizeDataItem);
    populateEditView(mEnrolleesData.EnrolleeAlternateContact, [],{}, 'uOffenderAlternateAgencyContact', 'Edit', localizeDataItem);
    uOffenderProfileOrganizationIdEdit_OnChange();
}

function populateSexOffenseCheckboxList() {
    "use strict";

    var lKey, lItem;

    populateEditView(mEnrolleesData.OffenderProfileCurrent, [
        { 'Id': 'SexOffenseList', 'Type': 'CheckboxList', 'DataSource': mSexOffenseList, 'LocaleName': 'SexOffense', 'DataValueField': 'Id', 'DataTextField': 'Description' },
    ], {
        'SupervisionBeginDate': dateSelectorFormatter,
        'Weight': displayMetricWeigthData,
        'VehicleYear': displayNumericData,
        'SupervisionEndDate': dateSelectorFormatter,
        'DailyRate': displayCurrencyNoMoney
    }, 'uOffenderProfile', 'Edit', localizeDataItem);

    for (lKey in mEnrolleesData.OffenderProfileSexOffenses) {
        if (mEnrolleesData.OffenderProfileSexOffenses.hasOwnProperty(lKey)) {
            lItem = mEnrolleesData.OffenderProfileSexOffenses[lKey];
            if (lItem.IsActive) {
                $('#uOffenderProfileSexOffenseListEdit' + lItem.SexOffenseId).prop("checked", true);
            }
        }
    }

    if (mEnrolleesData.OffenderProfileCurrent.Id == -1) {
        uOffenderProfileAgentIdEdit_OnChange();
    }
}

function uOffenderProfileTimeZoneCodeEdit_OnChange() {
    "use strict";

    mEnrolleesData.OffenderTimeZoneIsOverridden = true;
}
function uOffenderProfileAgentIdEdit_OnChange() {
    "use strict";
    var lAgentId = $('#uOffenderProfileAgentIdEdit').val(),
        lAgent = getDataItem(lAgentId, 'Agents'),
        lTimeZone;

    if (!isNullOrUndefined(lAgent)) {
        lTimeZone = getDataItem(lAgent.TimeZoneId, 'TimeZone');
    }

    //TimeZoneId
    if (!mEnrolleesData.OffenderTimeZoneIsOverridden && !isNullOrUndefined(lTimeZone)) {
        $('#uOffenderProfileTimeZoneCodeEdit').val(lTimeZone.TimeZoneCode);
    }
}
var EnrolleeController = {
    elementPrefixId:'uEnrolleeProfile',
    aContainerId:'uEnrolleeProfile'+'Panel',
    aLoadingId:'uEnrolleeProfile'+'LoadingBar',
    aButtonBarId:'uEnrolleeProfile'+'ButtonBar',
    IsEditMode:false,
    OrganizationChanged:false,
    showLoading: function(){
        $('#'+this.aLoadingId).show();
        $('#'+this.aContainerId).hide();
        $('#'+this.aButtonBarId+' .ButtonCommandBarBox').hide();
    },
    hideLoading: function(){
        $('#'+this.aLoadingId).hide();
        $('#'+this.aContainerId).show();
        $('#'+this.aButtonBarId+' .ButtonCommandBarBox').show();
    }
};
function GetVictimRiskLevels(){
    var lBuilder = new SumoPredicateBuilder();
    return query(getDataItems('VictimRiskLevels'), lBuilder.RootExpression);;
}

function uOffenderProfileOrganizationIdEdit_OnChange() {
    "use strict";
    var lId = -1,
        lEnrollee = GetEnrollee(mEnrolleesData.OffenderEditingId),
        lCurrentRiskLevel,
        lBuilder = new SumoPredicateBuilder(),
        lOrganizationId = $('#uOffenderProfileOrganizationIdEdit').val(),
        lAgents,
        lMyAgents,
        lKey,
        lSelectedId,
        lRiskLevels = RiskLevelFormatter(),
        lRiskLevelsByOrg = [],
        lDefaultValue = -1,
        lEnrolleeOrganizationEMAenabled = lEnrollee ? checkOrganizationProperty(lEnrollee['OrganizationId'],'enable_ema'): 'N',
        lEMAenabled = checkOrganizationProperty(lOrganizationId, 'enable_ema'),
        lSort = new SortExpression();
        if(lEnrollee){
            var state = {
                Old: new OrganizationController(lEnrollee.OrganizationId),
                New: new OrganizationController(parseInt(lOrganizationId)),
            },sameORI = state.New.Id === state.Old.Id,
            IsEMASupported = state.Old.IsPropertySupported(StalkerController.sama_property) && !state.New.IsPropertySupported(StalkerController.sama_property),
            IsEnrolleePaired = mEnrolleesData.OffenderProfileCurrentVictims.length>0;
            if(EnrolleeController.IsEditMode && !sameORI && IsEnrolleePaired){
                StalkerController.PreventORIChangePairing(function(){
                    EnrolleeController.OrganizationChanged = true;
                    // VictimForm.detail.setValue('OrganizationId',state.New.Id);
                    // _Init(state.New.Id); 
                    InitOrganization();
                    $('#uOffenderProfileOrganizationIdEdit option[value='+state.New.Id+']').attr('selected','selected');
                },function(){
                    EnrolleeController.OrganizationChanged = false
                    // VictimForm.detail.setValue('OrganizationId',state.Old.Id);
                    // _Init(state.Old.Id);
                    InitOrganization();
                    $('#uOffenderProfileOrganizationIdEdit option[value='+state.Old.Id+']').attr('selected','selected');
                });
            }else {
                InitOrganization();
            }
            
        }else {
            InitOrganization();
        }
        
    function InitOrganization(){
        if(!isNullOrUndefined(lEnrollee) && lEnrolleeOrganizationEMAenabled && (lEMAenabled === 'N' || !lEMAenabled) && $('#uEMAHasEnrolleeMobileApp').val() === 'Yes'){
            var lHtml = [],
            lButtonBar = GenerateButtonCommandBar();
            
            lHtml.push('<div id="uEnrolleeOrganizationPopupPanel" style="padding: 15px; text-align: center;">');
            lHtml.push('The organization you are trying to select does not support "Enrollink"<br>');
            lHtml.push('<br>Please use a different organization');
            lHtml.push('</div>');
    
            GenerateButton('Close', 'Close', ClosePopup).appendTo(lButtonBar);
            DisplayModal('Warning', lHtml.join(''), lButtonBar, false);
            $('#uOffenderProfileOrganizationIdEdit option[value='+ lEnrollee.OrganizationId +']').prop('selected', true);
            populateSexOffenseCheckboxList();
            return;
            // go back to first 
        }else {
            if(lEMAenabled === 'Y'){
                $('#uOffenderProfileHasEnrolleeMobileApp').show();
                if($('#uEMAHasEnrolleeMobileApp').val() === 'Yes' && lEnrolleeOrganizationEMAenabled ==='Y'){
                    $('#uEMAHasEnrolleeMobileApp').val('Yes');
                    $('#uEMAHasEnrolleeMobileAppEdit').prop('checked', true);
                }
            }else {
                $('#uOffenderProfileHasEnrolleeMobileApp').hide();
                if(lEnrolleeOrganizationEMAenabled ==='N' ){
                    $('#uEMAHasEnrolleeMobileApp').val('No');
                    $('#uEMAHasEnrolleeMobileAppEdit').prop('checked', false);
                }
                
            }
        }
        
        if (!isNullOrUndefined(lEnrollee))
            lCurrentRiskLevel = lEnrollee.RiskLevelId;
    
        lBuilder.AddNewExpressionConditional('DisplayType', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('OrganizationId', lOrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lAgents = query(getDataItems('Agents'), lBuilder.RootExpression);
    
        if (!isNullOrUndefined(lEnrollee)) {
            for (lKey in lAgents) {
                if (lAgents.hasOwnProperty(lKey)) {
                    if (parseInt(lKey) === lEnrollee.AgentId) {
                        lSelectedId = lKey;
                        break;
                    }
                }
            }
        }
        if (isNullOrUndefined(lSelectedId)) {
            lBuilder.AddNewExpressionConditional('UserId', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lMyAgents = query(getDataItems('Agents'), lBuilder.RootExpression);
            if (lMyAgents.length > 0) {
                for (lKey in lMyAgents) {
                    if (lMyAgents.hasOwnProperty(lKey)) {
                        lSelectedId = lKey;
                        break;
                    }
                }
            }
    
            lMyAgents = AgentsSortFormatter(lMyAgents);
        }
    
        lAgents = AgentsSortFormatter(lAgents);
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('OrganizationId', lOrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lSort.addDescendingColumn('SortOrder');
        var lRiskLevelsList = query(lRiskLevels, lBuilder.RootExpression);
    
        for (lKey in lRiskLevelsList) {
            if (lRiskLevelsList.hasOwnProperty(lKey)) {
                lRiskLevelsByOrg.push(lRiskLevelsList[lKey])
            }
        }
    
        populateEditView({ 'AgentId': lSelectedId }, [
                { 'Id': 'AgentId', 'Type': 'Dropdown', 'DataSource': lAgents, 'DataValueField': 'Id', 'DataTextField': 'FullName' },
                { 'Id': 'RiskLevelId', 'Type': 'Dropdown', 'DataSource': lRiskLevelsByOrg, 'DataValueField': 'Id', 'DataTextField': 'Name', 'DefaultValue': lDefaultValue.toString(),'insertBlank':true }
        ], {}, 'uOffenderProfile', 'Edit');
    
        $('#uOffenderProfileAgentIdEdit').change();
    
        if (!isNullOrUndefined(lCurrentRiskLevel)) {
            var lRiskLevelFound = false;
            for (lKey in lRiskLevelsByOrg) {
                if (lRiskLevelsByOrg.hasOwnProperty(lKey)) {
                    if (lRiskLevelsByOrg[lKey].Id == lEnrollee.RiskLevelId)
                        lRiskLevelFound = true;
                }
            }
            if (!lRiskLevelFound)
                DisplayModal('Risk Level Not Found', '<div style="height:100px"> Your Risk Level was not found in this Organization. Please select a new Risk Level.  Save.  Then change Organization again. Please contact your Regional Coordinator if you have any questions.</div>', null, null);
            else
                $('select#uOffenderProfileRiskLevelIdEdit').val(lEnrollee.RiskLevelId);
        }
    
        if (!isNullOrUndefined(mEnrolleesControls.OffenderProfileValidator))
            mEnrolleesControls.OffenderProfileValidator.AutoFillVerify($('#uOffenderProfileRiskLevelIdEdit'));
    
        if (checkOrganizationProperty((parseInt($("#uOffenderProfileOrganizationIdEdit").val())), 'is_arkansas_all') == "Y") {
            tempLocalizationOffenderProfile_Arkansas((parseInt($("#uOffenderProfileOrganizationIdEdit").val())));
            if (mEnrolleesData.OffenderEditingId == -1) {
                $("#uOffenderProfileOrganizationAddressIdEdit").val(0);
            } else {
                $("#uOffenderProfileOrganizationAddressIdEdit").val(mEnrolleesData.OffenderProfileCurrent.OrganizationAddressId);
            }
    
        } else {
            removeTempLocalizationOffenderProfile_Arkansas((parseInt($("#uOffenderProfileOrganizationIdEdit").val())));
            $("#uOffenderProfileOrganizationAddressIdEdit").val(0);
        }
    
        $('select#uOffenderProfileRiskLevelIdEdit').change();
    
        getSexOffenseCheckList(lOrganizationId);
    }
}

function offenderDatePicker_OnChange() {
    "use strict";
    mEnrolleesControls.OffenderProfileValidator.IsValid();
}

function uAddOffenderButton_OnClick() {
    "use strict";
    var lEnrollee = new Enrollee();
    mEnrolleesData.OffenderProfileCurrent = new OffenderProfile();
    offenderPopulateEditMode(lEnrollee, mEnrolleesData.OffenderProfileCurrent);
    mEnrolleesData.OffenderPhotos = [];
    mEnrolleesData.OffenderDeviceClusters = [];
    enrolleeOffenderEnterEditMode();
    GetOffenderImage(null);
    mEnrolleesData.OffenderEditingId = -1;
    //mEnrolleesControls.CardView.selected(-1);
    mEnrolleesControls.OffenderProfileValidator = new Validator('uOffenderProfilePanel', mRegexValidation);
    $('#uOffenderProfilePanel').show();
    $("#uPhotoNumberContainer").hide();
    $("#uNextOffenderPhotoButton").hide();
    $('#uOffenderPhotoAddButton').addClass('DisabledOffenderActionButtons');
    $('#uPreviousOffenderPhotoButton').hide();
     //PhoneInternationalNumber 
    $("#uEMACellPhoneNumber").hide();
    setIntlPhoneNumber('#uEMACellPhoneNumberEdit','',{onlyCountries:UserHelper.getPhoneCodes()});
            
    // const itl =window.intlTelInput.getInstance(document.querySelector('#uEMACellPhoneNumberEdit'));
    // itl?itl.setNumber(""):$('#uEMACellPhoneNumberEdit').val("");
    $("#OffenderProfileCellPhoneNumber .iti").show();
    $('#uEMAHasEnrolleeMobileAppEdit').prop('checked', false);
    $('#uEMACellPhoneNumberEdit').removeClass("ValidateRequired");
    $('#uEMACellPhoneNumberEdit').removeClass("ValidateSuccess");
    //$("#uOffenderProfilePhotoUri").removeClass('AlcoholUploadedImage');
}

function uEditOffenderButton_OnClick() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    function onComplete() {
        enrolleeOffenderEnterEditMode();
        $('#uOffenderPhotoAddButton').removeClass('DisabledOffenderActionButtons');
        $('#uOffenderPhotoHolder').attr('src', mEnrolleesData.OffenderProfileCurrent.PhotoUri);//not meant to be here remove
        mEnrolleesData.OffenderEditingId = mEnrolleesData.OffenderCurrentId;
        var lOffender = GetEnrollee(mEnrolleesData.OffenderEditingId),
            lFeet = Math.floor(mEnrolleesData.OffenderProfileCurrent.Height / 12),
            lInches = mEnrolleesData.OffenderProfileCurrent.Height - (lFeet * 12),
            lCentimeters = convertInchesToCentimeters(mEnrolleesData.OffenderProfileCurrent.Height),
            lKey,
            lItem,
            lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric'));
        //Vulnerability 3254.1
        lOffender.FirstName = veritracks.system.decodeHtml(lOffender.FirstName);
        lOffender.LastName = veritracks.system.decodeHtml(lOffender.LastName);
        lOffender.PrimaryId = veritracks.system.decodeHtml(lOffender.PrimaryId);
        lOffender.SecondaryId = veritracks.system.decodeHtml(lOffender.SecondaryId); 
        lOffender.Birthdate = veritracks.system.decodeHtml(lOffender.Birthdate);
        var shortcutOffender = mEnrolleesData.OffenderProfileCurrent;
        shortcutOffender.MarksTattoos = veritracks.system.decodeHtml(shortcutOffender.MarksTattoos);
        shortcutOffender.PrimaryJurisdiction = veritracks.system.decodeHtml(shortcutOffender.PrimaryJurisdiction);
        shortcutOffender.VehicleModel   = veritracks.system.decodeHtml(shortcutOffender.VehicleModel);
        shortcutOffender.VehicleColor   = veritracks.system.decodeHtml(shortcutOffender.VehicleColor);
        shortcutOffender.VehicleMake   = veritracks.system.decodeHtml(shortcutOffender.VehicleMake);
        shortcutOffender.VehiclePlateNumber   = veritracks.system.decodeHtml(shortcutOffender.VehiclePlateNumber);

        offenderPopulateEditMode(lOffender, mEnrolleesData.OffenderProfileCurrent);
        EnrolleeController.IsEditMode = true;
        if (checkOrganizationProperty(lOffender.OrganizationId, 'is_arkansas_th') == "Y") {
            tempLocalizationOffenderProfile_Arkansas(lOffender.OrganizationId);
        } else {
            removeTempLocalizationOffenderProfile_Arkansas(lOffender.OrganizationId);
        }

        mEnrolleesControls.OffenderProfileValidator = new Validator('uOffenderProfilePanel', mRegexValidation);

        if (!isNullOrUndefined(mEnrolleesData.OffenderEidReservation) && mEnrolleesData.OffenderEidReservation.StatusId <= 2) {
            $('#uOffenderProfilePrimaryIdEdit').hide();
            $('#uOffenderProfilePrimaryId').show();
        }

		if (lDoMetric) {
            $('#uOffenderProfileHeightCentimeterEditSpan').show();
            $('#uOffenderProfileHeightCentimeterEdit').val(lCentimeters);
            $('#uOffenderProfileHeightFeetEditSpan').hide();
            $('#uOffenderProfileHeightInchesEditSpan').hide();
        }
        else {
            $('#uOffenderProfileHeightCentimeterEditSpan').hide();
            $('#uOffenderProfileHeightFeetEditSpan').show();
            $('#uOffenderProfileHeightInchesEditSpan').show();
            $('#uOffenderProfileHeightFeetEdit').val(lFeet);
            $('#uOffenderProfileHeightInchesEdit').val(lInches);
        }

        //user story 1920
        var primaryIdEditable = veritracks.system.clientSetting('PrimaryIdEditable');
        if (!isNullOrUndefined(primaryIdEditable) && primaryIdEditable == 0) {
            $('#uOffenderProfilePrimaryIdEdit').hide();
            $('#uOffenderProfilePrimaryId').show();
        }
        if (lOffender.ReferralDate.getFullYear() > 1900) {
            $('#uOffenderProfileReferralDateCheckEdit').prop('checked', true);
        }
        //$('#uOffenderProfileReferralDateEdit').hide();
        // $('#uOffenderProfileReferralDate').hide();
        //PhoneInternationalNumber 
        $("#uEMACellPhoneNumber").hide();
        $("#OffenderProfileCellPhoneNumber .iti").show()

        $('#uOffenderProfileHeightFeetEdit').val(lFeet);
        $('#uOffenderProfileHeightInchesEdit').val(lInches);
        for (lKey in mEnrolleesData.OffenderProfileCategories) {
            if (mEnrolleesData.OffenderProfileCategories.hasOwnProperty(lKey)) {
                lItem = mEnrolleesData.OffenderProfileCategories[lKey];
                if (lItem.IsActive) {
                    $('#uOffenderProfileCategoryListEdit' + lItem.MetaEnrolleeCategoryId).prop("checked", true);
                }
            }
        }

        $('#uOffenderProfileIsSexOffenderEdit').prop("checked", mEnrolleesData.OffenderProfileCurrent.IsSexOffender);

        if (!CheckUserHasPermission(211)) { //enrollee primary id
            $('#uOffenderProfilePrimaryIdEdit').attr('disabled', true).addClass('DisabledSelect');
        }
        
    }

    function onFailure(aParams, aError, aStatus, aError2, aFunction) {
        onComplete();
    }

    function onSuccess(aParams, aData) {
        FixDates(aData);
        mEnrolleesData.OffenderEidReservation = aData[0];
        onComplete();
    }

    getEidReservation(onSuccess, onFailure);
    getDeviceClusters()
    if (mEnrolleesData.OffenderPhotoIndex != 0) {
        offenderPhoto_OnSuccess(null, mEnrolleesData.OffenderPhotos);
    }

    function getDeviceClusters() {
        var lBuilder = new SumoPredicateBuilder()
        lBuilder.AddNewExpressionConditional('EnrolleeId', mEnrolleesData.OffenderCurrentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.DeviceClusterEnrollee.AssemblyQualifiedName, lBuilder.RootExpression, 0, function (aParams, aData) {
            if (aParams === mEnrolleesData.OffenderCurrentId) {
                mEnrolleesData.OffenderDeviceClusters = aData;
            }
        }, Sad, mEnrolleesData.OffenderCurrentId, null, 0);
    }

}

function getEidReservation(aOnSuccess, aOnFailure) {
    var lBuilder = new SumoPredicateBuilder();
    var lDataItem = new DataItem('EidReservation')
    lBuilder.AddNewExpressionConditional('EnrolleeId', mEnrolleesData.OffenderCurrentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('StatusId', 2, false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
    ReadMultiple(lDataItem.AssemblyQualifiedName, lBuilder.RootExpression, 0, aOnSuccess, aOnFailure, null, null, 0);
}

function getRiskLevel(aRiskLevelId, aOrganizationId) {
    var lBuilder = new SumoPredicateBuilder();

    lBuilder.AddNewExpressionConditional('OrganizationId', aOrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('Id', aRiskLevelId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    var lRiskLevel = query(getDataItems('RiskLevels'), lBuilder.RootExpression)

    lRiskLevel = Object.values(lRiskLevel);

    if (lRiskLevel.length == 1) return lRiskLevel[0];

    return null;
}

function getEnrolleeRiskLevel(enrolleeId) {
    var lEnrollee = GetEnrollee(enrolleeId);
    var lBuilder = new SumoPredicateBuilder();

    if (!lEnrollee) return null;

    return getRiskLevel(lEnrollee.RiskLevelId, lEnrollee.OrganizationId);
}
function EidQuotaCheck(aRiskLevel, aOnSuccess) {
    "use strict";
    var eidQuota = new EidQuota();

    if (!aRiskLevel || aRiskLevel.EidTypeId == -1) { return aOnSuccess(-1) }

    eidQuota.EidTypeId = aRiskLevel.EidTypeId;
    eidQuota.OrganizationId = aRiskLevel.OrganizationId;

    WriteSingle(eidQuota, function (a, b) {
        return aOnSuccess(b.Id);
    }, function (a, b) { console.log('error') }, null, true);
}

function uOffenderProfileDailyRateDisable_OnCheck() {
    "use strict";
    if (!$('#uOffenderProfileDailyRateDisableEdit').prop('checked')) {
        $('#uOffenderProfileDailyRateEdit').prop('disabled', true);
        //$('#uOffenderProfileDailyRateEdit').val('');
    } else {
        $('#uOffenderProfileDailyRateEdit').prop('disabled', false);
    }
}


function uOffenderProfileReferralDate_OnCheck() {
    "use strict";

    var lDate = new Date(),
        lValue = $('#uOffenderProfileReferralDateEdit').val();

    if (lValue == '') {
        $('#uOffenderProfileReferralDateEdit').val(displayShortDate(lDate));
        //   $('#uOffenderProfileReferralDate').text(displayShortDate(lDate));
    }
    else {
        $('#uOffenderProfileReferralDateEdit').val(null);
        //    $('#uOffenderProfileReferralDate').text('');
    }
}

function uSaveOffenderButton_OnClick() {
    "use strict";
    
    function onHide() {
        $('#uSaveOffenderButton').hide();
        $('#uCancelOffenderButton').hide();
        $('#uEnrollmentDateError').hide();
        
        if(EnrolleeController.OrganizationChanged && !isNullOrUndefined(mEnrolleesData.OffenderProfileCurrentVictims)&& mEnrolleesData.OffenderProfileCurrentVictims.length >0){
            var lDissociations = mEnrolleesData.OffenderProfileCurrentVictims.map(function(i){
                var d = new SAMAOffenderDissociation();
                d.SAMAId = i.SamaPhoneNumber
                return d;
            });
            console.log('lDissociations',lDissociations)
            WriteMultiple(lDissociations, function(res){
                console.log('successfully unpaired',res)
                SaveStateTargetSet()
                enrolleesOffenderSave();
                ClearValidation();
                // mActivityNotification.addNotification('Successfully saved Associations');
            }, failure, null, true);
        }else {
            SaveStateTargetSet()
            enrolleesOffenderSave();
            ClearValidation();
        }

    }
    var lRiskLevelIsValid = $('#uOffenderProfileRiskLevelIdEdit').hasClass('ValidateError');

    if (lRiskLevelIsValid) {
        return false;
    }

    var lStartDate = new Date($('#uOffenderProfileSupervisionBeginDateEdit').val()),
        lEndDate = new Date($('#uOffenderProfileSupervisionEndDateEdit').val());


    if ($('#uOffenderProfileSupervisionBeginDateEdit').val() === "" || !mEnrolleesControls.OffenderProfileValidator.IsValid()) {
        lStartDate = new Date();
        $('#uOffenderProfileSupervisionBeginDateEdit').val(displayShortDate(lStartDate));
    }
    if ($('#uOffenderProfileSupervisionEndDateEdit').val() === "" || !mEnrolleesControls.OffenderProfileValidator.IsValid()) {
        lEndDate = new Date(lStartDate);
        lEndDate.addYears(1);
        $('#uOffenderProfileSupervisionEndDateEdit').val(displayShortDate(lEndDate));
    }
    if (lEndDate > lStartDate) {
        if (mEnrolleesControls.OffenderProfileValidator.IsValid()) {
            setLoadingBarStatus('uEnrolleesProfilePanelLoadingBar', 'uOffenderProfilePanel', true, onHide);
        }
    } else {
        $('#uEnrollmentDateError').show();
    }

    $("#uPreviousOffenderPhotoButtonContainer").show();
    $("#uPreviousOffenderPhotoButton").hide();
    $("#uPhotoTypeContainer").hide();
    //$("#uNextOffenderPhotoButton").hide();
    resetImageUploadContainerAction();


}

function enrolleesOffenderEidReservation() {
    "use strict";
    var lRiskLevel = getEnrolleeRiskLevel(mEnrolleesData.OffenderCurrentId);
    var create = false;
    var lAssignment = gCurrentDeviceAssignment[mEnrolleesData.OffenderCurrentId];

    if (!lAssignment) return
    lAssignment = Object.values(lAssignment).filter(function (a) { return [103, 104, 111, 151].indexOf(a.ProductId) !== -1 });

    //blutag and blutwo support only paired with bluhome/blubox.
    if (lAssignment.length == 0) return;

    if (!lAssignment.find(function (a) { return a.ProductId == 104 }) && !mEnrolleesData.OffenderDeviceClusters.length > 0) {
        return
    }

    if (lRiskLevel.EidTypeId == -1) return

    if (mEnrolleesData.OffenderEidReservation) {
        if (mEnrolleesData.OffenderEidReservation.EidTypeId != lRiskLevel.EidTypeId) {
            mEnrolleesData.OffenderEidReservation.EidTypeId = lRiskLevel.EidTypeId;
            mEnrolleesData.OffenderEidReservation.UserId = gUserDetails.UserId;
        }
    } else {
        create = true;
        mEnrolleesData.OffenderEidReservation = new EidReservation();
        var lNewEndDate = $('#uOffenderProfileEnrolleeEIdEndDateEdit').val();
        mEnrolleesData.OffenderEidReservation.EndDate = new Date(lNewEndDate);
        mEnrolleesData.OffenderEidReservation.StartDate = moment()._d;
        mEnrolleesData.OffenderEidReservation.StatusId = 2;
        mEnrolleesData.OffenderEidReservation.UserId = gUserDetails.UserId;
        mEnrolleesData.OffenderEidReservation.EidTypeId = lRiskLevel.EidTypeId;
        mEnrolleesData.OffenderEidReservation.EnrolleeId = mEnrolleesData.OffenderCurrentId;
    }

    WriteSingle(mEnrolleesData.OffenderEidReservation, function (aParams, aData) {
        if (!isNullOrUndefined(aData)) {
            FixDates(aData);
            mEnrolleesData.OffenderEidReservation = aData;
            if (create) {
                mActivityNotification.addNotification(localizeWrapper('cEnrolleeEidReservationCreated'));
            } else {
                mActivityNotification.addNotification(localizeWrapper('cEnrolleeEidReservationUpdated'));
            }
        }
    }, Sad, null, true)


}

function enrolleesOffenderSave_OnComplete(aParams, aData) {
    "use strict";
    var lHeight = 0,
        lOffender = $.extend({}, aParams.OffenderProfile),
        lKey,
        lValue,
        lOffenderSexOffense,
        lBuilder = new SumoPredicateBuilder(),
        lItemFound,
        lOffenderCategory,
        lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric')),
        lPageClass = gPageClassManager.EnrolleesOffenderSecondary,       
        lEMAData = new EMAEnrolleeStatus();
        var lEnrolleeAlternateAgencyEdit = mEnrolleesData.EnrolleeAlternateContact;
    if (($('#uEMACellPhoneNumberEdit').val() !== $('#uEMACellPhoneNumber').val())
        || ($('#uEMAHasEnrolleeMobileAppEdit').is(":checked") == true && $('#uEMAHasEnrolleeMobileApp').val() !== "Yes")
        || ($('#uEMAHasEnrolleeMobileAppEdit').is(":checked") == false && $('#uEMAHasEnrolleeMobileApp').val() === "Yes")
        || ($('#uEMAHasEnrolleeMobileAppEdit').is(":checked") == false && $('#uEMAHasEnrolleeMobileApp').val() == "No") && $('#uEMACellPhoneNumber').val() != '') {
        lEMAData.AppUserId = gUserDetails.UserId
        lEMAData.Id = aData.Id;

        if ($('#uEMAHasEnrolleeMobileAppEdit').is(":checked")) {
            lEMAData.HasEnrolleeMobileApp = 1;
        }
        lEMAData.CellPhoneNumber =  getIntlPhoneNumberForSaveFromElement('#uEMACellPhoneNumberEdit');//.replace('+','');
        lEMAData.EMAFlag = mEnrolleesData.OffenderCurrentEMAFlag;
        //TODO: UNDO CHANGE
        console.log(lEMAData)
        WriteSingle(lEMAData, PopulateEMAProfileViews_Update, Sad, null, true);
    }   
    
    if (aData.Id === -2) {
        enrolleeOffenderEnterEditMode();
        $('#uPrimaryIdAlert').show();
        setLoadingBarStatus('uEnrolleesProfilePanelLoadingBar', 'uOffenderProfilePanel', false);
    } else {
        $('#uPrimaryIdAlert').hide();
        FixDates(aData);
        //AssignGlobalIds(gEnrolleeIds, getCacheItem('Enrollees'), 'Id'); // this new line fixes ticket 980
        if (lDoMetric) {
            lHeight = parseInt($('#uOffenderProfileHeightCentimeterEdit').val()) / 2.54;
        }
        else {
            lHeight = (parseInt($('#uOffenderProfileHeightFeetEdit').val()) * 12) + parseInt($('#uOffenderProfileHeightInchesEdit').val());
        }

        checkEnabledFrp();

        if (!isNaN(lHeight)) {
            lOffender.Height = lHeight;
        }

        populateFromEditView(lOffender, 'uOffenderProfile', 'Edit');
        //Vulnerability 3254.1
        lOffender.MarksTattoos = veritracks.system.encodeHtml(lOffender.MarksTattoos);
        lOffender.PrimaryJurisdiction = veritracks.system.encodeHtml(lOffender.PrimaryJurisdiction);
        lOffender.VehicleModel   = veritracks.system.encodeHtml(lOffender.VehicleModel);
        lOffender.VehicleColor   = veritracks.system.encodeHtml(lOffender.VehicleColor);
        lOffender.VehicleMake   = veritracks.system.encodeHtml(lOffender.VehicleMake);
        lOffender.VehiclePlateNumber   = veritracks.system.encodeHtml(lOffender.VehiclePlateNumber);


        if (lOffender.Id === -1) {
            lOffender.Id = aData.Id;
        }
        lOffender.Weight = parseInt(lOffender.Weight);
        if (isNaN(lOffender.Weight)) {
            lOffender.Weight = 0;
        }
        if (lDoMetric) {
            lOffender.Weight = convertKilogramsToLBS(parseInt(lOffender.Weight));
        }
        else {
            lOffender.Weight = parseInt(lOffender.Weight);
        }


        lOffender.VehicleYear = parseInt(lOffender.VehicleYear);
        if (isNaN(lOffender.VehicleYear)) {
            lOffender.VehicleYear = 0;
        }
        if (aData.OffenderPayFlag) {
            lOffender.DailyRate = parseFloat(lOffender.DailyRate);
            if (isNaN(lOffender.DailyRate)) {
                lOffender.DailyRate = -1;
            }
        } else {
            lOffender.DailyRate = -1;
        }
        aData.InMyOrganization = (gUserDetails.OrganizationIds.indexOf(aData.OrganizationId) !== -1);
        setDataItem(aData.Id, "Enrollees", aData);
        if (CheckUserHasPermission(45)) {
            setDataItem(aData.Id, "EnrolleesUniversal", aData);
        }
        AssignGlobalIds(gEnrolleeIds, getCacheItem('Enrollees'), 'Id'); // this new line fixes ticket 980
        universalSearch_UpdateData();

        if ($('#uOffenderProfileIsSexOffenderEdit').prop("checked")) {
            lOffender.IsSexOffender = true;
        } else {
            lOffender.IsSexOffender = false;
        }
        if (!lOffender.OrganizationAddressId) {
            lOffender.OrganizationAddressId = -1;
        }
        // avoid unnecesary Write
        populateFromEditView(lEnrolleeAlternateAgencyEdit,'uOffenderAlternateAgencyContact','Edit');
        var isNewOrEdit = IsObjectEqual(new EnrolleeAlternateContact(),lEnrolleeAlternateAgencyEdit);
        if(!isNewOrEdit){
            lEnrolleeAlternateAgencyEdit.EnrolleeId = aData.Id;
            WriteSingle(lEnrolleeAlternateAgencyEdit, function(aParam,aData){
                console.log('Saving Alternate Agency Contact',aData)
            }, Sad, null, true);
        }

        WriteSingle(lOffender, uOffenderProfileSave_OnComplete, uOffenderProfileSave_OnFailure, { 'Enrollee': aData, 'IsNew': aParams.IsNew });

        for (lKey in mEnrolleesData.OffenderProfileCategories) {
            mEnrolleesData.OffenderProfileCategories[lKey].IsActive = false;
        }
        $('#uOffenderProfileCategoryListEdit input').each(function (aIndex) {
            if ($(this).prop("checked")) {
                lValue = $(this).val();
                lItemFound = false;
                for (lKey in mEnrolleesData.OffenderProfileCategories) {
                    if (mEnrolleesData.OffenderProfileCategories.hasOwnProperty(lKey)) {
                        if (mEnrolleesData.OffenderProfileCategories[lKey].MetaEnrolleeCategoryId.toString() === lValue) {
                            mEnrolleesData.OffenderProfileCategories[lKey].IsActive = true;
                            lItemFound = true;
                            break;
                        }
                    }
                }
                if (!lItemFound) {
                    lOffenderCategory = new OffenderCategory();
                    lOffenderCategory.Id = aData.Id;
                    lOffenderCategory.MetaEnrolleeCategoryId = lValue;
                    mEnrolleesData.OffenderProfileCategories.push(lOffenderCategory);
                }
            }
        });
        WriteMultiple(mEnrolleesData.OffenderProfileCategories, enrolleesOffenderProfileCategoriesWrite_OnSuccess, enrolleesOffenderProfileCategoriesWrite_OnFailure, mEnrolleesData.OffenderEditingId);

        for (lKey in mEnrolleesData.OffenderProfileSexOffenses) {
            mEnrolleesData.OffenderProfileSexOffenses[lKey].IsActive = false;
        }
        $('#uOffenderProfileSexOffenseListEdit input').each(function (aIndex) {
            if ($(this).prop("checked")) {
                lValue = $(this).val();
                lItemFound = false;
                for (lKey in mEnrolleesData.OffenderProfileSexOffenses) {
                    if (mEnrolleesData.OffenderProfileSexOffenses.hasOwnProperty(lKey)) {
                        if (mEnrolleesData.OffenderProfileSexOffenses[lKey].SexOffenseId.toString() === lValue) {
                            mEnrolleesData.OffenderProfileSexOffenses[lKey].IsActive = true;
                            lItemFound = true;
                            break;
                        }
                    }
                }
                if (!lItemFound) {
                    lOffenderSexOffense = new OffenderSexOffense();
                    lOffenderSexOffense.Id = aData.Id;
                    lOffenderSexOffense.SexOffenseId = lValue;
                    mEnrolleesData.OffenderProfileSexOffenses.push(lOffenderSexOffense);
                }
            }
        });
        WriteMultiple(mEnrolleesData.OffenderProfileSexOffenses, enrolleesOffenderSexOffensesWrite_OnSuccess, enrolleesOffenderSexOffensesWrite_OnFailure, mEnrolleesData.OffenderEditingId);

        enrolleesOffenderEidReservation();
    }
}

function enrolleesOffenderSave_OnFailure(aParams, a, b, c) {
    "use strict";
    console.log(aParams, a, b, c);
    setLoadingBarStatus('uEnrolleesProfilePanelLoadingBar', 'uOffenderProfilePanel', false);
    mActivityNotification.addNotification(localizeWrapper('cDefaultGothimSaveFail'));
}

    function enrolleeOffenderPhotoDeleted_OnSuccess(aParams, aData) {
        "use strict";

        for (var i = 0; i < aData.length; i++) {
            if (aData.hasOwnProperty(i)) {
            for (var j = 0; j < mEnrolleesData.OffenderPhotos.length; j++) {
                    if (aData[i].Id == mEnrolleesData.OffenderPhotos[j].Id) {
                        mEnrolleesData.OffenderPhotos = mEnrolleesData.OffenderPhotos.splice(j, 1);
                        break;
                    }
            }
        }
        }

        if (mEnrolleesData.OffenderPhotos.length == 0) {
            $("#uPhotoNumberContainer").hide();
        }
        mEnrolleesData.OffenderPhotosDeleted = [];
        enrolleesOffenderPhotoSave();
    }

    function enrolleeOffenderPhotoEdited_OnSuccess(aParams, aData) {
        "use strict";

            mEnrolleesData.OffenderPhotosEdited = [];
    enrolleesOffenderPhotoSave(aParams);
    }


    function enrollePhotoSwapNo_OnSuccess(aParams, aData) {
        "use strict";
    mEnrolleesData.OffenderPhotoIndex = 0;
    enrolleesOffenderPhotoSave();
    }

    function enrolleeOffenderPhotoSave_OnSuccess(aParams, aData) {
        "use strict";
        var lNewPhoto = new OffenderPhoto(),
            lNewPhotoDescription = new OffenderPhoto(),
            lNewPhotoType = new OffenderPhoto();

        function onHide() {

        }

        for (var lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lNewPhoto.Id = aData[lKey].Id;
                lNewPhotoDescription.Id = aData[lKey].Id;
                lNewPhotoType.Id = aData[lKey].Id;

                lNewPhoto.IsActive = aData[lKey].IsActive;
                lNewPhotoDescription.IsActive = aData[lKey].IsActive;
                lNewPhotoType.IsActive = aData[lKey].IsActive;

                lNewPhoto.EnrolleeId = aData[lKey].EnrolleeId;
                lNewPhotoDescription.EnrolleeId = aData[lKey].EnrolleeId;
                lNewPhotoType.EnrolleeId = aData[lKey].EnrolleeId;

                lNewPhoto.PhotoOrderNo = aData[lKey].PhotoOrderNo;
                lNewPhotoDescription.PhotoOrderNo = aData[lKey].PhotoOrderNo;
                lNewPhotoType.PhotoOrderNo = aData[lKey].PhotoOrderNo;

                lNewPhoto.PhotoUri = aData[lKey].PhotoUri;
                lNewPhotoDescription.PhotoUri = null;
                lNewPhotoType.PhotoUri = null;

                lNewPhoto.PhotoDescription = aParams.description;
                lNewPhotoDescription.PhotoDescription = aParams.description;
                lNewPhotoType.PhotoDescription = null;

                mEnrolleesData.OffenderPhotosEdited.push(lNewPhotoDescription);

            if (aParams.type != "1") {
                lNewPhotoType.PhotoTypeId = parseInt(aParams.type);
                lNewPhoto.PhotoTypeId = parseInt(aParams.type);
                mEnrolleesData.OffenderPhotosEdited.push(lNewPhotoType);
            }

            mEnrolleesData.OffenderPhotos.push(lNewPhoto);
        }
        }

        //put photo on the back of the queue
        mEnrolleesData.OffenderPhotoIndex = mEnrolleesData.OffenderPhotos.length - 1;
        if (!isNullOrUndefined(aData) && aData.length > 0) {
            $('#uOffenderPhotoDeleteButton').removeClass("DisabledOffenderActionButtons");
            $('#uOffenderPhotoAddButton').removeClass("DisabledOffenderActionButtons");
            $('#uOffenderPhotoEditButton').removeClass("DisabledOffenderActionButtons");
            //reset offender photos description
            mEnrolleesData.OffenderPhotoDescription = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoDescription;
        }

        if ($("#uPhotoNumberContainer").css("display") == "none") {
            $("#uPhotoNumberContainer").show();
        }

        mEnrolleesData.OffenderPhotosAdded = [];

        setLoadingBarStatus('uEnrolleesProfilePanelLoadingBar', 'uOffenderProfilePanel', false, onHide);
        enrolleesOffenderPhotoSave(aParams);

}

function enrolleeOffenderPhotoEdit(aParams) {
    "use strict";
    WriteMultiple(mEnrolleesData.OffenderPhotosEdited, enrolleeOffenderPhotoEdited_OnSuccess, enrolleesOffenderSave_OnFailure, aParams, true, true);
}

function enrolleeOffenderPhotoAdd(aParams) {
    "use strict";
    var lClean = false;
    //clean up offender photos
    while (!lClean) {
        lClean = true;
        for (var lKey in mEnrolleesData.OffenderPhotos) {
            if (mEnrolleesData.OffenderPhotos.hasOwnProperty(lKey)) {
                if (mEnrolleesData.OffenderPhotos[lKey].Id == -1) {
                    mEnrolleesData.OffenderPhotos.splice(lKey, 1);
                    lClean = false;
                }//end of if
            }//end of if
        }//end of for
    }//end of while

    WriteMultiple(mEnrolleesData.OffenderPhotosAdded, enrolleeOffenderPhotoSave_OnSuccess, enrolleesOffenderSave_OnFailure, aParams, true, true);
}

function enrolleeOffenderIndexChange() {
    "use strict";

    var currentOffenderPhoto = new OffenderPhoto();
    currentOffenderPhoto.Id = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].Id;
    currentOffenderPhoto.EnrolleeId = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].EnrolleeId;
    currentOffenderPhoto.IsActive = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].IsActive;
    currentOffenderPhoto.PhotoOrderNo = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoOrderNo;
    currentOffenderPhoto.PhotoUri = null;
    currentOffenderPhoto.PhotoDescription = null;
    currentOffenderPhoto.PhotoTypeId = -1;
    WriteSingle(currentOffenderPhoto, enrollePhotoSwapNo_OnSuccess, enrolleesOffenderSave_OnFailure, null, true);
 }

function enrolleeOffenderDelete() {
    "use strict";
    WriteMultiple(mEnrolleesData.OffenderPhotosDeleted, enrolleeOffenderPhotoDeleted_OnSuccess, enrolleesOffenderSave_OnFailure, null, true, true);
    }

    function enrolleesOffenderPhotoSave(aParams) {
        "use strict";

        if (mEnrolleesData.OffenderPhotosAdded.length > 0) {
            enrolleeOffenderPhotoAdd(aParams);
        } else if (mEnrolleesData.OffenderPhotosEdited.length > 0) {
            enrolleeOffenderPhotoEdit(aParams);
        } else if (mEnrolleesData.OffenderPhotoIndex != 0 && mEnrolleesData.OffenderPhotos.length > 0 && isNullOrUndefined(aParams)) {
        enrolleeOffenderIndexChange();
        } else if (mEnrolleesData.OffenderPhotosDeleted.length > 0) {
        enrolleeOffenderDelete();
        }


    }

function enrolleesOffenderSave() {
    "use strict";
    var lKey,
        lItem,
        //lOffenderCategory = new OffenderCategory(),
        //lOffenderOffenderSexOffense = new OffenderSexOffense(),
        //lItemFound = false,
        lEnrollee = GetEnrollee(mEnrolleesData.OffenderEditingId),
        lEnrolleeEdit,
        //lHeight = 0,
        lOriginalOrganizationId = -1,
        lDeviceAssignments,
        lDevice,
        lDeviceWrite = [],
        lBuilder,
        lMonth = '0',
        lDay = '0',
        lCurrentOffender,
        lFoundOffender = false,
        lTransactionId = moment().format("YYYYMMDDHHmmss");

    if (isNullOrUndefined(lEnrollee)) {
        lEnrolleeEdit = new Enrollee();
        lEnrolleeEdit.EnrolleeType = 1;
        lEnrolleeEdit.TransactionId = lTransactionId;
        mEnrolleesData.OffenderProfileCurrent = new OffenderProfile();
        mEnrolleesData.OffenderProfileCurrent.TransactionId = lTransactionId;
        mEnrolleesData.OffenderProfileCurrent.IsNewEnrollee = 1;
    } else {
        lEnrollee.TransactionId = lTransactionId;
        lEnrolleeEdit = $.extend({}, lEnrollee);
        mEnrolleesData.OffenderProfileCurrent.TransactionId = lTransactionId;
        mEnrolleesData.OffenderProfileCurrent.IsNewEnrollee = 0;
        lOriginalOrganizationId = lEnrolleeEdit.OrganizationId;
    }
    //PhoneInternationalNumber
    $("#uEMACellPhoneNumber").hide();
    $("#OffenderProfileCellPhoneNumber .iti").hide();
    populateFromEditView(lEnrolleeEdit, 'uOffenderProfile', 'Edit');
    //populateFromDateView(lEnrolleeEdit, 'Birthdate', '#uOffenderProfileBirthdateEdit');
        //Vulnerability 3254.1
        // lEnrolleeEdit.FirstName = veritracks.system.encodeHtml(lEnrolleeEdit.FirstName);
        // lEnrolleeEdit.LastName = veritracks.system.encodeHtml(lEnrolleeEdit.LastName);
        // lEnrolleeEdit.FullName = veritracks.system.encodeHtml(lEnrolleeEdit.FullName);
        // lEnrolleeEdit.PrimaryId = veritracks.system.encodeHtml(lEnrolleeEdit.PrimaryId);
        // lEnrolleeEdit.SecondaryId = veritracks.system.encodeHtml(lEnrolleeEdit.SecondaryId);
        // lEnrolleeEdit.FullName = lEnrolleeEdit.FirstName + ' ' + lEnrolleeEdit.LastName;
    var lbday = new Date(lEnrolleeEdit.Birthdate);
    if (lbday.getFullYear() > 1900) {
        lEnrolleeEdit.Birthdate = displayShortDate(lbday);
    } else {
        lEnrolleeEdit.Birthdate = '';
    }


    if ($("#uOffenderProfileOffenderPayFlagEdit").prop("checked") == true) {
        lEnrolleeEdit.OffenderPayFlag = 1;
    } else {
        lEnrolleeEdit.OffenderPayFlag = 0;
    }

    if ($("#uOffenderProfileAlcoholDeviceFlagEdit").prop("checked") == true) {
        lEnrolleeEdit.AlcoholDeviceFlag = 1;
    } else {
        lEnrolleeEdit.AlcoholDeviceFlag = 0;
    }

    if (lEnrolleeEdit.ReferralDate.getFullYear() < 1900) {
        delete lEnrolleeEdit.ReferralDate;
    }
    // fix for new enrollee timezone

    lBuilder = new SumoPredicateBuilder();
    lBuilder.AddNewExpressionConditional('TimeZoneCode', lEnrolleeEdit.TimeZoneCode, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    var lTimezone = query(getDataItems('TimeZone'), lBuilder.RootExpression);
    for (var lKey in lTimezone) {
        if (lTimezone.hasOwnProperty(lKey)) {
            lEnrolleeEdit.TimeZoneId = lTimezone[lKey].Id;
        }
    }
    if (lEnrolleeEdit.Id == -1) {
        lBuilder.Clear();
        // check for duplicate primary id
        lEnrolleeEdit.PrimaryId = $.trim(lEnrolleeEdit.PrimaryId);
        var lCheckNoSpecialChars = lEnrolleeEdit.PrimaryId.replace(/[^a-zA-Z0-9]/g, '');
        lBuilder.AddNewExpressionConditional('PrimaryId', lEnrolleeEdit.PrimaryId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());
        lBuilder.AddNewExpressionConditional('PrimaryId', lCheckNoSpecialChars, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());
        ReadMultiple(gObjectList.Enrollee.AssemblyQualifiedName, lBuilder.RootExpression, 0, EnrolleeDuplicatePrimaryID_OnSuccess, null, { 'EnrolleeEdit': lEnrolleeEdit }, null, 0);
    }
    else {// (lEnrolleeEdit.Id !== -1) {
        WriteSingle(lEnrolleeEdit, enrolleesOffenderSave_OnComplete, enrolleesOffenderSave_OnFailure, { 'EnrolleeId': mEnrolleesData.OffenderEditingId, 'OffenderProfile': mEnrolleesData.OffenderProfileCurrent, 'IsNew': (lEnrolleeEdit.Id === -1) });
        if (parseInt(lEnrolleeEdit.OrganizationId) !== lOriginalOrganizationId) {
            lDeviceAssignments = gCurrentDeviceAssignment[lEnrolleeEdit.Id];
            if (!isNullOrUndefined(lDeviceAssignments)) {

                for (lKey in lDeviceAssignments) {
                    if (lDeviceAssignments.hasOwnProperty(lKey)) {
                        lItem = lDeviceAssignments[lKey];
                        lDevice = getDataItem(lItem.Id, 'Devices');
                        if (!isNullOrUndefined(lDevice)) {
                            lDevice.OrganizationId = lEnrolleeEdit.OrganizationId;
                            lDevice.UserId = gUserDetails.UserId
                            lDeviceWrite.push(lDevice);
                        }
                    }
                }
                if (lDeviceWrite.length > 0) {
                    WriteMultiple(lDeviceWrite, null, null, null, false, true);
                }
            }
        }
        var lCachedEnrollee = getDataItem(lEnrolleeEdit.Id, 'Enrollees');
        // Work for User Story 1954
        // avoid read if organization id and/or agent id has been changed.
        if (lCachedEnrollee.OrganizationId != parseInt(lEnrolleeEdit.OrganizationId)) {
            // moving blubox groups
            EnrolleeMoveBluBoxGroups_Init(lEnrolleeEdit);
        }
        // moving zones
        if (lCachedEnrollee.AgentId != parseInt(lEnrolleeEdit.AgentId) || lCachedEnrollee.OrganizationId != parseInt(lEnrolleeEdit.AgentId)) {
            var lBuilder = new SumoPredicateBuilder();
            lBuilder.Clear();
            lBuilder.AddNewExpressionConditional('EnrolleeId', getArrayByIds([lEnrolleeEdit]), false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            ReadMultiple(gObjectList.ZoneEnrollee.AssemblyQualifiedName, lBuilder.RootExpression, 0, MoveZoneEnrollee_OnSuccess, null, lEnrolleeEdit, null, 0, true);
        }
    }

    if (mEnrolleesData.OffenderPhotos.length > 0 && mEnrolleesData.OffenderPhotoDescription != mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoDescription && mEnrolleesData.OffenderPhotoDescription != '') {

        lCurrentOffender = new OffenderPhoto();
        lCurrentOffender.Id = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].Id;
        lCurrentOffender.EnrolleeId = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].EnrolleeId;
        lCurrentOffender.PhotoUri = null;
        lCurrentOffender.PhotoOrderNo = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoOrderNo;
        lCurrentOffender.IsActive = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].IsActive;
        lCurrentOffender.PhotoDescription = mEnrolleesData.OffenderPhotoDescription;
        lCurrentOffender.PhotoTypeId = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoTypeId;
        if (mEnrolleesData.OffenderPhotosEdited.length == 0) {
            mEnrolleesData.OffenderPhotosEdited.push(lCurrentOffender);
        } else {
            for (var i = 0; i < mEnrolleesData.OffenderPhotosEdited.length; i++) {
                if (mEnrolleesData.OffenderPhotosEdited[i].Id == lCurrentOffender.Id && mEnrolleesData.OffenderPhotosEdited[i].PhotoUri == null) {
                    mEnrolleesData.OffenderPhotosEdited[i] = lCurrentOffender;
                    lFoundOffender = true;
                    break;
                }//end of if
            }//end of for

            if (!lFoundOffender) {
                mEnrolleesData.OffenderPhotosEdited.push(lCurrentOffender);
            }
        }//end of else

        mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoDescription = mEnrolleesData.OffenderPhotoDescription;
    }//end of outer if
    mEnrolleesData.OffenderPhotoDescription = '';

    enrolleesOffenderPhotoSave();
}

function EnrolleeDuplicatePrimaryID_OnSuccess(aParams, aData) {
    "use strict";
    var lEnrolleeEdit = aParams.EnrolleeEdit;
    if (ObjectLength(aData) < 1) {
        WriteSingle(lEnrolleeEdit, enrolleesOffenderSave_OnComplete, enrolleesOffenderSave_OnFailure, { 'EnrolleeId': mEnrolleesData.OffenderEditingId, 'OffenderProfile': mEnrolleesData.OffenderProfileCurrent, 'IsNew': (lEnrolleeEdit.Id === -1) })
    } else {
        enrolleeOffenderEnterEditMode();
        $('#uPrimaryIdAlert').show();
        setLoadingBarStatus('uEnrolleesProfilePanelLoadingBar', 'uOffenderProfilePanel', false);
    }
}
//NEEDS REFACTORING -- Merge agents.js and enrollees.js methods are identical
// zone move methods
function EnrolleeZoneMove_OnSuccess(aParams, aData) {
    var lItem,
        lKey;

    FixDates(aData);
    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lItem = aData[lKey];
            setDataItem(lItem.Id, 'Zones', lItem);
        }
    }

    mActivityNotification.addNotification(localizeWrapper('cAgentZoneMoveSuccess'));
}

function EnrolleeZoneMove_OnFailure() {
    mActivityNotification.addNotification(localizeWrapper('cAgentZoneMoveFailed'));
}

function MoveZoneEnrollee_OnSuccess(aParams, aData) {
    var lEnrolleeZones = aData,
        lBuilder = new SumoPredicateBuilder(),
        lZoneIds = getArrayByIds(lEnrolleeZones),
        lEnrollee = aParams,
        lZoneList,
        lZoneCount = {},
        lMoveZoneWrite = [],
        lKeyA,
        lKeyB;

    // get count of enrollees appearing in zones to be moved
    for (lKeyA in lZoneIds) {
        if (lZoneIds.hasOwnProperty(lKeyA)) {
            var lnum = lZoneIds[lKeyA];
            lZoneCount[lnum] = lZoneCount[lnum] ? lZoneCount[lnum] + 1 : 1;
        }
    }

    // gather zones that may be moved.
    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('Id', lZoneIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lZoneList = query(getDataItems('Zones'), lBuilder.RootExpression);

    for (lKeyB in lZoneList) {
        if (lZoneList.hasOwnProperty(lKeyB)) {
            var lZone = lZoneList[lKeyB];
            if (lZone.EnrolleeCount == lZoneCount[lZone.Id] && (lZone.AgentId != lEnrollee.AgentId || lZone.OrganizationId != lEnrollee.OrganizationId)) {
                lZone.AgentId = lEnrollee.AgentId;
                lZone.OrganizationId = lEnrollee.OrganizationId;
                lMoveZoneWrite.push(lZone);
            } else {
                // not to be moved
            }
        }
    }

    if (ObjectLength(lMoveZoneWrite) > 0) {
        //  mActivityNotification.addNotification('Moving Zones........');
        WriteMultiple(lMoveZoneWrite, EnrolleeZoneMove_OnSuccess, EnrolleeZoneMove_OnFailure, null, false);
    } else {
        //    mActivityNotification.addNotification('No Zones Moved');
    }
}

// BBG move methods
function EnrolleeMoveDeviceClusters_OnSuccess(aParams, aData) {
    var lItem,
        lKey;

    FixDates(aData);
    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lItem = aData[lKey];
            setDataItem(lItem.Id, 'DeviceClusters', lItem);
        }
    }

    mActivityNotification.addNotification(localizeWrapper('cAgentBluBoxGroupMoveSuccess'));
}

function EnrolleeMoveDeviceClusters_OnFailure(aParams, aData) {
    mActivityNotification.addNotification(localizeWrapper('cAgentBluBoxGroupMoveFailed'));
}

function EnrolleeMoveBluBoxGroups_Init(aData) {
    var lBuilder = new SumoPredicateBuilder(),
        lDeviceClustersEnrollees,
        lDeviceClusters,
        lDeviceClustersCollection = [],
        lDeviceClusterCount = {},
        lDeviceClusterIds = [],
        lEnrollee = aData,
        lEnrolleeIds = getArrayByIds([aData]);

    // gather device cluster enrollees
    lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrolleeIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lDeviceClustersEnrollees = query(getDataItems('DeviceClusterEnrollee'), lBuilder.RootExpression);


    // get Device cluster ids and count
    for (var lKey in lDeviceClustersEnrollees) {
        if (lDeviceClustersEnrollees.hasOwnProperty(lKey)) {
            var lnum = lDeviceClustersEnrollees[lKey].DeviceClusterId;
            lDeviceClusterIds.push(lnum);
            lDeviceClusterCount[lnum] = lDeviceClusterCount[lnum] ? lDeviceClusterCount[lnum] + 1 : 1;
        }
    }

    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('Id', lDeviceClusterIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lDeviceClusters = query(getDataItems('DeviceClusters'), lBuilder.RootExpression);

    for (var lKey in lDeviceClusters) {
        if (lDeviceClusters.hasOwnProperty(lKey)) {
            var lDeviceCluster = lDeviceClusters[lKey];
            if (lDeviceCluster.EnrolleeCount == lDeviceClusterCount[lDeviceCluster.Id] && lDeviceCluster.OrganizationId != lEnrollee.OrganizationId) {
                lDeviceCluster.OrganizationId = lEnrollee.OrganizationId;
                lDeviceClustersCollection.push(lDeviceCluster);
            }
        }
    }

    if (ObjectLength(lDeviceClustersCollection) > 0) {
        WriteMultiple(lDeviceClustersCollection, EnrolleeMoveDeviceClusters_OnSuccess, EnrolleeMoveDeviceClusters_OnFailure, null, true);
    } else {
        //   mActivityNotification.addNotification('No BLUbox groups Moved');
    }

}

function uOffenderProfileSave_OnComplete(aParams, aData) {
    "use strict";
    function onShow() {
        enrolleeOffenderExitEditMode();
        offenderProfileRead_OnComplete(aParams, [aData]);
        if (!aParams.IsNew) {
            enrolleesResetOffenderCardView(aParams.Enrollee.Id);
        } else {
            enrolleesDataListConverter();
            window.location.hash = 'Enrollees.Offenders.Profile.Addresses.' + aParams.Enrollee.Id.toString();
        }
        //enrolleesResetOffenderCardView(aData.Id);
        mEnrolleesData.OffenderEditingId = null;
    }

    if (mEnrolleesData.QueuedFrps.length > 0) {
        uSaveEnrolleeFrpFinal(aData.Id);
    }
   
    if (aParams.Enrollee.OffenderPayFlag == 1) {
        getEnrolleePayArchived(aParams.Enrollee, aData);
    }

    setLoadingBarStatus('uEnrolleesProfilePanelLoadingBar', 'uOffenderProfilePanel', false, onShow);
    //mEnrolleesControls.CardView.selected(aParams.Id);
}

function uOffenderProfileSave_OnFailure(a, b, c, d, e) {
    "use strict";
    console.log(a, b, c, d, e);
    setLoadingBarStatus('uEnrolleesProfilePanelLoadingBar', 'uOffenderProfilePanel', false);
    mActivityNotification.addNotification(localizeWrapper('cDefaultGothimSaveFail'));
}

function enrolleesOffenderProfileCategoriesWrite_OnSuccess(aParams, aData) {
    "use strict";
    offenderCategoryRead_OnComplete(aParams, aData);
}

function enrolleesOffenderProfileCategoriesWrite_OnFailure(a, b, c) {
    "use strict";
}

function enrolleesOffenderSexOffensesWrite_OnSuccess(aParams, aData) {
    "use strict";
    offenderSexOffenseRead_OnComplete(aParams, aData);
}

function enrolleesOffenderSexOffensesWrite_OnFailure(a, b, c) {
    "use strict";
}

function enrolleesOffenderEditCancel() {
    enrolleeOffenderExitEditMode();
    $('#uOffenderImageUploadContainer').hide();
    $('#uPhotoTypeContainer').hide();
    ClearValidation();
    enrolleesOffenderImageUpload_Reset();
}

function enrolleesVictimEditCancel() {

}

function isAssignedCheck() {
    "use strict";
    var lEnrollee;

    if(mEnrolleesControls.CardView){
        lEnrollee = mEnrolleesControls.CardView.selectedDataItem();
    }

    if (!isNullOrUndefined(lEnrollee)) {
        if (lEnrollee.IsAssigned) {
            $('#uEnrolleesRemoveAssignment').show();
                $('#uEnrolleesRemoveVictimAssignment').show();
        } else {
            $('#uEnrolleesRemoveAssignment').hide();
                $('#uEnrolleesRemoveVictimAssignment').hide();
        }
        //disable the action buttons if the user is a T-Band user
        const lProductId = getProductIdFromEnrolleeId(lEnrollee.Id);
        const lIsTBand = lProductId === 161;
        if(lIsTBand){
            disableDeviceAction(); 
        }else {
            enableDeviceAction();
            
        }
    }
    
}

function enrolleesOffenderImageUpload_Reset() {
    "use strict";
    $('#uOffenderImageUploadContainer').attr('src', 'ImageUpload.html');
}

function addEditOffenderPhoto(aFileName, aAction) {
    "use strict";
    var html = [],
        lKey = mEnrolleesData.OffenderPhotos.length,
        lParams = { 'description': 'Default', 'type': '1' };

    function onHide() {
        enrolleesOffenderPhotoSave(lParams);
    }

    if (aAction == "add") {

        if ($("#uOffenderPhotoDescriptionEdit").val() != '') {
            lParams.description = veritracks.system.encodeHtml($("#uOffenderPhotoDescriptionEdit").val());
        }
        lParams.type = $("#uPhotoType").val();

        $("#uOffenderPhotoDescriptionContainer").hide();

        var newOffenderPhoto = new OffenderPhoto();
        newOffenderPhoto.EnrolleeId = parseInt(mEnrolleesData.OffenderProfileCurrent.Id);
        newOffenderPhoto.PhotoUri = aFileName;
        newOffenderPhoto.PhotoOrderNo = mEnrolleesData.OffenderPhotos.length + 1;
        newOffenderPhoto.ActiveFlag = 1;
        mEnrolleesData.OffenderPhotosAdded.push(newOffenderPhoto);
        $("#uOffenderProfilePhotoUri").attr("src",  MUGSHOTS + aFileName);
        $("#uOffenderProfilePhotoUri").attr("title", lParams.description);
        $("#uNextOffenderPhotoButton").hide();
        $("#uNextOffenderPhotoButtonContainer").show();
        if (mEnrolleesData.OffenderPhotos.length > 1) {
            $("#uPreviousOffenderPhotoButton").show();
            $("#uPreviousOffenderPhotoButtonContainer").hide();
            mEnrolleesData.OffenderPhotoIndex = mEnrolleesData.OffenderPhotoIndex + 1;
        }



        $("#uOffenderProfilePhotoUri").css("width", "auto");
        setLoadingBarStatus('uEnrolleesProfilePanelLoadingBar', 'uOffenderProfilePanel', true, onHide)

    } else if (aAction == "edit") {

        if (aFileName != '') {
            var lCurrentOffenderPhoto = new OffenderPhoto();
            lCurrentOffenderPhoto.Id = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].Id;
            lCurrentOffenderPhoto.EnrolleeId = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].EnrolleeId;
            lCurrentOffenderPhoto.IsActive = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].IsActive;
            lCurrentOffenderPhoto.PhotoDescription = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoDescription;
            lCurrentOffenderPhoto.PhotoOrderNo = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoOrderNo;
            lCurrentOffenderPhoto.PhotoTypeId = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoTypeId;
        var newPhotoUri = $("#uOffenderProfilePhotoUri").attr("src");
        newPhotoUri = newPhotoUri.replace("Images/Mugshots/", "");
            lCurrentOffenderPhoto.PhotoUri = newPhotoUri;
            mEnrolleesData.OffenderPhotosEdited.push(lCurrentOffenderPhoto);
        }


    }

}
function uCancelOffenderButton_OnClick() {
    "use strict";
    var lIsEmpty;
    //PhoneInternationalNumber 
    $("#uEMACellPhoneNumber").show();
    $("#OffenderProfileCellPhoneNumber .iti").hide();
    enrolleesOffenderEditCancel();
    enrolleesOffenderEditCancel();
    if (mEnrolleesData.OffenderEditingId === -1) {
        mEnrolleesControls.CardView.selected(mEnrolleesData.OffenderCurrentId);
    }
    mEnrolleesData.OffenderEditingId = null;
    $('#uOffenderImageUploadContainer').hide();
    lIsEmpty = (mEnrolleesData.OffenderDirty.length === 0);
    veritracks.system.applyFilterState('Enrollees', lIsEmpty);
    if (mEnrolleesData.OffenderCurrentId > 0) {
        var lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees');
        if (lEnrollee.InMyOrganization)
            $('#uEditOffenderButton').show();
        else
            $('#uEditOffenderButton').hide();
    }

    if (mEnrolleesData.OffenderPhotosAdded.length != 0 || mEnrolleesData.OffenderPhotosDeleted != 0 || mEnrolleesData.OffenderPhotosEdited != 0 || mEnrolleesData.OffenderPhotoIndex != 0) {
        offenderPhoto_OnSuccess(null, mEnrolleesData.OffenderPhotos);
    }
    $("#uPreviousOffenderPhotoButton").hide();
    $("#uPreviousOffenderPhotoButtonContainer").show();
    $("#uPhotoTypeContainer").hide();
    //$("#uNextOffenderPhotoButton").hide();

    mEnrolleesData.OffenderPhotosAdded = [];
    mEnrolleesData.OffenderPhotosDeleted = [];
    mEnrolleesData.OffenderPhotosEdited = [];
    mEnrolleesData.OffenderPhotoDescription = '';
    mEnrolleesData.OffenderPhotoIndex = 0;
    offenderProfilePopulate();
    mEnrolleesData.QueuedFrps = [];
    if(mEnrolleesData.OffenderCurrentEMAFlag && mEnrolleesData.OffenderCurrentEMAFlag === 1) {
        $('#uEMAHasEnrolleeMobileApp').val('Yes');
        $('#uEMAHasEnrolleeMobileAppEdit').prop('checked', true);
    }else {
        $('#uEMAHasEnrolleeMobileApp').val('No');
        $('#uEMAHasEnrolleeMobileAppEdit').prop('checked', false);
    }
    
    CloseModal();
   // $("#ar1RiskLevelWarning").hide();
}


function uGetImageUploadRendered() {
    "use strict";

    if ($("#uOffenderImageUploadContainer").css("display") == "none") {
        return false;
    }

    return true;
}


function uOffenderPhotoAction() {
    "use strict";
    var lResult = "edit";
    if ($('#uOffenderImageUploadContainer').hasClass("pseudoOffenderDeleteClicked")) {
        lResult = "delete";
    } else if ($('#uOffenderImageUploadContainer').hasClass("pseudoOffenderAddClicked")) {
        lResult = "add";
    }
    return lResult;
}

function uEditOffenderPhotoButton_OnClick(aButton, aContainer) {
    "use strict";
    //disabled button
    if ($(aContainer).hasClass("DisabledOffenderActionButtons")) {
        if (aButton == "add") {
            mActivityNotification.addNotification(localizeWrapper('cEnrolleeImageNeedsOffenderCreate'));
        }
        return;
    }

    //$("#uOffenderProfilePhotoUri").removeClass("AlcoholUploadedImage");

    $('#uOffenderPhotoEditButton').hide();
    $("#uOffenderPhotoAddButton").hide();
    $('#uOffenderPhotoCancelButton').show();

    if (aButton == "edit") {
        $("#uOffenderPhotoDeleteButton").hide();
        $('#uOffenderImageUploadContainer').addClass("pseudoOffenderEditClicked");
        $('#uOffenderImageUploadContainer').show();
        $('#uOffenderPhotoDescriptionContainer').show();
        $("#uOffenderPhotoDescriptionEdit").val(mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoDescription);
        if (mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoTypeId == 5 || mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoTypeId == 4) {
            $("#uPhotoTypeContainer").hide();
            $("#uOffenderImageUploadContainer").hide();
        } else {
            $("#uPhotoTypeContainer").show();
            $("#uOffenderImageUploadContainer").show();
        }
        
        mEnrolleesData.OffenderPhotoDescription = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoDescription;
    } else if (aButton == "add") {
        $('#uOffenderImageUploadContainer').addClass("pseudoOffenderAddClicked");
        var lNewPhoto = new OffenderPhoto();
        mEnrolleesData.OffenderPhotos.push(lNewPhoto);
        $("#uOffenderProfilePhotoUri").attr("src", "Images/NoPhoto.png");
        $("#uOffenderProfilePhotoUri").attr("title", "Default");
        $("#uOffenderPhotoDeleteButton").hide();
        $('#uOffenderImageUploadContainer').show();
        $('#uOffenderPhotoDescriptionContainer').show();
        $("#uPhotoTypeContainer").show();
        $("#uOffenderPhotoDescriptionEdit").val('');
        $("#uPhotoType").val('1');
        $("#uPreviousOffenderPhotoButton").hide();
        $("#uPreviousOffenderPhotoButtonContainer").show();
        $("#uNextOffenderPhotoButton").hide();
        $("#uNextOffenderPhotoButtonContainer").show();
        updatePhotoNumbers(mEnrolleesData.OffenderPhotos.length);
    } else {
        $("#uOffenderPhotoDeleteButton").show();
        $('#uOffenderImageUploadContainer').addClass("pseudoOffenderDeleteClicked");
        $('#uOffenderImageUploadContainer').hide();
        $('#uOffenderPhotoDescriptionContainer').hide();
        //delete the current offender photo
        if (mEnrolleesData.OffenderPhotos.length > 0) {
            uDeleteMainOffenderPhoto();
        }

    }
}

function cleanOffenderPhotos() {
    "use strict";
    var lOffenderPhotos = mEnrolleesData.OffenderPhotos,
        lDeleteCount = 0;

    for (var lKey in lOffenderPhotos) {
        if (lOffenderPhotos.hasOwnProperty(lKey) && lOffenderPhotos[lKey].Id == -1) {
            lOffenderPhotos.splice(lKey, 1);
            lDeleteCount++;
        }
    }

    if (lDeleteCount > 0) {

        if (mEnrolleesData.OffenderPhotoIndex == 0) {
            $("#uPreviousOffenderPhotoButton").hide();
            $("#uPreviousOffenderPhotoButtonContainer").show();
            if (mEnrolleesData.OffenderPhotos.length > 1) {
                $("#uNextOffenderPhotoButton").show();
                $("#uNextOffenderPhotoButtonContainer").hide();
            } else {
                $("#uNextOffenderPhotoButton").hide();
                $("#uNextOffenderPhotoButtonContainer").show();
            }

        } else if (mEnrolleesData.OffenderPhotoIndex == mEnrolleesData.OffenderPhotos.length - 1) {
            $("#uNextOffenderPhotoButton").hide();
            $("#uNextOffenderPhotoButtonContainer").show();
            $("#uPreviousOffenderPhotoButton").show();
            $("#uPreviousOffenderPhotoButtonContainer").hide();
        } else {
            $("#uNextOffenderPhotoButton").show();
            $("#uNextOffenderPhotoButtonContainer").hide();
            $("#uPreviousOffenderPhotoButton").show();
            $("#uPreviousOffenderPhotoButtonContainer").hide();
        }

        if (mEnrolleesData.OffenderPhotos.length >= 1) {
            $("#uOffenderProfilePhotoUri").attr("src",  MUGSHOTS + mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoUri);
            $("#uOffenderProfilePhotoUri").attr("title", mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoDescription);
        } else {
            $("#uOffenderProfilePhotoUri").attr("src", "Images/NoPhoto.png");
            $("#uOffenderProfilePhotoUri").attr("title","Default");
        }
    }


}

function updatePhotoNumbers(aNumber) {
    "use strict";

    if (!isNullOrUndefined(aNumber)) {
        $("#uCurrentPhotoIndex").html(aNumber);
    } else if (mEnrolleesData.OffenderPhotos.length == 0) {
        $("#uCurrentPhotoIndex").html(mEnrolleesData.OffenderPhotoIndex);
    } else {
        $("#uCurrentPhotoIndex").html(mEnrolleesData.OffenderPhotoIndex + 1);
    }

    $("#uTotalPhotoIndex").html(mEnrolleesData.OffenderPhotos.length);
}

function uCancelOffenderPhotoButton_OnClick() {
    "use strict";

    $('#uOffenderImageUploadContainer').hide();
    $("#uOffenderPhotoDescriptionContainer").hide();
    enrolleesOffenderImageUpload_Reset();
    cleanOffenderPhotos();
    $('#uOffenderPhotoDeleteButton').show();
    $('#uOffenderPhotoAddButton').show();
    $('#uOffenderPhotoEditButton').show();

    if (mEnrolleesData.OffenderPhotos.length == 0) {
        $('#uOffenderPhotoDeleteButton').addClass("DisabledOffenderActionButtons");
        $('#uOffenderPhotoEditButton').addClass("DisabledOffenderActionButtons");
    } else {
        $('#uOffenderPhotoDeleteButton').removeClass("DisabledOffenderActionButtons");
        $('#uOffenderPhotoEditButton').removeClass("DisabledOffenderActionButtons");
    }
    $('#uOffenderPhotoCancelButton').hide();
    $('#uPhotoTypeContainer').hide();
    updatePhotoNumbers();
    resetImageUploadContainerAction();

}

 function resetImageUploadContainerAction() {
    "use strict";
    if ($('#uOffenderImageUploadContainer').hasClass("pseudoOffenderEditClicked")) {
        $('#uOffenderImageUploadContainer').removeClass("pseudoOffenderEditClicked");
    }

    if ($('#uOffenderImageUploadContainer').hasClass("pseudoOffenderAddClicked")) {
        $('#uOffenderImageUploadContainer').removeClass("pseudoOffenderAddClicked");
    }

    if ($('#uOffenderImageUploadContainer').hasClass("pseudoOffenderDeleteClicked")) {
        $('#uOffenderImageUploadContainer').removeClass("pseudoOffenderDeleteClicked");
    }
}

function uOffenderPhotoDescriptionSet() {
    "use strit";
    var lBadScriptRexex = /(\b)(on\S+)(\s*)=|javascript|<(|\/|[^\/>][^>]+|\/[^>][^>]+)>/ig;
    if (lBadScriptRexex.test($("#uOffenderPhotoDescriptionEdit").val())) {
        $("#uOffenderPhotoDescriptionEdit").val('');
        mEnrolleesData.OffenderPhotoDescription = '';
    } else {
        mEnrolleesData.OffenderPhotoDescription = veritracks.system.encodeHtml($("#uOffenderPhotoDescriptionEdit").val());
    }
}


function uChangePhotoType(aValue) {
    "use strict";
    var lPhoto = new OffenderPhoto(),
        lNewPhoto = new OffenderPhoto();

    if (mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].Id != -1) {
        lNewPhoto.Id = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].Id;
        lPhoto.Id = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].Id;
        lNewPhoto.EnrolleeId = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].EnrolleeId;
        lPhoto.EnrolleeId = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].EnrolleeId;
        lNewPhoto.IsActive = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].IsActive;
        lPhoto.IsActive = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].IsActive;
        lNewPhoto.PhotoTypeId = parseInt(aValue);
        lPhoto.PhotoTypeId = parseInt(aValue);
        lNewPhoto.PhotoUri = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoUri;
        lNewPhoto.PhotoDescription = mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoDescription;
        lPhoto.PhotoUri = null;
        lPhoto.PhotoDescription = null;
        mEnrolleesData.OffenderPhotosEdited.push(lPhoto);

        //replace current photo with new one
        for (var lKey in mEnrolleesData.OffenderPhotos) {
            if (mEnrolleesData.OffenderPhotos.hasOwnProperty(lKey) && mEnrolleesData.OffenderPhotos[lKey].Id == lNewPhoto.Id) {
                mEnrolleesData.OffenderPhotos[lKey] = lNewPhoto;
                break;
            }
        }//end of for
    }//end of if

}

function uOffenderPhotoHolderSet(aFileName, aAction) {
    "use strict";

    if (aAction == "edit" && !isNullOrUndefined(aFileName) && aFileName != '') {
        $('#uOffenderProfilePhotoUri').attr('src', MUGSHOTS + aFileName);
        $('#uOffenderProfilePhotoUriEdit').val(aFileName);
    }

    if ((aFileName.indexOf(".png") != -1 || aFileName.indexOf(".jpg") != -1 || aFileName.indexOf(".jpeg") != -1) && aFileName != "") {

        $('#uOffenderPhotoCancelButton').hide();
        $("#uOffenderPhotoDeleteButton").show();
        $("#uOffenderPhotoDeleteButton").css("display", "table");
        $('#uOffenderPhotoEditButton').show();
        $('#uOffenderPhotoEditButton').css("display", "table");

        if (mEnrolleesData.OffenderPhotos.length > 0) {
            $("#uOffenderPhotoDeleteButton").removeClass("DisabledOffenderActionButtons");
            $('#uOffenderPhotoEditButton').removeClass("DisabledOffenderActionButtons");
        } else {
            $("#uOffenderPhotoDeleteButton").addClass("DisabledOffenderActionButtons");
            $('#uOffenderPhotoEditButton').addClass("DisabledOffenderActionButtons");
        }
        $("#uOffenderPhotoAddButton").show();
        $("#uOffenderPhotoAddButton").css("display", "table");
        $('#uOffenderImageUploadContainer').hide();
        $("#uOffenderPhotoDescriptionContainer").hide();
        $("#uPhotoTypeContainer").hide();
        enrolleesOffenderImageUpload_Reset();
        resetImageUploadContainerAction();
        addEditOffenderPhoto(aFileName, aAction);
    }

}
//-------------
// Assignments
//-------------
    function enrolleeDeviceSetStatus_OnSuccess(aParams, aData) {
    "use strict";
    var lDevice,
        lKey;
    for (lKey = 0; lKey < aData.length; lKey++) {
        lDevice = aData[lKey];
        setDataItem(lDevice.Id, 'Devices', lDevice);
    }

}

function offenderDeviceSetStatus_OnFailure(aParams, a, b, c) {
    "use strict";
}

function enrolleeAddOnDelete() {
    "use strict";
    var lAssignmentList = getDataItems('CurrentDeviceAssignments'),
        lAssignmentWrite = [],
        lDeviceWrite = [],
        lAssignmentQuery,
        lAssignment,
        lDevice,
        lKey,
        lEnrollee,
        lNow = new Date(),
        lIsDeviceUnassigned = true,
        lBuilder = new SumoPredicateBuilder();

    lBuilder.AddNewExpressionConditional('EnrolleeId', mEnrolleesData.OffenderCurrentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lAssignmentQuery = query(lAssignmentList, lBuilder.RootExpression);
    for (var lKey in lAssignmentQuery) {
        if (lAssignmentQuery.hasOwnProperty(lKey)) {
            if (lAssignmentQuery[lKey].ProductId == 111) {
                lAssignment = lAssignmentQuery[lKey];
            }
        }
    }

    lAssignment.ReasonForChange = 'None';
    lAssignment.EndDate = lNow;
    lAssignmentWrite.push(prepareObjectFrWcf(lAssignment));
    lDevice = getDataItem(lAssignment.Id, 'Devices');
    lDevice.Status = 5;
    lDevice.UserId = gUserDetails.UserId;
    lDeviceWrite.push(lDevice);


    WriteMultiple(lAssignmentWrite, tesmethod, offenderDeviceAssignment_OnFailure, null, false);
    WriteMultiple(lDeviceWrite, tesmethod, offenderDeviceSetStatus_OnFailure, null, false);

}


function enrolleeOffenderUnenrollmentWrite_OnSuccess(aParams, aData) {
    "use strict";
    var lReasons,
        lReason = '',
        lBuilder = new SumoPredicateBuilder(),
        lAssignmentWrite = [],
        lDeviceWrite = [],
        lAssignmentList = getDataItems('CurrentDeviceAssignments'),
        lAssignments = mEnrolleesControls.DeviceAssignmentsListView.getDataSource(),
        lVictimTabEnabled = veritracks.system.clientSetting('VictimMonitoringEnabled'),
        llAssignmentQuery,
        lAssignment,
        lDevice,
        lKey,
        lEnrollee,
        lNow = new Date(),
        lOriList = [],
        lIsDeviceUnassigned = true;

    enrolleesResetOffenderCardView(aData.Id);
    lEnrollee = $.extend({}, getDataItem(aData.Id, 'Enrollees'));
    lOriList.push(lEnrollee.OrganizationId);
    function continueUnassignment(lDeviceReasons) {
        lBuilder.AddNewExpressionConditional('Id', aData.ReasonId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('EnrolleeTypeId', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lReasons = query(lDeviceReasons, lBuilder.RootExpression);
        lBuilder.Clear();

        for (lKey in lReasons) {
            if (lReasons.hasOwnProperty(lKey)) {
                lReason = lReasons[lKey].Description;
            }
        }

        lBuilder.AddNewExpressionConditional('EndDate', lNow, false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());
        lAssignments = query(lAssignments, lBuilder.RootExpression);
        lBuilder.Clear();

        for (lKey in lAssignments) {
            if (lAssignments.hasOwnProperty(lKey)) {
                lAssignment = lAssignments[lKey];
                lAssignment.ReasonForChange = lReason;
                lAssignment.EndDate = lNow;
                lAssignment.UnAssignedByUserId = aData.UserId;
                lAssignment.AttemptRecoverFlag = aData.AttemptRecoverFlag ? 1 : 0;
                lAssignmentWrite.push(prepareObjectForWcf(lAssignment));

                if ($("#uChargerReturned").prop("checked") == true) {
                    lAssignment.ChargerReturnStatus = uChangeChargerStatus();
                }

                lIsDeviceUnassigned = true;
                lDevice = getDataItem(lAssignment.Id, 'Devices');
                if ([104, 109].indexOf(lDevice.ProductId) !== -1) {
                    lBuilder.AddNewExpressionConditional('EnrolleeId', lAssignment.EnrolleeId, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
                    lBuilder.AddNewExpressionConditional('Id', lAssignment.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                    llAssignmentQuery = query(lAssignmentList, lBuilder.RootExpression);
                    lBuilder.Clear();
                    lIsDeviceUnassigned = (count(llAssignmentQuery) === 0);
                }
                if (lIsDeviceUnassigned) {
                    lDevice.Status = 5;
                    lDevice.UserId = gUserDetails.UserId;
                    lDeviceWrite.push(lDevice);
                }
            }
        }

        lEnrollee.IsAssigned = false;
        lEnrollee.Birthdate = BirthDateStringFormatter(lEnrollee.Birthdate);
        lEnrollee.AlcoholDeviceFlag = 0;


        WriteMultiple(lAssignmentWrite, offenderDeviceAssignment_OnSuccess, offenderDeviceAssignment_OnFailure, aData.Id, false);
        WriteMultiple(lDeviceWrite, enrolleeDeviceSetStatus_OnSuccess, offenderDeviceSetStatus_OnFailure, aData.Id, false);
        // call victim unenrollment here?
        if (lVictimTabEnabled && lEnrollee.HasVictimFlag) {
            lEnrollee.HasVictimFlag = false;
            WriteSingle(prepareObjectForWcf(lEnrollee), enrolleeDeviceAssignmentEnrollee_OnSuccess, offenderDeviceAssignmentEnrollee_OnFailure, aData.Id, false);
            lBuilder.Clear();
            lBuilder.AddNewExpressionConditional('OffenderId', lEnrollee.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            ReadMultiple(gObjectList.VictimProfile.AssemblyQualifiedName, lBuilder.RootExpression, 0, enrolleeVictimProfileUnenrollmentRead_OnComplete, failure, lEnrollee, null, 0);
        }
        else {
            WriteSingle(prepareObjectForWcf(lEnrollee), enrolleeDeviceAssignmentEnrollee_OnSuccess, offenderDeviceAssignmentEnrollee_OnFailure, aData.Id, false);
        }
        ClosePopup();
    }

    GetOriDeviceChangeReason(lOriList.join(","), lEnrollee.EnrolleeType,
            function (aParams, aData) {
                if (aData.length > 0) {
                    continueUnassignment(aData);
                } else {
                    //no data
                    continueUnassignment(getDataItems('DeviceChangeReason'));
                }
            },
            function () {
                //failed
                continueUnassignment(getDataItems('DeviceChangeReason'));
            });

    
}

function enrolleeVictimProfileUnenrollmentRead_OnComplete(aParams, aData) {
    var lEnrollement;
    var lVictim;
    var lVictimDevice;
    var lDeviceAssignments;
    var lDeviceAssignment;
    if (aData.length > 0) {
        lVictim = aData[0];
        lDeviceAssignments = gCurrentDeviceAssignment[lVictim.Id];
        for (var lKey in lDeviceAssignments) {
            if (lDeviceAssignments.hasOwnProperty(lKey)) {
                lDeviceAssignment = lDeviceAssignments[lKey];
            }
        }
        lVictimDevice = getDataItem(lDeviceAssignment.Id, 'Devices');
        if (lVictimDevice) {
            WriteVictimDeviceAssignmentPR(lVictim, lVictimDevice, null, offenderUnAssignmentVictim_OnSuccess, victimAssignment_OnFailure,
            {
                'Enrollee': aParams,
                'Victim': lVictim
            });
        }
    }
}

function offenderUnAssignmentVictim_OnSuccess(aParams, aData) {
    var lVictim = aParams.Victim;
    var lEnrollee = getDataItem(lVictim.Id, 'Enrollees');
    if (aData) {
        lVictim.FirstName = lEnrollee.FirstName;
        lVictim.LastName = lEnrollee.LastName;
        lVictim.OffenderId = -1;

        removeOffenderVictimPair(aParams.Enrollee.Id)
        WriteSingle(lVictim, enrolleeUnassignedVictimUnenrollmentWrite_OnSuccess, failure, aParams, true);
    }
}

function enrolleeUnassignedVictimUnenrollmentWrite_OnSuccess(aParams, aData) {
    mActivityNotification.addNotification(localizeWrapper('cEnrolleeVictimOffenderUnPairComplete'));
}

function enrolleeOffenderUnenrollmentWrite_OnFailure(aParams, a, b, c) {
    "use strict";
    $('#uPopupContainer .SaveButton').show();
    var l = '';
}

function enrolleesOffenderDeviceClusterUnenrollmentWrite_OnSuccess(aParams, aData) {
    "use strict";
    var lDeviceCluster;
    var lDeviceClusterDevices;
    var lDeviceClusterDeviceList = [];
    var lDevice;
    var lDevices = [];
    var lBuilder = new SumoPredicateBuilder();
    var lKey;
    var lDeviceClusterEnrollees = [];
    var lEnrolleeCount = 1;

    if (aData[0]) {
        lDeviceCluster = getDataItem(aData[0].DeviceClusterId, 'DeviceClusters');

        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('DeviceClusterId', aData[0].DeviceClusterId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

        lDeviceClusterEnrollees = query(getDataItems('DeviceClusterEnrollee'), lBuilder.RootExpression);

        if(ObjectLength(lDeviceClusterEnrollees) > 0){
            lEnrolleeCount += ObjectLength(lDeviceClusterEnrollees);
        }
        if (lDeviceCluster && lEnrolleeCount == 1) {
            lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('DeviceClusterId', lDeviceCluster.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lDeviceClusterDevices = query(getDataItems('DeviceClusterDevices'), lBuilder.RootExpression);
            for (lKey in lDeviceClusterDevices) {
                if (lDeviceClusterDevices.hasOwnProperty(lKey)) {
                    lDeviceClusterDevices[lKey].IsActive = false;
                    lDeviceClusterDeviceList.push(lDeviceClusterDevices[lKey]);
                    lDevice = getDataItem(lDeviceClusterDevices[lKey].DeviceId, 'Devices');
                    if (lDevice) {
                        lDevice.Status = 5;
                        lDevices.push(lDevice);
                    }
                    if (lDeviceCluster.DeviceCount > 0)
                        lDeviceCluster.DeviceCount = lDeviceCluster.DeviceCount - 1;

                }
            }
            WriteMultiple(lDevices, DeviceClusterUnassignmentDevice_OnSuccess, Sad, null);
            WriteMultiple(lDeviceClusterDeviceList, DeviceClusterDeviceUnassignmentDevice_OnSuccess, Sad, null, false);
        }
        lDeviceCluster.EnrolleeCount = lEnrolleeCount - 1;
        if (lDeviceCluster.EnrolleeCount == 0 && lDeviceCluster.DeviceCount == 0) {
            lDeviceCluster.IsActive = false;
        }
        WriteSingle(lDeviceCluster, DeviceClusterUnassignmentUpdateEnrollee_OnSuccess, Sad, null, false);
    }
    mEnrolleesData.OffenderDeviceClusters = [];
}

function DeviceClusterUnassignmentUpdateEnrollee_OnSuccess(aParams, aData) {
    "use strict";
    setDataItem(aData.Id, 'DeviceClusters', aData);
}

function DeviceClusterDeviceUnassignmentDevice_OnSuccess(aParams, aData) {
    "use strict";
    var lKey;

    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            setDataItem(aData[lKey].Id, 'DeviceClusterDevices', aData);
        }
    }
}

function DeviceClusterUnassignmentDevice_OnSuccess(aParams, aData) {
    "use strict";
    var lKey;

    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            setDataItem(aData[lKey].Id, 'Devices', aData);
        }
    }
}

function enrolleesOffenderDeviceClusterUnenrollmentWrite_OnFailure(aParams, a, b, c) {
    "use strict";
}

function enrolleesOffenderEventCloseWrite_OnFailure(aParams, a, b, c) {
    "use strict";
}

function enrolleesOffenderEidReservationUnenrollmentWrite_OnSuccess(aParams, aData) {
    "use strict";
    mEnrolleesData.OffenderEidReservation = null;
}
function enrolleesOffenderEidReservationUnenrollmentWrite_OnFailure(aParams, aData) {
    "use strict";
    var l = "";
}

function uEnrolleesRemoveAssignmentSave_OnClick() {
    "use strict";
    var lUnassign = new OffenderUnenrollment(gUserDetails.UserId, mEnrolleesData.OffenderCurrentId),
        lAbsencesList,
        lItem,
        lKey,
        lEventList,
        lEventWriteList = [],
        lScheduleList,
        lNow,
        lValid = new Validator('uPopupContent', mRegexValidation),
        lBuilder = new SumoPredicateBuilder();
        lValid.scan();
        if(!lValid.IsValid()) {
            return;
        }
    lUnassign.TransactionId = moment().format("YYYYMMDDHHmmss");

    populateFromEditView(lUnassign, 'uUnassignDevice', 'Edit');
    if (!isNullOrUndefined(mEnrolleesData.OffenderEidReservation) && mEnrolleesData.OffenderEidReservation.StatusId === 2) {
        //mEnrolleesData.OffenderEidReservation.EndDateUTC = new Date();
        if (lUnassign.ReasonId == 17)
            mEnrolleesData.OffenderEidReservation.StatusId = 5;

        mEnrolleesData.OffenderEidReservation.UserId = gUserDetails.UserId;
        WriteSingle(mEnrolleesData.OffenderEidReservation, enrolleesOffenderEidReservationUnenrollmentWrite_OnSuccess, enrolleesOffenderEidReservationUnenrollmentWrite_OnFailure, mEnrolleesData.OffenderCurrentId, true);
    }

    if ($("#uChargerReturned").prop("checked") == true) {
        lUnassign.ChargerReturnStatus = uChangeChargerStatus();
    }

    lUnassign.AttemptRecoverFlag = $("#uAttemptedToRecover").prop("checked") ? 1 : 0;

    WriteSingle(lUnassign, enrolleeOffenderUnenrollmentWrite_OnSuccess, enrolleeOffenderUnenrollmentWrite_OnFailure, mEnrolleesData.OffenderCurrentId, true);

    if (mEnrolleesData.OffenderDeviceClusters.length > 0) {
        for (lKey in mEnrolleesData.OffenderDeviceClusters) {
            if (mEnrolleesData.OffenderDeviceClusters.hasOwnProperty(lKey)) {
                lItem = mEnrolleesData.OffenderDeviceClusters[lKey];
                lItem.IsActive = false;
                lItem.TransactionId = moment().format("YYYYMMDDHHmmss");
                setDataItem(lItem.Id, 'DeviceClusterEnrollee', lItem);
                WriteSingle(lItem, null, Sad, null, false);

            }
        }
        WriteMultiple(mEnrolleesData.OffenderDeviceClusters, enrolleesOffenderDeviceClusterUnenrollmentWrite_OnSuccess, enrolleesOffenderDeviceClusterUnenrollmentWrite_OnFailure, mEnrolleesData.OffenderCurrentId);
    }
    lBuilder.AddNewExpressionConditional('EnrolleeId', mEnrolleesData.OffenderCurrentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsOpen', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lEventList = query(getDataItems('Events'), lBuilder.RootExpression);
    if (lEventList.length > 0) {
        lNow = new Date();
        for (lKey in lEventList) {
            if (lEventList.hasOwnProperty(lKey)) {
                lItem = lEventList[lKey];
                lItem.IsOpen = false;
                lItem.StopDateUTC = lNow;
                lEventWriteList.push(prepareObjectForWcf(lItem));
            }
        }
        WriteMultiple(lEventWriteList, null, enrolleesOffenderEventCloseWrite_OnFailure, mEnrolleesData.OffenderCurrentId, false);
    }


    var lDeleteSchedule = veritracks.system.clientSetting('deletescheduleatunassign');


    if (lDeleteSchedule) {
        // update offender schedule cache
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('EnrolleeId', mEnrolleesData.OffenderCurrentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

        lScheduleList = query(mEnrolleesData.OffenderSchedules, lBuilder.RootExpression);

        for (lKey in lScheduleList) {
            if (lScheduleList.hasOwnProperty(lKey)) {
                lItem = lScheduleList[lKey];
                if (lItem.ScheduleType == 3 || lItem.ScheduleType == 4 || lItem.ScheduleType == 7) {
                    lItem.IsActive = false;
                    updateOffenderScheduleCache(lItem);
                }
            }
        }
    }
}



function DisplayEnrollmentInfoUpToDatePopup(aStep, aAssignments) {
    var lBodyHtml = [],
      lBuilder = new SumoPredicateBuilder(),
      lReasons,
      lContinueCallback = 'EnrollmentUpToDate_OnContinue();',
      lUnassign = new OffenderUnenrollment(-1, -1),
      lButtonBar = GenerateButtonCommandBar();

    if ((aStep == 1 || aStep == 2) && (aAssignments > 0))
    {
       lContinueCallback = 'uDisplayUnassignmentReasonPopup();';
    }

    GenerateButton(localizeWrapper('cEnrolleeContinue'), 'Save', lContinueCallback).appendTo(lButtonBar);
    GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'EnrollmentUpToDate_OnCancel();').appendTo(lButtonBar);
    lBodyHtml.push('<p>');
    lBodyHtml.push(localizeWrapper('cEnrolleeEnrollmentNotificationUpToDate'));
    lBodyHtml.push('</p>');
    lBodyHtml.push('<ol class="list">');
    lBodyHtml.push('<li class="EnrolleeIconProperty">');
    lBodyHtml.push(localizeWrapper('cEnrolleeEnrollmentDuration'));
    lBodyHtml.push('</li>');
    lBodyHtml.push('<li class="AddressIconProperty">');
    lBodyHtml.push(localizeWrapper('cEnrolleeAddress'));
    lBodyHtml.push('</li>');
    lBodyHtml.push('<li class="ZoneIconProperty">');
    lBodyHtml.push(localizeWrapper('cZones'));
    lBodyHtml.push('</li>');
    lBodyHtml.push('<li class="DateIconProperty">');
    lBodyHtml.push(localizeWrapper('cEnrolleeSchedules'));
    lBodyHtml.push('</li>');
    lBodyHtml.push('</ol>');
    DisplayPopup(localizeWrapper('cEnrolleeEnrollmentUpToDate'), lBodyHtml.join(''), lButtonBar, false);
 }

function EnrollmentUpToDate_OnContinue() {
    SaveDeviceAssignment(mEnrolleesData.EnrolleeChangeReasonHolder);
    ClosePopup();
}

function EnrollmentUpToDate_OnCancel() {
    mEnrolleesData.EnrolleeChangeReasonHolder = [];
    ClosePopup();
}

function uDisplayUnassignmentReasonPopup() {
    var lBodyHtml = [],
        lBuilder = new SumoPredicateBuilder(),
        lReasons,
        lUnassign = new OffenderUnenrollment(-1, -1),
        lButtonBar = GenerateButtonCommandBar();

    GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'uEnrolleesChangeAssignmentSave_OnClick();').appendTo(lButtonBar);

    lBodyHtml.push('<table>');
    lBodyHtml.push('<tr><td class="FormTitle">' + localizeWrapper('cType') + '</td>');
    lBodyHtml.push('<td class="FormField"><select id="uUnassignDeviceReasonIdEdit"></td>');
    lBodyHtml.push('</table>');

    lBuilder.AddNewExpressionConditional('EnrolleeTypeId', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lBuilder.AddNewExpressionConditional('Id', [16, 17], false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And());

    lReasons = query(getDataItems('DeviceChangeReason'), lBuilder.RootExpression);

    DisplayPopup(localizeWrapper('cEnrolleeChangeDeviceAssignReason'), lBodyHtml.join(''), lButtonBar, false);
    populateEditView(lUnassign, [{ 'Id': 'ReasonId', 'Type': 'Dropdown', 'DataSource': lReasons, 'DataValueField': 'Id', 'DataTextField': 'Description' }], {}, 'uUnassignDevice', 'Edit');
    $('#uUnassignDeviceReasonIdEdit').val(1);
}

function uEnrolleesChangeAssignmentSave_OnClick() {
    "use strict";
    var lReason = $('#uUnassignDeviceReasonIdEdit').val();

    mEnrolleesData.EnrolleeChangeReasonHolder.Enrollment.UnassignmentReason = parseInt(lReason);
    SaveDeviceAssignment(mEnrolleesData.EnrolleeChangeReasonHolder);
    ClosePopup();
}



function uChangeChargerStatus() {
    "use strict";
    var lBroken = $("#uChagerBrokenStatus").prop("checked"),
        lMissing = $("#uChargerMissingStatus").prop("checked")

    if (lMissing) {
        return "Missing";
    } else if (lBroken) {
        return "Broken";
    } else {
        return "Returned";
    }

}
/**
 * @description This function is used to display the unassign device popup
 */
function uEnrolleesRemoveAssignment_OnClick() {
    "use strict";
    
    

    var _displayModal = function(){
        var lBodyHtml = [],
        lBuilder = new SumoPredicateBuilder(),
        lReasons,
        lUnassign = new OffenderUnenrollment(-1, -1),
        lButtonBar = GenerateButtonCommandBar();
        if (!isNullOrUndefined(mEnrolleesControls.TrackingDeviceCardView)) {
            mEnrolleesControls.TrackingDeviceCardView.dispose();
            mEnrolleesControls.TrackingDeviceCardView = null;
        }
        if (!isNullOrUndefined(mEnrolleesControls.DeviceAssignmentsContactList)) {
            mEnrolleesControls.DeviceAssignmentsContactList.dispose();
            mEnrolleesControls.DeviceAssignmentsContactList = null;
        }
        if (!isNullOrUndefined(mEnrolleesControls.DeviceAssignmentsMap)) {
            mEnrolleesControls.DeviceAssignmentsMap.dispose();
            mEnrolleesControls.DeviceAssignmentsMap = null;
        }
        if (!isNullOrUndefined(mEnrolleesControls.StationCardView)) {
            mEnrolleesControls.StationCardView.dispose();
            mEnrolleesControls.StationCardView = null;
        }
        GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'uEnrolleesRemoveAssignmentSave_OnClick();').appendTo(lButtonBar);
        const lModalHtml = `
            <table> 
                <tr>
                    <td class="FormTitle">${localizeWrapper('cReason')}</td>
                    <td class="FormField"><select id="uUnassignDeviceReasonIdEdit" class="Validate ValidateNotNull" ></td></tr>
                    <tr><td class="FormTitle">${localizeWrapper('cInventoryTrackChargerReturnStatus')}</td>
                    <td class="FormField"><input id="uChargerReturned" type="checkbox" value="1" /></td></tr>
                    <tr id="uChargerStatusRow" style="display:none;">
                    <td class="FormTitle">${localizeWrapper('cInventoryChargerStatus')}</td>
                    <td class="FormField">
                        <input id="uChagerBrokenStatus" type="radio" value="Broken" name="chargerStatus" />${localizeWrapper('cInventoryChargerStatus')}
                        <input style="margin-left:10px;" id="uChargerReturnedStatus" type="radio" value="Returned" name="chargerStatus" />${localizeWrapper('cInventoryChargerOk')}
                        <input checked="true" style="margin-left:10px" id="uChargerMissingStatus" type="radio" value="Missing" name="chargerStatus" />${localizeWrapper('cInventoryChargerMissing')}
                    </td>
                </tr>
                <tr>
                    <td class="FormTitle">${localizeWrapper('cInventoryAttemptedToRecover')}</td>
                    <td class="FormField"><input id="uAttemptedToRecover" type="checkbox" value="1" /></td></tr>
                    <tr id="uAtmpRecRow" style="display:none">
                    <td class="FormTitle">${gUserDetails.FullName}</td>
                    <td class="FormField">${moment().format('MMMM Do YYYY, h:mm:ss a')}</td>
                </tr>
            </table>
        `;
    
        lBuilder.AddNewExpressionConditional('EnrolleeTypeId', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    
        if (!isNullOrUndefined(mEnrolleesData.OffenderEidReservation) && mEnrolleesData.OffenderEidReservation.StatusId === 2) {
            lBuilder.AddNewExpressionConditional('Id', [16, 17], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        } else {
            lBuilder.AddNewExpressionConditional('Id', [16, 17], false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And());
        }
        DisplayPopup(localizeWrapper('cEnrolleeRemoveDeviceAssign'), lModalHtml, lButtonBar, false);
        
        $('#uChagerReturnedStatus').prop('checked', true);
        // EID Reservation 
        if (!isNullOrUndefined(mEnrolleesData.OffenderEidReservation) && mEnrolleesData.OffenderEidReservation.StatusId === 2) {
            $('#uUnassignDeviceReasonIdEdit').val(17);
        } else {
            $('#uUnassignDeviceReasonIdEdit').val(1);
        }
        GetOriDeviceChangeReasonList(lBuilder.RootExpression, lUnassign);
        
        /**
         * @description This function is used to show/hide the charger status row based on the checkbox value
         */
        function uCheckedChargerReturned() {
            "use strict";
            var lChargerReturned = $("#uChargerReturned").prop("checked");
            if (lChargerReturned == true) {
                $("#uChargerStatusRow").show();
            } else {
                $("#uChargerStatusRow").hide();
            }
        
        }
        /**
         * @description This function is used to show/hide the Attempted to recover row based on the checkbox value
         */
        function uCheckedAttemptedtoRecover() {
            "use strict";
            var lAttemptedtoRecover = $("#uAttemptedToRecover").prop("checked");
        
            if (lAttemptedtoRecover == true) {
                $("#uAtmpRecRow").show();
            } else {
                $("#uAtmpRecRow").hide();
            }
        }
        // EventListener for Track Charger Return Status checkbox
        const uChargerReturnedBtn = document.getElementById('uChargerReturned');
        uChargerReturnedBtn.addEventListener('click', uCheckedChargerReturned);

        // EventListener for Attempted to Recover checkbox
        const uAttemptedToRecoverBtn = document.getElementById('uAttemptedToRecover');
        uAttemptedToRecoverBtn.addEventListener('click', uCheckedAttemptedtoRecover);

        //Remove Listeners 
        uChargerReturnedBtn.addEventListener('click', uCheckedChargerReturned);
        uAttemptedToRecoverBtn.addEventListener('click', uCheckedAttemptedtoRecover);
    }
    // Check if the enrollee is Paired with S.A.M.A. 
    if(StalkerController.IsEnrolleeSAMAPaired(mEnrolleesData.OffenderCurrentId)){
        StalkerController.PreventRemoveAssignment(_displayModal,function(){})
    }else { 
        _displayModal();
    }
}

function GetOriDeviceChangeReasonList(aRootExpression, aUnAssign) {
    var lReasons = query(getDataItems('DeviceChangeReason'), aRootExpression),
        lOriList = []
        lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
        lFields = [{ 'Id': 'ReasonId', 'Type': 'Dropdown', 'DataSource': lReasons, 'LocaleName': 'DeviceChangeReason', 'DataValueField': 'Id', 'DataTextField': 'Description','isNullableKey':true }];

    if (!isNullOrUndefined(lEnrollee)) {
        lOriList.push(lEnrollee.OrganizationId);
        GetOriDeviceChangeReason(lOriList.join(","),lEnrollee.EnrolleeType,
            function (aParams, aData) {
                if (aData.length > 0) {                    
                    populateEditView(aUnAssign, [{ 'Id': 'ReasonId', 'Type': 'Dropdown', 'DataSource': aData, 'LocaleName': 'DeviceChangeReason', 'DataValueField': 'Id', 'DataTextField': 'Description','isNullableKey':true }], {}, 'uUnassignDevice', 'Edit', localizeDataItem);
                } else {
                    populateEditView(aUnAssign, lFields, {}, 'uUnassignDevice', 'Edit', localizeDataItem);
                }
            },
            function () {
                populateEditView(aUnAssign, lFields, {}, 'uUnassignDevice', 'Edit', localizeDataItem);
        });
    }
   
}

function EnrolleeAssignmentSelectCurrentDevice() {
    "use strict";

    var lConfiguration = new BluHomeConfiguration(),
        lDeviceAssignments = gCurrentDeviceAssignment[mEnrolleesData.OffenderCurrentId],
        lDevices = getDataItems('Devices'),
        lDevice,
        lItem,
        lKey,
        lDeviceId;

    // the intent of this block is to find the device that is NOT a station device, but a tracking device
    for (lKey in lDeviceAssignments) {
        if (lDeviceAssignments.hasOwnProperty(lKey)) {
            lItem = lDeviceAssignments[lKey];
            lDevice = lDevices[lItem.Id];
            if ([104, 109].indexOf(lDevice.ProductId) === -1) {
                lDeviceId = lDevice.Id;
                break;
            }
        }
    }
    if (mEnrolleesControls.TrackingDeviceCardView.selected() !== lDeviceId) {
        mEnrolleesControls.TrackingDeviceCardView.selected(lDeviceId);
    }
}

function uEnrolleesAddAssignment_OnLoad(aData) {
    "use strict";
    var lButtonBar = GenerateButtonCommandBar(),
        lBodyHtml = [],
        lValidator = new Validator('uOffenderProfilePanel', mRegexValidation),
        lDeviceList = offenderUnassignedTrackingDevices(),
        lEnrolleeDevices = offenderAssignedTrackingDevices();

    //if (!isNullOrUndefined(lDeviceList[lEnrolleeDevices[0]].SerialNumber)) {
    //    lCurrentDeviceSerial = lDeviceList[lEnrolleeDevices[0]].SerialNumber;
    //}
    if (!isNullOrUndefined(mEnrolleesControls.DeviceAssignmentsValidator)) {
        mEnrolleesControls.DeviceAssignmentsValidator.dispose();
    }
    mEnrolleesControls.DeviceAssignmentsValidator = new Validator('uOffenderProfilePanel', mRegexValidation);
    mEnrolleesData.OffenderEnrollment = new OffenderDeviceEnrollment(gUserDetails.UserId, mEnrolleesData.OffenderCurrentId);
    GenerateButton(localizeWrapper('cEnrolleeRestart'), 'Restart', 'uEnrolleesAddAssignmentRestart_OnClick();').appendTo(lButtonBar);
    GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'uEnrolleesAddAssignmentSave_OnClick();').appendTo(lButtonBar);
    GenerateButton(localizeWrapper('cEnrolleeContinue'), 'Continue', 'uEnrolleesAddAssignmentContinue_OnClick();').appendTo(lButtonBar);
    DisplayPopup(localizeWrapper('cEnrolleeAssignment'), aData, lButtonBar, false);
    $('#uAssignmentPopup .WizardStep2').hide();
    $('#uAssignmentPopup .WizardStep3').hide();
    $('#uTrackingDeviceSearch').keyup(uEnrolleesAddAssignment_uTrackingDeviceSearch_OnChange).change(uEnrolleesAddAssignment_uTrackingDeviceSearch_OnChange);
    $('#uStationSearch').keyup(uEnrolleesAddAssignment_uStationSearch_OnChange).change(uEnrolleesAddAssignment_uTrackingDeviceSearch_OnChange);
    $('.PopupWindow .RestartButton').hide();
    uOffenderAssignmentContactMap_Init();
    uOffenderAssignmentContactList_Init();
    mEnrolleesControls.TrackingDeviceCardView = new sumo.controls.CardView('uOffenderTrackingDeviceCardView', 'uTrackingDeviceList', { 'cardTemplate': 'Interface/Enrollees.Offenders.Profile.Assignments.Popup.Tracking.Card.Template.htm', 'selectMethod': 'single', 'canUnselect': true, 'cssClass': 'VeritracksCardView', 'keyField': 'Id', 'keyFieldType': 'number' });
    mEnrolleesControls.TrackingDeviceCardView.bind('selectedchanged', uOffenderTrackingDeviceCardView_OnSelectChange);
    mEnrolleesControls.TrackingDeviceCardView.bind('databind', cardView_OnDataBind);
    mEnrolleesControls.TrackingDeviceCardView.setDataSource(lDeviceList);
    window.setTimeout(EnrolleeAssignmentSelectCurrentDevice, 250);
}

function uEnrolleesAddAssignment_OnClickxx() {
    "use strict";
    getFileHtml('Enrollees.Offenders.Profile.Assignments.Popup.htm', uEnrolleesAddAssignment_OnLoad);
}

function offenderAssignedTrackingDevices() {
    "use strict";
    var lKey,
        lBuilder = new SumoPredicateBuilder(),
        lAssignedDevices = getDataItems('CurrentDeviceAssignments'),
        lAssignedDeviceIds = [];

    lBuilder.AddNewExpressionConditional('EndDate', new Date(), false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());
    lAssignedDevices = query(lAssignedDevices, lBuilder.RootExpression);
    for (lKey in lAssignedDevices) {
        if (lAssignedDevices.hasOwnProperty(lKey)) {
            if (lAssignedDevices[lKey].EnrolleeId == mEnrolleesData.OffenderCurrentId) {
                lAssignedDeviceIds.push(lAssignedDevices[lKey].Id);
            }
        }
    }
    return lAssignedDeviceIds;
}

function uOffenderAssignmentContactMap_Init() {
    "use strict";
    var lSystemPreferences = getUserPreferences(10),
        lDisplayType = 'roadmap',
        lLayerOptions;

    if (!isNullOrUndefined(lSystemPreferences['MapDisplayType'])) {
        lDisplayType = lSystemPreferences['MapDisplayType'].Value;
    }
    mEnrolleesControls.DeviceAssignmentsMap = new sumo.maps.GoogleMapControl('uOffenderAssignmentContactMap', 'uStep1ContactHistoryMapPanel', { 'displayType': lDisplayType, 'mapTypeId_OnChange': mapDisplayType_OnChange, 'OnClick': null });
    lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1000000
    };
    mEnrolleesControls.DeviceAssignmentsMap.layerAdd('Trackpoints', lLayerOptions);
    lLayerOptions = {
        'renderType': 'label',
        'doesPlayback': true,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 800000
    };
    mEnrolleesControls.DeviceAssignmentsMap.layerAdd('NumberedLabels', lLayerOptions);

    mEnrolleesControls.DeviceAssignmentsMap.zoom(18);
}

function uOffenderAssignmentContactList_Init() {
    if (!isNullOrUndefined(mEnrolleesControls.DeviceAssignmentsContactList)) {
        mEnrolleesControls.DeviceAssignmentsContactList.dispose();
    }
    var lColumns = [
        { 'id': 'ContactDate', 'title': 'Date/Time', 'dataField': 'ContactDate', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'formatMethod': DisplayLongDateTime },
        { 'id': 'Status', 'title': 'Status', 'dataField': 'Status', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'formatMethod': ContactStatusNameFormatter },
        { 'id': 'RecordCount', 'title': 'Records', 'dataField': 'RecordCount', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'formatMethod': null },
        { 'id': 'GpsRecordCount', 'title': 'GPS', 'dataField': 'GpsRecordCount', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'formatMethod': null },
        { 'id': 'PercentGps', 'title': '% GPS', 'dataField': 'PercentGps', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'formatMethod': DisplayPercent },
        { 'id': 'BatteryLevel', 'title': '', 'dataField': 'BatteryLevel', 'width': 'autoData', 'minWidth': 24, 'sortable': false, 'cssClass': 'CenterImage', 'formatMethod': inventoryBatteryLevelFormatter, 'canResize': false },
        { 'id': 'BatteryVoltage', 'title': '', 'dataField': 'BatteryVoltage', 'width': 'autoData', 'minWidth': 24, 'sortable': false, 'cssClass': 'CenterImage', 'formatMethod': DisplayVolts, 'canResize': false }
    ];

    mEnrolleesControls.DeviceAssignmentsContactList = new sumo.controls.ListView('uOffenderAssignmentContactList', 'uStep1ContactHistoryListPanel', { 'keyField': 'Id', 'selectMethod': 'none', 'cssClass': 'VeritracksListView', 'canUnselect': true }, lColumns);
}

function uOffenderTrackingDeviceCardView_OnSelectChange(aSender, aDeviceId, aData) {
    "use strict";
    var lDevice = getDataItem(aDeviceId, 'Devices'),
        lContact = getDeviceLastContact(aDeviceId),
        lSort = new SortExpression(),
        lPointList = [],
        lLabelList = [];

    mEnrolleesData.OffenderEnrollment.TrackingDeviceId = aDeviceId;
    if (!isNullOrUndefined(lDevice)) {
        mEnrolleesData.OffenderEnrollment.TrackingDeviceType = lDevice.ProductId;
    }
    if (!isNullOrUndefined(aDeviceId)) {
        var lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('DeviceId', aDeviceId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lSort.addDescendingColumn('TrackDate');
        mEnrolleesControls.DeviceAssignmentsContactList.setDataSource([]);
        GetDeviceContact(aDeviceId, new Date(0).toWcf(), offenderAssignmentDeviceContact_OnComplete, Sad);
        //ReadMultiple(gObjectList.DeviceContact.AssemblyQualifiedName, lBuilder.RootExpression, 0, offenderAssignmentDeviceContact_OnComplete, Sad, null, lSort, 20);
    } else {
        offenderAssignmentDeviceContact_OnComplete(null, []);
    }
    $('.PopupWindow .ContinueButton').show();
    $('.PopupWindow .SaveButton').show();
    if (!isNullOrUndefined(lContact)) {
        lPointList.push({
            'data': lContact,
            'latitude': lContact.Latitude,
            'longitude': lContact.Longitude,
            'anchor': { 'x': 6, 'y': 6 },
            'iconUri': 'Images/Maps/Trackpoints/1100000.png',
            'hoverText': DisplayShortDateTime(lContact.TrackDate)
        });
        lLabelList.push({
            'data': lContact,
            'latitude': lContact.Latitude,
            'longitude': lContact.Longitude,
            'text': lDevice.SerialNumber,
            'horizontalOffset': -10,
            'verticalOffset': -11,
            'cssClass': 'NumericLabel'
        });
    }
    if (!isNullOrUndefined(mEnrolleesControls.DeviceAssignmentsMap)) {
        mEnrolleesControls.DeviceAssignmentsMap.layerSetDataSource('Trackpoints', lPointList);
        mEnrolleesControls.DeviceAssignmentsMap.layerSetDataSource('NumberedLabels', lLabelList);
        if (!isNullOrUndefined(lPointList[0])) {
            mEnrolleesControls.DeviceAssignmentsMap.setCenter(lPointList[0].latitude, lPointList[0].longitude);
        }
        //mEnrolleesControls.DeviceAssignmentsMap.fitBounds();
    }

    //$('#uOffenderTrackingDeviceCardViewRow1831').addClass('sumo-data-row-selected');

}

function uEnrolleesAddAssignment_uTrackingDeviceSearch_OnChange() {
    "use strict";
    if (!isNullOrUndefined(mEnrolleesControls.TrackingDeviceCardView)) {
        var lValue = $('#uTrackingDeviceSearch').val(),
            lList = offenderUnassignedTrackingDevices('SerialNumber', lValue);
        mEnrolleesControls.TrackingDeviceCardView.setDataSource(lList);
        if (lList.length === 0) {
            $('.PopupWindow .SaveButton').hide();
            $('.PopupWindow .ContinueButton').hide();
        }
    }
}

function uEnrolleesAddAssignment_uStationSearch_OnChange() {
    "use strict";
    var lValue = $('#uStationSearch').val(),
        lList = offenderUnassignedStations(lValue);
    mEnrolleesControls.StationCardView.setDataSource(lList);
}

function uOffenderEnrollmentMapTab_OnClick(aSelectedItem) {
    "use strict";
    $('#uAssignmentPopup .AssignmentPopupContactTab.Selected').removeClass('Selected');
    if (aSelectedItem === 'Map') {
        $('#uOffenderEnrollmentMapTab').addClass('Selected');
        $('#uStep1ContactHistoryListPanel').hide();
        $('#uStep1ContactHistoryMapPanel').show();
    } else {
        $('#uOffenderEnrollmentContactTab').addClass('Selected');
        $('#uStep1ContactHistoryMapPanel').hide();
        $('#uStep1ContactHistoryListPanel').show();
        mEnrolleesControls.DeviceAssignmentsContactList.setDataSource(mEnrolleesControls.DeviceAssignmentsContactList.getDataSource());
    }
}

function uEnrolleesAddAssignmentTab_OnClick(aSelectedClass) {
    "use strict";
    $('#uAssignmentPopup .AssignmentPopupTab.Selected').removeClass('Selected');
    $('#uAssignmentPopup .AssignmentPopupTab.' + aSelectedClass).addClass('Selected');
    $('#uStationSearch').val('');

    if (aSelectedClass === 'BluHome') {
        mEnrolleesData.OffenderEnrollment.StationDeviceType = 104;
    } else {
        mEnrolleesData.OffenderEnrollment.StationDeviceType = 105;
    }
    var lUnassignedStations = offenderUnassignedStations();
    uEnrolleesAddAssignmentBluHome_Init(lUnassignedStations);
}

function offenderDeviceEnrollment247Schedule_OnSuccess(aParams, aData) {
    "use strict";
    ReloadEnrolleeSchedules(mEnrolleesData.OffenderCurrentId);
}

function offenderDeviceEnrollment247Schedule_OnFailure(aParams, a, b, c) {
    "use strict";
}

function offenderDeviceEnrollment247Schedule(aType, aEntityId) {
    "use strict";
    var lSchedule = new OffenderSchedule(),
        lDevice = getDataItem(aEntityId, 'Devices'),
        lNow = new Date();

    lSchedule.EntityId = aEntityId;
    lSchedule.EnrolleeId = mEnrolleesData.OffenderCurrentId;
    lSchedule.ScheduleType = aType;

    lSchedule.IsSunday = true;
    lSchedule.IsMonday = true;
    lSchedule.IsTuesday = true;
    lSchedule.IsWednesday = true;
    lSchedule.IsThursday = true;
    lSchedule.IsFriday = true;
    lSchedule.IsSaturday = true;

    lSchedule.IsRecurring = true;
    lSchedule.Name = 'Auto Generated ' + lDevice.SerialNumber;
    lSchedule.StartTime = new Date(displayShortDate(lNow) + ' 00:00:00');
    lSchedule.EndTime = new Date(displayShortDate(lNow) + ' 23:59:00');
    WriteSingle(lSchedule, offenderDeviceEnrollment247Schedule_OnSuccess, offenderDeviceEnrollment247Schedule_OnFailure, {}, true);
    // write 24/7 schedule
}

function offenderDeviceEnrollmentDeviceCluster_Init() {
    "use strict";
    var lDeviceCluster = new DeviceCluster(),
        lDevice = getDataItem(mEnrolleesData.OffenderEnrollment.StationDeviceId, 'Devices'),
        lOffender = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees');

    lDeviceCluster.Name = 'BBG-' + lDevice.SerialNumber;
    lDeviceCluster.Description = 'Auto-generated during enrollment.';
    lDeviceCluster.OrganizationId = lOffender.OrganizationId;
    lDeviceCluster.TransactionId = moment().format("YYYYMMDDHHmmss");
    WriteSingle(lDeviceCluster, offenderDeviceEnrollmentDeviceCluster_OnSuccess, offenderDeviceEnrollmentDeviceCluster_OnFailure, null);
}



function offenderDeviceEnrollmentDeviceCluster_OnSuccess(aParams, aData) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    lBuilder.AddNewExpressionConditional('DeviceId', mEnrolleesData.OffenderEnrollment.StationDeviceId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.DeviceClusterDevice.AssemblyQualifiedName, lBuilder.RootExpression, 0, offenderDeviceEnrollmentDeviceClusterDeviceRead_OnSuccess, offenderDeviceEnrollmentDeviceClusterDeviceRead_OnFailure, aData);
}

function offenderDeviceEnrollmentDeviceClusterDeviceRead_OnSuccess(aParams, aData) {
    "use strict";
    var lWriteList = [],
        lDCD = new DeviceClusterDevice(aParams.Id, mEnrolleesData.OffenderEnrollment.StationDeviceId, true),
        lItem,
        lKey;
    for (lKey = 0; lKey < aData.length; lKey++) {
        lItem = aData[lKey];
        lItem.TransactionId = moment().format("YYYYMMDDHHmmss");
        lItem.IsActive = false;
        lWriteList.push(lItem);
    }
    lWriteList.push(lDCD);
    WriteMultiple(lWriteList, offenderDeviceEnrollmentDeviceClusterDevice_OnSuccess, offenderDeviceEnrollmentDeviceClusterDevice_OnFailure, aParams.Id);
}

function offenderDeviceEnrollmentDeviceClusterDeviceRead_OnFailure(aParams, a, b, c) {
    "use strict";
}

function offenderDeviceEnrollmentDeviceCluster_OnFailure(a, b, c) {
    "use strict";
}

function offenderDeviceEnrollmentDeviceClusterDevice_OnSuccess(aParams, aData) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    lBuilder.AddNewExpressionConditional('EnrolleeId', mEnrolleesData.OffenderCurrentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.DeviceClusterEnrollee.AssemblyQualifiedName, lBuilder.RootExpression, 0, offenderDeviceEnrollmentDeviceClusterEnrolleeRead_OnSuccess, offenderDeviceEnrollmentDeviceClusterEnrolleeRead_OnFailure, aParams);
}

function offenderDeviceEnrollmentDeviceClusterDevice_OnFailure(a, b, c) {
    "use strict";
}

function offenderDeviceEnrollmentDeviceClusterEnrolleeRead_OnSuccess(aParams, aData) {
    "use strict";
    var lWriteList = [],
        lDCE = new DeviceClusterEnrollee(aParams, mEnrolleesData.OffenderCurrentId, true),
        lItem,
        lKey;
    for (lKey = 0; lKey < aData.length; lKey++) {
        lItem = aData[lKey];
        lItem.IsActive = false;
        lItem.TransactionId = moment().format("YYYYMMDDHHmmss");
        lWriteList.push(lItem);
    }
    lWriteList.push(lDCE);
    WriteMultiple(lWriteList, offenderDeviceEnrollmentDeviceClusterEnrollee_OnSuccess, offenderDeviceEnrollmentDeviceClusterEnrollee_OnFailure, aParams);
}

function offenderDeviceEnrollmentDeviceClusterEnrolleeRead_OnFailure(aParams, a, b, c) {
    "use strict";
}

function offenderDeviceEnrollmentDeviceClusterEnrollee_OnSuccess(aParams, aData) {
    "use strict";
    if ($('#uStep3247ScheduleEdit').prop('checked')) {
        offenderDeviceEnrollment247Schedule(3, mEnrolleesData.OffenderEnrollment.StationDeviceId);
    }
    mEnrolleesData.OffenderEnrollment.StationDeviceId = -1;
    mEnrolleesData.OffenderEnrollment.StationDeviceType = -1;
    WriteSingle(mEnrolleesData.OffenderEnrollment, offenderDeviceEnrollment_OnSuccess, offenderDeviceEnrollment_OnFailure, mEnrolleesData);
}

function offenderDeviceEnrollmentDeviceClusterEnrollee_OnFailure(a, b, c) {
    "use strict";
    var l = '';
}

function offenderDeviceAssignment_OnSuccess(aParams, aData) {
    "use strict";
    var lAssignment,
        lNow = new Date(),
        lKey;

    function onSuccess() {
        mCache.unbind('CurrentDeviceAssignmentsupdated', onSuccess, aParams);
        enrolleesDataListConverter();
        enrolleesStationListConverter();
        window.location.hash = 'Enrollees.Offenders.Profile.Assignments.' + aParams;
    }

    FixDates(aData);
    mCache.bind('CurrentDeviceAssignmentsupdated', onSuccess, aParams);
    mCache.UpdateItem('CurrentDeviceAssignments');

    //gCurrentDeviceAssignment[aParams] = [];
    for (lKey = 0; lKey < aData.length; lKey++) {
        lAssignment = aData[lKey];
        setDataItem(lAssignment.Id, 'CurrentDeviceAssignments', lAssignment);
        if (lAssignment.ProductId == 121) {
            setDataItem(lAssignment.Id, 'AlcoholDeviceAssignments', lAssignment);
        }
    }
}

function offenderDeviceAssignment_OnFailure(aParams, a, b, c) {
}


function testDeviceClusterDevices(a, b) {
    var l = '';
}

function offenderDeviceAssignmentDevice_OnSuccess(aParams, aData) {
    "use strict";
    var //lItems = getDataItems('Devices'),
        lItem,
        lKey;
    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lItem = aData[lKey];
            setDataItem(lItem.Id, 'Devices', lItem);
            //lItems[lItem.Id] = lItem;
        }
    }
    mCache.bind('DeviceClusterDevicesupdated', testDeviceClusterDevices, null);
    mCache.UpdateItem('DeviceClusterDevices');
}

function offenderDeviceAssignmentDevice_OnFailure(aParams, a, b, c) {
}

    function enrolleeDeviceAssignmentEnrollee_OnSuccess(aParams, aData) {
    "use strict";
    FixDates(aData);
    aData.InMyOrganization = (gUserDetails.OrganizationIds.indexOf(aData.OrganizationId) !== -1);
    setDataItem(aData.Id, 'Enrollees', aData);
    enrolleesResetOffenderCardView(aParams);
}

function offenderDeviceAssignmentEnrollee_OnFailure(aParams, a, b, c) {
}

function offenderDeviceEnrollment_OnSuccess(aParams, aData) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lCurrentAssignments = getDataItems('CurrentDeviceAssignments'),
        lExistingAssignments = mEnrolleesControls.DeviceAssignmentsListView.getDataSource(),
        lAssignmentList = getDataItems('CurrentDeviceAssignments'),
        lAssignmentQuery,
        lIsDeviceUnassigned = true,
        lCurrentAssignmentList = [],
        lAssignmentWrite = [],
        lDeviceWrite = [],
        lTrackingDevice,
        lStationDevice,
        lOffender = GetEnrollee(aData.Id),
        lNow = new Date(),
        lCurrentAssignment,
        lNewAssignment,
        lAssignment,
        lDevice,
        lKey;

    ClosePopup();
    lBuilder.AddNewExpressionConditional('EndDate', lNow, false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());
    lExistingAssignments = query(lExistingAssignments, lBuilder.RootExpression);

    lBuilder.AddNewExpressionConditional('EnrolleeId', mEnrolleesData.OffenderCurrentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lCurrentAssignments = query(lCurrentAssignments, lBuilder.RootExpression);
    lBuilder.Clear();

    for (lKey in lCurrentAssignments) {
        if (lCurrentAssignments.hasOwnProperty(lKey)) {
            lCurrentAssignment = lCurrentAssignments[lKey];
            lCurrentAssignment.EndDate = lNow;
            lCurrentAssignment.ReasonForChange = 'Equipment Maintenance';
        }
    }
    enrolleesStationListConverter();

    for (lKey in lExistingAssignments) {
        if (lExistingAssignments.hasOwnProperty(lKey)) {
            lAssignment = lExistingAssignments[lKey];
            if (!isNullOrUndefined(lAssignment)) {
                lAssignment.ReasonForChange = 'Equipment Maintenance';
                lAssignment.EndDate = lNow;
                lAssignmentWrite.push(prepareObjectForWcf(lAssignment));

                lIsDeviceUnassigned = true;
                lDevice = getDataItem(lAssignment.Id, 'Devices');
                if ([104, 109].indexOf(lDevice.ProductId) !== -1) {
                    lBuilder.AddNewExpressionConditional('EnrolleeId', lAssignment.EnrolleeId, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
                    lBuilder.AddNewExpressionConditional('Id', lAssignment.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                    lAssignmentQuery = query(lAssignmentList, lBuilder.RootExpression);
                    lBuilder.Clear();
                    lIsDeviceUnassigned = (count(lAssignmentQuery) === 0);
                }
                //lIsDeviceUnassigned = false;
                lDevice.UserId = gUserDetails.UserId;
                if (lIsDeviceUnassigned) {
                    lDevice.Status = 5;                    
                    lDeviceWrite.push(lDevice);
                }
            }
        }
    }
    if (aData.TrackingDeviceId !== -1) {
        lAssignmentWrite.push(prepareObjectForWcf(new DeviceAssignment(aData.TrackingDeviceId, aData.Id)));
        lTrackingDevice = getDataItem(aData.TrackingDeviceId, 'Devices');
        lTrackingDevice.Status = 4;

        if (lDeviceWrite.indexOf(lTrackingDevice) === -1) {
            lTrackingDevice.UserId = gUserDetails.UserId;
            lDeviceWrite.push(lTrackingDevice);
        }
    }
    if (aData.StationDeviceId !== -1) {
        lAssignmentWrite.push(prepareObjectForWcf(new DeviceAssignment(aData.StationDeviceId, aData.Id)));
        lStationDevice = getDataItem(aData.StationDeviceId, 'Devices');
        lStationDevice.Status = 4;

        if (lDeviceWrite.indexOf(lStationDevice) === -1) {
            lStationDevice.UserId = gUserDetails.UserId;
            lDeviceWrite.push(lStationDevice);
        }
    }

    WriteMultiple(lAssignmentWrite, enrolleeDeviceAssignment_OnSuccess, offenderDeviceAssignment_OnFailure, aData.Id, false);
    WriteMultiple(lDeviceWrite, offenderDeviceAssignmentDevice_OnSuccess, offenderDeviceAssignmentDevice_OnFailure, aData.Id, false);

    lOffender.IsAssigned = true;
        WriteSingle(lOffender, enrolleeDeviceAssignmentEnrollee_OnSuccess, offenderDeviceAssignmentEnrollee_OnFailure, aData.Id, false);
}

function offenderDeviceEnrollment_OnFailure(aParams, a, b, c) {
    "use strict";
    var l = '';
}

function uEnrolleesAddAssignmentSave_OnClick() {
    "use strict";
    var lDevice = null,
        lEventList,
        lEventWriteList = [],
        lNow,
        lKey,
        lItem,
        lBuilder = new SumoPredicateBuilder();
    //var lSchedule = new OffenderSchedule();

    //offenderDeviceEnrollmentDeviceClusterEnrolleeRead_OnSuccess
    $('.PopupWindow .SaveButton').hide();
    $('.PopupWindow .ContinueButton').hide();
    function success(aParams, aData) {
        mEnrolleesData.OffenderDeviceClusters = [];
        if ($('.WizardStep3').is(':visible')) {
            switch (mEnrolleesData.OffenderEnrollment.StationDeviceType) {
                case 109:
                case 104:
                    // BluHome
                    if ($('#uStep3247ScheduleEdit').prop('checked')) {
                        offenderDeviceEnrollment247Schedule(2, mEnrolleesData.OffenderEnrollment.StationDeviceId);
                    }
                    lDevice = GetDevice(mEnrolleesData.OffenderEnrollment.StationDeviceId);
                    mEnrolleesData.OffenderEnrollment.StationDeviceType = lDevice.ProductId;
                    populateFromEditView(mEnrolleesData.OffenderEnrollment, 'uStep3', 'Edit');
                    WriteSingle(mEnrolleesData.OffenderEnrollment, offenderDeviceEnrollment_OnSuccess, offenderDeviceEnrollment_OnFailure, mEnrolleesData);
                    break;
                case 999:
                    // BluBox Group
                    offenderDeviceEnrollmentDeviceClusterDevice_OnSuccess(
                        mEnrolleesData.OffenderEnrollment.StationDeviceId, null);
                    break;
                case 105:
                    // BluBox
                    offenderDeviceEnrollmentDeviceCluster_Init();
                    break;

                case 0:
                    //BluBox Group
                    if ($('#uStep3247ScheduleEdit').prop('checked')) {
                        offenderDeviceEnrollment247Schedule(3, mEnrolleesData.OffenderEnrollment.StationDeviceId);
                    }
                    // write enrollment
                    break;
            }
        } else {
            WriteSingle(mEnrolleesData.OffenderEnrollment, offenderDeviceEnrollment_OnSuccess, offenderDeviceEnrollment_OnFailure, mEnrolleesData);
        }
        lBuilder.AddNewExpressionConditional('EnrolleeId', mEnrolleesData.OffenderCurrentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsOpen', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

        lEventList = query(getDataItems('Events'), lBuilder.RootExpression);
        if (lEventList.length > 0) {
            lNow = new Date();
            for (lKey in lEventList) {
                if (lEventList.hasOwnProperty(lKey)) {
                    lItem = lEventList[lKey];
                    lItem.IsOpen = false;
                    lItem.StopDateUTC = lNow;
                    lEventWriteList.push(prepareObjectForWcf(lItem));
                }
            }
            WriteMultiple(lEventWriteList, null, enrolleesOffenderEventCloseWrite_OnFailure, mEnrolleesData.OffenderCurrentId, false);
        }
    }

    if (!isNullOrUndefined(mEnrolleesData.OffenderDeviceClusters) && mEnrolleesData.OffenderDeviceClusters.length > 0) {
        for (lKey in mEnrolleesData.OffenderDeviceClusters) {
            if (mEnrolleesData.OffenderDeviceClusters.hasOwnProperty(lKey)) {
                lItem = mEnrolleesData.OffenderDeviceClusters[lKey];
                lItem.IsActive = false;
            }
        }
        WriteMultiple(mEnrolleesData.OffenderDeviceClusters, success, null, {}, true);
    } else {
        success({}, []);
    }
}

function uEnrolleesAddAssignmentBluHome_Init(aDeviceList) {
    "use strict";

    function rendered() {
        var lAssignments,
            lKey,
            lItem,
            lDevice,
            lSelected = null;
        mEnrolleesControls.StationCardView.unbind('databind', rendered);
        if (mEnrolleesData.OffenderEnrollment.StationDeviceType === 105) {
            if (!isNullOrUndefined(mEnrolleesData.OffenderDeviceClusters) && mEnrolleesData.OffenderDeviceClusters.length > 0) {
                lItem = mEnrolleesData.OffenderDeviceClusters[mEnrolleesData.OffenderDeviceClusters.length - 1];
                if (!isNullOrUndefined(lItem)) {
                    lSelected = 'C' + lItem.DeviceClusterId.toString();
                }
            }
        } else {
            lAssignments = gCurrentDeviceAssignment[mEnrolleesData.OffenderCurrentId];
            for (lKey in lAssignments) {
                if (lAssignments.hasOwnProperty(lKey)) {
                    lItem = lAssignments[lKey];
                    lDevice = getDataItem(lItem.Id, 'Devices');
                    if (!isNullOrUndefined(lDevice) && [104, 109].indexOf(lDevice.ProductId) !== -1) {
                        lSelected = 'D' + lDevice.Id.toString();
                    }
                }
            }
        }
        mEnrolleesControls.StationCardView.selected(lSelected);
    }

    mEnrolleesControls.StationCardView = new sumo.controls.CardView('uOffenderStationCardView', 'uStationList', { 'cardTemplate': 'Interface/Enrollees.Offenders.Profile.Assignments.Popup.Station.Card.Template.htm', 'selectMethod': 'single', 'canUnselect': true, 'cssClass': 'VeritracksCardView' });
    mEnrolleesControls.StationCardView.bind('selectedchanged', uOffenderStationCardView_OnSelectChange);
    mEnrolleesControls.StationCardView.bind('databind', rendered);
    mEnrolleesControls.StationCardView.setDataSource(aDeviceList);
}

function uOffenderStationCardView_OnSelectChange(aSender, aStationCardId, aData) {
    "use strict";
    var lCard = mEnrolleesData.StationsClean[aStationCardId];
    if (!isNullOrUndefined(lCard)) {
        $('.PopupWindow .SaveButton').hide();
        $('.PopupWindow .ContinueButton').show();
        mEnrolleesData.OffenderEnrollment.StationDeviceId = lCard.Id;
        mEnrolleesData.OffenderEnrollment.StationDeviceType = lCard.ProductId;
    } else {
        $('.PopupWindow .SaveButton').show();
        $('.PopupWindow .ContinueButton').hide();
        mEnrolleesData.OffenderEnrollment.StationDeviceId = -1;
    }
}
function uEnrolleesAddAssignmentRestart_OnClick(aData) {
    "use strict";
    uEnrolleesAddAssignment_OnClick();
}

function uEnrolleesAddAssignmentContinue_OnClick() {
    "use strict";
    if ($('#uAssignmentPopup .WizardStep1').is(':visible')) {
        $('#uTrackingDeviceSearch').unbind('keyup', uEnrolleesAddAssignment_uTrackingDeviceSearch_OnChange);
        $('#uTrackingDeviceSearch').unbind('change', uEnrolleesAddAssignment_uTrackingDeviceSearch_OnChange);
        mEnrolleesControls.TrackingDeviceCardView.dispose();
        mEnrolleesControls.TrackingDeviceCardView = null;

        // BluHome (Initial tab)
        if (!isNullOrUndefined(mEnrolleesData.OffenderDeviceClusters) && mEnrolleesData.OffenderDeviceClusters.length > 0) {
            mEnrolleesData.OffenderEnrollment.StationDeviceType = 105;
            uEnrolleesAddAssignmentTab_OnClick('DeviceCluster');
        } else {
            mEnrolleesData.OffenderEnrollment.StationDeviceType = 104;
        }
        $('.PopupWindow .RestartButton').show();
        $('.PopupWindow .SaveButton').show();
        $('.PopupWindow .ContinueButton').hide();
        $('#uAssignmentPopup .WizardStep1').hide();
        $('#uAssignmentPopup .WizardStep2').show();

        if (mEnrolleesData.OffenderEnrollment.TrackingDeviceType === 103 || mEnrolleesData.OffenderEnrollment.TrackingDeviceType === 141 || mEnrolleesData.OffenderEnrollment.TrackingDeviceType === 151) {
            $('#uOffenderEnrollmentDeviceClusterTab').show();
            //lCanUnselect = true;
        } else {
            $('#uOffenderEnrollmentDeviceClusterTab').hide();
        }
        uEnrolleesAddAssignmentBluHome_Init(offenderUnassignedStations());
    } else {
        if (!isNullOrUndefined(mEnrolleesControls.StationCardView)) {
            mEnrolleesControls.StationCardView.dispose();
            mEnrolleesControls.StationCardView = null;
        }
        $('.PopupWindow .SaveButton').show();
        $('.PopupWindow .ContinueButton').hide();
        $('#uAssignmentPopup .WizardStep2').hide();
        $('#uAssignmentPopup .WizardStep3').show();
        var test = getDataItems('RfRange');
        if (mEnrolleesData.OffenderEnrollment.StationDeviceType === 104 || mEnrolleesData.OffenderEnrollment.StationDeviceType === 109) {
            populateEditView({}, [{ 'Id': 'StationRfRange', 'Type': 'Dropdown', 'DataSource': getDataItems('RfRange'), 'LocaleName': 'RFRange', 'DataValueField': 'Id', 'DataTextField': 'Description' }], {}, 'uStep3', 'Edit', localizeDataItem);
            $('#uWizardStep3Title').text('BLUhome');
            if (mEnrolleesData.OffenderEnrollment.StationDeviceType === 109) {
                $('.BluHomeLandlineItems').hide();
            }
        } else if (mEnrolleesData.OffenderEnrollment.StationDeviceType === -1) {
            $('#uAssignmentPopup .StationItems').hide();
            $('#uAssignmentPopup .BluHomeItems').hide();
        } else {
            $('#uWizardStep3Title').text('BLUbox Group');
            $('#uAssignmentPopup .BluHomeItems').hide();
        }
    }
}

function uEnrolleesAddAssignmentCancel_OnClick() {
    "use strict";
}

function GetOffenderImage(aUrl) {
    "use strict";
    var lResult = null,
        lUrl = MUGSHOTS + aUrl;
    if (!isNullOrUndefined(aUrl) && aUrl !== "") {
        $('#uOffenderProfilePhotoUri').attr('src', lUrl);
    } else {
        $('#uOffenderProfilePhotoUri').attr('src', 'Images/NoPhoto.png');
    }
}


/* DATA ACCESS */
function GetEnrollee(aId) {
    "use strict";
    var lResult = null,
        lItem = getDataItem(aId, 'Enrollees');


    if (!isNullOrUndefined(lItem)) {
        lResult = lItem;
    } else {
        if (CheckUserHasPermission(45)) {
            lResult = getDataItem(aId, 'EnrolleesUniversal');
        }
    }
    return lResult;
}

function GetDevice(aId) {
    "use strict";
    var lResult = null,
        lItem = getDataItem(aId, 'Devices');


    if (!isNullOrUndefined(lItem)) {
        lResult = lItem;
    } else {
        if (CheckUserHasPermission(45)) {
            lResult = getDataItem(aId, 'DevicesUniversal');
        }
    }
    return lResult;
}

function GetOffenderSchedule(aId) {
    "use strict";
    return mEnrolleesData.OffenderSchedules.find(function(sc){return sc.Id == aId});
}

function getGender(aId) {
    return getDataItem(aId, 'Gender');
}


// PLAYBACK
function uEnrolleesMapPlaybackNextButton_OnClick() {
    "use strict";
    if (mEnrolleesData.PlaybackStatus === 'Stopped') {
        $('#uSlider').slider('option', 'max', mEnrolleesControls.PlaybackControl.getOverlayCount() - 1);
    }
    //mEnrolleesData.PlaybackStatus = 'Paused';
    mEnrolleesControls.PlaybackControl.next();
    var lTrackpointsReviewed =  mEnrolleesControls.PlaybackControl.getOverlaysPlayed(),
        lCurrentTrackPoint =  mEnrolleesControls.PlaybackControl.getCurrentPoint(),
        lDate =overlayDateFormatter(lCurrentTrackPoint);
    if(!isNullOrUndefined(mEnrolleesData.UserTransactionRecordLogger)){
        mEnrolleesData.UserTransactionRecordLogger.addTransaction(UserTransactionRecordEvents.NEXT,lDate,-1,-1,lTrackpointsReviewed)
    }
}

function uEnrolleesMapPlaybackPreviousButton_OnClick() {
    "use strict";
    if (mEnrolleesData.PlaybackStatus === 'Stopped') {
        $('#uSlider').slider('option', 'max', mEnrolleesControls.PlaybackControl.getOverlayCount() - 1);
    }
    //mEnrolleesData.PlaybackStatus = 'Paused';
    mEnrolleesControls.PlaybackControl.previous();
    var lTrackpointsReviewed =  mEnrolleesControls.PlaybackControl.getOverlaysPlayed(),
        lCurrentTrackPoint =  mEnrolleesControls.PlaybackControl.getCurrentPoint(),
        lDate =overlayDateFormatter(lCurrentTrackPoint);
    if(!isNullOrUndefined(mEnrolleesData.UserTransactionRecordLogger)){
        mEnrolleesData.UserTransactionRecordLogger.addTransaction(UserTransactionRecordEvents.PREVIOUS,lDate,-1,-1,lTrackpointsReviewed)
    }
}

function uEnrolleesMapPlaybackRewindButton_OnClick() {
    "use strict";

    if (mEnrolleesData.PlaybackStatus === 'Playing' || mEnrolleesData.PlaybackStatus === 'Rewinding') {
        if (mEnrolleesData.PlaybackDirection === -1) {
            switch (mEnrolleesData.PlaybackDivider) {
                case 1:
                    mEnrolleesData.PlaybackDivider = 2;
                    break;
                case 2:
                    mEnrolleesData.PlaybackDivider = 4;
                    break;
                case 4:
                    mEnrolleesData.PlaybackDivider = 8;
                    break;
                case 8:
                    mEnrolleesData.PlaybackDivider = 1;
                    break;
            }
        } else {
            //mEnrolleesData.PlaybackStatus = 'Rewinding';
            //$('#uMapPlaybackStatus').html(mEnrolleesData.PlaybackStatus);
            mEnrolleesData.PlaybackDirection = -1;
            mEnrolleesData.PlaybackDivider = 1;
            mEnrolleesControls.PlaybackControl.direction(mEnrolleesData.PlaybackDirection);
        }
        mEnrolleesControls.PlaybackControl.speed(mEnrolleesData.PlaybackDivider);
        $('#uMapPlaybackSpeed').html('(' + mEnrolleesData.PlaybackDivider + 'x)');
    }
}


function uEnrolleesMapPlaybackPlayButton_OnClick() {
    "use strict";
    $('#uSlider').slider('option', 'max', mEnrolleesControls.PlaybackControl.getOverlayCount() - 1);
    $('#uMapPlaybackSpeed').html('(' + mEnrolleesData.PlaybackDivider + 'x)');
    mEnrolleesControls.PlaybackControl.start();
    var lTrackpointsReviewed =  mEnrolleesControls.PlaybackControl.getOverlaysPlayed(),
        lCurrentTrackPoint =  mEnrolleesControls.PlaybackControl.getCurrentPoint();
        console.log('PLAY START ',lTrackpointsReviewed,lCurrentTrackPoint)
    if(isNullOrUndefined(mEnrolleesData.UserTransactionRecordLogger)){
        mEnrolleesData.UserTransactionRecordLogger = new UserTransactionRecordLogger(mEnrolleesData.OffenderCurrentId,gUserDetails.UserId);
        
        var lMapDateRange = offenderMapPopulate_GetDateRange();
        mEnrolleesData.UserTransactionRecordLogger.addTransactionMultiple([
            {LogDateName:UserTransactionRecordEvents.MAP_START,LogDateValue:lMapDateRange.startDate,TrackReviewed:mEnrolleesControls.PlaybackControl.getOverlayCount()},
            {LogDateName:UserTransactionRecordEvents.MAP_END,LogDateValue:lMapDateRange.endDate,TrackReviewed:mEnrolleesControls.PlaybackControl.getOverlayCount()},
            {LogDateName:UserTransactionRecordEvents.PLAY,LogDateValue:lMapDateRange.startDate,TrackReviewed:lTrackpointsReviewed}
        ])
    }else {
        var lDate =overlayDateFormatter(lCurrentTrackPoint);
        mEnrolleesData.UserTransactionRecordLogger.addTransaction(UserTransactionRecordEvents.PLAY,lDate,-1,lTrackpointsReviewed)
    }
    
}

function uEnrolleesMapPlaybackPauseButton_OnClick() {
    "use strict";
    mEnrolleesControls.PlaybackControl.pause();
    $('#uMapPlaybackSpeed').html('');
    var lTrackpointsReviewed =  mEnrolleesControls.PlaybackControl.getOverlaysPlayed(),
            lCurrentTrackPoint =  mEnrolleesControls.PlaybackControl.getCurrentPoint(),
            lDate =overlayDateFormatter(lCurrentTrackPoint);
        if(!isNullOrUndefined(mEnrolleesData.UserTransactionRecordLogger)){
            mEnrolleesData.UserTransactionRecordLogger.addTransaction(UserTransactionRecordEvents.PAUSE,lDate,-1,lTrackpointsReviewed)
        }
}

function uEnrolleesMapPlaybackFastForwardButton_OnClick() {
    "use strict";

    if (mEnrolleesData.PlaybackStatus === 'Playing' || mEnrolleesData.PlaybackStatus === 'Rewinding') {
        if (mEnrolleesData.PlaybackDirection === 1) {
            switch (mEnrolleesData.PlaybackDivider) {
                case 1:
                    mEnrolleesData.PlaybackDivider = 2;
                    break;
                case 2:
                    mEnrolleesData.PlaybackDivider = 4;
                    break;
                case 4:
                    mEnrolleesData.PlaybackDivider = 8;
                    break;
                case 8:
                    mEnrolleesData.PlaybackDivider = 1;
                    break;
            }
        } else {
            mEnrolleesData.PlaybackDirection = 1;
            mEnrolleesData.PlaybackDivider = 1;
            mEnrolleesControls.PlaybackControl.direction(mEnrolleesData.PlaybackDirection);
        }
        mEnrolleesControls.PlaybackControl.speed(mEnrolleesData.PlaybackDivider);
        $('#uMapPlaybackSpeed').html('(' + mEnrolleesData.PlaybackDivider + 'x)');
        var lTrackpointsReviewed =  mEnrolleesControls.PlaybackControl.getOverlaysPlayed(),
            lCurrentTrackPoint =  mEnrolleesControls.PlaybackControl.getCurrentPoint(),
            lDate =overlayDateFormatter(lCurrentTrackPoint);
            if(!isNullOrUndefined(mEnrolleesData.UserTransactionRecordLogger)){
                mEnrolleesData.UserTransactionRecordLogger.addTransaction(UserTransactionRecordEvents.FAST_FORWARD,lDate,-1,lTrackpointsReviewed)
            }
    }
}


// slow down function for iteration 3? use in wherever slowdown is required
function uEnrolleesMapPlaybackSlowDownButton_OnClick() {
    "use strict";

    if (mEnrolleesData.PlaybackStatus === 'Playing' || mEnrolleesData.PlaybackStatus === 'Rewinding') {
        if (mEnrolleesData.PlaybackDirection === 1) {
            switch (mEnrolleesData.PlaybackDivider) {
                case 1:
                    mEnrolleesData.PlaybackDivider = 0;
                    break;
                case 2:
                    mEnrolleesData.PlaybackDivider = 1;
                    break;
                case 4:
                    mEnrolleesData.PlaybackDivider = 2;
                    break;
                case 8:
                    mEnrolleesData.PlaybackDivider = 4;
                    break;
            }
            var lTrackpointsReviewed =  mEnrolleesControls.PlaybackControl.getOverlaysPlayed(),
            lCurrentTrackPoint =  mEnrolleesControls.PlaybackControl.getCurrentPoint(),
            lDate =overlayDateFormatter(lCurrentTrackPoint);
            if(!isNullOrUndefined(mEnrolleesData.UserTransactionRecordLogger)){
                mEnrolleesData.UserTransactionRecordLogger.addTransaction(UserTransactionRecordEvents.SLOW_DOWN,lDate,-1,lTrackpointsReviewed)
            }
        } else {
            //mEnrolleesData.PlaybackStatus = 'Playing';
            //$('#uMapPlaybackStatus').html(mEnrolleesData.PlaybackStatus);
            mEnrolleesData.PlaybackDirection = 1;
            mEnrolleesData.PlaybackDivider = 1;
            mEnrolleesControls.PlaybackControl.direction(mEnrolleesData.PlaybackDirection);
        }
        if (mEnrolleesData.PlaybackDivider == 0) {
            uEnrolleesMapPlaybackPauseButton_OnClick();
            mEnrolleesData.PlaybackDivider = 1;
        }
        else {
            mEnrolleesControls.PlaybackControl.speed(mEnrolleesData.PlaybackDivider);
            $('#uMapPlaybackSpeed').html('(' + mEnrolleesData.PlaybackDivider + 'x)');
        }
    }
}

function uEnrolleesMapPlayback_OnProgressed(aSender, aEvent, aEventData) {
    "use strict";

    var lPercentage = ((aEvent.currentIndex + 1) / aEvent.overlayCount) * 100,
        lDate = aEvent.currentPoint.TrackDateUTC,
        lLatitude = aEvent.currentPoint.Latitude,
        lLongitude = aEvent.currentPoint.Longitude,
        lEnrollee = mEnrolleesControls.CardView.selectedDataItem(),
        lTimeZone = getEnrolleeTimeZone(lEnrollee.Id),
        lTrackType = 'track point';

    if (aEvent.currentPoint.Type == 2) {
        lTrackType = 'visit';
    }
    else if (aEvent.currentPoint.Type == 3) {
        lTrackType = 'cellular';
    }
    if (isNullOrUndefined(lDate)) {
        lDate = aEvent.currentPoint.StartDateUTC;
    }
    $('#uMapPlaybackOutput').html('Location ' + '(' + lTrackType +
        ') ' + (aEvent.currentIndex + 1).toString() + ' of ' + aEvent.overlayCount.toString() + ' (' + displayEnrolleeTimeZone(lDate, lTimeZone) + ')' + '&thinsp;   &thinsp;' + ' Latitude ' + lLatitude.toString() + ' Longitude ' + lLongitude.toString());
    $('#uSlider').slider('option', 'value', aEvent.currentIndex);
}
function uEnrolleesMapPlayback_OnBookmarkViewed(aSender, aEvent, aEventData) {
    console.log(aSender, aEvent, aEventData)
    for(var key=0; key<aEvent.currentBookmark.data.length;key++){
        if(aEvent.currentBookmark.viewed){
            var lEvent = aEvent.currentBookmark.data[key];
            var lTypeId = bookmarkTypeIdFormatter(lEvent);
            console.log('TypeId', lTypeId)
            var lTrackpointsReviewed =  mEnrolleesControls.PlaybackControl.getOverlaysPlayed();
            if(!isNullOrUndefined(mEnrolleesData.UserTransactionRecordLogger)){
                mEnrolleesData.UserTransactionRecordLogger.addTransaction(UserTransactionRecordEvents.VIEWED,new Date(lEvent['StartDateUTC']),lTypeId,lEvent.Id,lTrackpointsReviewed)
            }
        }
    }
    
}

function uEnrolleesMapPlaybackStopButton_OnClick() {
    "use strict";

    if (!isNullOrUndefined(mEnrolleesControls.PlaybackControl)) {
        mEnrolleesControls.PlaybackControl.stop();
    }
    mEnrolleesData.PlaybackDirection = 1;
    mEnrolleesData.PlaybackDivider = 1;
    $('#uMapPlaybackSpeed').html('');
    $('#uMapPlaybackOutput').html('');
    $('#uSlider').slider('option', 'value', 0);
    if(mEnrolleesControls.PlaybackControl.IsActive()){ 
        var lTrackpointsReviewed =  mEnrolleesControls.PlaybackControl.getOverlaysPlayed(),
            lCurrentTrackPoint =  mEnrolleesControls.PlaybackControl.getCurrentPoint(),
            lDate =overlayDateFormatter(lCurrentTrackPoint);       
            console.log('STOP',lCurrentTrackPoint,lTrackpointsReviewed)
            if(!isNullOrUndefined(mEnrolleesData.UserTransactionRecordLogger)){
                mEnrolleesData.UserTransactionRecordLogger.addTransaction(UserTransactionRecordEvents.STOP,lDate,-1,lTrackpointsReviewed)
            }
    }
}

function uEnrolleesMapPlayback_OnCompleted(aSender, aEvent, aEventData) {
    "use strict";
    var lClientProperty = veritracks.system.clientSetting('TrackReviewByPlayback');
    var isChecked = document.getElementById('uBookmarksToggleButton').checked;
    var lTrackpointsReviewed =  mEnrolleesControls.PlaybackControl.getOverlaysPlayed(),
        lCurrentTrackPoint =  mEnrolleesControls.PlaybackControl.getCurrentPoint();
    if (lClientProperty && isChecked) {
        var lHtml = `
        <div class="playback-review-content">
        <h3>${localizeText('cAgentTrackReviewAgreement')}</h3>
        </div>
    `;
        var lButtonBar = GenerateButtonCommandBar();
        GenerateButton(localizeText('cUserAgreementAccept'), '', function(){
            if(!isNullOrUndefined(mEnrolleesData.UserTransactionRecordLogger)){
                mEnrolleesData.UserTransactionRecordLogger.addTransaction(UserTransactionRecordEvents.ACKNOWLEDGE,new Date(),-1,-1,lTrackpointsReviewed);
                mEnrolleesData.UserTransactionRecordLogger = null;
            }
            ClosePopup();
        }).appendTo(lButtonBar);
        DisplayPopup(localizeText('cAcknowledge'), lHtml, lButtonBar, false, true);
    }
    if(!isNullOrUndefined(mEnrolleesData.UserTransactionRecordLogger)){
        var lDate =overlayDateFormatter(lCurrentTrackPoint);
        mEnrolleesData.UserTransactionRecordLogger.addTransaction(UserTransactionRecordEvents.END,lDate,-1,-1,lTrackpointsReviewed)
    }
    uEnrolleesMapPlaybackStopButton_OnClick();
}

function uToggleAllLastKnownPointsButton_OnClick() {
    "use strict";

    var lIsCaseLoadVisible = false,
        lPreference = new UserPreference(),
        lUserPreferences = getUserPreferences(4);

    // using user preferences caseload to save state.
    if (!isNullOrUndefined(lUserPreferences['IsCaseLoadVisible'])) {
        lIsCaseLoadVisible = (lUserPreferences['IsCaseLoadVisible'].Value === 'true');
    }
    if (!lIsCaseLoadVisible) {
        if (!isNullOrUndefined(mEnrolleesControls.EnrolleesMap)) {
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('CaseLoad', veritracks.mapping.prepareTrackpointMarkerData(mEnrolleesData.LastLocationByCardView));
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('CaseLoadLabels', veritracks.mapping.prepareSuggestionLabelOverlayData(mEnrolleesData.LastLocationByCardView));
        }
        mEnrolleesControls.EnrolleesMap.layerShow('CaseLoad');
        mEnrolleesControls.EnrolleesMap.layerShow('CaseLoadLabels');
        $('#uToggleAllLastKnownPointsButton').addClass('Selected');
        $('#uToggleAllLastKnownPointsButton').attr('title', localizeTitleFormatter('remove all last known positions'));
    } else {
        mEnrolleesControls.EnrolleesMap.layerHide('CaseLoad');
        mEnrolleesControls.EnrolleesMap.layerHide('CaseLoadLabels');
        $('#uToggleAllLastKnownPointsButton').removeClass('Selected');
        $('#uToggleAllLastKnownPointsButton').attr('title', localizeTitleFormatter('toggle all last known positions'));
    }
    lPreference.ColumnName = 'IsCaseLoadVisible';
    lPreference.UserPreferenceType = 4;
    lPreference.Value = !lIsCaseLoadVisible;
    lPreference.Id = gUserDetails.UserId;
    writeUserPreferences([lPreference]);
}

function uDisplayBLUBoxConfirmedLocation(aSerialNumber) {
    "use strict";
    var lDeviceLastContact;
    var lDeviceCluster;
    var lDeviceClusterDevice;
    var lBuilder = new SumoPredicateBuilder();

    lBuilder.AddNewExpressionConditional('Name', aSerialNumber, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lDeviceCluster = query(getDataItems('DeviceClusters'), lBuilder.RootExpression);
    for (var lKey in lDeviceCluster) {
        if (lDeviceCluster.hasOwnProperty(lKey)) {
            lDeviceCluster = lDeviceCluster[lKey];
        }
    }

    if (lDeviceCluster) {
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('DeviceClusterId', lDeviceCluster.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lDeviceClusterDevice = query(getDataItems('DeviceClusterDevices'), lBuilder.RootExpression);
        for (var lKey in lDeviceClusterDevice) {
            if (lDeviceClusterDevice.hasOwnProperty(lKey)) {
                lDeviceLastContact = getDataItem(lDeviceClusterDevice[lKey].DeviceId, 'DeviceLastContact');
            }
        }
    }

    if (lDeviceLastContact && lDeviceCluster && lDeviceLastContact.Latitude !== 0 && lDeviceLastContact.Longitude !== 0) {
        if (!isNullOrUndefined(mEnrolleesControls.EnrolleesMap)) {
            var lDeviceTrack = {
                'Latitude': lDeviceLastContact.Latitude,
                'Longitude': lDeviceLastContact.Longitude,
                'TrackTypeId': 14,
                'Name': lDeviceCluster.Name +' - Confirmed'
            }
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('DeviceLastContact', veritracks.mapping.prepareTrackpointMarkerData([lDeviceTrack]));
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('DeviceLastContactLabels', veritracks.mapping.prepareSuggestionLabelOverlayData([lDeviceTrack]));
        }
        mEnrolleesControls.EnrolleesMap.layerShow('DeviceLastContact');
        mEnrolleesControls.EnrolleesMap.layerShow('DeviceLastContactLabels');
    }
}

function enrolleesPrintInit(aMapCardViewDataSource, aEnrolleesData, aEnrolleesControls) {
    var allowed = "veritracks.com";
    if (document.domain.indexOf(allowed) !== -1) {
        document.domain = allowed;
    }
    var lDisplayType = 'roadmap',
        layerAdd,
        lKey,
        lCard,
        lListKey,
        lVisitList = [],
        lTagList = [],
        lTagLabelList = [],
        lLabelList = [],
        lZones = aEnrolleesData.OffenderMapCardRendered,
        lZoneList = [],
        lZoneNameList = [],
        lBuilder = new SumoPredicateBuilder(),
        lValue;
        if (aEnrolleesControls.OffenderTrackpointDetailCardViewFilter) {
        lValue = aEnrolleesControls.OffenderTrackpointDetailCardViewFilter.columnValue('Type');
        } else {
            lValue = aEnrolleesControls.VictimTrackpointDetailCardViewFilter.columnValue('TypeVictim');
        }



    lBuilder.AddNewExpressionConditional('Type', 2, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lZoneList = query(lZones, lBuilder.RootExpression);

    mPrintControls.PrintMap = new sumo.maps.GoogleMapControl('uPrintMap', 'uMapPanel', { 'displayType': lDisplayType, 'OnClick': null });

    var lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': true,
        'isVisible': true,
        'clickEventHandler': veritracks.mapping.enrolleeMarkerClick,
        'zIndexStart': 90000
    };

    // removed causes too much of a clutter.
    // map labels
    if (lValue.indexOf('10') !== -1) {
        lLayerOptions = {
            'renderType': 'label',
            'doesPlayback': true,
            'isVisible': true,
            'clickEventHandler': null,
            'zIndexStart': 85000
        };
        mPrintControls.PrintMap.layerAdd('Labels', lLayerOptions);
    }

    lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'zIndexStart': 120000,
        'dragEndEventHandler': function (aEvent, aMarker) {
            var lLatLong = { 'Latitude': aMarker.latLng.lat(), 'Longitude': aMarker.latLng.lng() };
            populateEditView(lLatLong, [], {}, 'uMapTag', 'Edit');
        }
    };
    mPrintControls.PrintMap.layerAdd('TagEdit', lLayerOptions);

    lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': function () { },
        'zIndexStart': 60000
    };
    mPrintControls.PrintMap.layerAdd('Addresses', lLayerOptions);
    lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 80000
    };
    mPrintControls.PrintMap.layerAdd('Tags', lLayerOptions);
    mPrintControls.PrintMap.layerAdd('TagLabels', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1700000
    });
    mPrintControls.PrintMap.layerAdd('ZonesNames', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1700000
    });
    mPrintControls.PrintMap.layerAdd('Zones', {
        'renderType': 'geometry',
        'doesPlayback': false,
        'isVisible': true,
            'clickEventHandler': null,
        'zIndexStart': 1000000,
        'shapeChangeHandler': offenderZoneMapShape_OnChange
    });
    mPrintControls.PrintMap.layerAdd('Selected', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1200000
    });
    mPrintControls.PrintMap.layerAdd('SuggestionLabels', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1300000
    });
    mPrintControls.PrintMap.layerAdd('Suggestions', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1400000
    });
    mPrintControls.PrintMap.layerAdd('Visits', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1600000
    });
    if (lValue.indexOf('7') !== -1) {
        lLayerOptions = {
            'renderType': 'linesegment',
            'doesPlayback': true,
            'isVisible': true,
            'isClickable': false,
            'clickEventHandler': null,
            'zIndexStart': 10000
        };
        mPrintControls.PrintMap.layerAdd('ConnectedTracks', lLayerOptions);
    }

    if (lZoneList == null) {
        lZoneList = [];
    }

    for (lKey in aMapCardViewDataSource) {

        if (aMapCardViewDataSource.hasOwnProperty(lKey)) {
            lCard = aMapCardViewDataSource[lKey];
            if (!isNullOrUndefined(lCard)) {
                switch (lCard.Type) {
                    case 2:
                        lZoneList.push(lCard.TrackItem);
                        lZoneNameList.push(lCard.TrackItem);
                        break;
                    case 3:
                        //lVisitList.push(veritracks.mapping.prepareTrackpointMarkerItem({ 'Latitude': lCard.Latitude, 'Longitude': lCard.Longitude, 'TrackTypeId': 4 }));
                        //lVisitList.push(veritracks.mapping.prepareVisitItem(lCard));
                        lVisitList.push(lCard.TrackItem);
                        lLabelList.push(lCard);
                        break;
                    case 4:
                        //lVisitList.push(veritracks.mapping.prepareTrackpointMarkerItem({ 'Latitude': lCard.Latitude, 'Longitude': lCard.Longitude, 'TrackTypeId': 1 }));
                        lVisitList.push(lCard.TrackItem);
                        lLabelList.push(lCard);
                        break;
                    case 5:
                        //lVisitList.push(veritracks.mapping.prepareTrackpointMarkerItem({ 'Latitude': lCard.Latitude, 'Longitude': lCard.Longitude, 'TrackTypeId': 1 }));
                        lVisitList.push(lCard.TrackItem);
                        lLabelList.push(lCard);
                        break;
                        //if (lCard.Type === 3) {
                        //    //lVisitList.push(veritracks.mapping.prepareTrackpointMarkerItem({ 'Latitude': lCard.Latitude, 'Longitude': lCard.Longitude, 'TrackTypeId': 4 }));
                        //    lVisitList.push(veritracks.mapping.prepareVisitItem(lCard));
                        //} else if (lCard.Type === 5) {
                        //    lVisitList.push(veritracks.mapping.prepareTrackpointMarkerItem({ 'Latitude': lCard.Latitude, 'Longitude': lCard.Longitude, 'TrackTypeId': 1 }));
                        //    lLabelList.push(lCard);
                        //} else if (lCard.Type === 4) {
                        //    lLabelList.push(lCard);
                        //    lVisitList.push(veritracks.mapping.prepareTrackpointMarkerItem({ 'Latitude': lCard.Latitude, 'Longitude': lCard.Longitude, 'TrackTypeId': 1 }));
                        //}
                    case 8:
                        lVisitList.push(lCard.TrackItem);
                        lLabelList.push(lCard);
                        break;
                }
            }
        }
    }
    for (lKey in aMapCardViewDataSource) {

        if (aMapCardViewDataSource.hasOwnProperty(lKey)) {
            lTagItem = aMapCardViewDataSource[lKey];
            if (!isNullOrUndefined(lTagItem)) {
                if (lTagItem.Type === 6) {
                    lTagList.push(veritracks.mapping.prepareTrackpointMarkerItem(lTagItem.TrackItem.data, 1));
                    lTagLabelList.push(veritracks.mapping.prepareSuggestionLabelOverlayData([lTagItem.TrackItem.data]));
                } else if (lTagItem.Type === 1) {
                    lTagList.push(lTagItem.TrackItem);
                    lTagLabelList.push(lTagItem);
                }
            }
        }
    }
    var lLabels = veritracks.mapping.prepareTrackpointDetailCardLabelOverlayData(lLabelList, lValue);
    mPrintControls.PrintMap.layerSetDataSource('Labels', lLabels);
    //mPrintControls.PrintMap.layerSetDataSource('', veritracks.mapping.prepareNumericLabelOverlayData(lEnrolleesData.OffenderMapCardDirty));
    mPrintControls.PrintMap.layerSetDataSource('TagLabels', lTagLabelList);
    mPrintControls.PrintMap.layerSetDataSource('Tags', lTagList);
    mPrintControls.PrintMap.layerSetDataSource('Visits', lVisitList);
    mPrintControls.PrintMap.layerSetDataSource('Zones', lZoneList);
    mPrintControls.PrintMap.layerSetDataSource('ZonesNames', veritracks.mapping.prepareEnrolleesZoneLabelOverlayData(lZoneNameList));
    mPrintControls.PrintMap.layerSetDataSource('ConnectedTracks', veritracks.mapping.prepareTripPointLineSegmentData(lVisitList));

    var arrayConcat = lVisitList.concat(lTagList, lZoneList);
    if (arrayConcat.length > 0) {
        var lMapBounds = mPrintControls.PrintMap.getBoundsFromArray(arrayConcat);
        mPrintControls.PrintMap.fitBounds(lMapBounds);
    } else {
        var lCenter = aEnrolleesControls.EnrolleesMap.getCenter();
        mPrintControls.PrintMap.zoom(aEnrolleesControls.EnrolleesMap.getZoom());
        mPrintControls.PrintMap.setCenter(lCenter.lat(), lCenter.lng());
    }
}


function EnrolleesCheckTrackPointEvents(aCard) {
    "use strict";
    var lHasEvents = false;

    if (aCard.TrackItem.data.IsInBraceletStrap) {
        lHasEvents = true;
    }
    if (aCard.TrackItem.data.IsInExclusionZone) {
        lHasEvents = true;
    }
    if (aCard.TrackItem.data.IsInInclusionZone) {
        lHasEvents = true;
    }
    if (aCard.TrackItem.data.IsInLowBattery) {
        lHasEvents = true;
    }
    if (aCard.TrackItem.data.IsOnCharger) {
        lHasEvents = true;
    }

    return lHasEvents;
}
function uShowConnectedTrackPoints_OnClick() {
    "use strict";
    mEnrolleesControls.EnrolleesMap.layerShow('ConnectedTracks');
    mEnrolleesControls.EnrolleesMap.layerShow('SecondaryConnectedTracks');
    mEnrolleesControls.EnrolleesMap.layerShow('Labels');
    $('#uShowConnectedButton').hide();
    $('#uHideConnectedButton').show();
}

function uHideConnectedTrackPoints_OnClick() {
    "use strict";
    mEnrolleesControls.EnrolleesMap.layerHide('ConnectedTracks');
    mEnrolleesControls.EnrolleesMap.layerHide('SecondaryConnectedTracks');
    mEnrolleesControls.EnrolleesMap.layerHide('Labels');
    $('#uShowConnectedButton').show();
    $('#uHideConnectedButton').hide();
}

function offenderSecondaryMapPopulate(aIsStandalone) {
    "use strict";
    var lDateRange = offenderMapPopulate_GetDateRange(),
       lTripStartDate = lDateRange.startDate,
       lTripEndDate = lDateRange.endDate,
       lSecondaryOffender = getDataItem(mEnrolleesData.OffenderSecondaryCurrentId, 'Enrollees');

    if (!lSecondaryOffender.InMyOrganization)
        $('#uEnrolleesPrintButton').hide();
    else
        $('#uEnrolleesPrintButton').show();

    function onReplace(aId) {
        mEnrolleesData.OffenderMapRequestCount -= 3;
        alert(mEnrolleesData.OffenderMapRequestCount);
    }
    if (!isNullOrUndefined(mEnrolleesData.OffenderSecondaryCurrentId) && mEnrolleesData.OffenderSecondaryCurrentId > 0) {
        if (!$('#uAddOffenderSecondaryButton').hasClass('Selected')) {
            $('#uAddOffenderSecondaryButton').addClass('Selected');
        }
    }

    var lSmallTimelineUsed = $('#enrolleesSmallMapCharting').is(":visible");

    if (lSmallTimelineUsed) {
        lTripStartDate = mEnrolleesData.ChartStartDate;
        lTripEndDate = mEnrolleesData.ChartEndDate;
    }

    var ltTripStartDate = FixSentDate(lTripStartDate, lSecondaryOffender);
    var ltTripEndDate = FixSentDate(lTripEndDate, lSecondaryOffender);

    if (!isNullOrUndefined(mEnrolleesData.OffenderSecondaryCurrentId) && mEnrolleesData.OffenderSecondaryCurrentId != mEnrolleesData.OffenderCurrentId) {
        veritracks.enrollees.mapping.initialize(mEnrolleesData.OffenderSecondaryCurrentId, 2, ltTripStartDate, ltTripEndDate);
        var lNextDay = offenderMapPopulateNextDay_GetDateRange(ltTripEndDate);
        if (lNextDay.IsValid && !lSmallTimelineUsed)
            veritracks.enrollees.mapping.initializeNextDay(mEnrolleesData.OffenderSecondaryCurrentId, 2, lNextDay.startDate, lNextDay.endDate);
    }
}

function addSecondaryOffender_OnContinue() {
    "use strict";
    var lSelectedEnrollee = mEnrolleesControls.OffenderSecondaryEnrolleeListView.selectedDataItem();

    mEnrolleesData.OffenderSecondaryCurrentId = lSelectedEnrollee.Id;
    //if(mEnrolleesData.IsExpandedAllVisits)
    //    uExpandAllVisitPointsButton_OnClick();
    if (mEnrolleesData.OffenderSecondaryCurrentId != mEnrolleesData.OffenderCurrentId) {
        $('#uAddOffenderSecondaryButton').addClass('Selected');
    } else {
        if ($('#uAddOffenderSecondaryButton').hasClass('Selected')) {
            $('#uAddOffenderSecondaryButton').removeClass('Selected');
        }
    }
    offenderSecondaryMapPopulate(true);
    ClosePopup();
    if (mEnrolleesData.PlaybackStatus !== 'Stopped') {
        uEnrolleesMapPlaybackStopButton_OnClick();
    }
    $('#uMapPlaybackPanel').hide();
}

function clearSecondaryOffender_OnClick() {
    "use strict";
    veritracks.enrollees.mapping.clear(2);
    ClosePopup();
    mEnrolleesData.OffenderSecondaryCurrentId = null;
    $('#uAddOffenderSecondaryButton').removeClass('Selected');
    $('#uMapPlaybackPanel').show();
}

function uOffenderSecondaryEnrolleeListView_OnSelectChange() {
    "use strict";
    $('#uPopupContainer .AddButton').show();

    if (!isNullOrUndefined(mEnrolleesData.OffenderSecondaryCurrentId)) {
        $('#uPopupContainer .RemoveButton').show();
    } else {
        $('#uPopupContainer .RemoveButton').hide();
    }
}

function uSecondaryOffenderFilterFullNameEdit_OnKeyUp(aTextBox) {
    "use strict";
    var lEnrollees = getDataItems('Enrollees'),
        lBuilder = new SumoPredicateBuilder(),
        lOrganizationValue = parseInt($('#uSecondaryOffenderFilterOrganizationIdEdit').val()),
        lIsAssignedValue = $('#uSecondaryOffenderFilterIsAssignedEdit').val(),
        lAgentValue = parseInt($('#uSecondaryOffenderFilterAgentIdEdit').val()),
        lNameValue = $(aTextBox).val();

    lBuilder.AddNewExpressionConditional('RiskLevel', 1, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
    if (lOrganizationValue !== -1) {
        lBuilder.AddNewExpressionConditional('OrganizationId', lOrganizationValue, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    }
    if (lAgentValue !== -1) {
        lBuilder.AddNewExpressionConditional('AgentId', lAgentValue, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    }
    if (lIsAssignedValue !== '-1') {
        lIsAssignedValue = (lIsAssignedValue === 'true');
        lBuilder.AddNewExpressionConditional('IsAssigned', lIsAssignedValue, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    }
    if ($.trim(lNameValue) !== '') {
        lBuilder.AddNewExpressionConditional('FullName', lNameValue, false, mRelationalOperatorEnum.Like(), mLogicalOperatorEnum.And());
    }
    // remove victims from offender maps.
    lBuilder.AddNewExpressionConditional('EnrolleeType', 1, false, mRelationalOperatorEnum.Like(), mLogicalOperatorEnum.And());

    lEnrollees = query(lEnrollees, lBuilder.RootExpression);
    mEnrolleesControls.OffenderSecondaryEnrolleeListView.setDataSource(lEnrollees);
}

function uSecondaryOffenderFilterAgentIdEdit_OnChange(aSelect) {
    "use strict";
    $('#uSecondaryOffenderFilterFullNameEdit').keyup();
}

function uSecondaryOffenderFilterOrganizationIdEdit_OnChange(aSelect) {
    "use strict";
    var lAgents = getDataItems('Agents'),
        lBuilder = new SumoPredicateBuilder(),
        lValue = parseInt($(aSelect).val());

    if (lValue !== -1) {
        lBuilder.AddNewExpressionConditional('OrganizationId', lValue, false, mRelationalOperatorEnum.Equal(), mRelationalOperatorEnum.GreaterThan());
        lAgents = query(lAgents, lBuilder.RootExpression);
    }
    populateEditView({ 'AgentId': -1 }, [
        { 'Id': 'AgentId', 'Type': 'Dropdown', 'DataSource': lAgents, 'DataValueField': 'Id', 'DataTextField': 'FullName', 'isNullableKey': true, 'nullText': '' }
    ], {}, 'uSecondaryOffenderFilter', 'Edit');
    $('#uSecondaryOffenderFilterAgentIdEdit').change();
}

function enrolleesOffendersAddSecondary_OnLoad() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lSecondaryOffenderList = [];
    mEnrolleesControls.OffenderSecondaryEnrolleeListView = new sumo.controls.ListView('uOffenderMapSecondaryListView', 'uOffenderMapSecondaryListViewHolder', {
        'keyField': 'Id',
        'keyFieldType': 'number',
        'cssClass': 'VeritracksSelectListView',
        'selectMethod': 'single',
        'canUnselect': true,
        'showHeader': false
    }, [
    { 'id': 'Name', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'FullName', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'dataType': 'string', 'canResize': true }
    ]);
    if (!isNullOrUndefined(mEnrolleesData.OffenderSecondaryCurrentId)) {
        $('#uPopupContainer .AddButton').show();
        $('#uPopupContainer .RemoveButton').show();
    } else {
        $('#uPopupContainer .AddButton').hide();
        $('#uPopupContainer .RemoveButton').hide();
    }
    mEnrolleesControls.OffenderSecondaryEnrolleeListView.bind('selectedchanged', uOffenderSecondaryEnrolleeListView_OnSelectChange);
    populateEditView({ 'OrganizationId': -1 }, [
        { 'Id': 'OrganizationId', 'Type': 'Dropdown', 'DataSource': getDataItems('Organizations'), 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': true, 'nullText': '' }
    ], {}, 'uSecondaryOffenderFilter', 'Edit');
    $('#uSecondaryOffenderFilterOrganizationIdEdit').change();

    if (!isNullOrUndefined(mEnrolleesData.OffenderSecondaryCurrentId)) {
        mEnrolleesControls.OffenderSecondaryEnrolleeListView.selected(mEnrolleesData.OffenderSecondaryCurrentId);
        $('#uPopupContainer .RemoveButton').show();
    } else {
        mEnrolleesControls.OffenderSecondaryEnrolleeListView.selected(mEnrolleesData.OffenderCurrentId);
        $('#uPopupContainer .RemoveButton').hide();
    }
}

function uAddOffenderSecondaryButton_OnClick() {
    "use strict";
    var lButtonCommandBar = GenerateButtonCommandBar();
    GenerateButton(localizeWrapper('cEnrolleeAddToMap'), 'Add', 'addSecondaryOffender_OnContinue()').appendTo(lButtonCommandBar);
    GenerateButton(localizeWrapper('cEnrolleeRemoveFromMap'), 'Remove', 'clearSecondaryOffender_OnClick()').appendTo(lButtonCommandBar);
    GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'ClosePopup()').appendTo(lButtonCommandBar);
    DisplayPopup(localizeWrapper('cEnrolleeAddSecondaryOffender'), '<div id="uOffenderMapSecondaryHolder" style="height:100%;"></div>', lButtonCommandBar, false);

    populateElement('uOffenderMapSecondaryHolder', 'Enrollees.Offenders.Map.Secondary.Popup.Layout.htm', enrolleesOffendersAddSecondary_OnLoad);
}


function enrolleesGeocodeToolBar_OnClick() {
    "use strict";
    if (veritracks.enrollees.mapping.data.DoGeocode) {
        veritracks.enrollees.mapping.data.DoGeocode = false;
        $('#uGeocodeToolBarButton').removeClass('Selected');
    } else {
        if (veritracks.enrollees.mapping.data.DoDistanceCalculation) {
            enrolleesDistanceToolBar_OnClick();
        } else if (veritracks.enrollees.mapping.data.DoAddHomeAddress) {
            enrolleesHomeAddressAdd_OnClick();
        }
        veritracks.enrollees.mapping.data.DoGeocode = true;
        $('#uGeocodeToolBarButton').addClass('Selected');
    }
}

function enrolleesDistanceToolBar_OnClick() {
    "use strict";
    if (veritracks.enrollees.mapping.data.DoDistanceCalculation) {
        veritracks.enrollees.mapping.data.DoDistanceCalculation = false;
        $('#uDistanceToolCommandButton').removeClass('Selected');
        mEnrolleesData.DistancePoints = [];
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('DistancePoints', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('DistanceLabels', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('ConnectedDistancePoints', []);
    } else {
        if (veritracks.enrollees.mapping.data.DoGeocode) {
            enrolleesGeocodeToolBar_OnClick();
        } else if (veritracks.enrollees.mapping.data.DoAddHomeAddress) {
            enrolleesHomeAddressAdd_OnClick();
        }
        veritracks.enrollees.mapping.data.DoDistanceCalculation = true;
        $('#uDistanceToolCommandButton').addClass('Selected');
    }
}

function enrolleesHomeAddressAdd_OnClick() {
    "use strict";
    if (veritracks.enrollees.mapping.data.DoAddHomeAddress) {
        veritracks.enrollees.mapping.data.DoAddHomeAddress = false;
        $("#uHomeToolCommandButton").removeClass("Selected");
    } else {
        if (veritracks.enrollees.mapping.data.DoGeocode) {
            enrolleesGeocodeToolBar_OnClick();
        } else if (veritracks.enrollees.mapping.data.DoDistanceCalculation) {
            enrolleesDistanceToolBar_OnClick();
        }
        veritracks.enrollees.mapping.data.DoAddHomeAddress = true;
        $("#uHomeToolCommandButton").addClass("Selected");
    }//end of if

}
function enrolleeBookmarksToggleButton_OnClick() {
    var isChecked = document.getElementById('uBookmarksToggleButton').checked;
    if (isChecked) {
        mEnrolleesControls.PlaybackControl.removeBookmarks();
        mEnrolleesControls.PlaybackControl.bookmarkAdd('Events',bookmarkEventDataFormatter);
        mEnrolleesControls.PlaybackControl.bookmarkAdd('FrequentVisits',bookmarkFrequentVisitDataFormatter);
    } else {
         mEnrolleesControls.PlaybackControl.removeBookmarks();
    }
}

function enrolleesCalculateDistance_OnComplete(aDistance, aLatitude, aLongitude) {
    "use strict";
    mEnrolleesControls.EnrolleesMap.layerSetDataSource('DistanceLabels', veritracks.mapping.prepareDistanceLabelOverlayData([{ 'latitude': aLatitude, 'longitude': aLongitude, 'text': aDistance }]));
    mEnrolleesControls.EnrolleesMap.layerSetDataSource('ConnectedDistancePoints', veritracks.mapping.prepareTripPointLineSegmentData(mEnrolleesData.DistancePoints));
}

function enrolleesCalculateDistance(aClickData,unit) {
    "use strict";
    var lLatitude = aClickData.lat(),
        lLongitude = aClickData.lng(),
        lResult,
        lCard;
    if (!isNullOrUndefined(lLatitude) && !isNullOrUndefined(lLongitude)) {
        if (mEnrolleesData.DistancePoints.length >= 2) {
            mEnrolleesData.DistancePoints = [];
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('DistancePoints', veritracks.mapping.prepareDistanceMarkerData([]));
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('DistanceLabels', veritracks.mapping.prepareDistanceLabelOverlayData([]));
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('ConnectedDistancePoints', veritracks.mapping.prepareTripPointLineSegmentData([]));
        }
        lCard = new DistanceCard();
        lCard.latitude = lLatitude;
        lCard.longitude = lLongitude;
        if (isNullOrUndefined(mEnrolleesData.DistancePoints)) {
            mEnrolleesData.DistancePoints.push(lCard);
        } else {
            mEnrolleesData.DistancePoints.push(lCard);
        }
        if (mEnrolleesData.DistancePoints.length > 1) {
            if (unit == null) {
                lResult = veritracks.mapping.calculateDistances(mEnrolleesData.DistancePoints[0].latitude, mEnrolleesData.DistancePoints[0].longitude, mEnrolleesData.DistancePoints[1].latitude, mEnrolleesData.DistancePoints[1].longitude, 'events');
            }
            else {
                if (unit.name === "Metric") {
                    lResult = veritracks.mapping.calculateDistancesMetric(mEnrolleesData.DistancePoints[0].latitude, mEnrolleesData.DistancePoints[0].longitude, mEnrolleesData.DistancePoints[1].latitude, mEnrolleesData.DistancePoints[1].longitude, 'events');
                }
                else {
                    lResult = veritracks.mapping.calculateDistances(mEnrolleesData.DistancePoints[0].latitude, mEnrolleesData.DistancePoints[0].longitude, mEnrolleesData.DistancePoints[1].latitude, mEnrolleesData.DistancePoints[1].longitude, 'events');
                }
            }
            enrolleesCalculateDistance_OnComplete(lResult.distanceDisplay, lResult.endPoint.latitude, lResult.endPoint.longitude);
        }
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('DistancePoints', veritracks.mapping.prepareDistanceMarkerData(mEnrolleesData.DistancePoints));
    }
}

function enrolleeAddressGeocode_OnSuccess(aResult, aStatus) {
    "use strict";
    var lAddress;
    if (aStatus == "OK") {
        lAddress = aResult.formated_address.split(",");
        if (lAddress.length == 4) {
            $("#uOffenderAddressStreet1Edit").val(lAddress[0]);
            $("#uOffenderAddressCityEdit").val(lAddress[1]);
            var stateZip = lAddress[2].split(" ");
            $("#uOffenderAddressStateEdit").val(stateZip[1]);
            $("#uOffenderAddressZipEdit").val(stateZip[2]);
            $("#uOffenderAddressCountryEdit").val(lAddress[3]);
        } else {
            $("#uOffenderAddressStreet1Edit").val(lAddress[0]);
            $("#uOffenderAddressStreet2Edit").val(lAddress[1]);
            $("#uOffenderAddressCityEdit").val(lAddress[2]);
            var stateZip = lAddress[3].split(" ");
            $("#uOffenderAddressStateEdit").val(stateZip[1]);
            $("#uOffenderAddressZipEdit").val(stateZip[2]);
            $("#uOffenderAddressCountryEdit").val(lAddress[4]);
        }//end of if

        //click the find button
        uOffenderAddressEditMapLocateButton_OnClick();

    }//end of outer if
}

function enrolleesHomeAddressAdd(aClickData) {
    "user strict";
    var lat = aClickData.lat(),
        lng = aClickData.lng();

    mEnrolleesData.EnrolleeAddressGeocodeMatch = true;
    enrolleeAddressEditGenerator(-1, -1);
    veritracks.mapping.reverseGeoCode(mEnrolleesControls.EnrolleesMap, lat, lng, enrolleeAddressGeocode_OnSuccess);
}

function enrolleesMapPanel_OnClick() {
    "use strict";
    if ($('#uEnrolleesListCell').is(':visible') || $('#uMapDetailPanelCell').is(':visible')) {
        $('#uExpandMapButton').addClass('ExpandMapButton').removeClass('ContractMapButton');

    } else {
        $('#uExpandMapButton').removeClass('ExpandMapButton').addClass('ContractMapButton');
    }
    if ($('#uMapDetailPanelCell').is(':visible')) {
        mEnrolleesControls.NotificationPanel.clearNotifications();
        if (!isNullOrUndefined(mEnrolleesControls.OffenderTrackpointDetailCardView)) {
            mEnrolleesControls.OffenderTrackpointDetailCardView.scrollTop(mEnrolleesControls.OffenderTrackpointDetailCardView.selected());
        }
    } else {
        //var lSelected = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItem();
        //if (!isNullOrUndefined(lSelected) && !isNullOrUndefined(lSelected.TrackItem)) {
        //    $(lSelected.TrackItem).click();
        //}
    }
    resetOffenderProfileWindow(.25);
    resetContentHoldersEnrollees();
}

function uExpandMapButtonButton_OnClick(aSender) {
    "use strict";
    if ($(aSender).hasClass('ExpandMapButton')) {
        veritracks.mapping.setMapPanelDisplay($('#uPrimaryMapCollapsePanel'), 'uEnrolleesListCell', false, enrolleesMapPanel_OnClick);
        veritracks.mapping.setMapPanelDisplay($('#uSecondaryMapCollapsePanel'), 'uMapDetailPanelCell', false, enrolleesMapPanel_OnClick);
    } else {
        veritracks.mapping.setMapPanelDisplay($('#uPrimaryMapCollapsePanel'), 'uEnrolleesListCell', true, enrolleesMapPanel_OnClick);
        veritracks.mapping.setMapPanelDisplay($('#uSecondaryMapCollapsePanel'), 'uMapDetailPanelCell', true, enrolleesMapPanel_OnClick);
    }
}

function instantReporting_OnClick(aReportType, aMonitoredEventId) {
    "use strict";
    var lEnrollees = getDataItems('Enrollees'),
        lBuilder = new SumoPredicateBuilder(),
        lAgentId,
        lEnrollee,
        lOrganizationId,
        lParams,
        lCard = mEnrolleesControls.CardView.selectedDataItem(),
        lEnrolleeEventIds,
        lEnrolleeEventNames = [],
        lEnrolleeEventIdList,
        lFilterState,
        lKey,
        lItem,
        lIsConfirmed,
        lIsOpen,
        lStartDateText,
        lStopDateText,
        lStartDate = 0,
        lStopDate = 0,
        lDuration = 0,
        lDurationText = '0';


    lEnrollee = lEnrollees[mEnrolleesData.OffenderCurrentId];
    if (!isNullOrUndefined(lEnrollee)) {
        lOrganizationId = lEnrollee.OrganizationId;
        lAgentId = getMyAgentIdsByOrganization(gUserDetails.UserId, [lOrganizationId])[0];

        if (aReportType === 0) {//Enrollee Profile Instant Report

            CreateEnrolleeProfileInstantReport(mEnrolleesData.OffenderCurrentId, lAgentId);

        } else if (aReportType === 2 && aMonitoredEventId > 0) {//Enrollee Monitored Instant Report

            CreateMonitoredInstantReport(aMonitoredEventId, lAgentId);

        } else {                //Enrollee Events Instant Report

            var lInstantReportData = new EnrolleeEventInstantReportData();
            lFilterState = mEnrolleesControls.EventsListViewFilter.FilterState;
            for (lKey in lFilterState) {
                if (lFilterState.hasOwnProperty(lKey)) {
                    lItem = lFilterState[lKey];

                    if (lItem.ColumnName === 'EventType') {
                        lEnrolleeEventIds = lItem.Value;
                    } else if (lItem.ColumnName === 'IsOpen') {
                        lIsOpen = lItem.Value === "" ? -1 : lItem.Value === true ? 1 : 0;
                    } else if (lItem.ColumnName === 'IsConfirmed') {
                        lIsConfirmed = lItem.Value === "" ? -1 : lItem.Value === true ? 1 : 0;
                    }
                }
            }
            lStartDateText = $('#uEnrolleesEventsListViewFilterStartDateUTC').val();
            lStopDateText = $('#uEnrolleesEventsListViewFilterStopDateUTC').val();

            if (lStopDateText !== '') {
                lStopDate = new Date(lStopDateText);
                lStopDate.setHours(0, 0, 0, 0);
            }

            if (lStartDateText !== '') {
                lStartDate = new Date(lStartDateText);
                lStartDate.setHours(0, 0, 0, 0);
            }

            lDuration = lStopDate - lStartDate;
            lDurationText = lDuration.toString();
            lEnrolleeEventIdList = JSON.parse(lEnrolleeEventIds);
            lEnrolleeEventIds = lEnrolleeEventIds.replace("\"", "");
            lEnrolleeEventIds = lEnrolleeEventIds.replace(/\\\//g, "");
            lEnrolleeEventIds = lEnrolleeEventIds.replace("[", "");
            lEnrolleeEventIds = lEnrolleeEventIds.replace("]", "");
            lEnrolleeEventIds = lEnrolleeEventIds.replace(/\"/g, '');

            for (lKey in lEnrolleeEventIdList) {
                if (lEnrolleeEventIdList.hasOwnProperty(lKey)) {
                    lItem = lEnrolleeEventIdList[lKey];
                    lItem = getDataItem(lItem, 'EventGroup');
                    if (!isNullOrUndefined(lItem)) {
                        lEnrolleeEventNames.push(lItem.Description);
                    }
                }
            }

            lInstantReportData.EnrolleeId = lCard.Id;
            lInstantReportData.EnrolleeName = lCard.FullName;
            lInstantReportData.StartDate = DisplaySuperShortDate(lStartDate);//.toGMTString();
            lInstantReportData.EndDate = DisplaySuperShortDate(lStopDate);//.toGMTString();
            lInstantReportData.EventsList = lEnrolleeEventIds;
            lInstantReportData.EventsListNames = lEnrolleeEventNames.join(',');
            lInstantReportData.IsOpen = lIsOpen;// ? 1 : 0;

            lInstantReportData.Duration = lDuration;
            lInstantReportData.DurationText = lDurationText;

            lInstantReportData.IsConfirmed = lIsConfirmed;// ? 1 : 0;


            CreateEnrolleeEventInstantReport(lInstantReportData, lAgentId);

        }
    }
}
function enrolleesOffenderMapTypeChange(aIndex) {
    "use strict";
    var lValue = mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.columnValue('Type'),
        lIndex = lValue.indexOf(aIndex),
        lItem,
        mMap = mEnrolleesControls.EnrolleesMap.getMap(),
        lCenter = mMap.getCenter(),
        lKey;
    veritracks.enrollees.mapping.PreviousZoom(mEnrolleesControls.EnrolleesMap.getZoom());
    if (lIndex === -1) {
        lValue.push(aIndex);
    } else {
        lValue.remove(lIndex, lIndex);
    }
    mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.columnValue('Type', lValue);
    mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.filter();
}

//Heat Map

function populateHeatMapData() {
    "use strict";
    var lCardList = [],
        lCTPoints = [],
        lHeatDataSet = [];

    lCardList = lCardList.concat(mEnrolleesControls.EnrolleesMap.layerGetDataSource('ConnectedTracks'));
    lCardList = lCardList.concat(mEnrolleesControls.EnrolleesMap.layerGetDataSource('DistancePoints'));
    lCardList = lCardList.concat(mEnrolleesControls.EnrolleesMap.layerGetDataSource('ConnectedDistancePoints'));
    lCardList = lCardList.concat(mEnrolleesControls.EnrolleesMap.layerGetDataSource('Visits'));
    lCardList = lCardList.concat(mEnrolleesControls.EnrolleesMap.layerGetDataSource('SecondaryVisits'));
    lCardList = lCardList.concat(mEnrolleesControls.EnrolleesMap.layerGetDataSource('SecondaryConnectedTracks'));

    for (var key in lCardList) {
        if (lCardList.hasOwnProperty(key)) {

            if (!isNullOrUndefined(lCardList[key]) && !isNullOrUndefined(lCardList[key].data)) {
                if (lCardList[key].data.TrackTypeId == 1) {
                    lCTPoints.push(lCardList[key]);
                } else {
                    if (lCardList[key].data.hasOwnProperty("begin")) {
                        lHeatDataSet.push(lCardList[key].data.begin.data);

                        if (lCardList[key].data.hasOwnProperty("end")) {
                            lHeatDataSet.push(lCardList[key].data.end.data);
                        }

                        if (!isNullOrUndefined(lCardList[key].data.Latitude) && !isNullOrUndefined(lCardList[key].data.Longitude)) {
                            lHeatDataSet.push(lCardList[key].data);
                        }


                    } else if (lCardList[key].data.hasOwnProperty("end")) {
                        lHeatDataSet.push(lCardList[key].data.end.data);
                        if (!isNullOrUndefined(lCardList[key].data.Latitude) && !isNullOrUndefined(lCardList[key].data.Longitude)) {
                            lHeatDataSet.push(lCardList[key].data);
                        }
                    } else {
                        lHeatDataSet.push(lCardList[key].data);
                    }
                }

            }//end of if
        }
    }//end of for

    return { 'heatpoints': lHeatDataSet, 'ctpoints': lCTPoints };
}

function uShowHeatMapButton_OnClick() {
    "use strict";
    var lHeatDataPoints = [],
        lCTPoints = [];

    if (mEnrolleesControls.EnrolleesMap.getHeatMap() == null) {
        var lHeatDataSet = populateHeatMapData();
        lHeatDataPoints = lHeatDataSet.heatpoints;
        lCTPoints = lHeatDataSet.ctpoints;
        mEnrolleesControls.EnrolleesMap.layerHide("ConnectedTracks");
        mEnrolleesControls.EnrolleesMap.layerHide("SecondaryConnectedTracks");
        mEnrolleesControls.EnrolleesMap.layerHide("Visits");
        mEnrolleesControls.EnrolleesMap.layerHide("SecondaryVisits");
        mEnrolleesControls.EnrolleesMap.layerHide("DistancePoints");
        mEnrolleesControls.EnrolleesMap.layerHide("ConnectedDistancePoints");
        if (lCTPoints.length > 0) {
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('TempHeatCT', lCTPoints);
            mEnrolleesControls.EnrolleesMap.layerShow("TempHeatCT");
        } else {
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('TempHeatCT', []);
        }
        mEnrolleesControls.EnrolleesMap.setHeatMapDataPoints(lHeatDataPoints);
        if (!isNullOrUndefined(mEnrolleesControls.PlaybackControl)) {
            mEnrolleesControls.PlaybackControl.Activate(false);
            uEnrolleesMapPlaybackLock();
        }
    } else {
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('TempHeatCT', []);
        mEnrolleesControls.EnrolleesMap.layerHide("TempHeatCT");
        mEnrolleesControls.EnrolleesMap.layerShow("ConnectedTracks");
        mEnrolleesControls.EnrolleesMap.layerShow("SecondaryConnectedTracks");
        mEnrolleesControls.EnrolleesMap.layerShow("Visits");
        mEnrolleesControls.EnrolleesMap.layerShow("SecondaryVisits");
        mEnrolleesControls.EnrolleesMap.layerShow("DistancePoints");
        mEnrolleesControls.EnrolleesMap.layerShow("ConnectedDistancePoints");
        if (!isNullOrUndefined(mEnrolleesControls.PlaybackControl)) {
            mEnrolleesControls.PlaybackControl.Activate(true);
            uEnrolleesMapPlaybackLock();
        }
    }


    mEnrolleesControls.EnrolleesMap.toggleHeatMap();

    if (mEnrolleesControls.EnrolleesMap.getHeatMap() != null) {
        mEnrolleesControls.EnrolleesMap.changeRadius(20);
        //$("#uShowHeatMapButton").removeClass("HeatMapButton");
        $("#uShowHeatMapButton").addClass("Selected");

    } else {
        //$("#uShowHeatMapButton").addClass("HeatMapButton");
        $("#uShowHeatMapButton").removeClass("Selected");
    }



}

function uShowVisitsButton_OnClick() {
    "use strict";
    enrolleesOffenderMapTypeChange('3');
}

function uShowTrackpointsButton_OnClick() {
    "use strict";
    enrolleesOffenderMapTypeChange('5');
}

function uShowTrackPointEventsButton_OnClick() {
    "use strict";
    enrolleesOffenderMapTypeChange('20');
}

function uShowVisitPointsButton_OnClick() {
    "use strict";

    enrolleesOffenderMapTypeChange('4');
}

function uEnrolleeVisitExpandedPreference() {
    "use strict";
    var lPreferences = getUserPreferences(4);
    var lExpanded = false;

    if (lPreferences) {
        var lVisitPreferences = lPreferences['VisitExpandedPreference'];
        if (lVisitPreferences) {
            lExpanded = (lVisitPreferences.Value == "1" ? true : false);
        }
    }

    if (lExpanded) {
        $('#uExpandAllButton').addClass('Selected');
    } else {
        $('#uExpandAllButton').removeClass('Selected');
    }
}

function uExpandAllVisitPointsButton_OnClick() {
    "use strict";
    if ($('#uExpandAllButton').hasClass('Selected')) {
        $('#uExpandAllButton').removeClass('Selected');
        mEnrolleesData.IsExpandedAllVisits = false;
        uShowVisitPoints_CloseVisits();
        saveExpandVisitPointPreference(0);

    }
    else {
        if (!$('#uShowVisitPointsButton').hasClass('Selected')) {
            enrolleesOffenderMapTypeChange('4');
        }
        mEnrolleesData.IsExpandedAllVisits = true;
        $('#uExpandAllButton').addClass('Selected');
        uShowVisitPoints_ExpandVisits();
        saveExpandVisitPointPreference(1);
    }
}

function saveExpandVisitPointPreference(aVisitDisplayPreference) {
    "use strict";
    var lPreferenceWrite = [];
    var userId = gUserDetails.UserId;
    var lVisitDisplayPreference = aVisitDisplayPreference;

    if (!isNullOrUndefined(lVisitDisplayPreference)) {
        lPreference = new UserPreference();
        lPreference.UserPreferenceType = 4;
        lPreference.ColumnName = 'VisitExpandedPreference';
        lPreference.Id = userId;
        lPreference.Value = lVisitDisplayPreference;
        lPreferenceWrite.push(lPreference);
    }
    if (lPreferenceWrite.length > 0) {
        writeUserPreferences(lPreferenceWrite, onSuccessSavingExpandedVisitsPreference);
    }
}

function onSuccessSavingExpandedVisitsPreference() {
    "use strict";
}

function uShowVisitPoints_CloseVisits() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lData,
        lKey;

    lBuilder.AddNewExpressionConditional('VisitId', -1, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
    lData = veritracks.enrollees.mapping.data.PrimaryCardList.concat(veritracks.enrollees.mapping.data.SecondaryCardList);
    lData = query(lData, lBuilder.RootExpression);

    for (lKey in lData) {
        if (lData.hasOwnProperty(lKey)) {
            lData[lKey].IsExpanded = false;
        }
    }
    veritracks.enrollees.mapping.data.VisitCardList = [];
    mEnrolleesData.VisitsProcesssed = false;
    mEnrolleesData.OffenderPastData = null;

    mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.filter();
    if (!isNullOrUndefined(mEnrolleesControls.EnrolleesMap.getHeatMap())) {
        mEnrolleesControls.EnrolleesMap.disposeHeatMap();
        uShowHeatMapButton_OnClick();
    }
}
function uShowVisitPoints_ExpandVisits() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lData,
        lIsExpanded;

    // user story 660
    lBuilder.AddNewExpressionConditional('VisitId', -1, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
    lData = veritracks.enrollees.mapping.data.PrimaryCardList.concat(veritracks.enrollees.mapping.data.SecondaryCardList);
    lData = query(lData, lBuilder.RootExpression);

    lBuilder.AddNewExpressionConditional('IsExpanded', true, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lIsExpanded = query(lData, lBuilder.RootExpression);

    if (ObjectLength(lIsExpanded) != ObjectLength(lData)) {
        veritracks.enrollees.mapping.data.VisitCardList = [];
        mEnrolleesData.VisitsProcesssed = false;
    } else {
        // mEnrolleesData.VisitsProcesssed = true;
    }

    if (lData.length > 0 && !mEnrolleesData.VisitsProcesssed) {
        veritracks.enrollees.mapping.expandAllVisits();
    }
}

function uEnrolleeSpatialBackButton_OnClick() {
    "use strict";
    var lUrl = 'Analysis.History.Map',
        lViewState = getViewState('AnalysisSelectedIncident'),
        lAnalysisViewState = getViewState('AnalysisView');

    if (lAnalysisViewState)
        lUrl = 'Analysis.' + lAnalysisViewState.Value + '.Map';

    if (lViewState) {
        if (lViewState.Value) {
            lUrl += '.' + lViewState.Value;
        }
    }
    deleteViewState('TravelBackFromEnrolleesTile');
    deleteViewState('AnalysisView');
    window.location.hash = lUrl;
}

function getEnrolleeTimeZone(aEnrolleeId, aDefaultId) {
    var lEnrollee = GetEnrollee(aEnrolleeId);
    var lTimeZone;

    if (!lEnrollee && aDefaultId) {
        return getTimezone(aDefaultId, 'TimeZone');
    }

    lTimeZone = getTimezone(lEnrollee.TimeZoneId, 'TimeZone');

    return lTimeZone;
}

function getTimeZoneUTCDday(aDate, aTimeZoneName) {
    "use strict";
    var lUTCDay = 0,
        lOffset = getTimeZoneOffSet(aTimeZoneName),
        lDate = new Date(aDate);
    // convert to utc time
    lDate.addMinutes(-lOffset);
    // use regular get day
    lUTCDay = lDate.getDay();

    return lUTCDay;
}

/* Veritracks Enrollees Schedule View */

function uEnrolleeViewScheduleButton_OnClick() {
    "use strict";
    var lCarvedSchedule = checkCarveOutModeEnabled(mEnrolleesData.OffenderCurrentId);
    var lAbsences;

    enrolleeSchedulePopup_Init(mEnrolleesData.OffenderCurrentId);
    if (lCarvedSchedule) {
        lAbsences = getAbsentSchedules(mEnrolleesData.OffenderCurrentId);
        if(lAbsences.length > 0)
            enrolleesVeritracksCalendarEnterCarveMode();
    }
}

function enrolleesSortSchedulePopup(aSchedules) {
    "use strict";
    var lFullSchedule = [],
        lEnrolleeSchedules = aSchedules,
        lAllWeekSchedule,
        lSchedule,
        lStartTime,
        lTime,
        lKey,
        i = 0,
        lBuilder = new SumoPredicateBuilder();

    // sort 24 hour schedules first, then whatever
    for (i = 0; i < lEnrolleeSchedules.length; i++) {
        lSchedule = lEnrolleeSchedules[i];
        lAllWeekSchedule = (lSchedule.IsMonday && lSchedule.IsTuesday && lSchedule.IsWednesday && lSchedule.IsThursday && lSchedule.IsFriday && lSchedule.IsSaturday && lSchedule.IsSunday)
        if (lAllWeekSchedule) {
            lStartTime = new Date(lSchedule.StartTime);
            lTime = new Date(lSchedule.EndTime);
            lTime = lTime.addMinutes(1);
            if (lStartTime - lTime == 0) {
                lFullSchedule.push(lSchedule);
                lEnrolleeSchedules.splice(i, 1);
                i--;
            }
        }
    }

    lEnrolleeSchedules = ScheduleSortHourFormatter(lEnrolleeSchedules);

    for (lKey in lFullSchedule) {
        if (lFullSchedule.hasOwnProperty(lKey)) {
            lEnrolleeSchedules.unshift(lFullSchedule[lKey]);
        }
    }
    return lEnrolleeSchedules;
}


function selectEditModePopup() {
    "use strict";
    var lHtml = [];
    var lButtonCommandBar = GenerateButtonCommandBar();
    var lEditingSchedule = mEnrolleesControls.veritracksCalendar.getEditingSchedule();
    if (!lEditingSchedule.isRecurring) {
        createSchedule(lEditingSchedule.start, lEditingSchedule.end, lEditingSchedule.scheduleId, false, false);
        uDeleteSchedule([lEditingSchedule.scheduleId], true);
    }
    else {
        lHtml.push('<div class="Button LargeIconButton FullEditScheduleIcon" onclick="CreateChangedSchedule(1);">' + localizeWrapper('cEnrolleeEdit') +'</div>');
        if (!lEditingSchedule.end || lEditingSchedule.start.day() == lEditingSchedule.end.day() && (lEditingSchedule.end.date() - lEditingSchedule.start.date() != 7)) {
            lHtml.push('<div class="Button LargeIconButton CreateOverrideIcon" onclick="CreateChangedSchedule(4);">' + localizeWrapper('cCreateOverride') + '</div>');
        }
        DisplayModal(localizeWrapper('cEnrolleeEditMode'), lHtml.join(''), 'CloseCalendarModal()', true);
    }
}

function handleClickSchedule(aEvent, deleteOnly) {
    "use strict";
    var lHtml = [];
    var lButtonCommandBar = GenerateButtonCommandBar();
    var lEdit = aEvent;
    if (aEvent.editable) {
    mEnrolleesControls.veritracksCalendar.setEditingSchedule(lEdit);
   // if (!deleteOnly)
    lHtml.push('<div class="Button LargeIconButton FullEditScheduleIcon" onclick="ClickChangedSchedule(1);">' + localizeWrapper('cEnrolleeEdit') + '</div>');
    lHtml.push('<div class="Button LargeIconButton DeleteSingleDayIcon" onclick="ClickChangedSchedule(2);">' + localizeWrapper('cEnrolleeDeleteDay') + '</div>');
    if (lEdit.isRecurring)
            lHtml.push('<div class="Button LargeIconButton DeleteAllSchedulesIcon" onclick="ClickChangedSchedule(3);">' + localizeWrapper('cEnrolleeDeleteAll') + '</div>');
    lHtml.push('</div>');
    DisplayModal(localizeWrapper('cEnrolleeEditMode'), lHtml.join(''), 'CloseCalendarModal()', true);
    } else {
        mActivityNotification.addNotification(localizeWrapper('cEnrolleeScheduleNoEdit'));
    }
}

function createSchedule(aStart, aEnd, aId, aReocurring, aPopup) {
    "use strict";
    var lPopupName = localizeWrapper('cEnrolleeAddNewSchedule');
    if (!aEnd) {
        aEnd = moment(aStart).add(1, 'day');
    }
    if (aId !== -1) {
        mEnrolleesData.SchedulesEditItem = new OffenderScheduleDisplay(GetOffenderSchedule(aId), aPopup);
        var lTimeZone = getEnrolleeTimeZone(mEnrolleesData.SchedulesEditItem.EnrolleeId);
        lPopupName = localizeWrapper('cEnrolleeEditSchedule');
        if (aStart) {
            singleFullCalendarObject(mEnrolleesData.SchedulesEditItem, aStart, aEnd, false);
        } else {
            mEnrolleesData.SchedulesEditItem.StartTime = displayFixedTimeZoneTime(mEnrolleesData.SchedulesEditItem.StartTime, lTimeZone.TimeZoneName);
            mEnrolleesData.SchedulesEditItem.EndTime = displayFixedTimeZoneTime(mEnrolleesData.SchedulesEditItem.EndTime, lTimeZone.TimeZoneName);
        }
        if (!mEnrolleesData.SchedulesEditItem.IsRecurring && !mEnrolleesData.SchedulesEditItem.IsNoSchedule) {
            FixStartTime();
        }
    } else {
        mEnrolleesData.SchedulesEditItem = new OffenderSchedule();
        singleFullCalendarObject(mEnrolleesData.SchedulesEditItem, aStart, aEnd, false);
    }

    if (aPopup) {
        if (ModalIsOpen()) {
            CloseModal();
        }
        EnrolleeProfileSchedule_Init(lPopupName, enrolleesSchedulePopulate, true);
    } else {
        mEnrolleesData.SchedulesEditItem.IsRecurring = aReocurring;
        mEnrolleesData.SchedulesEditItem.Id = -1;

        mEnrolleesData.SchedulesEditItem.StartTime = convertTimeToUTC(mEnrolleesData.SchedulesEditItem.StartTime, lTimeZone.TimeZoneName);
        mEnrolleesData.SchedulesEditItem.EndTime = convertTimeToUTC(mEnrolleesData.SchedulesEditItem.EndTime, lTimeZone.TimeZoneName);
        WriteMultiple([mEnrolleesData.SchedulesEditItem], enrolleesOffenderScheduleWrite_OnSuccess, enrolleesOffenderScheduleWrite_OnFailure, null, true);
    }
}

function fixOverrideShifts(aDate, aSchedule) {
    "use strict";
    var lDate = moment(aDate);
    var lDay = 0;

    if (aSchedule.IsSunday)
        lDay = 0;
    if (aSchedule.IsMonday)
        lDay = 1;
    if (aSchedule.IsTuesday)
        lDay = 2;
    if (aSchedule.IsWednesday)
        lDay = 3;
    if (aSchedule.IsThursday)
        lDay = 4;
    if (aSchedule.IsFriday)
        lDay = 5;
    if (aSchedule.IsSaturday)
        lDay = 6;

    if (moment(aDate).day() == 0 && lDay == 6) {
        aDate = moment(aDate).add(-7, 'days');
    }

    if (moment(aDate).day() == 6 && lDay == 0) {
        aDate = moment(aDate).add(7, 'days');
    }

    return moment(aDate).weekday(lDay);
}

function scheduleEditAllowed(aCarve, aScheduleType){
    "use strict";
    var lAllowed = true;

    if (aCarve && [2, 3].indexOf(aScheduleType) !== -1) {
        lAllowed = false;
    }
    return lAllowed;
}

function generateSchedulesTimespan(aView) {
    var lDataSource = [],
        lSchedule,
        lStartDate = aView.start,
        lEndDate = aView.end,
        lIsAllDay = false,
        lIsEditable = true,
        lScheduleMoment,
        lEnrollee = GetEnrollee(mEnrolleesControls.veritracksCalendar.getExtraData("enrolleeId")),
        lBuilder = new SumoPredicateBuilder();

    var lTimeZone = getTimezone(lEnrollee.TimeZoneId);

    var aId = mEnrolleesControls.veritracksCalendar.calendarId();
    var aDataSource = mEnrolleesControls.veritracksCalendar.getDataSource();
    var lAbsencesExist = mEnrolleesControls.veritracksCalendar.getExtraData("absencesExist");
    $(aId).fullCalendar('removeEvents');

    for (var lKey in aDataSource) {
        if (aDataSource.hasOwnProperty(lKey)) {
            lSchedule = aDataSource[lKey];
            lScheduleMoment = moment(lSchedule.StartTime);

            if (moment(lSchedule.StartTime).diff(moment(lSchedule.EndTime), 'minutes') == 1) {
                lIsAllDay = true;
            } else {
                lIsAllDay = false;
            }
            if (lSchedule.TargetTypeId == 6) {
                lIsEditable = false;
            }
            else {
                lIsEditable = scheduleEditAllowed(lAbsencesExist, lSchedule.TargetTypeId);
            }
            if (!lSchedule.IsReocurring) {
                var lFullCalendarObject = new fullCalendarObject(lSchedule, DisplaySuperShortMomentDate(lScheduleMoment), lIsAllDay, lSchedule.IsReocurring, lIsEditable);
                //if (lSchedule.TargetTypeId == 7) {
                lFullCalendarObject.start = fixOverrideShifts(lSchedule.StartTime, lSchedule);
                lFullCalendarObject.end = fixOverrideShifts(lSchedule.EndTime, lSchedule);
                //}
                lDataSource.push(lFullCalendarObject);
            }
            if (lSchedule.IsReocurring) {
                var lMoment = moment(lStartDate);
                while (lMoment < lEndDate) {
                    var lDay = lMoment.day();
                    var lFullCalendarObject = new fullCalendarObject(lSchedule, DisplaySuperShortMomentDate(lMoment), lIsAllDay, lSchedule.IsReocurring, lIsEditable);
                    if (lSchedule.IsSunday && lDay == 0) {
                        lDataSource.push(lFullCalendarObject);
                    } else if (lSchedule.IsMonday && lDay == 1) {
                        lDataSource.push(lFullCalendarObject);
                    } else if (lSchedule.IsTuesday && lDay == 2) {
                        lDataSource.push(lFullCalendarObject);
                    } else if (lSchedule.IsWednesday && lDay == 3) {
                        lDataSource.push(lFullCalendarObject);
                    } else if (lSchedule.IsThursday && lDay == 4) {
                        lDataSource.push(lFullCalendarObject);
                    } else if (lSchedule.IsFriday && lDay == 5) {
                        lDataSource.push(lFullCalendarObject);
                    } else if (lSchedule.IsSaturday && lDay == 6) {
                        lDataSource.push(lFullCalendarObject);
                    }
                    lMoment.add(1, 'days');
                }
            }
        }
    }
    $(aId).fullCalendar('addEventSource', lDataSource);
    $(aId).fullCalendar('rerenderEvents');
}


function singleFullCalendarObject(aSchedule, aStart, aEnd, aIsCarved) {
    "use strict";
    var lDay;

    aEnd.local();
    aStart.local();

    if (Math.abs(aStart.diff(aEnd, 'minutes')) == 0) {
        aEnd = moment(aEnd).add(1, 'days');
    }
    if (aEnd.hours() == 0 && aEnd.minutes() == 0) {
        aEnd = moment(aEnd).add(-1, 'minutes');
    }

    if (aIsCarved) {
        aSchedule.StartTime = aStart.format("HH:mm");
        aSchedule.StopTime = aEnd.format("HH:mm");
    } else {
        aSchedule.StartTime = getMoment(aStart);
        aSchedule.EndTime = getMoment(aEnd);
    }
        var lMoment = moment(aStart);
        while (lMoment < aEnd) {
            lDay = lMoment.day();
            if (lDay == 0) {
                aSchedule.IsSunday = true;
            } else if (lDay == 1) {
                aSchedule.IsMonday = true;
            } else if (lDay == 2) {
                aSchedule.IsTuesday = true;
            } else if (lDay == 3) {
                aSchedule.IsWednesday = true;
            } else if (lDay == 4) {
                aSchedule.IsThursday = true;
            } else if (lDay == 5) {
                aSchedule.IsFriday = true;
            } else if (lDay == 6) {
                aSchedule.IsSaturday = true;
            }
            lMoment.add(1, 'days');
        }
}

// onclick methods
function CreateChangedSchedule(aChangeType) {
    var lSchedule = mEnrolleesControls.veritracksCalendar.getEditingSchedule();
    if (aChangeType == 1) { // Full Edit
        createSchedule(lSchedule.start, lSchedule.end, lSchedule.scheduleId, null, true);
    } else if (aChangeType == 4) { // Create Override
        createSchedule(lSchedule.start, lSchedule.end, lSchedule.scheduleId, false, false); //false reocurring, no popup
    }
    else { // Create Reocurring
        createSchedule(lSchedule.start, lSchedule.end, lSchedule.scheduleId, true, false); // true reocurring, no popup
    }

}

function ClickChangedSchedule(aChangeType) {
    var lSchedule = mEnrolleesControls.veritracksCalendar.getEditingSchedule();
    if (aChangeType == 1) { // Full Edit
        createSchedule(null, null, lSchedule.scheduleId, null, true);
    } else if (aChangeType == 2) { // Delete Day
        uUpdateSchedule(lSchedule.scheduleId, lSchedule.start.day());
    }
    else if (aChangeType == 3) { // Delete Schedule
        uRemoveAllAbsenceSchedules([[lSchedule.scheduleId]],[lSchedule.scheduleId], true);
    } else if (aChangeType == 4) {
        uUpdateAbsenceSchedule(lSchedule.scheduleId, lSchedule);
    } else if (aChangeType == 5) {
        uDeleteAbsenceSchedule([lSchedule.scheduleId], true);
    }else if(aChangeType == 6){
      editAbsenceSchedule(lSchedule, true);
    }

}

function CloseCalendarModal() {
    mEnrolleesControls.veritracksCalendar.resetData();
}

//ipad support
function enrolleesIphoneResolutionMapDisplay() {
    "use strict";
    if ($('#uEnrolleesListCell').css('display') == 'none') {
        $('#uEnrolleesTime').css('float', '');
        $('#uEnrolleesTime').css('padding', '');
        $('#uEnrolleeActions').css('float', '');
        setHeight('#uEnrolleesMapButtonBar', 24);
    }
    else {
        $('#uEnrolleesTime').css('float', 'left');
        $('#uEnrolleesTime').css('padding', '5px');
        $('#uEnrolleeActions').css('float', 'left');
        setHeight('#uEnrolleesMapButtonBar', 75);
    }
}

function enrolleesIphoneResolutionTableDisplay() {
    "use strict";
    var uEnrolleesContentWidth = $('#uEnrolleesContentRow').width(),
        uEnrolleesListWidth = $('#uEnrolleesListCell').width(),
        lContentWidth = $('#uEnrolleesMainContentPanel').width();

    //setWidth('#uOffenderProfilePanel', lContentWidth);

    var uEnrolleesSecondPanelWidth = uEnrolleesContentWidth - uEnrolleesListWidth;
    setWidth('#uEnrolleesSecondaryContentPanel', 700 - 10);

    if (mStateManager.Settings()[2] === 'Schedules') {
        $('#uEnrolleesSchedulesListView').css('overflow', 'auto');
    }
}

//Prototype Correlate stuff
function enrolleeCorrelatePopup_Dispose() {
    "use strict";

    $('.PopupWindow').removeClass('CalendarWidth');
    ClosePopup();
    if (!isNullOrUndefined(lCorrelateCardViewControl)){
        lCorrelateCardViewControl.dispose();
        lCorrelateCardViewControl = null;
    }
}

function enrolleeCreateThreads() {
    "use strict";
    var lData = lCorrelateCardViewControl.getDataSource();
    var lOffenderTrackCard = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItem();
    var lDevice
    var lMaster = new NodeThread();//lData.Address;
    var lNodes = [];//lData.enrolleeCorrelations;
    var lCorrelation;
    var lReasons = [];
    var lKey;
    var lPointGroupingIds = lData.enrolleeCorrelations.map(function (c) {return c.MatchPointGroupingId});
    var lEnrolleeIds = lData.enrolleeCorrelations.map(function(c){return c.MatchEnrolleeId});
    var EnrolleeCorrelate = new DataItem("EnrolleeCorrelate");

    lEnrolleeIds.push(lOffenderTrackCard.EnrolleeId);
    lPointGroupingIds.push(lOffenderTrackCard.TrackItem.data.Id);


    var lBuilder = new SumoPredicateBuilder();
    lBuilder.AddNewExpressionConditional('PointGroupingId', lPointGroupingIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    ReadMultiple(EnrolleeCorrelate.AssemblyQualifiedName, lBuilder.RootExpression, 0, matchAssociationsLoad, Sad, {}, null, 0, true);


    function matchAssociationsLoad(aParams, aData) {
        mEnrolleesControls.Threads.setData("Associations", aData);
        var lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrolleeIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

        ReadMultiple(gObjectList.OffenderPhotos.AssemblyQualifiedName, lBuilder.RootExpression, 0, PhotoLoadThreadSave_Success, Sad, null, null, 0, true);

    }

    function PhotoLoadThreadSave_Success(aParams, aData) {
        var lSort = new SortExpression();

        lSort.addDescendingColumn('PhotoOrderNo');
        aData = lSort.sort(aData);
        mEnrolleesControls.Threads.setData("Photos", aData);

        var lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('Id', lOffenderTrackCard.AddressId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.Address.AssemblyQualifiedName, lBuilder.RootExpression, 0, CreateThread, Sad, null, null, 0, true);
    }

    function GetThreadAssociationReasons() {
        var lConnectionReasons = [];
        var lAssociations = mEnrolleesControls.Threads.getData("Associations");
        if (getPermutations(lPointGroupingIds.length, 2) == lAssociations.length) {
            for (var lKey in lAssociations) {
                if (lAssociations.hasOwnProperty(lKey)) {
                    var lAssociation = new VeritracksAsociation(lAssociations[lKey]);
                    if (lAssociation.Description !== "fail") {
                        lConnectionReasons.push(lAssociation);
                    }
                }
            }
        } else {
            var lIdHolder = [];
            for (var lKey in lAssociations) {
                if (lAssociations.hasOwnProperty(lKey)) {
                    if (lIdHolder.indexOf(lAssociations[lKey].Id.toString() + lAssociations[lKey].MatchEnrolleeId.toString()) == -1){
                        var lAssociation = new VeritracksAsociation(lAssociations[lKey]);
                        if (lAssociation.Description !== "fail") {
                            lConnectionReasons.push(lAssociation);
                        }
                        lIdHolder.push(lAssociations[lKey].Id.toString() + lAssociations[lKey].MatchEnrolleeId.toString());
                        var lExtendAssociation = $.extend({}, lAssociations[lKey]);
                        var lTemp = lExtendAssociation.Id;
                        lExtendAssociation.Id = lExtendAssociation.MatchEnrolleeId;
                        lExtendAssociation.MatchEnrolleeId = lTemp;
                        lExtendAssociation.PointGroupingId = lExtendAssociation.MatchPointGroupingId;
                        var lAssociation = new VeritracksAsociation(lExtendAssociation);
                        if (lAssociation.Description !== "fail") {
                            lConnectionReasons.push(lAssociation);
                        }
                        lIdHolder.push(lExtendAssociation.MatchEnrolleeId.toString() + lExtendAssociation.Id.toString());
                    }
                }
            }
        }


        return lConnectionReasons;
    }

    function GetThreadAssociation(aEnrolleeId) {
        var lAssociations = mEnrolleesControls.Threads.getData("Associations");
        var lAssociation;

        for (var lKey in lAssociations) {
            if (lAssociations.hasOwnProperty(lKey)) {
                if (lAssociations[lKey].Id == aEnrolleeId) {
                    lAssociation = lAssociations[lKey];
                    break;
                }
            }
        }


        if (lAssociation) {
            return lAssociation;
        }
    }

    function GetThreadMatchAssociation(aEnrolleeId) {
        var lAssociations = mEnrolleesControls.Threads.getData("Associations");
        var lAssociation;

        for (var lKey in lAssociations) {
            if (lAssociations.hasOwnProperty(lKey)) {
                if (lAssociations[lKey].MatchEnrolleeId == aEnrolleeId) {
                    lAssociation = $.extend({}, lAssociations[lKey]);
                    break;
                }
            }
        }

        lAssociation.PointGroupingId = lAssociation.MatchPointGroupingId;
        lAssociation.DeviceId = lAssociation.MatchDeviceId;

        if (lAssociation) {
            return lAssociation;
        }
    }

    function GetThreadPhotoFromAssociation(aEnrolleeId) {
        var lPhotos = mEnrolleesControls.Threads.getData("Photos");
        var lPhoto;
        for (var i = 0; i < lPhotos.length; i++) {
            if (lPhotos[i].EnrolleeId == aEnrolleeId) {
                lPhoto = lPhotos[i];
                break;
            }
        }
        return lPhoto;
    }
    function CreateThread(aParams, aData) {
        var lAddress = aData[0];
        var lAssociations = mEnrolleesControls.Threads.getData("Associations");

        if (lAddress) {
            lMaster.Identifier = lAddress.Id.toString();
            lMaster.Title = lAddress.Description;
            lMaster.SubTitle = lAddress.Latitude + ", " + lAddress.Longitude;
            lMaster.IconUrl = "Address.png";
            lMaster.Id = lAddress.Id;

            var lIdentifierList = [];
            for (var j = 0; j < lEnrolleeIds.length; j++) {
                var lEnrollee = GetEnrollee(lEnrolleeIds[j]);
                var lAssociation;
                var lPhoto;

                if (lEnrollee) {
                    lAssociation = GetThreadAssociation(lEnrollee.Id);
                    lPhoto = GetThreadPhotoFromAssociation(lEnrollee.Id);
                }
                if (!lAssociation) {
                    lAssociation = GetThreadMatchAssociation(lEnrollee.Id);
                }
                if (lAssociation && lEnrollee) {
                    var lNode = new AssociationNode(
                        lAssociation,
                        lEnrollee,
                        lPhoto
                    );

                    if (lNode.Title !== "" && lIdentifierList.indexOf(lNode.Identifier) == -1) {
                        lNodes.push(lNode);
                        lIdentifierList.push(lNode.Identifier);
                    }
                }
            }
            lReasons = GetThreadAssociationReasons();


            var lThread = mEnrolleesControls.Threads.buildGraph(lMaster, lNodes, lReasons);

            mActivityNotification.addNotification("Creating Thread....");
            mEnrolleesControls.Threads.CreateGraph(lThread, threadGeneration_OnSuccess);
        }
    }
}

function threadGeneration_OnSuccess(aParams, aData) {
    "use strict";

    var lAssociations = lCorrelateCardViewControl.getDataSource().enrolleeCorrelations;
    var lOffenderTrackCard = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItem();
    var lAssociation = lOffenderTrackCard.Association;
    var lAssociationThreads = [];
    var lAssociationThread = new EnrolleeAssociationThread();

    if (aData.ThreadId != "") {
        mEnrolleesData.AssociatedThread = aData.ThreadId;
        $('.ShowThreadButton').removeClass('HideButton');
        $('.SaveButton').addClass('HideButton');

        mActivityNotification.addNotification("Successfully created Thread....");

        lAssociationThread.UserId = gUserDetails.UserId;
        lAssociationThread.ThreadId = aData.ThreadId;
        lAssociationThread.PointGroupingId = lAssociation.PointGroupingId;
        lAssociationThreads.push(lAssociationThread);
        for (var lKey in lAssociations) {
            if (lAssociations.hasOwnProperty(lKey)) {
                lAssociationThread = new EnrolleeAssociationThread();
                lAssociationThread.UserId = gUserDetails.UserId;
                lAssociationThread.ThreadId = aData.ThreadId;
                lAssociationThread.PointGroupingId = lAssociations[lKey].MatchPointGroupingId;
                lAssociationThreads.push(lAssociationThread);
            }
        }
    }

    WriteMultiple(lAssociationThreads, ThreadAssociation_OnSuccess, Sad, null);
}

function ThreadAssociation_OnSuccess(aParams, aData) {
    "use strict";
    console.log(aData);
}

function correlateVisit_OnSuccess(aParams, aData){
    "use strict";

    var lResultVisit = aData;
    var lVisitData = aParams[0].Visit;

    if (!isNullOrUndefined(lResultVisit)) {
        var lVisit = new Object();
        lVisit.TrackItem = '';

        var lTrackItem = new Object();
        lTrackItem.data = lResultVisit;

        lVisit.TrackItem = lTrackItem;
        lVisitData = lVisit;
    }

    var lCorrelateControl = new EnrolleeCorrelateControl(aParams[0].Enrollee, aParams[0].Organization, aParams[0].Agent, aParams[0].TimeZone, lVisitData, aParams[0].Correlation, aParams[0].Photo, aParams[1], aParams[0].Visit.Address);

    if (isNullOrUndefined(lCorrelateCardViewControl)) {
        lCorrelateCardViewControl = new VeritracksCorrelateControl("CorrelateControl", "uAssociationsListPanel", null, "Interface/Enrollees.Offenders.Correlation.Popup.Layout.htm", populateMapEnrolleeCorrelateData, aParams);

        lCorrelateCardViewControl.setDataSource(lCorrelateControl);

        $("#VeritracksCorrelatePanel").find("div[class~='loadingGif']").remove();
    } else {
        lCorrelateCardViewControl.PaginateNext(aParams[0].Enrollee.Id, lCorrelateControl, aParams);
        lCorrelateCardViewControl.setModal(false);
    }//end of if
}

function uAgentCorrelateContact_OnClick(aEnrolleeId) {
    "use strict";
    var lButtonCommandBar = GenerateButtonCommandBar(),
        lTextArea = $('<textarea/>', { 'id': 'uAgentContactTextArea', 'class': 'AgentContactTextArea', 'width': '490px', 'onkeyup': '' });

    function uAgentContactSend_OnSuccess(aParams, aData) {
        ClosePopup();
        mActivityNotification.addNotification(localizeWrapper('cAgentMessageSent'));
    }

    function uAgentContactSend_OnFailure() {
        alert('Fail');
    }

    function uAgentContactSendButton_OnClick() {
        var lMessage = $('#uAgentContactTextArea').val(),
            lCurrentUserId = gUserDetails.UserId,
            lAgentContact = new AgentContact();

        lAgentContact.Subject = 'Enrollee Association Information';
        lAgentContact.Id = aEnrolleeId;
        lAgentContact.UserId = lCurrentUserId;
        lAgentContact.Message = lMessage;

        WriteSingle(lAgentContact, uAgentContactSend_OnSuccess, uAgentContactSend_OnFailure, null, true);
    }

    GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'ClosePopup();').appendTo(lButtonCommandBar);
    GenerateButton(localizeWrapper('cAgentSend'), '', uAgentContactSendButton_OnClick).appendTo(lButtonCommandBar);
    DisplayPopup(localizeWrapper('cAgentContactAgent'), lTextArea, lButtonCommandBar, false, true);
}


function correlationAssignmentRead_OnSuccess(aParams, aData) {
    "use strict";
    var lAssingment = null,
       lGroupPoint = new DataItem("PointGrouping"),
       lDevices = [],
       lBuilder = new SumoPredicateBuilder();


    if (isNullOrUndefined(lCorrelateCardViewControl)) {
        correlateVisit_OnSuccess(aParams, aParams[0].Correlation[0]);
        } else {
        var lCount = lCorrelateCardViewControl.getNextTabCount(aParams[0].Enrollee.Id);
        --lCount;
        correlateVisit_OnSuccess(aParams, aParams[0].Correlation[lCount]);
        }//end of if
}

function correlateDevice_OnSuccess(aParams, aData) {
    "use strict";
    var lDevice = new DataItem("Device"),
        lAssignmentIds = [],
        lBuilder = new SumoPredicateBuilder();

    if (aData.length == 0) {
        correlateVisit_OnSuccess(aParams, null)
    } else {
        for (var key in aData) {
            if (aData.hasOwnProperty(key)) {
                lAssignmentIds.push(aData[key].Id);
            }
        }
        lBuilder.AddNewExpressionConditional('Id', lAssignmentIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        ReadMultiple(lDevice.AssemblyQualifiedName, lBuilder.RootExpression, 0, correlationAssignmentRead_OnSuccess, enrolleeCorrelate_OnFailure, aParams, null, 0, null);
    }

}

function correlateOffenderProfile_OnSuccess(aParams, aData) {
    "use strict";
    var lProfile = null,
        lAssingment = new DataItem("DeviceAssignment"),
        lDate = offenderMapPopulate_GetDateRange(),
        lBuilder = new SumoPredicateBuilder();

    FixDates(aData);
    for (var key in aData) {
        if (aData.hasOwnProperty(key)) {
            lProfile = aData[key];
            break;
        }//end of if
    }//end of for

    correlationAssignmentRead_OnSuccess([aParams, lProfile]);
}

function enrolleeCorrelatePhoto_OnSuccess(aParams, aData) {
    "use strict";
    var lPhoto = null,
        lBuilder = new SumoPredicateBuilder(),
        lProfileType = new DataItem("OffenderProfile");

    for (var key in aData) {
        if (aData.hasOwnProperty(key)) {
            lPhoto = aData[key];
            break;
        }//end of CorrelationNode
    }//end of for

    aParams.Photo = lPhoto;

    lBuilder.AddNewExpressionConditional("Id", aParams.Enrollee.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(lProfileType.AssemblyQualifiedName, lBuilder.RootExpression, 0, correlateOffenderProfile_OnSuccess, enrolleeCorrelate_OnFailure, aParams, null, 0, null);
}

function enrolleeCorrelate_OnSuccess(aParams, aData) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lAgent = new Agent(),
        lOrganization = null,
        lTimeZone = null,
        lEnrolleePhoto = null,
        lResults = {},
        lEnrolleeCard = null,
        lAddressId = -1;

    if(aData.length > 0) {
        for (var key in aData) {
            if (aData.hasOwnProperty(key)) {
                lEnrolleeCard = GetEnrollee(aData[key].MatchEnrolleeId);
                if (!isNullOrUndefined(lEnrolleeCard)) {
                    break;
                }
            }//end of if
        }//end of for
    }

    if (lEnrolleeCard) {
        if (isNullOrUndefined(aParams.isNavigating)) {
            lOrganization = getDataItem(lEnrolleeCard.OrganizationId, 'Organizations');
            lAgent = getDataItem(lEnrolleeCard.AgentId, 'Agents');
            lTimeZone = getDataItem(lEnrolleeCard.TimeZoneId, 'TimeZone');

            lResults = { 'Enrollee': lEnrolleeCard, 'Organization': lOrganization, 'Agent': lAgent, 'TimeZone': lTimeZone, 'Visit': aParams, 'Correlation': aData, 'Photo': '' };
            lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrolleeCard.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        } else {
            lResults = aParams;
            lBuilder.AddNewExpressionConditional('EnrolleeId', lResults.Enrollee.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        }

        lBuilder.AddNewExpressionConditional('IsActive', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.OffenderPhotos.AssemblyQualifiedName, lBuilder.RootExpression, 0, enrolleeCorrelatePhoto_OnSuccess, null, lResults, null, 0);
    }
    else {
        $('.EnrolleeCorrelatetionAutoCentered').remove();
        $('#uAssociationsListPanel').remove();
        mActivityNotification.addNotification(localizeWrapper('cEnrolleeNoCorrelateData'));
    }
}

function enrolleeCorrelate_OnFailure(aParams, aData){
    "use strict";
}

function generateEnrolleeCorrelatePanel(aVisitCard){
    "use strict";
    var lHtml = [],
        lCorrelation = new DataItem("EnrolleeCorrelate"),
        lBuilder = new SumoPredicateBuilder();

    var lMainPanelContent = '<div id="VeritracksCorrelatePanel"><div class="loadingGif EnrolleeCorrelatetionAutoCentered"></div></div>';
    lHtml.push(lMainPanelContent);
    lBuilder.AddNewExpressionConditional("PointGroupingId", aVisitCard.VisitId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(lCorrelation.AssemblyQualifiedName, lBuilder.RootExpression, 0, enrolleeCorrelate_OnSuccess, enrolleeCorrelate_OnFailure, aVisitCard, null, 0, null);

    return lHtml.join('');
}

/*********artf66646**********/
function populateMapEnrolleeCorrelateData(aParams) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    var lCorrelations = aParams[0].Correlation;
    var lEnrollee = aParams[0].Enrollee;
    var lCorrelation;
    var lKey;

    for (lKey in lCorrelations) {
        if (lCorrelations.hasOwnProperty(lKey)) {
            if (lCorrelations[lKey].MatchEnrolleeId == lEnrollee.Id) {
                if (!lCorrelation) {
                    lCorrelation = lCorrelations[lKey];
                }
                if (lCorrelation && lCorrelations[lKey].StartDate < lCorrelation.StartDate) {
                    lCorrelation = lCorrelations[lKey];
                }
            }
        }
    }

    mEnrolleesControls.EnrolleesCorrelateMap.layerSetDataSource('CorrelateVisit', []);
    /*Read data to populate trackpoint*/
    lBuilder.AddNewExpressionConditional('Id', lCorrelation.MatchPointGroupingId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('DeviceId', lCorrelation.MatchDeviceId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('StartDate', moment(lCorrelation.StartDateUTC).add(-1, 'days')._d.toWcf(), false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());

    ReadMultiple(gObjectList.PointGrouping.AssemblyQualifiedName, lBuilder.RootExpression, 0, populateCorrelateMapTrackPoint, null, aParams[0].Visit.Association);
}

function populateCorrelateMapTrackPoint(aAssociation, aData) {
    "use strict";
    var lTrackItem = veritracks.mapping.prepareVisitItem(aData[0], 2, aAssociation);
    var lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
        lIsInformatics = false;
    if (!isNullOrUndefined(lEnrollee)) {
        lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
    }
    
    if (lIsInformatics == false) {
        if (aAssociation && aAssociation.OrganizationAddressId > 0) {
            lTrackItem.iconUri = 'Images/Maps/Trackpoints/20400000AssociationKnownLocation.png';
        } else {
            lTrackItem.iconUri = 'Images/Maps/Trackpoints/20400000Association.png';
        }
    } else {
        lTrackItem.iconUri = veritracks.mapping.iconGenerator.generateMapMarker(lTrackItem.SVGMarker);
    }
   

    mEnrolleesControls.EnrolleesCorrelateMap.layerSetDataSource('CorrelateVisit', [lTrackItem]);
    mEnrolleesControls.EnrolleesCorrelateMap.fitBounds();
}

function populateEnrolleeCorrelateProfile(aEnrolleeData) {
    "use strict";
    /*enrolle data*/
    var lEnrolleeTimeZoneId = getTimezone(aEnrolleeData.TrackItem.data.TimeZoneId),
        uEnrolleeProfileInformation = $('#EnrolleeProfileInformation'),
        lCorrelationVisitIconClass = '',
        lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
        lIsInformatics = false,
        uEnrolleeVisit = $('#EnrolleeVisit');

    if (!isNullOrUndefined(lEnrollee)) {
        lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
    }

    if (lIsInformatics) {
        lCorrelationVisitIconClass = "informatics__icon__cardview";
    } else {
        lCorrelationVisitIconClass = "enrolleeCorrelateVisitIcon";
    }

    uEnrolleeProfileInformation.append('<img id="enrolleeCorrelateVisitIcon" class="' + lCorrelationVisitIconClass + '" src="' + aEnrolleeData.TrackItem.iconUri + '" /> ' + '<span>' + aEnrolleeData.EnrolleeName + '</span>');

    uEnrolleeVisit.append('<table><tr><td id="visitTitle">' +
                            localizeText('cEnrolleesMappingStart') + '</td><td>' +
                            displayEnrolleeTimeZoneFormatted(aEnrolleeData.TrackItem.data.StartDateUTC, lEnrolleeTimeZoneId) +
                            '</td></tr><tr><td id="visitTitle">' +
                            localizeText('cEnrolleesMappingEnd') + '</td><td>' +
                            displayEnrolleeTimeZoneFormatted(aEnrolleeData.TrackItem.data.EndDateUTC, lEnrolleeTimeZoneId) +
                            '</td></tr></table>');

    uEnrolleeVisit.append('<span class="StreetIconProperty" id="uAssociateStreetView" onclick="uAssociationAddressStreetView_OnClick()"></span>');

    loadEnrollePhotos(aEnrolleeData.EnrolleeId, LoadAssociationsPhotosMainOffender);

    associationAddresses_Init(aEnrolleeData.TrackItem.data);


    /*********Known Location Address and ORI**********/
    populateKnownLocationCorrelationInfo(aEnrolleeData);
}

function LoadAssociationsPhotosMainOffender(aParams, aData) {
    "use strict";
    var uEnrolleeCorrelateProfilePhotoUri = $('#uOffenderCorrelateProfilePhotoUri');
    var lSort = new SortExpression();
    lSort.addAscendingColumn('PhotoOrderNo');
    if (!isNullOrUndefined(aData) && aData.length > 0) {
        aData = lSort.sort(aData);
        var lEnrolleeProfileImageUri = aData[0];
        uEnrolleeCorrelateProfilePhotoUri.attr("src",  MUGSHOTS + lEnrolleeProfileImageUri.PhotoUri);

    } else {
        uEnrolleeCorrelateProfilePhotoUri.attr("src", "Images/NoPhoto.png");
    }
}

function uAssociationAddressStreetView_OnClick() {
    var lCard = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItem();
    mEnrolleesControls.EnrolleesCorrelateMap.setStreetLevel(lCard.TrackItem.data.Latitude.toString().substring(0, 9), lCard.TrackItem.data.Longitude.toString().substring(0, 9));
}

/***reverse geocode address***/
function associationAddresses_Init(aVisit) {
    "use strict";
    veritracks.mapping.reverseGeoCode(mEnrolleesControls.EnrolleesCorrelateMap, aVisit.Latitude.toString().substring(0, 9), aVisit.Longitude.toString().substring(0, 9), associateAddress_Success);

    function associateAddress_Success(aResults) {
        var lResult = aResults[0];
        var lAddress = new Address(lResult);
        var lAddressPrepared = lAddress.Street1 + ', ' + lAddress.City + ', ' + lAddress.State + ', ' + lAddress.ZipCode;
        $('#EnrolleeVisit').append('<span>' + lAddressPrepared + '</span>');

    }
}

function checkValidOrganizationAddress(aId) {
    "use strict";
    var lIsValid = false;
    var lOrganizationAddress = getDataItem(aId, 'OrganizationAddress');

    if (lOrganizationAddress && lOrganizationAddress.IsActive) {
        lIsValid = true;
    }

    return lIsValid;
}

/***known location correlation information***/
function populateKnownLocationCorrelationInfo(aEnrolleeData) {
    "use strict";
    var lEnrolleeData = aEnrolleeData,
        lEnrolleeId = lEnrolleeData.EnrolleeId;

    if (!isNullOrUndefined(lEnrolleeData.Association)) {
        if (lEnrolleeData.Association.OrganizationAddressId > 0) {
           var uEnrolleeKnownLocation = $('#EnrolleeKnownLocation'),
               lOrganizationAddress = getDataItem(lEnrolleeData.Association.OrganizationAddressId, 'OrganizationAddress'),
                uEnrolleeKnownLocationIcon = $('#EnrolleeKnownLocationImage');
            if(lOrganizationAddress){
                uEnrolleeKnownLocationIcon.append('<img id="uOffenderCorrelateProperty" src="Images/Maps/Cards/Correlate16KnownLocation.png" alt="Enrollee Correlattion" class="EnrolleeAssociations" />');
                uEnrolleeKnownLocation.append('<div id="KnownLocationAddress">' + addressFormatter(lOrganizationAddress) + '</div>');

                /***known location name***/
                uEnrolleeKnownLocation.append('<div id="KnownLocationORIName">' + lOrganizationAddress.Title + '</div>');
            }
        }
    }
}

function enrolleeAssociationThread_OnClick() {
    "use strict";
    var lThread = lCorrelateCardViewControl.getDataSource();

    var lTitle = 'Initial Thread : ' + lThread.Address + ' | ' + lThread.EnrolleeName + ' - ' + lThread.VisitStartDate + ' - ' + lThread.VisitEndDate;
    loadThread(lTitle, mEnrolleesData.AssociatedThread);
}

function enrolleeCorrelatePopup_Onclick(aCardId) {
    "use strict";
    var lButtonBar = GenerateButtonCommandBar();
    var lCard = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItemById(aCardId);
    if (!PopupIsOpen()) {
        getEnrolleeAssociationThreads(lCard);
        
        var lTransactionDate = new Date(moment());
        logUserTransactionRecordOnly(lCard.EnrolleeId, 9, gUserDetails.UserId, lTransactionDate, lTransactionDate)
        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleePrintAssociations'), 'Print', "enrolleePrintAssociations('" + aCardId + "')"));

        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', enrolleeCorrelatePopup_Dispose));
        DisplayPopup(localizeWrapper('cEnrolleeAssociations') + ' | ' + lCard.Address, '<div id="uAssociationsPanel"></div><div id="uAssociationsListPanel"><div class="loadingGif EnrolleeCorrelatetionAutoCentered"></div></div>', lButtonBar, true, false, true);
        populateElement('uAssociationsPanel', 'Enrollees.Offenders.CorrelationHeader.Popup.Layout.htm',
            function () {
                generateEnrolleeAssociationPanel(aCardId);
            });
        $('.PopupWindow').addClass('CorrelationWidth');
    }//end of if
}

/*Association List Last 7 Days*/
function associationListLast7_OnClick(aCardId) {
    "use strict";
    var lButtonBar = GenerateButtonCommandBar();
    if (!PopupIsOpen()) {
        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', enrolleeCorrelatePopup_Dispose));
        DisplayPopup(localizeWrapper('cEnrolleeLatestAssociations'), '<div id="uAssociationsLatestPanel"></div><div id="uAssociationsLatestListPanel"><div class="loadingGif EnrolleeCorrelatetionAutoCentered"></div></div>', lButtonBar, true, false, true);

        populateElement('uAssociationsLatestListPanel', 'Enrollees.Correlation.Latest.Popup.Layout.htm', associationListLatest_OnComplete, aCardId);

        $('.PopupWindow').addClass('CorrelationWidth');
    }
}


function associationListLatest_OnComplete(aCardId) {
    "use strict";
    var lEnrolleeId = aCardId,
        lCurrentDate = new Date(),
        lStopDate = new Date(),
        lTransactionDate = new Date(moment()),
        lStartDate = new Date(lCurrentDate.setDate(lCurrentDate.getDate() - 7));

    logUserTransactionRecordOnly(lEnrolleeId, 8, gUserDetails.UserId, lTransactionDate, lTransactionDate)
    // Last 7 Days of Associations
    veritracks.mapping.getEnrolleeWeekAssociation(lEnrolleeId, lStartDate, lStopDate, 1,
        function (aEnrolleeId, aAssociationsData) {
            associationListLatest_OnPopulate(aEnrolleeId, aAssociationsData);
        },
        getEnrolleeWeekAssociation_OnFailure, lEnrolleeId
    );
}

function associationListLatest_OnPopulate(lEnrolleeId, aAssociationsData) {
    "use strict";
    var lAssociationsData = aAssociationsData,
        lFirstAssociation,
        lLatestListHolder = $('#uLatestCorrelationHolder'),
        lLatestList = $('#uLatestCorrelationHolder ul'),
        lListOpen = '<li>',
        lListButtonC = '</button>',
        lListClose = '</li>',
        lAssociationsHTML = [];


    if (lAssociationsData.length > 0) {
        lFirstAssociation = lAssociationsData[0];
    }

    mEnrolleesData.EnrolleeLatestWeekAssociation = [];
    mEnrolleesData.EnrolleeLatestWeekAssociationSelected = null;

    for (var i = 0; i < lAssociationsData.length; i++) {
        var lButtonCreate = document.createElement("div");

        var lAssociationBuild = buildAssociationLatestObject(lAssociationsData[i], i);

        mEnrolleesData.EnrolleeLatestWeekAssociation.push(lAssociationBuild);
        lButtonCreate.innerHTML = '<button class="lWeekAssociationButton" id="lAssociationButton' + i + '" type="button" onclick="associationListLatestMatchPointGroupingId(' + i + ')"><div class="assoc-enrolleeicon" id="EnrolleeKnownLocationImage' + i + '"></div><div class="assoc-box">' + buildListButtonAssociation(lAssociationsData[i], lEnrolleeId, "lAssociationButton" + i) + '<div id="EnrolleeKnownLocation' + i + '"></div></div>' + lListButtonC;

        lLatestList.append(lButtonCreate);

        populateKnownLocationCorrelationInfo_Latest(i, lAssociationsData[i]);


    }

    //associationListLatestMap_OnInit(0);
    associationListLatestMatchPointGroupingId(0);
}

/***known location correlation information***/
function populateKnownLocationCorrelationInfo_Latest(aId, aAssociation) {
    "use strict";
    var lAssociation = aAssociation,
        lEnrolleeId = lAssociation.EnrolleeId;

    if (!isNullOrUndefined(lAssociation)) {
        if (lAssociation.OrganizationAddressId > 0) {
            var uEnrolleeKnownLocation = $('#EnrolleeKnownLocation' + aId),
                lOrganizationAddress = getDataItem(lAssociation.OrganizationAddressId, 'OrganizationAddress'),
                uEnrolleeKnownLocationIcon = $('#EnrolleeKnownLocationImage' + aId);
            if (!isNullOrUndefined(lOrganizationAddress)) {
                uEnrolleeKnownLocationIcon.append('<img id="uOffenderCorrelateProperty" src="Images/Maps/Cards/Correlate16KnownLocation.png" alt="Enrollee Correlattion" class="EnrolleeAssociations" />');
                uEnrolleeKnownLocation.append('<div>' + addressFormatter(lOrganizationAddress) + '</div>');

                /***known location name***/
                uEnrolleeKnownLocation.append('<div id="assoc-ori">' + lOrganizationAddress.Title + '</div>');
            }

        }
    }
}

function associationListLatestMatchPointGroupingId(aListId) {
    "use strict";
    var lAssociationButton = $('#lAssociationButton' + aListId);
    var lAssociationPreviousButton = $('.lWeekAssociationButton');

    if (mEnrolleesData.EnrolleeLatestWeekAssociationSelected != aListId) {
        lAssociationPreviousButton.removeClass('lSelectedAssociationLatestBox');
        lAssociationButton.addClass('lSelectedAssociationLatestBox');

        var lAssociation = mEnrolleesData.EnrolleeLatestWeekAssociation.filter(function (a, b) {
            if (a.Id == aListId) {
                mEnrolleesData.EnrolleeLatestWeekAssociationSelected = aListId;
                return a.Id == aListId;
            }
        })

        var lAssociationData = lAssociation[0];

        var lBuilder = new SumoPredicateBuilder();

        lBuilder.AddNewExpressionConditional('Id', lAssociationData.PointGroupingId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('DeviceId', lAssociationData.DeviceId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('StartDate', moment(lAssociationData.StartDateUTC).add(-1, 'days')._d.toWcf(), false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());

        ReadMultiple(gObjectList.PointGrouping.AssemblyQualifiedName, lBuilder.RootExpression, 0, associationListLatestMap_OnInit, null, lAssociationData);
    }

}


function buildAssociationLatestObject(lAssociation, aId) {
    "use strict";
    var lAssociationObject = {};
    lAssociationObject.PointGroupingId = lAssociation.PointGroupingId;
    lAssociationObject.MatchPointGroupingId = lAssociation.MatchPointGroupingId;
    lAssociationObject.MatchDeviceId = lAssociation.MatchDeviceId;
    lAssociationObject.AddressId = lAssociation.AddressId;
    lAssociationObject.Latitude = lAssociation.Latitude;
    lAssociationObject.Longitude = lAssociation.Longitude;
    lAssociationObject.StartDateUTC = lAssociation.Longitude;
    lAssociationObject.Id = aId;
    lAssociationObject.OrganizationAddressId = lAssociation.OrganizationAddressId;
    lAssociationObject.EnrolleeId = lAssociation.Id;
    lAssociationObject.DeviceId = lAssociation.DeviceId;

    return lAssociationObject;
}

function buildCheckInOrgAssoc(aAssociationsData, aEnrolleeId) {
    return GetEnrollee(aAssociationsData.MatchEnrolleeId);

}

function buildListButtonAssociation(aAssociationsData, aEnrolleeId, lUIId) {
    var lMatchEnrollee = GetEnrollee(aAssociationsData.MatchEnrolleeId),
        lTimeZone = getEnrolleeTimeZone(aEnrolleeId),
        lMatchEnrolleName = lMatchEnrollee ? lMatchEnrollee.FullName : '- unauthorized -',
        lStartDate = displayEnrolleeTimeZoneFormatted(aAssociationsData.StartDateUTC, lTimeZone),
        lStopDate = displayEnrolleeTimeZoneFormatted(aAssociationsData.EndDateUTC, lTimeZone);

    return "<span>" + lMatchEnrolleName + "</span><p>Start Date: " + lStartDate + "</p><p>Stop Date: " + lStopDate + "</p>";
}

function associationListLatestMap_OnInit(aAssociationData, aAssociationResultData) {
    "use strict";
    var lDisplayType = 'roadmap';
    var lAssociationData = aAssociationData;
    var lAssociationResultData = aAssociationResultData[0];
    var lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees');
    var lIsInformatics = false;   
    var lVisitMap = null;
   
    if (!isNullOrUndefined(lEnrollee)) {
        lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
    }
    mEnrolleesControls.EnrolleesLatestAssociationsMap = new sumo.maps.GoogleMapControl('EnrolleeLatestMapCor', 'EnrolleeMapLatestCorrelateHolder',
    {
        'displayType': lDisplayType,
        'mapTypeId_OnChange': mapDisplayType_OnChange,
        'OnClick': veritracks.enrollees.mapping.onClick
    });

    var lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'zIndexStart': 90000,
        'hoverEventHandler': veritracks.mapping.enrolleeMarkerHover,
        'hoverOutEventHandler': veritracks.mapping.enrolleeMarkerHoverOut
    };

    mEnrolleesControls.EnrolleesLatestAssociationsMap.layerAdd('Visit', lLayerOptions);
   
    lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'zIndexStart': 90000,
        'hoverEventHandler': veritracks.mapping.enrolleeMarkerHover,
        'hoverOutEventHandler': veritracks.mapping.enrolleeMarkerHoverOut
    };
     
    

    mEnrolleesControls.EnrolleesLatestAssociationsMap.layerAdd('CorrelateVisit', lLayerOptions);
    
    if (lIsInformatics == false) {
        lVisitMap = [
        { 'latitude': lAssociationResultData.Latitude, 'longitude': lAssociationResultData.Longitude, 'iconUri': 'Images/Maps/Trackpoints/10400000Association.png', 'cardViewClass': '10400000', 'anchor': { 'x': 8, 'y': 8 } }];
        mEnrolleesControls.EnrolleesLatestAssociationsMap.layerSetDataSource('Visit', lVisitMap);
    } else {
        var lIconNameId = IconHelper.getIconIdByName("Visit Association");
        lAssociationResultData.IconId = lIconNameId;
        lAssociationData.IconId = lIconNameId;
        lAssociationData.Data = lAssociationResultData;
        lVisitMap = [veritracks.mapping.prepareVisitItem(lAssociationData, 1, lAssociationResultData)];
        lVisitMap[0].latitude = lAssociationResultData.Latitude;
        lVisitMap[0].longitude = lAssociationResultData.Longitude;
        lVisitMap[0].anchor.x = 8;
        lVisitMap[0].anchor.y = 8;
        lVisitMap[0].iconUri = veritracks.mapping.iconGenerator.generateMapMarker(lVisitMap[0].SVGMarker);
        mEnrolleesControls.EnrolleesLatestAssociationsMap.layerSetDataSource('Visit', lVisitMap);
     }

    mEnrolleesControls.EnrolleesLatestAssociationsMap.setCenter(lAssociationData.Latitude, lAssociationData.Longitude);


    mEnrolleesControls.EnrolleesLatestAssociationsMap.fitBounds();
    mEnrolleesControls.EnrolleesLatestAssociationsMap.zoom(17);

    var lCorrelation = { MatchPointGroupingId: lAssociationData.MatchPointGroupingId, MatchDeviceId: lAssociationData.MatchDeviceId, AddressId: lAssociationData.AddressId, StartDateUTC: lAssociationData.StartDateUTC, IconId: IconHelper.getIconIdByName("Second Enrollee Association") };

    populateEnrolleeLatestCorrelate(lCorrelation);

}

function populateEnrolleeLatestCorrelate(lCorrelation) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    mEnrolleesControls.EnrolleesLatestAssociationsMap.layerSetDataSource('CorrelateVisit', []);
    /*Read data to populate trackpoint*/
    lBuilder.AddNewExpressionConditional('Id', lCorrelation.MatchPointGroupingId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('DeviceId', lCorrelation.MatchDeviceId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('StartDate', moment(lCorrelation.StartDateUTC).add(-1, 'days')._d.toWcf(), false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());

    ReadMultiple(gObjectList.PointGrouping.AssemblyQualifiedName, lBuilder.RootExpression, 0, populateCorrelateMapLatestTrackPoint, null, lCorrelation);
}

function populateCorrelateMapLatestTrackPoint(aAssociation, aData) {
    "use strict";
    var lTrackItem = veritracks.mapping.prepareVisitItem(aData[0], 2, aAssociation),
        lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
        lIsInformatics = false;
    if (!isNullOrUndefined(lEnrollee)) {
        lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
    }
       
    if (lIsInformatics == false) {
        if (aAssociation && aAssociation.OrganizationAddressId > 0) {
            lTrackItem.iconUri = 'Images/Maps/Trackpoints/20400000AssociationKnownLocation.png';
        } else {
            lTrackItem.iconUri = 'Images/Maps/Trackpoints/20400000Association.png';
        }
    } else {
        lTrackItem.iconUri = veritracks.mapping.iconGenerator.generateMapMarker(lTrackItem.SVGMarker);
    }
   

    mEnrolleesControls.EnrolleesLatestAssociationsMap.layerSetDataSource('CorrelateVisit', [lTrackItem]);

    mEnrolleesControls.EnrolleesLatestAssociationsMap.fitBounds();
    mEnrolleesControls.EnrolleesLatestAssociationsMap.zoom(17);
}


function getEnrolleeWeekAssociation_OnFailure(a, b, c, d) {
    "use strict";
    console.log(a, b, c, d);
}

function enrolleePrintAssociations(aCardId) {
    "use strict";
    var lEnrolleeAssociationCard = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItemById(aCardId);

    loadEnrollePhotos(lEnrolleeAssociationCard.EnrolleeId, LoadAssociationsForPrintPhotosMainOffender);

    mEnrolleesData.AssociationPrintEnrollee = lEnrolleeAssociationCard;

    var lBuilder = new SumoPredicateBuilder(),
        lSelectedEnrollee = new Enrollee(),
        lAgent = new Agent(),
        lOrganization = null,
        lTimeZone = null,
        lVisit = null,
        lDataSource = lCorrelateCardViewControl.getDataSource(),
        lCorrelationList = [],
        aCurrentTab,
        lEnrolleeList = [],
        lListResults = [];


    var lCorrelateControl = lCorrelateCardViewControl.getDataSource(),
        lEnrolleeCorrelations = lCorrelateControl.enrolleeCorrelations;

    for (var i = 0; i < lEnrolleeCorrelations.length; i++) {
        var lEnrolleeId = lEnrolleeCorrelations[i].MatchEnrolleeId;
        if (lEnrolleeList.indexOf(lEnrolleeId) == -1) {
            lEnrolleeList.push(lEnrolleeId);
        }
    }
    for (var k = 0; k < lEnrolleeList.length; k++) {
        lSelectedEnrollee = GetEnrollee(lEnrolleeList[k]);
        if (!isNullOrUndefined(lSelectedEnrollee)){
            lOrganization = getDataItem(lSelectedEnrollee.OrganizationId, 'Organizations');
            lAgent = getDataItem(lSelectedEnrollee.AgentId, 'Agents');
            lTimeZone = getDataItem(lSelectedEnrollee.TimeZoneId, 'TimeZone');
            var lResults = { 'Enrollee': lSelectedEnrollee, 'Organization': lOrganization, 'Agent': lAgent, 'TimeZone': lTimeZone, 'Visit': lEnrolleeAssociationCard, 'Correlation': lEnrolleeCorrelations, 'Photo': '', 'Profile': '', 'TrackItem': '' };
            lListResults.push(lResults);
        }        
    }    

    enrolleePrintCorrelate_OnSuccess(lEnrolleeList, lListResults, lEnrolleeCorrelations);

    function enrolleePrintCorrelate_OnSuccess(aEnrolleeList, aParams, aEnrolleeCorrelations) {
        "use strict";
        var lResults = aParams,
            lBuilder = new SumoPredicateBuilder(),
            lEnrolleeIds = aEnrolleeList;

        lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrolleeIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsActive', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

        ReadMultiple(gObjectList.OffenderPhotos.AssemblyQualifiedName, lBuilder.RootExpression, 0, enrolleePrintCorrelatePhoto_OnSuccess, null, lResults, null, 0);
    }

    function enrolleePrintCorrelatePhoto_OnSuccess(aParams, aData) {
        "use strict";
        var lPhoto = null,
            lBuilder = new SumoPredicateBuilder(),
            lProfileType = new DataItem("OffenderProfile"),
            lResults = aParams;

        /*match photo to enrolleeid*/
        lResults.map(function (obj) {
            var lEnrolleeId, lEnrollee;
            for (var prop in obj) {
                if(prop == 'Enrollee') {
                    lEnrollee = obj[prop];
                    lEnrolleeId = lEnrollee.Id;
                }
                if (prop == 'Photo') {
                    obj[prop] = getTheCorrectPhotoForThisProperty(lEnrolleeId);
                }
            }
        });

        function getTheCorrectPhotoForThisProperty(aEnrolleeId) {
            var lNewPhoto = {};
            aData.map(function (obj) {
                var lEnrolleeId;
                for (var prop in obj) {
                    if (prop == 'EnrolleeId') {
                        lEnrolleeId = obj[prop];
                        if (lEnrolleeId == aEnrolleeId) {
                            lNewPhoto = $.extend({}, obj);
                        }
                    }
                }
            });

            return lNewPhoto;
        }

        lBuilder.AddNewExpressionConditional("Id", lEnrolleeList, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        ReadMultiple(lProfileType.AssemblyQualifiedName, lBuilder.RootExpression, 0, correlatePrintOffenderProfile_OnSuccess, enrolleePrintCorrelate_OnFailure, lResults, null, 0, null);
    }

    function correlatePrintOffenderProfile_OnSuccess(aParams, aData) {
        "use strict";
        var lProfiles = [],
            lResults = aParams;

        FixDates(aData);
        lResults.map(function (obj) {
            var lEnrolleeId, lEnrollee;
            for (var prop in obj) {
                if (prop == 'Enrollee') {
                    lEnrollee = obj[prop];
                    lEnrolleeId = lEnrollee.Id;
                }
                if (prop == 'Profile') {
                    obj[prop] = getTheCorrectProfileForThisProperty(lEnrolleeId);
                }
            }
        });

        function getTheCorrectProfileForThisProperty(aEnrolleeId) {
            "use strict"
            var lNewProfile = {};
            aData.map(function (obj) {
                var lEnrolleeId;
                for (var prop in obj) {
                    if (prop == 'Id') {
                        lEnrolleeId = obj[prop];
                        if (lEnrolleeId == aEnrolleeId) {
                            lNewProfile = $.extend({}, obj);
                        }
                    }
                }
            });

            return lNewProfile;
        }

        lResults.map(function (obj) {
            for (var prop in obj) {
                if (prop == 'Profile') {
                    console.log(obj[prop]);
                    var lNewObj = obj[prop]
                    for (var newProp in lNewObj) {
                        if (newProp == 'SupervisionBeginDate') {
                            lNewObj[newProp] = displayEnrolleeTimeZoneFormatted(lNewObj[newProp]);
                        }
                        if (newProp == 'SupervisionEndDate') {
                            lNewObj[newProp] = displayEnrolleeTimeZoneFormatted(lNewObj[newProp]);
                        }
                    }
                }
            }
        });

        populateMapEnrolleePrintCorrelateData(lResults);
    }

    function populateMapEnrolleePrintCorrelateData(aResultVisits) {
        "use strict";
        var lCounter = 0;
        var lFinalPrintValues = [];

        callProcedureToGetTrackPointMapData(aResultVisits[lCounter]);

        function callProcedureToGetTrackPointMapData(aResultVisit) {
            "use strict";
            var lBuilder = new SumoPredicateBuilder();
            var lCorrelation;
            var lKey;


                var lCorrelations = aResultVisit.Correlation;
                var lEnrollee = aResultVisit.Enrollee;

                for (lKey in lCorrelations) {
                    if (lCorrelations.hasOwnProperty(lKey)) {
                        if (lCorrelations[lKey].MatchEnrolleeId == lEnrollee.Id) {
                            if (!lCorrelation) {
                                lCorrelation = lCorrelations[lKey];
                            }
                            if (lCorrelation && lCorrelations[lKey].StartDate < lCorrelation.StartDate) {
                                lCorrelation = lCorrelations[lKey];
                            }
                        }
                    }
                }

                //mEnrolleesControls.EnrolleesCorrelateMap.layerSetDataSource('CorrelateVisit', []);

                lBuilder.AddNewExpressionConditional('Id', lCorrelation.MatchPointGroupingId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional('DeviceId', lCorrelation.MatchDeviceId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional('StartDate', moment(lCorrelation.StartDateUTC).add(-1, 'days')._d.toWcf(), false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());

                ReadMultiple(gObjectList.PointGrouping.AssemblyQualifiedName, lBuilder.RootExpression, 0, populateCorrelateMapPrintTrackPoint_OnSuccess, null, aResultVisit);

        }

        function populateCorrelateMapPrintTrackPoint_OnSuccess(aResultVisit, aData) {
            "use strict";

            var lAssociation = aResultVisit.Visit.Association,
                lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
                lIsInformatics = false,
                lTrackItem = veritracks.mapping.prepareVisitItem(aData[0], 2, lAssociation);

            if (!isNullOrUndefined(lEnrollee)) {
                lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
            }
            if (lIsInformatics == false) {
                if (lAssociation && lAssociation.OrganizationAddressId > 0) {
                    lTrackItem.iconUri = 'Images/Maps/Trackpoints/20400000AssociationKnownLocation.png';
                } else {
                    lTrackItem.iconUri = 'Images/Maps/Trackpoints/20400000Association.png';
                }
            } else {
                lTrackItem.iconUri = veritracks.mapping.iconGenerator.generateMapMarker(lTrackItem.SVGMarker);
            }           

            lTrackItem.data.StartDateUTC = displayEnrolleeTimeZoneFormatted(lTrackItem.data.StartDateUTC);
            lTrackItem.data.EndDateUTC = displayEnrolleeTimeZoneFormatted(lTrackItem.data.EndDateUTC);

            aResultVisit.TrackItem = lTrackItem;
            lCounter++;
            lFinalPrintValues.push(aResultVisit);

            if (aResultVisits.length > lCounter) {
                callProcedureToGetTrackPointMapData(aResultVisits[lCounter]);
            } else {               
                mEnrolleesData.AssociationsPrint = lFinalPrintValues;
                window.open('Enrollee.Associations.Print.htm');
            }

        }

    }

    function enrolleePrintCorrelate_OnFailure() {
        "use strict";
    }

}

function LoadAssociationsForPrintPhotosMainOffender(aEnrolleeId, aData) {
    "use strict";
    var lSort = new SortExpression();
    lSort.addAscendingColumn('PhotoOrderNo');
    if (aData) {
        aData = lSort.sort(aData);
        var lEnrolleeProfileImageUri = aData[0];

        mEnrolleesData.AssociationPrintEnrollee.ProfilePhoto = lEnrolleeProfileImageUri.PhotoUri;

    } else {
        mEnrolleesData.AssociationPrintEnrollee.ProfilePhoto = "Images/NoPhoto.png";
    }
}

function enrolleePrintAssociationsMap_onInit(aResult, aEnrollee, aKey) {
    "use strict";    
    var lCard = aResult;
    var lTrackItem = [lCard.TrackItem];
    var lVisit = [lCard.Visit.TrackItem]
    var lDisplayType = 'roadmap';
    var lEnrolleeId = aEnrollee.Id;
    var lId = lEnrolleeId + '' + aKey;
    var lIsInformatics = false;
    var lPrintMap;

    if (!isNullOrUndefined(aEnrollee)) {
        lIsInformatics = getInformaticsEnabled(aEnrollee.OrganizationId);
    }
    mPrintControls.ArrayPrintAssociationMap[lEnrolleeId] = new sumo.maps.GoogleMapControl('uPrintMap' + lId, 'uMapPanel' + lId,
    {
        'displayType': lDisplayType,
        'OnClick': null
    });

    lPrintMap = mPrintControls.ArrayPrintAssociationMap[aEnrollee.Id];

    var lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': true,
        'isVisible': true,
        'zIndexStart': 90000
    };

    lPrintMap.layerAdd('Visit', lLayerOptions);

    lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'zIndexStart': 90000
    };    
   

    lPrintMap.layerAdd('CorrelateVisit', lLayerOptions);

    lPrintMap.layerSetDataSource('Visit', lVisit);

    lPrintMap.layerSetDataSource('CorrelateVisit', lTrackItem);

    lPrintMap.setCenter(lTrackItem[0].latitude, lTrackItem[0].longitude);
    lPrintMap.zoom(20);
    lPrintMap.fitBounds();
}

function enrolleePrintAssocations_OnFailure() {
    "use strict";
}

function getEnrolleeAssociationThreads(aCard) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();

    if (CheckUserHasPermission(61)){
        lBuilder.AddNewExpressionConditional("PointGroupingId", aCard.TrackItem.data.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.EnrolleeAssociationThread.AssemblyQualifiedName, lBuilder.RootExpression, 0, EnrolleeAssociationThread_OnSuccess, Sad, null);
    }

    function EnrolleeAssociationThread_OnSuccess(aParams, aData) {
        if (aData.length > 0) {
            var lThread = aData[0];
            mEnrolleesData.AssociatedThread = lThread.ThreadId;
            $('.ShowThreadButton').removeClass('HideButton');
        } else {
            $('.SaveButton').removeClass('HideButton');
        }
    }
}

function generateEnrolleeAssociationPanel(aCardId) {
    "use strict";
    var lCard = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItemById(aCardId);
    var lTrackItem = [lCard.TrackItem];
    var lDisplayType = 'roadmap';
    var lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees');
    var lIsInformatics = false;

    if (!isNullOrUndefined(lEnrollee)) {
        lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);

    }
     
    mEnrolleesControls.EnrolleesCorrelateMap = new sumo.maps.GoogleMapControl('EnrolleeMapCor', 'EnrolleeMapCorrelateHolder',
    {
        'displayType': lDisplayType,
        'mapTypeId_OnChange': mapDisplayType_OnChange,
        'OnClick': veritracks.enrollees.mapping.onClick
    });

    var lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'zIndexStart': 90000,
        'hoverEventHandler': veritracks.mapping.enrolleeMarkerHover,
        'hoverOutEventHandler': veritracks.mapping.enrolleeMarkerHoverOut
    };

    mEnrolleesControls.EnrolleesCorrelateMap.layerAdd('Visit', lLayerOptions);
   
    lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'zIndexStart': 90000,
        'hoverEventHandler': veritracks.mapping.enrolleeMarkerHover,
        'hoverOutEventHandler': veritracks.mapping.enrolleeMarkerHoverOut
    };     
    

    mEnrolleesControls.EnrolleesCorrelateMap.layerAdd('CorrelateVisit', lLayerOptions);

    mEnrolleesControls.EnrolleesCorrelateMap.layerSetDataSource('Visit', lTrackItem);
    mEnrolleesControls.EnrolleesCorrelateMap.setCenter(lTrackItem[0].latitude, lTrackItem[0].longitude);
    mEnrolleesControls.EnrolleesCorrelateMap.zoom(20);

    populateEnrolleeCorrelateProfile(lCard);
    generateEnrolleeCorrelatePanel(lCard);
}

function onEnrolleeCorrelationClick(aEnrolleeId) {
    "use strict";
    var lPageTitle = 'Offenders',
        lDataSource = lCorrelateCardViewControl.getDataSource(),
        lDateFilterValue = $("#uEnrolleeMapTimeFilter").val(),
        lMatchEnrollee = null,
        lEndDate = new Date(),
        lTimeFrame,
        lTimeDiff = 9999,
        lTimeMin = 9999,
        lTimeSpanValue = 0,
        lDate = new Date();

    lDate = new Date(lDataSource.VisitStartDate);
    lEndDate = new Date(lDataSource.VisitEndDate);
    lMatchEnrollee = getDataItem(aEnrolleeId, 'Enrollees');
    lTimeFrame = lEndDate - lDate;
    lTimeFrame = lTimeFrame / (1000 * 60);


    $('#uEnrolleeMapTimeFilter option').each(function () {
        lTimeDiff = Math.abs(lTimeFrame - parseInt($(this).val()));
        if (lTimeDiff < lTimeMin) {
            lTimeMin = lTimeDiff;
            lTimeSpanValue = $(this).val();
        }
    });

    lDate.addMinutes(parseInt(lTimeSpanValue));
    enrolleeCorrelatePopup_Dispose();

    setViewState('CurrentCorrelationStartDate', lDate);
    setViewState('CurrentCorrelationTime', lDate.getHours() + ":" + lDate.getMinutes() + ":" + lDate.getSeconds());
    setViewState('CorrelationTimeFilter', lTimeSpanValue);

    if (isNullOrUndefined(lMatchEnrollee)) {
        EnrolleesAdvancedDataPermissions('Enrollees.Offenders.Profile.Events', aEnrolleeId);
    } else {
        window.location.hash = "Enrollees." + lPageTitle + ".Profile.Events." + aEnrolleeId;
    }
    console.log('lPageTitle',lPageTitle,aEnrolleeId)



}

function navigateToNewCorrelation(aEnrolleeId) {
    "use strict";

    var lBuilder = new SumoPredicateBuilder(),
       lSelectedEnrollee = new Enrollee(),
       lAgent = new Agent(),
       lOrganization = null,
       lTimeZone = null,
       lVisit = null,
       lDataSource = lCorrelateCardViewControl.getDataSource(),
       lCorrelationList = [],
       aCurrentTab;

    if (lCorrelateCardViewControl.isCurrentTab(aEnrolleeId)) {
        return;
    }
    lCorrelateCardViewControl.setModal(true);
    lSelectedEnrollee = GetEnrollee(aEnrolleeId);

    lOrganization = getDataItem(lSelectedEnrollee.OrganizationId, 'Organizations');
    lAgent = getDataItem(lSelectedEnrollee.AgentId, 'Agents');
    lTimeZone = getDataItem(lSelectedEnrollee.TimeZoneId, 'TimeZone');

    if (!isNullOrUndefined(lDataSource)) {
        lCorrelationList = lDataSource.enrolleeCorrelations;

        var ldata = new Object();
        ldata.StartDateUTC = lDataSource.VisitStartDate;
        ldata.EndDateUTC = lDataSource.VisitEndDate;

        var TrackItem = new Object();
        TrackItem.data = ldata;

        lVisit = new Object();
        lVisit.Address = lDataSource.Address;
        lVisit.Id = lDataSource.VisitId;
        lVisit.TrackItem = TrackItem;

        var lResults = {'isNavigating':true, 'Enrollee': lSelectedEnrollee, 'Organization': lOrganization, 'Agent': lAgent, 'TimeZone':lTimeZone, 'Visit': lVisit, 'Correlation': lCorrelationList, 'Photo':''};
        enrolleeCorrelate_OnSuccess(lResults, lCorrelationList);
    }//end of if

}

/** BEGIN ABSENCE SCHEDULE FEATURE **/
/*** PREPARATION FOR CARVE MODE ON VERITRACKS CALENDAR ****/
function checkCarveOutModeEnabled(aEnrolleeId, aRecurring) {
    "use strict";
    var lAbsencesEnabled = veritracks.system.clientSetting('veritracksabsenceschedules');
    var lBuilder = new SumoPredicateBuilder();
    var lAbsenceExists = false;
    var lAllowedTypes = [2, 3]; // bluhome blubox
    var lSchedules;
    var lSchedule;
    var lRecurring = true;

    if(aRecurring){
      lRecurring = aRecurring;
    }


    if (lAbsencesEnabled) {
            lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('ScheduleType', lAllowedTypes, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('IsSunday', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('IsMonday', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('IsTuesday', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('IsWednesday', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('IsThursday', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('IsFriday', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('IsSaturday', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('IsAbsenceSched', getCarveOutPreference(), false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

            lSchedules = query(mEnrolleesData.OffenderSchedules, lBuilder.RootExpression);

            for (var lKey in lSchedules) {
                if (lSchedules.hasOwnProperty(lKey)) {
                    if (moment(lSchedules[lKey].StartTime).diff(moment(lSchedules[lKey].EndTime), 'minutes') == 1 || moment(lSchedules[lKey].StartTime).diff(moment(lSchedules[lKey].EndTime), 'minutes') == -1439) {
                        lSchedule = lSchedules[lKey];
                    }
                }
            }

            if (!lSchedule) {
                lBuilder.Clear();
                lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional('ScheduleType', 7, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
              //  lBuilder.AddNewExpressionConditional('IsAbsenceSched', getCarveOutPreference(), false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

                lSchedules = query(mEnrolleesData.OffenderSchedules, lBuilder.RootExpression);

                if (lSchedules.length > 0) {
                    lBuilder.Clear();
                    lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                    lBuilder.AddNewExpressionConditional('ScheduleType', lAllowedTypes, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
                    lBuilder.AddNewExpressionConditional('IsRecurring', lRecurring, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                  //  lBuilder.AddNewExpressionConditional('IsAbsenceSched', getCarveOutPreference(), false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

                    lSchedules = query(mEnrolleesData.OffenderSchedules, lBuilder.RootExpression);

                    for (var lKey in lSchedules) {
                        if (lSchedules.hasOwnProperty(lKey)) {
                          lSchedule = lSchedules[lKey];
                        }
                    }
                }
            }
    }

    return lSchedule;
}

function absencesExist(aEnrolleeId) {
    var lExists = false;
    var lAbsencesEnabled = veritracks.system.clientSetting('veritracksabsenceschedules');
    var lResults = [];
    if (lAbsencesEnabled) {
        lResults = getAbsentSchedules(aEnrolleeId);
        if (lResults.length > 0)
            lExists = true;
    }

    return lExists;
}
function getAbsentSchedules(aEnrolleeId) {
        var lBuilder = new SumoPredicateBuilder(),
            lEnrolleeScheduleDisplays = [],
            lOldSchedules,
            lEnrolleeSchedules = [],
            lTimeZone = getEnrolleeTimeZone(aEnrolleeId),
            lKey;

    lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('ScheduleType', 7, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
  //  lBuilder.AddNewExpressionConditional('IsAbsenceSched', getCarveOutPreference(), false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lOldSchedules = query(mEnrolleesData.OffenderSchedules, lBuilder.RootExpression);
    for (lKey in lOldSchedules) {
        if (lOldSchedules.hasOwnProperty(lKey)) {
            var lSchedule = new OffenderScheduleDisplay(lOldSchedules[lKey], true);
            lSchedule.StartTime = convertMomentFromStringTimezone(lSchedule.StartDateUTC + " " +moment(lSchedule.StartTimeUTC).format("hh:mm A"), lTimeZone.TimeZoneName);
          //  lSchedule.StartTime = convertMomentFromStringTimezone(lSchedule.StartTimeUTC, lTimeZone.TimeZoneName);
        //    lSchedule.EndTime = convertMomentFromStringTimezone(lSchedule.EndTimeUTC, lTimeZone.TimeZoneName);
            lSchedule.EndTime = convertMomentFromStringTimezone(lSchedule.EndDateUTC + " " +moment(lSchedule.EndTimeUTC).format("hh:mm A"), lTimeZone.TimeZoneName);

            lSchedule.ScheduleType = 7;
            lEnrolleeScheduleDisplays.push(lSchedule);
        }
    }

    lEnrolleeSchedules = enrolleesScheduleDataListConverter(lEnrolleeScheduleDisplays);
    return lEnrolleeSchedules;
}

/*** END PREPARATION FOR CARVE MODE ON VERITRACKS CALENDAR ****/

/** CARVE MODE POPUPS **/
function enrolleesVeritracksCalendarSaveCarved() {
    var lSchedules = mEnrolleesControls.veritracksCalendar.getRawDataSource(),
        lButtonBar = GenerateButtonCommandBar(),
        lMasterSchedule = mEnrolleesControls.veritracksCalendar.getExtraData("masterSchedule"),
        lHtml = [];

    if (lSchedules.length > 0) {
        lHtml.push('<div id="uVeritracksCarveSaver" style="width:650px; display:block;">');
        lHtml.push("<div style='padding:3px;'");
        lHtml.push("<label for='24hourScheduleName'>" + localizeWrapper('cEnrolleeMasterScheduleName') + "</label>")
        lHtml.push("<input id='24hourScheduleName' style='width: 440px;' class='Validate ValidateRequired' type='text'");
        if (lMasterSchedule.Name != "") {
            lHtml.push("value='" + lMasterSchedule.Name + "' ");
        }
        lHtml.push("placeholder="+localizeText('cEnrolleeAbsence24ScheduleName')+"/>");
        lHtml.push("</div>");
        lHtml.push("<hr/>");
        lHtml.push("<form id='uCarveForm'>");

        lSchedules = cleanCarveSaveBuilder(lSchedules);
        for (var lKey in lSchedules) {
            if (lSchedules.hasOwnProperty(lKey)) {
                lHtml.push(buildCarveScheduleRow(lSchedules[lKey]));
            }
        }
        lHtml.push("</form>");
        lHtml.push("</div>");
        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'enrolleesVeritracksCalendarCarveSave()'));
        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'ClosePopup()'));
        DisplayPopup(localizeWrapper('cEnrolleeSaveAbsenceSchedulesFor') + lMasterSchedule.Name, lHtml.join(''), lButtonBar, false, true);
        mEnrolleesControls.CarvingValidator = new Validator('uPopupContainer2', mRegexValidation);
    } else {
        mActivityNotification.addNotification(localizeWrapper('cEnrolleeAbsenceCreateQuestion'));
    }


    function buildCarveScheduleRow(aAbsence) {
        var lDuration = '';
        var ScheduleString = "<div style='padding:3px;'>";

        ScheduleString += "<label for='" + aAbsence.id + "'>";
        if (aAbsence.isRecurring) {
            ScheduleString +=' ' + localizeWrapper('cEnrolleeRecurring') + ' ';
            lDuration = aAbsence.daysOfWeek;
        }
        else {
            ScheduleString += ' ' + localizeWrapper('cEnrolleeOverride') + ' ';
            lDuration = aAbsence.overrideDay;
        }
        ScheduleString += localizeWrapper('cEnrolleeAbsenceReasonFor') + ' ' + lDuration + ' ' + localizeWrapper('cFrom') + ' ' + aAbsence.startTime + ' ' + localizeWrapper('cTo') + ' ' + aAbsence.endTime + " </label>";
        ScheduleString += "<input name='" + aAbsence.id + "' type='text' style='float: right;'";
        if (aAbsence.title)
            ScheduleString += "value='" + aAbsence.title + "'";
        ScheduleString += "placeholder=" + localizeText('cEnrolleeAbsenceReason') + "/>";
        ScheduleString += "</div>";

        return ScheduleString;
    }


    function cleanCarveSaveBuilder(aSchedules) {
        "use strict";
        var lSchedules = [],
            lSecondState = [],
            lItem;

        for (var lKey in aSchedules) {
            if (aSchedules.hasOwnProperty(lKey)) {
                if (!aSchedules[lKey].state) {
                    lSchedules.push(new OffenderAbsenceScheduleDisplay(aSchedules[lKey]));
                }
            }
        }

        for (var lKey in lSecondState) {
            if (lSecondState.hasOwnProperty(lKey)) {

            }
        }
        return lSchedules;
    }
}

function enrolleesVeritracksCalendarCarveSave() {
    "use strict";
    var lScheduleNames,
        lSchedules,
        lMasterScheduleName = $('#24hourScheduleName').val(),
        saveMaster = false,
        lMasterSchedule = mEnrolleesControls.veritracksCalendar.getExtraData('masterSchedule'),
        lSchedulesList = [];

    if (mEnrolleesControls.CarvingValidator.IsValid()) {
        lScheduleNames = $('form').serializeArray();
        lSchedules = mEnrolleesControls.veritracksCalendar.getRawDataSource();
        for (var i = 0; i < lSchedules.length; i++) {
            if (!lSchedules[i].state) {
                var lSchedule = new OffenderSchedule();
                var lTitle = getObjectProperty(lScheduleNames, "name", lSchedules[i]._id, "value");
                if (lTitle)
                    lSchedule.Name = lTitle;
                else
                    lSchedule.Name = AbsentScheduleNameFormatter(lMasterScheduleName, lSchedules[i].start, lSchedules[i].end);

                lSchedule.IsRecurring = lSchedules[i].isRecurring;
                lSchedule.StartDate = DisplaySuperShortMomentDate(lSchedules[i].start);
                singleFullCalendarObject(lSchedule, lSchedules[i].start, lSchedules[i].end, false);
                lSchedulesList.push(lSchedule);
            }
        }
        if (lMasterScheduleName !== lMasterSchedule.Name) {
            lMasterSchedule.Name = lMasterScheduleName;
            saveMaster = true;
        }
        if (lSchedulesList.length > 0)
            saveCarved(lSchedulesList, lMasterSchedule, saveMaster);
    } else {
        mActivityNotification.addNotification(localizeWrapper('cEnrolleeMasterScheduleNameRequired'));
    }
}

function handleClickScheduleAbsence(aEvent) {
    "use strict";
    var lHtml = [];
    var lButtonCommandBar = GenerateButtonCommandBar();
    var lEdit = aEvent;
    mEnrolleesControls.veritracksCalendar.setEditingSchedule(lEdit);
    //BE Changed to Divs from Tables because IE issue
    lHtml.push('<div class="Button LargeIconButton FullEditScheduleIcon" onclick="ClickChangedSchedule(6);">'+localizeWrapper('cEnrolleeEdit')+'</div>');
    lHtml.push('<div class="Button LargeIconButton DeleteSingleDayIcon" onclick="ClickChangedSchedule(4);">' + localizeWrapper('cEnrolleeDeleteDay') + '</div>');
    if (lEdit.isRecurring)
        lHtml.push('<div class="Button LargeIconButton DeleteAllSchedulesIcon" onclick="ClickChangedSchedule(5);">' + localizeWrapper('cEnrolleeDeleteAll') + '</div>');
    DisplayModal(localizeWrapper('cEnrolleeEditMode'), lHtml.join(''), 'CloseCalendarModal()', true);
}

function editAbsenceSchedule(aSchedule, aIsCalendar){
      "use strict";
      var lId = aSchedule.scheduleId,
      lTimeZone;

      mEnrolleesData.SchedulesEditItem = new OffenderScheduleDisplay(GetOffenderSchedule(lId), true);
      lTimeZone = getEnrolleeTimeZone(mEnrolleesData.SchedulesEditItem.EnrolleeId);
      mEnrolleesData.SchedulesEditItem.StartTime = displayFixedTimeZoneTime(mEnrolleesData.SchedulesEditItem.StartTime, lTimeZone.TimeZoneName);
      mEnrolleesData.SchedulesEditItem.EndTime = displayFixedTimeZoneTime(mEnrolleesData.SchedulesEditItem.EndTime, lTimeZone.TimeZoneName);
      if (!mEnrolleesData.SchedulesEditItem.IsRecurring) {
          FixStartTime();
      }
      EnrolleeProfileAbsenceSchedule_Init(localizeWrapper('cEnrolleeEditAbsence'), enrolleesAbsenceSchedulePopulate, aIsCalendar);
}

function enrolleesAbsenceSchedulePopulate() {
    "use strict";
    var lSchedule = mEnrolleesData.SchedulesEditItem,
        lMasterSchedule = new ScheduleItem(checkCarveOutModeEnabled(mEnrolleesData.OffenderCurrentId)),
        lItem;

        switch (lMasterSchedule.TargetTypeId) {
            case 2:
                lItem = getDataItem(lMasterSchedule.EntityId, 'Devices');
                if (!isNullOrUndefined(lItem)) {
                  lMasterSchedule.TargetName = lItem.SerialNumber;
                }
                break;
            case 3:
                lItem = getDataItem(lMasterSchedule.EntityId, 'DeviceClusters');
                if (!isNullOrUndefined(lItem)) {
                  lMasterSchedule.TargetName = lItem.Name;
                }
        }


    if (!isNullOrUndefined(lSchedule)) {
        $('#uScheduleName').val(lSchedule.Name);
        $('#uScheduleType').val(lSchedule.IsRecurring.toString());
        $('#uScheduleStartTime').val($.format.date(lSchedule.StartTime, "h:mm a"));
        $('#uScheduleStartDate').val($.format.date(lSchedule.StartTime, "MM/dd/yyyy"));
        $('#uScheduleEndTime').val($.format.date(lSchedule.EndTime, "h:mm a"));
        $('#uScheduleEndDate').val($.format.date(lSchedule.EndTime, "MM/dd/yyyy"));

        document.getElementById('uScheduleRecurrenceSunday').checked = lSchedule.IsSunday;
        document.getElementById('uScheduleRecurrenceMonday').checked = lSchedule.IsMonday;
        document.getElementById('uScheduleRecurrenceTuesday').checked = lSchedule.IsTuesday;
        document.getElementById('uScheduleRecurrenceWednesday').checked = lSchedule.IsWednesday;
        document.getElementById('uScheduleRecurrenceThursday').checked = lSchedule.IsThursday;
        document.getElementById('uScheduleRecurrenceFriday').checked = lSchedule.IsFriday;
        document.getElementById('uScheduleRecurrenceSaturday').checked = lSchedule.IsSaturday;
        //enrolleeScheduleEnterEditMode();
        if (lSchedule.ZoneScheduleType !== -1) {
            $('#uSchedulesZoneCategory').val(lSchedule.ZoneScheduleType);
        }

        $("#uMasterScheduleName").html(lMasterSchedule.Name);
        $("#uMasterScheduleTarget").html('Target Name: ' + lMasterSchedule.TargetName);
        $("#uMasterScheduleTargetType").html('Type: ' + lMasterSchedule.TargetTypeName);

        mEnrolleesData.SchedulesValidator = new Validator('uAbsenceScheduleDialogPanel', mRegexValidation);
    }
    uScheduleType_OnChange(document.getElementById('uScheduleType'));
}

function EnrolleeProfileAbsenceSchedule_Init(aHeaderText, aCallback, aIsCalendar) {
    "use strict";
    var lButtonCommandBar = GenerateButtonCommandBar();

    if (ModalIsOpen()) {
        CloseModal();
    }

    GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'uSaveAbsenceScheduleButton_OnClick(' + aIsCalendar + ')').appendTo(lButtonCommandBar);
    GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'CalendarClosePopup()').appendTo(lButtonCommandBar);
    DisplayPopup(aHeaderText, '<div id="uAbsenceScheduleDialogPanel"></div>', lButtonCommandBar, true, aIsCalendar);
    populateElement('uAbsenceScheduleDialogPanel', 'Enrollees.Offenders.Profile.AbsenceSchedules.Dialog.htm', function () { EnrolleeProfileAbsenceSchedule_OnComplete(aCallback); });
}

function EnrolleeProfileAbsenceSchedule_OnComplete(aCallback) {
    "use strict";
    applyUserPermissions([2, 7, 8, 11]);

    populateDateView('#uScheduleStartDate', function () { });
    //populateDateView('#uScheduleEndDate', function () {  });
    $('.TimePicker').ptTimeSelect({
        'zIndex': 100000,
        'onFocusDisplay': true
    });
    populateEditView({}, [
        //{ 'Id': 'EntityId', 'Type': 'Dropdown', 'DataSource': mEnrolleesData.SchedulesTargetsClean, 'DataValueField': 'UniqueId', 'DataTextField': 'Name' }
    ], {}, 'uSchedule', 'Edit');
    if (!isNullOrUndefined(aCallback)) {
        aCallback();
    }
}
/** END CARVE MODE POPUPS **/

/*** CALENDAR HANDLERS ***/
function handleAbsenceRender(aEvent) {
    "use strict";
    var lBuilder;
    var lRawSchedules;
    var lData;
    if (aEvent.state) {
        lRawSchedules = mEnrolleesControls.veritracksCalendar.getRawDataSource();
        lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('scheduleId', aEvent.scheduleId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lData = query(lRawSchedules, lBuilder.RootExpression);
        for (var lKey in lData) {
            if (lData.hasOwnProperty(lKey)) {
                if (lData[lKey]._id != aEvent._id) {
                    lData[lKey].end.hour(aEvent.end.hour());
                    lData[lKey].start.hour(aEvent.start.hour());
                    lData[lKey].end.minute(aEvent.end.minute());
                    lData[lKey].start.minute(aEvent.start.minute());
                }
            }
        }
    }
    pushAbsenceOverlapBack(aEvent);
}

function verifyOverrideDateMatches() {
    "use strict";
    var lElement = mEnrolleesControls.veritracksCalendar.getExtraData("absenceElement");

    if (lElement) {
        var lDate = prototypeCorrectStartDate(mEnrolleesData.SchedulesEditItem.StartTime, lElement, true);
        $('#uScheduleStartDate').val($.format.date(lDate, "MM/dd/yyyy"));
    }
}

function calendarCloseAbsence(aEvent, aElement) {
    var lCalendarId = mEnrolleesControls.veritracksCalendar.calendarId();

    if (aEvent.state) {
        mEnrolleesControls.veritracksCalendar.addExtraData("absenceElement", aElement);
        handleClickScheduleAbsence(aEvent, 'delete');
    } else {
        $(lCalendarId).fullCalendar('removeEvents', aEvent._id);
    }
    checkAbsenceSaveButtonDisplayed();
}

function checkRecurringAbsence(aStart, aEnd) {
    "use strict";
    var lDetails = { start: aStart, end: aEnd, isRecurring: false, backgroundColor: "#ffffff" };
    if ($('.ToggleOffButton').hasClass('ToggleOnButton')) {
        lDetails.isRecurring = true;
        lDetails.backgroundColor = "#CCC8BA";
    }

    pushAbsenceOverlapBack(lDetails);


    return lDetails;
}

function getCalendarSplitDays(aStart, aEnd, aEvent) {
    var lEvents = [];
    var lStart = aStart.clone();
    var lEnd = aEnd.clone();

    while (lStart.day() <= lEnd.day()) {
        var lEvent = Object.assign({}, aEvent);
        lEvent.start = lStart.clone();
        lEvent.end = lEnd.clone().day(lStart.day());

        lStart.add(1, 'day')

        lEvents.push(lEvent);
    }


    return lEvents;
}

function updateEditFlags(aEvent) {
    var lSchedule = mEnrolleesControls.veritracksCalendar.getEditingSchedule();
    var lSchedules = mEnrolleesControls.veritracksCalendar.getDataSource();
    var lOldSchedule;
    var l;
    var lOldScheduleDisplay;
    var lAbsence = [];
    var lOldAbsence = [];
    var lMasterSchedule,
        lEnrollee;
    var lBuilder;
    var lData;

    if (mEnrolleesControls.veritracksCalendar) {
        lEnrollee = getDataItem(mEnrolleesControls.veritracksCalendar.getExtraData('enrolleeId'), 'Enrollees');
        lMasterSchedule = mEnrolleesControls.veritracksCalendar.getExtraData("masterSchedule");
    } else {
        lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees');
        lMasterSchedule = checkCarveOutModeEnabled(mEnrolleesData.OffenderCurrentId);
    }

    if (lSchedule.state) {
        lSchedule.state = 2;
        for (var lKey in lSchedules) {
            if (lSchedules.hasOwnProperty(lKey)) {
                if (lSchedules[lKey].Id == lSchedule.scheduleId) {
                    lOldSchedule = lSchedules[lKey];
                }
            }
        }
        if (lOldSchedule) {
            if (!lOldSchedule.IsReocurring) {
                l = new OffenderScheduleDisplay(GetOffenderSchedule(lOldSchedule.Id), true);
                l.IsActive = false;
                l.StartTime = displayEventInEnrolleeTimeZone(l.StartTime, lEnrollee);
                l.EndTime = displayEventInEnrolleeTimeZone(l.EndTime, lEnrollee);
                lOldAbsence = ConvertToAbsenceSchedules([l], lMasterSchedule);
            } else {
                lRawSchedules = mEnrolleesControls.veritracksCalendar.getRawDataSource();
                lBuilder = new SumoPredicateBuilder();
                lBuilder.AddNewExpressionConditional('scheduleId', lOldSchedule.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lData = query(lRawSchedules, lBuilder.RootExpression);

                if (ObjectLength(lData) > 0) {
                    for (var lKey in lData) {
                        if (lData.hasOwnProperty(lKey)){
                            lMin = lData[lKey].start;
                            lMax = lData[lKey].end;
                            break;
                        }
                    }

                    for (var lKey in lData) {
                        if (lData.hasOwnProperty(lKey)) {
                            if (lData[lKey].start < lMin)
                                lMin = lData[lKey].start;
                            if (lData[lKey].end > lMax)
                                lMax = lData[lKey].end;
                        }
                    }
                    lSchedule.start = lMin;
                    lSchedule.end = lMax;
                }
            }
            lOldScheduleDisplay = new OffenderScheduleDisplay(lOldSchedule, false, true);
            singleFullCalendarObject(lOldScheduleDisplay, lSchedule.start, lSchedule.end, false);
            lOldScheduleDisplay.IsActive = lOldSchedule.IsEnabled;
            lOldScheduleDisplay.IsRecurring = lOldSchedule.IsReocurring;
            lAbsence = ConvertToAbsenceSchedules([lOldScheduleDisplay], lMasterSchedule);
            if (!lOldSchedule.IsReocurring) {
                lAbsence.push(lOldAbsence[0]);
            }
            lOldSchedule.IsActive = false;
            updateOffenderScheduleCache(lOldSchedule);
            disableAbsences(false);
            saveabsenceschedules(lAbsence, "Updated");
        }
    }
}

function disableAbsences(aDisabled) {
    var lDataSource = [];

    if (mEnrolleesControls.veritracksCalendar) {
        lDataSource = mEnrolleesControls.veritracksCalendar.getRawDataSource();
    }

    if (lDataSource) {
        for (var lKey in lDataSource) {
            lDataSource[lKey].editable = aDisabled;
        }
    }
}

function checkAbsenceSaveButtonDisplayed() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    var lCount = 0;
    var lDataSource = mEnrolleesControls.veritracksCalendar.getRawDataSource();

    lBuilder.AddNewExpressionConditional('state', 0, false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());
    lCount = query(mEnrolleesControls.veritracksCalendar.getRawDataSource(), lBuilder.RootExpression).length;

    if (lDataSource.length - lCount > 0) {
        $('.Clickable.Button.SaveButton.HideButton').show();
    } else {
        $('.Clickable.Button.SaveButton.HideButton').hide();
    }
}

function resizeOverUpdateAbsences(aEvent) {
}
/*** END CALENDAR HANDLERS ***/


/**** ABSENCE UPDATE METHODS ****/
function uSaveAbsenceScheduleButton_OnClick() {
    "use strict";
    var lStart = new Date($('#uScheduleStartDate').val() + ' ' + $('#uScheduleStartTime').val()),
        lEnd = new Date($('#uScheduleStartDate').val() + ' ' + $('#uScheduleEndTime').val()),
        lSchedule = mEnrolleesData.SchedulesEditItem,
        lBuilder = new SumoPredicateBuilder(),
        lMasterSchedule = new ScheduleItem(checkCarveOutModeEnabled(mEnrolleesData.OffenderCurrentId)),
        lEnrollee = GetEnrollee(mEnrolleesData.OffenderCurrentId),
        lScheduleList = [],
        lOldSchedule,
        lWrapSchedule;

    if (mEnrolleesData.SchedulesValidator.IsValid()) {
        $('.PopupWindow .SaveButton').hide();
        $('.PopupWindow .CancelButton').hide();

        lSchedule.EnrolleeId = mEnrolleesData.OffenderCurrentId;
        lSchedule.EndTime = lEnd;
        lSchedule.StartTime = lStart;
        lSchedule.IsRecurring = ($('#uScheduleType').val() === 'true');
        lSchedule.IsActive = true;
        lSchedule.Name = $('#uScheduleName').val();
        //lSchedule.TimeZoneCode = getTimezonebyBrowser();
        if (lSchedule.IsRecurring) {
            lSchedule.IsSunday = $('#uScheduleRecurrenceSunday').is(':checked');// document.getElementById('uScheduleRecurrenceSunday').checked;
            lSchedule.IsMonday = $('#uScheduleRecurrenceMonday').is(':checked');//document.getElementById('uScheduleRecurrenceMonday').checked;
            lSchedule.IsTuesday = $('#uScheduleRecurrenceTuesday').is(':checked');//document.getElementById('uScheduleRecurrenceTuesday').checked;
            lSchedule.IsWednesday = $('#uScheduleRecurrenceWednesday').is(':checked');//document.getElementById('uScheduleRecurrenceWednesday').checked;
            lSchedule.IsThursday = $('#uScheduleRecurrenceThursday').is(':checked');//document.getElementById('uScheduleRecurrenceThursday').checked;
            lSchedule.IsFriday = $('#uScheduleRecurrenceFriday').is(':checked');//document.getElementById('uScheduleRecurrenceFriday').checked;
            lSchedule.IsSaturday = $('#uScheduleRecurrenceSaturday').is(':checked');//document.getElementById('uScheduleRecurrenceSaturday').checked;
        } else {
            lSchedule.IsSunday = lSchedule.StartTime.getDay() === 0;
            lSchedule.IsMonday = lSchedule.StartTime.getDay() === 1;
            lSchedule.IsTuesday = lSchedule.StartTime.getDay() === 2;
            lSchedule.IsWednesday = lSchedule.StartTime.getDay() === 3;
            lSchedule.IsThursday = lSchedule.StartTime.getDay() === 4;
            lSchedule.IsFriday = lSchedule.StartTime.getDay() === 5;
            lSchedule.IsSaturday = lSchedule.StartTime.getDay() === 6;
        }
        lScheduleList.push(lSchedule);
        if (lSchedule.EndTime < lSchedule.StartTime) {
            lWrapSchedule = $.extend({}, lSchedule);
            lWrapSchedule.StartTime = new Date(lWrapSchedule.StartTime);
            lWrapSchedule.EndTime = new Date(lWrapSchedule.EndTime);

            lWrapSchedule.Name += ' Early';
            lWrapSchedule.StartTime.setHours(0);
            lWrapSchedule.StartTime.setMinutes(0);
            lSchedule.Name += ' Late';
            lSchedule.EndTime.setHours(23);
            lSchedule.EndTime.setMinutes(59);
            lScheduleList.push(lWrapSchedule);
        }
        /* Remove Old Schedule */
        lOldSchedule = new OffenderScheduleDisplay(GetOffenderSchedule(OffenderSchedules), true);
        lOldSchedule.IsActive = false;
        lOldSchedule.StartTime = displayEventInEnrolleeTimeZone(lOldSchedule.StartTime, lEnrollee);
        lOldSchedule.EndTime = displayEventInEnrolleeTimeZone(lOldSchedule.EndTime, lEnrollee);

        lScheduleList.push(lOldSchedule)
        lScheduleList = ConvertToAbsenceSchedules(lScheduleList, lMasterSchedule);

        saveabsenceschedules(lScheduleList, "Updated");
    } else {
        $('.PopupWindow .SaveButton').removeClass('Disabled');
        $('.PopupWindow .CancelButton').removeClass('Disabled');
    }
}

function saveCarved(aSchedules, aMasterSchedule, aSaveMaster) {
    "use strict";
    var lEnrollee = GetEnrollee(mEnrolleesControls.veritracksCalendar.getExtraData("enrolleeId")),
        lSchedules = [],
        lTimeZone = getTimezone(lEnrollee.TimeZoneId);


    for (var lKey in aSchedules) {
        if (aSchedules.hasOwnProperty(lKey)) {
            var lSchedule = aSchedules[lKey];
            lSchedule.EnrolleeId = lEnrollee.Id;
            lSchedule.RegularScheduleId = aMasterSchedule.Id;
        }
    }

    lSchedules = ConvertToAbsenceSchedules(aSchedules, aMasterSchedule);
    if (aSaveMaster) {
        aMasterSchedule.StartTime = convertTimeToUTC(aMasterSchedule.StartTime, lTimeZone.TimeZoneName);
        aMasterSchedule.EndTime = convertTimeToUTC(aMasterSchedule.EndTime, lTimeZone.TimeZoneName);
        saveMasterSchedule(aMasterSchedule, lSchedules, "Created");
    } else {
        saveabsenceschedules(lSchedules, "Created");
    }

    ClosePopup();
}

function saveMasterSchedule(aMasterSchedule, aAbsences, aType){
  "use strict";
  WriteSingle(aMasterSchedule, masterSaveSuccess, failure, null, true);

  function masterSaveSuccess(aParams, aData){
      updateOffenderScheduleCache(aData);
      saveabsenceschedules(aAbsences, "Created");
  }
}

function uDeleteAbsenceSchedule(aSchedules, aIsCalendar, aCallback) {
    var lSchedules = [];

    lSchedules = aSchedules.map(function (schedule) {
        schedule.IsActive = false;

        return schedule;
    });

    saveCarveOutSchedule(lSchedules, 'deleted');
}

function uUpdateAbsenceSchedule(aScheduleId, aSchedule) {
    var lSchedule = new OffenderScheduleDisplay(GetOffenderSchedule(aScheduleId), true),
        lAbsentMaster = mEnrolleesControls.veritracksCalendar.getExtraData("masterSchedule"),
        lAbsenceList = [],
        lDay = aSchedule.start.day(),
        lStatus = 'Updated',
        lDayCount = 0;

    // clean this checking if single day schedule and has clicked delete day
    if (lSchedule.IsSunday)
        lDayCount++;
    if (lSchedule.IsMonday)
        lDayCount++;
    if (lSchedule.IsTuesday)
        lDayCount++;
    if (lSchedule.IsWednesday)
        lDayCount++;
    if (lSchedule.IsThursday)
        lDayCount++;
    if (lSchedule.IsFriday)
        lDayCount++;
    if (lSchedule.IsSaturday)
        lDayCount++;

    if (lDay == 0) {
        lSchedule.IsSunday = false;
    } else if (lDay == 1) {
        lSchedule.IsMonday = false;
    } else if (lDay == 2) {
        lSchedule.IsTuesday = false;
    } else if (lDay == 3) {
        lSchedule.IsWednesday = false;
    } else if (lDay == 4) {
        lSchedule.IsThursday = false;
    } else if (lDay == 5) {
        lSchedule.IsFriday = false;
    } else if (lDay == 6) {
        lSchedule.IsSaturday = false;
    } else {

    }

    if (lDayCount == 1 || !lSchedule.IsRecurring) {
        lSchedule = new OffenderScheduleDisplay(GetOffenderSchedule(aScheduleId), true);
        lSchedule.IsActive = false;
        lStatus = 'Deleted';
    }

    lAbsenceList = ConvertToAbsenceSchedules([lSchedule], lAbsentMaster, aSchedule.start, aSchedule.end);
    saveabsenceschedules(lAbsenceList, lStatus);
}

function enrolleesOffenderAbsenceWrite_OnSuccess(aParams, aData){
  "use strict";
  var lItem;

  mActivityNotification.addNotification(aParams.type + " Absence Successfully!");
  for (var lKey in aParams.Ids) {
      if (aParams.Ids.hasOwnProperty(lKey)) {
          lItem = GetOffenderSchedule(aParams.Ids[lKey]);
          if (lItem) {
              lItem.IsActive = false;
              updateOffenderScheduleCache(lItem);
          }
      }
  }

  enrolleesOffenderScheduleWrite_OnSuccess(aParams, aData);
}

function saveabsenceschedules(aAbsences, saveType, aCallback) {
    "use strict";
    var lSchedules = [],
        lAbsenceList = [],
        lRecurringSave = new EmptyOffenderAbsenceSchedule(),
        lOverrideSave = new EmptyOffenderAbsenceSchedule(),
        lCallback = enrolleesOffenderAbsenceWrite_OnSuccess,
        lEnrollee,
        lMasterSchedule,
        lAbsenceIdList = getArrayByIds(aAbsences),
        lBuilder = new SumoPredicateBuilder();

    if (aCallback) {
        lCallback = aCallback;
    }
    if (mEnrolleesControls.veritracksCalendar) {
        lEnrollee = getDataItem(mEnrolleesControls.veritracksCalendar.getExtraData('enrolleeId'), 'Enrollees');
        lMasterSchedule = mEnrolleesControls.veritracksCalendar.getExtraData("masterSchedule");
    } else {
        lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees');
        lMasterSchedule = checkCarveOutModeEnabled(mEnrolleesData.OffenderCurrentId);
    }
    lBuilder.AddNewExpressionConditional('Id', lAbsenceIdList, false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrollee.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('ScheduleType', [7,8,9], false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsAbsenceSched', getCarveOutPreference(), false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    var lSchedulesList = query(mEnrolleesData.OffenderSchedules, lBuilder.RootExpression);

    for (var lKey in lSchedulesList) {
        if (lSchedulesList.hasOwnProperty(lKey)) {
            lAbsenceList.push(new OffenderScheduleDisplay(lSchedulesList[lKey], true));
        }
    }

    for (var lKey in lAbsenceList) {
        if (lAbsenceList.hasOwnProperty(lKey)) {
            lAbsenceList[lKey].StartTime = displayEventInEnrolleeTimeZone(lAbsenceList[lKey].StartTime, lEnrollee);
            lAbsenceList[lKey].EndTime = displayEventInEnrolleeTimeZone(lAbsenceList[lKey].EndTime, lEnrollee);
            lAbsenceIdList.push(lAbsenceList[lKey].Id);
        }
    }

    lAbsenceList = ConvertToAbsenceSchedules(lAbsenceList, lMasterSchedule);
    for (var lKey in aAbsences) {
        if (aAbsences.hasOwnProperty(lKey)) {

            if (saveType === 'Deleted') {
                aAbsences[lKey].IsActive = 0;
            }
            lAbsenceList.push(aAbsences[lKey]);
        }
    }

    //  var lAbsenceSchedules = GetAbsenceSaveList(lAbsenceList, lMasterSchedule);
    var ignoreList = ['Id', 'EnrolleeId', '__type', 'RegularScheduleId', 'IsRecurring', 'EntityId', 'FriScheduleId', 'MonScheduleId', 'SatScheduleId',
    'ScheduleTypeId', 'SunScheduleId', 'ThuScheduleId', 'TransactionId', 'TueScheduleId', 'WedScheduleId', 'ZoneScheduleType'];
    for (var i in lAbsenceList) {
        if (lAbsenceList.hasOwnProperty(i)) {
            for (var j in lAbsenceList[i]) {
                if (lAbsenceList[i].hasOwnProperty(j)) {

                    if (ignoreList.indexOf(j) === -1) {
                        if (lAbsenceList[i].IsRecurring) {
                            if (lRecurringSave[j].length != 0) {
                                lRecurringSave[j] += ',';
                            }
                            lRecurringSave[j] += lAbsenceList[i][j];
                        } else {
                            if (lOverrideSave[j].length != 0) {
                                lOverrideSave[j] += ',';
                            }
                            lOverrideSave[j] += lAbsenceList[i][j];
                        }
                    }
                }
            }
        }
    }
    lRecurringSave.EnrolleeId = lEnrollee.Id;
    lRecurringSave.IsRecurring  = true;
    lOverrideSave.EnrolleeId = lEnrollee.Id;
    lOverrideSave.IsRecurring = false;
    if (lMasterSchedule) {
        lRecurringSave.Id = lMasterSchedule.Id;
        lOverrideSave.Id = lMasterSchedule.Id;
    }

    SaveRecurringAbsences(lEnrollee, lAbsenceList, lOverrideSave, lRecurringSave, lCallback, saveType);
}

function getScheduleMaster(aOffenderId, aCallback) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();

    lBuilder.AddNewExpressionConditional('EnrolleeId', aOffenderId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsRecurring', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.OffenderSchedule.AssemblyQualifiedName, lBuilder.RootExpression, 0, aCallback, null, mEnrolleesData.OffenderCurrentId, null, 0);
}

function getScheduleMasterAllowedType(aSchedules) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    var lAllowedTypes = [2, 3]; // bluhome blubox
    var lSchedules = [];
    var lSchedule;

    lBuilder.AddNewExpressionConditional('ScheduleType', lAllowedTypes, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lSchedules = query(aSchedules, lBuilder.RootExpression);

    for (var lKey in lSchedules) {
        if (lSchedules.hasOwnProperty(lKey)) {
            lSchedule = lSchedules[lKey];
        }
    }

    return lSchedule;
}

function SaveRecurringAbsences(aEnrollee, aAbsenceList, aOverrides, aRecurrings, aCallback, saveType) {
    "use strict";
    var lParams = { 'Enrollee': aEnrollee, 'saveType': saveType, 'Override': aOverrides, 'absenceIds': aAbsenceList, 'Callback': aCallback };

    if (aRecurrings.IsActive !== "") {
        getScheduleMaster(aEnrollee.Id, firstStepSave);
    } else {
        SaveOverrideAbsences(lParams, []);
    }
    function firstStepSave(aParams, aData) {
        var lMasterSchedule = getScheduleMasterAllowedType(aData);
        if (lMasterSchedule) {
            aRecurrings.Id = lMasterSchedule.Id;
            aRecurrings.SatScheduleId = lMasterSchedule.Id;
            aRecurrings.SunScheduleId = lMasterSchedule.Id;
            aRecurrings.MonScheduleId = lMasterSchedule.Id;
            aRecurrings.TueScheduleId = lMasterSchedule.Id;
            aRecurrings.WedScheduleId = lMasterSchedule.Id;
            aRecurrings.ThuScheduleId = lMasterSchedule.Id;
            aRecurrings.FriScheduleId = lMasterSchedule.Id;
            aRecurrings.ScheduleTypeId = 7;
            aRecurrings.EntityId = lMasterSchedule.EntityId;
            deleteAllOldSchedulesRelated(aEnrollee.Id, true, aAbsenceList);
            WriteMultiple([aRecurrings], SaveOverrideAbsences, absenceSaveFail, lParams, true);
        }
    }
}

function SaveOverrideAbsences(aParams, aData) {
    "use strict";
    var lOverrides = aParams.Override;
    var lEnrollee = aParams.Enrollee;
    var lSaveType = aParams.saveType;
    var lAbsenceList = aParams.absenceIds;
    var lAbsenceIdList = getArrayByIds(lAbsenceList);
    var lCallback = aParams.Callback;

    if (lOverrides.IsActive !== "") {
        getScheduleMaster(lEnrollee.Id, secondStepSave);
    } else {
        lCallback({ "Ids": lAbsenceIdList, "type": lSaveType }, aData)
    }

    function secondStepSave(aParams, aData) {
        var lMasterSchedule = getScheduleMasterAllowedType(aData);
        if (lMasterSchedule) {
            lOverrides.Id = lMasterSchedule.Id;
            lOverrides.SatScheduleId = lMasterSchedule.Id;
            lOverrides.SunScheduleId = lMasterSchedule.Id;
            lOverrides.MonScheduleId = lMasterSchedule.Id;
            lOverrides.TueScheduleId = lMasterSchedule.Id;
            lOverrides.WedScheduleId = lMasterSchedule.Id;
            lOverrides.ThuScheduleId = lMasterSchedule.Id;
            lOverrides.FriScheduleId = lMasterSchedule.Id;
            lOverrides.ScheduleTypeId = 7;
            lOverrides.EntityId = lMasterSchedule.EntityId;

            deleteAllOldSchedulesRelated(lEnrollee.Id, false, lAbsenceList);
            WriteMultiple([lOverrides], lCallback, absenceSaveFail, { "Ids": lAbsenceIdList, "type": lSaveType }, true);
        }
    }
}

function absenceSaveFail() {
    disableAbsences(true);
}

function deleteAllOldSchedulesRelated(aEnrolleeId, aRecurring, aAbsences) {
    var lBuilder = new SumoPredicateBuilder();
    var lAllowedTypes = [2, 3]; // bluhome blubox
    var lSchedules;
    var lTimeZone;
    lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('ScheduleType', lAllowedTypes, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsRecurring', aRecurring, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsAbsenceSched', getCarveOutPreference(), false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lSchedules = query(mEnrolleesData.OffenderSchedules, lBuilder.RootExpression);


    if (!aRecurring) {
      lTimeZone = getEnrolleeTimeZone(aEnrolleeId);
        for (var lKey in lSchedules) {
            if (lSchedules.hasOwnProperty(lKey)) {
                var lCurrentSchedule = new OffenderScheduleDisplay(lSchedules[lKey], true);
                var lStartDate = moment(lCurrentSchedule.StartTime);
                lCurrentSchedule.StartTime = displayFixedTimeZoneTime(lCurrentSchedule.StartTime, lTimeZone.TimeZoneName);
                lCurrentSchedule.EndTime = displayFixedTimeZoneTime(lCurrentSchedule.EndTime, lTimeZone.TimeZoneName);
                lCurrentSchedule.StartTime = moment(lCurrentSchedule.StartTime).format("HHmm");
                lCurrentSchedule.EndTime = moment(lCurrentSchedule.EndTime).format("HHmm");

                for (var a in aAbsences) {
                    if (aAbsences.hasOwnProperty(a)) {
                        var lAbsence = aAbsences[a];
                        var lDuration = Math.abs(moment.duration(moment(lAbsence.StartDate).diff(lStartDate)).asDays());
                        if (!lAbsence.IsRecurring && (lCurrentSchedule.IsMonday == lAbsence.IsMonday && lCurrentSchedule.IsTuesday == lAbsence.IsTuesday && lCurrentSchedule.IsWednesday == lAbsence.IsWednesday &&
                            lCurrentSchedule.IsThursday == lAbsence.IsThursday && lCurrentSchedule.IsFriday == lAbsence.IsFriday &&
                            lCurrentSchedule.IsSaturday == lAbsence.IsSaturday && lCurrentSchedule.IsSunday == lAbsence.IsSunday)) {
                            if (lDuration < 6 && (lCurrentSchedule.EndTime == lAbsence.StartTime || lCurrentSchedule.StartTime == lAbsence.StopTime)) {
                                lSchedules[lKey].IsActive = false;
                                updateOffenderScheduleCache(lSchedules[lKey]);
                            }
                        }
                    }
                }
            }
        }
    } else {
        for (var lKey in lSchedules) {
            if (lSchedules.hasOwnProperty(lKey)) {
                lSchedules[lKey].IsActive = false;
                updateOffenderScheduleCache(lSchedules[lKey]);
            }
        }
    }
}

/** END SAVE METHODS **/


/** CONVENIENCE METHODS **/
function pushAbsenceOverlapBack(aEvent) {
    "use strict";
    if (!$('.ToggleOffButton').hasClass('ToggleOnButton') && !aEvent.isRecurring || ($('.ToggleOffButton').hasClass('ToggleOnButton') && aEvent.isRecurring == false)) {
        if (aEvent.end.hours() == 0 && aEvent.end.minutes() == 0)
            aEvent.end = aEvent.end.add(-1, 'minutes');

        aEvent.end.weekday(aEvent.start.day());
    }
}

function enrolleesVeritracksCurrentCarveRecurring() {
    "use strict";
    if ($('.ToggleOffButton').hasClass('ToggleOnButton')) {
        $('.ToggleOffButton').removeClass('ToggleOnButton');
        $('.ToggleOffButton').text('Override');
    }
    else {
        $('.ToggleOffButton').addClass('ToggleOnButton');
        $('.ToggleOffButton').text('Recurring');
    }
}

function ConvertToAbsenceSchedules(aSchedules, aMaster, aStart, aEnd) {
    "use strict";
    var lAbsenceList = [],
        lItem;

    for (var lKey in aSchedules) {
        if (aSchedules.hasOwnProperty(lKey)) {
            lItem = new OffenderAbsenceSchedule(aSchedules[lKey]);
            if (lItem.IsRecurring && aMaster) {
                lItem.StartDate = DisplaySuperShortMomentDate(moment(aMaster.StartTime), "MMDDYYYY");
            } else {
                lItem.StartDate = DisplaySuperShortMomentDate(fixOverrideShifts(aSchedules[lKey].StartTime, aSchedules[lKey]), "MMDDYYYY");
            }
            if (aStart && aEnd) {
                lItem.StartTime = aStart.format("HHmm");
                lItem.StopTime = aEnd.format("HHmm");
            } else {
                lItem.StartTime = moment(aSchedules[lKey].StartTime).format("HHmm");
                lItem.StopTime = moment(aSchedules[lKey].EndTime).format("HHmm");
            }
            lItem.Reason = lItem.Reason || "";
            lAbsenceList.push(lItem);
        }
    }

    return lAbsenceList;
}

/** END CONVENIENCE METHODS **/



/* Offender Profile Convenience Methods*/

function offenderProfilePopulate(aId, aCallback) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    var lEnrolleeId = mEnrolleesData.OffenderCurrentId;
    var lCallback = offenderProfileRead_OnComplete; //default callback

    if (aCallback) {
        lCallback = aCallback;
    }
    if (aId) {
        lEnrolleeId = aId;
    }
    //PhoneInternationalNumber
    $("#OffenderProfileCellPhoneNumber .iti").hide();
    
    lBuilder.AddNewExpressionConditional('Id', lEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.OffenderProfile.AssemblyQualifiedName, lBuilder.RootExpression, 0, lCallback, offenderProfileRead_OnFailure, mEnrolleesData.OffenderCurrentId, null, 0);

    //lBuilder.Clear();
    //lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    GetEMAEnrolleeStatus(lEnrolleeId, PopulateEMAProfileViews, Sad, null);
    mEnrolleesData.EnrolleeAlternateContact = new EnrolleeAlternateContact();
    mEnrolleesData.EnrolleeAlternateContacts = [];
    ReadMultiple(gObjectList.OffenderCategory.AssemblyQualifiedName, lBuilder.RootExpression, 0, offenderCategoryRead_OnComplete, offenderCategoryRead_OnFailure, mEnrolleesData.OffenderCurrentId, null, 0);
    ReadMultiple(gObjectList.OffenderSexOffense.AssemblyQualifiedName, lBuilder.RootExpression, 0, offenderSexOffenseRead_OnComplete, offenderSexOffenseRead_OnFailure, mEnrolleesData.OffenderCurrentId, null, 0);
    enrolleesOffenderImageUpload_Reset();
    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional("EnrolleeId", lEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.EnrolleeAlternateContact.AssemblyQualifiedName, lBuilder.RootExpression, 0, function success(aParam,aData){
        if(aData.length >0){
            //Prepare support for multiple
            mEnrolleesData.EnrolleeAlternateContact = aData[aData.length-1];//last item
            mEnrolleesData.EnrolleeAlternateContacts = aData;
        }
        PopulateDetailView(mEnrolleesData.EnrolleeAlternateContact, {}, 'uOffenderAlternateAgencyContact');
    }, Sad, null, null, 0);
}

function quickAlcoholMonitoringReview() {
    "use strict";
    var lButtonBar = GenerateButtonCommandBar();
    var lTitle = 'Alcohol Monitoring Test Result';

    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', 'CloseTimelineDataPopup()'));

    DisplayPopup(lTitle, '<div id="uAlcoholReviewPopupHolder"></div>', lButtonBar, false, true);
    //// calls main timeline popup that will hold tabs --- go to timelinePopulate_Init
    populateElement('uAlcoholReviewPopupHolder', 'Alcohol.Review.Popup.htm', null);
}

function instantScheduleReporting_OnClick() {
  var lEnrollee = GetEnrollee(mEnrolleesData.OffenderCurrentId);
  if (lEnrollee) {
    var lOrganizationId = lEnrollee.OrganizationId;
    var lAgentId = getMyAgentIdsByOrganization(gUserDetails.UserId, [lOrganizationId])[0];

    CreateEnrolleeScheduleInstantReport(lEnrollee.Id, lAgentId);
  }
}

function ReloadEnrolleeSchedules(aEnrolleeId, aOnSuccess, aOnFailure, aParams) {
    "use strict";

    GetEnrolleeSchedules(aEnrolleeId, function (aParams, aData) {
        FixDates(aData);
        mEnrolleesData.OffenderSchedules = aData;
        aOnSuccess(aParams, aData)
    }, aOnFailure, aParams)

}

function GetEnrolleeSchedules(aEnrolleeId, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();

    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetSchedules', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aEnrolleeId': aEnrolleeId
        }, aOnSuccess, aOnFailure, aOutParams);
    }
};

function updateOffenderScheduleCache(aSchedule){
    "use strict";

    var aIndex =  mEnrolleesData.OffenderSchedules.findIndex(function(sc){ return sc.Id == aSchedule.Id});

    if(aIndex){
        mEnrolleesData.OffenderSchedules[aIndex] = aSchedule;
    }else{ 
        mEnrolleesData.OffenderSchedules.push(aSchedule);
    }
}


function VeritracksTerminateEnrolleeLogging() {
    if (mEnrolleesData.AgentTimeManagement[mEnrolleesData.OffenderCurrentId]) {
        mEnrolleesData.AgentTimeManagement[mEnrolleesData.OffenderCurrentId].finish()
    }
}